(function ()
{
    'use strict';

    angular
        .module('app.rent.gantt-chart',
            [
                // 3rd Party Dependencies
                'gantt',
                'gantt.sortable',
                'gantt.movable',
                'gantt.drawtask',
                'gantt.tooltips',
                'gantt.bounds',
                'gantt.progress',
                'gantt.table',
                'gantt.tree',
                'gantt.groups',
                'gantt.overlap',
                'gantt.resizeSensor'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {

        $stateProvider.state('app.rent.gantt-chart', {
            url    : '/calendar',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/rent/gantt-chart/gantt-chart.html',
                    controller : 'GanttChartController as vm'
                }
            },
            resolve: {

                /*Tasks    : function (msApi)
                {
                    return msApi.resolve('ganttChart.tasks@get');
                },

                Timespans: function (msApi)
                {
                    return msApi.resolve('ganttChart.timespans@get');
                }*/
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/rent/gantt-chart');


        msNavigationServiceProvider.saveItem('rent.gantt-chart', {
            title : 'Calendar',
            state : 'app.rent.gantt-chart',
            weight: 1
        });

        // Api
        //msApiProvider.register('ganttChart.tasks', ['app/data/gantt-chart/tasks.json']);
        //msApiProvider.register('ganttChart.timespans', ['app/data/gantt-chart/timespans.json']);

    }

})();
(function ()
{
    'use strict';

    angular.module('app.rent.gantt-chart')
        .controller('GanttChartAddEditDialogController', GanttChartAddEditDialogController);

    /** @ngInject */
    function GanttChartAddEditDialogController($scope,$timeout,$mdDialog,$state, dialogData, fuseGenerator,ShowToast,UserAdapter,UserService,CategoryService,RentStationService,RateService,ReservationAdapter,RentalAgreementAdapter,CurrentNewRentalBooking,RentBookingStatus,RentalBookingType,RentalBookingColor,DamageStatus,DamageStatusViewer,DamageInstantSpotted,DamageInstantSpottedViewer,ServiceSettings) {
        /**
         * 
         * 
         * 
         * 
         * 
         * 
         * THIS SECTION NEEDS TO BE UDPATED TO USE MOMENTJS INSTEAD OF THE TODATE() methods
         * 
         * 
         * 
         * 
         * 
         * 
         * 
         * 
         * 
         */

        var vm = this;

        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })
        
        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    // FIXME: wrong timezone get
                    vm.timezone = settings && settings.timezone;
                }
            });
        }
        init()
        
        // Data

        vm.onTabSelect = function (index) {
            vm.selectedTab = index;

        }
        vm.chartData = dialogData.chartData;
        vm.dialogType = dialogData.dialogType;

        vm.reservationTypes = RentalBookingType;
        vm.rentBookingStatus = RentBookingStatus;

        vm.canUpgradeReservation = false;

        //property to invalidate vehicle input
        vm.showVehicleFieldError = false;

        //data util function to manage simple case and currentNewRentalBooking and currentNewUser
        //check if dialog is opened from gantt (dialogData.formData.model) or task dialog is opened by me (dialogData.formData)
        function getTaskData() {

          return  dialogData.formData.model ? dialogData.formData.model : dialogData.formData;
        }

        function updateTaskData(updatedTask) {

            var taskRow;

            if(dialogData.formData.model){

                console.log("update task in gantt data,case editDialog is opened from gantt")
                dialogData.formData.model = updatedTask;

            }else{
                //cause of missing syncronization in gantt data, delete current task from gantt and add updated current task
                console.log("remove and add updatedTask from gantt data,case editDialog is opened by me")
                taskRow = vm.chartData.getById(vm.task.vehicle);

                taskRow.tasks.splice(taskRow.tasks.indexOf(taskRow.tasks.getById(vm.task.id)), 1 ,updatedTask);
            }
        }

        /// Edit Dialog

        if ( vm.dialogType === 'edit' ) {

            vm.formView = dialogData.formView;
            vm.row = vm.task = angular.copy(getTaskData());

            //check task type to see if it is a new reservation or not
            var currentTaskType = vm.task.type;

            if(typeof currentTaskType != "undefined" && currentTaskType != null){

                if(currentTaskType == vm.reservationTypes.RESERVATION) {
                    console.log("this is a reservation,set canUpgrade to true");
                    vm.canUpgradeReservation = true;
                }
            }else{

                //this is a new reservation set task type to reservation
                console.log("this is a new reservation,set task type to reservation")
                vm.task.type = vm.reservationTypes.RESERVATION;

            }

            //set creation date
            if(vm.task.created_at){
                vm.creationDate = moment(vm.task.created_at).tz(vm.timezone).toDate()
            }else{
                console.log("now date")
                vm.creationDate = moment.tz(vm.timezone).toDate();
            }

            //set vehicle correlated in task
            if( !(vm.task.vehicle) ){
                vm.task.vehicle = dialogData.rowData.model.id;
            }

            //set drivers
            if(typeof vm.task.drivers == "undefined"){

                vm.task.drivers = [null,null]
            }

            //check if rate exists else set default
            vm.task.rate =  vm.task.rate ? vm.task.rate : 'default';

            //refresh client payment methods
            var clientId = vm.task.client;

            if(typeof clientId != "undefined"){
                getUserPayments(clientId);
                setClientAsFirstDriver(clientId)
            }

            var taskFrom = vm.task.from;
            var taskTo = vm.task.to;

            var taskFromDateObj,taskToDateObj;
            var pickUpTimeDate,returnTimeDate;

            //trasform task.from from Moment Obj in Date obj
            if(vm.task.from && !(vm.task.from instanceof Date)){
                console.log("trasform task.from from Moment Obj in Date obj")
                taskFromDateObj = moment(taskFrom).tz(vm.timezone).toDate();
                vm.task.from = taskFromDateObj;

                taskToDateObj = moment(taskTo).tz(vm.timezone).toDate();
                vm.task.to = taskToDateObj;

            }

            //update pickUpTime Date
            if(vm.task.from && (typeof vm.task.pickUpTime == "undefined" || vm.task.pickUpTime == null)){

                console.log("pickUpTime undefined",vm.task.pickUpTime)

                pickUpTimeDate = moment(taskFrom).tz(vm.timezone).startOf('minute').toDate();

                returnTimeDate = moment(taskTo).tz(vm.timezone).startOf('minute').toDate();

                vm.task.pickUpTime = pickUpTimeDate;
                vm.task.returnTime = returnTimeDate;
            }

            console.log("edit mode,current reservation",vm.task);
        }
        /// Add Dialog
        else if ( vm.dialogType === 'add' ){

            /*vm.row = {
                id      : ganttUtils.randomUuid(),
                name    : '',
                tasks   : [],
                classes : ['', ''],
                sortable: true,
                parent  : ''
            };*/

            //case dialog is opened from plus button

            vm.creationDate = moment.tz(vm.timezone).toDate();

            vm.task = {
                //id      : ganttUtils.randomUuid(),
                id : 1,
                stubReservation : true,
                name    : '',
                classes : [RentalBookingColor.NOT_SAVED],
                drivers : [null,null],
                type : vm.reservationTypes.RESERVATION, //set default task type to reservation
                rate : 'default' //set default task rate
            };

        }

        //my data initialization

        vm.reservationStatus = ["Rental","Canceled","Refused","No Show"];

        vm.toggleShowVehicleFieldError = function () {

            if(typeof vm.showVehicleFieldError == "undefined"){

                vm.showVehicleFieldError = false;
            }
            else{
                vm.showVehicleFieldError = vm.showVehicleFieldError ? false : true;
            }

        };

        UserService.getUsers()
            .then(function (users) {
                
                vm.clients = users;
            },function (error) {
                
            });

        CategoryService.getCategories()
            .then(function (categories) {

                vm.categories = categories;

                },function error() {

                });

        RentStationService.getRentStations()
            .then(function (rentStations) {

                vm.rentStations = rentStations;
            },function (error) {

            });


        RateService.getRates()
            .then(function (rates) {

                vm.rates = rates;
            },function (error) {

            });

        function getUserPayments (clientId) {

            if(typeof clientId != "undefined" && clientId != null){

                UserAdapter.getPayments(clientId,function (paymentMethods,error) {

                    if(!error){

                        vm.clientPaymentMethods = paymentMethods;
                    }

                });
            }

        };

        function setClientAsFirstDriver (clientId) {

            if(typeof clientId != "undefined" && clientId != null){

                vm.task.drivers[0] = clientId;
            }
        };

        vm.setClientAsFirstDriverAndRefreshPayments = function (clientId) {

            getUserPayments(clientId);
            setClientAsFirstDriver(clientId)
        };

        //damages init

        vm.damageStatus = DamageStatus;
        vm.damageStatusViewer = DamageStatusViewer;
        vm.damageInstantSpotted = DamageInstantSpotted;
        vm.damageInstantSpottedViewer = DamageInstantSpottedViewer;


        $scope.rentalAgreementRelatedDamages = {
            instantSpotted: DamageInstantSpottedViewer[DamageInstantSpotted.AFTER].value,
            status: DamageStatusViewer[DamageStatus.NOT_CREATED].value,
            Part:{}
        };

        $timeout(function (){
            $timeout(function (){

                if(vm.task.type == vm.reservationTypes.RENTAL_AGREEMENT){

                    RentalAgreementAdapter.getRelatedDamages(vm.task.id,function (relatedDamages,error) {

                        if(!error){

                            if(!relatedDamages.length==0) {
                                $scope.rentalAgreementRelatedDamages.id = relatedDamages[0].id;
                                $scope.rentalAgreementRelatedDamages.instantSpotted = relatedDamages[0].instantSpotted;
                                $scope.rentalAgreementRelatedDamages.status = relatedDamages[0].status;
                                updateCurrentDamagesInVehicleSvg(relatedDamages[0].Part);
                            }
                        }
                    });
                }

                var vehicleSideSvg = document.getElementById("vespaSideSVG");
                var vehicleFrontSvg = document.getElementById("vespaFrontSVG");
                var vehicleFrontSvgEl = angular.element(vehicleFrontSvg);
                var vehicleSideSvgEl = angular.element(vehicleSideSvg);

                if(vehicleSideSvg){setUpSvgElement(vehicleSideSvg);}
                if(vehicleFrontSvg){setUpSvgElement(vehicleFrontSvg);}

                function setUpSvgElement(element){

                    var vehicleFrontSvgEl = angular.element(vehicleFrontSvg);
                    var vehicleSideSvgEl = angular.element(vehicleSideSvg);
                    //vehicleSideSvgEl.css({transform:"translateX(100%)"})
                    //vehicleFrontSvgEl.css({transform:"translateX(-100%)"})

                    var selectablePathElements = element.getElementsByClassName("isSelectable");

                    for(var i=0;i<selectablePathElements.length;i++){

                        var currentPathElement = angular.element(selectablePathElements[i]);
                        var currentPathElementId = currentPathElement.attr('id');

                        if(currentPathElementId){
                            var vehicleSvgDamagedPart = $scope.rentalAgreementRelatedDamages.Part[currentPathElementId];

                            if(!vehicleSvgDamagedPart){
                                vehicleSvgDamagedPart = {name: currentPathElementId,value: false,elements: [],description:""};
                                $scope.rentalAgreementRelatedDamages.Part[currentPathElementId] = vehicleSvgDamagedPart;
                            }
                            vehicleSvgDamagedPart.elements.push(currentPathElement);

                            currentPathElement.on('click',function () {
                                var currentPathElement = angular.element(this);
                                var currentFill = currentPathElement.attr('fill');
                                var currentPathElementId = currentPathElement.attr('id');
                                var currentPathElementValue = (currentFill=== "#FFFFFF" || currentFill=== "white");

                                console.log("id",currentPathElementId,"fill",currentFill);

                                $scope.$apply(function(){

                                    updateDamageInVehicleSvg(currentPathElementId,currentPathElementValue);
                                })
                            })
                        }
                    }
                }
                
                function selectVehicleFrontSvg() {
                    vehicleSideSvgEl.css({transform:"translateX(-100%)"});
                    vehicleFrontSvgEl.css({transform:""});
                }

                function selectVehicleSideSvg() {
                    vehicleFrontSvgEl.css({transform:"translateX(-100%)"});
                    vehicleSideSvgEl.css({transform:""});

                }

                vm.selectVehicleFrontSvg = selectVehicleFrontSvg;
                vm.selectVehicleSideSvg = selectVehicleSideSvg;

                function updateCurrentDamagesInVehicleSvg(relatedDamages) {

                    relatedDamages.forEach(function (damagedPart) {

                        updateDamageInVehicleSvg(damagedPart.name,damagedPart.value,damagedPart.description);
                    })
                }

                function updateDamageInVehicleSvg(pathElementId,damageValue,damageDescription) {

                    var vehicleSvgDamagedPart = $scope.rentalAgreementRelatedDamages.Part[pathElementId];
                    console.log("vehicleSvgDamagedPart",vehicleSvgDamagedPart);

                    vehicleSvgDamagedPart.value = damageValue;
                    vehicleSvgDamagedPart.description = (damageDescription || "");

                    for(var i= 0; i<vehicleSvgDamagedPart.elements.length;i++){

                        vehicleSvgDamagedPart.elements[i].attr('fill',damageValue ? "red" : "white");
                    }
                }

                function prepareRelatedDamageToSend(){

                    var dataToSend = {
                        instantSpotted: $scope.rentalAgreementRelatedDamages.instantSpotted,
                        pars:[]};

                    for(var damagedPartKey in $scope.rentalAgreementRelatedDamages.Part){
                        var damagedPart = $scope.rentalAgreementRelatedDamages.Part[damagedPartKey];

                        if(damagedPart.value)
                            dataToSend.pars.push({
                                name: damagedPart.name,
                                value: damagedPart.value,
                                description: damagedPart.description
                            })
                    }
                    return dataToSend;
                }

                function callAddRentalAgreementRelatedDamage() {

                    var dataToSend = prepareRelatedDamageToSend();
                    console.log("add damage",dataToSend)

                    RentalAgreementAdapter.addRelatedDamage(vm.task.id,dataToSend,
                        function (newRelatedDamage,error) {
                            if(!error){
                                console.log("newRelatedDamage",newRelatedDamage);
                                ShowToast.only("Damage added!");
                                $scope.rentalAgreementRelatedDamages.status = newRelatedDamage.status;
                            }else {
                                ShowToast.only("Error adding damage please retry," + (error.description ? error.description :error));
                            }

                    })
                }

                function callUpdateRentalAgreementRelatedDamage() {
                    var dataToSend = prepareRelatedDamageToSend();
                    var relatedDamageId = $scope.rentalAgreementRelatedDamages.id;

                    console.log("update damage",dataToSend)

                    RentalAgreementAdapter.updateRelatedDamage(vm.task.id,relatedDamageId,dataToSend,
                        function (relatedDamages,error) {
                            if(!error){
                                updateCurrentDamagesInVehicleSvg(relatedDamages);
                            }
                    })
                }

                function callUpdateRentalAgreementRelatedDamageStatus() {
                    var dataToSend = {status: $scope.rentalAgreementRelatedDamages.status};
                    var relatedDamageId = $scope.rentalAgreementRelatedDamages.id;

                    console.log("update damage status",dataToSend)

                    RentalAgreementAdapter.updateRelatedDamageStatus(vm.task.id,relatedDamageId,dataToSend,
                        function (damageStatus,error) {
                            if(!error){
                                console.log("damageStatus",damageStatus);
                                ShowToast.only("Damage status updated!");
                                $scope.rentalAgreementRelatedDamages.status = damageStatus
                            }else {
                                ShowToast.only("Error updating damage status," + (error.description ? error.description :error));
                            }
                        })
                }

                vm.callAddRentalAgreementRelatedDamage = callAddRentalAgreementRelatedDamage;
                vm.callUpdateRentalAgreementRelatedDamage = callUpdateRentalAgreementRelatedDamage;
                vm.callUpdateRentalAgreementRelatedDamageStatus = callUpdateRentalAgreementRelatedDamageStatus;

            });
        });


        //end my data init

        // Methods
        vm.addNewRow = addNewRow;
        vm.saveRow = saveRow;
        vm.removeRow = removeRow;

        vm.validateReservationFields = validateReservationFields;
        vm.callAddReservationAddDialog = callAddReservationAddDialog;
        vm.callAddReservationEditDialog = callAddReservationEditDialog;
        vm.callUpdateReservation = callUpdateReservation;
        vm.removeTask = removeTask;
        vm.callUpgradeReservation = callUpgradeReservation;
        vm.callDeleteReservation = callDeleteReservation;

        vm.validateRentalAgreementFields = validateRentalAgreementFields;
        vm.callAddRentalAgreementAddDialog = callAddRentalAgreementAddDialog;
        vm.callAddRentalAgreementEditDialog = callAddRentalAgreementEditDialog;
        vm.callUpgradeRentalAgreement = callUpgradeRentalAgreement;
        vm.callDeleteRentalAgreement = callDeleteRentalAgreement;

        vm.closeDialog = closeDialog;
        vm.rgba = fuseGenerator.rgba;

        vm.goToUsersView = goToUsersView;
        vm.goToUserProfileView = goToUserProfileView;
        vm.generateRentalAgreementInvoice = generateRentalAgreementInvoice;

        //////////

        /**
         * Add New Row
         */
        function addNewRow() {

            vm.chartData.push(vm.row);

            closeDialog();
        }

        /**
         * Save Row
         */
        function saveRow() {

            dialogData.formData.model = vm.row;

            closeDialog();
        }

        /**
         * Remove Row
         */
        function removeRow() {

            vm.chartData.splice(vm.chartData.indexOf(vm.chartData.getById(vm.row.id)), 1);

            closeDialog();
        }

        /**
         * Add New Task
         */

        function validateReservationFields() {

            var fields = ["from", "to", "pickup","pickUpTime","returnTime","return", "category", "vehicle", "client", "payment", "rate"];
            var isValidated = true;

            fields.forEach(function (field) {
                isValidated = isValidated && (typeof vm.task[field] != "undefined" && vm.task[field] != null)
            })

            return isValidated;
        }

        function callAddReservationAddDialog(){


            console.log("add reservation,add dialog",vm.task);

            ReservationAdapter.addReservation(vm.task,
                function (reservation,error) {

                if(!error){

                    //use scope object cause of date showing in gantt
                    vm.task.id = reservation.id;
                    vm.task.stubReservation =  false;
                    vm.task.classes = [RentalBookingColor.RESERVATION];
                    vm.task.price = reservation.price;
                    vm.chartData.getById(vm.task.vehicle).tasks.push(vm.task);

                    closeDialog();

                }else{

                    ShowToast.only("Error with new reservation," + (error.description ? error.description :error))
                }

            });

        }

        /**
         * Add New Task edit dialog
         */
        function callAddReservationEditDialog() {

            console.log("add reserv,edit dialog",vm.task);

            ReservationAdapter.addReservation(vm.task,
                function (reservation,error) {

                    if(!error){

                        //use scope object cause of date showing in gantt
                        vm.task.id = reservation.id;
                        vm.task.stubReservation =  false;
                        vm.task.classes = [RentalBookingColor.RESERVATION];
                        vm.task.price = reservation.price;
                        updateTaskData(vm.task);

                        closeDialog();

                    }else{

                        ShowToast.only("Error with new reservation," + (error.description ? error.description :error))
                    }

                });
        }

        /**
         * Save Task
         */
        function callUpdateReservation() {

            console.log("update reserv",vm.task);

            ReservationAdapter.updateReservation(vm.task,
                function (reservation,error) {

                    if(!error){

                        //use scope object cause of date showing in gantt
                        updateTaskData(vm.task);

                        closeDialog();

                    }else{

                        ShowToast.only("Error saving reservation,retry")
                    }

                });
        }

        //function to upgrade reservation to rental agreement
        function callUpgradeReservation() {

            console.log("current reserv",vm.task);

            ReservationAdapter.upgradeReservation(vm.task,

                function (data,error) {

                    if(!error){

                        //set type of reservation at 1
                        vm.task.type = vm.reservationTypes.RENTAL_AGREEMENT;
                        vm.task.classes = [RentalBookingColor.RENTAL_AGREEMENT];
                        updateTaskData(vm.task);

                        closeDialog();

                    }else{

                        ShowToast.only("Error upgrading reservation,retry")
                    }
                })

        }

        /**
         * Remove Task
         */
        function removeTask() {

            var rowTask;

            //cause missing synchronization,delete task even from row when it is added locally after send it to server
            if(vm.task.stubReservation == false) {

                console.log("stubReservation false")

                rowTask = dialogData.formData.row;
                rowTask.tasks.splice(rowTask.tasks.indexOf(rowTask.tasks.getById(vm.task.id)), 1);

            }

            var rowId =  vm.task.vehicle ? vm.task.vehicle : dialogData.formData.row.model.id;
            rowTask = vm.chartData.getById(rowId);

            rowTask.tasks.splice(rowTask.tasks.indexOf(rowTask.tasks.getById(vm.task.id)), 1);

            closeDialog();
        }

        function callDeleteReservation() {

            ReservationAdapter.deleteReservation(vm.task.id,
                function (data,error) {

                    if(!error){

                        removeTask()//close dialog

                    }else{

                        ShowToast.only("Error deleting reservation,retry")
                    }
            })

        }

        function validateRentalAgreementFields() {
            return validateReservationFields() && vm.task.deposit>=0;
        }


        function callAddRentalAgreementAddDialog() {

            console.log("add rental,add dialog",vm.task);


            RentalAgreementAdapter.addRentalAgreement(vm.task,

                function (rentalAgreement,error) {

                    if(!error){

                        //use scope object cause of date showing in gantt
                        vm.task.id = rentalAgreement.id;
                        vm.task.stubReservation =  false;
                        vm.task.type = vm.reservationTypes.RENTAL_AGREEMENT;
                        vm.task.classes = [RentalBookingColor.RENTAL_AGREEMENT];
                        vm.task.price = rentalAgreement.price;
                        vm.chartData.getById(vm.task.vehicle).tasks.push(vm.task);

                        closeDialog();

                    }else{

                        ShowToast.only("Error with new rental agreement," + (error.description ? error.description :error))
                    }

            })
        }

        function callAddRentalAgreementEditDialog() {

            console.log("add rental agreement,edit dialog",vm.task);

            RentalAgreementAdapter.addRentalAgreement(vm.task,

                function (rentalAgreement,error) {

                    if(!error){

                        //use scope object cause of date showing in gantt
                        vm.task.id = rentalAgreement.id;
                        vm.task.stubReservation =  false;
                        vm.task.type = vm.reservationTypes.RENTAL_AGREEMENT;
                        vm.task.classes = [RentalBookingColor.RENTAL_AGREEMENT];
                        vm.task.price = rentalAgreement.price;
                        updateTaskData(vm.task);

                        closeDialog();

                    }else{

                        ShowToast.only("Error with new rental agreement," + (error.description ? error.description :error))
                    }

                })
        }

        function callUpgradeRentalAgreement() {

            console.log("save rental agreement",vm.task);

            RentalAgreementAdapter.updateRentalAgreement(vm.task,

                function (rentalAgreement,error) {

                    if(!error){

                        //use scope object cause of date showing in gantt
                        updateTaskData(vm.task);

                        closeDialog();

                    }else{

                        ShowToast.only("Error saving rental agreement,retry")
                    }

                })
        }

        function callDeleteRentalAgreement() {

            RentalAgreementAdapter.deleteRentalAgreement(vm.task.id,
                function (data,error) {

                    if(!error){

                        removeTask()//close dialog

                    }else{

                        ShowToast.only("Error deleting rental agreement,retry")
                    }
                })

        }

        function goToUsersView() {

            //check if current dialog is addDialog or editDialog
            if(vm.task.vehicle){

                CurrentNewRentalBooking.setData(vm.task);
                console.log("CurrentNewRentalBooking set before go to /user",CurrentNewRentalBooking.getData());

                closeDialog();
                $state.go('app.user')
            }else {
                //invalid vehicle input
                vm.showVehicleFieldError = true;
            }

        }

        function goToUserProfileView() {

            var clientId = vm.task.client;

            if(clientId){

                CurrentNewRentalBooking.setData(vm.task);
                console.log("CurrentNewRentalBooking set before go to /user/profile",CurrentNewRentalBooking.getData());

                closeDialog();
                $state.go("app.user.profile",{user: clientId});
            }

        }

        function generateRentalAgreementInvoice() {

            var rentalAgreementId = vm.task.id;

            if(rentalAgreementId){

                closeDialog();
                $state.go('app.pages_rentalAgreement_invoice',{rentalAgreement:{id:rentalAgreementId}})

            }

            //var printContents = document.getElementById('invoice-container').innerHTML;
            /*var popupWin = window.open('dashboard.2hire.io/#/invoice/rental-agreement', '', 'width=1000,height=1000');
            popupWin.document.open();
            popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="assets/css/rentalAgreementPrintable.css"/></head><body onload="window.print()"></body></html>');
            popupWin.document.close();*/
        }


        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value) {

            return this.filter(function (x) {
                return x.id === value;
            })[0];
        };
    }
})();

(function () {
    ('use strict');

    angular
        .module('app.coupon.template.detail', []) //this is for formatting
        .config(config)
        .value('CouponTemplateDetailPage', 'app.coupon.template.detail');

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.coupon.template.detail', {
            url: '/{templateId: int}',
            views: {
                'content@app': {
                    templateUrl: 'app/main/coupon/template/details/template-detail.html',
                    controller: 'CouponTemplateDetailController as vm',
                },
            },
            resolve: {
                // NOTE AppRequirements is required for angular module injection
                Template: function (
                    AppRequirements,
                    $state,
                    $q,
                    $stateParams,
                    $timeout,
                    CouponBonusAdapter,
                    CouponTemplatesListPage,
                    ErrorUtility
                ) {
                    var deferred = $q.defer();
                    var templateId = $stateParams.template ? $stateParams.template.id : $stateParams.templateId;

                    if (typeof templateId == undefined) {
                        $timeout(function () {
                            deferred.reject();
                            $state.go(CouponTemplatesListPage);
                        });
                    }

                    CouponBonusAdapter.getTemplate(templateId, function (response, error) {
                        if (!error) {
                            deferred.resolve(response);
                        } else {
                            ErrorUtility.showErrorMessage({
                                title: 'Get Coupon Template Details',
                                description: 'Error while getting the details!',
                            });
                            deferred.reject(error);
                            $state.go(CouponTemplatesListPage);
                        }
                    });
                    return deferred.promise;
                },
            },
            params: {
                template: null,
                action: null,
            },
        });

        // // Navigation
        // msNavigationServiceProvider.saveItem('coupon.template.detail', {
        //     title: 'Coupon',
        //     icon: 'icon-receipt',
        //     state: 'app.coupon.template.detail',
        //     weight: 1,
        // });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.coupon.template.detail')
        .controller('CouponBonusAddDialogController', CouponBonusAddDialogController);

    /** @ngInject */
    function CouponBonusAddDialogController(
        Template,
        SweetAlert,
        $mdDialog,
        CouponBonusAdapter,
        SitesService,
        DefaultSite,
        ServiceSettings,
        MiscUtility,
        FiltersRequestParamFactory,
        ErrorUtility
    ) {
        var vm = this;

        vm.couponTemplate = Template || null;
        console.log(vm.couponTemplate);
        vm.coupon = {
            code: '',
            SiteId: DefaultSite.id,
        };

        vm.preventSiteChange = false;
        vm.searchSiteText = '';
        vm.sites = [];

        vm.searchOptions = [
            {
                name: 'ID',
                key: 'id',
                getItemText: function (template) {
                    return 'ID: ' + template.id + ', Name: ' + template.name;
                },
                filter: FiltersRequestParamFactory.createIdFilter,
                filterType: 'number',
                adapter: CouponBonusAdapter.getTemplates,
            },
        ];

        ServiceSettings.getServiceSettings(function (settings) {
            if (settings.loaded) {
                SitesService.getSites(function () {
                    vm.selectedSiteId = SitesService.getSelectedSite();

                    // NOTE we do not prevent admin site restricted to create only one site valid bonus at the moment, we'll decide
                    // vm.coupon.constraints.siteIds = [vm.selectedSiteId]

                    // NOTE prevent site ownership if no in All cities view
                    vm.preventSiteChange = vm.selectedSiteId !== DefaultSite.id;
                    vm.coupon.SiteId = vm.selectedSiteId;

                    var timezone = settings && settings[vm.selectedSiteId] && settings[vm.selectedSiteId].timezone;
                    vm.timezone = timezone;
                    vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                });
            }
        });

        vm.setTemplate = setTemplate;
        vm.callAddCoupon = callAddCoupon;
        vm.closeDialog = closeDialog;

        SitesService.getSites(
            function (sites) {
                vm.sites = sites;
                vm.isServiceMultisite = SitesService.isServiceMultisite;
            },
            function (error) {
                console.log('BonusTemplateAddDialogController error getting sites', error);
            }
        );

        function setTemplate(t) {
            vm.couponTemplate = t;
        }

        function callAddCoupon() {
            console.log('coupon to send', vm.coupon);

            if (!vm.couponTemplate || vm.couponTemplate.id == undefined) {
                console.warn('callAddCoupon: invalid input', vm.couponTemplate);
                ErrorUtility.showErrorMessage({
                    title: 'Add Coupon',
                    description: 'The selected Coupon Template is invalid!',
                });
                return;
            }

            vm.dataToSend = {
                code: vm.coupon.code,
                CouponTemplateId: vm.couponTemplate.id,
            };

            if (typeof vm.coupon.SiteId !== 'undefined' && vm.coupon.SiteId !== DefaultSite.id) {
                vm.dataToSend.SiteId = vm.coupon.SiteId;
            }

            console.log('dataToSend', vm.dataToSend);

            CouponBonusAdapter.addCoupon(vm.dataToSend, function (newCoupon, error) {
                if (error) {
                    const errorDescription = 'Error while adding the Coupon!';
                    if (error.type && error.type === 'already_exists') {
                        errorDescription = 'The selected code already exists!';
                    }
                    ErrorUtility.showErrorMessage({
                        title: 'Add Coupon',
                        description: errorDescription,
                    });
                } else {
                    SweetAlert.swal('Add Coupon', 'The Coupon was successfully added!', 'success');
                    closeDialog(true);
                }
            });
        }

        function closeDialog(value) {
            $mdDialog.hide(value);
        }
    }
})();

/**
 * Created by Alex on 22/12/16.
 */
(function () {
    'use strict';

    angular.module('app.utility', ['app.utility.adapter']).config(config).run(run);

    /** @ngInject */
    function config() {}

    /** @ngInject */
    function run($rootScope, $timeout, NewDashboardGatewayUtility) {
        //my code

        $rootScope.$on('$stateChangeStart', function (event, toState) {
            if (toState.external) {
                event.preventDefault();
                $timeout(function () {
                    $rootScope.loadingProgress = false;
                });
                NewDashboardGatewayUtility.openUrl(toState.url);
            }
        });
    }
})();

/**
 * Created by alex on 21/06/19.
 */
(function () {

    'use strict'

    angular.module("app.utility")
        .component('updateSegwaySettings', {
            templateUrl: "app/main/utility/directives/vehicle/update-segway-settings.html",
            bindings: {
                onUpdateClick: "&",
            },
            controller: updateSegwaySettingsController,
            controllerAs: "vm"
        })

    function updateSegwaySettingsController(VehicleSharingAdapter, ErrorUtility) {
        var vm = this

        vm.settings = {
            buttonSwitchSpeedMode: true,
            lowSpeedLimit: 6,
            mediumSpeedLimit: 15,
            highSpeedLimit: 25
        }
       
        // vm.$onInit = function () {
        //     // vm.updateVehicleFn = updateSegwaySetting
        //     // console.warn("oninit")
        // }

        // vm.$onChanges = function (changesObj) {
        //     // console.warn("onChanges")
        // }

        // vm.$onDestroy = function () {
        // }

        vm.updateSegwaySetting = updateSegwaySetting

        function updateSegwaySetting(vehicle, cb){

            VehicleSharingAdapter.unlockSegwayCommand(vehicle.id, function(response,error){
                if(error){
                    console.log(error)
                    cb(false,error)
                }else{
                    if(response.success){

                        ((VehicleSharingAdapter.setSegwaySettings(
                            {
                                buttonSwitchSpeedMode: vm.settings.buttonSwitchSpeedMode ? 1 : 0
                            }
                        ))(vehicle.id, function(response,error){
                            if(error){
                                console.log(error)
                                cb(false,error)
                            }else{
                                if(response.success){
                                    
                                    ((VehicleSharingAdapter.setSegwaySpeedLimits(
                                        {
                                            lowSpeedLimit: vm.settings.lowSpeedLimit, 
                                            mediumSpeedLimit: vm.settings.mediumSpeedLimit, 
                                            highSpeedLimit: vm.settings.highSpeedLimit
                                        }
                                    ))(vehicle.id, function(response,error){
                                        if(error){
                                            console.log(error)
                                            cb(false,error)
                                        }else{
                                            if(response.success){
        
                                                VehicleSharingAdapter.lockSegwayCommand(vehicle.id, function(response,error){
                                                    if(error){
                                                        console.log(error)
                                                        cb(false,error)
                                                    }else{
                                                        if(response.success){
                                                            cb(true,null)
                                                        }
                                                    }
                                                })
                                            }
                                        }
                                        
                                    }))
                                }
                            }
                        }))
                    }
                }
            })
        }
    }

})();
/**
 * Created by alex on 14/04/17.
 */
(function () {

    'use strict'

    angular.module("app.utility")
        .component('twoHireVehicleMap', {
            templateUrl: "app/main/utility/directives/vehicle/two-hire-vehicle-map.html",
            bindings: {
                mapProvider: "<",
                vehicles: "<", //
                onRefresh: "=?", // 
                onMapInit: "=?", // 
                focusOnVehicle: "=?", // 
                hideGeofence: "<?", //
                shownGeofenceVehicleTypes: "<" // Array containing the geofences types to display in the map. 
            },
            controller: twoHireVehicleMapController,
            controllerAs: "vm"
        })

    function twoHireVehicleMapController(
        $scope,
        $location,
        $anchorScroll,
        MapUtility,
        MapDrawingUtilities,
        GeofenceService,
        $timeout,
        ErrorUtility,
        AppConfigurations,
        MapProvider,
        VehicleUtility,
        MiscUtility
    ) {
        var vm = this;
        var mapProvider = MapProvider.GOOGLE_MAPS;
        vm.MapProvider = MapProvider;
        var mainMap = null;
        var mapLoaded = false;
        var mapInitialized = false;
        var enabledMapFitBounds = true;
        var markerClusterer = null;
        vm.mapData = null;
        var hideGeofence = false;
        var currentActiveAreas = [];

        vm.lastClickedVehicleWatcher = null;
        const mapConfigs = AppConfigurations.getMapConfigs();

        var isMapboxDefault = true;

        vm.$onInit = function () {
            // console.log("hideGeofence ",vm.hideGeofence)
            hideGeofence = vm.hideGeofence ? vm.hideGeofence : false;
            mapProvider = typeof vm.mapProvider !== 'undefined'
                ? vm.mapProvider
                : isMapboxDefault
                    ? MapProvider.MAPBOX
                    : MapProvider.GOOGLE_MAPS;

            vm.mapProvider = mapProvider;
            switch (mapProvider) {
                case MapProvider.GOOGLE_MAPS:
                    vm.mapData = {
                        center: {
                            latitude: mapConfigs.center.latitude, //41.901898,
                            longitude: mapConfigs.center.longitude, //12.503282
                        },
                        zoom: mapConfigs.zoom,
                        options: {
                            mapTypeControl: false,
                            streetViewControl: false,
                            scrollwheel: false,
                            clickableIcons: false,
                            fullscreenControlOptions: {
                                position: 9, // RIGHT_BOTTOM
                            },
                            // gestureHandling: isMobileDevice ? 'none' :''
                        },
                        vehicleMarkers: {},
                        events: {
                            tilesloaded: tilesloaded,
                        },
                    };
                    break;
                case MapProvider.MAPBOX:
                    vm.mapData = {
                        container: 'mapboxMap',
                        center: {
                            lat: mapConfigs.center.latitude, //41.901898,
                            lon: mapConfigs.center.longitude, //12.503282
                        },
                        style: 'mapbox://styles/mapbox/streets-v11',
                        scrollZoom: true,
                        vehicleMarkers: {},
                    };
                    mapboxgl.accessToken =
                        'pk.eyJ1IjoiMmhpcmUiLCJhIjoiY2tvem01NnpyMGdxbzJvbXI4MDh0bG9iYyJ9.Oyz7OovFOqR4OAzlzd7DDA';
                    mainMap = new mapboxgl.Map(vm.mapData);
                    mainMap.addControl(new mapboxgl.NavigationControl());
                    mainMap.on('load', tilesloaded);

                    VehicleUtility.getAllIconUrls().forEach(function (url) {
                        const img = new Image(60, 75);
                        img.onload = function () {
                            if (!mainMap.hasImage(url)) {
                                mainMap.addImage(url, img);
                            }
                        };
                        img.src = url;
                    });
                    mainMap.on('load', function () {
                        VehicleUtility.getAllIconUrls().forEach(function (url) {
                            if (!mainMap.getLayer(url)) {
                                if (mainMap.getSource('vehicles')) {
                                    
                                    mainMap.addLayer({
                                        id: url,
                                        type: 'symbol',
                                        source: 'vehicles',
                                        anchor: 'bottom',
                                        filter: ['all', ['!has', 'point_count'], ['==', 'url', url]],
                                        'icon-anchor': 'bottom',
                                        layout: {
                                            'icon-image': url,
                                            'icon-offset': [0, -37.5],
                                        },
                                    });
                                }

                                // Handle click on vehicle pin
                                mainMap.on('click', url, function (e) {
                                    const coordinates = e.features[0].geometry.coordinates.slice();
                                    const vehicleString = e.features[0].properties.vehicle;
                                    const vehicle = JSON.parse(vehicleString);

                                    if (typeof vehicle.reference_code !== 'undefined') {
                                        new mapboxgl.Popup()
                                            .setLngLat(coordinates)
                                            .setHTML(MapUtility.getPopupContent(vehicle))
                                            .addTo(mainMap);
                                    }
                                });
                            }
                        });
                    });

                    // Handle click on cluster
                    mainMap.on('click', 'clusters', function (e) {
                        var features = mainMap.queryRenderedFeatures(e.point, {
                            layers: ['clusters'],
                        });
                        var clusterId = features[0].properties.cluster_id;
                        mainMap.getSource('vehicles').getClusterExpansionZoom(clusterId, function (err, zoom) {
                            if (err) {
                                return;
                            }

                            mainMap.easeTo({
                                center: features[0].geometry.coordinates,
                                zoom: zoom,
                            });
                        });
                    });

                    break;

                default:
                    console.warn('unknown mapProvider', vm.mapProvider, typeof vm.mapProvider)
                    break;
            }

            $scope.$on('siteChanged', function (site) {
                if (mapInitialized && !enabledMapFitBounds) {
                    // console.warn("reset enabledMapFitBounds",enabledMapFitBounds)
                    enabledMapFitBounds = true;
                }
                //cancel interval on site change
                vm.stopVehiclesWatchers(false);
            });

            vm.onRefresh = function (vehicles) {
                if (vehicles) {
                    setMarkersForVehicles(vehicles);
                }
            };

            vm.focusOnVehicle = function (vehicle) {
                switch (mapProvider) {
                    case MapProvider.GOOGLE_MAPS:
                        const marker = vm.mapData.vehicleMarkers[vehicle.id];
                        mainMap.setCenter(new google.maps.LatLng(vehicle.latitude, vehicle.longitude));
                        mainMap.setZoom(15);
                        if (marker) {
                            google.maps.event.trigger(marker, 'click');
                        }
                        break;
                    case MapProvider.MAPBOX:
                        // TODO: Add ability to open Popup
                        mainMap.jumpTo({
                            center: [vehicle.longitude, vehicle.latitude],
                            zoom: 20,
                        });
                        break;
                    default:
                        break;
                }
                $location.hash('vehiclesMap');
                $anchorScroll();
            };
        };

        vm.$onChanges = function (changesObj) {
            if (changesObj.shownGeofenceVehicleTypes && changesObj.shownGeofenceVehicleTypes.currentValue) {
                // console.log("shownGeofenceVehicleTypes changed",changesObj.shownGeofenceVehicleTypes.currentValue)
                getGeofencingAreas();
            }
        };

        vm.$onDestroy = function () {
            //cancel interval on scope destroy
            vm.stopVehiclesWatchers(false);
        };

        function tilesloaded(map) {
            console.log('TILES_LOADED')
            if (mapLoaded) return;

            mapLoaded = true;
            switch (mapProvider) {
                case MapProvider.GOOGLE_MAPS:
                    mainMap = map;
                    
                    break;
                case MapProvider.MAPBOX:
                    mainMap = map.target
                    break;
                default:
                    break;
            }

            if (vm.onMapInit) {
                getGeofencingAreas();
                vm.onMapInit(mainMap, mapProvider);
            }

            if (vm.onRefresh) vm.onRefresh(vm.vehicles);

            vm.lastClickedVehicleWatcher = MapUtility.getCurrentVehicleWatcher();
        }

        function calculateScaledPoint(point) {
            var scale = Math.pow(2, mainMap.getZoom());
            return new google.maps.Point(point.x / scale || 0, point.y / scale || 0);
        }

        function calculateLatLngWithOffset(latlng, offsetx, offsety) {
            var worldCoordinateCenter = mainMap.getProjection().fromLatLngToPoint(latlng);
            var pixelOffset = calculateScaledPoint({ x: offsetx, y: offsety });

            var worldCoordinateNewCenter = new google.maps.Point(
                worldCoordinateCenter.x + pixelOffset.x,
                worldCoordinateCenter.y + pixelOffset.y
            );

            return mainMap.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
        }

        // if(isMobileDevice){

        //     var elem = $document[0].getElementById('twoHireVehicleMap')

        //     elem.addEventListener('touchstart', function(e){
        //         vm.touchesTemp = [{x: e.touches[0].screenX, y: e.touches[0].screenY, center: mainMap.getCenter()}]

        //         if(e.touches.length==2){
        //             vm.touchesTemp =[{x: e.touches[0].screenX, y: e.touches[0].screenY},{x: e.touches[1].screenX, y: e.touches[1].screenY}]
        //         }

        //     })

        //     elem.addEventListener('touchmove', function(e){
        //         e.preventDefault()

        //         if(e.touches.length==2){

        //             var distanceX = vm.touchesTemp[1].x - vm.touchesTemp[0].x
        //             var distanceY = vm.touchesTemp[1].y - vm.touchesTemp[0].y

        //             var startDistance = Math.sqrt(Math.pow(distanceY,2) + Math.pow(distanceX,2))
        //             var distance = Math.sqrt(Math.pow(e.touches[1].screenY - e.touches[0].screenY,2) + Math.pow(e.touches[1].screenX - e.touches[0].screenX,2))

        //             var delta = distance - startDistance

        //             if(delta>0 && delta>60){
        //                 mainMap.setZoom(mainMap.getZoom()+1)
        //                 vm.touchesTemp =[{x: e.touches[0].screenX, y: e.touches[0].screenY},{x: e.touches[1].screenX, y: e.touches[1].screenY}]

        //             }else if(delta<0 && delta<-60){
        //                 mainMap.setZoom(mainMap.getZoom()-1)
        //                 vm.touchesTemp =[{x: e.touches[0].screenX, y: e.touches[0].screenY},{x: e.touches[1].screenX, y: e.touches[1].screenY}]
        //             }

        //         }else{
        //             var newPoint = {x: e.touches[0].screenX, y: e.touches[0].screenY}
        //             var delta = {x: vm.touchesTemp[0].x - newPoint.x, y: vm.touchesTemp[0].y - newPoint.y}

        //             var movedCenter = calculateLatLngWithOffset(vm.touchesTemp[0].center, delta.x, delta.y)
        //             mainMap.setCenter(movedCenter)

        //             newPoint.center = mainMap.getCenter()
        //             vm.touchesTemp[0] = newPoint
        //         }
        //     })
        // }

        vm.stopVehiclesWatchers = MapUtility.stopVehiclesWatchers;

        function setMarkersForVehicles(vehicles) {
            if (mainMap == null) {
                console.warn("setMarkersForVehicles: set vehicles before map's load, set timeout");
                $timeout(function () {
                    setMarkersForVehicles(vehicles);
                }, 1000);
                return;
            }

            if (mapInitialized) {
                hideAllVehicleMarkers();
                // console.warn("Setting markers from refresh")
            }
            getGeofencingAreas();
            var firstVehicle = vehicles[0];
            if (!firstVehicle || (firstVehicle.latitude === 0 && firstVehicle.longitude === 0)) {
                firstVehicle = {
                    latitude: mapConfigs.center.latitude,
                    longitude: mapConfigs.center.longitude,
                };
            }
            var mapBounds =
                mapProvider === MapProvider.GOOGLE_MAPS
                    ? new google.maps.LatLngBounds()
                    : new mapboxgl.LngLatBounds(
                          [firstVehicle.longitude, firstVehicle.latitude],
                          [firstVehicle.longitude, firstVehicle.latitude]
                      );

            switch (mapProvider) {
                case MapProvider.GOOGLE_MAPS:
                    vm.mapData.vehicleMarkers = MapUtility.generateVehicleMarkers(vehicles, mapBounds, mapProvider);
                    //handle single marker
                    if (Object.keys(vm.mapData.vehicleMarkers).length > 0) {
                        if (Object.keys(vm.mapData.vehicleMarkers).length == 1) {
                            var vehicle = vehicles[0];
                            //
                            mainMap.setCenter({ lat: vehicle.latitude, lng: vehicle.longitude });
                            mainMap.setZoom(18);
                        } else if (mapBounds && enabledMapFitBounds) {
                            //fit map to bounds
                            mainMap.fitBounds(mapBounds);

                            enabledMapFitBounds = false;
                        }
                    }
                    markerClusterer = new MarkerClusterer(mainMap, vm.mapData.vehicleMarkers, {
                        imagePath: 'assets/icons/pin/Cluster_Pin_',
                    });
                    break;
                case MapProvider.MAPBOX:
                    const geoJSON = vehicles.reduce(
                        function (prev, current) {
                            // Extending bounding box
                            if (!(current.longitude === 0 && current.latitude === 0)) {
                                mapBounds.extend([current.longitude, current.latitude]);
                            }
                            prev.features.push({
                                type: 'Feature',
                                geometry: {
                                    type: 'Point',
                                    coordinates: [current.longitude, current.latitude],
                                },
                                properties: {
                                    vehicle: current,
                                    url: VehicleUtility.getIconUrl(
                                        current.type,
                                        current.status,
                                        current.inMaintenance,
                                        current.reference_code
                                    ),
                                },
                            });
                            return prev;
                        },
                        {
                            type: 'FeatureCollection',
                            features: [],
                        }
                    );
                    if (vehicles.length === 1) {
                        mainMap.jumpTo({
                            center: [firstVehicle.longitude, firstVehicle.latitude],
                            zoom: 18,
                        });
                    } else {
                        mainMap.fitBounds(mapBounds.toArray(), { padding: 64 });
                    }
                    const vehiclesSource = mainMap.getSource('vehicles');
                    const clusterLayer = mainMap.getLayer('clusters');
                    const clusterCount = mainMap.getLayer('cluster-count');
                    if (vehiclesSource) {
                        vehiclesSource.setData(geoJSON);
                    } else {
                        mainMap.addSource('vehicles', {
                            type: 'geojson',
                            data: geoJSON,
                            cluster: true,
                        });
                    }

                    if (!clusterLayer) {
                        mainMap.addLayer({
                            id: 'clusters',
                            type: 'circle',
                            source: 'vehicles',
                            filter: ['has', 'point_count'],
                            paint: {
                                // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
                                // with three steps to implement three types of circles:
                                //   * Blue, 20px circles when point count is less than 15
                                //   * Yellow, 30px circles when point count is between 15 and 30
                                //   * Pink, 40px circles when point count is greater than or equal to 30
                                'circle-color': [
                                    'step',
                                    ['get', 'point_count'],
                                    '#51bbd6',
                                    15,
                                    '#f1f075',
                                    30,
                                    '#f28cb1',
                                ],
                                'circle-radius': ['step', ['get', 'point_count'], 20, 15, 30, 30, 40],
                            },
                        });
                    }

                    if (!clusterCount) {
                        mainMap.addLayer({
                            id: 'cluster-count',
                            type: 'symbol',
                            source: 'vehicles',
                            filter: ['has', 'point_count'],
                            layout: {
                                'text-field': '{point_count_abbreviated}',
                                'text-font': ['Roboto Medium'],
                                'text-size': 14,
                            },
                        });
                    }
                    break;

                default:
                    break;
            }

            mapInitialized = true;
        }

        function showAllVehicleMarkers() {
            if (mapInitialized && markerClusterer) {
                hideAllVehicleMarkers();
                markerClusterer.addMarkers(vm.mapData.vehicleMarkers);
            }
        }

        function hideAllVehicleMarkers() {
            //clean markers cluster
            if (mapInitialized && markerClusterer) {
                markerClusterer.clearMarkers();
            }
        }

        vm.panTo = function (newPosition) {
            var position = newPosition;
            //handle google position
            if (newPosition.lat) {
                position = { lat: position.latitude, lng: position.longitude };
            }

            if (!position || position.lat == 0 || position.lng == 0) {
                return;
            }

            mainMap.panTo(newPosition);
        };

        function clearGeofenceAreasFromMap() {
            // remove active areas from map
            currentActiveAreas.forEach(function (area) {
                area.polygons.forEach(function (polygon) {
                    polygon.setMap(null);
                }, this);
            });

            // clear currentActiveAreas arr
            currentActiveAreas = [];
        }

        function updateGeofenceFunction(response, error) {
            if (error) {
                ErrorUtility.showErrorMessage({
                    title: 'Get Geofencing Area List',
                    description: 'Error while getting the geofencing area list',
                });
            } else {
                var areas = [];
                if (vm.shownGeofenceVehicleTypes && vm.shownGeofenceVehicleTypes.length > 0) {
                    const types = vm.shownGeofenceVehicleTypes;
                    areas = response.filter(function (area) {
                        return area && types.includes(area.vehicleType);
                    });
                } else {
                    areas = response;
                }
                clearGeofenceAreasFromMap();
                
                var polygons = null
                switch (mapProvider) {
                    case MapProvider.GOOGLE_MAPS:
                        for (var index in areas) {
                            var area = areas[index];
                            polygons = MapDrawingUtilities.convertServerAreaToPolygons(area.zonas, {
                                vehicleType: area.vehicleType,
                            });
                            // var polygons = area.polygons;

                            //disable polygon interaction for mobile double click
                            polygons.forEach(function (polygon) {
                                polygon.setOptions({ clickable: false });
                            });
                            area.polygons = polygons;
                            setCurrentActiveAreaOnMap(area);
                        }
                        ///set map center and zoom
                        //if (mainMap && currentActiveAreas.length>0) {
                        //var polygons = vm.currentActiveAreas[0].polygons
                        //vm.mainMap.setCenter(polygons[0].getPath().getAt(0))
                        //}
                        break;
                    case MapProvider.MAPBOX:
                        const onlyActiveArea = true;
                        const geoJson = MapDrawingUtilities.convertServerAreasToGeoJson(areas, onlyActiveArea);
                        // console.log('geojson', geoJson);
                        const legacyGeofencesSourceName = 'legacyGeofences';
                        const geoJsonSourceJson = mainMap.getSource(legacyGeofencesSourceName);

                        if (geoJsonSourceJson) {
                            geoJsonSourceJson.setData(geoJson);
                        } else {
                            mainMap.addSource(legacyGeofencesSourceName, {
                                type: 'geojson',
                                data: geoJson,
                            });
                        }

                        if (!mainMap.getLayer('legacyGeofencesPolygonFill')) {
                            if(mainMap.getLayer('clusters')) {

                                mainMap.addLayer({
                                    id: 'legacyGeofencesPolygonFill',
                                    source: legacyGeofencesSourceName,
                                    type: 'fill',
                                    paint: {
                                        'fill-color': ['get', 'fillColor'],
                                        'fill-opacity': ['get', 'fillOpacity'],
                                    },
                                }, 'clusters');
                            } else {
                                mainMap.addLayer({
                                    id: 'legacyGeofencesPolygonFill',
                                    source: legacyGeofencesSourceName,
                                    type: 'fill',
                                    paint: {
                                        'fill-color': ['get', 'fillColor'],
                                        'fill-opacity': ['get', 'fillOpacity'],
                                    },
                                });
                            }
                        }
                        if (!mainMap.getLayer('legacyGeofencesPolygonLine')) {
                            if(mainMap.getLayer('clusters')) {

                                mainMap.addLayer({
                                    id: 'legacyGeofencesPolygonLine',
                                    source: legacyGeofencesSourceName,
                                    type: 'line',
                                    paint: {
                                        'line-color': ['get', 'lineColor'],
                                        'line-width': 3,
                                    },
                                }, 'clusters');
                            } else {
                                mainMap.addLayer({
                                    id: 'legacyGeofencesPolygonLine',
                                    source: legacyGeofencesSourceName,
                                    type: 'line',
                                    paint: {
                                        'line-color': ['get', 'lineColor'],
                                        'line-width': 3,
                                    },
                                });
                            }
                        }
                        break;
                    default:
                        console.warn('unknown map provider', mapProvider);
                        break;
                }
            }
        }

        // get geofence areas from storage
        function getGeofencingAreas() {
            if(hideGeofence){
                console.warn("getGeofencingAreas: hideGeofence true")
                return
            }

            if (mapInitialized) {
                // console.log("remove current geofencearea before refresh")
                removeCurrentActiveAreaOnMap();
            }

            GeofenceService.getGeofencingAreas(updateGeofenceFunction);
        }

        function setCurrentActiveAreaOnMap(area) {
            if (area.active) {
                currentActiveAreas.push(area);
                setPolygonsOnMap(area.polygons);
            }
        }

        function setPolygonsOnMap(polygons) {
            polygons.forEach(function (polygon) {
                polygon.setMap(mainMap);
            });
        }

        function removeCurrentActiveAreaOnMap() {
            currentActiveAreas.forEach(function (area) {
                area.polygons.forEach(function (polygon) {
                    polygon.setMap(null);
                });
            });
            currentActiveAreas = [];
        }
    }

})();

/**
 * Created by alex on 21/06/19.
 */
(function () {

    'use strict'

    angular.module("app.utility")
        .component('executeVehicleCommands', {
            templateUrl: "app/main/utility/directives/vehicle/execute-vehicle-commands.html",
            bindings: {
                onUpdateClick: "&",
            },
            controller: executeVehicleCommandsController,
            controllerAs: "vm"
        })

    function executeVehicleCommandsController(VehicleSharingAdapter, VehicleTypes) {
        var vm = this

        vm.vehicleTypes = VehicleTypes
        vm.availableCommands = []
        vm.commands = [{}]
       
        // vm.$onInit = function () {
        //     // console.warn("oninit")
        // }

        // vm.$onChanges = function (changesObj) {
        //     // console.warn("onChanges",changesObj)
            
        //     // if(changesObj.vehicleTypes && changesObj.vehicleTypes.currentValue){
        //     //     initVehicleActions(changesObj.vehicleTypes.currentValue)
        //     // }
        // }

        // vm.$onDestroy = function () {
        // }

        vm.initVehicleCommands = initVehicleCommands
        vm.executeCommandsOnVehicles = executeCommandsOnVehicles
        vm.addACommand = addACommand
        vm.removeACommand = removeACommand

        function initVehicleCommands(vehicleType) {
            // console.log("initVehicleCommands", vehicleType)
            
            switch(vehicleType){
                case VehicleTypes.CAR.value : 
                    vm.availableCommands = [
                        {name:"Unlock Car", executeFn: VehicleSharingAdapter.unlockCommand},
                        {name:"Lock Car", executeFn: VehicleSharingAdapter.lockCommand},
                        {name:"Make Available", executeFn: VehicleSharingAdapter.makeAvailable},
                        {name:"Make Unavailable", executeFn: VehicleSharingAdapter.makeUnavailable}
                    ]
                    break;
                case VehicleTypes.SCOOTER.value :
                        vm.availableCommands = [
                            {name:"Start Scooter", executeFn: VehicleSharingAdapter.startCommand},
                            {name:"Stop Scooter", executeFn: VehicleSharingAdapter.stopCommand},
                            {name:"End from parked", executeFn: VehicleSharingAdapter.endCommand},
                            {name:"Open Trunk", executeFn: VehicleSharingAdapter.openTrunkCommand},
                            {name:"Close Trunk", executeFn: VehicleSharingAdapter.closeTrunkCommand},
                            {name:"Make Available", executeFn: VehicleSharingAdapter.makeAvailable},
                            {name:"Make Unavailable", executeFn: VehicleSharingAdapter.makeUnavailable}
                        ]
                    break;
                case VehicleTypes.KICK_SCOOTER.value :
                        vm.availableCommands = [
                            { name: 'Start Kick', executeFn: VehicleSharingAdapter.startKickCommand },
                            { name: 'Stop Kick', executeFn: VehicleSharingAdapter.stopKickCommand },
                            { name: 'End from parked', executeFn: VehicleSharingAdapter.endKickCommand },
                            { name: 'Disable Alarm', executeFn: VehicleSharingAdapter.disableAlarmSegwayKickCommand },
                            { name: 'Enable Alarm', executeFn: VehicleSharingAdapter.enableAlarmSegwayKickCommand },
                            { name: 'Locate', executeFn: VehicleSharingAdapter.tootSegwayKickCommand },
                            { name: 'Make Available', executeFn: VehicleSharingAdapter.makeAvailable },
                            { name: 'Make Unavailable', executeFn: VehicleSharingAdapter.makeUnavailable },
                        ];
                    break;
                case VehicleTypes.BIKE.value :
                        vm.availableCommands = [
                            {name:"Start Bike", executeFn: VehicleSharingAdapter.startBikeCommand},
                            {name:"Stop Bike", executeFn: VehicleSharingAdapter.stopBikeCommand},
                            {name:"Unlock Bike", executeFn: VehicleSharingAdapter.unlockCommand},
                            {name:"Lock Bike", executeFn: VehicleSharingAdapter.lockCommand},
                            {name:"Make Available", executeFn: VehicleSharingAdapter.makeAvailable},
                            {name:"Make Unavailable", executeFn: VehicleSharingAdapter.makeUnavailable}
                        ]
                    break;
                default:
                    
            }
            
        }

        function addACommand(index) {
            // console.log("addACommand",vm.commands,index)
            vm.commands.splice(index+1, 0, {})
        }

        function removeACommand(index) {
            // console.log("removeACommand",vm.commands,index)
            vm.commands.splice(index, 1)
        }

        function executeMultipleCommands(commands, vehicleId, callback) {

            if(commands.length === 0){
                callback(true, null)
                return
            }
            
            const command = commands.shift()

            if(Object.keys(command).length>0 && command.executeFn){

                command.executeFn(vehicleId, function(response, error){
                    if(error){
                        callback(false, error)
                    }else{
                        if((response.send !== undefined && !response.send) || (response.success !== undefined && !response.success)){ //response.success for direct segway command)
                            callback(false, error)
                        }else{
                            executeMultipleCommands(commands, vehicleId, callback)
                        }
                    }
                })
            }else{
                console.warn("executeMultipleCommands: invalid command skipped",command)
                executeMultipleCommands(commands, vehicleId, callback)
            }

        }

        function executeCommandsOnVehicles(vehicle, cb){

            if(vm.commands.length === 0){
                console.warn("executeCommandsOnVehicles: invalid commands", vm.commands)
                cb(true, null)
                return
            }

            executeMultipleCommands(vm.commands.slice(), vehicle.id, function(response, error){
                if(error){
                    cb(false, error)
                }else{
                    cb(response, null)
                }
            })
            
        }
    }

})();

(function() {
  "use strict";

  angular.module("app.utility")
    .component("twoHireAutocomplete", {
      templateUrl: "app/main/utility/directives/two-hire-autocomplete/two-hire-autocomplete.html",
      bindings: {
        options: "<",
        setResult: "=",
        selectedItem: "<",
        disabled: "<"
      },
      controller: twoHireAutocomplete,
      controllerAs: "vm"
    });

  function twoHireAutocomplete(
    $q,
    FiltersRequestParamFactory,
    ErrorUtility
  ) {
    var vm = this;

    /* ========================================== */
    /* ============ INITIALIZATIONS ============= */
    /* ========================================== */

    vm.searchText = ""
    vm.items = []
    vm.isDownloading = false
    vm.selectedSearchFilter = null

    /* ========================================== */
    /* ============ METHODS ============= */
    /* ========================================== */
    vm.getItemText = getItemText
    vm.setOptionFilter = setOptionFilter
    vm.querySearch = querySearch
    vm.updateSelectedItem = updateSelectedItem

    function updateSelectedItem(item) {
      vm.selectedItem = item
      vm.setResult(item)
    }

    function setOptionFilter(filter){
      vm.searchText = ""
      vm.selectedSearchFilter = filter
      vm.items = []
    }

    function getItemText(item){
      //case injected selectedItem
      if(vm.selectedItem && !vm.selectedSearchFilter){
        vm.selectedSearchFilter = vm.options[0]
      }
      return  (vm.selectedSearchFilter.getItemText && vm.selectedSearchFilter.getItemText(item)) || vm.options.map(function(opt){ return opt.name + ': ' + item[opt.key] }).join(', ') 
    }

    function generateFilterRequestParams(query) {
      var filter;
      switch(vm.selectedSearchFilter.filterType) {
        case 'string':
          filter = vm.selectedSearchFilter.filter(query)
          break
        case 'number': 
          filter = vm.selectedSearchFilter.filter(Number(query))
          break
        default:
          console.warn('no filterType found for this item')
          filter = { }
      }
      return FiltersRequestParamFactory.createAFilterRequestParam(filter)
    }

    function loadItems(query){
        if(vm.queryBeingDownloaded === query && vm.filterBeingDownloaded === vm.selectedSearchFilter) {
            return vm.items
        }

        var deferred = $q.defer()

        if(vm.isDownloading) {
            deferred = vm.loadItemsPromise
        }
        else if(!vm.isDownloading) {
          vm.isDownloading = true
          // track current filter and query to avoid repeating queries
          vm.queryBeingDownloaded = query
          vm.filterBeingDownloaded = vm.selectedSearchFilter

          var params = generateFilterRequestParams(query)

          vm.selectedSearchFilter.adapter(params, function(response, error) {
              vm.isDownloading = false
              if (error) {
                deferred.reject([])
                ErrorUtility.showErrorMessage({title: 'Autocomplete Error', description: 'Error getting items list'})
              } else {
                var responseData = (typeof response.data !== "undefined") ? response.data : response
                vm.items = responseData || []
                deferred.resolve(vm.items)
              }
          })

          vm.loadItemsPromise = deferred
        }
        return deferred.promise
    }

    function querySearch(query){
      
      if(query && query!=="") {
        return loadItems(query)
      }

      // return empty string to avoid the error from 
      // the autocomplete component looking for the "length" property
      return ''
    }

  }
})();

/**
 * Created by alex on 14/04/17.
 */

 (function () {

    'use strict'

    angular.module("app.utility")
        .directive("twoHireTileWithFooterColor",twoHireTileWithFooterColor)

    
    function twoHireTileWithFooterColor(){
        return{
            restrict: "E",
            scope:{
                title:"=",
                value:"=",
                description:"=",
                color:"="
            },
            templateUrl: 'app/main/utility/directives/tile-with-footer-color/tile-with-footer-color.html'
        }
    }

 })();
(function () {

    'use strict';

    angular.module("app.utility")
        .component('twoHireServiceSettings',{
                bindings: {
                    siteName:"<",
                    siteId:"<?",
                    serviceSettings:"<",
                    permitDelete:"<?",
                    showAppTranslations:"<?",
                    onUpdateServiceSettings:"&"
                },
                controllerAs:"vm",
                controller: function($state,ServiceAdapter,DialogFactory,TranslationsPage,FareUtility,FareType,OutsideAreaFareType,PaymentRequestType,InvoiceFileType,InvoiceType,VehicleTypes, ApiSettingsAdapter, SweetAlert){
                    var vm = this

                    vm.enabledVehicleTypes = []
                    // vm.multiVehicleType = VehicleType                    
                    vm.vehicleType = VehicleTypes                    
                    vm.outsideAreafareType = OutsideAreaFareType
                    vm.paymentRequestType = PaymentRequestType
                    vm.fareType = FareType
                    vm.invoiceFileType = InvoiceFileType
                    vm.invoiceType = InvoiceType
                    
                    const pricingType = {
                        TIME_PROPORTIONAL: {name: "Time proportional",value:"time_proportional"},
                        TIME_THRESHOLDS: {name: "Time thresholds",value:"time_thresholds"}
                    }
                    const minimumChargeType = {
                        FLOOR: {name: "Floor",value:"floor"}
                    }
                    vm.pricingType = pricingType
                    vm.minimumChargeType = minimumChargeType
                    vm.isNewPricing = false
                    vm.permitDelete = vm.permitDelete ? vm.permitDelete : false
                    vm.showAppTranslations = vm.showAppTranslations ? vm.showAppTranslations : false
                    vm.serviceGlobalMessage = {}
                    vm.isEditingServiceGlobalMessage = false

                    vm.$onInit = function () {
                    }

                    vm.$onChanges = function (changesObj){
                        // console.warn("changesObj",vm.siteName)
                        vm.enabledVehicleTypes = []
                        
                        // set enabledVehicleTypes from service settings
                        if(vm.serviceSettings && vm.serviceSettings.service && vm.serviceSettings.service.vehicle && vm.serviceSettings.service.vehicle.enabled && Object.keys(vm.serviceSettings.service.vehicle.enabled).length>0){
                            for(var key in VehicleTypes){
                                
                                var vehicleTypeObj = VehicleTypes[key]
                                var isEnabled = vm.serviceSettings.service.vehicle.enabled[vehicleTypeObj.value]
                                
                                if(typeof isEnabled !== "undefined"){
                                    if(vm.serviceSettings.service.vehicle.enabled[vehicleTypeObj.value]){
                                        
                                        if(!vm.enabledVehicleTypes.includes(vehicleTypeObj)){
                                            vm.enabledVehicleTypes.push(vehicleTypeObj)
                                        }
                                    }
                                }
                            }
                            // console.log("vm.enabledVehicleTypes",vm.enabledVehicleTypes)
                        }
                    }

                    vm.$postLink = function(event){
                    }
                    
                    vm.goToTranslationsPage = goToTranslationsPage
                    vm.callModifyServiceGlobalMessage = callModifyServiceGlobalMessage
                    vm.callDeleteServiceGlobalMessage = callDeleteServiceGlobalMessage
                    vm.toggleServiceGlobalMessageEditing = toggleServiceGlobalMessageEditing
                    vm.localeFieldInvalid = false
                    
                    //ctrl.callChangePricingConfirmDialog = callChangePricingConfirmDialog
                    vm.addPricingThreeshold = addPricingThreeshold
                    vm.addAvailabilityHour = addAvailabilityHour
                    vm.removePricingThreeshold = removePricingThreeshold
                    vm.removeAvailabilityHour = removeAvailabilityHour;
                    vm.callDeleteServicePropertyConfirmDialog = callDeleteServicePropertyConfirmDialog
                    
                    function getFareTypeDescription(fare){
                        return FareUtility.getFareTypeDescription(fare)
                    }

                    vm.validateLocaleFormat = function(event) {
                        vm.localeFieldInvalid = event.target.className.indexOf('ng-invalid-pattern') !== -1 ? true : false;
                    }

                    vm.handleFileUpload = function(event, siteID) {
                        var files = event.target.files
                        if (files.length > 0) {
                            var file = files[0]

                            var formData = new FormData()
                            // Type 0 corresponds to default invoice template
                            formData.append("type",0)
                            formData.append("file",file)

                            ApiSettingsAdapter.uploadInvoiceTemplate(formData, siteID, function (data,error) {
                                if(!error){
                                    var rectifiedFormData = new FormData()
                                    // Type 1 corresponds to rectified invoice template
                                    rectifiedFormData.append("type",1)
                                    rectifiedFormData.append("file",file)
                                    ApiSettingsAdapter.uploadInvoiceTemplate(formData, siteID, function (data,error) {
                                        if(!error){
                                            vm.isLoadingFile = true
                                            SweetAlert.swal("Success","Success updating invoice templates","success")
                                        }
                                        else{
                                            SweetAlert.swal("Error","Error updating rectified invoice template","error")
                                        }
                                    })
                                }
                                else{
                                    SweetAlert.swal("Error","Error updating default invoice template","error")
                                }
                            })
                            
                        }
                    
                    }


                    function addPricingThreeshold(multiVehicleTypeValue) {
                        var movoPricing = vm.serviceSettings.movo
                        if (!movoPricing) {
                            // console.warn("addPricingThreeshold: no movo pricing obj, create",multiVehicleTypeValue,vm.serviceSettings)
                            vm.serviceSettings['movo'] = movoPricing = { pricing: {} }
                        }
                        var multiVehicle = vm.serviceSettings.movo.pricing.multi_vehicle
                        if (!multiVehicle) {
                            // console.warn("addPricingThreeshold: no multi_vehicle pricing obj, create",multiVehicleTypeValue,vm.serviceSettings)
                            vm.serviceSettings.movo.pricing.multi_vehicle = multiVehicle = { time_thresholds: {}, type: {} }
                        }

                        var pricingType = multiVehicle.type
                        if (!pricingType) {
                            multiVehicle.type = pricingType = {}
                        }
                        // NOTE set default to time_thresholds because we do not use time_proportional any more
                        pricingType[multiVehicleTypeValue] = 'time_thresholds'

                        var timeThresholds = multiVehicle.time_thresholds
                        if (!timeThresholds) {
                            multiVehicle.time_thresholds = timeThresholds = {}
                        }

                        var vehicleThresholdsObj = timeThresholds[multiVehicleTypeValue]
                        if (!vehicleThresholdsObj) {
                            // console.warn("addPricingThreeshold: no thresholds array for this multi_vehicle, create",multiVehicleTypeValue,vm.serviceSettings)
                            vehicleThresholdsObj = timeThresholds[multiVehicleTypeValue] = { thresholds: [] }
                        }
                        const thresholds = vehicleThresholdsObj.thresholds
                        thresholds.push({ ms: 0, price: 0 })
                    }

                    function addAvailabilityHour(vehicleType) {
                        var serviceSetting = vm.serviceSettings.service;
                        if (!serviceSetting) {
                            vm.serviceSettings.service = serviceSetting = {};
                        }
                        var availabilitySetting = serviceSetting.availability;

                        if (!availabilitySetting) {
                            availabilitySetting = {};
                            availabilitySetting[vehicleType] = { frames: [] };
                            vm.serviceSettings.service.availability = availabilitySetting;
                        }

                        if (availabilitySetting.hasOwnProperty(vehicleType)) {
                            availabilitySetting[vehicleType].frames.push({
                                start: { hour: 0, minute: 0 },
                                end: { hour: 0, minute: 0 },
                            });
                        } else {
                            availabilitySetting[vehicleType] = {
                                frames: [
                                    {
                                        start: { hour: 0, minute: 0 },
                                        end: { hour: 0, minute: 0 },
                                    },
                                ],
                            };
                        }
                    }

                    function callDeleteServicePropertyConfirmDialog(obj,keys,event) {
                        DialogFactory.alert('Bear in mind','This field will be deleted once "Update settings" button is pressed',event)
                            .then(function (param) {
                                deleteServiceSettingsProperty(obj,keys)
                            })
                    }

                    function removePricingThreeshold(index,multiVehicleTypeValue) {
                        var array = vm.serviceSettings.movo.pricing.multi_vehicle.time_thresholds[multiVehicleTypeValue].thresholds
                        if(!array){
                            console.warn("removePricingThreeshold: no array",array)
                            return
                        }

                        array.splice(index,1)

                        if(array.length == 0){
                            delete vm.serviceSettings.movo.pricing.multi_vehicle.time_thresholds[multiVehicleTypeValue]
                        }
                    }

                    function removeAvailabilityHour(index, multiVehicleTypeValue) {
                        var array = vm.serviceSettings.service.availability[multiVehicleTypeValue].frames;
                        if (!array) {
                            console.warn('removePricingThreeshold: no array', array);
                            return;
                        }

                        array.splice(index, 1);

                        if (array.length == 0) {
                            delete vm.serviceSettings.service.availability[multiVehicleTypeValue];
                        }

                        if (Object.keys(vm.serviceSettings.service.availability).length === 0) {
                            delete vm.serviceSettings.service.availability;;
                        }

                        if (Object.keys(vm.serviceSettings.service).length === 0) {
                            delete vm.serviceSettings.service;;
                        }
                    }

                    function deleteServiceSettingsProperty(obj,keys) {

                        if(typeof obj == "undefined" || obj == null){
                            console.warn("deleteServiceSettingsProperty: obj undefined")
                            return
                        }
                        
                        keys.forEach(function (key) {
                            var keysSplitted = key.split(".")
                            if(keysSplitted.length>0){
                                var objC = obj
                                keysSplitted.forEach(function (keyIn,index) {
                                    if(index == keysSplitted.length-1){
                                        if(typeof objC == "undefined" || objC == null){
                                            console.warn("deleteServiceSettingsProperty: keysSplitted obj invalid",objC)
                                        }else{
                                            delete objC[keyIn]
                                        }
                                    }else{
                                        objC = objC[keyIn]
                                    }
                                })
                                deleteServiceSettingsEmptyProperties(obj,keysSplitted)
                            }else{
                                delete obj[key]
                            }
                        })
                    }
                    function deleteServiceSettingsEmptyProperties(obj,keysSplitted) {
                        
                        if(typeof keysSplitted == "undefined" || keysSplitted==null || typeof obj == "undefined" || obj == null){
                            console.warn("deleteServiceSettingsEmptyProperties: invalid input",obj,keysSplitted)
                            return
                        }

                        if(keysSplitted.length==0){
                            return
                        }

                        var objC = obj
                        keysSplitted.forEach(function (keyIn) {
                            if(objC.hasOwnProperty(keyIn)){
                                if(Object.keys(objC[keyIn]).length == 0){
                                    delete objC[keyIn]
                                }
                                else{
                                    objC = objC[keyIn]
                                }
                            }
                        })
                        keysSplitted.pop()
                        deleteServiceSettingsEmptyProperties(obj,keysSplitted)
                    }

                    function removeEnabledVehicleType(vehicleType){
                        if(typeof vehicleType === "undefined"){
                            console.warn("removeEnabledVehicleType: invalid vehicleType",vehicleType)
                            return
                        }
                        
                        var index = vm.enabledVehicleTypes.indexOf(Object.values(VehicleTypes).find(function(type){return type.value === vehicleType}))
                        vm.enabledVehicleTypes.splice(index,1)
                    }

                    function addEnabledVehicleType(vehicleType) {
                        
                        if(typeof vehicleType === "undefined"){
                            console.warn("addEnabledVehicleType: invalid vehicleType",vehicleType)
                            return
                        }
                        
                        var vehicleTypeObj = Object.values(VehicleTypes).find(function(type){return type.value === vehicleType})
                        if(vehicleTypeObj){
                            vm.enabledVehicleTypes.push(vehicleTypeObj)
                        }else{
                            console.warn("addEnabledVehicleType: vehicleTypeObj not found",vehicleTypeObj)
                        }
                    }

                    vm.handleVehicleTypeEnableChange = function(vehicleTypeClicked){
                        // console.warn("handleVehicleTypeEnableChange",vehicleTypeClicked,vm.serviceSettings.service.vehicle.enabled[vehicleTypeClicked])

                        if(typeof vehicleTypeClicked === "undefined"){
                            console.warn("handleVehicleTypeEnableChange: invalid input vehicleTypeClicked",vehicleTypeClicked)
                            return
                        }

                        var isVehicleTypeEnabled = vm.serviceSettings.service.vehicle.enabled[vehicleTypeClicked]
                        
                        if(typeof isVehicleTypeEnabled === "undefined"){
                            console.warn("handleVehicleTypeEnableChange: vehicle.enabled[vehicleTypeClicked] undefined")
                            return
                        }
                        
                        if(isVehicleTypeEnabled){
                            addEnabledVehicleType(vehicleTypeClicked)
                        }else{
                            removeEnabledVehicleType(vehicleTypeClicked)
                        }

                        //init undefined enabled vehicle type to override merge with base settings
                        Object.values(VehicleTypes).forEach(function(vehicleTypeObj){
                            var isEnabled = vm.serviceSettings.service.vehicle.enabled[vehicleTypeObj.value]
                            if(typeof isEnabled == "undefined"){
                                vm.serviceSettings.service.vehicle.enabled[vehicleTypeObj.value] = false
                            }
                        })
                    }

                    vm.print = function (data) {
                        console.log(data)
                        // checkServiceSettingsEmptyProperties({movo:{pricing:{price:{}}}},['movo','pricing','price'])

                    }

                    function goToTranslationsPage(){
                        $state.go(TranslationsPage)
                    }

                    function getServiceGlobalMessage(){
                        ServiceAdapter.getGlobalMessage(function(data,error){
                            if(!error){
                                // console.log("globalMessages",data)
                                if(data.length>0)
                                    vm.serviceGlobalMessage = data[data.length-1] // handle single message
                            }
                            else{
                            
                            }
                        })
                    }
        
                    function toggleServiceGlobalMessageEditing(){
        
                        if(!vm.isEditingServiceGlobalMessage){
                            vm.savedGlobalMessage = angular.copy(vm.serviceGlobalMessage)
                        }
                        else{
                            vm.serviceGlobalMessage = vm.savedGlobalMessage
                        }
                        vm.isEditingServiceGlobalMessage = !vm.isEditingServiceGlobalMessage
                    }
        
                    function callModifyServiceGlobalMessage(isUpdating){
                        //cause handling single message
                        if(vm.serviceGlobalMessage.id && !isUpdating){
                            callDeleteServiceGlobalMessage(function(){
                                callModifyServiceGlobalMessage(true)
                            })
                        }
                        else if(vm.serviceGlobalMessage.message){
        
                            var dataToSend = {message: vm.serviceGlobalMessage.message}
                            // console.log("dataToSend",dataToSend)
                            ServiceAdapter.modifyGlobalMessage(dataToSend,
                                function(data,error){
                                    if(!error){
                                        vm.isEditingServiceGlobalMessage = false
                                        getServiceGlobalMessage()
                                        SweetAlert.swal("Global Message Update","Success updating service global message","success")
                                    }
                                    else{
                                        vm.serviceGlobalMessage = vm.savedGlobalMessage
                                        SweetAlert.swal("Global Message Update","Error updating service global message","error")
                                    }
                            })
                        }
                    }
        
                    function callDeleteServiceGlobalMessage(callback){
                        if(vm.serviceGlobalMessage.id){
                            DialogFactory.confirm("Delete Global Message","Are you sure you want to delete the current global message?")
                                .then(function(){
                                    
                                    ServiceAdapter.deleteGlobalMessage(vm.serviceGlobalMessage.id,function(data,error){
                                        if(!error){
                                            console.log(data)
                                            //call modify if is an updating 
                                            if(callback){
                                                callback()
                                            }
                                            else{
                                                SweetAlert.swal("Global Message Update","Success deleting service global message","success")
                                            }
                                        }
                                        else{
                                            SweetAlert.swal("Global Message Update","Error deleting service global message","error")
                                        }
                                    })
                                })
                        }
                    }

                    // function checkIfNewPricingIsActivated(serviceSettings) {
                    //     if(serviceSettings.movo && serviceSettings.movo.pricing.type == ctrl.pricingType.TIME_THRESHOLDS.value){
                    //         ctrl.isNewPricing = true
                    //     }
                    // }

                    // function switchPricingType(){
                    //     if(ctrl.serviceSettings.movo.pricing.type == ctrl.pricingType.TIME_THRESHOLDS.value){
                    //         ctrl.serviceSettings.movo.pricing.type = ctrl.pricingType.TIME_PROPORTIONAL.value
                    //     }else{
                    //         ctrl.serviceSettings.movo.pricing.type = ctrl.pricingType.TIME_THRESHOLDS.value
                    //     }
                    //     ctrl.isNewPricing = !ctrl.isNewPricing 
                    // }

                    // function callChangePricingConfirmDialog(pricingType,ev){
                    //     console.log("old",pricingType)
                    //     ctrl.oldPricingType = pricingType
                    //     ctrl.isNewPricing = !ctrl.isNewPricing 

                    //     showChangePriceConfirmDialog(pricingType,ev,1)
                    // }

                    // function showChangePriceConfirmDialog(pricingType,ev,count){
                    //     var partContent = ""
                    //     var i = count
                    //     var fontSize = 13 * i
                        
                    //     while(i>1){
                    //         partContent += "<b style='font-size:"+fontSize+"px'>really</b> "
                    //         fontSize = fontSize - 13
                    //         i--
                    //     }
                    //     partContent += "<b>sure</b>"
                    //     var content = "Are you "+partContent+" you want to change the current pricing?"
                        
                    //     if(count>1){
                    //         switchPricingType()
                    //     }

                    //     DialogFactory.confirm("Change current pricing",content,ev,"OK","CANCEL",true)
                    //         .then(function ok(){
                    //             if(count==3){

                    //                 updateServiceSettings({
                    //                     movo:{
                    //                         pricing:{
                    //                             type: ctrl.serviceSettings.movo.pricing.type
                    //                         }
                    //                     }
                    //                 },
                    //                 function(response,error){
                    //                     if(error){
                    //                         switchPricingType()
                    //                         SweetAlert.swal("Change Current Pricing","The was an error while activating the new pricing","error")
                    //                     }else{
                    //                         SweetAlert.swal("Change Current Pricing","The new pricing has been successfully activated!","success")
                    //                     }
                    //                 })
                    //             }
                    //             else{
                    //                 switchPricingType()
                    //                 count++
                    //                 $timeout(function(){
                    //                     showChangePriceConfirmDialog(pricingType,ev,count)
                    //                 },500)
                    //             }
                    //         },function no(){
                    //             switchPricingType()            
                    //         })
                    // }
                },
                templateUrl:'app/main/utility/directives/settings/two-hire-service-settings.html'
        })
})();

(function() {
  "use strict";

  angular.module("app.utility")
    .component("paginatedTable", {
      templateUrl: "app/main/utility/directives/paginated-table/paginated-table.html",
      bindings: {
        headers: "<", // headers of the table (a.k.a. column description)              [{}, {}, {}, ...].
        data: "<", // data of the table (a.k.a. data to use to fill the table body).[{}, {}. {}, ...]
        pageLimit: "<", // data of the table (a.k.a. data to use to fill the table body).[{}, {}. {}, ...]
        onRowClick: "=", // called on row click, the unique data objected is passed as parameter.
        updateData: "=", // method to call to update data in the parent component.
        hideUpdateData: "=", // method to call to update data in the parent component.
        cssClass: "@",  // CSS class
        callUpdateDataOnInit:"<", // call update data on init
        applyUpdateData: "=?"
      },
      controller: paginatedTable,
      controllerAs: "vm"
  });

  function paginatedTable(
    $interval,
    GenerateCSVService
  ) {
    var vm = this;

    function init() {
      vm.tablePageLimit = vm.pageLimit || 50;
      
      if(vm.data) {
        switchPage()
        vm.max = Math.ceil(vm.data.length / vm.tablePageLimit);
      } else {
        vm.max = 1;
      }
    }

    // ON INIT
    vm.$onInit = function () {
      vm.applyUpdateData = vm.callUpdateData

      if(vm.callUpdateDataOnInit === undefined || vm.callUpdateDataOnInit === null) {
        vm.callUpdateDataOnInit = true;
      }

      if(vm.callUpdateDataOnInit) {
        vm.applyUpdateData();
      }

      init();
    }
      
    vm.$onChanges = function(changesObj) {
      init();
    }

    vm.getLink = function(iconInfo, data) {
      var params = "";
      if (iconInfo.key.indexOf(".")) {
        params = iconInfo.key
          .split(".")
          .reduce(function(a, b){ return (a ? a[b] : "") }, data);
      } else {
        params = data[iconInfo.key];
      }
      return params
        ? iconInfo.goto + "({" + iconInfo.gotoParams + ":" + params + "})"
        : "undefined";
    };

    /* ========================================== */
    /* ============ INITIALIZATIONS ============= */
    /* ========================================== */

    // COMPONENT RELATED
    vm.callUpdateData = callUpdateData;
    vm.dataHasLoaded = false;

    // TABLE RELATED
    vm.currentTablePageIndex = 1;
    vm.currentData = [] // vm.data.slice(0, vm.tablePageLimit);
    vm.goToTablePage = goToTablePage;

    // CSV
    vm.exportListAsCSV = exportListAsCSV

    /* ========================================== */
    /* =========== COMPONENT FUNCTIONS  ========= */
    /* ========================================== */

    function refreshLastUpdateTime() {
      const difference = moment().diff(vm.lastUpdateTime)
      vm.lastUpdateText = moment.duration(difference, "milliseconds").humanize() + ' ago';
    }

    function callUpdateData() {
      if(!vm.updateData) {
        return;
      }
      vm.isDownloadingData = true;
      
      vm.updateData(function() {
        vm.isDownloadingData = false;
        vm.dataHasLoaded = true;
        updateLastUpdateTime()
      });
    }

    function updateLastUpdateTime () {
      vm.lastUpdateTime = moment() // user's local time (NOT timezoned to the service)

      // cancel current interval if there is one
      if(vm.refreshLastUpdateInterval) {
        $interval.cancel(vm.refreshLastUpdateInterval);
      } 

      // update time
      refreshLastUpdateTime(); 

      // start new interval
      vm.refreshLastUpdateInterval = $interval(function() {
        refreshLastUpdateTime();
      }, 60000);
    }
    
    /* ========================================== */
    /* ============ TABLE FUNCTIONS  ============ */
    /* ========================================== */

    function switchPage(){
      const dataIndex = vm.currentTablePageIndex - 1
      const fromPos = dataIndex * vm.tablePageLimit;
      const toPos = dataIndex * vm.tablePageLimit + vm.tablePageLimit;
      vm.currentData = vm.data.slice(fromPos, toPos);
      document.querySelectorAll('.paginatedTable').forEach(function(el){
        el.scrollTop = 0;
      })
    }

    function goToTablePage(type) {
      if (
        vm.currentTablePageIndex === 0 ||
        typeof vm.currentTablePageIndex === "undefined" ||
        vm.currentTablePageIndex === null
      ) {
        vm.currentTablePageIndex = 1;
        switchPage()
      }

      if (type === "prev") {
        if(vm.currentTablePageIndex > 0) {
          vm.currentTablePageIndex = vm.currentTablePageIndex - 1
          switchPage()
        }
      }

      if (type === "next") {
        if(vm.currentTablePageIndex < (vm.data.length / vm.tablePageLimit)) {
          vm.currentTablePageIndex = vm.currentTablePageIndex + 1
          switchPage()
        }
      }

      if(type !== undefined || type !== null) {
        switchPage()
      }
      
    }

    /* ========================================== */
    /* ======= DOWNLOAD CSV FUNCTIONS  ========== */
    /* ========================================== */

     // remove symbols can can interrupt the csv formatting
     function curateValue(value) {
      var result = value;

      if(typeof value === 'undefined' || value === null) {
        return '';
      }

      if(typeof(value) === "number") {
        return value.toString();
      }

      //Replace all 3 types of line breaks with a space
      result = result.replace(/(\r\n|\n|\r)/g," ");

      //Replace any ";" symbol with a comma
      result = result.replace(/;/g,",");

      return result;
    }

    function exportListAsCSV() {
      var list = vm.data;
      var outputArray = [];
      var outputString = "";
      const semicolonString = ";";
      const endLineString = "\n";

      const excludedKeys = ['button', 'icon-link'];
      
      const headers = [];
      
      // remove the key types that are not shown
      for (var prop in vm.headers) {
        if (vm.headers.hasOwnProperty(prop)) {
          var value = vm.headers[prop];
          var isExcluded = excludedKeys.indexOf(value.type) > -1 || (value.hasOwnProperty('hideCsv') ? value.hideCsv : false);
          if(!isExcluded) {
            headers.push(value.name)
          }
        }
      } 
      
      // add headers to final output
      outputString = headers.join(semicolonString) + endLineString;
      
      list.forEach(function(item) {
        var row = "";
        for (var key in vm.headers) {
          if (vm.headers.hasOwnProperty(key)) {
            var field = vm.headers[key]
            if(!field.hideCsv){
              if(field.hasOwnProperty('csv')) {
                var value = field.csv(null, item);
                row += curateValue(value) + semicolonString;
              } else if (field.hasOwnProperty("type")) {
                switch(field.type) {
                  case 'link': 
                  case 'render':
                  case 'email':
                  case 'icon-click':
                    var value = field.render(item[vm.headers[key].key], item);
                    row += curateValue(value) + semicolonString;
                    break;
                  case 'icon-boolean':
                    var value = item[field.icon.key] ? 'yes' : 'no';
                    row += value + semicolonString;
                    break;
                  default:
                    // ecluded keys are not in the headers, so we just skip.
                    if(!excludedKeys.includes(field.type)) {
                      row += "" + semicolonString
                    }
                }
              } else {
                const value = item[field.key];
                row += curateValue(value) + semicolonString;
              }
            }
          }
        }
        row = row.substring(0,row.length-1)
        row += endLineString;
        outputString += row;
      });
      outputArray.push(outputString);
      GenerateCSVService.generate(outputArray);
    }
    
  }
})();

(function() {
  "use strict";

  angular.module("app.utility")
    .component("genericTable", {
      templateUrl: "app/main/utility/directives/generic-table/generic-table.html",
      bindings: {
        pageId:"@", // page ID passed to filter-row
        headers: "<", // headers of the table (a.k.a. column description)              [{}, {}, {}, ...].
        data: "<", // data of the table (a.k.a. data to use to fill the table body).[{}, {}. {}, ...]
        filters: "<", // static filters (headers) to utilize (optional).  { key: FiltersFactory.someFilter(), key: FiltersFactory.someFilter(), ...}
        // resetFilters: "=",  // reset external filters. 
        searchFilters: "<", // searcg filters to utilize (optional).  { key: FiltersFactory.someFilter(), key: FiltersFactory.someFilter(), ...}
        updateData: "=", // method to call to update data in the parent component.
        downloadData: "<", // allow csv download (optional). Boolean (Defaults to true)
        showLastUpdate: "<", // display last update time in the table. Boolean. (Defaults to true)
        enableAutoRefresh: "<", // enable table auto refresh. Boolean. (Defaults to false)
        onRowClick: "=", // called on row click, the unique data objected is passed as parameter.
        cssClass: "@", // CSS class
        pageLimit: "<", // max num of items per page
        applyFiltersTrigger: "=?",
        parseCsvData: "<"
      },
      controller: genericTable,
      controllerAs: "vm"
    });

  function genericTable(
    $scope,
    $sce,
    $timeout,
    $interval,
    FiltersFactory,
    FiltersRequestParamFactory,
    DialogFactory,
    OrderRequestParamFactory,
    GenerateCSVService,
    ServiceSettings,
    MiscUtility,
    AppConstants
  ) {
    var vm = this;
    // var trusted = {};
    var refreshDataInterval = null

    // $scope.$on('refreshServiceSettings',function (event) {
    //   init();
    // })

    // ON INIT
    vm.$onInit = function () {
      // init();

      // used by parent to trigger the filter call 
      vm.applyFiltersTrigger = vm.callApplyFilters;

      // default to true
      if(vm.showLastUpdate === undefined || vm.showLastUpdate === null) {
        vm.showLastUpdate = true;
      }

      // default to true
      if(vm.downloadData === undefined || vm.downloadData === null) {
        vm.downloadData = true;
      }

      if(vm.pageLimit) {
        vm.tablePageLimit = vm.pageLimit
      }

      if(vm.enableAutoRefresh === undefined || vm.enableAutoRefresh === null || !vm.enableAutoRefresh){
        vm.enableAutoRefresh = false
      }else{
        refreshDataInterval = MiscUtility.createRefreshDataInterval(callUpdateData, AppConstants.REFRESHDATAINTERVAL)
      }

    }

    vm.$onChanges = function(changesObj) {
      
      // handle headers obj change
      if(changesObj.headers){
        
        // look for default ordering
        var defaultSort = null;
        for(var key in vm.headers){
          if (vm.headers.hasOwnProperty(key)){
            var value = vm.headers[key];
            if(value.defaultSort) {
              defaultSort = value;
            }
          }
        }

        if(defaultSort) {
          if(defaultSort.hasOwnProperty('orderBy')) {
            setDefaultOrder(defaultSort.orderBy, defaultSort.defaultOrder)
          } else {
            console.error('the orderBy key is missing, can not sort by', defaultSort.name, 'default sorting is being applied')
            vm.callApplyFilters();
          }
        }
      }
    }

    this.$onDestroy = function () {
      $interval.cancel(vm.refreshLastUpdateInterval)
      
      if(refreshDataInterval){
        refreshDataInterval.stop()
        refreshDataInterval = null
      }

      if(isDownloadingCSVData && stopDownloadingCSVDataFn){
        stopDownloadingCSVDataFn()
      }

    };

    // vm.getSafeHtml = function (html) {
    // var result = trusted[html] || (trusted[html] = $sce.trustAsHtml(html));
    // console.log('result', result);
    // return $compile(result)($scope)[0];
    // };

    vm.getLink = function(iconInfo, data) {
      var params = "";
      if (iconInfo.key.indexOf(".")) {
        params = iconInfo.key
          .split(".")
          .reduce(function(a, b){ return (a ? a[b] : "") }, data);
      } else {
        params = data[iconInfo.key];
      }
      var state = iconInfo.activatesFilter
        ? "({searchFor:{filterKey:'" + iconInfo.gotoParams + "', value:" + params + "}})" 
        : "({" + iconInfo.gotoParams + ":" + params + "})"
      return params
        ? iconInfo.goto + state
        : "undefined";
    };

    // TODO
    vm.parseAndRender = function(string) {
      var html = $sce.trustAsHtml(string);
      // console.log('THE HTML', html)
      // var template = "<button ng-click='doSomething()'>{{label}}</button>";
      // var linkFn = $compile(template);
      // var content = linkFn($scope)[0];
      // element.append(content);
      // console.log('THE CONTENT', content);
      // return content;
      // return $parse();
      // return $compile($sce.trustAsHtml(string))($scope)[0];
      // return $sce.trustAsHtml(string);
      // return string;
      return html;
    };

    /* ========================================== */
    /* ============ INITIALIZATIONS ============= */
    /* ========================================== */

    // COMPONENT RELATED

    vm.refreshLastUpdateTime = refreshLastUpdateTime;
    vm.lastUpdateText = '...'
    vm.lastUpdateTime = null
    vm.totalDisplayed = '...'
    vm.totalAvailable = '...'

    // TABLE RELATED
    vm.tablePageLimit = 50;
    vm.currentTablePageIndex = 1;
    vm.goToTablePage = goToTablePage;
    vm.isDownloadingData = false;
    var isDownloadingCSVData = false;
    vm.callUpdateData = callUpdateData;
    vm.lastUpdate = null;
    var stopDownloadingCSVDataFn = null;

    // FILTER RELATED
    vm.selectedSearchFilter = null;
    vm.filters = null;
    // vm.resetSearchFilters = resetSearchFilters;
    vm.updateFiltersData = updateFiltersData
    vm.applyFilters = applyFilters;
    vm.callApplyFilters = callApplyFilters;
    vm.filterRequestParam = null;
    vm.callApplyOrderBy = callApplyOrderBy;
    vm.orderRequestParam = null;
    vm.selectedOrderBy = {
      ascOrder: false
    };


    // DOWNLOAD CSV RELATED
    vm.exportListAsCSVPromptDialog = exportListAsCSVPromptDialog;

    /* ========================================== */
    /* =========== COMPONENT FUNCTIONS  ============ */
    /* ========================================== */

    function refreshLastUpdateTime() {
      const difference = moment().diff(vm.lastUpdateTime)
      vm.lastUpdateText = moment.duration(difference, "milliseconds").humanize() + ' ago';
    }
    
    /* ========================================== */
    /* =========== FILTER FUNCTIONS  ============ */
    /* ========================================== */

    /**
     * This method is used by the datepickers used in the "dateRange" option.
     *  it checks both inputs have a value before submitting
     */
    // vm.callDatedApplyFilters = function(e) {
    //   const start = vm.selectedSearchFilter.selected[0];
    //   const end = vm.selectedSearchFilter.selected[1];
    //   if (start && end) {
    //     applyFilters(); // applyInnerFiltersTrigger
    //   }
    // };

    // reset table filters
    // function resetSearchFilters(exceptKey) {
    //   for (var key in vm.searchFilters) {
    //     if (typeof exceptKey !== "undefined") {
    //       if (exceptKey !== key) {
    //         const isArr = vm.searchFilters[key].selected instanceof Array;
    //         if (isArr) {
    //           if (vm.searchFilters[key].valueType === "dateRange") {
    //             vm.searchFilters[key].selected = [null, null];
    //           } else {
    //             vm.searchFilters[key].selected = [];
    //           }
    //         } else {
    //           vm.searchFilters[key].selected = null;
    //         }
    //       }
    //     } else {
    //       const isArr = vm.searchFilters[key].selected instanceof Array;
    //       if (isArr) {
    //         if (vm.searchFilters[key].valueType === "dateRange") {
    //           vm.searchFilters[key].selected = [null, null];
    //         } else {
    //           vm.searchFilters[key].selected = [];
    //         }
    //       } else {
    //         vm.searchFilters[key].selected = null;
    //       }
    //     }
    //   }

    //   // reset external filters 
    //   if(vm.resetFilters) {
    //     vm.resetFilters();
    //   }
    // }

    // instead of the method to call filters we should use the trigger
    // from the child component 
    function applyFilters(params) {
      if (vm.currentTablePageIndex !== 1) {
        resetTablePageIndex();
      }

      if (!FiltersFactory.isAfilterSelected()) {
        vm.filterRequestParam = null;
        goToTablePageWithIndex(1);
        return;
      }

      vm.applyInnerFiltersTrigger();
    }

    function callApplyFilters(externalFilters) {
      // if(externalFilters) {
      //   applySearchForFilter(externalFilters)
      // } else {
      //   $timeout.cancel(vm.applyFiltersTimeout);
      //   vm.applyFiltersTimeout = $timeout(function() {
      //     vm.applyInnerFiltersTrigger()
      //   }, 1200);
      // }
      // console.log('==== ABOUT TO CALL FILTERS')
      // $timeout.cancel(vm.applyFiltersTimeout);
      // vm.applyFiltersTimeout = $timeout(function() {
      // }, 1200);
      vm.applyInnerFiltersTrigger(externalFilters)
    }

  //   function applySearchForFilter(searchFor){
  //     var filterObj = FiltersFactory.getFilterObj(searchFor.filterKey)

  //     if(filterObj.hasOwnProperty('valueType')){
  //       vm.selectedSearchFilter = filterObj
  //       if(filterObj.options.multiple) {
  //         vm.selectedSearchFilter.selected = [ searchFor.value ]
  //       } else {
  //         vm.selectedSearchFilter.selected = searchFor.value
  //       }
        
  //       // vm.searchFilters[searchFor.filterKey].selected = searchFor.value
  //     } else {
  //       if(filterObj.options.multiple) {
  //         vm.filters[searchFor.filterKey].selected = [ searchFor.value ]
  //       } else {
  //         vm.filters[searchFor.filterKey].selected = searchFor.value
  //       }
  //     }
      
  //     callApplyFilters()
  // }

    // replace this metod with getting the current filters from the inner 
    // component . OR this should return the result of the inner trigger.
    function createFilterRequestParam() {
      var filtersFunctions = [];
      // external filters (headers)
      for (var key in vm.filters) {
        filtersFunctions.push(vm.filters[key].filter);
      }
      for (var key in vm.searchFilters) {
        filtersFunctions.push(vm.searchFilters[key].filter);
      }

      var selectedFiltersQuery = [];
      var filter = {};
      filtersFunctions.forEach(function(getFilter) {
        if(getFilter !== undefined) { // if filter was not defined will be undefined
          filter = getFilter();
          if (Object.keys(filter).length > 0) {
            selectedFiltersQuery.push(filter);
          }
        }
      });

      return FiltersRequestParamFactory.createAFilterRequestParam(
        FiltersRequestParamFactory.createAnAndFilter(selectedFiltersQuery)
      );
    }

    function setDefaultOrder(orderBy, orderingType){
      const defaultOrdering = typeof orderingType === "string" ? orderingType : "DESC"
      vm.selectedOrderBy.orderBy = orderBy;
      vm.selectedOrderBy.ascOrder = defaultOrdering === "ASC";
      setOrderRequestParam(vm.selectedOrderBy)
    }

    function setOrderRequestParam(orderByObj) {
      vm.orderRequestParam = OrderRequestParamFactory.createAOrderRequestParam([
        orderByObj.orderBy(orderByObj.ascOrder ? "ASC" : "DESC")
      ]);
    }

    function callApplyOrderBy(orderBy) {

      if (orderBy == null) return;

      if (vm.selectedOrderBy.orderBy != orderBy) {
        vm.selectedOrderBy.orderBy = orderBy;
        vm.selectedOrderBy.ascOrder = false;
      } else if (vm.selectedOrderBy.orderBy && vm.selectedOrderBy.ascOrder) {
        vm.selectedOrderBy.orderBy = null;
        vm.selectedOrderBy.ascOrder = false;
        //reset table page state
        vm.orderRequestParam = null;
        goToTablePageWithIndex(1);
        return;
      } else {
        vm.selectedOrderBy.ascOrder = !vm.selectedOrderBy.ascOrder;
      }

      applyOrderBy(orderBy);
    }

    function applyOrderBy() {
      if (vm.selectedOrderBy.orderBy == null) return;

      if (vm.currentTablePageIndex !== 1) {
        resetTablePageIndex();
      }

      setOrderRequestParam(vm.selectedOrderBy)

      vm.applyInnerFiltersTrigger()
    }

    /* ========================================== */
    /* ============ TABLE FUNCTIONS  ============ */
    /* ========================================== */

    function resetTablePageIndex() {
      vm.currentTablePageIndex = 1;
    }

    function goToTablePageWithIndex(pageIndex) {
      vm.currentTablePageIndex = pageIndex;
      goToTablePage();
    }

    function goToTablePage(type) {
      if (
        vm.currentTablePageIndex === 0 ||
        typeof vm.currentTablePageIndex === "undefined" ||
        vm.currentTablePageIndex === null
      ) {
        vm.currentTablePageIndex = 1;
      }

      if (type === "prev") {
        vm.currentTablePageIndex--;
        if (vm.currentTablePageIndex < 1) {
          vm.currentTablePageIndex = 1;
          return;
        }
      } else if (type === "next") {
        vm.currentTablePageIndex++;
      } else {
        console.log("case goTo");
      }
      vm.applyInnerFiltersTrigger()
    }

    function updateFiltersData(params) {
      vm.filterRequestParam = params;
      callUpdateData();
    }

    function callUpdateData() {
      if(!vm.updateData) {
        return;
      }

      vm.data = []
      vm.isDownloadingData = true;
      vm.totalDisplayed = '...'
      vm.totalAvailable = '...'
      vm.totalTablePages = '...'
      
      var paginationRequestParam = {
        limit: vm.tablePageLimit,
        offset: vm.tablePageLimit * (vm.currentTablePageIndex - 1)
      };

      if (
        vm.filterRequestParam !== null &&
        typeof vm.filterRequestParam === "object" &&
        Object.keys(vm.filterRequestParam).length > 0
      ) {
        //check if a filter was selected
        paginationRequestParam = FiltersRequestParamFactory.mergeObjects(
          vm.filterRequestParam,
          paginationRequestParam
        );
      }

      if (
        vm.orderRequestParam !== null &&
        typeof vm.orderRequestParam === "object" &&
        Object.keys(vm.orderRequestParam).length > 0
      ) {
        //check if orderBy was selected
        paginationRequestParam = FiltersRequestParamFactory.mergeObjects(
          vm.orderRequestParam,
          paginationRequestParam
        );
      }

      // TODO: REVIEW USE 
      if (
        typeof params !== "undefined" &&
        typeof params === "object" &&
        Object.keys(params).length > 0
      ) {
        paginationRequestParam = FiltersRequestParamFactory.mergeObjects(
          params,
          paginationRequestParam
        );
      }
      vm.updateData(paginationRequestParam, function(data, error){
        if(!isDownloadingCSVData){
          vm.isDownloadingData = false
        }

        // user's local time (NOT timezoned to the service)
        vm.lastUpdateTime = moment()
        
        // cancel current interval if there is one
        if(vm.refreshLastUpdateInterval) {
          $interval.cancel(vm.refreshLastUpdateInterval)
        } 

        // update time
        vm.refreshLastUpdateTime()

        // start new interval
        vm.refreshLastUpdateInterval = $interval(function() {
          vm.refreshLastUpdateTime()
        }, 60000)

        if(refreshDataInterval){
          refreshDataInterval.reset()
        }

        if(error){
        }else{
          vm.totalAvailable = (typeof data.count !== "undefined") ? data.count : data.length
          vm.totalDisplayed = data && data.data ? data.data.length : data.length
          // vm.totalDisplayed = totalDisplayed + '/' + numberFilter(vm.totalAvailable)
          var pagesRemaining = vm.totalAvailable / vm.tablePageLimit
          vm.totalTablePages = pagesRemaining > 1 ? Math.ceil(pagesRemaining) : 1
        }
      })
    }

    /* ========================================== */
    /* ======= DOWNLOAD CSV FUNCTIONS  ======== */
    /* ========================================== */
    function exportListAsCSVPromptDialog(event) {

      if(vm.parseCsvData){
        DialogFactory.confirm(
          "Download Data CSV",
          "Which format of CSV data do you want to use?",
          event,
          "Default",
          "Alternative"
        ).then(
          function(){
            exportCSVFormatPromptDialog(exportListAsCSV, event)
          },
          function (){
            exportCSVFormatPromptDialog(vm.parseCsvData, event)
          }
        )
      }
      else{
        exportCSVFormatPromptDialog(exportListAsCSV, event)
      }
    }

    function exportCSVFormatPromptDialog(exportFn, event){

      DialogFactory.confirm(
        "Download Data CSV",
        "Do you want to download the current page or all data?",
        event,
        "Current page",
        "All data"
      ).then(
        function ok() {
          exportFn(vm.data);

        },
        function cancel() {
          downloadAllData(function(allData, error) {
            if (error) {
              DialogFactory.alert(
                "Error while downloading data",
                "There was an error while downloading data",
                event
              );
            } else {
              exportFn(allData);
            }
          });
        }
      );
    }

    // remove symbols can can interrupt the csv formatting
    function curateValue(value) {
      var result = value;

      if(typeof value === 'undefined' || value === null) {
        return '';
      }

      if(typeof(value) === "number") {
        return value.toString();
      }

      //Replace all 3 types of line breaks with a space
      result = result.replace(/(\r\n|\n|\r)/g," ");

      //Replace any ";" symbol with a comma
      result = result.replace(/;/g,",");

      return result;
    }

    function exportListAsCSV(list) {
      var outputArray = [];
      var outputString = "";
      const semicolonString = ";";
      const endLineString = "\n";

      const excludedKeys = ['button', 'icon-link'];
      
      const headers = [];
      
      // remove the key types that are not shown
      for (var prop in vm.headers) {
        if (vm.headers.hasOwnProperty(prop)) {
          var value = vm.headers[prop];
          var isExcluded = excludedKeys.indexOf(value.type) > -1 || (value.hasOwnProperty('hideCsv') ? value.hideCsv : false);
          if(!isExcluded) {
            headers.push(value.name)
          }
        }
      } 
      
      // add headers to final output
      outputString = headers.join(semicolonString) + endLineString;
      
      list.forEach(function(item) {
        var row = "";
        for (var key in vm.headers) {
          if (vm.headers.hasOwnProperty(key)) {
            var field = vm.headers[key]
            if(!field.hideCsv){
              if(field.hasOwnProperty('csv')) {
                var value = field.csv(null, item);
                row += curateValue(value) + semicolonString;
              } else if (field.hasOwnProperty("type")) {
                switch(field.type) {
                  case 'link': 
                  case 'render':
                  case 'email':
                  case 'icon-click':
                    var value = field.render(item[vm.headers[key].key], item);
                    row += curateValue(value) + semicolonString;
                    break;
                  case 'icon-boolean':
                    var value = item[field.icon.key] ? 'yes' : 'no';
                    row += value + semicolonString;
                    break;
                  default:
                    // ecluded keys are not in the headers, so we just skip.
                    if(!excludedKeys.includes(field.type)) {
                      row += "" + semicolonString
                    }
                }
              } else {
                const value = item[field.key];
                row += curateValue(value) + semicolonString;
              }
            }
          }
        }
        row = row.substring(0,row.length-1)
        row += endLineString;
        outputString += row;
      });
      outputArray.push(outputString);
      GenerateCSVService.generate(outputArray);
    }

    function downloadAllData(cb){
      var paginationFilterRequestParam = {
        order: [[OrderRequestParamFactory.orderByDataId("ASC")]],
        limit: AppConstants.CSVPAGELIMIT,
        offset: 0
      };

      if (FiltersFactory.isAfilterSelected()) {
         paginationFilterRequestParam = FiltersRequestParamFactory.mergeObjects(
            createFilterRequestParam(),
            paginationFilterRequestParam
        );
      }
      isDownloadingCSVData = true;
      vm.isDownloadingData = true;

      stopDownloadingCSVDataFn = MiscUtility.downloadPaginatedData(
        paginationFilterRequestParam,
        vm.updateData,
        function(data, error){
          isDownloadingCSVData = false
          vm.isDownloadingData = false
          cb(data, error)
        }
      )
    }

    // function downloadAllData(cb) {
    //   var limit = 2000;
    //   var offset = 0;
    //   var startTime = moment().valueOf()
    //   var allData = [];
    //   var errorCounter = 0;
    //   var paginationFilterRequestParam = {
    //     order: [[OrderRequestParamFactory.orderByDataId("ASC")]],
    //     limit: limit,
    //     offset: offset
    //   };

    //   // vm.isDownloadingCSVData = true;
    //   vm.isDownloadingData = true;

    //   if (FiltersFactory.isAfilterSelected()) {
    //     paginationFilterRequestParam = FiltersRequestParamFactory.mergeObjects(
    //       createFilterRequestParam(),
    //       paginationFilterRequestParam
    //     );
    //   }

    //   function getHandler(data, error) {
    //     var localData = data.hasOwnProperty('data') ? data.data : data;
    //     if (error) {
    //       if (errorCounter > 5) {
    //         vm.isDownloadingData = false;
    //         cb(null, true);
    //       } else {
    //         errorCounter++;
    //         $timeout(function() {
    //           vm.updateData(paginationFilterRequestParam, getHandler, false);
    //         }, errorCounter * 1000);
    //       }
    //     } else {
    //       errorCounter = 0;
    //       if (localData.length == 0) {
    //         console.log(
    //           "end downloading all data, elapsed seconds",
    //           moment().valueOf() - startTime
    //         );
    //         // vm.isDownloadingCSVData = false;
    //         vm.isDownloadingData = false;
    //         cb(allData, null);
    //       } else {
    //         allData = allData.concat(localData);
    //         offset = offset + limit;
    //         paginationFilterRequestParam.offset = offset;

    //         if (FiltersFactory.isAfilterSelected()) {
    //           paginationFilterRequestParam = FiltersRequestParamFactory.mergeObjects(
    //             createFilterRequestParam(),
    //             paginationFilterRequestParam
    //           );
    //         }

    //         vm.updateData(paginationFilterRequestParam, getHandler, false);
    //       }
    //     }
    //   }
    //   console.log("start downloading all data", startTime);
    //   vm.updateData(paginationFilterRequestParam, getHandler, false);
    // }
  }
})();

(function() {
  "use strict";

  angular.module("app.utility").component("filterRow", {
    templateUrl: "app/main/utility/directives/filter-row/filter-row.html",
    bindings: {
      pageId:"<",
      filters: "<", // static filters (optional).  { key: FiltersFactory.someFilter(), key: FiltersFactory.someFilter(), ...}
      searchFilters: "<", // searcg filters to utilize (optional).  { key: FiltersFactory.someFilter(), key: FiltersFactory.someFilter(), ...}
      resetStaticFiltersTrigger: "=?",
      resetSearchFiltersTrigger: "=?",
      updateData: "=", // method to call to update data in the parent component. Passes the filters as parameter
      callUpdateDataOnInit: "<", // display static filters
      hideStaticFilters: "<", // display static filters
      hideSearchFilters: "<", // display search filters   
      placeholder: "@", // the placeholder text. Defaults to the text "Filter"
      allowMultiFilter: "<", // allow multiple search filters
      applyFiltersTrigger: "=?"
    },
    controller: filterRow,
    controllerAs: "vm"
  });

  function filterRow(
    $scope,
    $timeout,
    $stateParams,
    FiltersFactory,
    FiltersRequestParamFactory,
    MiscUtility,
    SitesService,
    ServiceSettings,
    SessionStorageService
  ) {
    var vm = this;
    
    vm.pageId = null;

    // ON INIT
    vm.$onInit = function () {
      // used by parent to trigger the filter call 
      vm.applyFiltersTrigger = vm.callApplyFilters;

      // reset filters
      vm.resetStaticFiltersTrigger = vm.resetStaticFilters;
      vm.resetSearchFiltersTrigger = vm.resetSearchFilters;

      // init 
      init();
      
      checkLastSessionFilter()

      // call filters
      // if(vm.callUpdateDataOnInit) {
      //   vm.callApplyFilters()
      // }
    }

    //  Called whenever one-way (<) or interpolation (@) bindings are updated
    vm.$onChanges = function() {
      //set empty if undefined
      if(vm.filters === undefined){
        vm.filters = {}
      }
      //set empty if undefined
      if(vm.searchFilters === undefined){
        vm.searchFilters = {}
      }
      vm.searchFiltersArray = []
      if(Object.keys(vm.searchFilters).length>0){
        vm.searchFiltersArray.push(vm.searchFilters)
      }
    }

    $scope.$on('refreshServiceSettings',function (event) {
      init();
    })

    /* ========================================== */
    /* ============ INITIALIZATIONS ============= */
    /* ========================================== */

    vm.selectedSearchFilter = [];
    vm.resetStaticFilters = resetStaticFilters;
    vm.resetSearchFilters = resetSearchFilters;
    vm.applyFilters = applyFilters;
    vm.callApplyFilters = callApplyFilters;
    vm.addSearchFilter = addSearchFilter
    vm.removeSearchFilter = removeSearchFilter
    vm.callDatedApplyFilters = callDatedApplyFilters

    function init() {
      ServiceSettings.getServiceSettings(function(settings){
        if(settings.loaded) {
          SitesService.getSites(function (params) {
            vm.selectedSiteId = SitesService.getSelectedSite()
            vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId)
          })
        }
      })
    }


    /* ========================================== */
    /* =============== FUNCTIONS =============== */
    /* ========================================== */

    function checkLastSessionFilter() {
      if (!vm.pageId) { 
        callApplyFilterIfOnInit();
        return;
      }

      var storedFilter = SessionStorageService.getItem('lastFilter');

      if (storedFilter) {
        var parsedFilter = JSON.parse(storedFilter);

        if (parsedFilter.id === vm.pageId) {
          for(var index = 0; index < parsedFilter.selectedSearchFilter.length; index++) {

            // check if filter not null
            if(parsedFilter.selectedSearchFilter[index]) {

              if (index > 0) {
                addSearchFilter()
              }
  
              var filterObj = FiltersFactory.getFilterByName(parsedFilter.selectedSearchFilter[index].name);
              vm.selectedSearchFilter[index] = filterObj;
  
              for(var key in vm.selectedSearchFilter[index]) {
                if (key !== 'filter') {
                  vm.selectedSearchFilter[index][key] = parsedFilter.selectedSearchFilter[index][key];
                } 
              }
            }

          } 
          
          callApplyFilters()

          return
        }
      }
      // fallback
      callApplyFilterIfOnInit()
    }

    function setLastCalledFilter() {
      if(vm.pageId && vm.selectedSearchFilter) {
        SessionStorageService.setItem('lastFilter', JSON.stringify({
          id: vm.pageId,
          selectedSearchFilter: vm.selectedSearchFilter,
        }));
      }
    }

    function callApplyFilterIfOnInit() {
      if(vm.callUpdateDataOnInit) {
        vm.callApplyFilters()
      }
    }

    function resetStaticFilters() {
      for(var key in vm.filters){
        vm.filters[key].selected = null
      }
      vm.applyFilters();
    }

    /**
     * Deactivates filters, excluding the passed parameter
     * @param {*} exceptKey string with the key of the filter we want to keep active
     */
    function resetSearchFilters(index, exceptKey) {
      // AngularJS does the binding of the filters to the methods in utility.service, even when 
      // duplicated the binding is preserved because is not a deep merge. We can NOT 
      // use angular.copy() to do a deep merge because we lose the binding of the filters, meaning
      // when that filter runs the method will not find the binded filter and it will return an empty object 
      // because is not binded to the "filters" variable in the filters factory.
      // We we must implement a barbatrick.

      // barbatrick: identify the active keys (from the other search filters) to fool angular's binding.
      var keys = [  ];
      if (exceptKey != "undefined") {
        keys.push(exceptKey)
      }
      for(var pos in vm.searchFiltersArray) {
        if(pos != index) {
          for(var k in vm.searchFiltersArray[pos]) {
            for(var filters in vm.selectedSearchFilter) {
              if(vm.selectedSearchFilter[filters] && vm.searchFiltersArray[pos][k].name === vm.selectedSearchFilter[filters].name && vm.searchFiltersArray[pos][k].selected !== null) {
                if(!keys.includes(k)) {
                  keys.push(k)
                }
              }
            }
          }
        }
      }

      for(var key in vm.searchFiltersArray[index]) {
        if (!keys.includes(key) && key !== "$$hashKey") {
          const isArr = vm.searchFiltersArray[index][key].selected instanceof Array;
          if (isArr) {
            if (vm.searchFiltersArray[index][key].valueType === "dateRange") {
              vm.searchFiltersArray[index][key].selected = [null, null];
            } else {
              vm.searchFiltersArray[index][key].selected = [];
            }
          } else {
            vm.searchFiltersArray[index][key].selected = null;
          }
        }
      }
    }

    function checkStateParams() {
      if(typeof $stateParams != "undefined" && $stateParams != null && $stateParams.searchFor) {
        if($stateParams.searchFor.value) { // if the param "value" is not null
          var searchFor = $stateParams.searchFor;
          $stateParams.searchFor = null
          applySearchForFilter(searchFor);
        }
        return;
      }
      $stateParams.searchFor = null
      callApplyFilters()
    }

    function applySearchForFilter(searchFor){
      var filterObj = FiltersFactory.getFilterObj(searchFor.filterKey)
      if(filterObj.hasOwnProperty('valueType')){
        vm.selectedSearchFilter[0] = filterObj
        if(filterObj.options.multiple) {
          vm.selectedSearchFilter[0].selected = [ searchFor.value ]
        } else {
          vm.selectedSearchFilter[0].selected = searchFor.value
        }
        
        // vm.searchFilters[searchFor.filterKey].selected = searchFor.value
      } else {
        if(filterObj.options.multiple) {
          vm.filters[searchFor.filterKey].selected = [ searchFor.value ]
        } else {
          vm.filters[searchFor.filterKey].selected = searchFor.value
        }
      }
      
      callApplyFilters()
    }

    function callApplyFilters(externalFilters) {
      if(externalFilters) {
        applySearchForFilter(externalFilters)
      } else {
        if($stateParams.searchFor) {
          checkStateParams()
        } else {
          $timeout.cancel(vm.applyFiltersTimeout);
          vm.applyFiltersTimeout = $timeout(function() {
            vm.applyFilters()
          }, 800);
        }
      }
    }

    function applyFilters() {
      // console.log("start applyFilters")

      if (!FiltersFactory.isAfilterSelected()) {
          console.log("None filter selected, show all")
          return
      } else {
          // console.log("A filter selected, hide all")
      }

      var filtersFunctions = []
      for(var key in vm.filters) {
        filtersFunctions.push(vm.filters[key].filter)
      }
      for(var filterObj in vm.searchFiltersArray) {
        for (var key in vm.searchFiltersArray[filterObj]) {
          filtersFunctions.push(vm.searchFiltersArray[filterObj][key].filter)
        }
      }

      var selectedFiltersQuery = []
      var filter = {}
      filtersFunctions.forEach(function(getFilter) {
        if(getFilter !== undefined) { // if filter was not defined will be undefined
          filter = getFilter();
          if (Object.keys(filter).length > 0) {
            // TO DO , FIXME: prevent the shadow filters generation that duplicate the filterObj generation, because of now the multifilter in a row logic creates a shadow filter for a single real filterObj
            selectedFiltersQuery.push(filter)
          }
        }
      });

      var filters = FiltersRequestParamFactory.createAFilterRequestParam(
          FiltersRequestParamFactory.createAnAndFilter(selectedFiltersQuery)
      );
      
      vm.updateData(filters);

      setLastCalledFilter();
    }

    function addSearchFilter() {

      vm.searchFiltersArray.push(vm.searchFilters)
    }

    function removeSearchFilter(index) {
      var lastFilterRemains = vm.searchFiltersArray.length === 1;

      resetSearchFilters(index);

      if(!lastFilterRemains) {
        setTimeout(function () {
          $scope.$apply(function () {
            vm.selectedSearchFilter.splice(index, 1)
            vm.searchFiltersArray.splice(index, 1)
          });
        }, 100);
      } 

      applyFilters();
    }

    function callDatedApplyFilters(index) {
      const start = vm.selectedSearchFilter[index] && vm.selectedSearchFilter[index].selected[0];
      const end = vm.selectedSearchFilter[index] && vm.selectedSearchFilter[index].selected[1];
      if (start && end) {
        applyFilters();
      }
    };
   
  }
})();

(function () {

    'use strict';

    angular.module("app.utility")
        .component('twoHireLoadingButton',{
            templateUrl:'app/main/utility/directives/buttons/two-hire-loading-button.html',
            bindings: {
                label:"<",
                myOnClick:"&",
                type:"@",
                disabled:"<",
                ariaLabel:"@"
            },
            controller: twoHireLoadingButton,
            controllerAs: "vm"
        })

        function twoHireLoadingButton($timeout){
            var vm = this
            vm.actionIsLoading = false
            vm.actionIsLoaded = false
            vm.actionSuccess = false

            vm.myOnClickHandler = function(){
                vm.actionIsLoading = true
                vm.actionIsLoaded = false
                vm.actionSuccess = false
                
                vm.myOnClick()
                    .then(function(response,error){
                            vm.actionIsLoading = false
                            vm.actionIsLoaded = true
                            if(error){
                                vm.actionSuccess = false
                            }else{
                                if(response && typeof response.send != "undefined"){
                                    vm.actionSuccess = response.send
                                }
                                else{
                                    vm.actionSuccess = true
                                }
                            }
                            $timeout(function(){
                                vm.actionIsLoaded = false
                            },1500)
                    },function(error){
                        vm.actionIsLoading = false
                        vm.actionIsLoaded = true
                        vm.actionSuccess = false
                        
                        $timeout(function(){
                            vm.actionIsLoaded = false
                        },1500)
                    })
            }
        }
})();
(function ()
{
    'use strict';

    angular
        .module('app.user',
            [
                // 3rd Party Dependencies
                'xeditable',
                "app.user.profile"
            ]
        )
        .value("UsersListPage","app.user")
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.user', {
            url    : '/user',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/user/user-list.html',
                    controller : 'UsersListController as vm'
                }
            },
            params:{
                searchFor:null
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/user');

        // Api
        //msApiProvider.register('contacts.contacts', ['app/data/contacts/contacts.json']);
        //msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('user', {
            title : 'Users',
            icon  : 'icon-account-box',
            state : 'app.user',
            weight: 30
        });

    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("user")
        
        if(!active) {
            msNavigationService.deleteItem("user")
        }
    }

})();

/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.user')
        .controller('MakeManualPaymentDialogController', MakeManualPaymentDialogController)

    /** @ngInject */
    function MakeManualPaymentDialogController(SweetAlert,$q,$timeout,$mdDialog,User,PaymentMethod,SitesService,ServiceSettings,ErrorUtility,UserAdapter,FiltersRequestParamFactory,DialogFactory){
        var vm = this

        vm.amountOfMoney = {
            amount: 0,
            description: "",
            siteId: null
        }

        vm.selectedUser = null
        vm.selectUserDisabled = false
        vm.userSites = []

        vm.searchOptions = [
            { 
                name:'ID',
                key: 'id',
                getItemText: function (user) { return "ID: "+user.id+", Email: "+user.email+", Full name: "+user.fullName},
                filter: FiltersRequestParamFactory.createUserWithIdFilter,
                filterType: 'number',
                adapter: UserAdapter.getUsers
            },
            { 
                name:'E-Mail',
                key: 'email',
                getItemText: function (user) { return "ID: "+user.id+", Email: "+user.email+", Full name: "+user.fullName},
                filter: FiltersRequestParamFactory.createUserWithEmailFilter,
                filterType: 'string',
                adapter: UserAdapter.getUsers
            },
            { 
                name:'Full Name',
                key: 'fullName',
                getItemText: function (user) { return "ID: "+user.id+", Email: "+user.email+", Full name: "+user.fullName},
                filter: FiltersRequestParamFactory.createUserWithFullNameFilter,
                filterType: 'string',
                adapter: UserAdapter.getUsers
            }
        ];
        
        if(User){
            vm.selectUserDisabled = true
            setUser(User)
        }

        vm.paymentMethod = PaymentMethod

        vm.closeDialog = closeDialog
        vm.setUser = setUser
        vm.callChargeUserPayment = callChargeUserPayment
        vm.getSiteName = SitesService.getSiteName
        vm.getCurrencySymbolBySite = function(){
            vm.currency = ServiceSettings.getCurrencySymbol(vm.amountOfMoney.siteId)
        }

        function setUser(user) {
            vm.selectedUser = user
            vm.userSites = user.UserSites
        }

        function closeDialog(value) {
            $mdDialog.hide(value)
        }

        function callChargeUserPayment(){

            var deferred = $q.defer()

            if(!vm.selectedUser){
                SweetAlert.swal("Make Manual Payment", "Please select a user!", "error")
                deferred.reject()
            }
            else if( !vm.amountOfMoney || !vm.amountOfMoney.siteId){
                SweetAlert.swal("Make Manual Payment", "Please insert a billing Site!", "error")
                deferred.reject()
            } else if( !vm.amountOfMoney || !vm.amountOfMoney.amount || vm.amountOfMoney.amount <= 0){
                SweetAlert.swal("Make Manual Payment", "Please insert a valid price!", "error")
                deferred.reject()
            }else{

                DialogFactory.confirm("Make Manual payment ", "Are you sure you want to charge this user?")
                    .then(function ok() {

                        var dataToSend = {
                            amount: vm.amountOfMoney.amount * 100,
                            description: vm.amountOfMoney.description,
                            SiteId: vm.amountOfMoney.siteId
                        }

                        // console.log("dataToSend", dataToSend)

                        UserAdapter.chargeUserPayment(vm.selectedUser.id, dataToSend, function (responseData, error) {
                            var updateInterface = false
                            if (error) {
                                ErrorUtility.showErrorMessage({ title: "Make Manual Payment", description: "Error while submitting the payment!" })
                                deferred.reject(error)
                            }
                            else {
                                if (responseData.submitted) {
                                    updateInterface = true
                                    SweetAlert.swal("Make Manual Payment", "Manual payment submitted!", "success")
                                    deferred.resolve(responseData)
                                } else {
                                    ErrorUtility.showErrorMessage({ title: "Make Manual Payment", description: "Error while submitting the payment!" })
                                    deferred.reject(error)
                                }
                            }
                            $timeout(function(){
                                closeDialog(updateInterface)
                            },1000)
                        })
                    },
                    function cancel() {
                        deferred.reject()
                    })
            }

            return deferred.promise
        }

    }

})();

/**
 * Created by alex on 27/06/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.trip.details',[])
        .config(config)
        .value("TripDetailsPage",'app.trip.details');

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {

        $stateProvider
            .state('app.trip.details',{
                url  : '/{tripId:int}',
                views: {
                    'content@app' : {
                        templateUrl: 'app/main/trip/details/trip-details.html',
                        controller : 'TripDetailsController as vm'
                    }
                },
                resolve:{
                    Trip: function (AppRequirements,$state,$q,$timeout,$stateParams,TripsAdapter,TripsListPage) {
                        
                        var detailsId = $stateParams.trip ? $stateParams.trip.id : $stateParams.tripId
                        var deferred = $q.defer();

                        if(typeof detailsId == undefined){
                            $timeout(function(){
                                deferred.reject()
                                $state.go(TripsListPage)
                            })
                        }

                        TripsAdapter.getTrip(detailsId,
                            function(trip,error){
                                if(!error){
                                    deferred.resolve(trip)
                                }
                                else{
                                    deferred.reject(error)
                                    $state.go(TripsListPage)
                                }
                            })

                        return deferred.promise;

                        /*if($stateParams.trip ==null){
                            console.log('page refreshed')
                            var detailsId = ''
                            try{
                                detailsId = LocalStorageService.getItem('detailsId')
                                if(detailsId && detailsId != '') {
                                    return TripsAdapter.getTrip(detailsId)
                                }
                                else{
                                    return goToTripList()
                                }
                            }
                            catch (err){
                                console.log("No localStorage to use for get detailsId")
                                return goToTripList()
                            }
                        }
                        else {
                            detailsId = $stateParams.trip.id
                            try{
                                LocalStorageService.setItem('detailsId',detailsId)
                                return TripsAdapter.getTrip(detailsId)
                            }
                            catch (err){
                                console.log("No localStorage to use for store detailsId")
                                return TripsAdapter.getTrip(detailsId)
                            }
                        }*/
                    }
                },
                params:{
                    trip: null
                }
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/vehicle/details');
    }
})();
/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.trip.details')
        .controller('TripEndImageDialogController', TripEndImageDialogController)

    /** @ngInject */
    function TripEndImageDialogController(
        $mdDialog,
        Trip,
        EndTripImages,
        TripsAdapter,
        ErrorUtility
    ){

        var vm = this

        vm.trip = Trip
        vm.selectedImage = { number: 0, location: "", takenAt: "" }
        vm.selectImage = selectImage
        vm.closeDialog = closeDialog
        
        // NOTE use preloaded end trip images
        if (EndTripImages && EndTripImages.length > 0) {
            vm.images = EndTripImages;
            //open first image
            selectImage(0);
        } else {
            getEndTripImages(vm.trip.id);
        }

        function getEndTripImages(tripId){
            if(!tripId){
                console.warn("no trip id",tripId)
                return
            }

            TripsAdapter.getEndTripImages(vm.trip.id, function(data, error){
                if(error){
                    ErrorUtility.showErrorMessage({title:'Get Trip End Image',description:'Error getting the images!'})
                }else{
                    vm.images = data
                    //open first image
                    selectImage(0)
                }
            } )
        }

        function selectImage(index){
            if (!vm.images || vm.images.length === 0) {
                console.warn("no images",vm.images)
                return
            }
            if (vm.images[index]) {
                vm.selectedImage.number = index
                vm.selectedImage.location = vm.images[index].location
                vm.selectedImage.takenAt = vm.images[index].created_at
            }
        }

        function closeDialog(value) {
            $mdDialog.hide(value)
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.permission.role-details', [])
        .config(config)
        .value('RoleDetailsPage', 'app.settings.permission.role-details');

    /** @ngInject */
    function config($stateProvider)
    {

        $stateProvider.state('app.settings.permission.role-details', {
            url: '/role/{id:int}',
            views: {
                'content@app': {
                    templateUrl: 'app/main/settings/permissions/role/role-details.html',
                    controller: 'RoleDetailsController as vm',
                },
            },
            resolve: {
                Role: function (
                    AppRequirements,
                    $timeout,
                    $stateParams,
                    $q,
                    $state,
                    PermissionsListPage,
                    PermissionsAdapter
                ) {
                    const id = $stateParams.id;
                    var deferred = $q.defer();

                    if (id == undefined) {
                        $timeout(function () {
                            deferred.reject();
                            $state.go(PermissionsListPage);
                        });
                    }

                    PermissionsAdapter.getRole(id, function (response, error) {
                        if (error) {
                            ErrorUtility.showErrorMessage({
                                title: 'Get Role Details',
                                description: 'Error getting the role!',
                            });
                            deferred.reject();
                            $state.go(PermissionsListPage);
                        } else {
                            deferred.resolve(response);
                        }
                    });

                    return deferred.promise;
                },
            },
            params: {},
        });

    }

})();

(function () {
    ('use strict');
    
    angular // NOTE this is for indentation
        .module('app.settings.permission.role-details')
        .controller('RoleDetailsController', RoleDetailsController);

    /** @ngInject */
    function RoleDetailsController(
        $scope,
        Role,
        PermissionsAdapter,
        ServiceSettings,
        SitesService,
        MiscUtility,
        UserUtility,
        SweetAlert,
        ErrorUtility,
        toDateFilter,
        DefaultSite,
        DialogFactory,
        UserAdapter
    ) {
        var vm = this;

        // Data
        vm.role = Role;
        vm.admins = [];

        vm.filters = {};
        vm.searchFilters = {};

        $scope.$on('refreshServiceSettings', function (event) {
            init();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    SitesService.getSites(function () {
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);

                        vm.tableFields = {
                            id: {
                                name: 'User Id',
                                class: 'vehicleRowCellSmall',
                                type: 'link',
                                link: {
                                    goto: 'app.user.details',
                                    gotoParams: 'userId',
                                    key: 'id',
                                    class: function (o) {
                                        return 'userLink';
                                    },
                                },
                                render: function (val, o) {
                                    return o.id;
                                },
                            },
                            fullName: {
                                name: 'Full Name',
                                class: 'vehicleRowCellVeryBig alignLeft',
                                ellipsis: true,
                                key: 'fullName',
                            },
                            email: {
                                name: 'Email',
                                class: 'vehicleRowCellVeryBig alignLeft',
                                ellipsis: true,
                                key: 'email',
                            },
                            creationDate: {
                                name: 'Registration date',
                                class: 'vehicleRowCellBigger',
                                type: 'render',
                                render: function (v, o) {
                                    return UserUtility.isAdminWithoutSite(o)
                                        ? toDateFilter(o.created_at, 'dateTime', DefaultSite.id)
                                        : toDateFilter(o.created_at, 'dateTime', o.SiteId);
                                },
                            },
                            restrictionSite: {
                                name: 'Restriction site',
                                class: 'vehicleRowCellBigger',
                                type: 'render',
                                render: function (v, o) {
                                    return o.SiteId !== undefined && o.SiteId !== null
                                        ? SitesService.getSiteName(o.SiteId)
                                        : 'No restriction';
                                },
                            },
                            action: {
                                name: 'Action',
                                class: 'genericTableRowCellButton',
                                type: 'button',
                                button: {
                                    class: 'md-raised button30pxHeight',
                                    click: function (user, $event) {
                                        return removeUserFromRole(user, $event);
                                    },
                                    aria: "remove user's role",
                                },
                                render: function (v, o) {
                                    return 'Remove';
                                },
                            },
                        };
                    });
                    $scope.$applyAsync();
                }
            });
        }
        init();

        // $scope.$on('siteChanged', function (site) {
        //     SitesService.getSites(function(){
        //         vm.selectedSiteId = SitesService.getSelectedSite();
        //     })
        //     vm.applyFiltersTrigger();
        // })

        // Methods
        vm.refresh = refresh;
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger;

        function refresh(paginationRequestParam, callback) {
            if (!vm.role) {
                if (callback !== undefined) {
                    callback(null, {});
                }
                return;
            }
            PermissionsAdapter.getAdminsByRole(vm.role.id, paginationRequestParam, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Admins For Role',
                        description: 'Error getting the admins list for ' + vm.role.name + ' !',
                    });
                } else {
                    var users = typeof data.data !== 'undefined' ? data.data : data;
                    if (users) {
                        vm.admins = users;
                    }
                }
                if (callback !== undefined) {
                    callback(data, error);
                }
            });
        }

        function removeUserFromRole(user, event) {
            if (!user || !vm.role) {
                console.warn('removeUserFromRole: invalid input', user, vm.role);
                return;
            }

            DialogFactory.confirm(
                "Remove User's Role",
                'Are you sure you want to remove the user ID: ' + user.id + ' from role ' + vm.role.name + ' ?',
                event
            ).then(
                function ok() {
                    UserAdapter.removeRoleFromUser(vm.role.id, user.id, function (response, error) {
                        if (error) {
                            ErrorUtility.showErrorMessage({
                                title: "Remove User's Role",
                                description: "Error while removing user's role!",
                            });
                        } else {
                            refresh();
                            SweetAlert.swal(
                                "Remove User's Role",
                                'Successfully removed the user ' + user.id + ' from role!',
                                'success'
                            );
                        }
                    });
                },
                function no() {}
            );
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger() {
            vm.applyFiltersTrigger();
        }
    }
})();

/**
 * Created by alex on 03/05/18.
 */

(function ()
{
    'use strict';

    angular.module("app.settings.device", [])
        .value('DevicesListPage','app.settings.device')
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.settings.device',{
                url  : '/devices',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/settings/devices/devices-list.html',
                        controller : 'DevicesListController as vm'
                    }
                },
                params:{
                    searchFor: null
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/vehicle');

        // Navigation
        msNavigationServiceProvider.saveItem('settings.device', {
            title : 'Devices',
            icon  : 'icon-select-inverse',
            state: "app.settings.device",
            weight: 1
        });
    }
    
    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("settings.device")
        
        if(!active) {
            msNavigationService.deleteItem("settings.device")
        }
    }

})();

/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.settings.device')
        .controller('DeviceManageDialogController', DeviceManageDialogController)

    /** @ngInject */
    function DeviceManageDialogController($scope,SweetAlert,$mdDialog,Device,DialogType,DeviceAdapter,VehicleSharingAdapter,DeviceStatus,ErrorUtility,FiltersRequestParamFactory){

        $scope.isLoading = false
        $scope.searchText = ""
        $scope.selectedVehicle = null
        $scope.vehicles = []
        $scope.isDownloading = false
        $scope.dialogTypes = {add:"add",edit:"edit"}
        $scope.deviceStatus = DeviceStatus
        $scope.device = Device

        $scope.dialogType = DialogType

        // console.log("dialogType",$scope.dialogType)
        // console.log("curr device",$scope.device)

        // $scope.querySearch = querySearch
        $scope.closeDialog = closeDialog
        $scope.callAttachVehicle = callAttachVehicle
        $scope.callDetachVehicle = callDetachVehicle
        $scope.callChangeVehicle = callChangeVehicle
        $scope.callUnlinkVehicle = callUnlinkVehicle
        $scope.callStartOTA = callStartOTA

        $scope.searchOptions = [
            { 
                name:'ID',
                key:'id',
                filter: FiltersRequestParamFactory.createVehicleWithIdFilter,
                filterType: 'number',
                adapter: VehicleSharingAdapter.getVehicles
            },
            { 
                name:'Reference Code',
                key:'reference_code',
                filter: FiltersRequestParamFactory.createVehicleWithReferenceCodeFilter,
                filterType: 'string',
                adapter: VehicleSharingAdapter.getVehicles
            },
            {
                name:'License Plate',
                key:'license_plate',
                filter: FiltersRequestParamFactory.createVehicleWithLicensePlateFilter,
                filterType: 'string',
                adapter: VehicleSharingAdapter.getVehicles
            },
        ];

        $scope.setVehicle = setVehicle;
        function setVehicle(vehicle) {
            $scope.selectedVehicle = vehicle
        }

        // function loadVehicles(){
        //     var deferred = $q.defer()

        //     if($scope.isDownloading){
        //         deferred = $scope.loadVehiclesPromise
        //     }
        //     else if(!$scope.isDownloading && $scope.vehicles.length == 0){
        //         $scope.isDownloading = true
        //         console.log("no vehicles, get vehicles")

        //         VehicleSharingAdapter.getVehicles({}, function(vehicles,error){
        //                 $scope.isDownloading = false
        //                 if(error){
        //                     ErrorUtility.showErrorMessage({title:'Get Vehicles List',description:'Error get vehicles list'})
        //                 }else{
        //                     $scope.vehicles = vehicles
        //                     deferred.resolve(querySearch($scope.searchText))
        //                 }
        //         })
        //         $scope.loadVehiclesPromise = deferred
        //     }
        //     return deferred.promise
        // }

        function callAttachVehicle(){

            if(!$scope.selectedVehicle){
                SweetAlert.swal("Manage Device","Please select the new vehicle to be attached","error")
                return
            }
            
            if($scope.device.status == $scope.deviceStatus.DETACHED.value){

                var dataToSend = {
                    vehicle: $scope.selectedVehicle.id
                }
                
                $scope.isLoading = true
                console.log("dataToSend",dataToSend)
                
                DeviceAdapter.attachVehicle($scope.device.id,dataToSend,function(data,error){
                    $scope.isLoading = false
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Manage Device',description:'Error while attaching new vehicle!'})
                    }
                    else{
                        if(data.success){
                            SweetAlert.swal("Manage Device","New vehicle attached!","success")
                            closeDialog(true)
                        }
                        else{
                            ErrorUtility.showErrorMessage({title:'Manage Device',description:'Error while attaching new vehicle!'})
                        }
                    }
                })
            }
        }

        function callDetachVehicle(){

            if($scope.device.status == $scope.deviceStatus.ATTACHED.value){
                $scope.isLoading = true

                DeviceAdapter.detachVehicle($scope.device.id,function(data,error){
                    $scope.isLoading = false
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Manage Device',description:'Error while detaching the vehicle!'})
                    }
                    else{
                        if(data.success){
                            SweetAlert.swal("Manage Device","Vehicle is succesfully detached!","success")
                            closeDialog(true)
                        }
                        else{
                            ErrorUtility.showErrorMessage({title:'Manage Device',description:'Error while detaching the vehicle!'})
                        }
                    }
                })
            } 
        }

        function callChangeVehicle(){

            if(!$scope.selectedVehicle){
                SweetAlert.swal("Manage Device","Please select the new vehicle to be attached","error")
                return
            }

            if($scope.device.status == $scope.deviceStatus.ATTACHED.value){
                var dataToSend = {
                    vehicle: $scope.selectedVehicle.id
                }
                
                $scope.isLoading = true
                console.log("dataToSend",dataToSend)

                DeviceAdapter.changeVehicle($scope.device.id,dataToSend,function(data,error){
                    $scope.isLoading = false
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Manage Device',description:'Error while changing the vehicle!'})
                    }
                    else{
                        if(data.success){
                            SweetAlert.swal("Manage Device","Vehicle is succesfully changed!","success")
                            closeDialog(true)
                        }
                        else{
                            ErrorUtility.showErrorMessage({title:'Manage Device',description:'Error while changing the vehicle!'})
                        }
                    }
                })
            } 
        }

        function callUnlinkVehicle(forced){

            if($scope.device.status == $scope.deviceStatus.ATTACHED.value){
                $scope.isLoading = true
                
                if(!$scope.device.online){
                    forced=true
                }
                DeviceAdapter.unlinkVehicle($scope.device.id,forced,function(data,error){
                    $scope.isLoading = false
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Manage Device',description:'Error while unlinking the vehicle! Force the unlinking....'})
                        callUnlinkVehicle(true)
                    }
                    else{
                        if(data.unlink){
                            SweetAlert.swal("Manage Device","Vehicle is succesfully unlinked!","success")
                            closeDialog(true)
                        }
                        else{
                            ErrorUtility.showErrorMessage({title:'Manage Device',description:'Error while unlinking the vehicle! Force the unlinking....'})
                            callUnlinkVehicle(true)
                        }
                    }
                })
            }
        }

        function callStartOTA(){
            $scope.isLoading = true
            DeviceAdapter.startOTA($scope.device.id,function(data,error){
                $scope.isLoading = false
                if(error){
                    ErrorUtility.showErrorMessage({title:'Manage Device',description:'Error while updating the vehicle!'})
                }
                else{
                    SweetAlert.swal("Manage Device","Device was succesfully updated!","success")
                    closeDialog(true)
                }
            })
        }

        function closeDialog(value) {
            $mdDialog.hide(value)
        }
    }

})();

/**
 * Created by alex on 05/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.rent.manage',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.rent.manage', {
            url    : '/manage',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/rent/manage/reservation-manager.html',
                    controller : 'ReservationManagerController as vm'
                }
            },
            resolve: {
                AliveReservations: function (AppRequirements,ReservationAdapter) {
                    return ReservationAdapter.getAliveReservations();
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/rent/manage');


        msNavigationServiceProvider.saveItem('rent.manage', {
            title : 'Ongoing Reservations',
            state : 'app.rent.manage',
            weight: 1
        });
    }

})();
/**
 * Created by alex on 05/01/17.
 */

(function () {

    angular.module('app.rent.manage')
        .controller('AssignVehicleDialogController',AssignVehicleDialogController);


    /** @ngInject */
    function AssignVehicleDialogController($mdDialog,dialogData,VehicleRentAdapter, ReservationAdapter,CategoryAdapter,CategoryService,ShowToast,VehicleTypes) {

        var vm = this;

        vm.aliveReservation = dialogData.AliveReservation;
        var aliveReservations = dialogData.AliveReservations;

        vm.availableVehicles = [];
        vm.noAvailableVehicles = true;

        vm.vehicleTypes = VehicleTypes;
        vm.categories = {};

        VehicleRentAdapter.getAvailableVehiclesFromTo(vm.aliveReservation.start,vm.aliveReservation.end,
            function (availableVehicles,error) {

                if(!error){

                    CategoryService.getCategories()
                        .then(function (categories) {

                            categories.forEach(function (category) {

                                vm.categories[category.id] = category;
                            })

                            console.log("categories",vm.categories);

                            if(availableVehicles != []){
                                vm.noAvailableVehicles = false;
                            }

                            availableVehicles.forEach(function (vehicle) {

                                vehicle.CategoryRent =  findCategory(vehicle.CategoryRentId);
                                vm.availableVehicles.push(vehicle);
                            })

                        },function (error) {

                        })
                }
            });

        //methods

        vm.assignVehicle = assignVehicle;
        vm.closeDialog = closeDialog;
        vm.findCategory = findCategory;

        function findCategory(vehicleCategoryId) {

            var category = vm.categories[vehicleCategoryId];

            if(category){
                return category
            }
            else return {name:"undefined",type:"undefined"}
        }

        function assignVehicle(vehicle){

            ReservationAdapter.assignVehicle(vm.aliveReservation.id, vehicle,
                function (data, error){

                    if (!error){
                        ReservationAdapter.upgradeReservation(vm.aliveReservation,
                            function (data, error){

                            if (!error){

                                    aliveReservations.splice(aliveReservations.indexOf(vm.aliveReservation), 1);

                                    closeDialog();
                            }else {

                                ShowToast.only("Error upgrading reservation," + error.description)
                            }
                        })
                    }else{
                        ShowToast.only("Error assigning vehicle," + error.description)
                }
            })
        }

        function closeDialog() {

            $mdDialog.hide();
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages_auth_login', [])
        .value('LoginPage','pages_auth_login')
        .value('LoginPageUrl','/login')
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // Set login app state out of root state because of AppRequirements load (only for states outer than root state) and the token checks in the routeChangeStartEvent
        $stateProvider.
            state('pages_auth_login', {
                url      : '/login',
                views    : {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@pages_auth_login': {
                        templateUrl: 'app/main/pages/auth/login/login.html',
                        controller : 'LoginController as vm'
                    }
                },
                bodyClass: 'login'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');
    }

})();
(function () {
    'use strict';

    angular.module('app.pages_auth_login').controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(
        LoginAdapter,
        LocalStorageService,
        SessionStorageService,
        ServiceTokenData,
        DialogFactory,
        UserService,
        SitesService,
        MiscData,
        DefaultSite,
        LogInUtility,
        LogInService,
        $timeout,
        $q
    ) {
        // Data and Methods

        var vm = this;

        vm.loginData = {
            username: '',
            password: '',
        };
        vm.rememberMe = true;
        vm.isOtpVisible = false;
        vm.showResetPasswordTab = false;

        vm.companyData = {
            name: '',
        };
        //company login tab
        var prevTab = 0;
        vm.selectedTab = 0;

        var isCompanyLoginLoading = false;
        var lastCompanyLoginTimeout = null;

        //check if serviceToken exists
        vm.canLogin = LocalStorageService.getItem(ServiceTokenData.TOKEN) ? true : false;
        var overrideAutoCompanyLogin = false;

        if (vm.canLogin) {
            console.log('LoginController: service token exists');
            vm.companyData.name = LocalStorageService.getItem(ServiceTokenData.COMPANY);
            //set login tab in advance
            callCompanyLogin();
            onTabSelect(1);
        } else {
            console.log('LoginController: service token not exists yet');
        }

        function onTabSelect(nextTabIndex) {
            // console.warn("set tab to", nextTabIndex,"from", prevTab,"loading", isCompanyLoginLoading)
            if (isCompanyLoginLoading && prevTab == 1 && nextTabIndex == 0) {
                // console.warn("would not login")
                overrideAutoCompanyLogin = true;
                return;
            }
            prevTab = nextTabIndex;
            vm.selectedTab = nextTabIndex;
        }

        vm.onTabSelect = onTabSelect;
        vm.callCompanyLogin = callCompanyLogin;
        vm.callLogin = callLogin;

        function handleCompanyLoginEnd(service) {
            if (overrideAutoCompanyLogin) {
                // console.warn("auto company login end but user is in company tab")
                overrideAutoCompanyLogin = false;
                vm.canLogin = false;
                return;
            }
            //enable login tab
            vm.canLogin = true;
            //select login tab
            onTabSelect(1);

            //set service sites if service supports it
            if (service.multisite) {
                console.log('This service supports multisite');
                SitesService.setSites(service.Sites);
            }
        }

        function callCompanyLogin(event, callback) {
            var deferred = $q.defer();

            var companyName = vm.companyData.name;
            if (!companyName) {
                $timeout(function () {
                    deferred.reject();
                    DialogFactory.alert('Wrong Company name', 'The Company Name you supplied was wrong!', event);
                });

                return deferred.promise;
            }

            isCompanyLoginLoading = true;

            // Reset otp input activation if the user call new company login
            vm.isOtpVisible = false;

            LogInUtility.doCompanyLogIn(companyName, function (service, error) {
                isCompanyLoginLoading = false;

                if (error) {
                    console.log('Error in LoginController.callCompanyLogin', error);
                    vm.canLogin = false;
                    onTabSelect(0);
                    deferred.reject();

                    if (error.type == 'internal') {
                        DialogFactory.alert('Internal Error', error.description, event);
                    } else {
                        DialogFactory.alert('Wrong Company name', 'The Company Name you supplied was wrong!', event);
                    }
                    if (callback) {
                        callback(null, error);
                    }
                } else {
                    try {
                        handleCompanyLoginEnd(service);
                        deferred.resolve({});

                        if (callback) {
                            callback(service, null);
                        }
                    } catch (error) {
                        //handle safari error if in private mode
                        console.log(error);
                        vm.canLogin = false;
                        onTabSelect(0);
                        deferred.reject();
                        DialogFactory.alert(
                            'Browser Error',
                            'Check if you are in private mode,in case disable it',
                            event
                        );
                    }
                }
            });

            return deferred.promise;
        }

        function callLogin(event) {
            var deferred = $q.defer();

            if (!vm.companyData.name) {
                console.log('LoginController.callLogin: company log in not done yet, callCompanyLogin');
                const event = null;
                return callCompanyLogin(event, function (service, error) {
                    if (error) {
                    } else {
                        callLogin(event);
                    }
                });
            }

            if (!vm.loginData.username || !vm.loginData.password) {
                deferred.reject();
                DialogFactory.alert('Wrong credentials', 'The credentials you supplied were wrong!', event);
                return deferred.promise;
            }

            var loginData = {
                username: vm.loginData.username.toLowerCase(),
                password: vm.loginData.password,
            };

            if (vm.loginData.otpCode) {
                loginData.otpcode = vm.loginData.otpCode;
            }

            //force at login time the dafault site as the one selected because it is saved in the local storage even if rememberMe is false
            SitesService.setSelectedSite({ id: DefaultSite.id, name: DefaultSite.name });

            function handleLoginResponse(responseData) {
                var token = responseData.token;
                var tokenCode = token.code;
                var user = token.User;
                // console.log("login success",responseData)

                if (user === undefined || user === null) {
                    DialogFactory.alert(
                        'Login Error',
                        'There was an error during the login, please contact 2hire support',
                        event
                    );
                    return;
                }

                UserService.currentUserId = user.id;
                SessionStorageService.setItem(MiscData.USERID, user.id);

                //store login data only if user want
                if (vm.rememberMe) {
                    try {
                        LogInService.saveLoginData(tokenCode, token.expire, true);

                        console.log('LoginController,remember me checked');

                        LogInUtility.setAuthorizationHeader(tokenCode);

                        if (user.SiteId !== undefined && user.SiteId !== null) {
                            var restrictedSite = { id: user.SiteId, name: '' };
                            SitesService.setSelectedSite(restrictedSite, true);
                        }

                        deferred.resolve({});

                        window.location = ''; //default route
                    } catch (error) {
                        console.log(error);
                        deferred.reject();
                        //handle safari error if in private mode
                        DialogFactory.alert(
                            'Browser Error',
                            'Check if you are in private mode,in case disable it',
                            event
                        );
                    }
                } else {
                    try {
                        LogInService.saveLoginData(tokenCode, token.expire, false);

                        console.log('LoginController,remember me NOT checked');

                        LogInUtility.setAuthorizationHeader(tokenCode);

                        if (user.SiteId !== undefined && user.SiteId !== null) {
                            var restrictedSite = { id: user.SiteId, name: '' };
                            SitesService.setSelectedSite(restrictedSite, true);
                        }

                        deferred.resolve({});

                        window.location = ''; //default route
                    } catch (err) {
                        console.log(error);
                        deferred.reject();
                        //handle safari error if in private mode
                        DialogFactory.alert(
                            'Browser Error',
                            'Check if you are in private mode,in case disable it',
                            event
                        );
                    }
                }
            }

            if(vm.showResetPasswordTab){
                loginData = {
                    username: loginData.username,
                    temp_password: loginData.password,
                    new_password: vm.loginData.newPassword,
                }

                LoginAdapter.loginTempPassword(loginData, 
                    function(responseData, responseError){
                        if(!responseError){
                            if(responseData.token){
                                handleLoginResponse(responseData);
                            }
                        } else {
                            console.log('Error in LoginController', responseError);
                            deferred.reject();

                            if (responseError.type == 'internal') {
                                DialogFactory.alert('Internal Error', responseError.description, event);
                            } else if (responseError.type == 'invalid_otp') {
                                DialogFactory.alert('Invalid OTP Code', responseError.description, event);
                            } else if (responseError.type == 'temp_password_expired') {
                                DialogFactory.alert('Password expired', responseError.description, event);
                            } else {
                                DialogFactory.alert('Wrong credentials', 'The credentials you supplied were wrong!', event);
                            }
                        }
                    }
                );
            }
            else
            {
                LoginAdapter.login(
                    loginData,

                    function (responseData, responseError) {
                        if (!responseError) {
                            if (responseData.token) {
                                handleLoginResponse(responseData);
                            } else if (responseData.otpCode === true) {
                                vm.isOtpVisible = true;
                                deferred.reject();
                            } else if (responseData.tempPassword === true) {
                                vm.showResetPasswordTab = true;
                                deferred.reject();             
                            }
                        } else {
                            console.log('Error in LoginController', responseError);

                            deferred.reject();

                            if (responseError.type == 'internal') {
                                DialogFactory.alert('Internal Error', responseError.description, event);
                            } else if (responseError.type == 'invalid_otp') {
                                DialogFactory.alert('Invalid OTP Code', responseError.description, event);
                            } else if (responseError.type == 'temp_password_expired') {
                                DialogFactory.alert('Password expired', responseError.description, event);
                            } else {
                                DialogFactory.alert('Wrong credentials', 'The credentials you supplied were wrong!', event);
                            }
                        }
                    }
                );
            }

            return deferred.promise;
        }
    }
})();

/**
 * Created by alex on 23/08/17.
 */

(function () {
    'use strict'

    angular.module('app.invoice',['app.invoice.details'])
        .value('InvoicesListPage','app.invoice')
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.invoice',{
                url : '/invoices',
                views : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/invoice-list.html',
                        controller : 'InvoicesController as vm'
                    }
                },
                params:{
                    searchFor: null
                }
            })

        // Navigation
        msNavigationServiceProvider.saveItem('invoice', {
            title : 'Tickets',
            icon  : 'icon-receipt',
            state: 'app.invoice',
            weight: 35
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("invoice")
        
        if(!active) {
            msNavigationService.deleteItem("invoice")
        }
    }
})();

/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.invoice')
        .controller('BulkChargesDialogController', BulkChargesDialogController)

    /** @ngInject */
    function BulkChargesDialogController($scope, SweetAlert, $q, $timeout, $mdDialog, InvoiceElementType, InvoicesAdapter, UserAdapter, MiscUtility, ErrorUtility, FiltersRequestParamFactory, ServiceSettings, SitesService) {

        var vm = this;

        $scope.selectedUser = null;
        $scope.newCharge = { amountOfMoney: 0, description: "", siteId: null, newTotal: 0 };
        $scope.closeDialog = closeDialog;
        $scope.searchOptions = [
            {
                name: 'ID',
                key: 'id',
                filter: FiltersRequestParamFactory.createUserWithIdFilter,
                filterType: 'number',
                adapter: UserAdapter.getUsers
            },
            {
                name: 'E-Mail',
                key: 'email',
                filter: FiltersRequestParamFactory.createUserWithEmailFilter,
                filterType: 'string',
                adapter: UserAdapter.getUsers
            },
            {
                name: 'Full Name',
                key: 'fullName',
                filter: FiltersRequestParamFactory.createUserWithFullNameFilter,
                filterType: 'string',
                adapter: UserAdapter.getUsers
            }
        ];

        $scope.callAddCharge = callAddCharge;
        $scope.isBulkActive = false;
        $scope.isBulkUploadError = false;
        $scope.loadingProgress = 0;
        $scope.bulkUploadKeys = [
            { key: 0, name: "User ID", index: 0 },
            { key: 1, name: "Amount", index: 1 },
            { key: 2, name: "Description", index: 2 },
            { key: 3, name: "Site Name", index: 3 },
        ];
        $scope.headingRowExists = false;
        $scope.fileLines = [];
        $scope.bulkKeysTable = [];
        $scope.updateBulkKeysTable = updateBulkKeysTable;
        $scope.totalUploadedFileRows = null;

        $scope.setUser = setUser;
        function setUser(user) {
            $scope.selectedUser = user
        }

        function getSiteIdFromUser(siteName) {
            for (var i = 0; i < $scope.selectedUser.UserSites.length; i++) {
                if ($scope.selectedUser.UserSites[i].name === siteName) {
                    return $scope.selectedUser.UserSites[i].id
                }
            }
        }

        function updateBulkKeysTable() {
            var sliceStart = $scope.headingRowExists ? 1 : 0;
            const lines = $scope.fileLines.slice(sliceStart, sliceStart + 3);
            $scope.bulkKeysTable = lines.map(function (row, i) {
                var r = {};
                for (var i = 0; i < row.length; i++) {
                    r[i] = row[i];
                }
                return r;
            });
        }

        vm.getSiteName = SitesService.getSiteName
        vm.getCurrencySymbolBySite = function (ev) {
            vm.currency = ServiceSettings.getCurrencySymbol($scope.newCharge.siteId)
        }

        var rowData = {};

        function validateRowFields(fields) {
            rowData = {};
            const errors = [];

            var userIdColumn = $scope.bulkUploadKeys[0].index;
            if (fields[userIdColumn] === "" || isNaN(fields[userIdColumn])) {
                errors.push('user ID: ' + fields[userIdColumn]);
                return errors;
            } else {
                rowData.UserId = Number(fields[userIdColumn]);
            }

            var chargeAmountIndex = $scope.bulkUploadKeys[1].index;
            var chargeAmountParsed = fields[chargeAmountIndex];
            if (chargeAmountParsed === "" || isNaN(Number(chargeAmountParsed)) || Number(chargeAmountParsed) <= 0) {
                errors.push('price: ' + chargeAmountParsed);
                return errors;
            } else {
                rowData.amount = parseFloat(chargeAmountParsed) * 100;
            }

            var descriptionColumnIndex = $scope.bulkUploadKeys[2].index;
            var descriptionColumn = fields[descriptionColumnIndex]
            if (descriptionColumn === '') {
                errors.push('description: ' + descriptionColumn);
                return errors;
            } else {
                rowData.description = descriptionColumn;
            }

            var siteIdColumn = $scope.bulkUploadKeys[3].index;
            var chargeSiteName = fields[siteIdColumn];
            var siteId = SitesService.getSiteId(chargeSiteName);
            if (!siteId) {
                errors.push('site ID: ' + chargeSiteName);
                return errors;
            } else {
                rowData.SiteId = siteId;
            }

            return errors;
        }

        function callAddBulkTableCharges(file) {
            var fs = new FileReader()
            fs.onload = parseFile
            fs.readAsText(file)
            function parseFile() {
                var data = fs.result
                var prevIndex = -1
                var lineCounter = 0

                for (var i = 0; i < data.length; i++) {
                    if (data[i] == '\n') {
                        lineCounter += 1
                        var currentRow = data.substring(prevIndex + 1, i)
                        var fields = currentRow.split(";")

                        //skip empty line
                        if (fields.length === 1) {
                            continue
                        }

                        //remove end of line or carriage return
                        fields[fields.length - 1] = fields[fields.length - 1].trim()

                        $scope.fileLines.push(fields);

                        prevIndex = i
                    }

                    if (i === data.length - 1 && prevIndex < i) {
                        SweetAlert.swal("Error while parsing", "Missing end of line!", "error")
                        return
                    }
                }

                updateBulkKeysTable()

                $scope.$apply(function () {
                    $scope.isBulkActive = true;
                });
            }
        }

        function initInputFileListeners() {
            initInputFileListener("id_charges_csv", callAddBulkTableCharges)
        }

        $timeout(function () {
            initInputFileListeners()
        }, 1000)


        function initInputFileListener(inputId, eventHandler) {

            var inputFile = document.getElementById(inputId)
            inputFile.addEventListener("change",
                function (event) {
                    eventHandler(event.target.files[0])
                }
            )
        }

        function parseFileLines() {
            $scope.loadingProgress = 0;
            var chargesParsed = [];
            const headingRowExists = $scope.headingRowExists;
            var start = headingRowExists ? 1 : 0;
            for (var i = start; i < $scope.fileLines.length; i++) {
                var errors = validateRowFields($scope.fileLines[i]);
                if (errors.length > 0) {
                    SweetAlert.swal("Error while parsing", "Line " + i + ' ' + errors.join(',') + ' is invalid', "error")
                    return;
                } else {
                    chargesParsed.push(rowData)
                }
            }

            var progressStep = (1 / chargesParsed.length) * 100;
            $scope.totalUploadedFileRows = 0;

            addChargesAsync(chargesParsed,
                function () {
                    $scope.loadingProgress += progressStep;
                    $scope.totalUploadedFileRows++;
                }, function (success, errorObj) {
                    if (success) {
                        SweetAlert.swal("Add Charges", "All charges added!", "success")
                        closeDialog(true)
                    } else {
                        $scope.isBulkUploadError = true
                        ErrorUtility.showErrorMessage({ title: "Add charges", description: "Error on charge " + (errorObj.charge.id || errorObj.charge.description) + " at line " + $scope.totalUploadedFileRows + ': ' + (errorObj.error.description || errorObj.error) + '. All charges before this row were addedd successfully.' })
                    }
                })
        }



        function addChargesAsync(charges, onElement, cb) {
            if (charges.length === 0) {
                cb(true, null)
                return
            }

            var chargeToSend = charges.shift()

            UserAdapter.chargeUserPayment(chargeToSend.UserId, chargeToSend, function (responseData, error) {
                onElement()
                if (error) {
                    console.log("error adding charge", chargeToSend)
                    cb(false, { error: error, charge: chargeToSend })
                }
                else {
                    console.log('Charge added', chargeToSend)
                    addChargesAsync(charges, onElement, cb)
                }
            })

        }

        function callAddCharge() {

            if ($scope.isBulkActive) {
                parseFileLines();
                return;
            }

            var deferred = $q.defer()

            // {amountOfMoney:0,description:"",siteId: null, newTotal: 0}

            if (!$scope.selectedUser) {
                SweetAlert.swal("Add Charge", "Please select a user!", "error")
                deferred.reject()
            }
            else if (!$scope.newCharge.siteId) {
                SweetAlert.swal("Add Charge", "Please insert a billing Site!", "error")
                deferred.reject()
            } else if (!$scope.newCharge.amountOfMoney || $scope.newCharge.amountOfMoney.amount <= 0) {
                SweetAlert.swal("Add Charge", "Please insert a valid price!", "error")
                deferred.reject()
            }
            else if (!$scope.newCharge.description) {
                SweetAlert.swal("Add Charge", "Please insert a valid description!", "error")
                deferred.reject()
            }
            else {
                var dataToSend = {
                    amount: $scope.newCharge.amountOfMoney * 100,
                    description: $scope.newCharge.description,
                    SiteId: $scope.newCharge.siteId
                }

                console.log("dataToSend", dataToSend)

                UserAdapter.chargeUserPayment($scope.selectedUser.id, dataToSend, function (responseData, error) {
                    var updateInterface = false
                    if (error) {
                        ErrorUtility.showErrorMessage({ title: "Make Manual Payment", description: "Error while submitting the payment!" })
                        deferred.reject(error)
                    }
                    else {
                        if (responseData.submitted) {
                            updateInterface = true
                            SweetAlert.swal("Make Manual Payment", "Manual payment submitted!", "success")
                            deferred.resolve(responseData)
                        } else {
                            ErrorUtility.showErrorMessage({ title: "Make Manual Payment", description: "Error while submitting the payment!" })
                            deferred.reject(error)
                        }
                    }
                    $timeout(function () {
                        closeDialog(updateInterface)
                    }, 1000)
                })

            }

            return deferred.promise
        }


        function closeDialog(value) {
            $mdDialog.hide(value)
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.history',
            [
                // 3rd Party Dependencies
                'wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                'uiGmapgoogle-maps',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.history', {
                abstract: true,
                url     : '/history'
            })
            .state('app.history.reservations', {
                url      : '/reservation',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/history/views/reservations/rentBooking.html',
                        controller : 'RentBookingController as vm'
                    }
                },
                resolve  : {
                    RentBookings: function (ReservationAdapter) {
                        return  ReservationAdapter.getReservations()
                    }
                },
                data:{
                    type : "reservation"
                },
                bodyClass: 'e-commerce'
            })
            .state('app.history.rentalAgreements',{
                url: '/rental-agreement',
                views : {
                    'content@app' : {
                        templateUrl: 'app/main/history/views/reservations/rentBooking.html',
                        controller: 'RentBookingController as vm'
                    }
                },
                resolve: {
                    RentBookings: function (AppRequirements,RentalAgreementAdapter) {
                        return RentalAgreementAdapter.getRentalAgreements()
                    }
                },
                data:{
                    type : "rentalAgreement"
                }
            });
            /*.state('app.history.reservations.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/history/views/order/order.html',
                        controller : 'OrderController as vm'
                    }
                },
                resolve  : {
                },
                bodyClass: 'e-commerce'
            });*/

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/history');

        // Api
        //msApiProvider.register('history.orders', ['app/data/e-commerce/orders.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('history', {
            title : 'History',
            icon  : 'icon-history',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('history.reservations', {
            title: 'Reservations',
            state: 'app.history.reservations'
        });

        msNavigationServiceProvider.saveItem('history.rentalAgreement',{
            title: 'Rental agreements',
            state: 'app.history.rentalAgreements'
        })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.history')
        .controller('RentBookingController', RentBookingController);

    /** @ngInject */
    function RentBookingController($state,RentBookingStatus,RentBookings,MiscUtility)
    {
        var vm = this;

        // Options
        vm.getCurrencyValue = MiscUtility.getCurrencyValue

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the status column
                    targets: 4,
                    render : function (cellData, type, rowData, rowMeta)
                    {

                        // Get last order status
                        //var orderStatusId = vm.reservations[rowMeta.row].status;

                        var currentStatus = RentBookingStatus[cellData];

                        if ( type === 'display' )
                        {

                            return '<span class="status ' + currentStatus.color + '">' + currentStatus.name + '</span>';
                        }

                        if ( type === 'filter' )
                        {
                            return currentStatus.name;
                        }

                        return cellData;
                    }
                }/*,
                {
                    // Target the actions column
                    targets           : 9,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }*/
            ],
            initComplete: function () {

                var api = this.api();
                var searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        // Data

        vm.viewTypes = {
            RESERVATION: "reservation",
            RENTALAGREEMENT: "rentalAgreement"
        };

        vm.viewType = $state.current.data.type;

        vm.rentBookings = RentBookings;


        // Methods
        vm.gotoOrderDetail = gotoOrderDetail;

        //////////

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoOrderDetail(id)
        {
            $state.go('app.history.reservations.detail', {id: id});
        }
    }
})();
(function () {
    ('use strict');

    angular // this is for formatting
        .module('app.coupon.template', ['app.coupon.template.detail'])
        .config(config)
        .run(run)
        .value('CouponTemplatesListPage', 'app.coupon.template');

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.coupon.template', {
            url: 'https://dashboard-v2.2hire.io/bonus/coupon/templates',
            external: true,
        });

        // Navigation
        msNavigationServiceProvider.saveItem('coupon-template', {
            title: 'Campaigns',
            icon: 'icon-content-duplicate',
            state: 'app.coupon.template',
            weight: 47,
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled('coupon-template');
        if (!active) {
            msNavigationService.deleteItem('coupon-template');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.coupon.template')
        .controller('CouponTemplateAddDialogController', CouponTemplateAddDialogController);

    /** @ngInject */
    function CouponTemplateAddDialogController(
        $state,
        $element,
        $timeout,
        BonusTemplate,
        SweetAlert,
        $mdDialog,
        BonusAdapter,
        CouponBonusAdapter,
        CouponTemplateValidityTimeType,
        SitesService,
        DefaultSite,
        ServiceSettings,
        CouponTemplateDetailPage,
        BonusTemplatesListPage,
        MiscUtility,
        FiltersRequestParamFactory,
        ErrorUtility,
        AppSettings
    ) {
        var vm = this;

        vm.bonusTemplate = BonusTemplate || null;
        vm.validityTimeType = CouponTemplateValidityTimeType;
        vm.template = {
            name: '',
            purchased: false,
            onlyNewUser: false,
            noRedeemLimit: false,
            constraints: {
                validityTime: [{}, {}],
                siteIds: [DefaultSite.id],
            },
            SiteId: DefaultSite.id,
        };
        vm.createCouponSelected = false;
        vm.preventSiteChange = false;
        vm.showPurchase = false;
        vm.searchSiteText = '';
        vm.sites = [];

        vm.searchOptions = [
            {
                name: 'ID',
                key: 'id',
                getItemText: function (template) {
                    return 'ID: ' + template.id + ', Type: ' + template.type + ', Descr: ' + template.description;
                },
                filter: FiltersRequestParamFactory.createIdFilter,
                filterType: 'number',
                adapter: BonusAdapter.getTemplates,
            },
        ];

        ServiceSettings.getServiceSettings(function (settings) {
            if (settings.loaded) {
                SitesService.getSites(function () {
                    vm.selectedSiteId = SitesService.getSelectedSite();

                    // NOTE we do not prevent admin site restricted to create only one site valid bonus at the moment, we'll decide
                    // vm.template.constraints.siteIds = [vm.selectedSiteId]

                    // NOTE prevent site ownership if no in All cities view
                    vm.preventSiteChange = vm.selectedSiteId !== DefaultSite.id;
                    vm.template.SiteId = vm.selectedSiteId;

                    var timezone = settings && settings[vm.selectedSiteId] && settings[vm.selectedSiteId].timezone;
                    vm.timezone = timezone;
                    vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                });
            }
        });

        vm.closeDialog = closeDialog;
        vm.onSiteChange = onSiteChange;
        vm.setBonusTemplate = setBonusTemplate;
        vm.callAddTemplate = callAddTemplate;
        vm.goToBonusTemplatesPage = goToBonusTemplatesPage;

        SitesService.getSites(
            function (sites) {
                vm.sites = sites;
                vm.isServiceMultisite = SitesService.isServiceMultisite;
            },
            function (error) {
                console.log('BonusTemplateAddDialogController error getting sites', error);
            }
        );

        //FIXME horrible workaround to find the element wait for html rendering (the event contentLoaded seems works only for pages, for dialog?)
        $timeout(function () {
            // The md-select directive eats keydown events for some quick select logic.
            // Since we have a search input here, we don't need that logic.
            $element.find('#template-constraint-site-search').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }, 1000);

        // NOTE do not show offline credit feature for Movo at the moment
        (function handleServiceSpecificBehaviour() {
            const serviceName = AppSettings.getServiceName();
            vm.showPurchase = serviceName && serviceName.indexOf('movo') == -1;
        })();

        function setBonusTemplate(t) {
            vm.bonusTemplate = t;
        }

        function onSiteChange(site) {
            if (site.id === DefaultSite.id) {
                vm.template.constraints.siteIds.splice(0).push(DefaultSite.id);
            } else {
                if (vm.template.constraints.siteIds.indexOf(DefaultSite.id) !== -1) {
                    vm.template.constraints.siteIds.splice(vm.template.constraints.siteIds.indexOf(DefaultSite.id), 1);
                }
            }
        }

        function goToCouponTemplateDetailPage(template) {
            closeDialog();
            // NOTE wait for a smooth page transition
            $timeout(function () {
                $state.go(CouponTemplateDetailPage, {
                    templateId: template.id,
                    template: template,
                    action: 'createCoupon',
                });
            }, 500);
        }

        function goToBonusTemplatesPage() {
            closeDialog();
            // NOTE wait for a smooth page transition
            $timeout(function () {
                $state.go(BonusTemplatesListPage, { action: 'createTemplate', nextAction: 'createCouponTemplate' });
            }, 500);
        }

        function callAddTemplate() {
            if (!vm.bonusTemplate || vm.bonusTemplate.id === undefined) {
                console.warn('callAddTemplate: invalid input', vm.bonusTemplate);
                ErrorUtility.showErrorMessage({
                    title: 'Add Campaign',
                    description: 'The selected Bonus Template is invalid!',
                });
                return;
            }

            vm.dataToSend = {
                name: vm.template.name,
                purchased: vm.template.purchased,
                onlyNewUser: vm.template.onlyNewUser,
                BonusTemplateId: vm.bonusTemplate.id,
                constraints: {},
            };

            if (vm.template.constraints && Object.keys(vm.template.constraints).length > 0) {
                const constraints = vm.template.constraints;

                if (
                    !vm.template.noRedeemLimit &&
                    constraints.useLimit !== undefined &&
                    !Number.isNaN(constraints.useLimit)
                ) {
                    vm.dataToSend.constraints.useLimit = constraints.useLimit;
                }

                vm.dataToSend.constraints.validityTime = [
                    { type: vm.validityTimeType.UNBOUNDED.value },
                    { type: vm.validityTimeType.UNBOUNDED.value },
                ];

                if (constraints.validityTime && Object.keys(constraints.validityTime).length > 0) {
                    const start = constraints.validityTime[0];
                    const end = constraints.validityTime[1];
                    if (start.type == vm.validityTimeType.TIMESTAMP.value) {
                        // FIXME in case of default template the default timezone it is not sufficient for all sites! Check currency code? It should be chosen by the admin?
                        vm.dataToSend.constraints.validityTime[0] = {
                            type: vm.validityTimeType.TIMESTAMP.value,
                            timestamp: MiscUtility.shiftJstoMoment(start.date, vm.selectedSiteId)
                                .startOf('day')
                                .valueOf(),
                        };
                    }
                    if (end.type == vm.validityTimeType.TIMESTAMP.value) {
                        vm.dataToSend.constraints.validityTime[1] = {
                            type: vm.validityTimeType.TIMESTAMP.value,
                            timestamp: MiscUtility.shiftJstoMoment(end.date, vm.selectedSiteId).endOf('day').valueOf(),
                        };
                    }
                }
                if (
                    constraints.siteIds &&
                    Array.isArray(constraints.siteIds) &&
                    constraints.siteIds.indexOf(DefaultSite.id) == -1
                ) {
                    vm.dataToSend.constraints.siteIds = constraints.siteIds;
                }
            }

            if (typeof vm.template.SiteId !== 'undefined' && vm.template.SiteId !== DefaultSite.id) {
                vm.dataToSend.SiteId = vm.template.SiteId;
            }

            console.log('dataToSend', vm.dataToSend);

            CouponBonusAdapter.addTemplate(vm.dataToSend, function (newTemplate, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Add Campaign',
                        description: 'Error while adding the Campaign!',
                    });
                } else {
                    SweetAlert.swal('Add Campaign', 'The Campaign was successfully added!', 'success');

                    if (vm.createCouponSelected) {
                        goToCouponTemplateDetailPage(newTemplate);
                    } else {
                        closeDialog(true);
                    }
                }
            });
        }

        function closeDialog(value) {
            $mdDialog.hide(value);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.coupon.template.detail')
        .controller('CouponTemplateDetailController', CouponTemplateDetailController)
        .factory('CouponBonusDialogFactory', CouponBonusDialogFactory);

    /** @ngInject */
    function CouponTemplateDetailController(
        $scope,
        $timeout,
        $stateParams,
        $state,
        Template,
        toDateFilter,
        toNumberFilter,
        OrderRequestParamFactory,
        MiscUtility,
        ErrorUtility,
        ServiceSettings,
        SitesService,
        DefaultSite,
        CouponBonusAdapter,
        FiltersRequestParamFactory,
        CouponBonusDialogFactory,
        CouponBonusUtility,
        CouponTemplatesListPage,
        ToHireDefaultColor,
        AppConfigurations
    ) {
        var vm = this;

        // Data
        vm.coupons = [];
        vm.template = Template;
        vm.exhaustedCoupons = null;
        vm.toHireDefaultColor = ToHireDefaultColor;
        vm.isAddCodeEnabled = AppConfigurations.isActionEnabled('couponBonusTemplate.detail.addCode');

        vm.filters = {};

        vm.searchFilters = {
            // type: FiltersFactory.createBonusTemplateWithTypeFilter(),
            // hidden: FiltersFactory.createBonusTemplateWithHiddenFilter(),
            // disabled: FiltersFactory.createBonusTemplateWithDisabledFilter(),
        };

        $scope.$on('refreshServiceSettings', function (event) {
            init();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    SitesService.getSites(function () {
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        var timezone = settings && settings[vm.selectedSiteId] && settings[vm.selectedSiteId].timezone;

                        // vm.timezone = timezone;
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);

                        vm.tableFields = {
                            id: {
                                name: 'Coupon Id',
                                orderBy: OrderRequestParamFactory.orderById,
                                defaultSort: true,
                                class: 'vehicleRowCellSmall',
                                key: 'id',
                            },
                            name: {
                                name: 'Code',
                                class: 'vehicleRowCellMedium alignLeft',
                                ellipsis: true,
                                key: 'code',
                            },
                            // properties: { name: "properties", class: "vehicleRowCellVeryBig alignLeft", ellipsis: true, key: 'properties', type: 'render', render: function (v, o) { return JSON.stringify(o.properties) },
                            fromDate: {
                                name: 'From',
                                class: 'vehicleRowCellMedium alignLeft',
                                key: 'fromDate',
                                type: 'render',
                                render: function (v, o) {
                                    return o.BonusCouponTemplate
                                        ? CouponBonusUtility.getFromDate(o.BonusCouponTemplate)
                                        : '';
                                },
                            },
                            toDate: {
                                name: 'To',
                                class: 'vehicleRowCellMedium alignLeft',
                                key: 'toDate',
                                type: 'render',
                                render: function (v, o) {
                                    return o.BonusCouponTemplate
                                        ? CouponBonusUtility.getToDate(o.BonusCouponTemplate)
                                        : '';
                                },
                            },
                            exhausted: {
                                name: 'Exhausted',
                                class: 'vehicleRowCellSmall',
                                key: 'exhausted',
                                type: 'render',
                                render: function (v, o) {
                                    return o.exhausted ? 'Yes' : 'No';
                                },
                            },
                            deactivated: {
                                name: 'Deactivation date',
                                class: 'vehicleRowCellMedium',
                                key: 'deactivated',
                                type: 'render',
                                render: function (v, o) {
                                    return o.deactivatedAt !== 0
                                        ? toDateFilter(o.deactivatedAt, 'dateTime', o.SiteId || DefaultSite.id)
                                        : 'Not deactivated';
                                },
                            },
                            creationDate: {
                                name: 'Creation date',
                                class: 'vehicleRowCellMedium',
                                type: 'render',
                                render: function (v, o) {
                                    return toDateFilter(o.created_at, 'dateTime', o.SiteId || DefaultSite.id);
                                },
                            },
                            modificationDate: {
                                name: 'Modification date',
                                class: 'vehicleRowCellMedium',
                                type: 'render',
                                render: function (v, o) {
                                    return toDateFilter(o.updated_at, 'dateTime', o.SiteId || DefaultSite.id);
                                },
                            },
                            site: {
                                name: 'Site',
                                class: 'vehicleRowCell preventLastChildShrink',
                                type: 'render',
                                render: function (v, o) {
                                    return o.SiteId !== undefined && o.SiteId !== null
                                        ? SitesService.getSiteName(o.SiteId)
                                        : 'No site';
                                },
                            },
                            // details: {
                            //     name: "Details", class: "", key: 'details', type: 'icon-link', icon: {
                            //         goto: "",
                            //         gotoParams: "userId",
                            //         icon: "icon-information-outline",
                            //         key: "id",
                            //     }
                            // }
                        };
                    });
                    $scope.$applyAsync();
                }
            });
        }
        init();

        getExhaustedCoupons();

        // NOTE open addTemplateDialog if user is redirect to do so
        if ($stateParams.action == 'createCoupon') {
            // NOTE wait for a smooth page transition
            $timeout(function () {
                openAddCouponDialog(null, vm.template);
            }, 500);
        }

        $scope.$on('siteChanged', function (site) {
            SitesService.getSites(function () {
                vm.selectedSiteId = SitesService.getSelectedSite();
            });
            vm.applyFiltersTrigger();
        });

        vm.refreshCoupons = refreshCoupons;
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger;
        vm.openAddTemplateDialog = openAddCouponDialog;
        vm.goToCouponTemplatesPage = goToCouponTemplatesPage;
        vm.getFromDate = CouponBonusUtility.getFromDate;
        vm.getToDate = CouponBonusUtility.getToDate;
        vm.getConstraintDescription = getConstraintDescription;
        vm.getBonusValue = getBonusValue;

        function getConstraintDescription(template) {
            if (!template || !template.constraints) {
                return '';
            }
            var parts = [];
            // NOTE show onlyNewUser attribute as a constraint
            if (template.onlyNewUser) {
                parts.push('Only new user');
            }

            if (template.constraints.useLimit != undefined) {
                parts.push(template.constraints.useLimit + ' time/s');
            }

            if (template.constraints.siteIds && Array.isArray(template.constraints.siteIds)) {
                parts.push(
                    'Valid for ' +
                        template.constraints.siteIds
                            .map(function (siteId) {
                                return SitesService.getSiteName(siteId);
                            })
                            .join(',')
                );
            } else {
                parts.push('Valid for All sites');
            }

            return parts.length > 0 ? parts.join(', ') : '';
        }

        function refreshCoupons(paginationRequestParam, callback, updateInterface) {
            console.log(paginationRequestParam);
            if (updateInterface === undefined) {
                updateInterface = true;
            }
            // NOTE example paginationRequestParam:  {limit: number, offset: number, filters: obj, order: [string, string][]}
            var filterParams = FiltersRequestParamFactory.createAnAndFilter([
                // FiltersRequestParamFactory.createBonusTemplateWithHiddenFilter(false),
                // FiltersRequestParamFactory.createBonusTemplateWithDisabledFilter(false),
            ]);
            if (!paginationRequestParam.filters || Object.keys(paginationRequestParam.filters).length == 0) {
                paginationRequestParam.filters = filterParams;
            }

            // var params = FiltersRequestParamFactory.mergeObjects(
            //     filterParam,
            //     paginationFilterRequestParam
            // );

            CouponBonusAdapter.getTemplateCoupons(vm.template.id, paginationRequestParam, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Coupon List',
                        description: 'Error getting the coupon list!',
                    });

                    if (callback !== undefined) {
                        callback(data, error);
                    }
                } else {
                    if (updateInterface) {
                        var coupons = typeof data.data !== 'undefined' ? data.data : data;
                        if (coupons) {
                            vm.coupons = coupons;
                        }
                    }
                    if (callback !== undefined) {
                        callback(data, error);
                    }
                }
            });
        }
        // NOTE this fn get the exhausted coupons filtering the coupons endpoint
        function getExhaustedCoupons() {
            var filterParams = FiltersRequestParamFactory.createAnAndFilter([{ _self: { exhausted: true } }]);
            // TODO use utility fn to create the request param instead to declare it inline
            // NOTE fetch exhausted coupons filtering the coupon code list
            refreshCoupons({ limit: 0, offset: 0, filters: filterParams }, function (data, error) {
                if (error) {
                    console.log('error while getExhaustedCoupons');
                } else {
                    vm.exhaustedCoupons = data.count;
                }
            });
        }

        // TODO refactor in a bonus coupon utility
        function getBonusValue(template) {
            if (!template || !template.BonusTemplate || !template.BonusTemplate.limits) {
                return null;
            }

            const limits = template.BonusTemplate.limits;
            var value = 0;
            var limitDescr = '';
            if (limits.forValidity && Object.keys(limits.forValidity).length > 0) {
                if (
                    limits.forValidity.price &&
                    limits.forValidity.price.value &&
                    !isNaN(limits.forValidity.price.value / 100)
                ) {
                    // TODO handle currency!
                    value = toNumberFilter(limits.forValidity.price.value / 100, 2) + '€';
                }
                if (limits.forValidity.count) {
                    limitDescr = 'Up to ' + limits.forValidity.count + ' trips';
                }
            }
            return { value: value, description: limitDescr };
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger() {
            vm.applyFiltersTrigger();
        }

        function openAddCouponDialog(ev, template) {
            CouponBonusDialogFactory.create(ev, template).then(function ok(refresh) {
                if (refresh) {
                    vm.applyFiltersTrigger();
                }
            });
        }

        function goToCouponTemplatesPage() {
            $state.go(CouponTemplatesListPage);
        }
    }

    /** @ngInject */
    function CouponBonusDialogFactory($mdDialog, $document) {
        return {
            create: function (ev, template) {
                return $mdDialog.show({
                    controller: 'CouponBonusAddDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/coupon/template/details/dialogs/coupon-bonus-add-dialog.html',
                    parent: angular.element('body'), //$document.find('#content-container')),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        Template: template,
                    },
                });
            },
        };
    }
})();

/**
 * Created by andrea on 25/01/17.
 */

(function ()
{
    'use strict';

    angular
        .module('app.catalog.station', [

        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.catalog.station',{
                url  : '/station',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalog/station/station-list.html',
                        controller : 'StationListController as vm'
                    }
                },
                resolve:{
                    Stations: function (AppRequirements,RentStationAdapter) {

                        return RentStationAdapter.getStations();
                    }
                }
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalog/station');

        msNavigationServiceProvider.saveItem('catalog.station', {
            title: 'Stations',
            icon : 'icon-store',
            state: 'app.catalog.station',
            weight: 10
        });



    }
})();
/**
 * Created by andrea on 25/01/17.
 */
(function ()
{
    'use strict'
    angular
        .module('app.catalog.station')
        .controller('StationDialogController', StationDialogController)

    /** @ngInject */
    function StationDialogController($mdDialog, Station, Stations, RentStationAdapter,RentStationService)
    {
        var vm = this
        // Data
        vm.station = angular.copy(Station)
        vm.stations = Stations

        if ( !vm.station ){
            vm.station = {}
            vm.dialogType = "add"
        }else{
            vm.dialogType = "edit"
        }
        // Methods
        vm.addStation = addStation
        vm.updateStation = updateStation
        vm.deleteStationConfirm = deleteStationConfirm
        vm.closeDialog = closeDialog
        //////////
        /**
         * Add new contact
         */
        function addStation() {

            var dataToBeSent = {

                "name": vm.station.name,
                "latitude": "0",
                "longitude": "0",
                "address": vm.station.address

            }

            RentStationAdapter.addStation(dataToBeSent, function (station,error) {
                if(error){
                    console.log("Couldn't add station",error)
                }else{
                    vm.stations.push(station)
                    RentStationService.refresh()
                    closeDialog()
                }
            })


        }
        /**
         * Save contact
         */
        function updateStation() {

            var dataToBeSent = {

                "name": vm.station.name,
                "address": vm.station.address,
                "latitude": "0",
                "longitude": "0"

            }

            RentStationAdapter.editStation(vm.station.id,dataToBeSent,function (station,error) {
                if(error){
                    console.log("Couldn't edit station", error)
                }else{

                    RentStationService.refresh()
                    closeDialog(true)

                }
            })

        }
        /**
         * Delete Contact Confirm Dialog
         */
        function deleteStationConfirm(ev) {

            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete the station?')
                .htmlContent('<b>' + vm.station.name + ', ' + vm.station.address + '</b>' + ' will be deleted.')
                .ariaLabel('delete station')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL')

            $mdDialog.show(confirm).then(function () {
                RentStationAdapter.deleteStation(vm.station.id, function (data, error){
                    if (!error){

                        RentStationService.refresh()
                        vm.stations.splice(vm.stations.indexOf(Station), 1)

                    }else{
                        console.log("Couldn't delete station", error)
                    }
                })
            })
        }
        /**
         * Close dialog
         */
        function closeDialog(shouldRefresh) {
            $mdDialog.hide(shouldRefresh)
        }
    }
})();
/**
 * Created by andrea on 25/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.catalog.fare', [

        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.catalog.fare',{
                url  : '/fare',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalog/fare/fare-list.html',
                        controller : 'FareListController as vm'
                    }
                },
                resolve:{
                    Fares: function (AppRequirements,RateAdapter) {

                        return RateAdapter.getRates();
                    }
                }
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalog/fare');

        msNavigationServiceProvider.saveItem('catalog.fare', {
            title: 'Fares',
            icon : 'icon-timetable',
            state: 'app.catalog.fare',
            weight: 10
        });



    }
})();
/**
 * Created by andrea on 25/01/17.
 */
(function ()
{
    'use strict'
    angular
        .module('app.catalog.fare')
        .controller('FareDialogController', FareDialogController)

    /** @ngInject */
    function FareDialogController($mdDialog, Fare, Fares, RateAdapter,RateService,CategoryService,ErrorUtility)
    {
        var vm = this;

        // Data
        vm.fare = angular.copy(Fare);
        vm.fares = Fares;

        if ( !vm.fare ){
            vm.fare = {}
            vm.dialogType = "add"
        }else{
            vm.dialogType = "edit"
        }

        vm.fareTypes = {
            DAILY   : {name:"Daily",value:0},
            HOURLY  : {name:"Hourly",value:1}
            /*PERIODIC:{name:"Periodic",value:2}*/
        };

        CategoryService.getCategories().then(
            function success(categories) {

                vm.allCategories = categories;
                console.log("allCategories",vm.allCategories)

            },function error(error) {

            }
        );


        // Methods
        vm.addFare = addFare
        vm.updateFare = updateFare
        vm.deleteFareConfirm = deleteFareConfirm
        vm.changeRange = changeRange;
        vm.print = print;

        vm.closeDialog = closeDialog
        //////////
        /**
         * Add new contact
         */
        function addFare() {

            RateAdapter.addRate(vm.fare, function (fare,error) {
                if(error){
                    ErrorUtility.showErrorMessage({title:'Add Fare',description:'Error while adding the new fare!'})
                }else{
                    vm.fares.push(fare)
                    RateService.refresh()
                    closeDialog()
                }
            })


        }
        /**
         * Save contact
         */
        function updateFare() {

            var dataToBeSent = {

                "name": vm.fare.name,
                "price": vm.fare.price,
                "type": 0,
                "start": vm.fare.start,
                "end": vm.fare.end

            }

            RateAdapter.editRate(vm.fare.id,vm.fare,function (fare,error) {
                if(error){
                    ErrorUtility.showErrorMessage({title:'Edit Fare',description:'Error while editing the fare!'})
                }else{
                    RateService.refresh()
                    closeDialog(true)

                }
            })

        }
        /**
         * Delete Contact Confirm Dialog
         */
        function deleteFareConfirm(ev) {

            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete the fare?')
                .htmlContent('<b>' + vm.fare.name  + '</b>' + ' will be deleted.')
                .ariaLabel('delete fare')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL')

            $mdDialog.show(confirm).then(function () {
                RateAdapter.deleteRate(vm.fare.id, function (data, error){
                    if (error){
                        ErrorUtility.showErrorMessage({title:'Delete Fare',description:'Error while deleting the fare!'})
                    }else{
                        vm.fares.splice(vm.fares.indexOf(Fare), 1)
                        RateService.refresh()
                    }
                })
            })
        }


        function changeRange(dailyFareNumberOfDays,dailyFareDays) {

            console.log("changeRange",dailyFareNumberOfDays)


            if(!dailyFareNumberOfDays)
                return


            if(dailyFareNumberOfDays === dailyFareDays.length)
                return

            var newDimension = 0;

            if(dailyFareNumberOfDays > dailyFareDays.length){

                newDimension = dailyFareNumberOfDays - dailyFareDays.length;

                for(var i=0; i<newDimension; i++){

                    dailyFareDays.push({price:null,extraDayPrice:null});
                }

            }else {

                newDimension = dailyFareDays.length - dailyFareNumberOfDays;
                var startIndex = dailyFareDays.length - newDimension;

                //update fare for that categories
                dailyFareDays.splice(startIndex,newDimension);
            }

        }

        function print(text) {
            console.log(text);
        }

        /**
         * Close dialog
         */
        function closeDialog(shouldRefresh) {
            $mdDialog.hide(shouldRefresh)
        }

    }
})();
/**
 * Created by andrea on 24/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.catalog.category', [

        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.catalog.category',{
                url  : '/category',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/catalog/category/category-list.html',
                        controller : 'CategoryListController as vm'
                    }
                },
                resolve:{
                    Categories: function (AppRequirements,CategoryAdapter) {

                        return CategoryAdapter.getCategories();
                    }
                }
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalog/category');

        msNavigationServiceProvider.saveItem('catalog.category', {
            title: 'Categories',
            icon : 'icon-car',
            state: 'app.catalog.category',
            weight: 10
        });



    }
})();
/**
 * Created by andrea on 25/01/17.
 */

(function ()
{
    'use strict'
    angular
        .module('app.catalog.category')
        .controller('CategoryDialogController', CategoryDialogController)

    /** @ngInject */
    function CategoryDialogController($mdDialog, Category, Categories, CategoryAdapter,CategoryTypes,CategoryService)
    {
        var vm = this
        // Data
        vm.category = angular.copy(Category)
        vm.categories = Categories
        vm.categoryTypes = CategoryTypes

        if ( !vm.category ){
            vm.category = {}
            vm.dialogType = "add"
        }else{
            vm.dialogType = "edit"
        }
        // Methods
        vm.addCategory = addCategory
        vm.updateCategory = updateCategory
        vm.deleteCategoryConfirm = deleteCategoryConfirm
        vm.closeDialog = closeDialog
        //////////
        /**
         * Add new contact
         */
        function addCategory() {

            var dataToBeSent = {

                "name": vm.category.name,
                "description": vm.category.description,
                "type": vm.category.type,
                "km": vm.category.km

            }

            CategoryAdapter.addCategory(dataToBeSent, function (category,error) {
                if(error){
                    console.log("Couldn't add category",error)
                }else{
                    vm.categories.push(category)
                    CategoryService.refresh()
                    closeDialog()
                }
            })


        }
        /**
         * Save contact
         */
        function updateCategory() {

            var dataToBeSent = {

                "name": vm.category.name,
                "description": vm.category.description,
                "type": vm.category.type,
                "km": vm.category.km

            }

            CategoryAdapter.editCategory(vm.category.id,dataToBeSent,function (category,error) {
                if(error){
                    console.log("Couldn't edit category", error)
                }else{

                    Category.name = category.name
                    Category.description = category.description
                    Category.type = category.type
                    Category.km = category.km
                    CategoryService.refresh()
                    closeDialog()

                }
            })

        }
        /**
         * Delete Contact Confirm Dialog
         */
        function deleteCategoryConfirm(ev) {

            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete the category?')
                .htmlContent('<b>' + vm.category.name + ', ' + vm.category.description + '</b>' + ' will be deleted.')
                .ariaLabel('delete category')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL')

            $mdDialog.show(confirm).then(function () {
                CategoryAdapter.deleteCategory(vm.category.id, function (data, error){
                    if (!error){

                        vm.categories.splice(vm.categories.indexOf(Category), 1)
                        CategoryService.refresh();

                    }else{
                        console.log("Couldn't delete category", error)
                    }
                })
            })
        }
        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide()
        }
    }
})();
(function () {
    ('use strict');

    angular // this is for formatting
        .module('app.bonus.template', [])
        .config(config)
        .run(run)
        .value('BonusTemplatesListPage', 'app.bonus.template');

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.bonus.template', {
            url: 'https://dashboard-v2.2hire.io/bonus/templates',
            external: true,
        });

        // Navigation
        msNavigationServiceProvider.saveItem('bonus.template', {
            title: 'Templates',
            icon: 'icon-receipt',
            state: 'app.bonus.template',
            weight: 1,
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled('bonus.template');

        if (!active) {
            msNavigationService.deleteItem('bonus.template');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.bonus.template')
        .controller('BonusTemplateAddDialogController', BonusTemplateAddDialogController)

    /** @ngInject */
    function BonusTemplateAddDialogController(
        $state,
        ShopItemsListPage,
        $element,
        $timeout,
        nextAction,
        SweetAlert,
        $mdDialog,
        BonusAdapter,
        BonusTemplateType,
        BonusTemplateValidityTimeType,
        SitesService,
        DefaultSite,
        ServiceSettings,
        MiscUtility,
        FiltersRequestParamFactory,
        ErrorUtility,
        CouponTemplatesListPage
    ){
        var vm = this;

        vm.bonusTemplateType = BonusTemplateType
        vm.validityTimeType = BonusTemplateValidityTimeType
        vm.template = {
            type: "",
            description: "",
            hidden: false,
            disabled: false,
            limits: {},
            constraints: {
                // set currency
                validityTime: [{},{}],
                siteIds: [ DefaultSite.id ]
            },
            SiteId: DefaultSite.id
        }
        vm.shopItem = {}

        vm.preventSiteChange = false
        vm.showCreateCouponTemplate = false;
        vm.searchSiteText = ""
        vm.sites = []

        if(nextAction === 'createCouponTemplate'){
            vm.showCreateCouponTemplate = true;
        }

        vm.searchOptions = [
            { 
                name:'ID',
                key: 'id',
                getItemText: function (template) { return "ID: "+template.id+", Type: "+template.type+", Descr: "+template.description},
                filter: FiltersRequestParamFactory.createIdFilter,
                filterType: 'number',
                adapter: BonusAdapter.getTemplates
            }
        ];
        
        ServiceSettings.getServiceSettings(function(settings) {
            if(settings.loaded){
                SitesService.getSites(function(){
                    vm.selectedSiteId = SitesService.getSelectedSite()
                    
                    // NOTE we do not prevent admin site restricted to create only one site valid bonus at the moment, we'll decide
                    // vm.template.constraints.siteIds = [vm.selectedSiteId]

                    // NOTE prevent site ownership if no in All cities view
                    vm.preventSiteChange = vm.selectedSiteId !== DefaultSite.id
                    vm.template.SiteId = vm.selectedSiteId
                    
                    var timezone = settings && settings[vm.selectedSiteId] && settings[vm.selectedSiteId].timezone;
                    vm.timezone = timezone;
                    vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                })
            }
        });

        vm.closeDialog = closeDialog
        vm.onSiteChange = onSiteChange
        vm.setTemplate = setTemplate
        vm.callAddTemplate = callAddTemplate
        vm.goToShopItemsListPage = goToShopItemsListPage

        SitesService.getSites(function (sites) {
            vm.sites = sites
            vm.isServiceMultisite = SitesService.isServiceMultisite
        }, function (error) {
            console.log("BonusTemplateAddDialogController error getting sites",error)
        })

        //FIXME horrible workaround to find the element wait for html rendering (the event contentLoaded seems works only for pages, for dialog?)
        $timeout(function(){
            // The md-select directive eats keydown events for some quick select logic. 
            // Since we have a search input here, we don't need that logic.
            $element.find('#template-constraint-site-search').on('keydown', function (ev) {
                ev.stopPropagation();
            });
        }, 1000)

        function setTemplate (t) {
            console.log("set template",t)
            vm.template = t
        }

        function onSiteChange(site) {
            console.log("site change",site)
            console.log("start",vm.template.constraints.siteIds)
            if (site.id === DefaultSite.id) {
                vm.template.constraints.siteIds.splice(0).push(DefaultSite.id)
            } else {
                if(vm.template.constraints.siteIds.indexOf(DefaultSite.id) !== -1){
                    vm.template.constraints.siteIds.splice(vm.template.constraints.siteIds.indexOf(DefaultSite.id), 1)
                }
            }
            console.log("end",vm.template.constraints.siteIds)
        }

        function goToShopItemsListPage(template) {
            closeDialog()
            // NOTE wait for a smooth page transition
            $timeout(function(){
                $state.go(ShopItemsListPage, {action: "createShopItem", template: template})
            }, 500)
        }

        function goToCouponTemplatesListPage(template) {
            closeDialog();
            // NOTE wait for a smooth page transition
            $timeout(function () {
                $state.go(CouponTemplatesListPage, { action: 'createCouponTemplate', bonusTemplate: template });
            }, 500);
        }

        function priceInCents(price) {
            if (typeof price !== "number") {
                console.warn("priceInCents: not a number price", price)
                return 0
            }
            return Math.round(price * 100);
        }

        function callAddTemplate() {

            console.log("template to send", vm.template);

            vm.dataToSend = {
                type: vm.template.type,
                description: vm.template.description,
                hidden: vm.template.hidden,
                disabled: vm.template.disabled,
                limits: {},
                constraints: {},
                properties: {},
            }

            // FIXME handle currency
            vm.dataToSend.constraints.currency = "EUR"

            if (vm.template.limits && Object.keys(vm.template.limits).length > 0) {
                const limits = vm.template.limits

                if (limits.forValidity && Object.keys(limits.forValidity).length > 0) {
                    const forValidity = {}
                    if (typeof limits.forValidity.price === "number") {
                        forValidity.price = { currency: vm.dataToSend.constraints.currency, value: priceInCents(limits.forValidity.price)}
                    }
                    if (typeof limits.forValidity.count === "number") {
                        forValidity.count = limits.forValidity.count
                    }
                    if (Object.keys(forValidity).length > 0) {
                        vm.dataToSend.limits.forValidity = forValidity
                    }
                }

                if (limits.perBooking && Object.keys(limits.perBooking).length > 0) {
                    if (typeof limits.perBooking.price === "number") {
                        vm.dataToSend.limits.perBooking = { price: { currency: vm.dataToSend.constraints.currency, value: priceInCents(limits.perBooking.price)} }
                    }
                }

                if (limits.perTimeWindow && Object.keys(limits.perTimeWindow).length > 0) {
                    const perTimeWindow = {}
                    if (limits.perTimeWindow.window && Object.keys(limits.perTimeWindow.window).length > 0) {
                        const window = {}
                        if (typeof limits.perTimeWindow.window.duration === "number") {
                            window.duration = parseInt(limits.perTimeWindow.window.duration) * 60 * 1000
                            window.offset = 3600 * 1000
                            window.type = "TUMBLING_WINDOW"
                        }
                        if (Object.keys(window).length > 0) {
                            perTimeWindow.window = window
                        }
                    }
                    if (limits.perTimeWindow.limits && Object.keys(limits.perTimeWindow.limits).length > 0) {
                        const perTimeWindowLimits = {}
                        if (typeof limits.perTimeWindow.limits.price === "number") {
                            perTimeWindowLimits.price = { currency: vm.dataToSend.constraints.currency, value: priceInCents(limits.perTimeWindow.limits.price) }
                        }
                        if (typeof limits.perTimeWindow.limits.count === "number") {
                            perTimeWindowLimits.count = limits.perTimeWindow.limits.count
                        }
                        if (Object.keys(limits).length > 0) {
                            perTimeWindow.limits = perTimeWindowLimits
                        }
                    }
                    if (Object.keys(perTimeWindow).length > 0) {
                        vm.dataToSend.limits.perTimeWindow = [perTimeWindow]
                    }
                }
            }

            if (vm.template.constraints && Object.keys(vm.template.constraints).length > 0) {
                const constraints = vm.template.constraints
                vm.dataToSend.constraints.validityTime = [{ type: vm.validityTimeType.UNBOUNDED.value }, { type: vm.validityTimeType.UNBOUNDED.value }]

                if (constraints.validityTime && Object.keys(constraints.validityTime).length > 0) {
                    const start = constraints.validityTime[0]
                    const end = constraints.validityTime[1]
                    if (start.type == vm.validityTimeType.TIMESTAMP.value) {
                        // FIXME in case of default template the default timezone it is not sufficient for all sites! Check currency code? It should be chosen by the admin?
                        vm.dataToSend.constraints.validityTime[0] = { type: vm.validityTimeType.TIMESTAMP.value, timestamp: MiscUtility.shiftJstoMoment(start.date, vm.selectedSiteId).startOf('day').valueOf() }
                    }
                    if (end.type == vm.validityTimeType.TIMESTAMP.value) {
                        vm.dataToSend.constraints.validityTime[1] = { type: vm.validityTimeType.TIMESTAMP.value, timestamp: MiscUtility.shiftJstoMoment(end.date, vm.selectedSiteId).endOf('day').valueOf() }
                    }
                    if (start.type == vm.validityTimeType.DURATION_FROM_ACQUISITION.value) {
                        vm.dataToSend.constraints.validityTime[0] = { type: vm.validityTimeType.DURATION_FROM_ACQUISITION.value, duration: parseInt(start.duration) * 60 * 1000 }
                    }
                    if (end.type == vm.validityTimeType.DURATION_FROM_ACQUISITION.value) {
                        vm.dataToSend.constraints.validityTime[1] = { type: vm.validityTimeType.DURATION_FROM_ACQUISITION.value, duration: parseInt(end.duration) * 60 * 1000 }
                    }
                }
                if (constraints.siteIds && Array.isArray(constraints.siteIds) && constraints.siteIds.indexOf(DefaultSite.id) == -1) {
                    vm.dataToSend.constraints.siteIds = constraints.siteIds
                }
            }

            if (typeof vm.template.SiteId !== "undefined" && vm.template.SiteId !== DefaultSite.id) {
                vm.dataToSend.SiteId = vm.template.SiteId
            }

            console.log("dataToSend",vm.dataToSend)

            BonusAdapter.addTemplate(vm.dataToSend,
                function (newTemplate, error) {

                    if (error) {
                        ErrorUtility.showErrorMessage({ title: "Add Template", description: "Error while adding the Template!" })
                    } else {
                        SweetAlert.swal("Add Template", "The Template was successfully added!", "success")

                        if (vm.createShopItemSelected) {
                            goToShopItemsListPage(newTemplate);
                        } else if (vm.createCouponTemplateSelected) {
                            goToCouponTemplatesListPage(newTemplate);
                        } else {
                            closeDialog(true);
                        }
                    }
                }
            )
        }

        function closeDialog(value) {
            $mdDialog.hide(value)
        }
    }
})();

(function () {
    ('use strict');

    angular // this is for formatting
        .module('app.bonus.shopItem', [])
        .config(config)
        .run(run)
        .value('ShopItemsListPage', 'app.bonus.shopItem');

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.bonus.shopItem', {
            url: 'https://dashboard-v2.2hire.io/bonus/shop/items',
            external: true,
        });

        // Navigation
        msNavigationServiceProvider.saveItem('bonus.shopItem', {
            title: 'Store',
            icon: 'icon-store',
            state: 'app.bonus.shopItem',
            weight: 1,
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled('bonus.shopItem');

        if (!active) {
            msNavigationService.deleteItem('bonus.shopItem');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.bonus.shopItem')
        .controller('ShopItemAddDialogController', ShopItemAddDialogController)

    /** @ngInject */
    function ShopItemAddDialogController(
        $state,
        $timeout,
        BonusTemplatesListPage,
        Template,
        SweetAlert,
        $mdDialog,
        BonusAdapter,
        BonusTemplateType,
        BonusTemplateValidityTimeType,
        SitesService,
        DefaultSite,
        ServiceSettings,
        MiscUtility,
        FiltersRequestParamFactory,
        ErrorUtility
    ){
        var vm = this;

        vm.bonusTemplateType = BonusTemplateType
        vm.validityTimeType = BonusTemplateValidityTimeType
        vm.template = null
        vm.shopItem = {}
        initShopItem()

        vm.preventSiteChange = false
        vm.searchSiteText = ""
        vm.sites = []

        vm.searchOptions = [
            { 
                name:'ID',
                key: 'id',
                getItemText: function (template) { return "ID: "+template.id+", Type: "+template.type+", Descr: "+template.description+",Site ownership: "+SitesService.getSiteName(template.SiteId)},
                filter: FiltersRequestParamFactory.createIdFilter,
                filterType: 'number',
                adapter: BonusAdapter.getTemplates
            }
        ];
        
        ServiceSettings.getServiceSettings(function(settings) {
            if(settings.loaded){
                SitesService.getSites(function(){
                    vm.selectedSiteId = SitesService.getSelectedSite()
                    
                    // NOTE we prevent admin site restricted to create only restriction site bonus
                    // vm.preventSiteChange = 
                    
                    var timezone = settings && settings[vm.selectedSiteId] && settings[vm.selectedSiteId].timezone;
                    vm.timezone = timezone;
                    vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                })
            }
        });

        SitesService.getSites(function (sites) {
            vm.sites = sites
            vm.isServiceMultisite = SitesService.isServiceMultisite
        }, function (error) {
            console.log("ShopItemAddDialogController error getting sites",error)
        })
        
        if(Template){
            setTemplate(Template)
        }

        vm.closeDialog = closeDialog
        vm.goToTemplatesPage = goToTemplatesPage
        vm.setTemplate = setTemplate
        vm.callAddShopItem = callAddShopItem

        function initShopItem() {
            vm.shopItem = {
                userVisible: true
            }
        }

        function goToTemplatesPage() {
            closeDialog()
            // NOTE wait for a smooth page transition
            $timeout(function(){
                $state.go(BonusTemplatesListPage, { action: 'createTemplate' });
            }, 500)
        }

        function setTemplate (t) {
            console.log("set template",t)
            vm.template = t
            initShopItem()

            if(typeof vm.template.SiteId === "number"){
                if(vm.template.SiteId !== DefaultSite.id){
                    vm.shopItem.SiteId = vm.template.SiteId
                    vm.preventSiteChange = true
                } else {
                    vm.preventSiteChange = false
                } 
            } else {
                vm.preventSiteChange = false
            }
        }

        function priceInCents(price) {
            if (typeof price !== "number") {
                console.warn("priceInCents: not a number price", price)
                return 0
            }
            return Math.round(price * 100);
        }

        function callAddShopItem(){
            console.log("add shop item", vm.template, vm.shopItem)
            if (vm.template == null || typeof vm.shopItem.price !== "number" || vm.shopItem.SiteId === undefined) {
                return
            }

            // FIXME support currency
            vm.dataToSend = {
                userVisible: vm.shopItem.userVisible,
                BonusTemplateId: vm.template.id,
                price: { currency: "EUR", value: priceInCents(vm.shopItem.price)},
                SiteId: vm.shopItem.SiteId
            }

            console.log("dataToSend", vm.dataToSend)

            BonusAdapter.addShopItem(vm.dataToSend, function (newShopItem, error) {
                console.log("newShopItem", newShopItem)
                if (error){
                    ErrorUtility.showErrorMessage({ title: "Add Shop Item", description: "Error while adding the Shop Item!" })
                } else {
                    SweetAlert.swal("Add Shop Item", "The Shop Item was successfully added!", "success")
                    closeDialog(true);
                }
            })
        }

        function closeDialog(value) {
            $mdDialog.hide(value)
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.vehicle.maps', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.vehicle_maps', {
                url  : '/map',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/vehicle/maps/maps.html',
                        controller : 'MapsController as vm'
                    }
                }
            })

        msNavigationServiceProvider.saveItem('map', {
            title: 'Map',
            icon : 'icon-map-marker',
            state: 'app.vehicle_maps',
            weight: 5
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("map")
        
        if(!active) {
            msNavigationService.deleteItem("map")
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.vehicle.maps')
        .controller('MapsController', MapsController)

    /** @ngInject */
    function MapsController($scope, VehicleSharingAdapter, VehicleTypes, VehicleTripStatus, VehicleStatus, VehicleStatusColor, FiltersFactory, MiscUtility, AppConstants) {

        var vm = this

        vm.vehicleTypes = VehicleTypes
        vm.vehicleStatus = VehicleStatus
        vm.vehicleStatusColor = VehicleStatusColor
        vm.vehicleTripStatus = VehicleTripStatus

        vm.markerClusterer = null
        vm.mainMap = null
        vm.vehicles = []
        vm.vehiclesViewed = '...'

        vm.mapInitialized = false

        var refreshDataInterval = MiscUtility.createRefreshDataInterval(refreshMap, AppConstants.REFRESHDATAINTERVAL)

        vm.filters = {
            // miscStatus: FiltersFactory.createMiscStatusFilter(),
            // batteryStatus: FiltersFactory.createBatteryStatusFilter(),
            // vehicleExternalStatus: FiltersFactory.createVehicleExternalStatusFilter(),
            // vehicleStatus: FiltersFactory.createVehicleStatusFilter(),
        }
        
        vm.searchFilters = {
            miscStatus: FiltersFactory.createMiscStatusFilter(),
            batteryStatus: FiltersFactory.createBatteryStatusFilter(),
            // vehicleExternalStatus: FiltersFactory.createVehicleExternalStatusFilter(),
            vehicleStatus: FiltersFactory.createVehicleStatusFilter(),
            vehicleReferenceCode: FiltersFactory.createVehicleWithReferenceCodeFilter(),
            vehicleId: FiltersFactory.createVehicleWithIdFilter(),
            vehicleLicensePlate: FiltersFactory.createVehicleWithLicensePlateFilter(),
            vehicleOnline: FiltersFactory.createVehicleWithOnlineFilter(),
            vehicleType: FiltersFactory.createVehicleWithTypeFilter(),
            vehicleDeviceType: FiltersFactory.createVehicleWithDeviceTypeFilter(),
            vehicleBoundingBox: FiltersFactory.createVehicleWithinBoundingBoxFilter(),
            vehicleBrand: FiltersFactory.createVehicleWithBrandFilter(),
            vehicleModelName: FiltersFactory.createVehicleWithModelNameFilter(),
            vehicleCurrentUser: FiltersFactory.createVehicleWithCurrentUserFilter()
        }

        $scope.$on('siteChanged', function () {
            console.log('Site changed in map')
            refreshMap()
        })

        $scope.$on('$destroy', function () {
            // console.log("destroy map page")
            //stop refresh data
            if(refreshDataInterval){
                refreshDataInterval.stop()
                refreshDataInterval = null
            }
        })

        // Methods
        vm.refreshMap = refreshMap
        vm.refreshVehicleMarkers = refreshVehicleMarkers

        function refreshMap() {
            vm.applyFiltersTrigger()
        }

        function refreshVehicleMarkers(params) {

            vm.vehiclesViewed = "..."
            vm.allVehiclesLength = "..."
            vm.isDownloadingData = true

            VehicleSharingAdapter.getVehicles(params,
                function (response, error) {
                    vm.isDownloadingData = false
                    if (error) {
                        ErrorUtility.showErrorMessage({title:"Get Vehicles", description:"Error getting vehicles!"})
                    }else{
                        
                        vm.vehicles = typeof response.data != "undefined" ? response.data : response
                        vm.allVehiclesLength = typeof response.count != "undefined" ? response.count : vm.vehicles.length
                        vm.vehiclesViewed = vm.vehicles.length

                        vm.onVehiclesRefresh(vm.vehicles)

                        if(refreshDataInterval){
                            refreshDataInterval.reset()
                        }
                    }
                }
                
            )
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.vehicle', [
            'app.vehicle.details',
            'app.vehicle.maps'
        ])
        .value('VehiclesListPage','app.vehicle')
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.vehicle',{
                url  : '/vehicle',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/vehicle/vehicle-list.html',
                        controller : 'VehicleListController as vm'
                    }
                },
                params:{
                    searchFor: null
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/vehicle');

        msNavigationServiceProvider.saveItem('vehicle', {
            title: 'Vehicles',
            icon : 'icon-car',
            state: 'app.vehicle',
            weight: 15
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("vehicle")

        if(!active) {
            msNavigationService.deleteItem("vehicle")
        }
    }

})();

/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.vehicle')
        .controller('VehicleTootGifDialogController', VehicleTootGifDialogController)

    /** @ngInject */
    function VehicleTootGifDialogController($scope, $mdDialog, $timeout){

        console.log("test toot gif")

        $timeout(function(){
            closeDialog()
        },2200)

        // $scope.vehicleTypes = VehicleTypes;
        $scope.closeDialog = closeDialog

        function closeDialog(value) {

            $mdDialog.hide(value)

        }
    }

})();
/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.vehicle')
        .controller('VehicleTestActionDialogController', VehicleTestActionDialogController)

    /** @ngInject */
    function VehicleTestActionDialogController($scope,Vehicle,SweetAlert,$state,$mdDialog,VehicleSharingAdapter,VehicleTypes,$timeout){

        var vehicleId = Vehicle.id
        var timeoutDuration = 5000
        console.log("test this vehicle",Vehicle)

        $scope.vehicleTypes = VehicleTypes;
        $scope.closeDialog = closeDialog;
        $scope.startTest = startTest;
        $scope.step = 0;
        $scope.progressValue = 0;
        $scope.isTesting = false
        $scope.isTestPassed = false

        $scope.commands = [
            VehicleSharingAdapter.onCommand,
            VehicleSharingAdapter.openTrunkCommand,
            VehicleSharingAdapter.closeTrunkCommand,
            VehicleSharingAdapter.offCommand,
            VehicleSharingAdapter.leaveCommand
        ]
        var stepSize = 100/$scope.commands.length

        function startTest(){
            console.log("test started")
            $scope.isTesting = true
            genericVehicleCommand($scope.commands[$scope.step])
        }
        startTest()

        function genericVehicleCommand(adapterFN){
            (adapterFN.bind(VehicleSharingAdapter))(vehicleId, function (response, error) {
                $scope.step +=1
                $scope.progressValue+=stepSize;
                if (error){
                    $scope.isTesting = false
                    $scope.isTestNotPassed = true;
                    $scope.errorLabel = "An error occurred at "+$scope.step+", "
                    $scope.errorLabel += error.description ? error.description : "generic error"
                    //SweetAlert.swal("Error send command", error.description, "error");
                }else if (!response.send){
                    $scope.isTesting = false
                    $scope.isTestNotPassed = true;
                    $scope.errorLabel = "An error occurred at "+$scope.step+", "
                    $scope.errorLabel += "vehicle is not online"
                    //SweetAlert.swal("Error send command", "Vehicle is not online", "error");
                }else{
                    if ($scope.step < $scope.commands.length){
                        $timeout(function(){genericVehicleCommand($scope.commands[$scope.step])}, timeoutDuration)
                        console.log("Step",$scope.step)
                    }
                    else{
                        console.log("Test finished",$scope.step)
                        $scope.isTesting = false
                        $scope.isTestPassed = true
                    }
                    //SweetAlert.swal("Success send command", "", "success");
                }
            })
        }

        function closeDialog(value) {

            $mdDialog.hide(value)

        }
    }

})();
/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.vehicle')
        .controller('VehicleBulkUpdateDialogController', VehicleBulkUpdateDialogController)

    /** @ngInject */
    function VehicleBulkUpdateDialogController($scope, $q, $mdDialog, $timeout, SweetAlert, ErrorUtility, VehicleSharingAdapter, FiltersRequestParamFactory, MiscUtility){
        
        $scope.showUploadVehicles = true
        $scope.disableUploadVehicles = true
        $scope.showAvailableActions = true
        $scope.showUpdateSegwayVehiclesSettings = false
        $scope.loadingProgress = 0
        $scope.progressStep = 0
        $scope.vehicles = []
        
        var lastInputMode = null
        var lastFile = null
        $scope.vehiclesListString = ""
        var lq = null

        $scope.isDownloadingData = false
        $scope.downloadSuccess = true
        $scope.vehiclesNotFound = 0

        $scope.errorsOccurred = false
        $scope.vehiclesWithError = []
        $scope.vehiclesWithErrorListString = ""
        
        $scope.selectedVehicleFieldFilter = null
        $scope.availableVehicleFieldFilters = [
            {name:"ID", field:"id", filterType: "number", filter: FiltersRequestParamFactory.createVehicleWithIdFilter},
            {name:"License plate", field:"license_plate", filterType: "string", filter: FiltersRequestParamFactory.createVehicleWithLicensePlateFilter},
            {name:"Ref. Code", field:"reference_code", filterType: "string", filter: FiltersRequestParamFactory.createVehicleWithReferenceCodeFilter}
        ]

        $scope.selectedAction = null
        $scope.availableActions = [
            {name:"Update segways settings", value: 0},
            {name:"Execute commands", value: 1}
        ]
        
        $scope.onSetVehicleFieldFilter = onSetVehicleFieldFilter
        $scope.onVehiclesListStringChange = onVehiclesListStringChange
        $scope.executeActionOnVehicles = executeActionOnVehicles
        $scope.selectAction = selectAction
        $scope.goBackToAvailableActions = goBackToAvailableActions
        $scope.closeDialog = closeDialog

        $timeout(function(){
            initInputFileListeners()
        },1200)

        function initInputFileListeners(){
            initInputFileListener("id_update_vehicles_csv",callReadVehiclesCsv)
        }

        function initInputFileListener(inputId,eventHandler){
    
            var inputFile = document.getElementById(inputId)
            inputFile.addEventListener("change", 
                function(event){
                        eventHandler(event.target.files[0])
                }
            )
        }

        function onSetVehicleFieldFilter(){
            $scope.disableUploadVehicles = false
            //invalidate vehicles list in order to do not use wrong field filter
            $scope.vehicles = []

            if(lastInputMode){
                switch(lastInputMode){
                    case "file":
                        if(lastFile){
                            callReadVehiclesCsv(lastFile)
                        }
                        break;
                    case "string":
                        onVehiclesListStringChange()
                }
            }
        }

        function generateFilterForVehicleField(vehicleFieldValue) {
            // console.log("generateFilter: ",vehicleFieldValue)
            var filterObj = null
            
            switch($scope.selectedVehicleFieldFilter.filterType){

                case "number":
                    filterObj = $scope.selectedVehicleFieldFilter.filter(Number(vehicleFieldValue))
                    break;
                case "string":
                    filterObj = $scope.selectedVehicleFieldFilter.filter(vehicleFieldValue)
                    break;
                default:
                    console.warn("generateFilterForVehicleField: unknown filterType", $scope.selectedVehicleFieldFilter)
            }

            return filterObj
        }

        function getVehicleInfo(vehicleFieldValue, cb){

            if(!$scope.selectedVehicleFieldFilter){
                console.warn("getVehicleInfo: invalid selected filter",$scope.selectedVehicleFieldFilter)
                return
            }

            const filterObj = generateFilterForVehicleField(vehicleFieldValue)
            const params = FiltersRequestParamFactory.createAFilterRequestParam(filterObj)
            
            VehicleSharingAdapter.getVehicles(params, function(vehicles, error){
                if(error){
                    cb(null, error)
                }else{
                    const firstVehicle = vehicles[0]
                    if(vehicles && firstVehicle){
                        cb(firstVehicle, null)
                    }else{
                        cb(null, {})
                    }
                }
            })
        }

        function setVehicles(vehicles){
            // applyAsync to sync angular wuth the js event in case of file read
            $scope.$applyAsync(function(){
                
                if(vehicles.length == 0){
                    resetViewState()
                }else{
                    $scope.vehicles = vehicles
                }
            })
        }

        function getAllVehiclesByFields(filteredVehicleFieldsLines){

            if(!filteredVehicleFieldsLines || filteredVehicleFieldsLines.length === 0){
                console.warn("getAllVehiclesByFields: invalid input",filteredVehicleFieldsLines)
                return
            }

            $scope.isDownloadingData = true
            $scope.vehiclesNotFound = 0
            var vehicles = []
            
            if(lq){
                //if already a limitQueue is running abort
                lq.abort()
            }
            lq = MiscUtility.createLimitQueue(3)
            
            filteredVehicleFieldsLines.forEach(function(fields){
                const field = fields[0]

                lq.join(
                    function(lqCallback){
                        getVehicleInfo(field, function(vehicle, error){
                            if(error){
                                console.warn("getVehicleInfo: error for ",error,field,vehicle)
                                $scope.vehiclesNotFound++
                            }else{
                                if(vehicle && Object.keys(vehicle).length > 0){
                                    vehicles.push(vehicle)
                                }else{
                                    $scope.vehiclesNotFound++
                                }
                            }

                            if(lqCallback){
                                lqCallback()
                            }
                        })
                    }
                )
            })

            lq.start(function onEnd(error){
                if(error){
                    console.warn("queue ended with an error", error)
                }
                $scope.isDownloadingData = false
                $scope.downloadSuccess = ($scope.vehiclesNotFound === 0)
                setVehicles(vehicles)
                
                lq = null
            })
        }

        function handleVehiclesFieldsFile(fileLines){
            $scope.vehicles = []
            
            if(!fileLines || fileLines.length === 0){
                console.warn("handleVehiclesFieldsFile: invalid fileLines",fileLines)
                $scope.downloadSuccess = false
                return
            }
            
            // console.log("filelines", fileLines)
            if(!$scope.selectedVehicleFieldFilter){
                console.warn("handleVehiclesFieldsFile: invalid selectedVehicleFieldFilter",$scope.selectedVehicleFieldFilter)
                $scope.downloadSuccess = false
                return
            }
            
            //filter file lines checking field type
            const filteredVehicleFieldsLines = fileLines
                .filter(function(fields){
                    const field = fields[0]
                    if($scope.selectedVehicleFieldFilter.filterType === "number"){
                        // console.warn("selected field is a number")
                        return field && !isNaN(Number(field))
                    }else if($scope.selectedVehicleFieldFilter.filterType === "string"){
                        return field && field != ""
                    }
                })
            
            if(filteredVehicleFieldsLines.length === 0){
                console.warn("handleVehiclesFieldsFile: empty filteredVehicleFieldsLines", filteredVehicleFieldsLines)
                $scope.downloadSuccess = false
                return
            }

            getAllVehiclesByFields(filteredVehicleFieldsLines)
        }

        function resetLastFile(){
            lastFile = null
        }

        function callReadVehiclesCsv(file){
            
            resetVehiclesListString()

            if(!file){
                console.warn("callReadVehiclesCsv: file is invalid",file)
                //in order to update view in handleVehiclesFieldsFile
                handleVehiclesFieldsFile([])
                return
            }

            var fileLines = []
            lastFile = file
            lastInputMode = "file"


            const fs = new FileReader()
            fs.onload = parseFile
            fs.readAsText(file)

            function parseFile(){
                var data = fs.result
                var lineCounter = 0
                
                data.split("\n").forEach(function(line){
                    lineCounter+=1
                    
                    // console.log("line",line)
                    //remove end of line or carriage return
                    line = line.trim()

                    //skip empty line ""
                    if(line !== ""){
                        const fields = line.split(";")
                        fileLines.push(fields)
                    }
                    
                })

                handleVehiclesFieldsFile(fileLines)
            }
        }

        function resetVehiclesListString(){
            $scope.vehiclesListString = ""
        }

        function onVehiclesListStringChange() {

            resetLastFile()
            
            if($scope.vehiclesListString === ""){
                console.warn("onVehiclesListStringChange: empty input")
                //in order to update view in handleVehiclesFieldsFile
                handleVehiclesFieldsFile([])
                return
            }
            var vehiclesField = []
            var fileLines = []
            lastInputMode = "string"

            vehiclesField = $scope.vehiclesListString.split(",")
            fileLines = vehiclesField.map(function(field){return [field]})
            
            handleVehiclesFieldsFile(fileLines)
        }

        function resetViewState(){
            $scope.showUploadVehicles = true
            $scope.showAvailableActions = true
            $scope.selectedAction = null
        }

        function goBackToAvailableActions() {
            resetViewState()
        }

        function selectAction(value) {
            // console.warn("selectAction", value, $scope.selectedAction)

            if(value !== null){
                $scope.showUploadVehicles = $scope.showAvailableActions = false
            }else{
                $scope.showUploadVehicles = $scope.showAvailableActions = true
            }
        }

        function executeActionOnVehicles(fn){
            // console.log("start executeActionOnVehicles",fn)

            if(!fn){
                console.warn("executeActionOnVehicles: invalid fn",fn)
                ErrorUtility.showErrorMessage({title:'Vehicles bulk update', description:"The app can't perform the action"})
                return
            }

            if(!$scope.vehicles || $scope.vehicles.length==0){
                ErrorUtility.showErrorMessage({title:'Vehicles bulk update', description:"The vehicles list is empty!"})
                return
            }
            
            $scope.errorsOccurred = false
            $scope.vehiclesWithError = []
            $scope.vehiclesWithErrorListString = ""
            
            $scope.loadingProgress = 0
            $scope.progressStep = (1/$scope.vehicles.length) * 100

            updateVehiclesAsync($scope.vehicles.slice(), fn, function(response, error){
                if(error){
                    // ErrorUtility.showErrorMessage({title:'Update Vehicles', description:'Error while performing an action on vehicle ID '+error.vehicle.id+". All the vehicles prior to this one have been updated!"})
                    $scope.errorsOccurred = true
                    $scope.vehiclesWithError.push(error.vehicle)
                    
                    $scope.vehiclesWithErrorListString += (($scope.vehiclesWithError[$scope.vehiclesWithError.length-1]).id+",")

                }else{
                    if($scope.errorsOccurred){
                        ErrorUtility.showErrorMessage({title:'Vehicles bulk update', description:'The process has been completed with some errors!'})
                    }else{
                        SweetAlert.swal("Vehicles bulk update","All actions on vehicles have been succefully completed!","success")
                        closeDialog()
                    }
                }
            })
        }

        function updateVehiclesAsync(vehicles, updateVehicleFn, cb) {

            if(vehicles.length === 0){
                cb(true, null)
                return
            }

            var vehicle = vehicles.shift()

            updateVehicleFn(vehicle, function(response, error){
                if(error){
                    cb(false, {error: error, vehicle: vehicle})
                }
                $scope.loadingProgress += $scope.progressStep
                updateVehiclesAsync(vehicles, updateVehicleFn, cb)
            })
            
        }
        
        function closeDialog(value) {
            $mdDialog.hide(value)
            
            //if a limitQueue is running abort
            if(lq){
                lq.abort()
            }
        }
    }

})();
/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.vehicle')
        .controller('VehicleAddDialogController', VehicleAddDialogController)

    /** @ngInject */
    function VehicleAddDialogController($scope,$interval,$timeout,SweetAlert,$mdDialog,VehicleSharingAdapter,VehicleTypes,FuelTypes,SitesService,DeviceType,ServiceSettings,MiscUtility,DialogFactory,ErrorUtility){
        $scope.vehicleTypes = VehicleTypes
        $scope.fuelTypes = FuelTypes
        $scope.deviceType = DeviceType
        ServiceSettings.getServiceSettings(function(settings) {
            if(settings.loaded){
                SitesService.getSites(function(){
                    $scope.selectedSiteId = SitesService.getSelectedSite()
                    var timezone = settings && settings[$scope.selectedSiteId] && settings[$scope.selectedSiteId].timezone;
    
                    $scope.timezone = timezone;
                    $scope.todayDate =  MiscUtility.serviceTodayDate($scope.selectedSiteId);
                })
            }
        });
        $scope.nOfInsertions = 1
        $scope.isBulkInsertion = false
        $scope.isBulkActive = false
        $scope.bulkUploadKeys = [
            { key: 0, name: "License Plate", index: 0 },
            { key: 1, name: "Reference Code", index: 1 },
            { key: 2, name: "Vehicle Type", index: 2 },
            { key: 3, name: "Device Provider", index: 3 },
            { key: 4, name: "Device ID", index: 4 },
            { key: 5, name: "Site", index: 5 },
            { key: 6, name: "Brand", index: 6 },
            { key: 7, name: "Model Name", index: 7 },
            { key: 8, name: "Version", index: 8 },
            { key: 9, name: "Cylinder Capacity", index: 9 },
            { key: 10, name: "KM", index: 10 },
            { key: 11, name: "Battery Code", index: 11 },
            { key: 12, name:"Battery AH Tot", index: 12 },
            { key: 13, name: "Registration Date", index: 13 }
        ]
        $scope.headingRowExists = false;
        $scope.fileLines = []; 
        $scope.selectedKey = []; // dummy arr
        $scope.bulkKeysTable = [];
        $scope.updateBulkKeys = updateBulkKeys;
        $scope.updateBulkKeysTable = updateBulkKeysTable
        $scope.totalUploadedFileRows = null;  

        $scope.sites = []
        $scope.vehicle = {deviceType: DeviceType.PERSONAL.value}
        
        $scope.closeDialog = closeDialog
        $scope.callAddVehicle = callAddVehicle

        SitesService.getSites(function (sites) {
                $scope.sites = sites
                $scope.isServiceMultisite = SitesService.isServiceMultisite
            },function (error) {
                console.log("VehicleAddDialogController error getting sites",error)
            })

        function initInputFileListeners(){

            initInputFileListener("id_vehicles_csv",callAddBulkVehicles)
        }

        $timeout(function(){
            initInputFileListeners()
        },1000)

        function initInputFileListener(inputId,eventHandler){

            var inputFile = document.getElementById(inputId)

            inputFile.addEventListener("change", 
                function(event){
                        eventHandler(event.target.files[0])
                }
            )
        }

        function updateBulkKeysTable() {
            var sliceStart = $scope.headingRowExists ? 1 : 0;
            $scope.bulkKeysTable = $scope.fileLines.slice(sliceStart, sliceStart + 3).map(function(row, i){
                var r = {};
                for(var i = 0; i < row.length; i++) {
                    r[i] = row[i];
                }
                return r;
            });
        }

        function updateBulkKeys(columnIndex,optionIndex) {
            // find which key in arr correspongs to option columnIndex
            var replacementColumPos, activeColumnPos, oldColumnVisualIndex;
            $scope.bulkUploadKeys.map(function(el,i) {
                if(el.index === columnIndex){
                    replacementColumPos = i;
                }
                if(el.key === optionIndex){
                    activeColumnPos = i;
                    oldColumnVisualIndex = el.index;
                }
            });

            // update the clicked column with the clicked value
            $scope.bulkUploadKeys[activeColumnPos].index = columnIndex;

            // move the value that was active to the position where the current item came from
            $scope.bulkUploadKeys[replacementColumPos].index = oldColumnVisualIndex;
        }

        var rowData = { }

        function validateRowFields(fields){
            rowData = { }
            const errors = [];
            
            var licensePlateColumn = $scope.bulkUploadKeys[0].index
            if(fields[licensePlateColumn] === "" ) {
                errors.push('license_plate: ' + fields[licensePlateColumn]);
                return errors;
            } else {
                rowData.license_plate = fields[licensePlateColumn];
            }

            var referenceCodeColumn = $scope.bulkUploadKeys[1].index
            if(fields[referenceCodeColumn] === "" ) {
                errors.push('reference_code: ' + field[referenceCodeColumn]);
                return errors;
            } else {
                rowData.reference_code = fields[referenceCodeColumn];
                // var tempRefCode = rowData.reference_code.toLowerCase();
                // if(tempRefCode.indexOf('m#')==-1){
                //     rowData.reference_code = "M#" + rowData.reference_code;
                // }
            }

            var vehicleTypeColumn = $scope.bulkUploadKeys[2].index
            var vehicleType = getVehicleType(fields[vehicleTypeColumn].toLowerCase());
            if(vehicleType === undefined || vehicleType === '') {
                errors.push('vehicle type: ' + fields[vehicleTypeColumn]);
                return errors;
            } else {
                rowData.type = vehicleType ;
            }

            var devicetypeColumn = $scope.bulkUploadKeys[3].index
            var deviceType = getDevicetype(fields[devicetypeColumn].toLowerCase());
            if(deviceType === undefined || deviceType === '') {
                errors.push('device provider: ' + fields[devicetypeColumn]);
                return errors;
            } else {
                rowData.deviceType = deviceType ;
            }

            var deviceIdColumn = $scope.bulkUploadKeys[4].index
            var deviceId = fields[deviceIdColumn];
            if(deviceId === "" && rowData.deviceType !== DeviceType.PERSONAL.value) {
                errors.push('deviceId ' + deviceId);
                return errors;
            } else {
                rowData.deviceId = deviceId.trim();
                if (rowData.deviceId.includes(" ")) {
                    errors.push("deviceId " + deviceId);
                    return errors;
                }
                if (rowData.deviceType === DeviceType.PERSONAL.value) {
                    rowData.deviceId = null;
                } else if (rowData.deviceType === DeviceType.SEGWAY.value) {
                    if (rowData.deviceId.indexOf("-") === -1) {
                        rowData.deviceId = rowData.deviceId + "-" + rowData.deviceId;
                    }
                }
            }

            var siteIdColumn = $scope.bulkUploadKeys[5].index
            var vehicleSiteName = fields[siteIdColumn]
            var siteId = getSiteId(vehicleSiteName);
            if(!siteId) {
                errors.push('Site ID: ' + vehicleSiteName);
                return errors;
            } else {
                rowData.SiteId = siteId ;
            }

            var brandColumn = $scope.bulkUploadKeys[6].index
            var brand = fields[brandColumn];
            if(brand === '') {
                errors.push('Brand: ' + brand);
                return errors;
            } else {
                rowData.brand = brand ;
            }

            var modelNameColumn = $scope.bulkUploadKeys[7].index
            var modelName = fields[modelNameColumn];
            if(modelName === '') {
                errors.push('Model Name: ' + modelName);
                return errors;
            } else {
                rowData.model_name = modelName ;
            }

            var versionColumn = $scope.bulkUploadKeys[8].index
            var version = fields[versionColumn];
            if(version === '') {
                errors.push('Version: ' + version);
                return errors;
            } else {
                rowData.version = version;
            }

            var cylinderCapacityColumn = $scope.bulkUploadKeys[9].index
            var cylinderCapacity = fields[cylinderCapacityColumn];
            if(cylinderCapacity === '' || isNaN(Number(cylinderCapacity))) {
                errors.push('Cylinder Capacity: ' + cylinderCapacity);
                return errors;
            } else {
                rowData.cylinder_capacity = Number(cylinderCapacity);
            }

            var kmColumn = $scope.bulkUploadKeys[10].index
            var kilometers = fields[kmColumn];
            if(kilometers === '' || isNaN(Number(kilometers))) {
                errors.push('Kilometers: ' + kilometers);
                return errors;
            } else {
                rowData.km = Number(kilometers);
            }

            var batteryCodeColumn = $scope.bulkUploadKeys[11].index
            var batteryCode = fields[batteryCodeColumn];
            if(batteryCode === '') {
                errors.push('Battery Code: ' + batteryCode);
                return errors;
            } else {
                rowData.battery = {};
                rowData.battery.code = batteryCode;
            }

            var batteryAhTotColumn = $scope.bulkUploadKeys[12].index
            var batteryTotalAmpers = fields[batteryAhTotColumn];
            if(batteryTotalAmpers === '' || isNaN(Number(batteryTotalAmpers))) {
                errors.push('Battery Total Ampers: ' + batteryTotalAmpers);
                return errors;
            } else {
                rowData.battery.ah_tot = Number(batteryTotalAmpers);
            }

            var registrationDateColumn = $scope.bulkUploadKeys[13].index
            var registrationDate = fields[registrationDateColumn];
            if(registrationDate === undefined || registrationDate === '') {
                const nowDate = MiscUtility.createTzMoment(null, rowData.SiteId)
                if(nowDate == null){
                    errors.push('Registration Date: timezone is not available for '+vehicleSiteName+' ,')
                }else{
                    rowData.registration_date = nowDate.startOf('day').toISOString()
                }
            }else{
                const parsedInput = Number(registrationDate);
                if(isNaN(parsedInput)) { 
                    if(moment(registrationDate, moment.ISO_8601, true).isValid()) {
                        const regDateFromISOString = MiscUtility.createTzMoment(registrationDate, rowData.SiteId)
                        if(regDateFromISOString == null){
                            errors.push('Registration Date: timezone is not available for '+vehicleSiteName+' ,')
                        }else{
                            rowData.registration_date = regDateFromISOString.startOf('day').toISOString()
                        }
                    }else{
                        errors.push('Registration Date: ' + registrationDate + ' is not an ISO String and ')
                    }
                } else {
                    // is an epoch time
                    const regDateFromTimestamp = MiscUtility.createTzMoment(parsedInput, rowData.SiteId)
                    if(regDateFromTimestamp == null){
                        errors.push('Registration Date: timezone is not available for '+vehicleSiteName+' ,')
                    }else{
                        rowData.registration_date = regDateFromTimestamp.startOf('day').toISOString()
                    }
                }
            }

            //add fuels
            rowData.fuels = [];
            if(rowData.type === VehicleTypes.CAR.value){
                rowData.fuels = [{
                    total: 100,
                    type: $scope.fuelTypes.GASOLINE.value,
                    multiplier: 100
                }]
            }

            return errors;    
        }

        function getVehicleType(vehicleType) {
            for(var key in VehicleTypes) {
                if(VehicleTypes[key].name.toLowerCase().indexOf(vehicleType) === 0) {
                    return VehicleTypes[key].value;
                }
            }
        }
        
        function getDevicetype(deviceTypeName) {
            for(var key in DeviceType) {
                if(DeviceType[key].name.toLowerCase().indexOf(deviceTypeName) === 0) {
                    return DeviceType[key].value;
                }
            }
        }

        function getSiteId(siteName) {
            for (var i = 0; i < $scope.sites.length; i++) {
                if($scope.sites[i].name === siteName) {
                    return $scope.sites[i].id
                }
            }
        }

        function parseFileLines(){
            $scope.loadingProgress = 0;
            var vehiclesParsed = [];
            var start = $scope.headingRowExists ? 1 : 0;
            for(var i = start; i < $scope.fileLines.length; i++) {
                var errors = validateRowFields($scope.fileLines[i]);
                if(errors.length > 0) {
                    SweetAlert.swal("Error while parsing","Line " + i + ' ' + errors.join(',') + ' is invalid',"error")
                    return;
                } else {
                    vehiclesParsed.push(rowData)
                }
            }

            var progressStep = (1/vehiclesParsed.length) * 100;
            $scope.totalUploadedFileRows = 0;

            addVehiclesAsync(vehiclesParsed,
                function(){
                    $scope.loadingProgress += progressStep;
                    $scope.totalUploadedFileRows++;
                },function(success,errorObj){
                    if(success){
                        SweetAlert.swal("Add Vehicles", "All vehicles added!", "success")
                        closeDialog(true)
                    } else {
                        ErrorUtility.showErrorMessage({title:"Add Vehicles" ,description: "Error on vehicle " + errorObj.vehicle.reference_code + " at line " + $scope.totalUploadedFileRows + ': ' + (errorObj.error.description || errorObj.error ) + '. All vehicles before this row were addedd successfully.'})
                    }
            })
        }

        function callAddBulkVehicles(file){

            var fs = new FileReader()
            fs.onload = parseFile
            fs.readAsText(file)

            function parseFile(){
                var data = fs.result
                var prevIndex = -1
                var lineCounter = 0

                for(var i = 0; i < data.length; i++){

                    if(data[i] == '\n'){
                        lineCounter+=1

                        var currentRow = data.substring(prevIndex +1, i)
                        var fields = currentRow.split(";")

                        //skip empty line
                        if(fields.length === 1){
                            continue
                        }
                        //check if ;;;
                        //disabled for deviceId empty in case of 2hire
                        // for(var f in fields){
                        //     fields[f] = fields[f].trim()
                        //     if(fields[f] === ""){
                        //         SweetAlert.swal("Error while parsing","Line "+lineCounter+" : a field was empty!","error")
                        //         return
                        //     }
                        // }

                        //remove end of line or carriage return
                        fields[fields.length-1] = fields[fields.length-1].trim()

                        $scope.fileLines.push(fields);

                        prevIndex = i
                    }
                    
                    if(i===data.length-1 && prevIndex<i){
                        SweetAlert.swal("Error while parsing","Missing end of line!","error")
                        return
                    }
                }

                updateBulkKeysTable()

                $scope.$apply(function () {
                    $scope.isBulkActive = true;
                });
            }
        }

        function addVehiclesAsync(vehicles,onElement,cb){
            if (vehicles.length === 0) {
                cb(true, null)
                return
            }

            var vehicleToSend = vehicles.shift()
            VehicleSharingAdapter.addVehicle(vehicleToSend,
                function (newVehicle, error){
                    if (error){
                        console.log("error add vehicle",vehicleToSend)
                        cb(false, {error: error, vehicle: vehicleToSend})
                    }else{
                        console.log('Vehicle added', vehicleToSend)
                        onElement()
                        addVehiclesAsync(vehicles,onElement,cb)
                    }
                }
            )
        }

        function callAddVehicle() {

            if($scope.isBulkActive) {
                parseFileLines();
                return;
            }

            console.log("vehicle to send",$scope.vehicle);

            if($scope.nOfInsertions>1){
                console.log("bulk insertion")
                $scope.isBulkInsertion = true
            }


            const vehicleRegDate = MiscUtility.shiftJstoMoment($scope.vehicle.registration_date, $scope.vehicle.SiteId);
            if(vehicleRegDate === null){
                SweetAlert.swal('Add vehicle','Error adding the vehicle, no timezone available for the selected vehicle\'s site. Please check the app\'s selected site','error')
                return
            }
            const trimmedDeviceId = $scope.vehicle.deviceId ? $scope.vehicle.deviceId.trim() : null;
            if (trimmedDeviceId && trimmedDeviceId.includes(" ")) {
                SweetAlert.swal("Add vehicle", "Error adding the vehicle, device id contains a space", "error");
                return;
            }
            var dataToSend = {
                license_plate: $scope.vehicle.license_plate,
                reference_code: $scope.vehicle.reference_code,
                type: $scope.vehicle.type,
                model_name: $scope.vehicle.model_name,
                brand: $scope.vehicle.brand,
                version: $scope.vehicle.version,
                cylinder_capacity: $scope.vehicle.cylinder_capacity,
                km: $scope.vehicle.km,
                registration_date: vehicleRegDate.toISOString(),
                battery: {
                    code: $scope.vehicle.battery.code,
                    ah_tot: $scope.vehicle.battery.ah_tot,
                },
                deviceType: $scope.vehicle.deviceType,
                deviceId: trimmedDeviceId,
                fuels: [],
                SiteId: $scope.vehicle.SiteId ? $scope.vehicle.SiteId : null,
            };

            if($scope.vehicle.deviceType === DeviceType.SEGWAY.value) {
                if($scope.vehicle.deviceId && $scope.vehicle.deviceId.indexOf('-') === -1) {
                    dataToSend.deviceId = dataToSend.deviceId + '-' + dataToSend.deviceId
                }
            }

            if($scope.vehicle.type === $scope.vehicleTypes.CAR.value){
                dataToSend.fuels = [{
                    total: 100,
                    type: $scope.fuelTypes.GASOLINE.value,
                    multiplier: 100
                }]
            }

            console.log("dataToSend",dataToSend)

            VehicleSharingAdapter.addVehicle(dataToSend,
                function (newVehicle, error){

                    console.log("add newVehicle",$scope.vehicle);

                    if (!error){
                        $scope.nOfInsertions -= 1

                        if($scope.nOfInsertions>=1){

                            $scope.vehicle.reference_code = ''
                            $scope.vehicle.license_plate = ''
                            $scope.vehicle.battery.code = ''
                            $scope.vehicle.deviceId = ''

                        }
                        if($scope.nOfInsertions==0){
                            closeDialog(true);
                        }
                        //$state.go("app.vehicle.details",{vehicle:newVehicle})

                    }else{
                        ErrorUtility.showErrorMessage({ title:"Add new vehicle" , description: error.description })
                        // SweetAlert.swal("Add new vehicle", error.description, "error");
                    }
                }
            )
        }

        function closeDialog(value) {

            $mdDialog.hide(value)

        }
    }

})();
/**
 * Created by alex on 27/06/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.vehicle.details',[])
        .config(config)
        .value("VehicleDetailsPage","app.vehicle.details");

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {

        $stateProvider
            .state('app.vehicle.details',{
                url  : '/{vehicleId:int}',
                views: {
                    'content@app' : {
                        templateUrl: 'app/main/vehicle/details/vehicle-details.html',
                        controller : 'VehicleDetailsController as vm'
                    }
                },
                resolve:{
                    Vehicle: function (AppRequirements,$state,$q,$stateParams,$timeout,VehicleSharingAdapter,VehiclesListPage,ErrorUtility) {
                        var deferred = $q.defer()
                        var vehicleId = $stateParams.vehicle ? $stateParams.vehicle.id : $stateParams.vehicleId

                        if(typeof vehicleId == undefined){
                            $timeout(function(){
                                deferred.reject()
                                $state.go(VehiclesListPage)
                            })
                        }

                        VehicleSharingAdapter.getVehicle(vehicleId,
                            function(response,error){
                                if(!error){
                                    deferred.resolve(response)
                                }
                                else{
                                    ErrorUtility.showErrorMessage({title:'Get Vehicle Details',description:"Error while getting the vehicle details!"})
                                    deferred.reject(error)
                                    $state.go(VehiclesListPage)
                                }
                        })
                        return deferred.promise

                        //handle reload with localstorage
                        /*if($stateParams.vehicle ==null){
                            console.log('page refreshed')
                            var detailsId = ''
                            try{
                                detailsId = LocalStorageService.getItem('detailsId')
                                if(detailsId && detailsId != '') {
                                    return VehicleSharingAdapter.getVehicle(detailsId)
                                }
                                else{
                                     return goToVehicles()
                                }
                            }
                            catch (err){
                                console.log("No localStorage to use for get detailsId")
                                return goToVehicles()
                            }
                        }
                        else {
                            detailsId = $stateParams.vehicle.id
                            try{
                                LocalStorageService.setItem('detailsId',detailsId)
                                return VehicleSharingAdapter.getVehicle(detailsId)
                            }
                            catch (err){
                                console.log("No localStorage to use for store detailsId")
                                return VehicleSharingAdapter.getVehicle(detailsId)
                            }
                        }*/
                    }
                },
                params:{
                    vehicle: null
                }
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/vehicle/details');
    }
})();
/**
 * Created by alex on 24/01/17.
 */

(function ()
{
    'use strict';

    angular
        .module('app.vehicle.details')
        .controller('VehicleDetailsController', VehicleDetailsController);

    /** @ngInject */
    function VehicleDetailsController(
        $scope,
        $q,
        $mdDialog,
        VehicleUtility,
        $location,
        $state,
        VehiclesListPage,
        ToHireDefaultColor,
        Vehicle,
        VehicleTypes,
        VehicleDocumentTypes,
        FuelTypes,
        VehicleSharingAdapter,
        $anchorScroll,
        HttpHeadersManager,
        SweetAlert,
        toDateFilter,
        TripsAdapter,
        numberFilter,
        GenerateCSVService,
        TripsListPage,
        SitesService,
        VehicleDialogFactory,
        DialogFactory,
        LogAdapter,
        VehicleStatus,
        VehicleBookingStatus,
        DevicesListPage,
        DeviceType,
        DeviceUtility,
        ServiceSettings,
        DamageReportDialogFactory,
        MiscUtility,
        ErrorUtility,
        OrderRequestParamFactory,
        MovoUnavailableDescriptor,
        VehicleServiceGroupTag,
        ServiceData,
        toNumberFilter,
        DeviceAdapter
    ) {
        var vm = this;
        // Data
        vm.vehicle = Vehicle;
        vm.vehicles = []
        vm.sites = []
        vm.toHireDefaultColor = ToHireDefaultColor;
        vm.vehicleStatusLogs = []
        vm.movoUnavailableDescriptors = MovoUnavailableDescriptor
        vm.vehicleServiceGroupTags = []
        vm.vehicleAdditionalActions = []

        vm.updateTableDamagesData = updateTableDamagesData

        vm.vehicleBattery = {
            value: null,
            description: "",
            unit: ""
        }

        var userClicks = 0
        vm.showEasterEgg = false

        $scope.$on('refreshServiceSettings',function (event) {
            refreshServiceSettings();
        })
        
        $scope.$on('siteChanged', function (site) {
            refreshVehicle();
            refreshSites();
        })

        ServiceData.getServiceData(function (service, error){
            if(error){
            }else{
                if(service.name){
                    var serviceName = service.name.replace(/-test.*$/g,"").replace(/-multisite.*$/g,"")
                    vm.serviceName = serviceName
                    initVehicleServiceGroupTags()
                    generateVehicleBatteryVoltage(vm.vehicle)
                }
            }
        })
        
        function refreshServiceSettings() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    SitesService.getSites(function(){
                        var vehicleSiteId = Vehicle.SiteId
                        
                        vm.timezone = ServiceSettings.getSiteTimezone(vehicleSiteId)
                        vm.todayDate = MiscUtility.serviceTodayDate(vehicleSiteId);

                        vm.vehicle.registration_date = MiscUtility.shiftMomentToJs(vm.vehicle.registration_date, vehicleSiteId);

                        vm.logFilter = {start:null,end:null}
                        vm.logFilter.start = MiscUtility.serviceTodayDate(vehicleSiteId); 
                        vm.logFilter.end = MiscUtility.serviceTodayDate(vehicleSiteId);

                        vm.vehicleStatusTableFields = {
                            timestamp: { name: "Timestamp", class:"vehicleRowCellBig", key:'updated_at', type:'render', render: function(v, o){ return toDateFilter(o.updated_at, "dateTime",  vm.vehicle.SiteId) }},
                            fuel: { name: (vm.vehicle.type === VehicleTypes.CAR.value) ? 'Fuel' : 'Battery', class:"vehicleRowCell", key:'total_percentage', type:'render', render: function(v,o){ return !isNaN(parseInt(o.total_percentage)) ? (o.total_percentage+' %') : ''}},
                            speed: { name: 'Speed', class:"vehicleRowCell", key:'speed', type:'render', render: function(v,o){ return !isNaN(parseInt(o.speed)) ? o.speed : ''}},
                            km: { name: 'Km', class:"vehicleRowCell", key:'km', type:'render', render: function(v,o){ return !isNaN(parseInt(o.km)) ? (o.km +' km ') : ''}},
                            latitude: { name: "Latitude", class:"vehicleRowCellBig", key:'latitude'},
                            longitude: { name: "Longitude", class:"vehicleRowCellBig", key:'longitude'},
                            satellites: { name: "Satellites", class:"vehicleRowCellSmall", key:'satellites'},
                            status: { name: "Status", class:"vehicleRowCellVeryBig", key:'sender', type:'render', render: function(v,o){ return (o.sender ? o.sender : '') + ' -> ' + (o.status ? o.status : '') }},
                        }
                
                        vm.vehicleDamageReportsFields = {
                            id: { name: "ID", class:"vehicleRowCellSmall", key:'id' },
                            description: { name: "Description", class:"vehicleRowCellVeryBig", key:'description', ellipsis: true },
                            creationDate: { name: "Creation date", class:"vehicleRowCellBig", key:'created_at', type:'render', render: function(v, o){ return toDateFilter(o.created_at, "dateTime", o.vehicle.SiteId) }},
                            userId:{ name:"User Id", class:"vehicleRowCellSmall", type:'link', link:{goto: "app.user.details",gotoParams: "userId", key:'user.id', class:function(o){ return 'userLink' }}, render: function(val, obj){ return obj.user ? obj.user.id : '' }},
                            name:{ name: "Full Name", class:"vehicleRowCellBig alignLeft", ellipsis: true, type:'render', key:'email', render: function(v, o) { return o.user ? o.user.fullName: ''}},            
                            userstatus:{ name: "User status", class:"vehicleRowCell", type: 'render', render: function(v, o){ return o.user ? o.user.statusHuman : '' } },
                            details:{ name: "Details", class:"button-cell", type:'icon-click', icon:{ class:'icon-information-outline', click:function(obj, $event){ vm.selectThisDamageReport(obj, $event) }, aria: 'Open Damage Report' }, hideCsv: true}
                        }
                    })
                }
            });
            
        }

        refreshServiceSettings()

        function refreshSites(){
            SitesService.getSites(function (sites) {
                    vm.sites = sites
                    vm.isServiceMultisite = SitesService.isServiceMultisite
                },function (error) {
                    ErrorUtility.showErrorMessage({title:'Get Sites List',description:'Error while getting the sites list'})
                })
        }
        refreshSites()

        function initVehicleServiceGroupTags(){

            vm.vehicleServiceGroupTags = VehicleServiceGroupTag[vm.serviceName]
        }

        vm.vehicleTypes = VehicleTypes
        vm.vehicleStatus = VehicleStatus
        vm.vehicleDocumentTypes = VehicleDocumentTypes
        vm.vehicleBookingStatus = VehicleBookingStatus
        vm.hasVehicleACurrentBooking = VehicleUtility.hasVehicleACurrentBooking
        vm.fuelTypes = FuelTypes
        vm.deviceType = DeviceType
        vm.disableEditVehicleDetails = true;
        vm.currentDamageReport = null
        vm.selectedDamageReportImage = {number:0,location:""}
        vm.totalVehicleTrips = '...'

        if ( !vm.vehicle ){
            vm.dialogType = "add"
        }else{
            vm.dialogType = "edit"
            var vehicleId = Vehicle.id
            getVehicleTrips(vehicleId)
            getRelatedData(vehicleId)
            vm.vehicles = [Vehicle]
            vm.geofenceVehicleTypes = [Vehicle.type]
        }
        // console.log("current vehicle",vm.vehicle)

        vm.tabs = {
            POSITION:0,
            MANAGE:1,
            DOCUMENTS:2,
            IMAGES:3,
            STATUSLOGS:4
        }
        vm.selectedTab = 0

        function onTabSelect(tabNumber) {
            vm.selectedTab = tabNumber;

            switch (tabNumber){
                /*case vm.tabs.OBD2_DATA:
                    if(vm.obdData.data.length == 0)
                        getVehicleObdData(vm.vehicle.id);
                    break;
                case vm.tabs.OBD2_DATA_HISTORY:
                    if(Object.keys(vm.lastObdParamsCharts).length == 0)
                        generateLastVehicleObdParamsCharts(vm.vehicle.id);
                    break;*/
                default: break;
            }
        }

        // vm.tabActions = {
        //     0:{
        //       add: callAddVehicle,
        //       save: callUpdateVehicle
        //     }
        // }

        //ngFlow,ngEmbed options
        vm.currentVehicleDocuments = [];
        vm.selectedVehicleDocument = null;
        vm.uploadErrors = 0;
        vm.showProgress = false;
        vm.isDocumentTypeInputInvalid = false;
        vm.isDocumentDescriptionInputInvalid = false;

        /*
         //it was useful for pdf link,now in ng-embed it does it
         vm.trustUrl = function (src){
         return $sce.trustAsResourceUrl(src);
         }*/

        //options for ng-embed directive,it shows pdf and img and other by settings
        vm.embedOptions = {
            pdf              : {
                embed: true                 // show pdf viewer.
            },

            image            : {
                embed: true                // toggle embedding image after link, supports gif|jpg|jpeg|tiff|png|svg|webp.
            },
            tweetEmbed       : false,
        };

        //set flow for vehicle image options
        vm.ngFlowImageFileOptions = {
            target   : function (flowFile) {

                return  VehicleSharingAdapter.getAddImageUrl(vehicleId)

            },
            query: {
                //description: "",
                //type:0
            },
            headers :HttpHeadersManager.getHeaders(),
            simultaneousUploads      : 1,
            chunkSize                : 20 * 1024 * 1024, //create 20MB chunk
            testChunks               : false,
            permanentErrors          :[404, 415, 500, 501,413]
        };

        //set flow for vehicle documents options
        vm.ngFlowDocumentFileOptions = {
            target   : function (flowFile) {

                return  VehicleSharingAdapter.getAddDocumentUrl(vehicleId)

            },
            query: function (flowFile) {

                // console.log(flowFile);

                return{
                    description: flowFile.vehicleDocumentDescription,
                    type: flowFile.vehicleDocumentType
                }
            },
            headers: HttpHeadersManager.getHeaders(),
            simultaneousUploads      : 1,
            chunkSize                : 20 * 1024 * 1024, //create 20MB chunk
            testChunks               : false,
            permanentErrors          :[404, 415, 500, 501,413]
        };

        //inject $flow instance here from directive
        vm.ngFlowImageFile = {
            flow:{}
        };

        vm.ngFlowDocumentFile = {
            flow:{}
        };

        // Methods
        // vm.callAddVehicle = callAddVehicle;
        vm.callUpdateVehicle = callUpdateVehicle;
        vm.callDeleteVehicleConfirmDialog = callDeleteVehicleConfirmDialog;
        vm.checkInput = checkInput;
        vm.onTabSelect = onTabSelect;
        vm.refreshVehicle = refreshVehicle;
        vm.goToVehicles = goToVehicles;
        vm.enableVehicleDetailsChange = enableVehicleDetailsChange;
        vm.disableVehicleDetailsChange = disableVehicleDetailsChange;
        vm.focusOnImagesTab = focusOnImagesTab;
        vm.goToTripsWithFilter = goToTripsWithFilter;
        vm.goToDevicesList = goToDevicesList
        vm.exportVehicleDetailsAsCSV = exportVehicleDetailsAsCSV
        vm.exportTripsListAsCSV = exportTripsListAsCSV
        vm.getVehicleShortAddress = VehicleUtility.getVehicleShortAddress
        vm.getVehicleExternalStatuses = VehicleUtility.getVehicleExternalStatuses
        vm.openDocument = openDocument
        vm.getTimeRangeVehicleStatusLogs = getTimeRangeVehicleStatusLogs
        vm.selectThisDamageReport = selectThisDamageReport
        vm.selectDamageReportImage = selectDamageReportImage
        vm.checkBookingStatusAndGetDescription = checkBookingStatusAndGetDescription
        vm.getDeviceTypeDescription = DeviceUtility.getDeviceTypeDescription
        vm.getCurrencySymbol = MiscUtility.getCurrencyValue
        vm.getVehicleBatteryPercentageIcon = getVehicleBatteryPercentageIcon

        vm.imageFilesAdded = imageFilesAdded;
        vm.imageFilesSubmitted = imageFilesSubmitted;
        vm.imageFileSuccess = imageFileSuccess;
        vm.imageFileError = imageFileError;
        vm.imageFileUploadComplete = imageFileUploadComplete;

        vm.documentFilesAdded = documentFilesAdded;
        vm.documentFilesSubmitted = documentFilesSubmitted;
        vm.uploadDocumentFiles = uploadDocumentFiles;
        vm.documentFileSuccess = documentFileSuccess;
        vm.documentFileError = documentFileError;
        vm.documentFileUploadComplete = documentFileUploadComplete;

        vm.deleteVehicleImage = deleteVehicleImage;
        vm.selectVehicleDocument = selectVehicleDocument;
        vm.modifyVehicleDocument = modifyVehicleDocument;
        vm.callDeleteVehicleDocumentDialog = callDeleteVehicleDocumentDialog;
        // vm.callVehicleTestActionConfirmDialog = callVehicleTestActionConfirmDialog;

        // vm.bookCommand = genericVehicleCommand(VehicleSharingAdapter.bookCommand);
        // vm.firstUnlockCommand = genericVehicleCommand(VehicleSharingAdapter.firstUnlockCommand);
        vm.unlockCommand = genericVehicleCommand(VehicleSharingAdapter.unlockCommand);
        // vm.enableEngineCommand = genericVehicleCommand(VehicleSharingAdapter.enableEngineCommand);
        // vm.disableEngineCommand = genericVehicleCommand(VehicleSharingAdapter.disableEngineCommand);
        // vm.parkCommand = genericVehicleCommand(VehicleSharingAdapter.parkCommand);
        vm.lockCommand = genericVehicleCommand(VehicleSharingAdapter.lockCommand);
        vm.leaveCommand = genericVehicleCommand(VehicleSharingAdapter.leaveCommand);
        vm.locateCommand = genericVehicleCommand(VehicleSharingAdapter.locateCommand);
        vm.getVehicleAdditionalActions = getVehicleAdditionalActions
        vm.executeVehicleAdditionalAction = executeVehicleAdditionalAction
        vm.startCarCommand = genericVehicleCommand(VehicleSharingAdapter.startCarCommand)
        vm.stopCarCommand = genericVehicleCommand(VehicleSharingAdapter.stopCarCommand)
        vm.extractData = extractData
        
        vm.onCommand = genericVehicleCommand(VehicleSharingAdapter.onCommand);
        vm.offCommand = genericVehicleCommand(VehicleSharingAdapter.offCommand);
        vm.closeTrunkCommand = genericVehicleCommand(VehicleSharingAdapter.closeTrunkCommand);
        vm.startScooterCommand = genericVehicleCommand(VehicleSharingAdapter.startScooterCommand);
        vm.stopScooterCommand = genericVehicleCommand(VehicleSharingAdapter.stopScooterCommand);
        // vm.endCommand = genericVehicleCommand(VehicleSharingAdapter.endCommand);
        vm.openSaddleCommand = genericVehicleCommand(VehicleSharingAdapter.openSaddleCommand);
        vm.openTrunkCommand = genericVehicleCommand(VehicleSharingAdapter.openTrunkCommand);
        vm.locateScooterCommand = genericVehicleCommand(VehicleSharingAdapter.locateScooterCommand);
        
        vm.onKickCommand = genericVehicleCommand(VehicleSharingAdapter.onKickCommand);
        vm.offKickCommand = genericVehicleCommand(VehicleSharingAdapter.offKickCommand);
        vm.startKickCommand = genericVehicleCommand(VehicleSharingAdapter.startKickCommand);
        vm.stopKickCommand = genericVehicleCommand(VehicleSharingAdapter.stopKickCommand);
        vm.endKickCommand = genericVehicleCommand(VehicleSharingAdapter.endKickCommand);
        vm.locateKickCommand = genericVehicleCommand(VehicleSharingAdapter.locateKickCommand);
        vm.unlockKickBatteryCompartmentCommand = genericVehicleCommand(VehicleSharingAdapter.unlockKickBatteryCompartmentCommand)
        vm.unlockKickCableLockCommand = genericVehicleCommand(VehicleSharingAdapter.unlockKickCableLockCommand)
        
        // vm.tootSegwayKickCommand = genericVehicleCommand(VehicleSharingAdapter.tootSegwayKickCommand)
        vm.disableAlarmSegwayKickCommand = genericVehicleCommand(VehicleSharingAdapter.disableAlarmSegwayKickCommand)
        vm.enableAlarmSegwayKickCommand = genericVehicleCommand(VehicleSharingAdapter.enableAlarmSegwayKickCommand)
        
        vm.startBikeCommand = genericVehicleCommand(VehicleSharingAdapter.startBikeCommand)
        vm.stopBikeCommand = genericVehicleCommand(VehicleSharingAdapter.stopBikeCommand)
        vm.locateBikeCommand = genericVehicleCommand(VehicleSharingAdapter.locateBikeCommand);

        vm.unlockBatteryCompartmentOkaiCommand = genericVehicleCommand(VehicleSharingAdapter.unlockBatteryCompartmentOkaiCommand)
        vm.lockBatteryCompartmentOkaiCommand = genericVehicleCommand(VehicleSharingAdapter.lockBatteryCompartmentOkaiCommand)
        
        vm.enableBikeLock = genericVehicleCommand(VehicleSharingAdapter.enableBikeLock)
        
        vm.startTrip = startTrip
        vm.stopTrip = stopTrip
        vm.toggleVehicleAvailability = toggleVehicleAvailability

        vm.getVehicleIcon = function(vehicle){

            if(!vehicle){
                return
            }
            var path = ""
            switch(vehicle.type){
                case vm.vehicleTypes.CAR.value:
                    path= 'assets/icons/icon-car.svg'
                    break
                case vm.vehicleTypes.SCOOTER.value:
                    path= 'assets/icons/icon-scooter.svg'
                    break
                case vm.vehicleTypes.KICK_SCOOTER.value:
                    path= 'assets/icons/icon-kick.svg'
                    break
                case vm.vehicleTypes.BIKE.value:
                    path= 'assets/icons/icon-bike.svg'
                    break
                default:
                    path = 'assets/icons/icon-car.svg'
            }

            return path
        }

        vm.triggerEasterEgg = function(){
            userClicks++
            
            if(userClicks >= 3 && !vm.showEasterEgg){
                vm.showEasterEgg = true
            }
        }

        //////////

        //Files added callback,used for validation,triggers when files are added before send it to the upload queue

        function imageFilesAdded(files) {
            console.log("files added",files);

            //reset errors and files to upload
            vm.uploadErrors = 0;
            vm.ngFlowImageFile.flow.files = [];

        };

        //File submit callback,triggers the files added to the upload queue
        function imageFilesSubmitted() {

            if(vm.vehicle.images.length>0){
                var index = 0;

                deleteVehicleImageWithCallback(vm.vehicle.images[0].id,index,
                    function success() {

                    console.log("start upload",vm.ngFlowImageFile.flow.files);

                        vm.uploadStatus = "Upload started!";
                        vm.ngFlowImageFile.flow.upload()
                })
            }
            else {
                console.log("start upload",vm.ngFlowImageFile.flow.files);

                vm.uploadStatus = "Upload started!";
                vm.ngFlowImageFile.flow.upload()
            }
        };

        //File upload success callback,triggers when single upload completed

        function imageFileSuccess(file,serverResponse) {

            var serverResponse = JSON.parse(serverResponse);
            var vehicleImage = serverResponse.data;

            console.log("image file success",file,"image",vehicleImage);

            //add image locally
            vm.vehicle.images.push(vehicleImage);
        };

        //An error occurred during upload of a specific file.
        function imageFileError(file,serverResponse) {

            console.log("image file error",file,serverResponse);

            vm.uploadErrors+1;
        }

        //Upload complete
        function imageFileUploadComplete() {

            console.log("upload complete");

            if(vm.uploadErrors == 0){
                vm.uploadStatus = "Upload completed!"
                vm.ngFlowImageFile.flow.files = [];
            }
            else {
                vm.uploadStatus = "An error has occurred while uploading,check file size!"
            }
        };

        //Files added callback,used for validation,triggers when files are added before send it to the upload queue

        function documentFilesAdded(files) {
            console.log("files added",files);

            //reset errors and files to upload
            vm.uploadErrors = 0;
            vm.ngFlowDocumentFile.flow.files = [];
            vm.currentVehicleDocuments = [];
            vm.showProgress = false;
            vm.isDocumentTypeInputInvalid = false;
            vm.isDocumentDescriptionInputInvalid = false;

        };

        //File submit callback,triggers the files added to the upload queue
        function documentFilesSubmitted() {

        };

        function uploadDocumentFiles() {

            vm.ngFlowDocumentFile.flow.files.forEach(function (flowFile) {

                console.log(flowFile)

                if(!flowFile.vehicleDocumentDescription || flowFile.vehicleDocumentDescription == ""){

                    vm.isDocumentDescriptionInputInvalid = true;
                }

                if(!flowFile.vehicleDocumentType || flowFile.vehicleDocumentType == ""){
                    vm.isDocumentTypeInputInvalid = true;
                }
            })

            if(!vm.isDocumentDescriptionInputInvalid &&  !vm.isDocumentTypeInputInvalid){



            }
            else {
                console.log("input invalid",vm.ngFlowDocumentFile.flow.files)
            }

            console.log("start upload",vm.ngFlowDocumentFile.flow.files);

            vm.uploadStatus = "Upload started!";//keep in mind the ng show for progress in view

            vm.showProgress = true;

            vm.ngFlowDocumentFile.flow.upload()

        };

        //File upload success callback,triggers when single upload completed

        function documentFileSuccess(file,serverResponse) {

            var serverResponse = JSON.parse(serverResponse);
            var vehicleDocument = serverResponse.data;

            console.log("document file success",file,"document",vehicleDocument);

            //add image locally
            vm.vehicle.documents.push(vehicleDocument);
        };

        //An error occurred during upload of a specific file.
        function documentFileError(file,serverResponse) {

            console.log("document file error",file,serverResponse);

            vm.uploadErrors+1;
        }

        //Upload complete
        function documentFileUploadComplete() {

            console.log("upload complete")

            if(vm.uploadErrors == 0){
                vm.uploadStatus = "Upload completed!"
                vm.ngFlowDocumentFile.flow.files = [];
            }
            else {
                vm.uploadStatus = "An error has occurred while uploading,check file size!"
            }
        };

        function deleteVehicleImage(imageId,index) {

            if(vehicleId && imageId){

                VehicleSharingAdapter.deleteImage(vehicleId,imageId,
                    function (response,error) {

                        if(error){
                            ErrorUtility.showErrorMessage({title:'Delete Vehicle Image',description:'Error while deleting the image'})

                        }else{
                            SweetAlert.swal("Delete Vehicle Image","Image deleted!","success")
                            vm.vehicle.images.splice(index,1)
                        }
                })
            }
            else{
                console.log("deleteVehicleImage: vehicleId && imageId is false",vehicleId,imageId)
            }
        };

        function deleteVehicleImageWithCallback(imageId,index,callback) {

            if(vehicleId && imageId){

                VehicleSharingAdapter.deleteImage(vehicleId,imageId,
                    function (response,error) {
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Delete Vehicle Image',description:'Error while deleting the image'})
                        }else{
                            vm.vehicle.images.splice(index,1)
                            callback()
                        }
                    })
            }
            else{
                console.log("deleteVehicleImage: vehicleId && imageId is false",vehicleId,imageId)
            }
        }

        function selectVehicleDocument($mdOpenMenu,vehicleDocument) {

            $mdOpenMenu();

            vm.selectedVehicleDocument = vehicleDocument;
        };

        function modifyVehicleDocument(vehicleDocument) {

            if(vehicleId && vehicleDocument){

                VehicleSharingAdapter.modifyDocument(vehicleId,vehicleDocument,
                    function (document,error) {

                        if(error){
                            vehicleDocument = angular.copy(vm.selectedVehicleDocument);
                            ErrorUtility.showErrorMessage({title:'Update Vehicle Document',description:'Error while updating the document'})
                        }
                        else {
                            SweetAlert.swal("Update Vehicle Document","Document updated!","success")
                        }
                    })
            }
            else{
                console.log("modifyVehicleDocument: vehicleId && imageId is false",vehicleId,docId)
            }

            vm.selectedVehicleDocument = null;
        }

        function deleteVehicleDocument(docId,index) {

            if(vehicleId && docId){

                VehicleSharingAdapter.deleteDocument(vehicleId,docId,
                    function (response,error) {

                        if(error){
                            ErrorUtility.showErrorMessage({title:'Delete Vehicle Document',description:'Error while deleting the document'})
                        }else{
                            SweetAlert.swal("Delete Vehicle Document","Document deleted!","success")
                            vm.vehicle.documents.splice(index,1)
                        }
                    })
            }
            else{
                console.log("deleteVehicleDocument: vehicleId && imageId is false",vehicleId,docId)
            }

            vm.selectedVehicleDocument = null;
        }

        var vehicleBeforeChanges = {}

        function enableVehicleDetailsChange() {
            if(vm.timezone === null || vm.timezone === undefined) {
                ErrorUtility.showErrorMessage({ title:'Edit Vehicle', description:'Vehicle editing is not available if vehicle\'s registration site is not selected' })
                return;
            }
            vm.disableEditVehicleDetails = !vm.disableEditVehicleDetails;
            vehicleBeforeChanges = angular.copy(vm.vehicle);
        }

        function disableVehicleDetailsChange() {
            vm.disableEditVehicleDetails = !vm.disableEditVehicleDetails;
            vm.vehicle = vehicleBeforeChanges;
        }

        function focusOnImagesTab() {
            vm.selectedTab = vm.tabs.IMAGES;
            $location.hash("vehicle-details-tabs");
            $anchorScroll();
        }

        /**
         * Add new contact
         */
        // function callAddVehicle() {

        //     console.log("vehicle to send",vm.vehicle);

        //     VehicleSharingAdapter.addVehicle({
        //          license_plate: vm.vehicle.license_plate,
        //          category_rent: {
        //             id : vm.vehicle.category_rent.id
        //          },
        //          type: vm.vehicle.type,
        //          model_name: vm.vehicle.model_name,
        //          brand: vm.vehicle.brand,
        //          version: vm.vehicle.version,
        //          cylinder_capacity: vm.vehicle.cylinder_capacity,
        //          km: vm.vehicle.km,
        //          registration_date: vm.vehicle.registration_date,
        //          battery: {
        //              code: vm.vehicle.battery.code,
        //              ah_tot: vm.vehicle.battery.ah_tot
        //          },
        //          fuels: vm.vehicle.fuels
        //         },
        //         function (newVehicle, error){

        //             console.log("add newVehicle",vm.vehicle);

        //             if (!error){

        //                 //add new user in first position
        //                 vm.vehicles.unshift(newVehicle);

        //             }else{
        //                 SweetAlert.swal("Add new vehicle", error.description, "error");
        //             }
        //         })
        // }

        /**
         * Save contact
         */
        function callUpdateVehicle() {

            console.log("vehicle to update",vm.vehicle);

            var vehicleBefore = angular.copy(vm.vehicle);

            var registrationDate = MiscUtility.shiftJstoMoment(vm.vehicle.registration_date, vm.vehicle.SiteId)

            // if there is no SiteId, shiftJstoMoment() returns null
            if(registrationDate === null) {
                ErrorUtility.showErrorMessage({title:'Update Vehicle details',description:'Error loading the timezone from this vehicle. ' + vm.vehicle.Site})
                return;
            }

            VehicleUtility.generateVehicleExtraInfo(vm.vehicle)

            VehicleSharingAdapter.updateVehicle(vehicleId, {
                license_plate: vm.vehicle.license_plate,
                reference_code: vm.vehicle.reference_code,
                model_name: vm.vehicle.model_name,
                brand: vm.vehicle.brand,
                version: vm.vehicle.version,
                cylinder_capacity: vm.vehicle.cylinder_capacity,
                km: vm.vehicle.km,
                registration_date: registrationDate.toISOString(), 
                battery: {
                    id: vm.vehicle.battery.id,
                    code: vm.vehicle.battery.code,
                    ah_tot: vm.vehicle.battery.ah_tot
                },
                fuels: vm.vehicle.fuels,
                SiteId: vm.vehicle.SiteId,
                extraInfo: vm.vehicle.extraInfo ? vm.vehicle.extraInfo : {}
            }, function (update, error){

                if (error){
                    vm.vehicle = vehicleBefore;
                    ErrorUtility.showErrorMessage({title:'Update Vehicle details',description:'Error while updating the vehicle details'})
                }else{
                    vm.disableEditVehicleDetails = true
                    SweetAlert.swal('Update Vehicle details', 'Succesfully updated!', 'success')
                }
            })
        }

        function callDeleteVehicle() {

            if(vehicleId){

                VehicleSharingAdapter.deleteVehicle(vehicleId,
                    function (data,error) {
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Delete Vehicle',description:'Error while deleting the vehicle'})
                        }
                        else {
                            $state.go(VehiclesListPage);
                        }
                })
            }

        }

        function callDeleteVehicleConfirmDialog(ev) {

            deleteVehicleConfirm(ev)
                .then(
                    function ok() {
                        callDeleteVehicle()
                    },
                    function close() {

                    }
                )
        }

        function deleteVehicleConfirm(ev) {

            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this vehicle?')
                .htmlContent('<b>' + 'Model: '+vm.vehicle.model_name + ', Plate: ' + vm.vehicle.license_plate + '</b>' + ' will be deleted.')
                .ariaLabel('delete vehicle')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            return $mdDialog.show(confirm);
        }

        function deleteDocumentConfirmDialog(document,ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this document?')
                .htmlContent('Document with name '+'<b>' + 'Name: '+document.name +'</b>' + ' will be deleted.')
                .ariaLabel('delete docuemnt')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            return $mdDialog.show(confirm);
        }

        function callDeleteVehicleDocumentDialog(document,index,ev) {
            deleteDocumentConfirmDialog(document,ev)
                .then(
                    function ok() {
                        deleteVehicleDocument(document.id,index)
                    }
                )
        }

        function callVehicleTestActionConfirmDialog(ev){
            DialogFactory.confirm("Test this vehicle","Are you sure you want to test this vehicle?",ev).then(
                function ok(){
                    VehicleDialogFactory.showTestAction(ev,vm.vehicle)
                }
            )
        }

        function refreshVehicle() {

            if(vehicleId){
                VehicleSharingAdapter.getVehicle(vehicleId,
                    function (vehicle,error) {
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Get Vehicle details',description:'Error while getting the vehicle details'})
                            goToVehicles();
                        }
                        else {
                            vm.vehicle = vehicle
                            getVehicleTrips(vehicle.id)
                            refreshServiceSettings()
                            generateVehicleBatteryVoltage(vehicle)
                            vm.onVehiclesRefresh([vehicle])
                        }
                })

                getRelatedData(vehicleId)
            }
        }

        function getVehicleTrips(vehicleId){
            // var filterParam = FiltersRequestParamFactory.createAFilterRequestParam(
            //     FiltersRequestParamFactory.createAnAndFilter([ 
            //         FiltersRequestParamFactory.createTripWithVehicleIdFilter(vehicleId)
            //     ])
            // );

            var paginationFilterRequestParam = {
                limit: 3,
                offset: 0,
                order: [[ OrderRequestParamFactory.orderByTripId('DESC') ]],
            }

            // var params = FiltersRequestParamFactory.mergeObjects(
            //     filterParam,
            //     paginationFilterRequestParam
            // );

            TripsAdapter.getVehicleTrips(vehicleId, paginationFilterRequestParam, function(trips, error){
                if(error){
                    ErrorUtility.showErrorMessage({title:'Get Vehicle Trips List',description:'Error while getting the vehicle trips list'})
                }else{
                    vm.vehicleTotalTrips = trips.data
                    vm.totalVehicleTrips = trips.count;
                    // trips.forEach(function (trip) {
                    //     trip.duration = TripUtility.calculateTripDuration(trip)
                    // })
                    vm.vehicle.trips = trips.data
                }
            })
        }

        function getLastDayVehicleStatusLogs(vehicleId){
            if(vehicleId){
                vm.vehicleStatusLogs = []

                LogAdapter.getLastDayVehicleStatusLogs(vehicleId,
                    function(data,error){
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Get Vehicle Status Logs',description:'Error while getting the vehicle status logs list'})
                        }else{
                            vm.vehicleStatusLogs = data
                        }
                    })
            }
        }

        function getTimeRangeVehicleStatusLogs(callback){

            var start = vm.logFilter.start && MiscUtility.shiftJstoMoment(vm.logFilter.start,vm.vehicle.SiteId)
            var end = vm.logFilter.end && MiscUtility.shiftJstoMoment(vm.logFilter.end,vm.vehicle.SiteId)
            
            if(start === null || end === null){
                SweetAlert.swal('Get Vehicle Status Logs','Timezone not available!','error')
                return
            }
            
            start = start.startOf('day').valueOf()
            end = end.endOf('day').valueOf()

            vm.isLoading = true
            vm.vehicleStatusLogs = []
            
            LogAdapter.getTimeRangeVehicleStatusLogs(vehicleId,
                {
                    start: start,
                    end: end
                },
                function(data,error){
                    vm.isLoading = false
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Get Vehicle Status Logs',description:'Error while getting the vehicle status logs list'})
                    }else{
                        //console.log(data)
                        vm.vehicleStatusLogs = data
                        if(callback) callback(data)
                    }  
                }
            )
        }

        function updateTableDamagesData(callback){
            getDamages(vm.vehicle.id, callback)
        }

        function getDamages(vehicleId, callback){
            if (vehicleId){
                // vm.vehicleDamagesReports = []
                vm.currentDamageReport = {}
                
                VehicleSharingAdapter.getDamages(vehicleId,
                    function(data,error){
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Get Damages Reports List',description:'Error while getting the vehicle reports list'})
                        }else{
                            vm.vehicleDamagesReports = data
                            // getExpenses()
                            if(callback) callback(vm.vehicleDamagesReports)
                        }
                })
            }
        }

        // function getExpenses(){
        //     ExpensesAdapter.getExpenses(
        //         function(data,error){
        //             if(!error){
        //                 vm.expenses = data

        //                 //fill description in each part
        //                 vm.vehicleDamagesReports.forEach(function(damageReport){
                            
        //                     var otherDamageHuman = "" 
        //                     damageReport.other_damage.forEach(function(label){
        //                         if(otherDamageHuman == "")
        //                             otherDamageHuman = label
        //                         else
        //                             otherDamageHuman+=","+label
        //                     })
        //                     damageReport.other_damage_human = otherDamageHuman

        //                     damageReport.parts.forEach(function(part){
        //                         part.description = getDamagePartDescription(part)
        //                     })
        //                 })
        //                 //open firt report
        //                 if(vm.vehicleDamagesReports.length>0)
        //                     selectThisDamageReport(vm.vehicleDamagesReports[0])
        //             }
        //         })
        // }

                
        function getRelatedData(vehicleId){
            // getLastDayVehicleStatusLogs(vehicleId)
            // getDamages(vehicleId)
            if (
                vm.vehicle.type == VehicleTypes.CAR.value
                || vm.vehicle.type == VehicleTypes.BIKE.value 
                || vm.vehicle.type == VehicleTypes.SCOOTER.value
            ) {
                getVehicleAdditionalActions();
            }
        }

        function selectThisDamageReport(report,ev){
            // vm.currentDamageReport = report
            // selectDamageReportImage(0)

            // function selectThisDamageReport(report,ev){
            // console.log(report)
            // }
            DamageReportDialogFactory.showDetails(ev,report)
        }

        function selectDamageReportImage(index){
            vm.selectedDamageReportImage = {number:0,location:""}
            if(vm.currentDamageReport.media.length>0){
                vm.selectedDamageReportImage.number = index
                vm.selectedDamageReportImage.location = vm.currentDamageReport.media[index].location
            }
        }

        function getDamagePartDescription(part){
            var descr=""

            vm.expenses.forEach(function(exp){
                if(exp.id == part.code){
                    descr = exp.name
                }
            })
            return descr
        }

        function checkBookingStatusAndGetDescription(vehicle){
            var descr = ""
            if(VehicleUtility.hasVehicleACurrentBooking(vehicle))
                descr = 'Currently used by:'
            else{
                descr = 'Last used by:'
            }
            return descr
        }

        function goToVehicles() {
            $state.go(VehiclesListPage)
        }

        function goToTripsWithFilter() {
            $state.go(TripsListPage,{searchFor: {filterKey: 'tripVehicleLicensePlate', value: vm.vehicle.license_plate}})
        }

        function goToDevicesList(device){
            if(device){
                $state.go(DevicesListPage,{searchFor: {filterKey: "deviceId", value: device.id}})
            }
        }
        
        function checkInput() {
            
        }

        function openDocument(document) {
            window.open(document.location);
        }

        function exportVehicleDetailsAsCSV() {
            var valuesToWrite = []
            var outputArray = []
            var outputString = ""
            const semicolonString=";"
            const endLineString="\n"

            var siteName = SitesService.getSiteName(vm.vehicle.SiteId);

            //header
            outputString+="Ref. Code"+semicolonString+"Vehicle id"+semicolonString+"Vehicle brand"+semicolonString+"Vehicle type"+semicolonString
                +"Vehicle version"+semicolonString+"License plate"+semicolonString+"Online"+semicolonString
                +"Street"+semicolonString+"City"+semicolonString+"Current/Last user"+semicolonString+"Fuel level"+semicolonString
                +"Status"+semicolonString+"State"+semicolonString+"Last moved"+semicolonString+"Total kms"+semicolonString
                +"Registration Date"+semicolonString+"Device Provider"+semicolonString+"Device id"+endLineString

            outputString += vm.vehicle.reference_code + semicolonString
            outputString += vm.vehicle.id + semicolonString
            outputString += vm.vehicle.brand + semicolonString
            outputString += vm.vehicle.model_name + semicolonString
            outputString += vm.vehicle.version + semicolonString
            outputString += vm.vehicle.license_plate + semicolonString
            outputString += (vm.vehicle.online ? 'yes' : 'no') + semicolonString
            outputString += (vm.vehicle.address ? vm.vehicle.address : '') + semicolonString
            outputString += (siteName ? siteName : '') + semicolonString
            outputString += (vm.hasVehicleACurrentBooking(vm.vehicle) ? vm.vehicle.currentUser : vm.vehicle.lastUser) + semicolonString
            outputString += vm.vehicle.total_percentage + semicolonString
            outputString += (vm.getVehicleExternalStatuses(vm.vehicle)) + semicolonString
            outputString += vm.vehicle.status + semicolonString
            outputString += (vm.vehicle.last_moved ? vm.vehicle.last_moved : 'Never moved') + semicolonString
            outputString += numberFilter(vm.vehicle.km, 0) + semicolonString
            outputString += toDateFilter(vm.vehicle.registration_date,"dateTime",vm.vehicle.SiteId) + semicolonString
            outputString += vm.vehicle.deviceTypeHuman + semicolonString
            outputString += (vm.vehicle.deviceType == DeviceType.PERSONAL.value ? vm.vehicle.core_board ? vm.vehicle.core_board.id : "No device" : vm.vehicle.deviceId)
            outputString += endLineString
            outputArray.push(outputString)

            GenerateCSVService.generate(outputArray)
        }

        function exportTripsListAsCSV() {
            var outputArray = []
            var outputString = ""
            const semicolonString=";"
            const endLineString="\n"
            // const priceString = "€ "
            const minString = " min"
            const kmString = " km"

            //header
            outputString+="Vehicle id"+semicolonString+"Trip id"+semicolonString+"From"+semicolonString+"Start"+semicolonString
                +"To"+semicolonString+"End"+semicolonString+"Duration"+semicolonString
                +"Currency Symbol"+semicolonString+"Price"+endLineString
            outputArray.push(outputString)

            vm.vehicleTotalTrips.forEach(function (trip) {
                outputString = vm.vehicle.id + semicolonString
                outputString += trip.id + semicolonString
                outputString += trip.StartPosition.address + semicolonString
                outputString += toDateFilter(trip.start,"dd/MM/yyyy HH:mm", vm.vehicle.SiteId) + semicolonString
                outputString += trip.FinishPosition.address + semicolonString
                outputString += toDateFilter(trip.end,"dd/MM/yyyy HH:mm", vm.vehicle.SiteId) + semicolonString
                outputString += (trip.FinishPosition ? (trip.duration + minString) : "Not finished") + semicolonString
                outputString += ServiceSettings.getCurrencySymbol (trip.SiteId) + semicolonString
                outputString += (trip.Booking ? numberFilter(trip.Booking.price,2) : "")
                outputString += endLineString
                outputArray.push(outputString)
            })

            GenerateCSVService.generate(outputArray)
        }

        function genericVehicleCommand(adapterFN){

            return  function () {

                return (adapterFN.bind(VehicleSharingAdapter))( vehicleId, function (response, error) {
                    if (error){
                        if(error.type == "unsupported_action"){
                            ErrorUtility.showErrorMessage({title:'Error send command', description:'The vehicle doesn\'t support this action!'})
                        }else{
                            ErrorUtility.showErrorMessage({title:'Error send command', description:'The command hasn\'t been sent!'})
                        }
                    }else if ((response.send !== undefined && !response.send) || (response.success !== undefined && !response.success)){ //response.success for direct segway command
                        if(adapterFN === VehicleSharingAdapter.stopCarCommand || adapterFN === VehicleSharingAdapter.stopScooterCommand || adapterFN === VehicleSharingAdapter.stopKickCommand || adapterFN === VehicleSharingAdapter.stopBikeCommand){
                            ErrorUtility.showErrorMessage({title:'Error send command', description:'Error during the execution of the command, the trip was closed but the vehicle could be on!. Please check physical status or try it again!'})
                        }else{
                            ErrorUtility.showErrorMessage({title:'Error send command', description:'Error during the execution of the command, please check the vehicle status locally!'})
                        }
                    }else{
                        if(adapterFN === VehicleSharingAdapter.locateCommand || adapterFN === VehicleSharingAdapter.locateScooterCommand || adapterFN === VehicleSharingAdapter.locateKickCommand || adapterFN === VehicleSharingAdapter.locateBikeCommand){
                            VehicleDialogFactory.showTootGif()
                        }else{
                            SweetAlert.swal("Success send command", "The command was correctly performed!", "success")
                        }
                    }
                })
            }
        }

        function startTrip() {
            return TripsAdapter.startTrip(
                {
                    vehicle: vm.vehicle.id,
                    name: ''
                },function (response,error) {

                    if(error){
                        ErrorUtility.showErrorMessage({title:'Error start trip',description: 'Error while starting the vehicle trip'})
                    }
                    else {
                        // console.log("startTrip resp",response)
                    }
                })
        }

        function stopTrip() {
            return TripsAdapter.stopTrip(
                {
                    vehicle: vm.vehicle.id

                },function (response,error) {

                    if(error){
                        ErrorUtility.showErrorMessage({title:'Error stop trip',description: 'Error while stopping the vehicle trip'})
                    }
                    else {
                        // console.log("stopTrip resp",response)
                    }
                })
        }

        function extractData(deviceId) {
            return DeviceAdapter.extractData(deviceId, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({ title: 'Error send command', description: 'The command hasn\'t been sent!' })
                } else {
                    SweetAlert.swal("Success send command", "The command was correctly sent! Please wait a few moments until the car will send the updated data, then refresh the page", "success")
                }
            })
        }

        function toggleVehicleAvailability(ev){

            var deferred = $q.defer()

            if(vm.vehicle && vehicleId){
                                
                const isVehicleUnavailable = vm.vehicle.status == VehicleStatus.UNAVAILABLE.value
                const actionType = isVehicleUnavailable ? "available" : "unavailable"
                
                DialogFactory.confirm(
                    "Make this vehicle "+actionType,
                    "Are you sure you want to make "+actionType+" this vehicle?",
                    ev
                ).then(
                        function ok(){
                            if(vm.vehicle.status == VehicleStatus.FREE.value){
                                VehicleSharingAdapter.makeUnavailable(vehicleId,
                                    function(data,error){
                                        if(error){
                                            deferred.reject(error)
                                            ErrorUtility.showErrorMessage({title:'Error send command',description:'The command hasn\'t been sent'})
                                        }
                                        else{
                                            deferred.resolve(data)
                                            vm.vehicle.status = VehicleStatus.UNAVAILABLE.value
                                            SweetAlert.swal("Now the vehicle is unavailable!", "", "success");
                                        }
                                    })
                            }
                            else if ( vm.vehicle.status == VehicleStatus.UNAVAILABLE.value){
                                VehicleSharingAdapter.makeAvailable(vehicleId,
                                    function(data,error){
                                        if(error){
                                            deferred.reject(error)
                                            ErrorUtility.showErrorMessage({title:'Error send command',description:'The command hasn\'t been sent'})
                                        }
                                        else{
                                            deferred.resolve(data)
                                            vm.vehicle.status = VehicleStatus.FREE.value
                                            SweetAlert.swal("Now the vehicle is available!", "", "success");
                                        }
                                    })
                            }
                            else{
                                deferred.reject("This vehicle is not in free status")
                                ErrorUtility.showErrorMessage({title:'Error send command',description:'This vehicle is not in free status'})
                            }
                        },function cancel(){
                            deferred.reject("canceled")
                        }
                )
            }

            return deferred.promise
        }

        function getVehicleAdditionalActions(){
            
            if(!vm.vehicle){
                console.warn("getVehicleAdditionalActions: invalid vehicle",vm.vehicle)
                return
            }
            
            VehicleSharingAdapter.getVehicleAdditionalActions(vm.vehicle.id, function(additionalActions,error){
                if(error){
                }else{
                    vm.vehicleAdditionalActions = []

                    for(var additionalName in additionalActions){
                        var actions = additionalActions[additionalName]
                        for(var index in actions){
                            vm.vehicleAdditionalActions.push({completeName: (additionalName + " " + actions[index]).replace(/_/g," "), name: additionalName, action: actions[index]})
                        }
                    }
                }
            })
        }

        function executeVehicleAdditionalAction(additional, action){
            
            if(!additional || !action){
                console.warn("executeVehicleAdditionalAction: invalid additional or action",additional,action)
                return
            }

            return VehicleSharingAdapter.executeVehicleAdditionalAction(vm.vehicle.id, additional, action, function(response,error){
                if (error){
                    ErrorUtility.showErrorMessage({title:'Error send additional action',description:'The action hasn\'t been sent'})
                }else if ((response.send!==undefined && !response.send)){
                    ErrorUtility.showErrorMessage({title:'Error send additional action',description:'Vehicle is not online'})
                }else{
                    SweetAlert.swal("Success send additional action", "", "success")
                }
            })
        }

        function getVehicleBatteryPercentageIcon(level) {
            if (level == 0) {
                return "icon-battery-outline"
            }
            if (level == 100) {
                return "icon-battery"
            }
            return 'icon-battery-' + (Math.floor(level / 10)) + '0'
        }

        function generateVehicleBatteryVoltage(vehicle) {
            
            if (!vehicle) {
                console.warn("generateVehicleBatteryVoltage: invalid input", vehicle)
                return
            }

            if (!vm.serviceName) {
                console.warn("generateVehicleBatteryVoltage: no service name")
                return
            }

            if (vm.serviceName === "movo") {
                return
            }
            else if (vm.vehicle.type == VehicleTypes.CAR.value) {
                vm.vehicleBattery.value = vm.vehicle.battery && toNumberFilter(vm.vehicle.battery.value_V, 2) || null
                vm.vehicleBattery.unit = "V"
                vm.vehicleBattery.description = "Service battery voltage"
            }
            else if (vm.serviceName === "govolt") {
                vm.vehicleBattery.value = vm.vehicle.battery && toNumberFilter(vm.vehicle.battery.percentage, 2) || null
                vm.vehicleBattery.unit = "V"
                vm.vehicleBattery.description = "Battery voltage"
            } else if (vm.serviceName === "ride") {
                vm.vehicleBattery.value = vm.vehicle.core_board && toNumberFilter(vm.vehicle.core_board.value_V, 2) || null
                vm.vehicleBattery.unit = "V"
                vm.vehicleBattery.description = "Device's battery voltage"
            } else if (vm.vehicle.extraInfo.noBatteryData === true) {
                vm.vehicleBattery.value = vm.vehicle.battery && toNumberFilter(vm.vehicle.battery.value_V / 100, 2) || null
                vm.vehicleBattery.unit = "V"
                vm.vehicleBattery.description = "Battery voltage"
            }
        }
    }
})();

/**
 * Created by alex on 03/01/17.
 */

(function () {
    'use strict';

    angular // this is for formatting
        .module('app.utility.adapter', [])
        .factory('AdapterUtility', AdapterUtility);

    /** @ngInject */
    function AdapterUtility($http, AppSettings) {
        // TODO support enableLogging based on a config depend only for testing purposes
        const enableLogging = true;

        function get(request, completionHandler) {
            var paramsQueryString = {};
            if (typeof request.params != 'undefined' && Object.keys(request.params).length > 0) {
                paramsQueryString = request.params;
            }

            return $http.get(AppSettings.getBaseUrl() + request.path, { params: paramsQueryString }).then(
                function success(response) {
                    var data = response.data.data;

                    if (enableLogging) console.log('success in ' + (request.callerName || 'AdapterUtility'), data);

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(data, null);
                    }
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in ' + (request.callerName || 'AdapterUtility'), error, response);

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(null, error);
                    }
                }
            );
        }

        function post(request, completionHandler) {
            if (!request.body) {
                console.warn('No request body in request', request);
                return;
            }

            return $http.post(AppSettings.getBaseUrl() + request.path, request.body).then(
                function success(response) {
                    var data = response.data.data;

                    if (enableLogging) console.log('success in ' + (request.callerName || 'AdapterUtility'), data);

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(data, null);
                    }
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in ' + (request.callerName || 'AdapterUtility'), error, response);

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(null, error);
                    }
                }
            );
        }

        return {
            get: get,
            post: post,
        };
    }
})();

/**
 * Created by alex on 03/01/17.
 */

(function(){

    'use strict';

    angular.module('app.utility.adapter')
        .factory('UserAdapter',UserAdapter)
        .factory('ReviewAdapter', ReviewAdapter);

    /** @ngInject */
    function UserAdapter($http,AppSettings,$q,EnrichDataUtility) {

        function getUsers(params,completionHandler) {
            var deferred = $q.defer(); // no disable for md-autocomplete

            var queryStringParams = {}
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            $http.get(AppSettings.getBaseUrl() + "/api/user",{params:queryStringParams}).then(
                function success(response) {
                    console.log("success in UserAdapter.getUsers");
                    var users = response.data.data
                    EnrichDataUtility.generateUserUsefulData(users.data ? users.data : users)
                    if(typeof completionHandler != "undefined")
                        completionHandler(users,null);

                    deferred.resolve(users)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.getUsers: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)
                });

            return deferred.promise;
        }

        function getUser(id, completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + id).then(
                function success(response) {

                    console.log("success in UserAdapter.getUser");
                    var user = response.data.data
                    EnrichDataUtility.generateUserUsefulData([user])
                    if(typeof completionHandler != "undefined")
                        completionHandler(user,null);

                    deferred.resolve(user);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.getUser: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)
                });

            return deferred.promise;
        }

        function getUserStatus(completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/user/status").then(
                function success(response) {

                    console.log("success in UserAdapter.getUserStatus");
                    var res = response.data.data;

                    if(typeof completionHandler != "undefined")
                        completionHandler(res,null);

                    deferred.resolve(res);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.getUserStatus: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)
                });

            return deferred.promise;
        }

        function getSpecificUserStatus(userId,completionHandler){

            $http.get(AppSettings.getBaseUrl() + "/api/user/"+userId+"/status").then(
                function success(response) {
                    console.log("success in UserAdapter.getSpecificUserStatus");

                    if(typeof completionHandler != "undefined")
                        completionHandler(response.data.data,null);

                },function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.getUserStatus: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                });
        }

        function addUser(data, completionHandler){
            var deferred = $q.defer();

            $http.post(AppSettings.getBaseUrl() + "/api/user", data).then(
                function success(response) {

                    console.log("success in UserAdapter.addUser");

                    if(typeof completionHandler != "undefined")
                        completionHandler(response.data.data,null);

                    deferred.resolve(response.data.data);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.addUser: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)
                });

            return deferred.promise;
        }

        function updateUser(user_id, data, completionHandler){
            
            $http.put(AppSettings.getBaseUrl() + "/api/user/"+ user_id, data).then(
                function success(response) {

                    console.log("success in UserAdapter.updateUser");

                    if(typeof completionHandler != "undefined")
                        completionHandler(response.data.data,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.updateUser: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                });
        }

        function deleteUser(userId, completionHandler){

            var deferred = $q.defer();

            $http.delete(AppSettings.getBaseUrl() + "/api/user/"+ userId).then(
                function success(response) {

                    console.log("success in UserAdapter.deleteUser");

                    if(typeof completionHandler != "undefined")
                        completionHandler(response.data.data,null);

                    deferred.resolve(response.data.data);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.deleteUser: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function addPayment(userId,payment,completionHandler) {

            var newPayment = {

                pan: payment.pan,
                cvc: payment.cvc,
                exp_month: payment.exp_month,
                exp_year: payment.exp_year
            };

            $http.post(AppSettings.getBaseUrl() + "/api/user/" + userId + "/payment",newPayment).then(
                function success(response) {

                    var paymentAdded = response.data.data;

                    console.log("success in UserAdapter.addPayment");

                    if(typeof completionHandler != "undefined")
                        completionHandler(paymentAdded,null);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.addPayment: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        function deletePayment(userId,paymentId,completionHandler) {

            $http.delete(AppSettings.getBaseUrl() + "/api/user/" + userId + "/payment/" + paymentId).then(
                function success(response) {

                    var deleted = response.data.data;

                    console.log("success in UserAdapter.deletePayment");

                    if(typeof completionHandler != "undefined")
                        completionHandler(deleted,null);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.deletePayment: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        function getPayments(userId,completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/user/"+ userId + "/payment").then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.getPayments");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                    return deferred.resolve(payments)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.getPayments: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    return deferred.reject(error);
                })

            return deferred.promise;
        }

        function getUserTransactions(id, params, completionHandler){
            var deferred = $q.defer();

            var queryStringParams = {}
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + id + "/transaction", {params:queryStringParams}).then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.getUserTransactions");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                    return deferred.resolve(payments)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.getUserTransactions: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    return deferred.reject(error);
                })

            return deferred.promise;
        }

        function getUserInvoices(id, params, completionHandler){
            var deferred = $q.defer();

            var queryStringParams = {}
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + id + "/invoice", {params: queryStringParams}).then(
                function success(response) {

                    var invoices = response.data.data;
                    EnrichDataUtility.generateInvoiceUsefulData(invoices.data ? invoices.data : invoices)
                    console.log("success in UserAdapter.getUserInvoices");

                    if(typeof completionHandler != "undefined")
                        completionHandler(invoices,null);

                    return deferred.resolve(invoices)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.getUserInvoices: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    return deferred.reject(error);
                })

            return deferred.promise;
        }

        function acceptUserLicense(userId, data, completionHandler){

            $http.post(AppSettings.getBaseUrl() + "/api/user/" + userId + "/license/accept", data).then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.acceptUserLicense");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.acceptUserLicense: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                })
        }

        function rejectUserLicense(userId, completionHandler){

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/license/reject").then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.rejectUserLicense");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.rejectUserLicense: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                })
        }

        function invalidateUserLicense(userId, completionHandler){

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/license/not/valid").then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.invalidateUserLicense");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.invalidateUserLicense: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                })
        }

        function acceptUserID(userId, completionHandler){

            $http.post(AppSettings.getBaseUrl() + "/api/user/" + userId + "/document/accept").then(
                function success(response) {

                    var data = response.data.data;

                    console.log("success in UserAdapter.acceptUserID");

                    if(typeof completionHandler != "undefined")
                        completionHandler(data,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.acceptUserID: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                })
        }

        function rejectUserID(userId, completionHandler){

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/document/reject").then(
                function success(response) {

                    var data = response.data.data;

                    console.log("success in UserAdapter.rejectUserID");

                    if(typeof completionHandler != "undefined")
                        completionHandler(data,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.rejectUserID: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                })
        }

        function invalidateUserID(userId, completionHandler){

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/document/not/valid").then(
                function success(response) {

                    var data = response.data.data;

                    console.log("success in UserAdapter.invalidateUserID");

                    if(typeof completionHandler != "undefined")
                        completionHandler(data,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.invalidateUserID: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                })
        }

        function resetUserPassword(userId, completionHandler){

            $http.put(AppSettings.getBaseUrl() + "/api/user/" + userId + "/password").then(
                function success(response) {

                    var response = response

                    console.log("success in UserAdapter.resetUserPassword");

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.resetUserPassword: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                })
        }

        function blockUser(userId, data, completionHandler){
            var deferred = $q.defer();

            $http.post(AppSettings.getBaseUrl() + "/api/user/" + userId + "/block", data).then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.blockUser");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                    return deferred.resolve(payments)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.blockUser: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    return deferred.reject(error);
                })

            return deferred.promise;
        }

        function unblockUser(userId, completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/unblock").then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.unblockUser");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                    return deferred.resolve(payments)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.unblockUser: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    return deferred.reject(error);
                })

            return deferred.promise;
        }

        function addRoleToUser(roleId, userId, completionHandler){
            var deferred = $q.defer();

            $http.put(AppSettings.getBaseUrl() + "/api/user/" + userId + "/role/" + roleId).then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.addRoleToUser");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                    return deferred.resolve(payments)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.addRoleToUser: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    return deferred.reject(error);
                })

            return deferred.promise;
        }

        function removeRoleFromUser(roleId, userId, completionHandler){
            var deferred = $q.defer();

            $http.delete(AppSettings.getBaseUrl() + "/api/user/" + userId + "/role/" + roleId).then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.removeRoleFromUser");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                    return deferred.resolve(payments)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.removeRoleFromUser: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    return deferred.reject(error);
                })

            return deferred.promise;
        }

        function getUserRoles(userId, completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/role").then(
                function success(response) {

                    var payments = response.data.data;

                    console.log("success in UserAdapter.getUserRoles");

                    if(typeof completionHandler != "undefined")
                        completionHandler(payments,null);

                    return deferred.resolve(payments)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.getUserRoles: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    return deferred.reject(error);
                })

            return deferred.promise;
        }

        function getReferredUser(userId, params, completionHandler) {

            var queryStringParams = {}
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/referral", {params: queryStringParams}).then(
                function success(response) {
                    
                    var responseData = response.data.data
                    var referredUsersData = responseData.data ? responseData.data : responseData
                    if(referredUsersData){
                        referredUsersData.forEach(function (referredData) {
                            if(referredData.User){
                                EnrichDataUtility.generateUserUsefulData([referredData.User])
                            }
                        })
                    }

                    console.log("success in UserAdapter.getReferredUser");

                    if(typeof completionHandler != "undefined")
                        completionHandler(responseData,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAdapter.getReferredUser: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                })
        }

        function retryTransaction(userId,transactionId,completionHandler){

            $http.post(AppSettings.getBaseUrl() + "/api/user/"+userId+"/transaction/"+transactionId+"/retry").then(
                function success(response){
                    var data = response.data.data
                    
                    console.log("success in UserAdapter.retryTransaction",data);

                    if(typeof completionHandler != "undefined")
                        completionHandler(data,null);

                },
                function error(error){
                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.retryTransaction: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error)
                }
            )
        }

        function blockAutomaticTransactionRetry(userId,transactionId,completionHandler){

            $http.post(AppSettings.getBaseUrl() + "/api/user/"+userId+"/transaction/"+transactionId+"/do/not/retry").then(
                function success(response){
                    var data = response.data.data
                    
                    console.log("success in UserAdapter.blockAutomaticTransactionRetry",data);

                    if(typeof completionHandler != "undefined")
                        completionHandler(data,null);

                },
                function error(error){
                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in UserAdapter.blockAutomaticTransactionRetry: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error)
                }
            )
        }

        function getCouponsLegacyHistory(userId, params, completionHandler){

            var queryStringParams = {}
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            $http.get(AppSettings.getBaseUrl() + '/api/user/' + userId + '/coupon', { params: queryStringParams }).then(
                function success(response) {
                    var data = response.data.data;

                    console.log('success in UserAdapter.getCouponsLegacyHistory');

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(data, null);
                    }
                },
                function error(error) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in UserAdapter.getCouponsLegacyHistory: ', error, response);

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(null, error);
                    }
                }
            );
        }

        function getCouponsHistory(userId,params,completionHandler){

            var queryStringParams = {};
            if (typeof params != 'undefined' && Object.keys(params).length > 0) {
                queryStringParams = params;
            }

            $http
                .get(AppSettings.getBaseUrl() + '/api/user/' + userId + '/bonus/coupon', { params: queryStringParams })
                .then(
                    function success(response) {
                        var data = response.data.data;

                        console.log('success in UserAdapter.getCouponsHistory');

                        if (typeof completionHandler != 'undefined') completionHandler(data, null);
                    },
                    function error(error) {
                        var error = response.data ? (response.data.error ? response.data.error : response) : response;

                        console.log('error in UserAdapter.getCouponsHistory: ', error, response);

                        if (typeof completionHandler != 'undefined') completionHandler(null, error);
                    }
                );
        }

        function getShopOrders(userId, params, completionHandler){

            if(typeof userId !== "number"){
                console.log("error in UserAdapter.getShopOrders: no params", userId)
                return
            }

            var queryStringParams = {}
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/order", { params: queryStringParams })
                .then(function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.getShopOrders", data)

                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.getShopOrders: ", error, response)
    
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        function uploadSelfie(userId,file,completionHandler){

            if( typeof userId =="undefined" || typeof file =="undefined"){
                console.log("error in UserAdapter.uploadID: no params")
                return
            }

            var formData = new FormData()
            formData.append("file",file)

            $http.post(AppSettings.getBaseUrl() + "/api/user/"+userId+"/avatar",formData,
                {
                    transformRequest: angular.identity, //override angular's default serialization,leaving data intact
                    headers:{
                        'Content-Type': undefined
                    }
                }).then(
                    function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.uploadSelfie")

                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.uploadSelfie: ",error,response);
    
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        function uploadID(userId,file,fileType,completionHandler){

            if( typeof userId =="undefined" || typeof file =="undefined" || typeof fileType =="undefined"){
                console.log("error in UserAdapter.uploadID: no params")
                return
            }

            var formData = new FormData()
            formData.append("file",file)
            formData.append("type",fileType)

            $http.post(AppSettings.getBaseUrl() + "/api/user/"+userId+"/document",formData,
                {
                    transformRequest: angular.identity, //override angular's default serialization,leaving data intact
                    headers:{
                        'Content-Type': undefined
                    }
                }).then(
                    function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.uploadID")

                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.uploadID: ",error,response);
    
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        function uploadDL(userId,file,fileType,completionHandler){

            if( typeof userId =="undefined" || typeof file =="undefined" || typeof fileType =="undefined"){
                console.log("error in UserAdapter.uploadID: no params")
                return
            }

            var formData = new FormData()
            formData.append("file",file)
            formData.append("type",fileType)

            $http.post(AppSettings.getBaseUrl() + "/api/user/"+userId+"/license",formData,
                {
                    transformRequest: angular.identity, //override angular's default serialization,leaving data intact
                    headers:{
                        'Content-Type': undefined
                    }
                }).then(
                    function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.uploadDL")

                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.uploadDL: ",error,response);
    
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        function getUserAdditional(userId,completionHandler){

            if( typeof userId =="undefined" ){
                console.log("error in UserAdapter.getUserAdditional: no params")
                return
            }

            $http.get(AppSettings.getBaseUrl() + "/api/user/"+userId+"/additional").then(
                    function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.getUserAdditional")
                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.getUserAdditional: ",error,response);
    
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        function updateUserAdditional(userId,dataToSend,completionHandler){

            if( typeof userId == "undefined" || !dataToSend){
                console.log("error in UserAdapter.updateUserAdditional: no params")
                return
            }

            $http.put(AppSettings.getBaseUrl() + "/api/user/"+userId+"/additional",dataToSend).then(
                    function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.updateUserAdditional")
                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.updateUserAdditional: ",error,response)
    
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        function activateUserInSite(userId, dataToSend, completionHandler){

            if( typeof userId == "undefined" || !dataToSend){
                console.log("error in UserAdapter.activateUserInSite: no params")
                return
            }

            $http.put(AppSettings.getBaseUrl() + "/api/user/"+userId+"/site/activate",dataToSend).then(
                    function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.activateUserInSite")

                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        
                        console.log("error in UserAdapter.activateUserInSite: ",error,response)
                        
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        function deactivateUserFromSite(userId, dataToSend, completionHandler){

            if( typeof userId == "undefined" || !dataToSend){
                console.log("error in UserAdapter.deactivateUserFromSite: no params")
                return
            }

            $http.put(AppSettings.getBaseUrl() + "/api/user/"+userId+"/site/deactivate",dataToSend).then(
                    function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.deactivateUserFromSite")
                    
                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;

                        console.log("error in UserAdapter.deactivateUserFromSite: ",error,response)

                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        function addFreeMillis(userId,dataToSend,completionHandler){

            if( typeof userId === "undefined" || typeof dataToSend === "undefined"){
                console.log("error in UserAdapter.addFreeMillis: invalid params")
                return
            }

            $http.post(AppSettings.getBaseUrl() + "/api/user/"+userId+"/freemillis/add",dataToSend)
                .then(
                    function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.addFreeMillis")

                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.addFreeMillis: ",error,response);
    
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }
                    
        function removeFreeMillis(userId,dataToSend,completionHandler){

            if( typeof userId === "undefined" || typeof dataToSend === "undefined"){
                console.log("error in UserAdapter.removeFreeMillis: invalid params")
                return
            }

            $http.post(AppSettings.getBaseUrl() + "/api/user/"+userId+"/freemillis/remove",dataToSend)
                .then(
                    function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.removeFreeMillis")


                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.removeFreeMillis: ",error,response);
    
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
                )
        }

        function chargeUserPayment(userId, dataToSend, completionHandler){

            if (typeof userId == "undefined" || !dataToSend) {
                console.log("error in UserAdapter.chargeUserPayment: no params")
                return
            }

            $http.post(AppSettings.getBaseUrl() + "/api/user/"+userId+"/payment/charge", dataToSend).then(
                function success(response){
                    var data = response.data.data
                    console.log("success in UserAdapter.chargeUserPayment")

                    if(typeof completionHandler != "undefined")
                        completionHandler(data, null)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;
                
                    console.log("error in UserAdapter.chargeUserPayment: ",error,response)

                    if(typeof completionHandler != "undefined")
                        completionHandler(null, error)
                }
            )
        }

        function registerAdmin(dataToSend,completionHandler){

            if(!dataToSend || Object.keys(dataToSend).length==0){
                console.log("error in UserAdapter.registerAdmin: no params")
                return
            }

            $http.post(AppSettings.getBaseUrl() + "/api/admin/", dataToSend)
                .then(function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.registerAdmin")

                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.registerAdmin: ",error,response)
    
                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        // NOTE this fn deactivate the user (firebase, tokens, phone, email)
        function deactivateUser(userId, completionHandler){

            if(typeof userId !== "number"){
                console.log("error in UserAdapter.deactivateUser: userId is not valid")
                return
            }

            $http.put(AppSettings.getBaseUrl() + "/api/user/" + userId + "/deactivate", {})
                .then(function success(response){
                        var data = response.data.data
                        console.log("success in UserAdapter.deactivateUser")

                        if(typeof completionHandler != "undefined")
                            completionHandler(data,null)
                    },
                    function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in UserAdapter.deactivateUser: ",error,response)

                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)
                    }
            )
        }

        return {
            getUsers: getUsers,
            getUser: getUser,
            getUserStatus: getUserStatus,
            getSpecificUserStatus:getSpecificUserStatus,
            addPayment:addPayment,
            deletePayment: deletePayment,
            getPayments: getPayments,
            getUserTransactions: getUserTransactions,
            getUserInvoices: getUserInvoices,
            addUser: addUser,
            updateUser: updateUser,
            deleteUser: deleteUser,
            acceptUserLicense: acceptUserLicense,
            rejectUserLicense: rejectUserLicense,
            invalidateUserLicense: invalidateUserLicense,
            acceptUserID: acceptUserID,
            rejectUserID: rejectUserID,
            invalidateUserID: invalidateUserID,
            resetUserPassword:resetUserPassword,
            blockUser: blockUser,
            unblockUser: unblockUser,
            addRoleToUser: addRoleToUser,
            getUserRoles: getUserRoles,
            removeRoleFromUser: removeRoleFromUser,
            getReferredUser:getReferredUser,
            retryTransaction:retryTransaction,
            blockAutomaticTransactionRetry:blockAutomaticTransactionRetry,
            getCouponsLegacyHistory: getCouponsLegacyHistory,
            getCouponsHistory:getCouponsHistory,
            uploadSelfie:uploadSelfie,
            uploadID:uploadID,
            uploadDL:uploadDL,
            addFreeMillis: addFreeMillis,
            removeFreeMillis: removeFreeMillis,
            getUserAdditional:getUserAdditional,
            updateUserAdditional:updateUserAdditional,
            activateUserInSite:activateUserInSite,
            deactivateUserFromSite:deactivateUserFromSite,
            chargeUserPayment:chargeUserPayment,
            registerAdmin: registerAdmin,
            getShopOrders: getShopOrders,
            deactivateUser: deactivateUser,
        };

    }

    /** @ngInject */
    function ReviewAdapter($http,AppSettings,$q) {

        function getReviews(userId, completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/review").then(
                function success(response) {

                    console.log("success in ReviewAdapter.getReviews");

                    if(typeof completionHandler != "undefined")
                        completionHandler(response.data.data,null);

                    deferred.resolve(response.data.data);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in ReviewAdapter.getReviews: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)
                })

            return deferred.promise;
        }

        function getReview(id, userId, completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/user/" + userId + "/review/"+ id).then(
                function success(response) {

                    console.log("success in ReviewAdapter.getReview");

                    if(typeof completionHandler != "undefined")
                        completionHandler(response.data.data,null);

                    deferred.resolve(response.data.data);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in ReviewAdapter.getReview: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)
                })

            return deferred.promise;
        }

        function createReview(userId, data, completionHandler) {

            $http.post(AppSettings.getBaseUrl() + "/api/user/" + userId + "/review", data).then(
                function success(response) {

                    console.log("success in ReviewAdapter.createReview");

                    if(typeof completionHandler != "undefined")
                        completionHandler(response.data.data,null);


                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in ReviewAdapter.createReview: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                })
        }

        function deleteReview(id, userId, completionHandler) {

            $http.delete(AppSettings.getBaseUrl() + "/api/user/" + userId + "/review/" + id).then(
                function success(response) {

                    console.log("success in ReviewAdapter.deleteReview");

                    if(typeof completionHandler != "undefined")
                        completionHandler(response.data.data,null);


                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                    console.log("error in ReviewAdapter.deleteReview: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                })

        }

        return {
            getReviews: getReviews,
            getReview: getReview,
            createReview: createReview,
            deleteReview: deleteReview
        };

    }


}());

/**
 * Created by alex on 27/06/17.
 */
(function () {
    ('use strict');

    angular // this is for formatting
        .module('app.utility.adapter')
        .factory('VehicleSharingAdapter', VehicleSharingAdapter);

    /** @ngInject */
    function VehicleSharingAdapter($http, AppSettings, $q, EnrichDataUtility, OkaiCommand) {
        function getVehicles(params, completionHandler) {
            var deferred = $q.defer();
            var paramsQueryString = {};
            if (typeof params != 'undefined' && Object.keys(params).length > 0) {
                paramsQueryString = params;
            }

            $http.get(AppSettings.getBaseUrl() + '/api/sharing/vehicle/', { params: paramsQueryString }).then(
                function success(response) {
                    //workaround because of the server return wrapped data obj with count if pagination is used
                    var vehicles = response.data.data;

                    console.log('success in VehicleSharingAdapter.getVehicles');
                    EnrichDataUtility.generateVehicleUsefulData(vehicles.data ? vehicles.data : vehicles);

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(vehicles, null);
                    }
                    deferred.resolve(vehicles);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in VehicleSharingAdapter.getVehicles: ', error, response);

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(null, error);
                    }

                    deferred.reject(error);
                }
            );

            return deferred.promise;
        }

        function getVehicle(vehicleId, completionHandler) {
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId).then(
                function success(response) {
                    var vehicle = response.data.data;

                    console.log('success in VehicleSharingAdapter.getVehicle');

                    EnrichDataUtility.generateVehicleUsefulData([vehicle]);

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(vehicle, null);
                    }
                    deferred.resolve(vehicle);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in VehicleSharingAdapter.getVehicle: ', error, response);

                    if (typeof completionHandler != 'undefined') {
                        completionHandler(null, error);
                    }

                    deferred.reject(error);
                }
            );

            return deferred.promise;
        }

        function addVehicle(dataToSend, completionHandler) {
            $http.post(AppSettings.getBaseUrl() + '/api/sharing/vehicle', dataToSend).then(
                function success(response) {
                    var addedVehicle = response.data.data;

                    console.log('success in VehicleSharingAdapter.addVehicle');

                    completionHandler(addedVehicle, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in VehicleSharingAdapter.addVehicle: ', error, response);

                    completionHandler(null, error);
                }
            );
        }

        function updateVehicle(vehicleId, dataToSend, completionHandler) {
            $http.put(AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId, dataToSend).then(
                function success(response) {
                    var updatedVehicle = response.data.data;

                    console.log('success in VehicleSharingAdapter.updateVehicle', updatedVehicle);

                    completionHandler(updatedVehicle, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in VehicleSharingAdapter.updateVehicle: ', error, response);

                    completionHandler(null, error);
                }
            );
        }

        function deleteVehicle(vehicleId, completionHandler) {
            var url = AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId;

            $http.delete(url).then(
                function success(response) {
                    var response = response.data.data;

                    console.log('success in VehicleSharingAdapter.deleteVehicle', response);

                    completionHandler(response, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in VehicleSharingAdapter.deleteVehicle', error, response);

                    completionHandler(null, error);
                }
            );
        }

        function addImage(vehicleId, file, completionHandler) {
            var formData = new FormData();

            formData.append('file', file);

            var url = AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId + '/image';

            $http
                .post(url, formData, {
                    transformRequest: angular.identity, //override angular's default serialization,leaving data intact
                    headers: {
                        'Content-Type': undefined,
                    },
                })
                .then(
                    function success(response) {
                        var newImage = response.data.data;

                        console.log('success in VehicleSharingAdapter.addImage', newImage);

                        completionHandler(newImage, null);
                    },
                    function error(response) {
                        var error = response.data ? (response.data.error ? response.data.error : response) : response;

                        console.log('error in VehicleSharingAdapter.addImage', error, response);

                        completionHandler(null, error);
                    }
                );
        }

        function getAddImageUrl(vehicleId) {
            return AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId + '/image';
        }

        function deleteImage(vehicleId, imageId, completionHandler) {
            var url = AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId + '/image/' + imageId;

            $http.delete(url).then(
                function success(response) {
                    var response = response.data.data;

                    console.log('success in VehicleSharingAdapter.deleteImage', response);

                    completionHandler(response, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in VehicleSharingAdapter.deleteImage', error, response);

                    completionHandler(null, error);
                }
            );
        }

        function addDocument(vehicleId, file, completionHandler) {
            var formData = new FormData();

            formData.append('file', file);

            var url = AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId + '/document';

            $http
                .post(url, formData, {
                    transformRequest: angular.identity, //override angular's default serialization,leaving data intact
                    headers: {
                        'Content-Type': undefined,
                    },
                })
                .then(
                    function success(response) {
                        var newDocument = response.data.data;

                        console.log('success in VehicleSharingAdapter.addDocument', newDocument);

                        completionHandler(newDocument, null);
                    },
                    function error(response) {
                        var error = response.data ? (response.data.error ? response.data.error : response) : response;

                        console.log('error in VehicleSharingAdapter.addDocument', error, response);

                        completionHandler(null, error);
                    }
                );
        }

        function getAddDocumentUrl(vehicleId) {
            return AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId + '/document';
        }

        function modifyDocument(vehicleId, docData, completionHandler) {
            var url = AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId + '/document/' + docData.id;

            $http.put(url, docData).then(
                function success(response) {
                    var documentModified = response.data.data;

                    console.log('success in VehicleSharingAdapter.modifyDocument', documentModified);

                    completionHandler(documentModified, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in VehicleSharingAdapter.modifyDocument', error, response);

                    completionHandler(null, error);
                }
            );
        }

        function deleteDocument(vehicleId, docId, completionHandler) {
            var url = AppSettings.getBaseUrl() + '/api/sharing/vehicle/' + vehicleId + '/document/' + docId;

            $http.delete(url).then(
                function success(response) {
                    var response = response.data.data;

                    console.log('success in VehicleSharingAdapter.deleteDocument', response);

                    completionHandler(response, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in VehicleSharingAdapter.deleteDocument', error, response);

                    completionHandler(null, error);
                }
            );
        }

        function vehicleCommand(type, command) {
            return function (vehicleId, completionHandler) {
                if (typeof vehicleId == 'undefined') {
                    console.warn('VehicleSharingAdapter.vehicleCommand: no vehicleId');
                    return;
                }

                var url = AppSettings.getBaseUrl();
                url += '/api/maintenance/sharing/' + type + '/' + vehicleId + '/' + command;

                var deferred = $q.defer();

                $http.get(url).then(
                    function success(response) {
                        var response = response.data.data;

                        console.log('success in VehicleSharingAdapter.vehicleCommand', response);

                        completionHandler(response, null);
                        deferred.resolve(response);
                    },
                    function error(response) {
                        var error = response.data ? (response.data.error ? response.data.error : response) : response;

                        console.log('error in VehicleSharingAdapter.vehicleCommand', error, response);

                        completionHandler(null, error);
                        deferred.reject(error);
                    }
                );
                return deferred.promise;
            };
        }

        function executeSingleCommand(commandRequest, vehicleId, callback) {
            if (typeof vehicleId == 'undefined' || typeof commandRequest == 'undefined') {
                console.warn('VehicleSharingAdapter.executeSingleCommand: no vehicleId', commandRequest, vehicleId);
                return;
            }

            var url = AppSettings.getBaseUrl() + '/api/segway/' + vehicleId + '/' + commandRequest.command;

            var request = {
                method: commandRequest.method,
                url: url,
            };
            if (commandRequest.data) {
                request.data = commandRequest.data;
            }
            console.log('segwayVehicleCommand request', request);
            $http(request).then(
                function success(response) {
                    var response = response.data.data;

                    console.log('success in VehicleSharingAdapter.executeSingleCommand', response);

                    if (callback) {
                        callback(response, null);
                    }
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;

                    console.log('error in VehicleSharingAdapter.segwayVehicleCommand', error, response);

                    if (callback) {
                        callback(null, error);
                    }
                }
            );
        }

        function executeMultipleCommands(commandsRequests, vehicleId, completionHandler) {
            var commandRequest = commandsRequests.shift();

            executeSingleCommand(commandRequest, vehicleId, function (response, error) {
                if (error) {
                    completionHandler(null, error);
                } else {
                    if (commandsRequests.length === 0) {
                        completionHandler(response, null);
                    } else {
                        executeMultipleCommands(commandsRequests, vehicleId, completionHandler);
                    }
                }
            });
        }

        function segwayVehicleCommand(commandsRequests) {
            return function (vehicleId, completionHandler) {
                var deferred = $q.defer();

                executeMultipleCommands(angular.copy(commandsRequests), vehicleId, function (response, error) {
                    if (error) {
                        completionHandler(null, error);
                        deferred.reject(error);
                    } else {
                        completionHandler(response, null);
                        deferred.resolve(response);
                    }
                });

                return deferred.promise;
            };
        }

        function getVehicleAdditionalActions(vehicleId, completionHandler) {
            var url = AppSettings.getBaseUrl() + '/api/personal/vehicle/' + vehicleId + '/action';

            $http.get(url).then(
                function success(response) {
                    var response = response.data.data;
                    console.log('success in VehicleSharingAdapter.getVehicleAdditionalActions', response);

                    completionHandler(response, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;
                    console.log('error in VehicleSharingAdapter.getVehicleAdditionalActions', error, response);

                    completionHandler(null, error);
                }
            );
        }

        function executeVehicleAdditionalAction(vehicleId, additional, action, completionHandler) {
            var url =
                AppSettings.getBaseUrl() +
                '/api/personal/vehicle/' +
                vehicleId +
                '/action/' +
                additional +
                '/' +
                action;
            var deferred = $q.defer();

            $http.put(url).then(
                function success(response) {
                    var response = response.data.data;
                    console.log('success in VehicleSharingAdapter.executeVehicleAdditionalAction', response);

                    completionHandler(response, null);
                    deferred.resolve(response);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;
                    console.log('error in VehicleSharingAdapter.executeVehicleAdditionalAction', error, response);

                    completionHandler(null, error);
                    deferred.reject(error);
                }
            );

            return deferred.promise;
        }

        function toggleVehicleAvailability(vehicleId, availabilityStatus, completionHandler) {
            var url =
                AppSettings.getBaseUrl() + '/api/maintenance/sharing/vehicle/' + vehicleId + '/' + availabilityStatus;

            $http.get(url).then(
                function success(response) {
                    var response = response.data.data;
                    console.log(
                        'success in VehicleSharingAdapter.toggleVehicleAvailability',
                        availabilityStatus,
                        response
                    );

                    completionHandler(response, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;
                    console.log(
                        'error in VehicleSharingAdapter.toggleVehicleAvailability',
                        availabilityStatus,
                        error,
                        response
                    );

                    completionHandler(null, error);
                }
            );
        }

        function makeAvailable(vehicleId, completionHandler) {
            toggleVehicleAvailability(vehicleId, 'available', completionHandler);
        }

        function makeUnavailable(vehicleId, completionHandler) {
            toggleVehicleAvailability(vehicleId, 'unavailable', completionHandler);
        }

        function getDamages(vehicleId, completionHandler) {
            $http.get(AppSettings.getBaseUrl() + '/api/personal/vehicle/' + vehicleId + '/damage').then(
                function success(response) {
                    var response = response.data.data;
                    console.log('success in VehicleSharingAdapter.getDamages');
                    EnrichDataUtility.generateDamageUsefulData(response.data ? response.data : response);

                    completionHandler(response, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;
                    console.log('error in VehicleSharingAdapter.getDamages', error, response);

                    completionHandler(null, error);
                }
            );
        }

        function getVehiclesMapInfo(dataToSend, completionHandler) {
            $http.post(AppSettings.getBaseUrl() + '/api/sharing/vehicle/map', dataToSend).then(
                function success(response) {
                    var response = response.data.data;
                    // console.log("success in VehicleSharingAdapter.getVehiclesMapInfo");

                    completionHandler(response, null);
                },
                function error(response) {
                    var error = response.data ? (response.data.error ? response.data.error : response) : response;
                    console.log('error in VehicleSharingAdapter.getVehiclesMapInfo', error, response);

                    completionHandler(null, error);
                }
            );
        }

        function okaiVehicleCommand(requestData) {
            return function (vehicleId, completionHandler) {
                if (
                    !vehicleId ||
                    !requestData ||
                    Object.keys(requestData).length == 0 ||
                    requestData.command === undefined
                ) {
                    console.warn('okaiVehicleCommand: invalid input', vehicleId, requestData);
                    return;
                }

                var deferred = $q.defer();
                const url = AppSettings.getBaseUrl() + '/api/okai/' + vehicleId + '/cmd';
                const body = { command: requestData.command };

                $http.put(url, body).then(
                    function success(response) {
                        console.log('success in VehicleSharingAdapter.okaiVehicleCommand');
                        var data = response.data.data;
                        if (completionHandler) {
                            completionHandler(data, null);
                        }
                        deferred.resolve(data);
                    },
                    function error(response) {
                        var error = response.data ? (response.data.error ? response.data.error : response) : response;
                        console.log('error in VehicleSharingAdapter.okaiVehicleCommand', error, response);

                        if (completionHandler) {
                            completionHandler(null, error);
                        }
                        deferred.reject(error);
                    }
                );

                return deferred.promise;
            };
        }

        // FIXME: This should be using the generic method but the generic method doesn't support POST ¯\_(ツ)_/¯
        function enableBikeLock() {
            return function (vehicleId, completionHandler) {
                if (
                    !vehicleId
                ) {
                    console.warn('enableBikeLock: invalid input', vehicleId);
                    return;
                }

                var deferred = $q.defer();
                const url = AppSettings.getBaseUrl() + '/api/maintenance/sharing/bike/' + vehicleId + '/horseshoe-lock/enable/lock';

                $http.post(url, {}).then(
                    function success(response) {
                        console.log('success in VehicleSharingAdapter.enableBikeLock');
                        var data = response.data.data;
                        if (completionHandler) {
                            completionHandler(data, null);
                        }
                        deferred.resolve(data);
                    },
                    function error(response) {
                        var error = response.data ? (response.data.error ? response.data.error : response) : response;
                        console.log('error in VehicleSharingAdapter.enableBikeLock', error, response);

                        if (completionHandler) {
                            completionHandler(null, error);
                        }
                        deferred.reject(error);
                    }
                );

                return deferred.promise;
            };
        }

        return {
            getVehicles: getVehicles,
            getVehicle: getVehicle,
            addVehicle: addVehicle,
            updateVehicle: updateVehicle,
            deleteVehicle: deleteVehicle,
            addImage: addImage,
            getAddImageUrl: getAddImageUrl,
            deleteImage: deleteImage,
            addDocument: addDocument,
            getAddDocumentUrl: getAddDocumentUrl,
            modifyDocument: modifyDocument,
            deleteDocument: deleteDocument,
            bookCommand: vehicleCommand('vehicle', 'book'),
            firstUnlockCommand: vehicleCommand('vehicle', 'unlock/first'),
            unlockCommand: vehicleCommand('vehicle', 'unlock'),
            enableEngineCommand: vehicleCommand('vehicle', 'enable'),
            disableEngineCommand: vehicleCommand('vehicle', 'disable'),
            parkCommand: vehicleCommand('vehicle', 'park'),
            lockCommand: vehicleCommand('vehicle', 'lock'),
            leaveCommand: vehicleCommand('vehicle', 'leave'),
            locateCommand: vehicleCommand('vehicle', 'locate'),
            startCommand: vehicleCommand('vehicle', 'start'),
            stopCommand: vehicleCommand('vehicle', 'stop'),
            startCarCommand: vehicleCommand('car', 'start'),
            stopCarCommand: vehicleCommand('car', 'stop'),
            getVehicleAdditionalActions: getVehicleAdditionalActions,
            executeVehicleAdditionalAction: executeVehicleAdditionalAction,
            onCommand: vehicleCommand('scooter', 'on'),
            offCommand: vehicleCommand('scooter', 'off'),
            openSaddleCommand: vehicleCommand('scooter', 'saddle/open'),
            openTrunkCommand: vehicleCommand('scooter', 'trunk/open'),
            closeTrunkCommand: vehicleCommand('scooter', 'trunk/close'),
            endCommand: vehicleCommand('scooter', 'end'),
            startScooterCommand: vehicleCommand('scooter', 'start'),
            stopScooterCommand: vehicleCommand('scooter', 'stop'),
            locateScooterCommand: vehicleCommand('scooter', 'locate'),
            onKickCommand: vehicleCommand('kick', 'on'),
            offKickCommand: vehicleCommand('kick', 'off'),
            endKickCommand: vehicleCommand('kick', 'end'),
            startKickCommand: vehicleCommand('kick', 'start'),
            stopKickCommand: vehicleCommand('kick', 'stop'),
            locateKickCommand: vehicleCommand('kick', 'locate'),
            unlockKickBatteryCompartmentCommand: vehicleCommand('kick', 'battery-compartment/unlock'),
            unlockKickCableLockCommand: vehicleCommand('kick', 'cable-lock/unlock'),
            startBikeCommand: vehicleCommand('bike', 'start'),
            stopBikeCommand: vehicleCommand('bike', 'stop'),
            locateBikeCommand: vehicleCommand('bike', 'locate'),
            tootSegwayKickCommand: segwayVehicleCommand([{ method: 'POST', command: 'control/toot', data: null }]),
            disableAlarmSegwayKickCommand: segwayVehicleCommand([
                { method: 'POST', command: 'control/unlock', data: null },
                { method: 'POST', command: 'control/power', data: { controlType: 0 } },
            ]),
            enableAlarmSegwayKickCommand: segwayVehicleCommand([
                { method: 'POST', command: 'control/power', data: { controlType: 1 } },
                { method: 'POST', command: 'control/lock', data: null },
            ]),
            unlockBatteryCompartmentSegwayCommand: segwayVehicleCommand([
                { method: 'POST', command: 'control/battery%2Fcover', data: null },
            ]),
            setSegwaySettings: function (dataToSend) {
                return segwayVehicleCommand([{ method: 'POST', command: 'setting/scooter', data: dataToSend }]);
            },
            setSegwaySpeedLimits: function (dataToSend) {
                return segwayVehicleCommand([{ method: 'POST', command: 'setting/speed-limit', data: dataToSend }]);
            },
            unlockSegwayCommand: segwayVehicleCommand([{ method: 'POST', command: 'control/unlock', data: null }]),
            lockSegwayCommand: segwayVehicleCommand([{ method: 'POST', command: 'control/lock', data: null }]),
            makeAvailable: makeAvailable,
            makeUnavailable: makeUnavailable,
            getDamages: getDamages,
            getVehiclesMapInfo: getVehiclesMapInfo,
            unlockBatteryCompartmentOkaiCommand: okaiVehicleCommand({
                command: OkaiCommand.BATTERY_COMPARTMENT_UNLOCK,
            }),
            lockBatteryCompartmentOkaiCommand: okaiVehicleCommand({ command: OkaiCommand.BATTERY_COMPARTMENT_LOCK }),
            enableBikeLock: enableBikeLock(),
        };
    }
})();

(function (){
    'use strict';

    angular
        .module('app.utility.adapter')
        .factory('ExpensesAdapter',ExpensesAdapter)
        .factory('GeofencesAdapter', GeofencesAdapter)
        .factory('CouponsAdapter', CouponsAdapter)
        .factory('FaresAdapter', FaresAdapter)
        .factory('ApiSettingsAdapter', ApiSettingsAdapter)
        .factory('PermissionsAdapter', PermissionsAdapter)
        .factory('TranslationsAdapter', TranslationsAdapter)
        .factory('LoggingAdapter', LoggingAdapter)

    /** @ngInject */
    function ExpensesAdapter($http,AppSettings,$q){
        
        function getExpenses(completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/service/expense").then(
                function success(response) {

                    var expenses = response.data.data;

                    console.log("success in ExpensesAdapter.getExpenses")

                    if(typeof completionHandler !== "undefined"){
                        completionHandler(expenses,null);
                    }
                    deferred.resolve(expenses);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ExpensesAdapter.getExpenses: ",error,response);

                    if(typeof completionHandler !== "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function addExpense(data,completionHandler){
            var deferred = $q.defer();

            $http.post(AppSettings.getBaseUrl() + "/api/service/expense", data).then(
                function success(response) {

                    var output = response.data.data;

                    console.log("success in ExpensesAdapter.addExpense")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(output,null);
                    }
                    deferred.resolve(output);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ExpensesAdapter.addExpense: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function editExpense(id, data, completionHandler){
            var deferred = $q.defer();

            $http.put(AppSettings.getBaseUrl() + "/api/service/expense/" + id, data).then(
                function success(response) {

                    var output = response.data.data;

                    console.log("success in ExpensesAdapter.editExpense")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(output,null);
                    }
                    deferred.resolve(output);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ExpensesAdapter.editExpense: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        function deleteExpense(id, completionHandler){
            var deferred = $q.defer();

            $http.delete(AppSettings.getBaseUrl() + "/api/service/expense/" + id).then(
                function success(response) {

                    var output = response.data.data;

                    console.log("success in ExpensesAdapter.deleteExpense")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(output,null);
                    }
                    deferred.resolve(output);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ExpensesAdapter.deleteExpense: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        return{
            getExpenses: getExpenses,
            addExpense: addExpense,
            editExpense: editExpense,
            deleteExpense: deleteExpense
        }
    }

    /** @ngInject */
    function GeofencesAdapter($http,AppSettings,$q){

        function getGeofenceAreas(completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/service/geofencing").then(
                function success(response) {

                    var areas = response.data.data;

                    console.log("success in GeofencesAdapter.getGeofenceAreas")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(areas,null);
                    }
                    deferred.resolve(areas);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in GeofencesAdapter.getGeofenceAreas: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function getGeofenceArea(id, completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/service/geofencing/" + id).then(
                function success(response) {

                    var area = response.data.data;

                    console.log("success in GeofencesAdapter.getGeofenceArea")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(area,null);
                    }
                    deferred.resolve(area);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in GeofencesAdapter.getGeofenceArea: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        function addGeofenceArea(data, completionHandler){
            var deferred = $q.defer();

            $http.post(AppSettings.getBaseUrl() + "/api/service/geofencing", data).then(
                function success(response) {

                    var area = response.data.data;

                    console.log("success in GeofencesAdapter.addGeofenceArea")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(area,null);
                    }
                    deferred.resolve(area);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in GeofencesAdapter.addGeofenceArea: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        function updateGeofenceArea(id, data, completionHandler){
            var deferred = $q.defer();

            $http.put(AppSettings.getBaseUrl() + "/api/service/geofencing/" + id, data).then(
                function success(response) {

                    var areas = response.data.data;

                    console.log("success in GeofencesAdapter.updateGeofenceArea")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(areas,null);
                    }
                    deferred.resolve(areas);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in GeofencesAdapter.updateGeofenceArea: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function deleteGeofencingArea(id, completionHandler){
            var deferred = $q.defer();

            $http.delete(AppSettings.getBaseUrl() + "/api/service/geofencing/" + id).then(
                function success(response) {

                    var areas = response.data.data;

                    console.log("success in GeofencesAdapter.deleteGeofencingArea")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(areas,null);
                    }
                    deferred.resolve(areas);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in GeofencesAdapter.deleteGeofencingArea: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        function addFareToGeofenceArea(idGeofence, idFare, completionHandler){
            var deferred = $q.defer();

            $http.put(AppSettings.getBaseUrl() + "/api/service/geofencing/" + idGeofence + "/rate/" + idFare).then(
                function success(response) {

                    var areas = response.data.data;

                    console.log("success in GeofencesAdapter.addFareToGeofenceArea")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(areas,null);
                    }
                    deferred.resolve(areas);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in GeofencesAdapter.addFareToGeofenceArea: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        function removeFareFromGeofenceArea(idGeofence, idFare, completionHandler){
            var deferred = $q.defer();

            $http.delete(AppSettings.getBaseUrl() + "/api/service/geofencing/" + idGeofence + "/rate/" + idFare).then(
                function success(response) {

                    var areas = response.data.data;

                    console.log("success in GeofencesAdapter.removeFareFromGeofenceArea")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(areas,null);
                    }
                    deferred.resolve(areas);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in GeofencesAdapter.removeFareFromGeofenceArea: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        return{
            getGeofenceAreas: getGeofenceAreas,
            getGeofenceArea: getGeofenceArea,
            addGeofenceArea: addGeofenceArea,
            updateGeofenceArea: updateGeofenceArea,
            deleteGeofencingArea: deleteGeofencingArea,
            addFareToGeofenceArea: addFareToGeofenceArea,
            removeFareFromGeofenceArea: removeFareFromGeofenceArea
        }
    }

    /** @ngInject */
    function CouponsAdapter($http,AppSettings,$q,EnrichDataUtility){
        
        function getCoupons(params, completionHandler){
            var queryStringParams = {};
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/service/coupon",{params: queryStringParams}).then(
                function success(response) {

                    var coupons = response.data.data;

                    console.log("success in CouponsAdapter.getCoupons")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(coupons,null);
                    }
                    deferred.resolve(coupons);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in CouponsAdapter.getCoupons: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function getCoupon(id, completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/service/coupon/" + id).then(
                function success(response) {

                    var coupons = response.data.data;

                    console.log("success in CouponsAdapter.getCoupon")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(coupons,null);
                    }
                    deferred.resolve(coupons);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in CouponsAdapter.getCoupon: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function editCoupon(id, data, completionHandler){
            var deferred = $q.defer();

            $http.put(AppSettings.getBaseUrl() + "/api/service/coupon/" + id, data).then(
                function success(response) {

                    var coupons = response.data.data;

                    console.log("success in CouponsAdapter.editCoupon")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(coupons,null);
                    }
                    deferred.resolve(coupons);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in CouponsAdapter.editCoupon: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function deleteCoupon(id, completionHandler){
            var deferred = $q.defer();

            $http.delete(AppSettings.getBaseUrl() + "/api/service/coupon/" + id).then(
                function success(response) {

                    var coupons = response.data.data;

                    console.log("success in CouponsAdapter.deleteCoupon")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(coupons,null);
                    }
                    deferred.resolve(coupons);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in CouponsAdapter.deleteCoupon: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function addCoupon(data, completionHandler){
            var deferred = $q.defer();

            $http.post(AppSettings.getBaseUrl() + "/api/service/coupon/", data).then(
                function success(response) {

                    var coupons = response.data.data;

                    console.log("success in CouponsAdapter.addCoupon")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(coupons,null);
                    }
                    deferred.resolve(coupons);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in CouponsAdapter.addCoupon: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function setCouponAsReferral(id, completionHandler){
            var deferred = $q.defer();

            $http.put(AppSettings.getBaseUrl() + "/api/service/coupon/" + id + "/referral").then(
                function success(response) {

                    var coupons = response.data.data;

                    console.log("success in CouponsAdapter.setCouponAsReferral")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(coupons,null);
                    }
                    deferred.resolve(coupons);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in CouponsAdapter.setCouponAsReferral: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                })
                return deferred.promise
        }

        function getCouponUsers(id, params, completionHandler){
            var queryStringParams = {};
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            $http.get(AppSettings.getBaseUrl() + "/api/service/coupon/" + id + "/user", {params: queryStringParams}).then(
                function success(response) {

                    var coupons = response.data.data;

                    //console.log("success in CouponsAdapter.getCouponUsers")
                    var couponUsers = coupons.data ? coupons.data : coupons
                    couponUsers.forEach(function(couponUser) {
                        if(couponUser.User){
                            EnrichDataUtility.generateUserUsefulData([couponUser.User])
                        }
                    })

                    if(typeof completionHandler != "undefined"){
                        completionHandler(coupons,null);
                    }
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in CouponsAdapter.getCouponUsers: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }
                })
        }


        return{
            getCoupons: getCoupons,
            getCoupon: getCoupon,
            editCoupon: editCoupon,
            deleteCoupon: deleteCoupon,
            addCoupon: addCoupon,
            setCouponAsReferral: setCouponAsReferral,
            getCouponUsers:getCouponUsers
        }


    }

    /** @ngInject */
    function FaresAdapter($http,AppSettings,$q) {
        
        function getFares(completionHandler) {
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/sharing/rate").then(
                function success(response) {

                    var fares = response.data.data;

                    console.log("success in FaresAdapter.getFares")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(fares,null);
                    }
                    deferred.resolve(fares);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in FaresAdapter.getFares: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function getFare(id, completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/sharing/rate/" + id).then(
                function success(response) {

                    var fares = response.data.data;

                    console.log("success in FaresAdapter.getFare")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(fares,null);
                    }
                    deferred.resolve(fares);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in FaresAdapter.getFare: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function addFare(data, completionHandler){
            var deferred = $q.defer();

            $http.post(AppSettings.getBaseUrl() + "/api/sharing/rate", data).then(
                function success(response) {

                    var fares = response.data.data;

                    console.log("success in FaresAdapter.addFare")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(fares,null);
                    }
                    deferred.resolve(fares);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in FaresAdapter.addFare: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function updateFare(id, data, completionHandler){
            var deferred = $q.defer();

            $http.put(AppSettings.getBaseUrl() + "/api/sharing/rate/" + id, data).then(
                function success(response) {

                    var fares = response.data.data;

                    console.log("success in FaresAdapter.updateFare")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(fares,null);
                    }
                    deferred.resolve(fares);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in FaresAdapter.updateFare: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function setAsDefault(id,completionHandler) {
            $http.get(AppSettings.getBaseUrl() + "/api/sharing/rate/" + id + "/default").then(
                function success(response) {

                    console.log("success in FaresAdapter.setAsDefault")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(response,null);
                    }
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in FaresAdapter.setAsDefault: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }
                }
            )

        }


        function deleteFare(id, completionHandler){
            var deferred = $q.defer();

            $http.delete(AppSettings.getBaseUrl() + "/api/sharing/rate/" + id).then(
                function success(response) {

                    var fares = response.data.data;

                    console.log("success in FaresAdapter.deleteFare")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(fares,null);
                    }
                    deferred.resolve(fares);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in FaresAdapter.deleteFare: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        return{
            getFares: getFares,
            getFare: getFare,
            addFare: addFare,
            updateFare: updateFare,
            setAsDefault:setAsDefault,
            deleteFare: deleteFare
        }

    }

    /** @ngInject */
    function ApiSettingsAdapter($http,$q,AppSettings) {
        
        function getSettings(completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/service/setting").then(
                function success(response) {

                    var settings = response.data.data;

                    console.log("success in ApiSettingsAdapter.getSettings")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(settings,null);
                    }
                    deferred.resolve(settings);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ApiSettingsAdapter.getSettings: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        function updateSettings(data, completionHandler){
            var deferred = $q.defer();

            $http.put(AppSettings.getBaseUrl() + "/api/service/setting", data).then(
                function success(response) {

                    var settings = response.data.data;

                    console.log("success in ApiSettingsAdapter.updateSettings")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(settings,null);
                    }
                    deferred.resolve(settings);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ApiSettingsAdapter.updateSettings: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function uploadInvoiceTemplate(data, siteID, completionHandler){
            var deferred = $q.defer();

            $http
                .post(
                    AppSettings.getBaseUrl() +
                        "/api/service/setting/invoice" +
                        (siteID !== undefined ? "/" + siteID : ""),
                    data,
                    {
                        transformRequest: angular.identity, //override angular's default serialization,leaving data intact
                        headers: {
                            "Content-Type": undefined,
                        },
                    }
                )
                .then(
                    function success(response) {
                        var settings = response.data.data;

                        console.log("success in ApiSettingsAdapter.uploadInvoiceTemplateToSiteSettings");

                        if (typeof completionHandler != "undefined") {
                            completionHandler(settings, null);
                        }
                        deferred.resolve(settings);
                    },
                    function error(response) {
                        var error = response.data ? (response.data.error ? response.data.error : response) : response;

                        console.log(
                            "error in ApiSettingsAdapter.uploadInvoiceTemplateToSiteSettings: ",
                            error,
                            response
                        );

                        if (typeof completionHandler != "undefined") {
                            completionHandler(null, error);
                        }

                        deferred.reject(error);
                    }
                );

            return deferred.promise;
        }

        return{
            getSettings: getSettings,
            updateSettings: updateSettings,
            uploadInvoiceTemplate: uploadInvoiceTemplate,
        }


    }

    /** @ngInject */
    function PermissionsAdapter($http, AppSettings, $q, EnrichDataUtility) {
        
        function getPermissions(completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/permission/available").then(
                function success(response) {

                    var permissions = response.data.data;

                    console.log("success in PermissionsAdapter.getPermissions")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(permissions,null);
                    }
                    deferred.resolve(permissions);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in PermissionsAdapter.getPermissions: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        function getRoles(completionHandler){
            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/permission/role").then(
                function success(response) {

                    var roles = response.data.data;

                    console.log("success in PermissionsAdapter.getRoles")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(roles,null);
                    }
                    deferred.resolve(roles);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in PermissionsAdapter.getRoles: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function addRole(data, completionHandler){
            var deferred = $q.defer();

            $http.post(AppSettings.getBaseUrl() + "/api/permission/role", data).then(
                function success(response) {

                    var roles = response.data.data;

                    console.log("success in PermissionsAdapter.addRole")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(roles,null);
                    }
                    deferred.resolve(roles);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in PermissionsAdapter.addRole: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        function editRole(id, data, completionHandler){
            var deferred = $q.defer();

            $http.put(AppSettings.getBaseUrl() + "/api/permission/role/" + id, data).then(
                function success(response) {

                    var roles = response.data.data;

                    console.log("success in PermissionsAdapter.editRole")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(roles,null);
                    }
                    deferred.resolve(roles);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in PermissionsAdapter.editRole: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }


        function deleteRole(id, completionHandler){
            var deferred = $q.defer();

            $http.delete(AppSettings.getBaseUrl() + "/api/permission/role/" + id).then(
                function success(response) {

                    var roles = response.data.data;

                    console.log("success in PermissionsAdapter.deleteRole")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(roles,null);
                    }
                    deferred.resolve(roles);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in PermissionsAdapter.deleteRole: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }



        function addPermissionToRole(id, name, completionHandler){
            var deferred = $q.defer();

            $http.post(AppSettings.getBaseUrl() + "/api/permission/role/"+ id +"/permission/" + name).then(
                function success(response) {

                    var roles = response.data.data;

                    console.log("success in PermissionsAdapter.addPermissionToRole")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(roles,null);
                    }
                    deferred.resolve(roles);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in PermissionsAdapter.addPermissionToRole: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function removePermissionFromRole(id, name, completionHandler){
            var deferred = $q.defer();

            $http.delete(AppSettings.getBaseUrl() + "/api/permission/role/"+ id +"/permission/" + name).then(
                function success(response) {

                    var roles = response.data.data;

                    console.log("success in PermissionsAdapter.removePermissionFromRole")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(roles,null);
                    }
                    deferred.resolve(roles);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in PermissionsAdapter.removePermissionFromRole: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function getRole(id, completionHandler){

            $http.get(AppSettings.getBaseUrl() + "/api/permission/role/" + id).then(
                function success(response) {

                    var roles = response.data.data;

                    console.log("success in PermissionsAdapter.getRole")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(roles,null);
                    }
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in PermissionsAdapter.getRole: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }
                }
            )
        }

        function getAdminsByRole(id, params, completionHandler){

            var paramsQueryString = {}
            if(typeof params != "undefined" && Object.keys(params).length>0){
                paramsQueryString = params
            }

            $http.get(AppSettings.getBaseUrl() + "/api/permission/role/"+ id +"/member/", {params: paramsQueryString}).then(
                function success(response) {

                    var admins = response.data.data;

                    console.log("success in PermissionsAdapter.getAdminsWithRole")
                    EnrichDataUtility.generateUserUsefulData(admins.data ? admins.data : admins)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(admins,null);
                    }
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in PermissionsAdapter.getAdminsWithRole: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                }
            )
        }

        return{
            getPermissions: getPermissions,
            getRoles: getRoles,
            addRole: addRole,
            editRole: editRole,
            deleteRole: deleteRole,
            addPermissionToRole: addPermissionToRole,
            removePermissionFromRole: removePermissionFromRole,
            getRole: getRole,
            getAdminsByRole: getAdminsByRole,
        }

    }

    /** @ngInject */
    function TranslationsAdapter($http,AppSettings,$q){
        
        function getTranslations(completionHandler) {

            $http.get(AppSettings.getBaseUrl() + "/api/service/i18n").then(
                function success(response) {
                    var data = response.data.data;

                    console.log("success in TranslationsAdapter.getTranslations")

                    completionHandler(data,null);
                },
                function error(response) {
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in TranslationsAdapter.getTranslations: ",error,response);

                    completionHandler(null,error);
                }
            )
        }

        function modifyTranslations(dataToSend,completionHandler) {
            if (dataToSend)
                $http.post(AppSettings.getBaseUrl() + "/api/service/i18n",dataToSend).then(
                    function success(response) {
                        var data = response.data.data;

                        console.log("success in TranslationsAdapter.modifyTranslations")

                        completionHandler(data,null);
                    },
                    function error(response) {
                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in TranslationsAdapter.modifyTranslations: ",error,response);

                        completionHandler(null,error);
                    }
                )
        }
        return{
            getTranslations:getTranslations,
            modifyTranslations:modifyTranslations
        }
    }

     /** @ngInject */
     function LoggingAdapter($http,AppSettings,LocalStorageService,SessionStorageService,MiscData){
        var userId = null
        var siteId = null
        
        function logUserInteraction(dataToSend, completionHandler){
            const newUserId = SessionStorageService.getItem(MiscData.USERID)
            const newSiteId = LocalStorageService.getItem(MiscData.SITE)
            if(!dataToSend.data){
                dataToSend.data = {}
            }
            dataToSend.data.userId = newUserId ? newUserId : userId
            userId = dataToSend.data.userId
            dataToSend.data.siteId = newSiteId ? newSiteId : siteId
            siteId = dataToSend.data.siteId
            // console.log("LoggingAdapter.logUserInteraction",dataToSend)

            $http.post(AppSettings.getBaseUrl() + "/api/log", dataToSend).then(
                function success(response) {

                    var data = response.data.data

                    // console.log("success in LoggingAdapter.logUserInteraction")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(data,null)
                    }
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response                  

                    // console.log("error in LoggingAdapter.logUserInteraction: ",error,response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error)
                    }

                }
            )
        }
        
        return{
            logUserInteraction:logUserInteraction
         }
     }

})();

/**
 * Created by alex on 23/08/17.
 */

(function () {
  'use strict'

  angular.module('app.utility.adapter')
      .factory('InvoicesAdapter',InvoicesAdapter)
      .factory('SitesAdapter',SitesAdapter)
      .factory('ServiceAdapter',ServiceAdapter)

    /** @ngInject */
    function InvoicesAdapter($http,AppSettings,$q,EnrichDataUtility) {

        function getInvoices(params,completionHandler) {
            
            var queryStringParams = {}
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            $http.get(AppSettings.getBaseUrl()+"/api/service/invoice",{params: queryStringParams}).then(
                function success(response) {

                    console.log('Success in InvoicesAdapter.getInvoices')

                    var invoices = response.data.data

                    EnrichDataUtility.generateInvoiceUsefulData(invoices.data ? invoices.data : invoices)

                    if(typeof completionHandler!= 'undefined')
                        completionHandler(invoices,null)

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log('error in InvoicesAdapter.getInvoices',error,response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error)
                    }
                }
            )
        }

        function getInvoice(invoiceId,completionHandler) {
            var deferred = $q.defer()

            $http.get(AppSettings.getBaseUrl()+"/api/service/invoice/"+invoiceId).then(
                function success(response) {

                    var invoice = response.data.data;

                    console.log('Success in InvoicesAdapter.getInvoice')

                    EnrichDataUtility.generateInvoiceUsefulData([invoice])

                    if(typeof completionHandler!= 'undefined')
                        completionHandler(invoice,null)

                    deferred.resolve(invoice)
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log('error in InvoicesAdapter.getInvoice',error,response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error)
                    }
                    deferred.reject(error)
                }
            )

            return deferred.promise
        }

        function upgradeInvoiceType(invoiceId,data,completionHandler) {

            $http.post(AppSettings.getBaseUrl()+"/api/service/invoice/"+invoiceId+"/transfer",data).then(
                function success(response) {

                    var invoice = response.data.data;

                    console.log('Success in InvoicesAdapter.upgradeInvoiceType')

                    if(typeof completionHandler!= 'undefined')
                        completionHandler(invoice,null)

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log('error in InvoicesAdapter.upgradeInvoiceType',error,response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }
                }
            )
        }

        function rectifyInvoice(data,completionHandler) {

            $http.post(AppSettings.getBaseUrl()+"/api/service/invoice/",data).then(
                function success(response) {

                    var invoice = response.data.data;
                    console.log('Success in InvoicesAdapter.rectifyInvoice')

                    if(typeof completionHandler!= 'undefined')
                        completionHandler(invoice,null)

                },
                function error(response) {
                    
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log('error in InvoicesAdapter.rectifyInvoice',error,response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }
                }
            )
        }

        function addInvoice(data,completionHandler) {

            $http.post(AppSettings.getBaseUrl()+"/api/service/invoice/",data).then(
                function success(response) {

                    var invoice = response.data.data;
                    console.log('Success in InvoicesAdapter.addInvoice')

                    if(typeof completionHandler!= 'undefined')
                        completionHandler(invoice,null)

                },
                function error(response) {
                    
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log('error in InvoicesAdapter.addInvoice',error,response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }
                }
            )
        }

        return{
            getInvoices:getInvoices,
            getInvoice:getInvoice,
            upgradeInvoiceType:upgradeInvoiceType,
            rectifyInvoice:rectifyInvoice,
            addInvoice:addInvoice
        }
    }

    /** @ngInject */
    function SitesAdapter($http,AppSettings) {

        function getSites(completionHandler) {

            $http.get(AppSettings.getBaseUrl()+"/api/service/site").then(
                function success(response) {

                    var invoices = response.data.data;

                    console.log('Success in SitesAdapter.getSites')

                    if(typeof completionHandler!= 'undefined')
                        completionHandler(invoices,null)
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log('error in SitesAdapter.getSites',error,response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }
                }
            )
        }

        return{
            getSites:getSites
        }
    }

    /** @ngInject */
    function ServiceAdapter($http,AppSettings,EnrichDataUtility){

        function enableVehicles(completionHandler){

            $http.post(AppSettings.getBaseUrl() + "/api/service/enable").then(
                function success(response) {
                    console.log('Success in ServiceAdapter.enableVehicles')
                    completionHandler(response.data.data,null)
                },
                function error(response) {
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log('error in ServiceAdapter.enableVehicles',error,response)
                    completionHandler(null,error);
                }
            )
        }

        function disableVehicles(completionHandler){

            $http.post(AppSettings.getBaseUrl() + "/api/service/disable").then(
                function success(response) {
                    console.log('Success in ServiceAdapter.disableVehicles')
                    completionHandler(response.data.data,null)
                },
                function error(response) {
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log('error in ServiceAdapter.disableVehicles',error,response)
                    completionHandler(null,error);
                }
            )
        }

        function getGlobalMessage(completionHandler){

            $http.get(AppSettings.getBaseUrl() + "/api/service/global-message").then(
                function success(response) {
                    console.log('Success in ServiceAdapter.getGlobalMessage')
                    completionHandler(response.data.data,null)
                },
                function error(response) {
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log('error in ServiceAdapter.getGlobalMessage',error,response)
                    completionHandler(null,error);
                }
            )
        }

        function modifyGlobalMessage(dataToSend,completionHandler){

            $http.post(AppSettings.getBaseUrl() + "/api/service/global-message",dataToSend).then(
                function success(response) {
                    console.log('Success in ServiceAdapter.modifyGlobalMessage')
                    completionHandler(response.data.data,null)
                },
                function error(response) {
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log('error in ServiceAdapter.modifyGlobalMessage',error,response)
                    completionHandler(null,error);
                }
            )
        }

        function deleteGlobalMessage(messageId,completionHandler){

            $http.delete(AppSettings.getBaseUrl() + "/api/service/global-message/"+messageId).then(
                function success(response) {
                    console.log('Success in ServiceAdapter.deleteGlobalMessage')
                    completionHandler(response.data.data,null)
                },
                function error(response) {
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log('error in ServiceAdapter.deleteGlobalMessage',error,response)
                    completionHandler(null,error);
                }
            )
        }

        function getDamages(params, completionHandler){
            var queryStringParams = {}
            if(typeof params != "undefined" && Object.keys(params).length>0){
                queryStringParams = params
            }

            $http.get(AppSettings.getBaseUrl() + "/api/service/damage", {params: queryStringParams}).then(
                function(response){
                    console.log('Success in ServiceAdapter.getDamages')
                    var damages = response.data.data
                    EnrichDataUtility.generateDamageUsefulData(damages.data ? damages.data : damages)
                    completionHandler(damages,null)
                },
                function error(response) {
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log('error in ServiceAdapter.getDamages',error,response)
                    completionHandler(null,error);
                }
            )
        }

        function getDamage(damageId, completionHandler){
            if(typeof damageId == "undefined" || damageId == null){
                console.warn("ServiceAdapter.getDamage: no damageId",damageId)
                return
            }
            $http.get(AppSettings.getBaseUrl() + "/api/service/damage/"+damageId).then(
                function(response){
                    console.log('Success in ServiceAdapter.getDamage')
                    var damage = response.data.data
                    EnrichDataUtility.generateDamageUsefulData([damage])
                    completionHandler(damage,null)
                },
                function error(response) {
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log('error in ServiceAdapter.getDamage',error,response)
                    completionHandler(null,error);
                }
            )
        }

        function getServiceFromName(dataToSend,completionHandler) {

            $http.post(AppSettings.getBaseUrl() + "/service",dataToSend)
                .then(function success(response) {

                    var responseData = response.data.data;

                    console.log("success in ServiceAdapter.getServiceFromName");

                    completionHandler(responseData,null);

                },function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ServiceAdapter.getServiceFromName: ",error,response);

                    completionHandler(null,error);

                })
        }

        return {
            enableAllVehicles: enableVehicles,
            disableAllVehicles: disableVehicles,
            getGlobalMessage:getGlobalMessage,
            modifyGlobalMessage:modifyGlobalMessage,
            deleteGlobalMessage:deleteGlobalMessage,
            getDamages:getDamages,
            getDamage:getDamage,
            getServiceFromName:getServiceFromName
        }
    }
})();
/**
 * Created by Alex on 27/12/16.
 */

(function ()
{
    'use strict';

    angular
        .module('app.utility.adapter')
        .factory('CategoryAdapter',CategoryAdapter)
        .factory('RentStationAdapter',RentStationAdapter)
        .factory('RateAdapter',RateAdapter)
        .factory('ReservationAdapter',ReservationAdapter)
        .factory('RentalAgreementAdapter',RentalAgreementAdapter)
        .factory('VehicleRentAdapter', VehicleRentAdapter)


    /** @ngInject */
    function CategoryAdapter($http,AppSettings,$q) {

        function getCategories(completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/rent/category").then(
                function success(response) {

                    console.log("success in CategoryAdapter.getCategories");

                    deferred.resolve(response.data.data)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(response.data.data,null);
                    }



                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in CategoryAdapter.getCategories: ",error,response);

                    deferred.reject(error)


                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }



                })
            return deferred.promise
        }


        function addCategory(data, completionHandler) {
            var url = AppSettings.getBaseUrl() + "/api/rent/category"

            $http.post(url,data).then(function (response) {

                completionHandler(response.data.data,null)

            },
            function (response) {

                completionHandler(null, response.data.error? response.data.error : response.statusText)

            })
        }


        function editCategory(id, data, completionHandler){

            var url = AppSettings.getBaseUrl() + "/api/rent/category/" + id
            $http.put(url,data).then(function (response) {
                completionHandler(response.data.data,null)
            },
            function (response) {
                completionHandler(null,response.data.error? response.data.error : response.statusText)
            })
        }

        
        function deleteCategory(id, completionHandler) {

            var url = AppSettings.getBaseUrl() + "/api/rent/category/" + id
            $http.delete(url).then(function (response) {
                completionHandler(true,null)
            },
            function (response) {
                completionHandler(false, response.data.error? response.data.error : response.statusText)
            })


        }

        return {
            getCategories: getCategories,
            editCategory: editCategory,
            deleteCategory: deleteCategory,
            addCategory: addCategory
        };

    }

    /** @ngInject */
    function RentStationAdapter($http,AppSettings,$q) {

        function getStations(completionHandler) {

            var deferred = $q.defer()

            $http.get(AppSettings.getBaseUrl() + "/api/rent/station").then(
                function success(response) {

                    console.log("success in RentStationAdapter.getRentStations");

                    deferred.resolve(response.data.data)

                    if(typeof completionHandler != "undefined") {
                        completionHandler(response.data.data, null);
                    }



                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentStationAdapter.getRentStations: ",error,response);

                    deferred.reject(error)

                    if(typeof completionHandler != "undefined") {
                        completionHandler(null, error);
                    }
                })

            return deferred.promise
        }


        function addStation(data,completionHandler) {
            var url = AppSettings.getBaseUrl() + "/api/rent/station"

            $http.post(url, data).then(function (response) {
                completionHandler(response.data.data,null)
            },
            function (response) {
                completionHandler(null, response.data.error? response.data.error : response.statusText)
            })
        }

        function editStation(id, data, completionHandler) {
            var url = AppSettings.getBaseUrl() + "/api/rent/station/" + id

            $http.put(url,data).then(function (response) {
                completionHandler(response.data.data, null)
            },
            function (response) {
                completionHandler(null, response.data.error? response.data.error : response.statusText)
            })
        }

        function deleteStation(id,completionHandler) {
            var url = AppSettings.getBaseUrl() + "/api/rent/station/" + id

            $http.delete(url).then(function (response) {
                completionHandler(true, null)
            },
            function (response) {
                completionHandler(false, response.data.error? response.data.error : response.statusText)
            })
        }

        return {
            getStations: getStations,
            addStation: addStation,
            editStation: editStation,
            deleteStation: deleteStation
        };

    }

    /** @ngInject */
    function RateAdapter($http,AppSettings,$q) {

        function getRates(completionHandler) {

            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/rent/rate").then(
                function success(response) {

                    console.log("success in RateAdapter.getRates");

                    deferred.resolve(response.data.data)
                    if(typeof completionHandler != "undefined") {
                        completionHandler(response.data.data, null);
                    }

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RateAdapter.getRates: ",error,response);

                    deferred.reject(error)
                    if(typeof completionHandler != "undefined") {
                        completionHandler(null, error);
                    }
                })
            return deferred.promise
        }


        function addRate(data,completionHandler) {
            var url = AppSettings.getBaseUrl() + "/api/rent/rate"

            $http.post(url,data).then(function (response) {
                completionHandler(response.data.data, null)
            },
            function (response) {
                completionHandler(null, response.data.error? response.data.error : response.statusText)
            })
        }


        function editRate(id, data, completionHandler) {

            var url = AppSettings.getBaseUrl() + "/api/rent/rate/" + id

            $http.put(url,data).then(function (response) {
                completionHandler(response.data.data, null)
            },
            function (response) {
                completionHandler(null, response.data.error? response.data.error : response.statusText)
            })
        }

        function deleteRate(id, completionHandler) {
            var url = AppSettings.getBaseUrl() + "/api/rent/rate/" + id

            $http.delete(url).then(url).then(function (response) {
                completionHandler(true, null)
            },
            function (response) {
                completionHandler(false, response.data.error? response.data.error : response.statusText)
            })
        }

        return {
            getRates: getRates,
            addRate: addRate,
            editRate: editRate,
            deleteRate: deleteRate
        };

    }

    /** @ngInject */
    function ReservationAdapter($http,AppSettings,$q,ServiceSettings) {


        function createReservationDataToSend(reservationData) {
            /**
             * 
             * 
             * 
             * 
             * 
             * 
             * THIS SECTION NEEDS TO BE UDPATED TO USE MOMENTJS INSTEAD OF THE TODATE() methods
             * 
             * 
             * 
             * 
             * 
             * 
             * 
             * 
             * 
             */

            return ServiceSettings.getServiceSettings(function(settings){
                // FIXME: wrong timezone get
                timezone = settings.timezone;

                //trasform reservation start end in epochUnix
                var reservationStartDate = moment(reservationData.from).tz(timezone).toDate();
                var reservationEndDate = moment(reservationData.to).tz(timezone).toDate();
    
                //trasform reservation pick up and return date
                var reservationPickUpDate = reservationData.pickUpTime;
                reservationStartDate.setHours(reservationPickUpDate.getHours(),reservationPickUpDate.getMinutes(),0,0);
    
                var reservationReturnTimeDate = reservationData.returnTime;
                reservationEndDate.setHours(reservationReturnTimeDate.getHours(),reservationReturnTimeDate.getMinutes(),0,0);
    
                //create reservation start adding the time
                var reservationStart = reservationStartDate.getTime();
                var reservationEnd = reservationEndDate.getTime();
    
    
                console.log("start date",reservationStart,moment(reservationStart).tz(timezone).toDate());
                console.log("end date",reservationEnd,moment(reservationEnd).tz(timezone).toDate());
    
                var currentRate = reservationData.rate;
    
                var newReservation = {
                    "start": reservationStart,
                    "end": reservationEnd,
                    "pickup": reservationData.pickup,
                    "return": reservationData.return,
                    "category": reservationData.category,
                    "vehicle": reservationData.vehicle,
                    "client": reservationData.client,
                    "payment": reservationData.payment,
                    "prepaid_day": reservationData.prepaid_day,
                    "discount": reservationData.discount,
                    "rate": currentRate == 'default' ? undefined: currentRate,
                    "drivers":[]
                };
    
                //add drivers
                reservationData.drivers.forEach(function (driverId) {
                    if(typeof driverId != "undefined" && driverId!=null){
                        newReservation.drivers.push(driverId);
                    }
                });
    
                console.log("reservation to send",newReservation);
    
                return newReservation;
            });


        }

        function addReservation(reservationData,completionHandler) {


            var newReservation = createReservationDataToSend(reservationData);

            $http.post(AppSettings.getBaseUrl() + "/api/rent/reservation",newReservation).then(
                function success(response) {

                    console.log("success in ReservationAdapter.addReservation");

                    completionHandler(response.data.data,null);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ReservationAdapter.addReservation: ",error,response);

                    completionHandler(null,error);
                })
        }
        
        function updateReservation(reservationData,completionHandler) {

            var updatedReservation = createReservationDataToSend(reservationData);

            $http.put(AppSettings.getBaseUrl() + "/api/rent/reservation/" + reservationData.id,updatedReservation).then(
                function success(response) {

                    var reservation = response.data.data;

                    console.log("success in ReservationAdapter.updateReservation",reservation)

                    completionHandler(reservation,null)

                },function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ReservationAdapter.updateReservation: ",error,response)

                    completionHandler(null,error)

                }
            )
            
        }

        function deleteReservation(reservationId,completionHandler) {

            $http.delete(AppSettings.getBaseUrl() + "/api/rent/reservation/" + reservationId).then(
                function success(response) {

                    var data = response.data.data;

                    console.log("success in ReservationAdapter.deleteReservation",data)

                    completionHandler(data,null)

                },function (response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ReservationAdapter.deleteReservation",error,response)

                    completionHandler(null,error)
                }
            )
        }

        function getReservation(reservationId,completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/rent/reservation/" + reservationId).then(
                function success(response) {

                    var reservation = response.data.data;

                    console.log("success in ReservationAdapter.getReservation");

                    if(typeof completionHandler != "undefined")
                        completionHandler(reservation,null);

                    deferred.resolve(reservation);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ReservationAdapter.getReservation: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)
                }
            )

            return deferred.promise;
        }

        function getReservations(completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/rent/reservation").then(
                function success(response) {

                    var reservations = response.data.data;

                    console.log("success in ReservAdapt.getReservations");

                    if(typeof completionHandler != "undefined")
                        completionHandler(reservations,null);

                    deferred.resolve(reservations);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ReservationAdapter.getReservations: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)
                }
            )

            return deferred.promise;
        }

        function getAliveReservations(completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/rent/reservation/alive").then(
                function success(response) {

                    var reservations = response.data.data;

                    console.log("success in ReservationAdapter.getAliveReservation")

                    if(typeof completionHandler != "undefined")
                        completionHandler(reservations,null);

                    deferred.resolve(reservations)
                },
                function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ReservationAdapter.getAliveReservation",error,response)

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function assignVehicle(reservationId, vehicle, completionHandler){

            var deferred = $q.defer();

            var dataToSend = {

                vehicle: vehicle.id
            };

            $http.post(AppSettings.getBaseUrl() + "/api/rent/reservation/"+reservationId+"/vehicle",dataToSend).then(

                function success(response) {

                    var reservations = response.data.data;

                    console.log("success in ReservationAdapter.assignVehicle",reservations);

                    if(typeof completionHandler != "undefined")
                        completionHandler(reservations,null);

                    deferred.resolve(reservations)
                },
                function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ReservationAdapter.assignVehicle",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        function upgradeReservation(reservation, completionHandler){

            var deferred = $q.defer();

            var dataToSend = {
                deposit: reservation.deposit
            };

            $http.post(AppSettings.getBaseUrl() + "/api/rent/reservation/"+ reservation.id +"/upgrade",dataToSend).then(
                function success(response) {

                    var data = response.data.data;

                    console.log("success in ReservationAdapter.upgradeReservation",data);

                    if(typeof completionHandler != "undefined")
                        completionHandler(data,null);

                    deferred.resolve(data)
                },
                function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in ReservationAdapter.upgradeReservation",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error);
                }
            )

            return deferred.promise;
        }

        return {
            addReservation: addReservation,
            updateReservation: updateReservation,
            deleteReservation:deleteReservation,
            getReservation: getReservation,
            getReservations: getReservations,
            getAliveReservations:getAliveReservations,
            assignVehicle: assignVehicle,
            upgradeReservation: upgradeReservation
        };

    }

    /** @ngInject */
    function RentalAgreementAdapter($http,AppSettings,$q,ServiceSettings) {

        
        function createRentalAgreementDataToSend(rentalAgreementData) {
            return ServiceSettings.getServiceSettings(function(settings){
                // FIXME: wrong timezone get
                const timezone = settings && settings.timezone;

                //trasform rentalAgreement start end in epochUnix
                var rentalAgreementStartDate = moment(rentalAgreementData.from).tz(timezone).toDate();
                var rentalAgreementEndDate = moment(rentalAgreementData.to).tz(timezone).toDate();
    
                //trasform rentalAgreement pick up and return date
                var rentalAgreementPickUpDate = rentalAgreementData.pickUpTime;
                rentalAgreementStartDate.setHours(rentalAgreementPickUpDate.getHours(),rentalAgreementPickUpDate.getMinutes(),0,0);
    
                var rentalAgreementReturnTimeDate = rentalAgreementData.returnTime;
                rentalAgreementEndDate.setHours(rentalAgreementReturnTimeDate.getHours(),rentalAgreementReturnTimeDate.getMinutes(),0,0);
    
                //create rentalAgreement start adding the time
                var rentalAgreementStart = rentalAgreementStartDate.getTime();
                var rentalAgreementEnd = rentalAgreementEndDate.getTime();
    
                console.log("start date",rentalAgreementStart,moment(rentalAgreementStart).tz(timezone).toDate());
                console.log("end date",rentalAgreementEnd,moment(rentalAgreementEnd).tz(timezone).toDate());
    
                var currentRate = rentalAgreementData.rate;
    
                var newRentalAgreement = {
                    "start": rentalAgreementStart,
                    "end": rentalAgreementEnd,
                    "pickup": rentalAgreementData.pickup,
                    "return": rentalAgreementData.return,
                    "category": rentalAgreementData.category,
                    "vehicle": rentalAgreementData.vehicle,
                    "client": rentalAgreementData.client,
                    "payment": rentalAgreementData.payment,
                    "prepaid_day": rentalAgreementData.prepaid_day,
                    "discount": rentalAgreementData.discount,
                    "rate": currentRate == 'default' ? undefined: currentRate,
                    "drivers":[],
                    "deposit": rentalAgreementData.deposit
                };
    
                //add drivers
                rentalAgreementData.drivers.forEach(function (driverId) {
    
                    if(typeof driverId != "undefined" && driverId!=null){
    
                        newRentalAgreement.drivers.push(driverId);
                    }
                });
    
                console.log("reservation agreement to send",newRentalAgreement);
    
                return newRentalAgreement;
            });

        }

        function addRentalAgreement(rentalAgreementData,completionHandler) {

            var newRentalAgreement = createRentalAgreementDataToSend(rentalAgreementData);

            $http.post(AppSettings.getBaseUrl() + "/api/rent/agreement",newRentalAgreement).then(
                function success(response) {

                    console.log("success in RentalAgreementAdapter.addRentalAgreement");

                    completionHandler(response.data.data,null)

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.addRentalAgreement: ",error,response);

                    completionHandler(null,error);
                })
        }

        function updateRentalAgreement(rentalAgreementData,completionHandler) {

            var updatedRentalAgreement = createRentalAgreementDataToSend(rentalAgreementData);

            $http.put(AppSettings.getBaseUrl() + "/api/rent/agreement/" + rentalAgreementData.id,updatedRentalAgreement).then(
                function success(response) {

                    var updatedRentalAgreement = response.data.data;

                    console.log("success in in RentalAgreementAdapter.updateRentalAgreement")

                    completionHandler(updatedRentalAgreement,null)
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.updateRentalAgreement: ",error,response)

                    completionHandler(null,error);
                }
            )
        }

        function deleteRentalAgreement(rentalAgreementId,completionHandler) {

            $http.delete(AppSettings.getBaseUrl() + "/api/rent/agreement/" + rentalAgreementId).then(
                function success(response) {

                    var data = response.data.data;

                    console.log("success in RentalAgreementAdapter.deleteRentalAgreement",data)

                    completionHandler(data,null)

                },function (response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.deleteRentalAgreement",error,response)

                    completionHandler(null,error)
                }
            )
        }

        function getRentalAgreement(id,completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + '/api/rent/agreement/' + id).then(
                function success(response) {

                    var rentalAgreement = response.data.data;

                    console.log("success in RentalAgreementAdapter.getRentalAgreement",rentalAgreement)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(rentalAgreement,null)
                    }

                    deferred.resolve(rentalAgreement)

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.getRentalAgreement: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error ? error : response.statusText)
                    }

                    deferred.reject(error ? error : response.statusText)
                }
            )

            return deferred.promise;
        }

        function getRentalAgreements(completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + '/api/rent/agreement').then(
                function success(response) {

                    var rentalAgreements = response.data.data;

                    console.log("success in RentalAgreementAdapter.getRentalAgreements");

                    if(typeof completionHandler != "undefined")
                        completionHandler(rentalAgreements,null);

                    deferred.resolve(rentalAgreements)
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.getRentalAgreements: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)
                }
            );

            return deferred.promise;
        }

        function getRelatedDamages(rentalAgreementId,completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + '/api/rent/agreement/'+rentalAgreementId+'/damage').then(
                function success(response) {

                    var damages = response.data.data;

                    console.log("success in RentalAgreementAdapter.getRelatedDamages",damages);

                    if(typeof completionHandler != "undefined")
                        completionHandler(damages,null);

                    deferred.resolve(damages)
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.getRelatedDamages",error,response)

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function addRelatedDamage(rentalAgreementId,dataToSend,completionHandler) {

            $http.post(AppSettings.getBaseUrl() + '/api/rent/agreement/'+rentalAgreementId+'/damage',dataToSend).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in RentalAgreementAdapter.addRelatedDamage",response);

                    completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.addRelatedDamage",error,response);

                    completionHandler(null,error);
                }
            );
        }

        function updateRelatedDamage(rentalAgreementId,damageId,dataToSend,completionHandler) {

            $http.put(AppSettings.getBaseUrl() + '/api/rent/agreement/'+rentalAgreementId+'/damage/'+damageId,dataToSend).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in RentalAgreementAdapter.updateRelatedDamage",response);

                    completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.updateRelatedDamage",error,response);

                    completionHandler(null,error);
                }
            );
        }

        function updateRelatedDamageStatus(rentalAgreementId,damageId,dataToSend,completionHandler) {

            $http.put(AppSettings.getBaseUrl() + '/api/rent/agreement/'+rentalAgreementId+'/damage/'+damageId+"/state",dataToSend).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in RentalAgreementAdapter.updateRelatedDamageStatus",response);

                    completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.updateRelatedDamageStatus",error,response);

                    completionHandler(null,error);
                }
            );
        }

        function deleteRelatedDamage(rentalAgreementId,damageId,completionHandler) {

            $http.delete(AppSettings.getBaseUrl() + '/api/rent/x/'+rentalAgreementId+'/damage/'+damageId).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in RentalAgreementAdapter.deleteRelatedDamage",response);

                    completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RentalAgreementAdapter.deleteRelatedDamage",error,response);

                    completionHandler(null,error);
                }
            );
        }

        return {
            addRentalAgreement: addRentalAgreement,
            updateRentalAgreement: updateRentalAgreement,
            deleteRentalAgreement:deleteRentalAgreement,
            getRentalAgreement: getRentalAgreement,
            getRentalAgreements: getRentalAgreements,
            getRelatedDamages: getRelatedDamages,
            addRelatedDamage: addRelatedDamage,
            updateRelatedDamage: updateRelatedDamage,
            updateRelatedDamageStatus: updateRelatedDamageStatus,
            deleteRelatedDamage: deleteRelatedDamage
        };

    }

    /** @ngInject */
    function VehicleRentAdapter($http,AppSettings,$q) {

        function addVehicle(dataToSend,completionHandler) {

            $http.post(AppSettings.getBaseUrl() + "/api/rent/vehicle",dataToSend).then(
                function success(response) {

                    var addedVehicle = response.data.data;

                    console.log("success in VehicleRentAdapter.addVehicle",addedVehicle)

                    completionHandler(addedVehicle,null)

                },function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.addVehicle: ",error,response);

                    completionHandler(null,error);
                }
            )

        }

        function updateVehicle(vehicleId,dataToSend,completionHandler) {

            $http.put(AppSettings.getBaseUrl() + "/api/rent/vehicle/" + vehicleId,dataToSend).then(
                function success(response) {

                    var updatedVehicle = response.data.data;

                    console.log("success in VehicleRentAdapter.updateVehicle",updatedVehicle)

                    completionHandler(updatedVehicle,null)

                },function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.updateVehicle: ",error,response);

                    completionHandler(null,error);
                }
            )

        }

        function getVehicle(vehicleId,completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/rent/vehicle/" + vehicleId).then(
                function success(response) {

                    var vehicle = response.data.data;

                    console.log("success in VehicleRentAdapter.getVehicle")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(vehicle,null);
                    }
                    deferred.resolve(vehicle);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.getVehicle: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                }
            )

            return deferred.promise;

        }

        function getVehicles(completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/rent/vehicle").then(
                function success(response) {

                    var vehicles = response.data.data;

                    console.log("success in VehicleRentAdapter.getVehicles");

                    if(typeof completionHandler != "undefined"){
                        completionHandler(vehicles,null);
                    }

                    deferred.resolve(vehicles);

                },function error(response){

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.getVehicles: ",error,response);

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null,error);
                    }

                    deferred.reject(error);
                })

            return deferred.promise;
        }

        function getAvailableVehiclesFromTo(fromDate,toDate,completionHandler) {

            var dataToSend = {
                start: fromDate,
                end: toDate
            };

            $http.post(AppSettings.getBaseUrl() + "/api/rent/vehicle/available",dataToSend).then(
                function success(response) {

                    var availableVehicles = response.data.data;

                    console.log("success in VehicleRentAdapter.getAvailableVehiclesFromTo",availableVehicles);

                    if(typeof completionHandler != "undefined")
                        completionHandler(availableVehicles,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.getAvailableVehiclesFromTo: ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        function addImage(vehicleId,file,completionHandler) {

            var formData = new FormData();

            formData.append("file",file);

            var url = AppSettings.getBaseUrl() + "/api/rent/vehicle/" + vehicleId + "/image";

            $http.post(url,formData, {
                transformRequest: angular.identity, //override angular's default serialization,leaving data intact
                headers:{
                    'Content-Type': undefined
                }
            }).then(
                function success(response) {

                    var newImage = response.data.data;

                    console.log("success in VehicleRentAdapter.addImage",newImage);

                    completionHandler(newImage,null)

                },function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.addImage",error,response);

                    completionHandler(null,error)

                })
        }

        function getAddImageUrl(vehicleId) {

            return AppSettings.getBaseUrl() + "/api/rent/vehicle/" + vehicleId + "/image";
        }

        function deleteImage(vehicleId,imageId,completionHandler) {

            var url = AppSettings.getBaseUrl() + "/api/rent/vehicle/" + vehicleId + "/image/"+imageId;

            $http.delete(url).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in VehicleRentAdapter.deleteImage",response);

                    completionHandler(response,null)

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.deleteImage",error,response);

                    completionHandler(null,error)

                }
            )

        }

        function addDocument(vehicleId,file,completionHandler) {

            var formData = new FormData();

            formData.append("file",file);

            var url = AppSettings.getBaseUrl() + "/api/rent/vehicle/" + vehicleId + "/document";

            $http.post(url,formData, {
                transformRequest: angular.identity, //override angular's default serialization,leaving data intact
                headers:{
                    'Content-Type': undefined
                }
            }).then(
                function success(response) {

                    var newDocument = response.data.data;

                    console.log("success in VehicleRentAdapter.addDocument",newDocument);

                    completionHandler(newDocument,null)

                },function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.addDocument",error,response);

                    completionHandler(null,error)

                })

        }

        function getAddDocumentUrl(vehicleId) {

            return AppSettings.getBaseUrl() + "/api/rent/vehicle/" + vehicleId + "/document";
        }

        function modifyDocument(vehicleId,docData,completionHandler) {

            var url = AppSettings.getBaseUrl() + "/api/rent/vehicle/" + vehicleId + "/document/"+ docData.id;

            $http.put(url,docData).then(
                function success(response) {

                    var documentModified = response.data.data;

                    console.log("success in VehicleRentAdapter.modifyDocument",documentModified);

                    completionHandler(documentModified,null)

                },function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.modifyDocument",error,response);

                    completionHandler(null,error)

                })

        }

        function deleteDocument(vehicleId,docId,completionHandler) {

            var url = AppSettings.getBaseUrl() + "/api/rent/vehicle/" + vehicleId + "/document/" + docId;

            $http.delete(url).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in VehicleRentAdapter.deleteDocument",response);

                    completionHandler(response,null)

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleRentAdapter.deleteDocument",error,response);

                    completionHandler(null,error)

                }
            )

        }

        function vehicleCommand(type, command){
            return function (vehicleId, completionHandler) {
                var url = AppSettings.getBaseUrl() + "/api/maintenance/rent/"+ type +"/" + vehicleId + "/" + command;

                $http.get(url).then(
                    function success(response) {

                        var response = response.data.data;

                        console.log("success in VehicleRentAdapter.vehicleCommand",response);

                        completionHandler(response,null)

                    },
                    function error(response) {

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in VehicleRentAdapter.vehicleCommand",error,response);

                        completionHandler(null,error)

                    }
                )
            }
        }

        function getObdData(vehicleId,completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/personal/vehicle/"+vehicleId+"/obd")
                .then(
                    function success(response) {

                        var obdData = response.data.data;

                        console.log("success in VehicleRentAdapter.getObdData");

                        if(typeof completionHandler != "undefined")
                            completionHandler(obdData,null);

                        deferred.resolve(obdData);
                    },
                    function error(response) {

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in VehicleRentAdapter.getObdData",error,response);

                        if(typeof completionHandler != "undefined")
                            completionHandler(null,error)

                        deferred.reject(error)

                    }
                );

            return deferred.promise;
        }


        return {
            addVehicle: addVehicle,
            updateVehicle: updateVehicle,
            getVehicle: getVehicle,
            getObdData: getObdData,
            getVehicles: getVehicles,
            getAvailableVehiclesFromTo: getAvailableVehiclesFromTo,
            addImage: addImage,
            getAddImageUrl:getAddImageUrl,
            deleteImage: deleteImage,
            addDocument:addDocument,
            getAddDocumentUrl:getAddDocumentUrl,
            modifyDocument:modifyDocument,
            deleteDocument: deleteDocument,
            bookCommand: vehicleCommand("vehicle", "book"),
            firstUnlockCommand: vehicleCommand("vehicle", "unlock/first"),
            unlockCommand: vehicleCommand("vehicle", "unlock"),
            onCommand: vehicleCommand("scooter", "on"),
            offCommand: vehicleCommand("scooter", "off"),
            enableEngineCommand: vehicleCommand("vehicle", "enable"),
            disableEngineCommand: vehicleCommand("vehicle", "disable"),
            parkCommand: vehicleCommand("vehicle", "park"),
            lockCommand: vehicleCommand("vehicle", "lock"),
            leaveCommand: vehicleCommand("vehicle", "leave"),
            openTrunkCommand: vehicleCommand("scooter", "trunk/open"),
            closeTrunkCommand: vehicleCommand("scooter", "trunk/close"),
        };

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.utility.adapter')
        .factory("TripsAdapter", TripsAdapter)
        .factory("LogAdapter", LogAdapter)

        /** @ngInject */
        function TripsAdapter($http,AppSettings,$q,EnrichDataUtility){

            function getTrips(params,completionHandler){
                var deferred = $q.defer();
                
                var queryStringParams = {}
                if(typeof params != "undefined" && Object.keys(params).length>0){
                    queryStringParams = params
                }
                
                $http.get(AppSettings.getBaseUrl() + "/api/personal/trip",{params: queryStringParams}).then(
                    function success(response) {

                        console.log("success in TripsAdapter.getTrips");
                        var trips = response.data.data
                        EnrichDataUtility.generateTripUsefulData(trips.data ? trips.data : trips)
                        
                        if(typeof completionHandler != "undefined"){
                            completionHandler(trips,null);
                        }

                        deferred.resolve(trips)


                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;

                        console.log("error in TripsAdapter.getTrips: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }

            function getTrip(tripId,completionHandler){

                var deferred = $q.defer();

                $http.get(AppSettings.getBaseUrl() + "/api/personal/trip/"+tripId).then(
                    function success(response) {

                        console.log("success in TripsAdapter.getTrip");
                        var trip = response.data.data
                        EnrichDataUtility.generateTripUsefulData([trip])
                        
                        if(typeof completionHandler != "undefined"){
                            completionHandler(trip,null);
                        }

                        deferred.resolve(trip)

                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        
                        console.log("error in TripsAdapter.getTrip: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }


            function getTripPositions(tripId, completionHandler){
                var deferred = $q.defer();

                $http.get(AppSettings.getBaseUrl() + "/api/personal/trip/"+ tripId + "/position").then(
                    function success(response) {

                        console.log("success in TripsAdapter.getTripPositions");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)

                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        
                        console.log("error in TripsAdapter.getTripPositions: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }

            function getVehicleTrips(id, params, completionHandler){
                var deferred = $q.defer();

                var queryStringParams = {}
                if(typeof params != "undefined" && Object.keys(params).length>0){
                    queryStringParams = params
                }

                $http.get(AppSettings.getBaseUrl() + "/api/personal/trip/vehicle/" + id, {params: queryStringParams}).then(
                    function success(response) {

                        console.log("success in TripsAdapter.getVehicleTrips");
                        var trips = response.data.data
                        EnrichDataUtility.generateTripUsefulData(trips.data ? trips.data : trips)

                        if(typeof completionHandler != "undefined"){
                            completionHandler(trips,null);
                        }

                        deferred.resolve(trips)

                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        
                        console.log("error in TripsAdapter.getVehicleTrips: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }

            function getUserTrips(id, params, completionHandler){
                var deferred = $q.defer();

                var queryStringParams = {}
                if(typeof params != "undefined" && Object.keys(params).length>0){
                    queryStringParams = params
                }

                $http.get(AppSettings.getBaseUrl() + "/api/user/" + id + "/trip", {params: queryStringParams}).then(
                    function success(response) {

                        console.log("success in TripsAdapter.getUserTrips")

                        var trips = response.data.data
                        EnrichDataUtility.generateTripUsefulData(trips.data ? trips.data : trips)

                        if(typeof completionHandler != "undefined"){
                            completionHandler(trips,null);
                        }

                        deferred.resolve(trips)

                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        
                        console.log("error in TripsAdapter.getUserTrips: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }

            function startTrip(dataToSend, completionHandler){
                var deferred = $q.defer();

                $http.post(AppSettings.getBaseUrl() + "/api/personal/vehicle/trip/start",dataToSend).then(
                    function success(response) {

                        console.log("success in TripsAdapter.startTrip");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)

                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        
                        console.log("error in TripsAdapter.startTrip: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }

            function stopTrip(dataToSend, completionHandler){
                var deferred = $q.defer();

                $http.put(AppSettings.getBaseUrl() + "/api/personal/vehicle/trip/stop",dataToSend).then(
                    function success(response) {

                        console.log("success in TripsAdapter.stopTrip");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)

                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        
                        console.log("error in TripsAdapter.stopTrip: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }
                        deferred.reject(error)

                    })
                return deferred.promise
            }

            function getEndTripImages(id, completionHandler){

                $http.get(AppSettings.getBaseUrl() + "/api/personal/trip/"+id+"/picture/stop").then(
                    function success(response) {

                        console.log("success in TripsAdapter.getEndTripImages");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }
                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        
                        console.log("error in TripsAdapter.getEndTripImages: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                    })
            }

            return{
                getTrips: getTrips,
                getVehicleTrips: getVehicleTrips,
                getTrip: getTrip,
                getTripPositions: getTripPositions,
                getUserTrips: getUserTrips,
                startTrip:startTrip,
                stopTrip:stopTrip,
                getEndTripImages:getEndTripImages,
            }
        }

        /** @ngInject */
        function LogAdapter($http,AppSettings,$q){

            function getTripLogs(tripId,completionHandler){
                $http.get(AppSettings.getBaseUrl() + "/api/personal/trip/"+tripId+"/log/position").then(
                    function success(response) {
                        console.log("success in LogAdapter.getTripLogs");

                        completionHandler(response.data.data,null);

                    },function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        console.log("error in LogAdapter.getTripLogs: ",error,response);

                        completionHandler(null,error);
                    })
            }

            function getLastDayVehicleBoardMessagesLogs(vehicleId,completionHandler){
                $http.get(AppSettings.getBaseUrl() + "/api/personal/vehicle/"+vehicleId+"/log/command").then(
                    function success(response) {
                        console.log("success in LogAdapter.getLastDayVehicleBoardMessagesLogs");

                        completionHandler(response.data.data,null);

                    },function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        console.log("error in LogAdapter.getLastDayVehicleBoardMessagesLogs: ",error,response);

                        completionHandler(null,error);
                    })
            }

            function getTimeRangeVehicleBoardMessagesLogs(vehicleId,dataToSend,completionHandler){
                $http.post(AppSettings.getBaseUrl() + "/api/personal/vehicle/"+vehicleId+"/log/command",dataToSend).then(
                    function success(response) {
                        console.log("success in LogAdapter.getTimeRangeVehicleBoardMessagesLogs");

                        completionHandler(response.data.data,null);

                    },function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        console.log("error in LogAdapter.getTimeRangeVehicleBoardMessagesLogs: ",error,response);

                        completionHandler(null,error);
                    })
            }

            function getLastDayVehicleStatusLogs(vehicleId,completionHandler){
                $http.get(AppSettings.getBaseUrl() + "/api/personal/vehicle/"+vehicleId+"/log/status").then(
                    function success(response) {
                        console.log("success in LogAdapter.getLastDayVehicleStatusLogs");

                        completionHandler(response.data.data,null);

                    },function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        console.log("error in LogAdapter.getLastDayVehicleStatusLogs: ",error,response);

                        completionHandler(null,error);
                    })
            }

            function getTimeRangeVehicleStatusLogs(vehicleId,dataToSend,completionHandler){
                $http.post(AppSettings.getBaseUrl() + "/api/personal/vehicle/"+vehicleId+"/log/status",dataToSend).then(
                    function success(response) {
                        console.log("success in LogAdapter.getTimeRangeVehicleStatusLogs");

                        completionHandler(response.data.data,null);

                    },function error(response){
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                        console.log("error in LogAdapter.getTimeRangeVehicleStatusLogs: ",error,response);

                        completionHandler(null,error);
                    })
            }

            return{
                getTripLogs:getTripLogs,
                getLastDayVehicleBoardMessagesLogs:getLastDayVehicleBoardMessagesLogs,
                getTimeRangeVehicleBoardMessagesLogs:getTimeRangeVehicleBoardMessagesLogs,
                getLastDayVehicleStatusLogs:getLastDayVehicleStatusLogs,
                getTimeRangeVehicleStatusLogs:getTimeRangeVehicleStatusLogs

            }
        }
})();

(function(){
    'use strict';

    angular
        .module('app.utility.adapter')
        .factory('MaintenanceAdapter', MaintenanceAdapter)

        /** @ngInject */
        function MaintenanceAdapter($http,AppSettings,$q) {
            
            function getRecords(params, completionHandler){
                var deferred = $q.defer();

                var queryStringParams = {}
                if(typeof params != "undefined" && Object.keys(params).length>0){
                    queryStringParams = params
                }
                
                $http.get(AppSettings.getBaseUrl() + "/api/maintenance", { params: queryStringParams }).then(
                    function success(response) {

                        console.log("success in MaintenanceAdapter.getRecords");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)


                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in MaintenanceAdapter.getRecords: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }


            function getRecord(id, completionHandler){
                var deferred = $q.defer();

                $http.get(AppSettings.getBaseUrl() + "/api/maintenance/" + id).then(
                    function success(response) {

                        console.log("success in MaintenanceAdapter.getRecord");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)


                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in MaintenanceAdapter.getRecord: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }


            function addRecord(data, completionHandler){
                var deferred = $q.defer();

                $http.post(AppSettings.getBaseUrl() + "/api/maintenance", data).then(
                    function success(response) {

                        console.log("success in MaintenanceAdapter.addRecord");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)


                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in MaintenanceAdapter.addRecord: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }

            function updateRecord(id, data, completionHandler){
                var deferred = $q.defer();

                $http.put(AppSettings.getBaseUrl() + "/api/maintenance/" + id, data).then(
                    function success(response) {

                        console.log("success in MaintenanceAdapter.updateRecord");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)


                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in MaintenanceAdapter.updateRecord: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }


            function finishRecord(id, completionHandler){
                var deferred = $q.defer();

                $http.get(AppSettings.getBaseUrl() + "/api/maintenance/" + id + "/finish").then(
                    function success(response) {

                        console.log("success in MaintenanceAdapter.finishRecord");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)


                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in MaintenanceAdapter.finishRecord: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }

            function getRecordComments(id, completionHandler){
                var deferred = $q.defer();

                $http.get(AppSettings.getBaseUrl() + "/api/maintenance/" + id + "/comment").then(
                    function success(response) {

                        console.log("success in MaintenanceAdapter.getRecordComments");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)


                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in MaintenanceAdapter.getRecordComments: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }
            
            function addCommentToRecord(id, comment, completionHandler){
                var deferred = $q.defer();

                $http.post(AppSettings.getBaseUrl() + "/api/maintenance/" + id + "/comment", comment).then(
                    function success(response) {

                        console.log("success in MaintenanceAdapter.addCommentToRecord");

                        if(typeof completionHandler != "undefined"){
                            completionHandler(response.data.data,null);
                        }

                        deferred.resolve(response.data.data)


                    },function error(response){

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in MaintenanceAdapter.addCommentToRecord: ",error,response);

                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }

                        deferred.reject(error)

                    })
                return deferred.promise
            }
            
            return{
                getRecords: getRecords,
                getRecord: getRecord,
                updateRecord: updateRecord,
                finishRecord: finishRecord,
                addRecord: addRecord,
                getRecordComments: getRecordComments,
                addCommentToRecord: addCommentToRecord
            }
        }
})();
/**
 * Created by alex on 15/05/17.
 */

(function () {

    'use strict';

    angular
        .module('app.utility.adapter')
        .factory('LoginAdapter', LoginAdapterFactory);

    /** @ngInject */
    function LoginAdapterFactory($http,AppSettings) {

        return {
            login: function (dataToSend,completionHandler) {

                $http.post(AppSettings.getBaseUrl() + "/login",dataToSend)
                    .then(function success(response) {

                        console.log("success in LoginAdapterFactory.login");

                        completionHandler(response.data.data,null);

                    },function error(response) {

                        var error = response.data ? response.data.error ? response.data.error : response : response;                     

                        console.log("error in LoginAdapterFactory.login: ",error,response);

                        completionHandler(null,error);
                    })
            },

            loginTempPassword: function (dataToSend,completionHandler) {
                $http.post(AppSettings.getBaseUrl() + "/login-temp-password",dataToSend)
                    .then(function success(response) {
                        console.log("success in LoginAdapterFactory.loginTempPassword");
                        completionHandler(response.data.data,null);

                    },function error(response) {
                        var error = response.data ? response.data.error ? response.data.error : response : response;                     
                        console.log("error in LoginAdapterFactory.loginTempPassword: ",error,response);
                        completionHandler(null,error);
                    })
            }
        }
    }
})();

/**
 * Created by alex on 03/05/18.
 */

(function(){

    'use strict'

    angular.module('app.utility.adapter')
        .factory("DeviceAdapter",DeviceAdapterFactory)

        /** @ngInject */
        function DeviceAdapterFactory(AppSettings,$http,EnrichDataUtility, $q){

            function getDevices(params,completionHandler){

                var paramsQueryString = {}

                if(typeof params != "undefined" && Object.keys(params).length>0){
                    paramsQueryString = params
                }
                
                $http.get(AppSettings.getBaseUrl() + "/api/device",{params:paramsQueryString}).then(
                    function success(response){
                        
                        var devices = response.data.data;
                        EnrichDataUtility.generateDeviceUsefulData(devices.data ? devices.data : devices)
                        console.log("success in DeviceAdapter.getDevices")
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(devices,null);
                        }
                    },
                    function error(response){
                        
                        var error = response.data ? response.data.error ? response.data.error : response : response;                     
                        console.log("error in DeviceAdapter.getDevices: ",error,response);
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }
                    }
                )
            }

            function attachVehicle(deviceId,dataToSend,completionHandler){
                
                if(!deviceId){return}
                dataToSend = dataToSend ? dataToSend : {}

                $http.put(AppSettings.getBaseUrl() + "/api/device/"+deviceId+"/attach",dataToSend).then(
                    function success(response){
                        
                        var data = response.data.data;
                        console.log("success in DeviceAdapter.attachVehicle")
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(data,null);
                        }
                    },
                    function error(response){
                        
                        var error = response.data ? response.data.error ? response.data.error : response : response;                     
                        console.log("error in DeviceAdapter.attachVehicle: ",error,response);
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }
                    }
                )
            }

            function detachVehicle(deviceId,completionHandler){

                if(!deviceId){return}

                $http.put(AppSettings.getBaseUrl() + "/api/device/"+deviceId+"/detach").then(
                    function success(response){
                        
                        var data = response.data.data;
                        console.log("success in DeviceAdapter.detachVehicle")
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(data,null);
                        }
                    },
                    function error(response){
                        
                        var error = response.data ? response.data.error ? response.data.error : response : response;                     
                        console.log("error in DeviceAdapter.detachVehicle: ",error,response);
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }
                    }
                )
            }

            function changeVehicle(deviceId,dataToSend,completionHandler){

                if(!deviceId){return}
                
                dataToSend = dataToSend ? dataToSend : {}

                $http.put(AppSettings.getBaseUrl() + "/api/device/"+deviceId+"/change",dataToSend).then(
                    function success(response){
                        
                        var data = response.data.data;
                        console.log("success in DeviceAdapter.changeVehicle")
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(data,null);
                        }
                    },
                    function error(response){
                        
                        var error = response.data ? response.data.error ? response.data.error : response : response;                     
                        console.log("error in DeviceAdapter.changeVehicle: ",error,response);
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }
                    }
                )
            }

            function unlinkVehicle(deviceId,forced,completionHandler){

                if(!deviceId){return}
                
                forced = forced ? forced : false
                var queryParams = {}
                
                if(forced){
                    queryParams = {force: forced}
                }
                
                $http.delete(AppSettings.getBaseUrl().replace("core-gcp","testing-core-gcp") + "/api/device/"+deviceId+"/unlink",{params: queryParams}).then(
                    function success(response){
                        
                        var data = response.data.data;
                        console.log("success in DeviceAdapter.unlinkVehicle")
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(data,null);
                        }
                    },
                    function error(response){
                        
                        var error = response.data ? response.data.error ? response.data.error : response : response;                     
                        console.log("error in DeviceAdapter.unlinkVehicle: ",error,response);
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }
                    }
                )
            }

            function startOTA(deviceId,completionHandler){

                if(!deviceId){return}
                

                $http.put(AppSettings.getBaseUrl() + "/api/device/"+deviceId+"/ota").then(
                    function success(response){
                        
                        var data = response.data.data;
                        console.log("success in DeviceAdapter.startOTA")
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(data,null);
                        }
                    },
                    function error(response){
                        
                        var error = response.data ? response.data.error ? response.data.error : response : response;                     
                        console.log("error in DeviceAdapter.startOTA: ",error,response);
    
                        if(typeof completionHandler != "undefined"){
                            completionHandler(null,error);
                        }
                    }
                )
            }

            function extractData(deviceId, completionHandler) {
                if(typeof deviceId == "undefined"){
                    console.warn("DeviceAdapter.extractData: no deviceId")
                    return
                }

                var deferred = $q.defer()

                $http.put(AppSettings.getBaseUrl() + "/api/device/" + deviceId + "/engine/on").then(
                    function success(response) {
                        var response = response.data.data;

                        console.log("success in DeviceAdapter.extractData",response);

                        completionHandler(response,null)
                        deferred.resolve(response)

                    },
                    function error(response) {
                        var error = response.data ? response.data.error ? response.data.error : response : response;
                    
                        console.log("error in DeviceAdapter.extractData",error,response);

                        completionHandler(null,error)
                        deferred.reject(error)
                    }
                )
                return deferred.promise
            }

            return{
                getDevices:getDevices,
                attachVehicle:attachVehicle,
                detachVehicle:detachVehicle,
                changeVehicle:changeVehicle,
                unlinkVehicle:unlinkVehicle,
                startOTA:startOTA,
                extractData: extractData,
            }
        }
})();

(function () {
    'use strict';

    angular // this is for formatting
        .module('app.utility.adapter')
        .factory('BonusAdapter', BonusAdapter)
        .factory('CouponBonusAdapter', CouponBonusAdapter);

    /** @ngInject */
    function BonusAdapter(AdapterUtility) {
        function getTemplates(params, completionHandler) {
            AdapterUtility.get(
                {
                    path: '/api/sharing/bonus/template',
                    params: params,
                    callerName: 'BonusAdapter.getTemplates',
                },
                completionHandler
            );
        }

        function getShopItems(params, completionHandler) {
            AdapterUtility.get(
                {
                    path: '/api/sharing/bonus/shop/item',
                    params: params,
                    callerName: 'BonusAdapter.getShopItems',
                },
                completionHandler
            );
        }

        function addTemplate(body, completionHandler) {
            AdapterUtility.post(
                {
                    path: '/api/sharing/bonus/template',
                    body: body,
                    callerName: 'BonusAdapter.addTemplate',
                },
                completionHandler
            );
        }

        function addShopItem(body, completionHandler) {
            AdapterUtility.post(
                {
                    path: '/api/sharing/bonus/shop/item',
                    body: body,
                    callerName: 'BonusAdapter.addShopItem',
                },
                completionHandler
            );
        }

        return {
            getTemplates: getTemplates,
            getShopItems: getShopItems,
            addTemplate: addTemplate,
            addShopItem: addShopItem,
        };
    }

    /** @ngInject */
    function CouponBonusAdapter(AdapterUtility, FiltersRequestParamFactory) {
        const resource = '/api/sharing/bonus/coupon';

        function getTemplate(id, completionHandler) {
            if (typeof id !== 'number') {
                console.warn('CouponBonusAdapter.getTemplate: invalid input', id);
                return;
            }

            AdapterUtility.get(
                {
                    path: resource + '/template/' + id,
                    callerName: 'CouponBonusAdapter.getTemplate',
                },
                completionHandler
            );
        }

        function getTemplates(params, completionHandler) {
            AdapterUtility.get(
                {
                    path: resource + '/template',
                    params: params,
                    callerName: 'CouponBonusAdapter.getTemplates',
                },
                completionHandler
            );
        }

        function getCoupons(params, completionHandler) {
            AdapterUtility.get(
                {
                    path: resource,
                    params: params,
                    callerName: 'CouponBonusAdapter.getCoupons',
                },
                completionHandler
            );
        }

        function getTemplateCoupons(templateId, params, completionHandler) {
            if (templateId == undefined) {
                console.warn('getTemplateCoupons: invalid input templateId', templateId);
                return;
            }
            // TODO use utility fn in utility.service to create the filter and the request param filter itself
            // NOTE maybe the server should expose the template/id/coupons endpoint!
            if (params.filters && Object.keys(params.filters).length > 0) {
                if (params.filters._self && Object.keys(params.filters._self).length > 0) {
                    params.filters = FiltersRequestParamFactory.createAnAndFilter([
                        { _self: { CouponTemplateId: templateId } },
                        params.filters,
                    ]);
                } else {
                    params.filters = { _self: { CouponTemplateId: templateId } };
                }
            } else {
                params.filters = { _self: { CouponTemplateId: templateId } };
            }
            AdapterUtility.get(
                {
                    path: resource,
                    params: params,
                    callerName: 'CouponBonusAdapter.getTemplateCoupons',
                },
                completionHandler
            );
        }

        function addTemplate(body, completionHandler) {
            AdapterUtility.post(
                {
                    path: resource + '/template',
                    body: body,
                    callerName: 'CouponBonusAdapter.addTemplate',
                },
                completionHandler
            );
        }

        function addCoupon(body, completionHandler) {
            AdapterUtility.post(
                {
                    path: resource,
                    body: body,
                    callerName: 'CouponBonusAdapter.addCoupon',
                },
                completionHandler
            );
        }

        return {
            getTemplate: getTemplate,
            getTemplates: getTemplates,
            getCoupons: getCoupons,
            getTemplateCoupons: getTemplateCoupons,
            addTemplate: addTemplate,
            addCoupon: addCoupon,
        };
    }
})();

/**
 * Created by alex on 10/01/17.
 */

(function () {

    'use strict';

    angular.module('app.utility.adapter')
        .factory('RentalAnalyticsAdapter',RentalAnalyticsAdapter)
        .factory('VehicleAnalyticsAdapter',VehicleAnalyticsAdapter)
        .factory('RideAnalyticsAdapter',RideAnalyticsAdapter)
        .factory('TripAnalyticsAdapter',TripAnalyticsAdapter)
        .factory('BusinessAnalyticsAdapter',BusinessAnalyticsAdapter)
        .factory('UserAnalyticsAdapter',UserAnalyticsAdapter)
        .factory('VehicleObdAnalyticsAdapter',VehicleObdAnalyticsAdapter);

    /** @ngInject */
    function RentalAnalyticsAdapter($http,AppSettings) {

        function getDailyRentalUsage (fromDate,toDate,completionHandler){

            var dataToSend = {
                start: fromDate.getTime(),
                end: toDate.getTime()
            };

            $http.post(AppSettings.getBaseUrl() + "/api/rent/analytics/rental",dataToSend).then(
                function success(response) {

                    var rentalUsage = response.data.data;

                    console.log("success in AnalyticsRentAdapter.getRentUsage ");

                    if(typeof completionHandler != "undefined")
                        completionHandler(rentalUsage,null);


                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in AnalyticsRentAdapter.getRentUsage ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            );

        }

        function getDailyIdle(fromDate,toDate,completionHandler) {

            var dataToSend = {
                start: fromDate.getTime(),
                end: toDate.getTime()
            };

            $http.post(AppSettings.getBaseUrl() + "/api/rent/analytics/idle",dataToSend).then(
                function success(response) {

                    var idleDays = response.data.data;

                    console.log("success in AnalyticsRentAdapter.getIdleDays ");

                    if(typeof completionHandler != "undefined")
                        completionHandler(idleDays,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in AnalyticsRentAdapter.getIdleDays ",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);


                }
            );

        }


        return {
            getDailyRentalUsage: getDailyRentalUsage,
            getDailyIdle: getDailyIdle
        }
    }

    /** @ngInject */
    function VehicleAnalyticsAdapter($http,AppSettings,$q) {

        function getDailyCoveredDistance(fromDate,toDate,completionHandler) {

            var deferred = $q.defer();
            
            var dataToSend = {
                start: fromDate.getTime(),
                end: toDate.getTime()
            };

            $http.post(AppSettings.getBaseUrl() + "/api/rent/analytics/covered/distance",dataToSend).then(
                function success(response) {
                    
                    var dailyCoveredDistance = response.data.data;

                    console.log("success in VehicleAnalyticsAdapter.getDailyCoveredDistance");

                    if(typeof completionHandler != "undefined")
                        completionHandler(dailyCoveredDistance,null);

                    deferred.resolve(dailyCoveredDistance)
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleAnalyticsAdapter.getCoveredDistance",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error)

                    deferred.reject(error)
                }
            )

        }

        function getDailyAverageConsumption(fromDate,toDate,completionHandler) {

            var deferred = $q.defer();

            var dataToSend = {
                start: fromDate.getTime(),
                end: toDate.getTime()
            };

            $http.post(AppSettings.getBaseUrl() + "/api/rent/analytics/consumption/daily",dataToSend).then(
                function success(response) {

                    var dailyConsumption = response.data.data;

                    console.log("success in VehicleAnalyticsAdapter.getDailyAverageConsumption")

                    if(typeof completionHandler != "undefined")
                        completionHandler(dailyConsumption,null);

                    deferred.resolve(dailyConsumption);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleAnalyticsAdapter.getDailyAverageConsumption",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error)

                }
            )
        }

        function getCurrentVehiclesStatus(completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/rent/analytics/vehicle/info").then(
                function success(response) {

                    var currentVehicleStatus = response.data.data;

                    console.log("success in VehicleAnalyticsAdapter.getCurrentVehiclesStatus")

                    if(typeof completionHandler != "undefined")
                        completionHandler(currentVehicleStatus,null);

                    deferred.resolve(currentVehicleStatus);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleAnalyticsAdapter.getCurrentVehiclesStatus",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error);

                }
            )
        }

        function getFleetStatus(completionHandler){
            var deferred = $q.defer()
            var url = AppSettings.getBaseUrl() + "/api/analytics/fleet"
            $http.get(url).then(function(response){
                    var fleetStatus = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getFleetStatus")
                    if(typeof completionHandler != "undefined"){
                        completionHandler(fleetStatus, null)
                    }
                    deferred.resolve(fleetStatus)
                },
                function(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getFleetStatus", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getActiveScooters(completionHandler){
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/fleet/active").then(
                function success(response){
                    var activeScooters = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getActiveScooters")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(activeScooters, null)
                    }
                    deferred.resolve(activeScooters)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getActiveScooters", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getInactiveScooters(completionHandler){
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/fleet/inactive").then(
                function success(response){
                    var inactiveScooters = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getInactiveScooters")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(inactiveScooters, null)
                    }
                    deferred.resolve(inactiveScooters)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getInactiveScooters", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getScootersInMaintenance(completionHandler){
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/fleet/maintenance").then(
                function success(response){
                    var scootersInMaintenance = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getScootersInMaintenance")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(scootersInMaintenance, null)
                    }
                    deferred.resolve(scootersInMaintenance)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getScootersInMaintenance", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getFullBatteries(completionHandler){
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/fleet/battery/full").then(
                function success(response){
                    var fullBatteries = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getFullBatteries")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(fullBatteries, null)
                    }
                    deferred.resolve(fullBatteries)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getFullBatteries", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getBatteriesUpToFiftyPercent(completionHandler){
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/fleet/battery/50").then(
                function success(response){
                    var batteries = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getBatteriesUpToFiftyPercent")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(batteries, null)
                    }
                    deferred.resolve(batteries)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getBatteriesUpToFiftyPercent", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getLowBatteries(completionHandler){
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/fleet/battery/swap/low").then(
                function success(response){
                    var batteries = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getLowBatteries")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(batteries, null)
                    }
                    deferred.resolve(batteries)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getLowBatteries", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getCriticalLowBatteries(completionHandler){
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/fleet/battery/swap/high").then(
                function success(response){
                    var batteries = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getCriticalLowBatteries")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(batteries, null)
                    }
                    deferred.resolve(batteries)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getCriticalLowBatteries", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getVehicleInterventionNeeded(completionHandler){
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/fleet/intervention").then(
                function success(response){
                    var batteries = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getVehicleInterventionNeeded")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(batteries, null)
                    }
                    deferred.resolve(batteries)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getVehicleInterventionNeeded", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getVehicleInError(completionHandler){
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/fleet/error").then(
                function success(response){
                    var batteries = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getVehicleInError")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(batteries, null)
                    }
                    deferred.resolve(batteries)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getVehicleInError", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getVehiclesStatus(completionHandler) {
            var deferred = $q.defer()
            $http.get(AppSettings.getBaseUrl() + "/api/analytics/vehicle/status").then(
                function success(response){
                    var vehiclesStatus = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getVehiclesStatus")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(vehiclesStatus, null)
                    }
                    deferred.resolve(vehiclesStatus)
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getVehiclesStatus", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                    deferred.reject(error)
                }
            )
        }

        function getVehiclesOnline(completionHandler) {

            $http.get(AppSettings.getBaseUrl() + "/api/analytics/vehicle/status/online").then(
                function success(response){
                    var vehiclesOnline = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getVehiclesOnline")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(vehiclesOnline, null)
                    }
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getVehiclesOnline", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                }
            )
        }

        function getVehiclesOfflineFrom(startTime,completionHandler) {

            if(!startTime){
                console.warn("No starTime param in VehicleAnalyticsAdapter.getVehiclesOfflineFrom")
                return
            }

            $http.get(AppSettings.getBaseUrl() + "/api/analytics/vehicle/status/offline/from",{params: {time: startTime}}).then(
                function success(response){
                    var vehiclesOfflineFrom = response.data.data
                    console.log("success in VehicleAnalyticsAdapter.getVehiclesOfflineFrom")

                    if(typeof completionHandler != "undefined"){
                        completionHandler(vehiclesOfflineFrom, null)
                    }
                },
                function error(response){
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in VehicleAnalyticsAdapter.getVehiclesOfflineFrom", error, response)

                    if(typeof completionHandler != "undefined"){
                        completionHandler(null, error)
                    }
                }
            )
        }

        return{
            getDailyCoveredDistance:getDailyCoveredDistance,
            getDailyAverageConsumption:getDailyAverageConsumption,
            getCurrentVehiclesStatus:getCurrentVehiclesStatus,
            getActiveScooters: getActiveScooters,
            getInactiveScooters: getInactiveScooters,
            getScootersInMaintenance: getScootersInMaintenance,
            getFullBatteries: getFullBatteries,
            getBatteriesUpToFiftyPercent: getBatteriesUpToFiftyPercent,
            getLowBatteries: getLowBatteries,
            getCriticalLowBatteries: getCriticalLowBatteries,
            getFleetStatus: getFleetStatus,
            getVehicleInterventionNeeded: getVehicleInterventionNeeded,
            getVehicleInError: getVehicleInError,
            getVehiclesStatus: getVehiclesStatus,
            getVehiclesOnline: getVehiclesOnline,
            getVehiclesOfflineFrom: getVehiclesOfflineFrom
        };
    }

    /** @ngInject */
    function RideAnalyticsAdapter($http,AppSettings) {

        var resourcePath = "/api/analytics/booking"

        function getAnalyticsResource(resource,filter,completionHandler) {

            var url = AppSettings.getBaseUrl()+resourcePath+"/"+resource + (filter =="hour" ? "": "/"+filter);

            $http.get(url).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in RideAnalyticsAdapter.get"+filter.toUpperCase()+ " " +resource)

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RideAnalyticsAdapter.get" +filter.toUpperCase()+ " " +resource,error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        function getBusinessAnalyticsResource(resource,filter,completionHandler) {

            var url = AppSettings.getBaseUrl()+"/api/analytics/business/"+resource + (filter =="hour" ? "": "/"+filter);

            $http.get(url).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in RideAnalyticsAdapter.get"+filter.toUpperCase()+ " " +resource)

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RideAnalyticsAdapter.get" +filter.toUpperCase()+ " " +resource,error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        function getAverageScooterRides(filter,completionHandler) {
            getAnalyticsResource("ride",filter,completionHandler)
        }
        function getHourlyAverageScooterRides(completionHandler) {
            getAverageScooterRides("hour",completionHandler)
        }
        function getDailyAverageScooterRides(completionHandler) {
            getAverageScooterRides("day",completionHandler)
        }
        function getMonthlyAverageScooterRides(completionHandler) {
            getAverageScooterRides("month",completionHandler)
        }
        function getYearlyAverageScooterRides(completionHandler) {
            getAverageScooterRides("year",completionHandler)
        }

        function getTotalRides(filter,completionHandler) {
            getAnalyticsResource("total",filter,completionHandler)
        }
        function getHourlyTotalRides(completionHandler) {
            getTotalRides("hour",completionHandler)
        }
        function getDailyTotalRides(completionHandler) {
            getTotalRides("day",completionHandler)
        }
        function getMonthlyTotalRides(completionHandler) {
            getTotalRides("month",completionHandler)
        }
        function getYearlyTotalRides(completionHandler) {
            getTotalRides("year",completionHandler)
        }

        function getAverageTotalRidesDistance(filter,completionHandler) {
            getAnalyticsResource("distance",filter,completionHandler)
        }
        function getHourlyAverageTotalRidesDistance(completionHandler) {
            getAverageTotalRidesDistance("hour",completionHandler)
        }
        function getDailyAverageTotalRidesDistance(completionHandler) {
            getAverageTotalRidesDistance("day",completionHandler)
        }
        function getMonthlyAverageTotalRidesDistance(completionHandler) {
            getAverageTotalRidesDistance("month",completionHandler)
        }
        function getYearlyAverageTotalRidesDistance(completionHandler) {
            getAverageTotalRidesDistance("year",completionHandler)
        }

        function getAverageTotalRidesTime(filter,completionHandler) {
            getAnalyticsResource("time",filter,completionHandler)
        }
        function getHourlyAverageTotalRidesTime(completionHandler) {
            getAverageTotalRidesTime("hour",completionHandler)
        }
        function getDailyAverageTotalRidesTime(completionHandler) {
            getAverageTotalRidesTime("day",completionHandler)
        }
        function getMonthlyAverageTotalRidesTime(completionHandler) {
            getAverageTotalRidesTime("month",completionHandler)
        }
        function getYearlyAverageTotalRidesTime(completionHandler) {
            getAverageTotalRidesTime("year",completionHandler)
        }

        function getFreeRidesTime(filter, completionHandler){
            getBusinessAnalyticsResource("economics/free", filter, completionHandler)
        }

        function getPaidRidesTime(filter, completionHandler){
            getBusinessAnalyticsResource("economics/payer", filter, completionHandler)
        }
        //////////heatmap

        function getHeatmapStartingPoints(completionHandler){
            var url = AppSettings.getBaseUrl() + "/api/analytics/heatmap/start"
            $http.get(url).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in RideAnalyticsAdapter.getHeatmapStartingPoints")

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RideAnalyticsAdapter.getHeatmapStartingPoints");

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        function getHeatmapFinishPoints(completionHandler){
            var url = AppSettings.getBaseUrl() + "/api/analytics/heatmap/finish"
            $http.get(url).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in RideAnalyticsAdapter.getHeatmapFinishPoints")

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in RideAnalyticsAdapter.getHeatmapFinishPoints");

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        return {
            getAverageScooterRides:getAverageScooterRides,
            getHourlyAverageScooterRides:getHourlyAverageScooterRides,
            getDailyAverageScooterRides:getDailyAverageScooterRides,
            getMonthlyAverageScooterRides:getMonthlyAverageScooterRides,
            getYearlyAverageScooterRides:getYearlyAverageScooterRides,
            getTotalRides:getTotalRides,
            getHourlyTotalRides:getHourlyTotalRides,
            getDailyTotalRides:getDailyTotalRides,
            getMonthlyTotalRides:getMonthlyTotalRides,
            getYearlyTotalRides:getYearlyTotalRides,
            getAverageTotalRidesDistance:getAverageTotalRidesDistance,
            getHourlyAverageTotalRidesDistance:getHourlyAverageTotalRidesDistance,
            getDailyAverageTotalRidesDistance:getDailyAverageTotalRidesDistance,
            getMonthlyAverageTotalRidesDistance:getMonthlyAverageTotalRidesDistance,
            getYearlyAverageTotalRidesDistance:getYearlyAverageTotalRidesDistance,
            getAverageTotalRidesTime:getAverageTotalRidesTime,
            getHourlyAverageTotalRidesTime:getHourlyAverageTotalRidesTime,
            getDailyAverageTotalRidesTime:getDailyAverageTotalRidesTime,
            getMonthlyAverageTotalRidesTime:getMonthlyAverageTotalRidesTime,
            getYearlyAverageTotalRidesTime:getYearlyAverageTotalRidesTime,
            getFreeRidesTime: getFreeRidesTime,
            getPaidRidesTime: getPaidRidesTime,
            getHeatmapStartingPoints: getHeatmapStartingPoints,
            getHeatmapFinishPoints: getHeatmapFinishPoints
        }

    }

    /** @ngInject */
    function TripAnalyticsAdapter($http,AppSettings) {
        var resourcePath ="/api/analytics/trip"

        function getTripsStatus(completionHandler) {

            var url = AppSettings.getBaseUrl()+resourcePath+'/status'

            $http.get(url).then(
                function success(response) {

                    var response = response.data.data;
                    console.log("success in TripAnalyticsAdapter.getTripsStatus")

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);
                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in TripAnalyticsAdapter.getTripsStatus");

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                }
            )
        }
        return{
            getTripsStatus: getTripsStatus
        }
    }

    /** @ngInject */
    function BusinessAnalyticsAdapter($http,AppSettings) {

        var resourcePath ="/api/analytics/business/economics"

        function getAnalyticsResource(resource,filter,completionHandler) {

            var url = AppSettings.getBaseUrl()+resourcePath+"/"+resource + (filter =="hour" ? "": "/"+filter);

            $http.get(url).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in BusinessAnalyticsAdapter.get"+filter.toUpperCase()+ " " +resource)

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in BusinessAnalyticsAdapter.get" +filter.toUpperCase()+ " " +resource,error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        ///TotalGeneratedRevenues

        function getTotalBillableMinutes(filter,completionHandler){
            getAnalyticsResource("billable",filter,completionHandler)
        }
        function getHourlyTotalBillableMinutes(completionHandler) {
            getTotalBillableMinutes("hour",completionHandler)
        }
        function getDailyTotalBillableMinutes(completionHandler) {
            getTotalBillableMinutes("day",completionHandler)
        }
        function getMonthlyTotalBillableMinutes(completionHandler) {
            getTotalBillableMinutes("month",completionHandler)
        }
        function getYearlyTotalBillableMinutes(completionHandler) {
            getTotalBillableMinutes("year",completionHandler)
        }

        ///TotalGeneratedRevenues

        function getTotalGeneratedRevenues(filter,completionHandler){
            getAnalyticsResource("revenue",filter,completionHandler)
        }
        function getHourlyTotalGeneratedRevenues(completionHandler) {
            getTotalGeneratedRevenues("hour",completionHandler)
        }
        function getDailyTotalGeneratedRevenues(completionHandler) {
            getTotalGeneratedRevenues("day",completionHandler)
        }
        function getMonthlyTotalGeneratedRevenues(completionHandler) {
            getTotalGeneratedRevenues("month",completionHandler)
        }
        function getYearlyTotalGeneratedRevenues(completionHandler) {
            getTotalGeneratedRevenues("year",completionHandler)
        }

        ///TotalFreeRides

        function getTotalFreeRides(filter,completionHandler){
            getAnalyticsResource("free",filter,completionHandler)
        }
        function getHourlyTotalFreeRides(completionHandler) {
            getTotalFreeRides("hour",completionHandler)
        }
        function getDailyTotalFreeRides(completionHandler) {
            getTotalFreeRides("day",completionHandler)
        }
        function getMonthlyTotalFreeRides(completionHandler) {
            getTotalFreeRides("month",completionHandler)
        }
        function getYearlyTotalFreeRides(completionHandler) {
            getTotalFreeRides("year",completionHandler)
        }


        return{
            getTotalBillableMinutes:getTotalBillableMinutes,
            getHourlyTotalBillableMinutes:getHourlyTotalBillableMinutes,
            getDailyTotalBillableMinutes:getDailyTotalBillableMinutes,
            getMonthlyTotalBillableMinutes:getMonthlyTotalBillableMinutes,
            getYearlyTotalBillableMinutes:getYearlyTotalBillableMinutes,
            getTotalGeneratedRevenues:getTotalGeneratedRevenues,
            getHourlyTotalGeneratedRevenues:getHourlyTotalGeneratedRevenues,
            getDailyTotalGeneratedRevenues:getDailyTotalGeneratedRevenues,
            getMonthlyTotalGeneratedRevenues:getMonthlyTotalGeneratedRevenues,
            getYearlyTotalGeneratedRevenues:getYearlyTotalGeneratedRevenues,
            getTotalFreeRides:getTotalFreeRides,
            getHourlyTotalFreeRides:getHourlyTotalFreeRides,
            getDailyTotalFreeRides:getDailyTotalFreeRides,
            getMonthlyTotalFreeRides:getMonthlyTotalFreeRides,
            getYearlyTotalFreeRides:getYearlyTotalFreeRides
        }
    }

    /** @ngInject */
    function UserAnalyticsAdapter($http,AppSettings) {

        var resourcePath ="/api/analytics/user"

        function getAnalyticsResource(resource,filter,completionHandler) {

            var url = AppSettings.getBaseUrl()+resourcePath+"/"+resource + (filter =="hour" ? "": "/"+filter);

            $http.get(url).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in UserAnalyticsAdapter.get"+filter.toUpperCase()+ " " +resource)

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAnalyticsAdapter.get" +filter.toUpperCase()+ " " +resource,error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        function getUsersAnalytics(completionHandler){
            var url = AppSettings.getBaseUrl() + "/api/analytics/user"
            $http.get(url).then(
                function success(response) {

                    var response = response.data.data;

                    console.log("success in UserAnalyticsAdapter.getUsersAnalytics")

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in UserAnalyticsAdapter.getUsersAnalytics");

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                }
            )
        }

        function getYearlyLeadUsers(completionHandler){
            getAnalyticsResource("lead","year",completionHandler);
        }

        function getYearlyMissingPersonalInfoUsers(completionHandler){
            getAnalyticsResource("missing/personal","year",completionHandler);
        }
        function getYearlyMissingDocumentsUsers(completionHandler){
            getAnalyticsResource("missing/document","year",completionHandler);
        }

        function getYearlyMissingCreditCardUsers(completionHandler){
            getAnalyticsResource("missing/creditcard","year",completionHandler);
        }

        function getYearlyRegisteredUsers(completionHandler){
            getAnalyticsResource("registered","year",completionHandler);
        }

        function getYearlyActiveUsers(completionHandler){
            getAnalyticsResource("active","year",completionHandler);
        }

        function getUsersStatus(completionHandler) {
            var url = AppSettings.getBaseUrl() + "/api/analytics/user/status"
            $http.get(url).then(
                function success(response) {
                    var response = response.data.data;
                    console.log("success in UserAnalyticsAdapter.getUsersStatus")

                    if(typeof completionHandler != "undefined")
                        completionHandler(response,null);
                },
                function error(response) {
                    var error = response.data ? response.data.error ? response.data.error : response : response;                     
                    console.log("error in UserAnalyticsAdapter.getUsersStatus");

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);
                }
            )
        }

        return{
            getUsersAnalytics: getUsersAnalytics,
            getYearlyLeadUsers:getYearlyLeadUsers,
            getYearlyMissingPersonalInfoUsers:getYearlyMissingPersonalInfoUsers,
            getYearlyMissingDocumentsInfoUsers:getYearlyMissingDocumentsUsers,
            getYearlyMissingCreditCardInfoUsers:getYearlyMissingCreditCardUsers,
            getYearlyRegisteredUsers:getYearlyRegisteredUsers,
            getYearlyActiveUsers:getYearlyActiveUsers,
            getUsersStatus:getUsersStatus
        }
    }

    /** @ngInject */
    function VehicleObdAnalyticsAdapter($http,AppSettings,$q) {

        function getObdParams(vehicleId,completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/personal/vehicle/"+vehicleId+"/obd/pid").then(
                function success(response) {

                    var vehicleObdParams = response.data.data;

                    console.log("success in VehicleObdAnalyticsAdapter.getObdParams")

                    if(typeof completionHandler != "undefined")
                        completionHandler(vehicleObdParams,null);

                    deferred.resolve(vehicleObdParams);

                },
                function error(response) {

                    var error = response.data ? response.data.error ? response.data.error : response : response;                     

                    console.log("error in VehicleObdAnalyticsAdapter.getObdParams",error,response);

                    if(typeof completionHandler != "undefined")
                        completionHandler(null,error);

                    deferred.reject(error);
                }
            )
        }

        function getLastObdParamValues(vehicleId,obdParamId,limitTo,completionHandler) {

            var deferred = $q.defer();

            $http.get(AppSettings.getBaseUrl() + "/api/personal/vehicle/"+vehicleId+"/obd/pid/"+obdParamId,{
                params:{limit:limitTo}
            }).then(function success(response) {

                var lastVehicleObdParamValues = response.data.data;

                console.log("success in VehicleObdAnalyticsAdapter.getLastObdParamValues");

                if(typeof completionHandler != "undefined")
                    completionHandler(lastVehicleObdParamValues,null)

                deferred.resolve(lastVehicleObdParamValues);


            },function error(response) {

                var error = response.data ? response.data.error ? response.data.error : response : response;                     

                console.log("error in VehicleObdAnalyticsAdapter.getLastObdParamValues",error,response);

                if(typeof completionHandler != "undefined")
                    completionHandler(null,error);

                deferred.reject(error);

            })

        }

        return{
            getObdParams:getObdParams,
            getLastObdParamValues:getLastObdParamValues
        }
    }

})();
(function(){
    'use strict'

    angular
        .module('app.utility')
        .service("PermissionsManager", PermissionsManager)

    /** @ngInject */
    function PermissionsManager(UserAdapter, SessionStorageService, HttpHeadersManager, MiscData){
        var self = this
        var timer = null
        var roles = null
        this.stopUpdating = false

        function updatePermissions(){
            if(self.stopUpdating){ return }

            var userId = SessionStorageService.getItem(MiscData.USERID)

            if(!userId || (!HttpHeadersManager.getHeaders().Authorization || !HttpHeadersManager.getHeaders()["X-SERVICE-TOKEN"])){
                timer = setTimeout(function() {
                    updatePermissions()
                }, 1000)
                return
            }

            UserAdapter.getUserRoles(userId, function(response, error){
                if(!error){
                    roles = response
                    console.log("Current user roles",roles)
                    timer = setTimeout(function() {
                        updatePermissions()
                    }, (60000 * 5))
                }else{
                    //check if the error is for internet connection or not (Object)
                    if(!(error instanceof Object)){
                        timer = setTimeout(function() {
                            updatePermissions()
                        },1000)
                    }
                }
            })
        }

        //TODO: use this method to prevent first updatePermissions failing when user logs out and then log in again
        this.stopUpdatePermissions = function(){
            clearTimeout(timer)
        }

        this.canIReachSection = function(state, action){
            console.warn("Checking permissions for", state, action)
            return true
        }
        
        //TODO re-activate when app uses user's roles
        // updatePermissions()
    }

})();
(function ()
{
    'use strict';

    angular.module("app.trip.list", [])
        .config(config)
        .value('TripsListPage','app.trip.list');

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.trip.list',{
                url  : '/trip-list',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/trip/tripList/trip-list-view.html',
                        controller : 'TripListViewController as vm'
                    }
                },
                params:{
                    searchFor: null
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/vehicle');
    }

})();
(function(){
    'use strict';
    angular.module('app.trip.list')
        .controller('TripListViewController', TripListViewController)

    /** @ngInject */
    function TripListViewController(TripsAdapter,$scope,$state,TripDetailsPage,TripsListMapPage,VehicleTripStatus,VehicleBookingStatus,FiltersFactory,OrderRequestParamFactory,SitesService,ServiceSettings,MiscUtility,ErrorUtility,AppConfigurations){
        var vm = this

        vm.tripsViewed = "..."
        vm.trips = []
        vm.allTripsLength = "..."
        vm.allTripsEnabled = false

        vm.vehicleTripStatus = VehicleTripStatus
        vm.vehicleBookingStatus = VehicleBookingStatus

        vm.dateFilters = {
            start: null,
            end: null
        }

        vm.filters = {
            // tripStatus: FiltersFactory.createTripWithStatusFilter(),
            // tripStartDate: FiltersFactory.createTripWithStartDateFilter(),
            // tripEndDate: FiltersFactory.createTripWithEndDateFilter()
        }

        vm.selectedSearchFilter = null
        vm.searchFilters = {
            tripId: FiltersFactory.createTripWithIdFilter(),
            tripVehicleReferenceCode: FiltersFactory.createTripWithVehicleReferenceCodeFilter(),
            tripVehicleId: FiltersFactory.createTripWithVehicleIdFilter(),
            tripVehicleLicensePlate: FiltersFactory.createTripWithVehicleLicensePlateFilter(),
            tripVehicleType: FiltersFactory.createTripWithVehicleTypeFilter(),
            tripDeviceType: FiltersFactory.createTripWithDeviceTypeFilter(),
            tripUserId: FiltersFactory.createTripWithUserIdFilter(),
            tripUser: FiltersFactory.createTripWithUserFilter(),
            tripStatus: FiltersFactory.createTripWithStatusFilter(),
            tripRange: FiltersFactory.createTripWithDatesRangeFilter(),
        }

        vm.filterRequestParam = null
        vm.orderRequestParam = null
        vm.selectedOrderBy = {orderBy: OrderRequestParamFactory.orderByTripStart, ascOrder: false}


        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })
        
        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){                    
                    SitesService.getSites(function(){
                        vm.todayDate = MiscUtility.serviceTodayDate(SitesService.getSelectedSite())
                        vm.tableFields = AppConfigurations.getTripListTableFields()
                    })
                }
            });
        }
        
        init();

        $scope.$on('siteChanged', function (site) {
            console.log('siteChanged in trips')
            vm.applyFiltersTrigger();
        })

        vm.refreshTrips = refreshTrips
        vm.goToTripsListMapView = goToTripsListMapView
        vm.goToTripDetails = goToTripDetails
        // vm.resetFilters = resetFilters
        vm.openMenu = openMenu
        vm.isAfilterSelected = FiltersFactory.isAfilterSelected
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger

        function refreshTrips (paginationRequestParam,callback,updateInterface){
            if(updateInterface === undefined) {
                updateInterface = true;
            }
            if(updateInterface) {
                vm.tripsViewed = "..."
                vm.allTripsLength = "..."
            }
            // if($stateParams.searchFor) {
            //     console.log("stateParams",$stateParams.searchFor)
            //     vm.applyFiltersTrigger($stateParams.searchFor)
            //     $stateParams.searchFor = null;
            // } else {
            TripsAdapter.getTrips(
                paginationRequestParam,
                function(data,error){
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Get Trips List',description:'Error while getting the trips list!'})

                        if (callback !== undefined) {
                            callback(data, error)
                        }
                    }else{
                        if(updateInterface){
                            var trips = (typeof data.data !== "undefined") ? data.data : data
                            vm.allTripsLength = (typeof data.count !== "undefined") ? data.count : data.length
                            vm.tripsViewed = trips.length
                            vm.trips = trips
                        }

                        if (callback !== undefined) {
                            callback(data, error)
                        }
                    }
                }
            )
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger(){
            vm.applyFiltersTrigger();
        }

        // function resetFilters(){
        //     resetStaticFilters()
        // }

        // function resetStaticFilters(){
        //     for(var key in vm.filters){
        //         vm.filters[key].selected = null
        //     }
        //     vm.applyFiltersTrigger();
        // }

        function goToTripsListMapView(trip) {
            if(trip){
                $state.go(TripsListMapPage,{searchFor: {filterKey: 'id', value: trip.id }})
            }
            else{
                $state.go(TripsListMapPage)
            }
        }

        function goToTripDetails(trip) {
            $state.go(TripDetailsPage,{tripId: trip.id});
        }

        function openMenu(mdMenu,ev) {
            mdMenu.open(ev)
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user')
        .controller('UserChangeFreeMinutesDialogController', UserChangeFreeMinutesDialogController);
    /** @ngInject */

    function UserChangeFreeMinutesDialogController($mdDialog, User, UserAdapter, UserUtility, SweetAlert, ErrorUtility, MiscUtility){

        var vm = this;

        // Data
        vm.user = angular.copy(User)
        vm.creditToChangeDisplayed = 0
        var creditToChange = 0
        var userFreeCredit = generateUserFreeCredit(vm.user)
        vm.newUserFreeCredit = userFreeCredit
        
        // Methods
        vm.closeDialog = closeDialog
        vm.calculateUserFreeCredit = calculateUserFreeCredit
        vm.callChangeUserFreeCredit = callChangeUserFreeCredit

        vm.parseFreeCredit = function(credit){
            return parseInt(credit)
        }
        vm.getUserFreeCredit = generateUserFreeCredit

        function generateUserFreeCredit(user) {
            const credit = UserUtility.getUserFreeCredit(user)
            if(credit == null){
                console.warn("invalid converted credit")
                ErrorUtility.showErrorMessage({title: 'Change user free credit', description: 'Error while setting the environment'})
                return null
            }
            return credit
        }

        function calculateUserFreeCredit () {
            var total = 0

            if(typeof vm.creditToChangeDisplayed !== "number"){
                creditToChange = vm.creditToChangeDisplayed = 0
            }
            creditToChange = vm.creditToChangeDisplayed
            total = Math.floor((userFreeCredit * 100) + (vm.creditToChangeDisplayed * 100))
            total = total/100
            
            //handle decimals
            if(total < 1){
                vm.newUserFreeCredit = 0
                creditToChange = -userFreeCredit
            }else{
                vm.newUserFreeCredit = total
            }
        }
        function callChangeUserFreeCredit() {

            if(typeof vm.user.id !== "number" || typeof creditToChange !== "number"){
                console.log("callChangeUserFreeCredit: invalid input")
                return
            }

            if(Math.abs(creditToChange) == 0){
                ErrorUtility.showErrorMessage({title: 'Change user free credit', description: 'Wrong credit amount!'})
                return
            }

            var actionType = "Add"
            if(creditToChange < 0){
                actionType = "Remove"
            }
            const milliseconds = MiscUtility.generateMillisecondsValue(creditToChange, vm.user.SiteId)
            if(milliseconds == null){
                ErrorUtility.showErrorMessage({title: 'Change user free credit', description: 'Error while changing the user free credit'})
                return
            }

            var dataToSend = {
                value: Math.abs(milliseconds)
            }

            // console.log("dataToSend",dataToSend)
            vm.isLoading = true
            if(actionType == "Remove") {
                UserAdapter.removeFreeMillis(vm.user.id, dataToSend, function(response, error){
                    vm.isLoading = false
                    if(error){
                        ErrorUtility.showErrorMessage({title: actionType + ' user free credit', description: 'Error while changing the user free credit'})
                    }else{
                        SweetAlert.swal( actionType + ' user free credit', 'Successfully removed ' + Math.abs(creditToChange) + ' from free credit', 'success')
                        closeDialog(true)
                    }
                })
            } else {
                UserAdapter.addFreeMillis(vm.user.id, dataToSend, function(response, error){
                    vm.isLoading = false
                    if(error){
                        ErrorUtility.showErrorMessage({title: actionType + ' user free credit', description: 'Error while changing the user free credit'})
                    }else{
                        SweetAlert.swal( actionType + ' user free credit', 'Successfully added ' + Math.abs(creditToChange) + ' to free credit', 'success')
                        closeDialog(true)
                    }
                })
            }

        }
        /**
         * Close dialog
         */
        function closeDialog(response) {
            $mdDialog.hide(response)
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user')
        .controller('AddUserDialogController', AddUserDialogController);

    /** @ngInject */
    function AddUserDialogController($scope,$mdDialog,UserAdapter,SweetAlert,$state,ServiceSettings,MiscUtility,SitesService,ErrorUtility,UserDetailsPage,DefaultSite){

        var vm = this;
        vm.disableSiteChange = false;
        vm.user = {};

        $scope.$on('refreshServiceSettings', function (event) {
            init();
        })
        
        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    SitesService.getSites(function(sites){
                        vm.sites = sites;
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        //prevent site change for admin site restricted and no_acl error in the backend 
                        if(vm.selectedSiteId !== DefaultSite.id){
                            vm.disableSiteChange = true;
                        }
                        //set current selected site
                        vm.user.SiteId = vm.selectedSiteId;
                        
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                    })
                }
            });
        }
        
        init();

        // Methods
        vm.callAddUser = callAddUser;        
        vm.closeDialog = closeDialog;

        function callAddUser() {

            // console.log("user to add", vm.user)
            var dataToSend = angular.copy(vm.user)
            
            if (vm.user.SiteId == DefaultSite.id) {
                delete dataToSend.SiteId
            }
            // console.log("datatosend",dataToSend)

            UserAdapter.registerAdmin(dataToSend,
                function (newUser, error){
                    if (error) {
                        ErrorUtility.showErrorMessage(
                            {
                                title: 'Register an Admin',
                                description: error.type && error.type == "no_acl" ? "You can't register an admin in a different site!" : error.type && error.type == "user_exist" ? "A user with this email already exists!" : 'Error while registering the admin!'
                            }
                        );

                    } else {
                        SweetAlert.swal("Register an Admin", "Admin successfully registered!", "success");
                        if(newUser && newUser.user && newUser.user.id){
                            showUserDetails(newUser.user)
                        }
                    }
            })

        }

        function closeDialog(refresh) {
            $mdDialog.hide(refresh);
        }

        function showUserDetails(user){
            $state.go(UserDetailsPage, {user: {id: user.id}});
            closeDialog();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user.profile', [])
        .value("UserDetailsPage","app.user.details")
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {

        //keep in mind gantt edit dialog controller
        $stateProvider.state('app.user.details', {
            url      : '/{userId:int}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/user/details/profile.html',
                    controller : 'UserDetailsController as vm'
                }
            },
            resolve  : {
                User: function (AppRequirements,UserAdapter,$stateParams,$timeout,$state,$q,UsersListPage,ErrorUtility) {
                    var userId = $stateParams.user ? $stateParams.user.id : $stateParams.userId
                    var deferred = $q.defer()
                    
                    if(typeof userId == undefined){
                        $timeout(function(){
                            deferred.reject()
                            $state.go(UsersListPage)
                        })
                    }

                    UserAdapter.getUser(userId,
                        function(user,error){
                            if(!error){
                                deferred.resolve(user)
                            }
                            else{
                                ErrorUtility.showErrorMessage({title:'Get User Details',description:"Error while getting the user details!"})
                                deferred.reject(error)
                                $state.go(UsersListPage)
                            }
                        }
                    )

                    return deferred.promise;

                    //NB Payments and Reviews are injected from resolve in state,User not
                    //check if this page is reloaded or this page is generated from user list with user injected in
                    /*if($stateParams.user == null){

                        console.log('page refreshed')
                        var detailsId = ''
                        try{
                            detailsId = LocalStorageService.getItem('detailsId')
                            if(detailsId && detailsId != '') {
                                return UserAdapter.getUser(detailsId)
                            }
                            else{
                                return goToUsers()
                            }
                        }
                        catch (err){
                            console.log("No localStorage to use for get detailsId")
                            return goToUsers()
                        }
                    }
                    else{
                        detailsId = $stateParams.user.id
                        try{
                            LocalStorageService.setItem('detailsId',detailsId)
                            return UserAdapter.getUser(detailsId)
                        }
                        catch (err){
                            console.log("No localStorage to use for store detailsId")
                            return UserAdapter.getUser(detailsId)
                        }
                    }*/
                }
            },
            bodyClass: 'profile',
            params: {
                user: null
            }
        })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/user/details');

        // Api
        /*msApiProvider.register('profile.timeline', ['app/data/profile/timeline.json']);
        msApiProvider.register('profile.about', ['app/data/profile/about.json']);
        msApiProvider.register('profile.photosVideos', ['app/data/profile/photos-videos.json']);*/
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.user.profile')
        .controller('UserDetailsController', UserDetailsController);

    /** @ngInject */
    function UserDetailsController(
        $scope,
        $state,
        UserAdapter,
        User,
        DialogFactory,
        $timeout,
        SweetAlert,
        DocumentTypes,
        TripsAdapter,
        PermissionsAdapter,
        toDateFilter,
        numberFilter,
        GenerateCSVService,
        TripsListPage,
        InvoicesListPage,
        UserDetailsPage,
        UserUtility,
        UserDocumentStatus,
        UserLicenseStatus,
        UserStatus,
        UserSexType,
        UserPaymentStatus,
        UsersListPage,
        TripDetailsPage,
        VehicleDetailsPage,
        CouponUtility,
        TransactionUtility,
        InvoiceUtility,
        ServiceSettings,
        MiscUtility,
        SitesService,
        ErrorUtility,
        DefaultSite,
        FiltersRequestParamFactory,
        OrderRequestParamFactory,
        ServiceData,
        UserDialogFactory,
        TransactionTag,
        CouponType,
        toCurrencyFilter,
        AppConfigurations
    ) {
        var vm = this;
        var initPage = true;
        var userBeforeChanges = null;

        vm.isShowingTheBiggerPicture = false;
        vm.biggerImage = null;
        vm.isButtonDisabled = false;
        // Data
        //ReviewAdapter.getReviews(detailsId)
        //vm.reviews = Reviews;
        vm.paymentAdded = false;
        vm.disableEditUserDetails = true;

        vm.transactionPageLimit = 20;
        vm.transactionsOffset = 0;

        vm.userTrips = [];
        vm.transactions = [];
        vm.invoices = [];
        vm.roles = [];
        vm.userRoles = [];
        vm.totalTrips = '...';
        vm.totalTransactions = '...';
        vm.totalInvoices = '...';
        vm.totalSpent = '...';
        vm.totalUnpaid = '...';
        vm.totalRefunded = '...';
        vm.canceledTrips = '...';
        vm.pausedTrips = '...';
        vm.canceledBookings = '...';
        vm.expiredBookings = '...';
        vm.referredUsersListFullScreen = false;
        vm.userDetailsFullScreen = false;
        vm.couponsLegacyHistoryListFullScreen = false;
        vm.couponsHistoryListFullScreen = false;
        vm.userRelatedDataFullScreen = false;

        vm.isManagingRoles = false;
        vm.isManagingUserSites = false;

        vm.documentSliderPage = {
            LICENSE: 0,
            ID: 1,
        };
        vm.documentSlider = {
            index: 0,
            license: {
                selectedImageIndex: 0,
                selectedImage: null,
                images: [],
            },
            document: {
                selectedImageIndex: 0,
                selectedImage: null,
                images: [],
            },
        };

        vm.documentTypes = DocumentTypes;
        vm.userDocumentStatus = UserDocumentStatus;
        vm.userLicenseStatus = UserLicenseStatus;
        vm.userStatus = UserStatus;
        vm.userSexType = UserSexType;
        vm.userPaymentStatus = UserPaymentStatus;
        vm.showMakeManualPaymentDialog = showMakeManualPaymentDialog;

        $scope.$on('refreshServiceSettings', function (event) {
            init();
        });

        $scope.$on('siteChanged', function (site) {
            console.log('site changed');
            refresh();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    SitesService.getSites(function (sites) {
                        vm.sites = sites;
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        vm.isDefaultSiteSelected = SitesService.isDefaultSiteSelected();
                        vm.timezone = UserUtility.isAdminWithoutSite(User)
                            ? ServiceSettings.getDefaultTimezone()
                            : ServiceSettings.getSiteTimezone(User.SiteId);
                        vm.todayDate = MiscUtility.serviceTodayDate(
                            UserUtility.isAdminWithoutSite(User) ? DefaultSite.id : User.SiteId
                        );

                        vm.referredUsersTableFields = {
                            id: {
                                name: 'ID',
                                class: 'userRowCell userRowCellSmall',
                                type: 'link',
                                link: {
                                    goto: 'app.user.details',
                                    gotoParams: 'userId',
                                    key: 'User.id',
                                    class: function (o) {
                                        return 'userLink';
                                    },
                                },
                                render: function (val, obj) {
                                    return obj.User ? obj.User.id : '';
                                },
                            },
                            fullName: {
                                name: 'Full Name',
                                class: 'userRowCell userRowCellBig',
                                ellipsis: true,
                                type: 'render',
                                render: function (v, o) {
                                    return o.User ? o.User.fullName : '';
                                },
                            },
                            email: {
                                name: 'Email',
                                class: 'userRowCell userRowCellBig',
                                ellipsis: true,
                                type: 'render',
                                render: function (v, o) {
                                    return o.User ? o.User.email : '';
                                },
                            },
                            state: {
                                name: 'User status',
                                class: 'userRowCell',
                                type: 'render',
                                render: function (v, o) {
                                    return o.User ? o.User.statusHuman : '';
                                },
                            },
                            registration: {
                                name: 'Registration date',
                                class: 'userRowCell userRowCellBig',
                                type: 'render',
                                render: function (v, o) {
                                    return o.User ? toDateFilter(o.User.created_at, 'dateTime', o.User.SiteId) : '';
                                },
                            },
                            siteId: {
                                name: "User's Site",
                                class: 'userRowCell',
                                key: 'User.SiteId',
                                hide: !SitesService.isDefaultSiteSelected(),
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.User ? SitesService.getSiteName(obj.User.SiteId) : '';
                                },
                            },
                            activated: {
                                name: 'Activated',
                                class: 'userRowCell userRowCellBig',
                                type: 'render',
                                render: function (v, o) {
                                    return toDateFilter(o.created_at, 'dateTime', o.User.SiteId);
                                },
                            },
                            used: {
                                name: 'Used',
                                class: 'userRowCell userRowCellBig',
                                type: 'render',
                                render: function (v, o) {
                                    return o.created_at == o.updated_at
                                        ? 'Not used'
                                        : toDateFilter(o.updated_at, 'dateTime', o.User.SiteId);
                                },
                            },
                        };

                        vm.couponsLegacyHistoryTableFields = {
                            id: {
                                name: 'ID',
                                class: 'userRowCellSmall',
                                type: 'link',
                                link: {
                                    goto: 'app.coupon-legacy.details',
                                    gotoParams: 'couponId',
                                    key: 'CouponId',
                                    class: function (o) {
                                        return 'userLink';
                                    },
                                },
                                render: function (val, obj) {
                                    return obj.CouponId ? obj.CouponId : '';
                                },
                            },
                            name: {
                                name: 'Name',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.Coupon ? obj.Coupon.name : '';
                                },
                            },
                            code: {
                                name: 'Code',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.Coupon ? obj.Coupon.code : '';
                                },
                            },
                            value: {
                                name: 'Value',
                                class: 'userRowCellSmall',
                                type: 'render',
                                render: function (v, o) {
                                    return o.Coupon
                                        ? o.Coupon.type == CouponType.MINUTES.value ||
                                          o.Coupon.type == CouponType.REFERRAL.value ||
                                          o.Coupon.type == CouponType.NEW_USERS.value
                                            ? toCurrencyFilter(
                                                  MiscUtility.generateCreditValue(
                                                      o.Coupon.value * 60000,
                                                      DefaultSite.id
                                                  ),
                                                  DefaultSite.id
                                              )
                                            : o.Coupon.value + ' ' + CouponUtility.getCouponTypeDescription(o.Coupon)
                                        : '';
                                },
                            },
                            type: {
                                name: 'Type',
                                class: 'userRowCellSmall',
                                type: 'render',
                                render: function (v, o) {
                                    return vm.getCouponTypeDescription(o.Coupon);
                                },
                            },
                            creation: {
                                name: 'Creation date',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (v, o) {
                                    return o.Coupon
                                        ? toDateFilter(
                                              o.Coupon.created_at,
                                              'dateTime',
                                              o.Coupon.SiteId ? o.Coupon.SiteId : vm.user.SiteId
                                          )
                                        : '';
                                },
                            }, //fallback for referral
                            start: {
                                name: 'Start validity',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (v, o) {
                                    return o.Coupon
                                        ? toDateFilter(
                                              o.Coupon.start,
                                              'dateTime',
                                              o.Coupon.SiteId ? o.Coupon.SiteId : vm.user.SiteId
                                          )
                                        : '';
                                },
                            }, //fallback for referral
                            siteId: {
                                name: 'Site',
                                class: 'userRowCellSmall',
                                key: 'Coupon.SiteId',
                                hide: !SitesService.isDefaultSiteSelected(),
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.Coupon ? SitesService.getSiteName(obj.Coupon.SiteId) : '';
                                },
                            },
                            activated: {
                                name: 'Activated',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (v, o) {
                                    return toDateFilter(
                                        o.created_at,
                                        'dateTime',
                                        o.Coupon.SiteId ? o.Coupon.SiteId : vm.user.SiteId
                                    );
                                },
                            }, //fallback for referral
                            referrer: {
                                name: 'Referrer',
                                class: '',
                                type: 'link',
                                link: {
                                    goto: 'app.user.details',
                                    gotoParams: 'userId',
                                    key: 'Coupon.UserId',
                                    class: function (o) {
                                        return 'userLink';
                                    },
                                },
                                render: function (val, obj) {
                                    return parseInt(obj.Coupon.UserId) ? parseInt(obj.Coupon.UserId) : 'No referrer';
                                },
                            },
                        };

                        vm.couponsHistoryTableFields = {
                            id: {
                                name: 'ID',
                                class: 'userRowCellSmall',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.CouponId ? obj.CouponId : '';
                                },
                            },
                            code: {
                                name: 'Code',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.BonusCoupon ? obj.BonusCoupon.code : '';
                                },
                            },
                            templateId: {
                                name: 'Campaign ID',
                                class: 'userRowCellSmall',
                                type: 'link',
                                link: {
                                    goto: 'app.coupon.template.detail',
                                    gotoParams: 'templateId',
                                    key: 'BonusCoupon.CouponTemplateId',
                                    class: function (o) {
                                        return 'userLink';
                                    },
                                },
                                render: function (val, obj) {
                                    return obj.BonusCoupon ? obj.BonusCoupon.CouponTemplateId : '';
                                },
                            },
                            campaignName: {
                                name: 'Campaign name',
                                class: 'userRowCellBig',
                                ellipsis: true,
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.BonusCoupon && obj.BonusCoupon.BonusCouponTemplate
                                        ? obj.BonusCoupon.BonusCouponTemplate.name
                                        : '';
                                },
                            },
                            bonusId: {
                                name: 'Bonus ID',
                                class: 'userRowCellSmall',
                                type: 'render',
                                render: function (v, o) {
                                    return o.BonusId;
                                },
                            },
                            // status: {
                            //     name: 'Status',
                            //     class: 'userRowCellSmall',
                            //     type: 'render',
                            //     render: function (val, obj) {
                            //         return obj.status === 1 ? 'Used' : '';
                            //     },
                            // },
                            redeemed: {
                                name: 'Redeem date',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (v, o) {
                                    // FIXME use template siteId if coupon is not defined. What if none of them? See bonus template
                                    // Waiting for template join...
                                    return toDateFilter(
                                        o.created_at,
                                        'dateTime',
                                        o.BonusCoupon.SiteId || DefaultSite.id
                                    );
                                },
                            },
                            deactivated: {
                                name: 'Deactivation date',
                                class: 'vehicleRowCellMedium',
                                key: 'deactivated',
                                type: 'render',
                                render: function (v, o) {
                                    return o.BonusCoupon && o.BonusCoupon.deactivatedAt !== 0
                                        ? toDateFilter(
                                              o.BonusCoupon.deactivatedAt,
                                              'dateTime',
                                              o.BonusCoupon.SiteId || DefaultSite.id
                                          )
                                        : 'Not deactivated';
                                },
                            },
                            siteId: {
                                name: 'Site',
                                class: 'userRowCellSmall',
                                key: 'SiteId',
                                hide: !SitesService.isDefaultSiteSelected(),
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.BonusCoupon && obj.BonusCoupon.SiteId
                                        ? SitesService.getSiteName(obj.BonusCoupon.SiteId)
                                        : 'No site';
                                },
                            },
                        };

                        // TODO show bonus usage when refactored utility bonus template description functions
                        vm.shopOrdersTableFields = {
                            orderId: { name: 'Order ID', class: 'userRowCellSmall', key: 'id' },
                            name: { name: 'Status', class: 'userRowCellSmall', key: 'status' },
                            price: {
                                name: 'Price',
                                class: 'userRowCellSmall',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.Transaction
                                        ? toCurrencyFilter(obj.Transaction.price, obj.SiteId)
                                        : 'N/A';
                                },
                            },
                            purchaseDate: {
                                name: 'Purchase date',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.created_at ? toDateFilter(obj.created_at, 'dateTime', obj.SiteId) : '';
                                },
                            },
                            bonusId: {
                                name: 'Bonus ID',
                                class: 'userRowCellSmall',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.Bonus ? obj.Bonus.id : 'N/A';
                                },
                            },
                            templateDescription: {
                                name: 'Description',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.ShopItem && obj.ShopItem.BonusTemplate
                                        ? obj.ShopItem.BonusTemplate.description
                                        : '';
                                },
                            },
                            bonusCreationDate: {
                                name: 'Assigned',
                                class: 'userRowCellBig',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.Bonus && obj.Bonus.created_at
                                        ? toDateFilter(obj.Bonus.created_at, 'dateTime', obj.SiteId)
                                        : 'N/A';
                                },
                            },
                            exhausted: {
                                name: 'Exhausted',
                                class: 'userRowCellSmall',
                                type: 'render',
                                render: function (val, obj) {
                                    return obj.Bonus ? (obj.Bonus.exhausted ? 'yes' : 'no') : 'N/A';
                                },
                            },
                            siteId: {
                                name: 'Site',
                                class: 'userRowCellSmall',
                                type: 'render',
                                render: function (val, obj) {
                                    return SitesService.getSiteName(obj.SiteId);
                                },
                                hide: !SitesService.isDefaultSiteSelected(),
                            },
                        };

                        $scope.$applyAsync();
                    });
                }
                initUserData(User);
            });
        }

        init();

        vm.enableDeleteUser = false;
        vm.enableDeactivateUser = true;
        vm.enableChangeFreeMillis = false;
        vm.enableManageUserSites = false;

        vm.enableManageUserSites = AppConfigurations.isActionEnabled('user.detail.manageUserSites');

        function getServiceData() {
            const isServiceAuthorized = function (authorizedServices, serviceName) {
                return (
                    authorizedServices.find(function (elem) {
                        return serviceName.toLowerCase().indexOf(elem.toLowerCase()) !== -1;
                    }) != undefined
                );
            };

            ServiceData.getServiceData(function (service, error) {
                if (error) {
                } else {
                    // TODO refactor to use AppConfiguration page action
                    if (service.name && service.name.indexOf('govolt') !== -1) {
                        vm.enableChangeFreeMillis = true;
                        vm.enableDeleteUser = true;
                    }
                    // TODO refactor to use AppConfiguration page action
                    if (
                        service.name &&
                        isServiceAuthorized(
                            ['2hire', 'e-motion', 'allways', 'elerent', 'tino', 'cosmic', 'easybike'],
                            service.name
                        )
                    ) {
                        vm.enableChangeFreeMillis = true;
                    }
                }
            });
        }
        getServiceData();

        refreshUserRelatedData(User.id);

        // Data
        vm.isShowingTheBiggerPicture = false;
        vm.biggerImage = null;
        vm.isButtonDisabled = false;
        // Data
        //ReviewAdapter.getReviews(detailsId)
        //vm.reviews = Reviews;
        vm.paymentAdded = false;
        vm.disableEditUserDetails = true;

        function initData() {
            vm.newPayment = {
                pan: '',
                cvc: '',
                exp_month: '',
                exp_year: '',
            };
        }
        initData();

        function initUserData(user) {
            vm.user = user;

            if (user.created_at) {
                vm.user.registrationDate = toDateFilter(
                    user.created_at,
                    'dateTime',
                    typeof user.SiteId === 'number' ? user.SiteId : DefaultSite.id
                );
            }

            //tasform date milliseconds string
            if (typeof user.birth === 'string') {
                // console.log("user.birth is string",user.birth)
                if (moment(user.birth, moment.ISO_8601, true).isValid()) {
                    console.log('case user birth string ISO string');
                    vm.user.birth = MiscUtility.shiftMomentToJs(
                        user.birth,
                        UserUtility.isAdminWithoutSite(user) ? DefaultSite.id : user.SiteId
                    );
                } else if (!isNaN(new Date(parseInt(user.birth)).getTime())) {
                    console.log('case user birth string but timestamp');
                    vm.user.birth = MiscUtility.shiftMomentToJs(
                        parseInt(user.birth),
                        UserUtility.isAdminWithoutSite(user) ? DefaultSite.id : user.SiteId
                    );
                }
            } else {
                if (typeof user.birth === 'number') {
                    console.log('case user birth number');
                    vm.user.birth = MiscUtility.shiftMomentToJs(
                        user.birth,
                        UserUtility.isAdminWithoutSite(user) ? DefaultSite.id : user.SiteId
                    );
                } else if (user.birth instanceof Date && !isNaN(user.birth.getTime())) {
                    //hotfix for negative timestamp after Ivan birth bug
                    vm.user.birth = MiscUtility.shiftMomentToJs(
                        user.birth,
                        UserUtility.isAdminWithoutSite(user) ? DefaultSite.id : user.SiteId
                    );
                }
            }

            if (typeof vm.user.identity_release == 'string' && vm.user.identity_release !== '') {
                console.log('doc release', vm.user.identity_release);
                vm.user.identity_release = MiscUtility.shiftMomentToJs(
                    vm.user.identity_release,
                    UserUtility.isAdminWithoutSite(user) ? DefaultSite.id : user.SiteId
                );
            }
            if (typeof vm.user.identity_expiration == 'string' && vm.user.identity_expiration !== '') {
                console.log('doc expiration', vm.user.identity_expiration);
                vm.user.identity_expiration = MiscUtility.shiftMomentToJs(
                    vm.user.identity_expiration,
                    UserUtility.isAdminWithoutSite(user) ? DefaultSite.id : user.SiteId
                );
            }
            if (typeof vm.user.license_release == 'string' && vm.user.license_release !== '') {
                console.log('license release', vm.user.license_release);
                vm.user.license_release = MiscUtility.shiftMomentToJs(
                    vm.user.license_release,
                    UserUtility.isAdminWithoutSite(user) ? DefaultSite.id : user.SiteId
                );
            }
            if (typeof vm.user.license_expiration == 'string' && vm.user.license_expiration !== '') {
                vm.user.license_expiration = MiscUtility.shiftMomentToJs(
                    vm.user.license_expiration,
                    UserUtility.isAdminWithoutSite(user) ? DefaultSite.id : user.SiteId
                );
            }
            vm.user.licenseStatusHuman = generateLicenseStatus();
            initDocumentSlider();

            //set user active sites
            vm.userSites = vm.user.UserSites.map(function (site) {
                return { id: site.SiteId, name: SitesService.getSiteName(site.SiteId) };
            });
            vm.shownSites = vm.userSites;

            // console.log("curr user",user)
        }

        // Methods

        vm.callAddPayment = callAddPayment;
        vm.callDeletePayment = callDeletePayment;
        vm.exporPersonalInfoAsCSV = exporPersonalInfoAsCSV;
        vm.exportUserTripsAsCSV = exportUserTripsAsCSV;
        vm.exportUserInvoicesAsCSV = exportUserInvoicesAsCSV;
        vm.exportUserTransactionsAsCSV = exportUserTransactionsAsCSV;
        vm.goToTripsWithFilter = goToTripsWithFilter;
        vm.goToTripDetails = goToTripDetails;
        vm.goToInvoicesWithFilter = goToInvoicesWithFilter;
        vm.goToUserList = goToUserList;
        vm.generateUserDetailsLink = generateUserDetailsLink;
        vm.getCurrencyValue = MiscUtility.getCurrencyValue;
        vm.gotoTripsPage = gotoTripsPage;
        vm.goToInvoicesPage = goToInvoicesPage;
        vm.showChangeUserFreeMinutesDialog = showChangeUserFreeMinutesDialog;
        vm.callDeleteUserConfirmDialog = callDeleteUserConfirmDialog;

        vm.selectImage = selectImage;
        vm.goToTripDetails = goToTripDetails;
        vm.openPdf = openPdf;
        vm.refresh = refresh;
        vm.getReferredUser = getReferredUser;
        vm.getCouponsLegacyHistory = getCouponsLegacyHistory;
        vm.getCouponsHistory = getCouponsHistory;
        vm.getShopOrders = getShopOrders;
        vm.callUpdateUser = callUpdateUser;
        vm.revokeRejectButtonAction = revokeRejectButtonAction;
        vm.acceptID = acceptID;
        vm.acceptLicense = acceptLicense;
        vm.blockUnblockAction = blockUnblockAction;
        vm.addRemoveRole = addRemoveRole;
        vm.checkUserForRole = checkUserForRole;
        vm.retryTransaction = retryTransaction;
        vm.blockAutomaticTransactionRetry = blockAutomaticTransactionRetry;
        vm.getNextTransactionsPage = getNextTransactionsPage;
        vm.getTransactionStatusDescription = getTransactionStatusDescription;
        vm.getCouponTypeDescription = CouponUtility.getCouponTypeDescription;
        vm.getDocumentTypeDescription = getDocumentTypeDescription;
        vm.getInvoiceTypeDescription = InvoiceUtility.getInvoiceTypeDescription;
        vm.getInvoiceStatusDescription = InvoiceUtility.getInvoiceStatusDescription;
        vm.getSiteNameDescription = getSiteNameDescription;
        vm.getUserFreeMinutes = UserUtility.getUserFreeMinutes;
        vm.getUserFreeCredit = UserUtility.getUserFreeCredit;

        vm.openResetUserPasswordConfirmDialog = openResetUserPasswordConfirmDialog;
        vm.enableUserDetailsChange = enableUserDetailsChange;
        vm.disableUserDetailsChange = disableUserDetailsChange;
        vm.toggleReferredUsersListInFullScreen = toggleReferredUsersListInFullScreen;
        vm.toggleCouponsLegacyHistoryListInFullScreen = toggleCouponsLegacyHistoryListInFullScreen;
        vm.toggleCouponsHistoryListInFullScreen = toggleCouponsHistoryListInFullScreen;
        vm.toggleUserRelatedDataFullScreen = toggleUserRelatedDataFullScreen;
        vm.checkTransactionStatusAndGetIcon = checkTransactionStatusAndGetIcon;

        vm.isTransactionRetryable = TransactionUtility.isTransactionRetryable;
        vm.isTransactionBlockedForRetry = TransactionUtility.isTransactionBlockedForRetry;
        vm.getTransactionDescription = TransactionUtility.getTransactionDescription;
        vm.getTransactionSiteId = TransactionUtility.getTransactionSiteId;

        vm.showBiggerImage = showBiggerImage;
        vm.dismissBiggerImage = dismissBiggerImage;

        vm.isAdminWithoutSite = UserUtility.isAdminWithoutSite;
        vm.getTransactionSiteId = getTransactionSiteId;
        vm.callDeactivateUserConfirmDialog = callDeactivateUserConfirmDialog;

        vm.handleUserSiteManaging = handleUserSiteManaging;
        vm.isUserActiveInSite = isUserActiveInSite;

        vm.toggleManageUserSites = toggleManageUserSites;
        vm.toggleManageRoles = toggleManageRoles;

        function checkTransactionStatusAndGetIcon(transaction) {
            var transactionStatus = transaction.status;
            var icon = 'icon-close-circle-outline error';

            if (TransactionUtility.isTransactionCompleted(transaction)) {
                icon = 'icon-checkbox-marked-circle-outline';
            } else if (TransactionUtility.isTransactionProcessing(transaction)) {
                icon = 'icon-close-circle-outline yellow';
            } else if (
                TransactionUtility.isTransactionRefunded(transaction) ||
                TransactionUtility.isTransactionBlockedForRetry(transaction) ||
                TransactionUtility.isTransactionCancelled(transaction)
            ) {
                icon = 'icon-close-circle-outline orange';
            }
            return icon;
        }

        function sortImages(array) {
            array.sort(function (imageA, imageB) {
                return imageA.type - imageB.type;
            });
        }

        function initDocumentSlider() {
            vm.documentSlider.license.images = vm.user.LicensePlate ? vm.user.LicensePlate : [];
            vm.documentSlider.document.images = vm.user.Document ? vm.user.Document : [];
            sortImages(vm.documentSlider.license.images);
            sortImages(vm.documentSlider.document.images);
            selectImage(0);
        }

        function generateLicenseStatus() {
            return UserUtility.getUserLicenseStatusDescription(vm.user);
        }

        function getTransactionStatusDescription(transaction) {
            return TransactionUtility.getTransactionStatusDescription(transaction);
        }

        function getDocumentTypeDescription() {
            if (vm.user) {
                for (var type in vm.documentTypes) {
                    if (vm.documentTypes[type].value == vm.user.identity_type) {
                        return vm.documentTypes[type].name;
                    }
                }
            }
        }

        function getSiteNameDescription(siteId) {
            if (typeof siteId == 'undefined' || siteId === null || typeof siteId !== 'number') {
                return '';
            }
            return SitesService.getSiteName(siteId);
        }

        function callAddPayment() {
            if (vm.newPayment.pan != '') {
                if (vm.user.id) {
                    UserAdapter.addPayment(
                        vm.user.id,
                        vm.newPayment,

                        function (paymentAdded, error) {
                            if (error) {
                                ErrorUtility.showErrorMessage({
                                    title: 'Add Payment Method',
                                    description: "Error while adding the new user's payment method",
                                });
                            } else {
                                vm.payments.push(paymentAdded);

                                //reset paymentMethod form
                                vm.paymentAdded = true;

                                $timeout(function () {
                                    vm.paymentAdded = false;
                                });

                                initData();
                            }
                        }
                    );
                } else {
                    console.warn('callAddPayment: user id is not defined');
                }
            }
        }

        function callDeletePayment(payment, index) {
            var userId = vm.user.id;
            var paymentId = payment.id;

            if (payment && userId) {
                DialogFactory.confirm(
                    'Delete User Payment Method',
                    'Are you sure you want to delete this payment method? (' + payment.pan + ')',
                    event
                ).then(function ok() {
                    UserAdapter.deletePayment(
                        userId,
                        paymentId,

                        function (deleted, error) {
                            if (error) {
                                ErrorUtility.showErrorMessage({
                                    title: 'Delete User Payment Method',
                                    description: 'There was an error while deleting this payment method!',
                                });
                            } else {
                                if (deleted) {
                                    getUser();
                                    SweetAlert.swal('Delete User Payment Method', 'Successfully deleted!', 'success');
                                } else {
                                    ErrorUtility.showErrorMessage({
                                        title: 'Delete User Payment Method',
                                        description: 'There was an error while deleting this payment method!',
                                    });
                                }
                            }
                        }
                    );
                });
            } else {
            }
        }

        function selectImage(index) {
            if (initPage) {
                vm.documentSlider.license.selectedImageIndex = index;
                vm.documentSlider.license.selectedImage = vm.documentSlider.license.images[index]
                    ? vm.documentSlider.license.images[index]
                    : null;
                vm.documentSlider.document.selectedImageIndex = index;
                vm.documentSlider.document.selectedImage = vm.documentSlider.document.images[index]
                    ? vm.documentSlider.document.images[index]
                    : null;
                initPage = false;
            } else {
                if (vm.documentSlider.index == vm.documentSliderPage.LICENSE) {
                    vm.documentSlider.license.selectedImageIndex = index;
                    vm.documentSlider.license.selectedImage = vm.documentSlider.license.images[index]
                        ? vm.documentSlider.license.images[index]
                        : null;
                } else if (vm.documentSlider.index == vm.documentSliderPage.ID) {
                    vm.documentSlider.document.selectedImageIndex = index;
                    vm.documentSlider.document.selectedImage = vm.documentSlider.document.images[index]
                        ? vm.documentSlider.document.images[index]
                        : null;
                }
            }
        }

        function enableUserDetailsChange() {
            if (vm.user.SiteId !== vm.selectedSiteId && vm.selectedSiteId !== DefaultSite.id) {
                SweetAlert.swal(
                    'Update User Details',
                    "User editing is not available if user's registration site is not selected",
                    'error'
                );
                return;
            }

            vm.disableEditUserDetails = !vm.disableEditUserDetails;
            userBeforeChanges = angular.copy(vm.user);
            vm.userDetailsFullScreen = true;
        }

        function disableUserDetailsChange() {
            vm.disableEditUserDetails = !vm.disableEditUserDetails;
            vm.user = angular.copy(userBeforeChanges);
            vm.userDetailsFullScreen = false;
        }

        function refreshUserRelatedData(userId) {
            getTrips(userId);
            getTransactions(userId);
            getInvoices(userId);
            getRoles();
            getUserRoles(userId);
            getPayments(userId);
            getUserStatus(userId);
        }

        function refresh(userId) {
            getUser(userId);
        }

        function getUser(userId) {
            if (!userId) userId = vm.user.id;

            UserAdapter.getUser(userId, function (user, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get User Details',
                        description: 'Error while getting the user details',
                    });
                    goToUserList();
                } else {
                    //vm.user.isActive = (vm.user.validEmail && vm.user.validID && vm.user.validLicensePlate == vm.userLicenseStatus.VALID.value && vm.user.validSMS)
                    //cause server is not updated with user status
                    initUserData(user);
                    refreshUserRelatedData(user.id);
                }
            });
        }

        function checkUserRequireFields(dataToSend) {
            //check required fields
            var fieldsRequired = [
                { key: 'identity_release', type: 0 },
                { key: 'identity_expiration', type: 1 },
                { key: 'license_release', type: 0 },
                { key: 'license_expiration', type: 1 },
            ];
            var missingRequiredField = false;
            fieldsRequired.forEach(function (field) {
                var date = dataToSend[field.key];
                //check if date field is "",null,undefined
                if (!date) {
                    missingRequiredField = true;
                } else {
                    if (!(date instanceof Date)) {
                        console.log('not date', date);
                        const tempData = moment.tz(date, vm.timezone);
                        date = new Date(tempData.year(), tempData.month(), tempData.date());
                    }
                    if (field.type == 0) {
                        if (date > vm.todayDate) {
                            missingRequiredField = true;
                        }
                    } else if (field.type == 1) {
                        if (date < vm.todayDate) {
                            missingRequiredField = true;
                        }
                    }
                }
            });

            return missingRequiredField;
        }

        function callUpdateUser() {
            var dataToSend = angular.copy(vm.user);

            if (vm.timezone === undefined || vm.timezone === null) {
                const isUserWithoutSite = typeof vm.user.SiteId !== 'number';
                ErrorUtility.showErrorMessage({
                    title: 'Update User Profile',
                    description:
                        'Timezone is not available!' +
                        (isUserWithoutSite
                            ? ' The user has not been activated in any site!'
                            : 'Try to refresh the page'),
                });
                return;
            }

            var missingRequiredField = checkUserRequireFields(dataToSend);
            if (missingRequiredField) {
                SweetAlert.swal('Update User Details', 'Check the documents release or expiration dates!', 'error');
                return;
            }

            //tasform only birth if is a valid date instance (correctly parsed from server or correcly typed)
            if (dataToSend.birth instanceof Date && !isNaN(dataToSend.birth)) {
                // console.log("birth to send",dataToSend.birth)
                var birthDate = MiscUtility.shiftJstoMoment(
                    dataToSend.birth,
                    UserUtility.isAdminWithoutSite(dataToSend) ? DefaultSite.id : dataToSend.SiteId
                );
                // console.log("output birth",birthDate.toISOString())
                if (birthDate == null) {
                    SweetAlert.swal('Update User Details', 'Invalid user birth date!', 'error');
                    return;
                }
                var birthTimestamp = birthDate.startOf('day').valueOf();
                dataToSend.birth = birthTimestamp;
            } else {
                SweetAlert.swal('Update User Details', 'Invalid user birth date!', 'error');
                return;
            }

            if (dataToSend.identity_release instanceof Date && !isNaN(dataToSend.identity_release)) {
                // console.log("identity_release",dataToSend.identity_release.toISOString())
                var idRelease = MiscUtility.shiftJstoMoment(
                    dataToSend.identity_release,
                    UserUtility.isAdminWithoutSite(dataToSend) ? DefaultSite.id : dataToSend.SiteId
                );
                // console.log("output identity_release",idRelease.toISOString())
                if (idRelease === null) {
                    SweetAlert.swal('Update User Details', 'Invalid ID release date!', 'error');
                    return;
                }
                dataToSend.identity_release = idRelease.startOf('day').toISOString();
            } else {
                SweetAlert.swal('Update User Details', 'Invalid ID release date!', 'error');
                return;
            }

            if (dataToSend.identity_expiration instanceof Date && !isNaN(dataToSend.identity_expiration)) {
                // console.log("identity_expiration",dataToSend.identity_expiration.toISOString())
                var idExpiration = MiscUtility.shiftJstoMoment(
                    dataToSend.identity_expiration,
                    UserUtility.isAdminWithoutSite(dataToSend) ? DefaultSite.id : dataToSend.SiteId
                );
                // console.log("output identity_expiration",idExpiration.toISOString())
                if (idExpiration === null) {
                    SweetAlert.swal('Update User Details', 'Invalid ID expiration date!', 'error');
                    return;
                }
                dataToSend.identity_expiration = idExpiration.toISOString();
            } else {
                SweetAlert.swal('Update User Details', 'Invalid ID expiration date!', 'error');
                return;
            }

            if (dataToSend.license_release instanceof Date && !isNaN(dataToSend.license_release)) {
                // console.log("license_release",dataToSend.license_release.toISOString())
                var DLRelease = MiscUtility.shiftJstoMoment(
                    dataToSend.license_release,
                    UserUtility.isAdminWithoutSite(dataToSend) ? DefaultSite.id : dataToSend.SiteId
                );
                // console.log("output license_release",DLRelease.toISOString())
                if (DLRelease === null) {
                    SweetAlert.swal('Update User Details', 'Invalid DL release date!', 'error');
                    return;
                }
                dataToSend.license_release = DLRelease.startOf('day').toISOString();
            } else {
                SweetAlert.swal('Update User Details', 'Invalid DL release date!', 'error');
                return;
            }

            if (dataToSend.license_expiration instanceof Date && !isNaN(dataToSend.license_expiration)) {
                // console.log("license_expiration",dataToSend.license_expiration.toISOString())
                var DLExpiration = MiscUtility.shiftJstoMoment(
                    dataToSend.license_expiration,
                    UserUtility.isAdminWithoutSite(dataToSend) ? DefaultSite.id : dataToSend.SiteId
                );
                // console.log("output license_expiration",DLExpiration.toISOString())
                if (DLExpiration === null) {
                    SweetAlert.swal('Update User Details', 'Invalid DL expiration date!', 'error');
                    return;
                }
                dataToSend.license_expiration = DLExpiration.toISOString();
            } else {
                SweetAlert.swal('Update User Details', 'Invalid DL expiration date!', 'error');
                return;
            }

            // console.log("dataToSend",dataToSend)

            UserAdapter.updateUser(vm.user.id, dataToSend, function (user, error) {
                if (error) {
                    vm.user = userBeforeChanges;
                    ErrorUtility.showErrorMessage({
                        title: 'Update User details',
                        description: 'Error updating the user details',
                    });
                } else {
                    vm.disableEditUserDetails = true;
                    vm.userDetailsFullScreen = false;
                    SweetAlert.swal('Update User Info', 'User info successfully updated!', 'success');
                }
            });
        }

        function getRoles() {
            PermissionsAdapter.getRoles(function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({ title: 'Get Roles', description: 'Error while getting the roles' });
                } else {
                    vm.roles = response;

                    if (vm.user.role == 'user') {
                        vm.roles = [{ id: -1, name: 'User' }];
                    }
                }
            });
        }

        function getUserRoles(userId) {
            if (!userId) userId = vm.user.id;

            vm.userRoles = [];

            UserAdapter.getUserRoles(userId, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get User Roles',
                        description: 'Error while getting the user roles',
                    });
                } else {
                    vm.userRoles = response;

                    if (vm.user.role == 'user') {
                        vm.userRoles = [{ id: -1, name: 'User' }];
                    }
                    vm.shownRoles = vm.userRoles;
                }
            });
        }

        function checkUserForRole(role, index) {
            for (var index in vm.userRoles) {
                var currentRole = vm.userRoles[index];
                if (currentRole.id == role.id) {
                    role.isUserRole = true;
                    return true;
                }
            }
            role.isUserRole = false;
            return false;
        }

        function hasUserARole() {
            var hasUserARole = vm.roles.find(function (role) {
                return checkUserForRole(role);
            });

            return hasUserARole !== undefined;
        }

        function goToInvoicesPage() {
            $state.go(InvoicesListPage, { searchFor: { filterKey: 'invoiceUserId', value: vm.user.id } });
        }

        function gotoTripsPage() {
            $state.go(TripsListPage, { searchFor: { filterKey: 'tripUserId', value: vm.user.id } });
        }

        function getTrips(userId) {
            if (!userId) userId = vm.user.id;

            var order = OrderRequestParamFactory.createAOrderRequestParam([
                OrderRequestParamFactory.orderByTripId('DESC'),
            ]);

            var paginationOptions = {
                limit: 20,
                offset: 0,
            };

            var params = FiltersRequestParamFactory.mergeObjects(paginationOptions, order);

            vm.totalTrips = '...';
            TripsAdapter.getUserTrips(userId, params, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get User Trips',
                        description: 'Error while getting the user trips',
                    });
                } else {
                    vm.totalTrips = typeof response.count != 'undefined' ? response.count : response.length;
                    vm.userTrips = typeof response.data != 'undefined' ? response.data : response;
                }
            });
        }

        function getNextTransactionsPage() {
            vm.transactionsOffset += vm.transactionPageLimit;

            getTransactions(
                vm.user.id,
                function (transactions, error) {
                    if (error) {
                        vm.transactionsOffset -= vm.transactionPageLimit;
                    } else {
                        if (vm.transactions != undefined) {
                            transactions.forEach(function (data) {
                                vm.transactions.push(data);
                            });
                        }

                        vm.displayedTransactions = vm.transactions.length;
                    }
                },
                true
            );
        }

        function getTransactions(userId, callback, step) {
            if (!userId) userId = vm.user.id;

            if (step == undefined) {
                step = false;
            }
            var order = OrderRequestParamFactory.createAOrderRequestParam([OrderRequestParamFactory.orderById('DESC')]);

            var paginationOptions = {
                limit: vm.transactionPageLimit,
                offset: vm.transactionsOffset,
            };

            var params = FiltersRequestParamFactory.mergeObjects(paginationOptions, order);
            vm.totalTransactions = '...';
            vm.totalSpent = '...';
            vm.totalUnpaid = '...';
            vm.totalRefunded = '...';

            UserAdapter.getUserTransactions(userId, params, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get User Transactions',
                        description: 'Error while getting the user transactions',
                    });

                    if (callback !== undefined) {
                        callback([], error);
                    }
                } else {
                    vm.totalTransactions = typeof response.count != 'undefined' ? response.count : response.length;
                    var transactions = typeof response.data != 'undefined' ? response.data : response.reverse();

                    if (!step) {
                        vm.transactions = transactions;
                    }

                    vm.displayedTransactions = vm.transactions.length;

                    if (callback !== undefined) {
                        callback(transactions, error);
                    }

                    var totalSpent = 0;
                    var totalUnpaid = 0;
                    var totalRefunded = 0;
                    for (var transactionIndex in vm.transactions) {
                        var transaction = vm.transactions[transactionIndex];
                        if (
                            TransactionUtility.isTransactionFailed(transaction) &&
                            !TransactionUtility.isTransactionAPreauthorizationFailure(transaction)
                        ) {
                            totalUnpaid += transaction.price;
                        } else if (TransactionUtility.isTransactionCompleted(transaction)) {
                            totalSpent += transaction.price;
                        } else if (TransactionUtility.isTransactionRefunded(transaction)) {
                            totalRefunded += transaction.price;
                        }
                    }
                    vm.totalSpent = numberFilter(totalSpent, 2);
                    vm.totalUnpaid = numberFilter(totalUnpaid, 2);
                    vm.totalRefunded = numberFilter(totalRefunded, 2);
                }
            });
        }

        function getInvoices(userId) {
            if (!userId) userId = vm.user.id;

            var order = OrderRequestParamFactory.createAOrderRequestParam([
                OrderRequestParamFactory.orderByInvoiceId('DESC'),
            ]);

            var paginationOptions = {
                limit: 20,
                offset: 0,
            };

            var params = FiltersRequestParamFactory.mergeObjects(paginationOptions, order);

            vm.totalInvoices = '...';
            UserAdapter.getUserInvoices(userId, params, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get User Invoices',
                        description: 'Error while getting the user invoices',
                    });
                } else {
                    // response.reverse()
                    vm.totalInvoices = typeof response.count != 'undefined' ? response.count : response.length;
                    vm.invoices = typeof response.data != 'undefined' ? response.data : response;
                }
            });
        }

        function getPayments(userId) {
            if (!userId) userId = vm.user.id;

            UserAdapter.getPayments(userId, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get User Payment Methods',
                        description: 'Error while getting the user payment methods',
                    });
                } else {
                    vm.payments = response;
                }
            });
        }

        function getReferredUser(paginationRequestParam, callback) {
            UserAdapter.getReferredUser(vm.user.id, paginationRequestParam, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Referred Users List',
                        description: 'Error while getting the referred users list',
                    });
                } else {
                    vm.referredUsersTotal = typeof response.count != 'undefined' ? response.count : response.length;
                    var downloadedReferredUsers = typeof response.data != 'undefined' ? response.data : response;
                    vm.referredUsers = [];

                    //clean user null at the moment
                    if (downloadedReferredUsers) {
                        downloadedReferredUsers.forEach(function (referralCouponUsage) {
                            if (referralCouponUsage.User) vm.referredUsers.push(referralCouponUsage);
                        });
                    }
                }
                if (callback !== undefined) {
                    callback(response, error);
                }
            });
        }
        //get some of the user stats
        function getUserStatus(userId) {
            if (!userId) userId = vm.user.id;

            vm.canceledTrips = '...';
            vm.pausedTrips = '...';
            vm.canceledBookings = '...';
            vm.expiredBookings = '...';

            UserAdapter.getSpecificUserStatus(userId, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get User Status',
                        description: 'Error while getting the user status info',
                    });
                } else {
                    if (data.bookingsStats) {
                        vm.canceledTrips = data.bookingsStats.canceledTrips;
                        vm.pausedTrips = data.bookingsStats.pausedTrips;
                        vm.canceledBookings = data.bookingsStats.canceledBookings;
                        vm.expiredBookings = data.bookingsStats.expiredBookings;
                    }
                }
            });
        }

        function getCouponsLegacyHistory(paginationRequestParam, callback) {
            UserAdapter.getCouponsLegacyHistory(vm.user.id, paginationRequestParam, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Coupons History',
                        description: 'Error while getting the coupons history',
                    });
                } else {
                    vm.couponLegacyHistoryTotal = typeof data.count != 'undefined' ? data.count : data.length;
                    vm.couponsLegacyHistory = typeof data.data != 'undefined' ? data.data : data;
                }
                if (callback !== undefined) {
                    callback(data, error);
                }
            });
        }

        function getCouponsHistory(paginationRequestParam, callback) {
            UserAdapter.getCouponsHistory(vm.user.id, paginationRequestParam, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Coupons History',
                        description: 'Error while getting the coupons history',
                    });
                } else {
                    vm.couponHistoryTotal = typeof data.count != 'undefined' ? data.count : data.length;
                    vm.couponsHistory = typeof data.data != 'undefined' ? data.data : data;
                }
                if (callback !== undefined) {
                    callback(data, error);
                }
            });
        }

        function getShopOrders(paginationRequestParam, callback) {
            UserAdapter.getShopOrders(vm.user.id, paginationRequestParam, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: "Get Store orders' list",
                        description: "Error while getting the store orders' list!",
                    });
                } else {
                    vm.shopOrdersTotal = typeof data.count != 'undefined' ? data.count : data.length;
                    vm.shopOrders = typeof data.data != 'undefined' ? data.data : data;
                }
                if (callback !== undefined) {
                    callback(data, error);
                }
            });
        }

        function acceptLicense() {
            if (!vm.user.accessForCar && !vm.user.accessForScooter && !vm.user.accessForBike) {
                SweetAlert.swal(
                    'Accept User Driving License',
                    'No vehicle type selected for user driving license',
                    'error'
                );
                return;
            }

            if (
                !vm.user.license_expiration ||
                vm.user.license_expiration == '' ||
                MiscUtility.shiftMomentToJs(
                    vm.user.license_expiration,
                    UserUtility.isAdminWithoutSite(vm.user) ? DefaultSite.id : vm.user.SiteId
                ) < vm.todayDate
            ) {
                SweetAlert.swal('Accept User Driving License', 'Check user driving license expiration', 'error');
                return;
            }

            UserAdapter.acceptUserLicense(
                vm.user.id,
                {
                    car: vm.user.accessForCar,
                    scooter: vm.user.accessForScooter,
                    bike: vm.user.accessForBike,
                },
                function (response, error) {
                    if (!error) {
                        vm.user.validLicensePlate = vm.userLicenseStatus.VALID.value;
                        getUser();
                        SweetAlert.swal(
                            'Accept User Driving License',
                            'Success accepting user driving license',
                            'success'
                        );
                    } else {
                        ErrorUtility.showErrorMessage({
                            title: 'Accept User Driving License',
                            description: 'Error accepting user driving license',
                        });
                    }
                }
            );
        }

        function rejectLicense() {
            UserAdapter.rejectUserLicense(vm.user.id, function (response, error) {
                if (!error) {
                    vm.user.validLicensePlate = vm.userLicenseStatus.REJECTED.value;
                    getUser();
                    SweetAlert.swal('Reject User Driving License', 'Success rejecting user driving license', 'success');
                } else {
                    ErrorUtility.showErrorMessage({
                        title: 'Reject User Driving License',
                        description: 'Error rejecting user driving license',
                    });
                }
            });
        }

        function revokeLicense() {
            UserAdapter.invalidateUserLicense(vm.user.id, function (response, error) {
                if (!error) {
                    vm.user.validLicensePlate = vm.userLicenseStatus.NOT_VALID.value;
                    getUser();
                    SweetAlert.swal('Revoke User Driving License', 'Success revoking user driving license', 'success');
                } else {
                    ErrorUtility.showErrorMessage({
                        title: 'Revoke User Driving License',
                        description: 'Error revoking user driving license',
                    });
                }
            });
        }

        function acceptID() {
            if (
                !vm.user.identity_expiration ||
                vm.user.identity_expiration == '' ||
                MiscUtility.shiftMomentToJs(
                    vm.user.identity_expiration,
                    UserUtility.isAdminWithoutSite(vm.user) ? DefaultSite.id : vm.user.SiteId
                ) < vm.todayDate
            ) {
                SweetAlert.swal('Accept User ID', 'Check user ID expiration', 'error');
                return;
            }

            UserAdapter.acceptUserID(vm.user.id, function (response, error) {
                if (!error) {
                    vm.user.validDocument = vm.userDocumentStatus.VALID.value;
                    getUser();
                    SweetAlert.swal('Accept User ID', 'Success accepting user ID', 'success');
                } else {
                    ErrorUtility.showErrorMessage({ title: 'Accept User ID', description: 'Error accepting user ID' });
                }
            });
        }

        function rejectID() {
            UserAdapter.rejectUserID(vm.user.id, function (response, error) {
                if (!error) {
                    vm.user.validDocument = vm.userDocumentStatus.REJECTED.value;
                    getUser();
                    SweetAlert.swal('Reject User ID', 'Success rejecting user ID', 'success');
                } else {
                    ErrorUtility.showErrorMessage({ title: 'Reject User ID', description: 'Error rejecting user ID' });
                }
            });
        }

        function revokeID() {
            UserAdapter.invalidateUserID(vm.user.id, function (response, error) {
                if (!error) {
                    vm.user.validDocument = vm.userDocumentStatus.NOT_VALID.value;
                    getUser();
                    SweetAlert.swal('Revoke User ID', 'Success revoking user ID', 'success');
                } else {
                    ErrorUtility.showErrorMessage({ title: 'Revoke User ID', description: 'Error revoking user ID' });
                }
            });
        }

        function revokeRejectButtonAction() {
            if (vm.documentSlider.index == vm.documentSliderPage.LICENSE) {
                if (vm.user.validLicensePlate == vm.userLicenseStatus.WAITING_FOR_APPROVAL.value) {
                    rejectLicense();
                }
                if (vm.user.validLicensePlate == vm.userLicenseStatus.VALID.value) {
                    revokeLicense();
                }
            } else if (vm.documentSlider.index == vm.documentSliderPage.ID) {
                if (vm.user.validDocument == vm.userDocumentStatus.WAITING_FOR_APPROVAL.value) {
                    rejectID();
                }
                if (vm.user.validDocument == vm.userDocumentStatus.VALID.value) {
                    revokeID();
                }
            }
        }

        function openPdf(invoice) {
            invoice.PDF[0].location ? window.open(invoice.PDF[0].location) : alert('No link for this invoice');
        }

        function toggleManageRoles() {
            if (vm.user.role !== 'admin') {
                ErrorUtility.showErrorMessage({
                    title: "Manage User's Role",
                    description: 'Could not manage roles if this is a User!',
                });
                return;
            }

            if (!vm.isManagingRoles) {
                vm.shownRoles = vm.roles;
            } else {
                vm.shownRoles = vm.userRoles;
            }

            vm.isManagingRoles = !vm.isManagingRoles;
        }

        function addRemoveRole(role) {
            if (role.id == -1) {
                ErrorUtility.showErrorMessage({
                    title: "Remove User's Role",
                    description: "Can't remove the user role!",
                });
                return;
            }
            const isUserRole = role.isUserRole;
            const alertTitle = isUserRole ? "Remove User's Role" : "Add User's Role";
            const action = isUserRole ? 'remove' : 'add';
            DialogFactory.confirm(
                alertTitle,
                'Are you sure you want to ' +
                    action +
                    ' this user ' +
                    (action == 'add' ? 'to ' : 'from ') +
                    role.name +
                    '?',
                event
            ).then(function ok() {
                if (!isUserRole) {
                    if (hasUserARole()) {
                        ErrorUtility.showErrorMessage({
                            title: alertTitle,
                            description: 'This user has already a role, please remove it before assign a new role!',
                        });
                        return;
                    }

                    UserAdapter.addRoleToUser(role.id, vm.user.id, function (response, error) {
                        if (!error) {
                            toggleManageRoles();
                            refresh();
                            SweetAlert.swal(alertTitle, "Successfully assigned the user's role", 'success');
                        } else {
                            ErrorUtility.showErrorMessage({
                                title: alertTitle,
                                description: "Error while assigning the user's role",
                            });
                        }
                    });
                } else {
                    UserAdapter.removeRoleFromUser(role.id, vm.user.id, function (response, error) {
                        if (!error) {
                            toggleManageRoles();
                            refresh();
                            SweetAlert.swal(alertTitle, "Successfully removed the user's role", 'success');
                        } else {
                            ErrorUtility.showErrorMessage({
                                title: alertTitle,
                                description: "Error while removing the user's role",
                            });
                        }
                    });
                }
            });
        }

        function openResetUserPasswordConfirmDialog(ev) {
            DialogFactory.confirm(
                'Are you sure you want to reset user password?',
                'An email with the instructions will be sent to this user',
                ev
            ).then(
                function yes() {
                    resetUserPassword();
                },
                function no() {}
            );
        }

        function resetUserPassword() {
            UserAdapter.resetUserPassword(vm.user.id, function (response, error) {
                if (!error) {
                    SweetAlert.swal('Reset User Password', 'An email has just sent to this user', 'success');
                } else {
                    ErrorUtility.showErrorMessage({
                        title: 'Reset User Password',
                        description: 'Error resetting password',
                    });
                }
            });
        }

        function blockUser(userId, reason) {
            if (!reason) {
                SweetAlert.swal('Block User Profile', 'Please fill the reason text field!', 'error');
                return;
            }

            DialogFactory.confirm('Block User Profile', 'Are you sure you want to block this user?').then(function () {
                UserAdapter.blockUser(
                    userId,
                    reason ? { reason: reason } : { reason: 'No reason' },
                    function (response, error) {
                        if (!error) {
                            getUser(userId);
                            SweetAlert.swal('Block User Profile', 'Success blocking user profile', 'success');
                        } else {
                            ErrorUtility.showErrorMessage({
                                title: 'Block User Profile',
                                description: 'Error blocking user profile',
                            });
                        }
                    }
                );
            });
        }

        function unblockUser(userId) {
            DialogFactory.confirm('Unblock User Profile', 'Are you sure you want to unblock this user?').then(
                function () {
                    UserAdapter.unblockUser(userId, function (response, error) {
                        if (!error) {
                            SweetAlert.swal('Unblock User Profile', 'Success unblocking user profile', 'success');
                            getUser(userId);
                        } else {
                            ErrorUtility.showErrorMessage({
                                title: 'Unblock User Profile',
                                description: 'Error unblocking user profile',
                            });
                        }
                    });
                }
            );
        }

        function blockUnblockAction() {
            vm.user.block ? unblockUser(vm.user.id) : blockUser(vm.user.id, vm.user.block_reason);
        }

        function retryTransaction(transaction) {
            var userId = vm.user.id;

            if (userId && transaction && TransactionUtility.isTransactionRetryable(transaction)) {
                vm.isButtonDisabled = true;

                UserAdapter.retryTransaction(userId, transaction.id, function (data, error) {
                    vm.isButtonDisabled = false;
                    if (error) {
                        ErrorUtility.showErrorMessage({
                            title: 'Retry User Transaction',
                            description: 'Error while retrying transaction',
                        });
                    } else {
                        SweetAlert.swal('Retry User Transaction', 'Successfully retried the transaction', 'success');
                        getUser(userId);
                        getTransactions(userId);
                    }
                });
            }
        }

        function blockAutomaticTransactionRetry(transaction) {
            var userId = vm.user.id;

            if (userId && transaction && TransactionUtility.isTransactionRetryable(transaction)) {
                vm.isButtonDisabled = true;

                UserAdapter.blockAutomaticTransactionRetry(userId, transaction.id, function (data, error) {
                    vm.isButtonDisabled = false;
                    if (error) {
                        ErrorUtility.showErrorMessage({
                            title: 'Block Automatic Retry',
                            description: 'Error while blocking the automatic retry of the transaction',
                        });
                    } else {
                        SweetAlert.swal(
                            'Block Automatic Retry',
                            'Successfully blocked the automatic retry of the transaction!',
                            'success'
                        );
                        getUser(userId);
                        getTransactions(userId);
                    }
                });
            }
        }

        function goToTripDetails(trip) {
            if (trip) {
                $state.go(TripDetailsPage, { trip: { id: trip.id } });
            }
        }

        function goToTripsWithFilter() {
            $state.go(TripsListPage, { searchFor: { filterKey: 'tripUserId', value: vm.user.id } });
        }

        function goToInvoicesWithFilter() {
            $state.go(InvoicesListPage, { searchFor: { filterKey: 'invoiceUserId', value: vm.user.id } });
        }

        function goToUserList() {
            $state.go(UsersListPage);
        }

        function goToVehicleDetails(vehicle) {
            if (vehicle) $state.go(VehicleDetailsPage, { vehicle: { id: vehicle.id } });
        }

        function generateUserDetailsLink(userId) {
            return userId ? $state.href(UserDetailsPage, { userId: userId }) : '';
        }

        function toggleReferredUsersListInFullScreen() {
            /*if(!vm.referredUsersListFullScreen){
                $location.hash("profile");
                $anchorScroll()
            }*/
            vm.referredUsersListFullScreen = !vm.referredUsersListFullScreen;
        }

        function toggleCouponsLegacyHistoryListInFullScreen() {
            /*if(!vm.couponsHistoryListFullScreen){
                $location.hash("profile");
                $anchorScroll()
            }*/
            vm.couponsLegacyHistoryListFullScreen = !vm.couponsLegacyHistoryListFullScreen;
        }

        function toggleCouponsHistoryListInFullScreen() {
            /*if(!vm.couponsHistoryListFullScreen){
                $location.hash("profile");
                $anchorScroll()
            }*/
            vm.couponsHistoryListFullScreen = !vm.couponsHistoryListFullScreen;
        }

        function toggleUserRelatedDataFullScreen() {
            //check if peronal details is in full screen
            if (vm.userDetailsFullScreen) {
                vm.userDetailsFullScreen = false;
            }

            /*if(!vm.userRelatedDataFullScreen){
                $location.hash("profile");
                $anchorScroll()
            }*/
            vm.userRelatedDataFullScreen = !vm.userRelatedDataFullScreen;
        }

        //upload files logic

        vm.imageSideType = {
            FRONT: { value: '0', name: 'Front' },
            BACK: { value: '1', name: 'Back' },
        };

        function initInputFileListener(inputId, eventHandler, hasImageSideSelection) {
            var inputFile = document.getElementById(inputId);

            if (hasImageSideSelection) {
                inputFile.addEventListener('change', function (event) {
                    showSelectImageSideSDialog(event, function (imageSide) {
                        if (typeof imageSide != 'undefined') eventHandler(event.target.files[0], imageSide);
                    });
                });
            } else {
                inputFile.addEventListener('change', function (event) {
                    eventHandler(event.target.files[0]);
                });
            }
        }

        function initInputFileListeners() {
            initInputFileListener('selfie_image_upload', callUploadSelfie, false);
            initInputFileListener('dl_image_upload', callUploadDL, true);
            initInputFileListener('id_image_upload', callUploadID, true);
        }
        initInputFileListeners();

        function showSelectImageSideSDialog($event, callback) {
            DialogFactory.confirm(
                'Choose document side',
                'Choose document side you want to upload',
                $event,
                'Front',
                'Back'
            ).then(
                function frontSideChoose() {
                    callback(vm.imageSideType.FRONT.value);
                },
                function backSideChoose() {
                    callback(vm.imageSideType.BACK.value);
                }
            );
        }

        function callUploadSelfie(file) {
            if (typeof vm.user.id == 'undefined' || typeof file == 'undefined') {
                return;
            }

            UserAdapter.uploadSelfie(vm.user.id, file, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Upload User Selfie',
                        description: 'Error while uploading user selfie',
                    });
                } else {
                    SweetAlert.swal('Upload User Selfie', 'Successfully uploaded user selfie', 'success');
                    getUser();
                }
            });
        }

        function callUploadID(file, imageSide) {
            if (typeof vm.user.id == 'undefined' || typeof file == 'undefined' || typeof imageSide == 'undefined') {
                return;
            }

            UserAdapter.uploadID(vm.user.id, file, imageSide, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Upload User ID',
                        description: 'Error while uploading user ID',
                    });
                } else {
                    SweetAlert.swal('Upload User ID', 'Successfully uploaded user ID', 'success');
                    getUser();
                }
            });
        }

        function callUploadDL(file, imageSide) {
            if (typeof vm.user.id == 'undefined' || typeof file == 'undefined' || typeof imageSide == 'undefined') {
                return;
            }

            UserAdapter.uploadDL(vm.user.id, file, imageSide, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Upload User Driving License',
                        description: 'Error while uploading user driving license',
                    });
                } else {
                    SweetAlert.swal(
                        'Upload User Driving License',
                        'Successfully uploaded user driving license',
                        'success'
                    );
                    getUser();
                }
            });
        }

        function showChangeUserFreeMinutesDialog(ev) {
            if (vm.getUserFreeCredit(vm.user) == null) {
                ErrorUtility.showErrorMessage({
                    title: 'Change user free credit',
                    description: 'The user is not activated in any Site!',
                });
                return;
            }

            UserDialogFactory.changeFreeMinutes(ev, vm.user).then(
                function ok(resp) {
                    if (resp) {
                        getUser(vm.user.id);
                    }
                },
                function cancel() {
                    console.log('cancel showChangeUserFreeMinutesDIalog dialog');
                }
            );
        }

        function callDeleteUserConfirmDialog(ev) {
            if (!vm.user) {
                console.log('callDeleteUser: invalid user', vm.user);
                return;
            }

            DialogFactory.confirm(
                'Delete User Account',
                'Are you sure you want to delete the account for user ' + vm.user.id + ' ?',
                ev
            ).then(
                function ok() {
                    // NOTE this fn marks the user as deleted_at
                    UserAdapter.deleteUser(vm.user.id, function (response, error) {
                        if (error) {
                            ErrorUtility.showErrorMessage({
                                title: 'Delete User Account',
                                description: 'Error while deleting the user account!',
                            });
                        } else {
                            SweetAlert.swal(
                                'Delete User Account',
                                'The user account has been successfully deleted!',
                                'success'
                            );
                            goToUserList();
                        }
                    });
                },
                function no() {}
            );
        }

        function toggleManageUserSites() {
            if (vm.user.role !== 'user') {
                ErrorUtility.showErrorMessage({
                    title: "Manage User's Sites",
                    description: "Could not manage user's sites if this is an Admin!",
                });
                return;
            }

            if (!vm.isManagingUserSites) {
                vm.shownSites = vm.sites;
            } else {
                vm.shownSites = vm.userSites;
            }

            vm.isManagingUserSites = !vm.isManagingUserSites;
        }

        function isUserActiveInSite(site) {
            if (vm.user.UserSites === null || vm.user.UserSites === undefined || vm.user.UserSites === []) {
                return false;
            }

            return (
                vm.user.UserSites.find(function (userSite) {
                    return userSite.SiteId === site.id;
                }) !== undefined
            );
        }

        function handleUserSiteManaging(site) {
            if (!site || !vm.user.id) {
                console.log('error activateUserInSite', site);
                return;
            }

            const isUserActivated = isUserActiveInSite(site);
            const alertTitle = isUserActivated ? 'Deactivate User from Site' : 'Activate User in Site';
            const action = isUserActivated ? 'deactivate' : 'activate';

            if (vm.user.role !== 'user') {
                ErrorUtility.showErrorMessage({
                    title: alertTitle,
                    description: "Could not manage user's site if this is an Admin!",
                });
                return;
            }

            DialogFactory.confirm(
                alertTitle,
                'Are you sure you want to ' +
                    action +
                    ' this user ' +
                    (action == 'activate' ? 'in ' : 'from ') +
                    site.name +
                    '?',
                event
            ).then(function ok() {
                if (isUserActivated) {
                    deactivateUserInSite(site);
                } else {
                    activateUserInSite(site);
                }
            });
        }

        function activateUserInSite(site) {
            if (!site || !vm.user.id || vm.user.role !== 'user') {
                console.log('error activateUserInSite', site);
                return;
            }
            const alertTitle = 'Activate User in Site';

            UserAdapter.activateUserInSite(vm.user.id, { siteId: site.id }, function (response, error) {
                if (error) {
                    console.log(error);
                    ErrorUtility.showErrorMessage({
                        title: alertTitle,
                        description: 'Error while activating the user in this site!',
                    });
                } else {
                    toggleManageUserSites();
                    SweetAlert.swal(
                        alertTitle,
                        'The user has been successfully activated in ' + site.name + '!',
                        'success'
                    );
                    refresh();
                }
            });
        }

        function deactivateUserInSite(site) {
            if (!site || !vm.user.id || vm.user.role !== 'user') {
                console.log('error deactivateUserInSite', site);
                return;
            }
            const alertTitle = 'Deactivate User from Site';

            UserAdapter.deactivateUserFromSite(vm.user.id, { siteId: site.id }, function (response, error) {
                if (error) {
                    console.log(error);
                    if (error.type && error.type == 'no_acl') {
                        ErrorUtility.showErrorMessage({
                            title: alertTitle,
                            description: "Could not deactivate the primary user's site!",
                        });
                    } else if (error.type && error.type == 'no_user_site') {
                        ErrorUtility.showErrorMessage({
                            title: alertTitle,
                            description: 'The user is not activated in this site!',
                        });
                    } else {
                        ErrorUtility.showErrorMessage({
                            title: alertTitle,
                            description: 'Error while deactivating the user from this site!',
                        });
                    }
                } else {
                    toggleManageUserSites();
                    SweetAlert.swal(
                        alertTitle,
                        'The user has been successfully deactivated from ' + site.name + '!',
                        'success'
                    );
                    refresh();
                }
            });
        }

        function showMakeManualPaymentDialog(ev) {
            if (!vm.payments || vm.payments.length === 0) {
                SweetAlert.swal('Make manual payment', "The user doesn't have a payment method!", 'error');
                return;
            }
            //FIXME
            //sort updated_at desc because server uses the last updated payment method
            const paymentMethod = vm.payments.sort(function (a, b) {
                return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
            })[0];

            UserDialogFactory.showMakeManualPayment(ev, vm.user, paymentMethod).then(function (refreshInterface) {
                if (refreshInterface) {
                    refresh(vm.user.id);
                }
            });
        }
        // NOTE override default TransactionUtility.getTransactionSiteId to handle shop order transaction siteId using user primary site
        // TODO delete this fn when BONUS CRUD will be merged
        function getTransactionSiteId(transaction) {
            if (!transaction) {
                console.warn('ProfileController.getTransactionSiteId: invalid transaction', transaction);
                return null;
            }

            const tag = TransactionUtility.getTag(transaction);
            if (!tag) {
                return null;
            }

            switch (tag) {
                case TransactionTag.SHOP_ORDER:
                    // FIXME we should use the transaction siteId but it hasn't it in the model, we should use the shop order siteId
                    // but we have not it here. Use the primary user registration siteId for now, the limit is for shop order placed in a site
                    // with a different timezone where the site of the.
                    // We are waiting for Bonus CRUD merge, does it will arrive?
                    return vm.user.SiteId || null;
                default:
                    // NOTE use default getTransactionSiteId for the other transactions
                    return TransactionUtility.getTransactionSiteId(transaction);
            }
        }

        function callDeactivateUserConfirmDialog(ev) {
            if (!vm.user) {
                return;
            }

            DialogFactory.confirm(
                'Deactivate User Account',
                'Are you sure you want to deactivate the account for user ' + vm.user.id + ' ?',
                ev
            ).then(
                function ok() {
                    // NOTE this deactivate the user not marks it as deleted_at
                    UserAdapter.deactivateUser(vm.user.id, function (response, error) {
                        if (error) {
                            ErrorUtility.showErrorMessage({
                                title: 'Deactivate User',
                                description: 'Error while deactivating the user',
                            });
                        } else {
                            SweetAlert.swal(
                                'Deactivate User',
                                'The user account has been successfully deactivated!',
                                'success'
                            );
                            goToUserList();
                        }
                    });
                },
                function no() {}
            );
        }

        function exporPersonalInfoAsCSV() {
            var outputArray = [];
            var outputString = '';
            const semicolonString = ';';
            const endLineString = '\n';
            const spaceString = ' ';
            const dateFormat = 'dd/MM/yyyy';

            //header
            outputString +=
                'Customer id' +
                semicolonString +
                'Full name' +
                semicolonString +
                'Email' +
                semicolonString +
                'Sex' +
                semicolonString +
                'Residence Country' +
                semicolonString +
                'Residence State' +
                semicolonString +
                'Residence City' +
                semicolonString +
                'Address' +
                semicolonString +
                'Zip code' +
                semicolonString +
                'Phone' +
                semicolonString +
                'Birth Country' +
                semicolonString +
                'Birth State' +
                semicolonString +
                'Birth City' +
                semicolonString +
                'Birth Date' +
                semicolonString +
                'Registration Date' +
                semicolonString +
                'Status' +
                semicolonString +
                'Blocked' +
                semicolonString +
                'Blocked reason' +
                semicolonString +
                'Driving license' +
                semicolonString +
                'Driving license status' +
                semicolonString +
                'Driving license issue country' +
                semicolonString +
                'Driving license issue city' +
                semicolonString +
                'Driving license release' +
                semicolonString +
                'Driving license expiration' +
                semicolonString +
                'ID' +
                semicolonString +
                'ID type' +
                semicolonString +
                'ID issue state' +
                semicolonString +
                'ID issue city' +
                semicolonString +
                'ID release' +
                semicolonString +
                'ID expiration' +
                semicolonString +
                'Total trips' +
                semicolonString +
                'Total spent' +
                semicolonString +
                'Total unpaid' +
                semicolonString +
                'Total refunded' +
                semicolonString +
                'Free minutes' +
                semicolonString +
                'Prepaid minutes' +
                semicolonString +
                'Last Payment status' +
                endLineString;
            outputArray.push(outputString);

            outputString = vm.user.id + semicolonString;
            outputString += vm.user.fullName + semicolonString;
            outputString += vm.user.email + semicolonString;
            outputString += vm.user.sex + semicolonString;
            outputString += vm.user.residence_country + semicolonString;
            outputString += vm.user.residence_state + semicolonString;
            outputString += vm.user.residence_city + semicolonString;
            outputString += vm.user.residence + semicolonString;
            outputString += vm.user.cap + semicolonString;
            outputString += vm.user.tel + semicolonString;
            outputString += vm.user.birth_country + semicolonString;
            outputString += vm.user.birth_state + semicolonString;
            outputString += vm.user.birth_city + semicolonString;
            outputString +=
                toDateFilter(
                    vm.user.birth,
                    dateFormat,
                    UserUtility.isAdminWithoutSite(vm.user) ? DefaultSite.id : vm.user.SiteId
                ) + semicolonString;
            outputString +=
                toDateFilter(
                    vm.user.created_at,
                    dateFormat,
                    UserUtility.isAdminWithoutSite(vm.user) ? DefaultSite.id : vm.user.SiteId
                ) + semicolonString;
            outputString += vm.user.statusHuman + semicolonString;
            outputString += (vm.user.block ? 'Yes' : 'No') + semicolonString;
            outputString += (vm.user.block_reason ? vm.user.block_reason : 'Not blocked') + semicolonString;
            outputString += (vm.user.license_id ? vm.user.license_id : '') + semicolonString;
            outputString += vm.user.licenseStatusHuman + semicolonString;
            outputString += (vm.user.license_country ? vm.user.license_country : '') + semicolonString;
            outputString += (vm.user.license_place ? vm.user.license_place : '') + semicolonString;
            outputString +=
                toDateFilter(
                    vm.user.license_release,
                    null,
                    UserUtility.isAdminWithoutSite(vm.user) ? DefaultSite.id : vm.user.SiteId
                ) + semicolonString;
            outputString +=
                toDateFilter(
                    vm.user.license_expiration,
                    null,
                    UserUtility.isAdminWithoutSite(vm.user) ? DefaultSite.id : vm.user.SiteId
                ) + semicolonString;
            outputString += (vm.user.identity_id ? vm.user.identity_id : '') + semicolonString;
            outputString += (vm.user.identity_type ? vm.user.identity_type : '') + semicolonString;
            outputString += (vm.user.identity_issue_state ? vm.user.identity_issue_state : '') + semicolonString;
            outputString += (vm.user.identity_issue_city ? vm.user.identity_issue_city : '') + semicolonString;
            outputString +=
                toDateFilter(
                    vm.user.identity_release,
                    null,
                    UserUtility.isAdminWithoutSite(vm.user) ? DefaultSite.id : vm.user.SiteId
                ) + semicolonString;
            outputString +=
                toDateFilter(
                    vm.user.identity_expiration,
                    null,
                    UserUtility.isAdminWithoutSite(vm.user) ? DefaultSite.id : vm.user.SiteId
                ) + semicolonString;
            outputString += vm.totalTrips + semicolonString;
            outputString += vm.totalSpent + semicolonString;
            outputString += vm.totalUnpaid + semicolonString;
            outputString += vm.totalRefunded + semicolonString;
            outputString += numberFilter(vm.user.freeMinutes, 0) + semicolonString;
            outputString += numberFilter(vm.user.prepaidMinutes, 0) + semicolonString;
            outputString += vm.user.paymentStatusHuman;
            outputString += endLineString;
            outputArray.push(outputString);

            GenerateCSVService.generate(outputArray);
        }

        function exportUserTripsAsCSV() {
            var outputArray = [];
            var outputString = '';
            const semicolonString = ';';
            const endLineString = '\n';
            const priceString = 'e ';
            const minString = ' min';
            const spaceString = ' ';
            const dateTimeFormat = 'dd/MM/yyyy HH:mm:ss';
            const noAddressString = 'No address';

            //header
            outputString =
                'User id' +
                semicolonString +
                'User full name' +
                semicolonString +
                'Trip id' +
                semicolonString +
                'Vehicle id' +
                semicolonString +
                'From' +
                semicolonString +
                'Start' +
                semicolonString +
                'To' +
                semicolonString +
                'End' +
                semicolonString +
                'Duration' +
                semicolonString +
                'Price' +
                endLineString;
            outputArray.push(outputString);

            vm.userTrips.forEach(function (trip) {
                outputString = vm.user.id + semicolonString;
                outputString += vm.user.fullName + semicolonString;
                outputString += trip.id + semicolonString;
                outputString += trip.Vehicle.id + semicolonString;
                outputString += (trip.StartPosition ? trip.StartPosition.address : noAddressString) + semicolonString;
                outputString += toDateFilter(trip.start, dateTimeFormat, trip.SiteId) + semicolonString;
                outputString += (trip.FinishPosition ? trip.FinishPosition.address : noAddressString) + semicolonString;
                outputString += toDateFilter(trip.end, dateTimeFormat, trip.SiteId) + semicolonString;
                outputString += (trip.FinishPosition ? trip.duration + minString : 'Not finished') + semicolonString;
                outputString += trip.Booking.price ? numberFilter(trip.Booking.price, 2) : '';
                outputString += endLineString;
                outputArray.push(outputString);
            });

            GenerateCSVService.generate(outputArray);
        }

        function exportUserInvoicesAsCSV() {
            var outputArray = [];
            var outputString = '';
            const semicolonString = ';';
            const endLineString = '\n';
            const priceString = 'e ';
            const minString = ' min';
            const spaceString = ' ';
            const dateTimeFormat = 'dd/MM/yyyy HH:mm:ss';
            const noLinkString = 'No link';

            //header
            outputString =
                'User id' +
                semicolonString +
                'User full name' +
                semicolonString +
                'Invoice code' +
                semicolonString +
                'Issue date' +
                semicolonString +
                'Rectified Sale' +
                semicolonString +
                'Type' +
                semicolonString +
                'Status' +
                semicolonString +
                'Description' +
                semicolonString +
                'Transaction' +
                semicolonString +
                'Currency' +
                semicolonString +
                'Total' +
                semicolonString +
                'Link' +
                endLineString;
            outputArray.push(outputString);

            vm.invoices.forEach(function (invoice) {
                outputString = vm.user.id + semicolonString;
                outputString += vm.user.fullName + semicolonString;
                outputString += invoice.code + semicolonString;
                outputString += toDateFilter(invoice.created, dateTimeFormat, invoice.SiteId) + semicolonString;
                outputString += (invoice.parent ? invoice.parent.code : '') + semicolonString;
                outputString += invoice.description + semicolonString;
                outputString += vm.getInvoiceTypeDescription(invoice) + semicolonString;
                outputString += vm.getInvoiceStatusDescription(invoice) + semicolonString;
                outputString += invoice.paymentStatusHuman + semicolonString;
                outputString += ServiceSettings.getCurrencySymbol(invoice.SiteId);
                outputString += invoice.totalPrice + semicolonString;
                outputString += invoice.PDF[0].location ? invoice.PDF[0].location : noLinkString;
                outputString += endLineString;
                outputArray.push(outputString);
            });

            GenerateCSVService.generate(outputArray);
        }

        function showBiggerImage(image) {
            vm.biggerImage = image;
            vm.isShowingTheBiggerPicture = true;
        }

        function dismissBiggerImage() {
            vm.biggerImage = null;
            vm.isShowingTheBiggerPicture = false;
        }

        function exportUserTransactionsAsCSV() {
            var outputArray = [];
            var outputString = '';
            const semicolonString = ';';
            const endLineString = '\n';
            const priceString = 'e ';
            const minString = ' min';
            const spaceString = ' ';
            const dateTimeFormat = 'dd/MM/yyyy HH:mm:ss';

            //header
            outputString =
                'User id' +
                semicolonString +
                'User full name' +
                semicolonString +
                'Transaction id' +
                semicolonString +
                'Code' +
                semicolonString +
                'Creation date' +
                semicolonString +
                'Status' +
                semicolonString +
                'Price' +
                endLineString;
            outputArray.push(outputString);

            vm.transactions.forEach(function (transaction) {
                outputString = vm.user.id + semicolonString;
                outputString += vm.user.fullName + semicolonString;
                outputString += transaction.id + semicolonString;
                outputString += (transaction.code ? transaction.code : '') + semicolonString;
                outputString +=
                    toDateFilter(
                        transaction.updated_at,
                        dateTimeFormat,
                        TransactionUtility.getTransactionSiteId(transaction)
                    ) + semicolonString;
                outputString += transaction.status + semicolonString;
                outputString += transaction.price;
                outputString += endLineString;
                outputArray.push(outputString);
            });

            GenerateCSVService.generate(outputArray);
        }
    }

})();

/**
 * Created by alex on 24/01/17.
 */
(function () {
    'use strict';

    angular
        .module('app.trip.details')
        .controller('TripDetailsController', TripDetailsController)
        .factory('TripDialogFactory', TripDialogFactory);

    /** @ngInject */
    function TripDetailsController(
        $scope,
        MapUtility,
        $state,
        TripsListPage,
        ToHireDefaultColor,
        Trip,
        VehicleTypes,
        VehicleStatus,
        VehicleDocumentTypes,
        FuelTypes,
        TripsAdapter,
        $location,
        $anchorScroll,
        SweetAlert,
        MatchedTripStatus,
        TripUtility,
        SitesService,
        VehicleTripStatus,
        LogAdapter,
        toDateFilter,
        ServiceSettings,
        MiscUtility,
        ErrorUtility,
        TripDialogFactory,
        MapProvider
    ) {
        var vm = this;
        vm.mapProvider = null
        // Data
        vm.trip = Trip;
        vm.resourceSiteId = vm.trip.SiteId;
        vm.toHireDefaultColor = ToHireDefaultColor;
        vm.vehicleTripStatus = VehicleTripStatus;
        var tripId = vm.trip.id;

        // console.log("current trip",vm.trip)

        vm.vehicleTypes = VehicleTypes;
        vm.vehicleDocumentTypes = VehicleDocumentTypes;
        vm.fuelTypes = FuelTypes;
        vm.disableEditVehicleDetails = true;

        vm.matchedTripStatus = MatchedTripStatus;
        vm.savedTripPaths = { raw: [], matched: [] };
        vm.isMatchedTripShown = true;

        vm.tripImages = null;
        vm.showTripImage = false;

        // Methods
        vm.refreshTrip = refreshTrip;
        vm.goToTrips = goToTrips;
        vm.enableVehicleDetailsChange = enableVehicleDetailsChange;
        vm.disableVehicleDetailsChange = disableVehicleDetailsChange;
        vm.focusOnImagesTab = focusOnImagesTab;
        vm.toggleOriginalOrMatchedTripPath = toggleOriginalOrMatchedTripPath;
        vm.getTripStatusDescription = TripUtility.getTripStatusDescription;
        vm.getTripLogs = getTripLogs;
        vm.showTripEndImagesDialog = showTripEndImagesDialog;

        $scope.$on('refreshServiceSettings', function (event) {
            console.warn('refreshServiceSettings event');
            init();
        });

        $scope.$on('siteChanged', function (site) {
            console.log('site changed', site);
            //check if a site change the trip belongs to this site
            refreshTrip();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    vm.todayDate = MiscUtility.serviceTodayDate(vm.trip.SiteId);
                    vm.getCurrencyValue = MiscUtility.getCurrencyValue;
                    //update interface

                    vm.tripLogsTableFields = {
                        timestamp: {
                            name: 'Timestamp',
                            class: 'vehicleRowCellBig',
                            key: 'id',
                            type: 'render',
                            render: function (v, o) {
                                return toDateFilter(o.fixtaken, 'dateTime', vm.resourceSiteId);
                            },
                        },
                        fuel: {
                            name: vm.trip.Vehicle.type === VehicleTypes.CAR.value ? 'Fuel' : 'Battery',
                            class: 'vehicleRowCell',
                            key: 'total_percentage',
                            type: 'render',
                            render: function (v, o) {
                                return !isNaN(parseInt(o.total_percentage)) ? o.total_percentage + ' %' : '';
                            },
                        },
                        speed: {
                            name: 'Speed',
                            class: 'vehicleRowCell',
                            key: 'speed',
                            type: 'render',
                            render: function (v, o) {
                                return !isNaN(parseInt(o.speed)) ? o.speed : '';
                            },
                        },
                        km: {
                            name: 'Km',
                            class: 'vehicleRowCell',
                            key: 'km',
                            type: 'render',
                            render: function (v, o) {
                                return !isNaN(parseInt(o.km)) ? o.km + ' km ' : '';
                            },
                        },
                        latitude: { name: 'Latitude', class: 'vehicleRowCellBig', key: 'latitude' },
                        longitude: { name: 'Longitude', class: 'vehicleRowCellBig', key: 'longitude' },
                        satellites: { name: 'Satellites', class: 'vehicleRowCellSmall', key: 'satellites' },
                        status: { name: 'Status', class: '', key: 'status' },
                    };

                    $scope.$applyAsync();
                }
            });
        }
        init();

        // NOTE get trip image in order to show the dialog button
        if (vm.trip) {
            getEndTripImages(vm.trip.id);
        }

        vm.onMapInit = function (map, mapProvider) {
            if (vm.mapInitialized) {
                return;
            }
            vm.mainMap = map;
            vm.mapProvider = mapProvider
            vm.mapInitialized = true;
            setDataOnMap(vm.trip, mapProvider);
        };


        var vehicleBeforeChanges = {};

        function enableVehicleDetailsChange() {
            vm.disableEditVehicleDetails = !vm.disableEditVehicleDetails;
            vehicleBeforeChanges = angular.copy(vm.vehicle);
        }

        function disableVehicleDetailsChange() {
            vm.disableEditVehicleDetails = !vm.disableEditVehicleDetails;
            vm.vehicle = angular.copy(vehicleBeforeChanges);
        }

        function focusOnImagesTab() {
            vm.selectedTab = vm.tabs.IMAGES;
            $location.hash('vehicle-details-tabs');
            $anchorScroll();
        }

        function toggleOriginalOrMatchedTripPath(mapProvider) {
            if (!vm.polyline) {
                var path = [];

                if (vm.savedTripPaths.matched.length > 0) {
                    path = vm.savedTripPaths.matched;
                } else {
                    path = vm.savedTripPaths.raw;
                    vm.isMatchedTripShown = false;
                }

                setPolylineOnMap(path, mapProvider);
            } else {
                if (vm.savedTripPaths.matched.length == 0) {
                    SweetAlert.swal('No Matched Trip', 'No matched trip path is avaiable!', 'error');
                    vm.isMatchedTripShown = true;
                    return;
                } else {
                    if (vm.isMatchedTripShown) {
                        updatePolylinePath(vm.savedTripPaths.raw, mapProvider);
                    } else {
                        updatePolylinePath(vm.savedTripPaths.matched);
                    }
                }
            }
        }

        function updatePolylinePath(path, mapProvider) {
            if (vm.polyline && path) {
                vm.polyline.setPath(path);
            } else {
                // MAPBOX
                if (mapProvider === MapProvider.MAPBOX) {

                    createOrUpdateMapboxPolyline(path)
                }
            }
        }

        function createOrUpdateMapboxPolyline(path) {
            if (!vm.mainMap) {return}
            const geoJSON = {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        geometry: {
                            type: 'LineString',
                            properties: {},
                            coordinates: path.map(function (latLngPoint) {
                                return [latLngPoint.lng, latLngPoint.lat];
                            }),
                        },
                        properties: {
                            lineColor: '#2587F1',
                        },
                    },
                ],
            };

            const lastPolyline = vm.mainMap.getSource('polyline')
            if(lastPolyline) {
                lastPolyline.setData(geoJSON)
            } else {
                vm.mainMap.addSource('polyline',{
                    type: 'geojson',
                    data: geoJSON,
                })
            }
            const polyLayer = vm.mainMap.getLayer('polylineLayer')
            if(!polyLayer) {
                vm.mainMap.addLayer({
                    id: 'polylineLayer',
                    source: 'polyline',
                    type: 'line',
                    paint: {
                        'line-color': ['get', 'lineColor'],
                        'line-width': 4,
                    },
                })
            }
        }

        function setPolylineOnMap(path, mapProvider) {
            switch (mapProvider) {
                case MapProvider.GOOGLE_MAPS:
                    vm.polyline = new google.maps.Polyline({
                        path: path,
                        strokeColor: '#2587F1',
                        strokeOpacity: 1.0,
                        strokeWeight: 4,
                    });
                    vm.polyline.setMap(vm.mainMap);
        
                    //polyline onClick : search nearest point where clicked
                    google.maps.event.addListener(vm.polyline, 'click', function (e) {
                        var clickedPosition = e.latLng;
        
                        var needle = {
                            minDistance: 9999999999, //silly high
                            index: -1,
                            latlng: null,
                        };
                        vm.polyline.getPath().forEach(function (routePoint, index) {
                            var dist = google.maps.geometry.spherical.computeDistanceBetween(clickedPosition, routePoint);
                            if (dist < needle.minDistance) {
                                needle.minDistance = dist;
                                needle.index = index;
                                needle.latlng = routePoint;
                            }
                        });
                        // The clicked point on the polyline
                        console.log('Clicked position', clickedPosition.toString());
                        // The closest point in the polyline
                        console.log('Closest position: ' + needle.latlng);
                        // The closest point index in the polyline
                        console.log('Closest position index: ' + needle.index);
                    });
                    break;

                case MapProvider.MAPBOX:
                    createOrUpdateMapboxPolyline(path)
                    break;
                default:
                    break;
            }
            
        }

        function setDataOnMap(trip, mapProvider) {
            if (!trip.StartPosition) return;

            if (!trip.Vehicle) return;

            trip.isFocused = true;
            var startPoint = trip.StartPosition;
            var endPoint = trip.FinishPosition;

            switch (mapProvider) {
                case MapProvider.GOOGLE_MAPS:
                    var startMarker = MapUtility.generateTripStartMarker(trip, vm.mainMap);

                    if (trip.StatusChanges) {
                        vm.parkedStatuses = trip.StatusChanges.filter(function (vehicle) {
                            return vehicle.status == VehicleStatus.PARKED.value;
                        });

                        if (vm.parkedStatuses && vm.parkedStatuses.length > 0) {
                            vm.parkedStatuses.forEach(function (vehicleParked) {
                                vehicleParked['SiteId'] = trip.SiteId;
                                MapUtility.generateTripParkedMarker(vehicleParked, vm.mainMap);
                            });
                        }
                    }
                    var endMarker = null;
                    //check if trip is still in progress,else create end point
                    if (endPoint) {
                        endMarker = MapUtility.generateTripEndMarker(trip, vm.mainMap);
                    }
                    break;

                case MapProvider.MAPBOX:
                    const vehicles = []
                    startPoint.status = 'tripStart'
                    startPoint.SiteId = trip.SiteId 
                    vehicles.push(startPoint)
                    if(trip.StatusChanges) {
                        trip.StatusChanges.forEach(function(statusChange) {
                            if(statusChange.status === VehicleStatus.PARKED.value) {
                                statusChange.SiteId = trip.SiteId
                                vehicles.push(statusChange)
                            }
                        })
                    }
                    if (endPoint) {
                        endPoint.status = 'tripEnd'
                        endPoint.SiteId = trip.SiteId
                        vehicles.push(endPoint)
                    }
                    vm.onRefreshMap(vehicles)
                    break;
                default:
                    break;
            }

            TripsAdapter.getTripPositions(trip.id, function (responseData, error) {
                if (!error) {
                    // console.log("getTripPosition",responseData[0])

                    var originalTrip = responseData.raw;
                    var matchedTrip = responseData.matched;
                    var path = [];
                    vm.polyline = null;
                    vm.savedTripPaths = { raw: [], matched: [] };
                    vm.isMatchedTripShown = true;
                    //check with path to use original or matched

                    //calculate and save original trip path
                    var originalTripPath = [];
                    originalTrip.forEach(function (point) {
                        originalTripPath.push({ lat: point.latitude, lng: point.longitude });
                    });
                    vm.savedTripPaths.raw = originalTripPath;
                    path = originalTripPath;

                    //calculate and save matched trip path only if ready status
                    if (matchedTrip.status == vm.matchedTripStatus.READY.value) {
                        // console.log("Matched trip path exists")
                        var matchedTripPath = google.maps.geometry.encoding.decodePath(matchedTrip.polyline);
                        //add start trip point in decoded polyline matching with startpoint marker
                        if (startPoint) {
                            matchedTripPath.unshift({
                                lat: startMarker.getPosition().lat(),
                                lng: startMarker.getPosition().lng(),
                            });
                        }
                        //add end trip point in decoded polyline matching with endpoint marker
                        if (endPoint) {
                            matchedTripPath.push({
                                lat: endMarker.getPosition().lat(),
                                lng: endMarker.getPosition().lng(),
                            });
                        }
                        vm.savedTripPaths.matched = matchedTripPath;
                        path = matchedTripPath;
                    }

                    //init path
                    toggleOriginalOrMatchedTripPath(mapProvider);

                    /*//check if trip is still in progress so set end point as last point
                    if (!endPoint) {
                        var lastPoint = path[path.length - 1]
                        endPoint = {latitude: lastPoint.lat, longitude: lastPoint.lng}
                    }*/
                    fitMapBounds(path, mapProvider);
                } else {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Trip Positions',
                        description: "There was an error while getting the trip's positions!",
                    });
                }
            });
        }

        function fitMapBounds(points, mapProvider) {
            // TODO: Fix fitMapBounds
            // This currently doesn't support mapbox as a side effect
            // map is centered on the markers and not on the polyline
            if (mapProvider !== MapProvider.GOOGLE_MAPS) {
                return
            }
            var bounds = new google.maps.LatLngBounds();

            points.forEach(function (point) {
                bounds.extend(point);
            });
            vm.mainMap.fitBounds(bounds);
        }

        function refreshTrip() {
            if (tripId) {
                TripsAdapter.getTrip(tripId, function (trip, error) {
                    if (error) {
                        ErrorUtility.showErrorMessage({
                            title: 'Get Trip details',
                            description: 'There was an error while getting the trip details!',
                        });
                        goToTrips();
                    } else {
                        vm.trip = trip;
                        // console.log("current trip",vm.trip)
                        setDataOnMap(trip, vm.mapProvider);
                        getEndTripImages(trip.id);
                    }
                });
            }
        }

        function goToTrips() {
            $state.go(TripsListPage);
        }

        function goToUserDetails(user) {
            $state.go(UserDetailsPage, { user: user });
        }

        function goToVehicleDetails(vehicle) {
            $state.go(VehicleDetailsPage, { vehicle: vehicle });
        }

        function getTripLogs(callback) {
            if (vm.trip.id) {
                vm.isLoading = true;
                vm.tripLogs = [];

                LogAdapter.getTripLogs(tripId, function (data, error) {
                    vm.isLoading = false;
                    if (error) {
                        ErrorUtility.showErrorMessage({
                            title: 'Get Trip Logs',
                            description: 'There was an error while getting the trip logs!',
                        });
                        if (callback) callback(data);
                    } else {
                        // console.log("getTripLogs",data[0])
                        vm.tripLogs = data;
                        if (callback) callback(null, error);
                    }
                });
            }
        }

        function showTripEndImagesDialog(event) {
            if (vm.showTripImage) {
                TripDialogFactory.showEndImages(event, vm.trip, vm.tripImages);
            }
        }

        function getEndTripImages(tripId) {
            if (!tripId) {
                console.warn('no trip id', tripId);
                return;
            }

            TripsAdapter.getEndTripImages(tripId, function (data, error) {
                if (error) {
                    // NOTE fail silently in order to do not show permission error
                    // ErrorUtility.showErrorMessage({
                    //     title: 'Get Trip End Image',
                    //     description: 'Error getting the images!',
                    // });
                } else {
                    if (data && data.length > 0) {
                        vm.showTripImage = true;
                        vm.tripImages = data;
                    }
                }
            });
        }
    }

    /** @ngInject */
    function TripDialogFactory($mdDialog, $document) {
        return {
            showEndImages: function (ev, trip, tripImages) {
                return $mdDialog.show({
                    controller: 'TripEndImageDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/trip/details/dialogs/trip-end-image-dialog.html',
                    parent: angular.element($document.body), //angular.element($document.find('#content-container'))
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        Trip: trip,
                        EndTripImages: tripImages,
                    },
                });
            },
        };
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.settings.translations',[])
        .value('TranslationsPage',"app.settings.translations")
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.settings.translations',{
                url: "/translations",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/translations/translations.html',
                        controller : 'TranslationsController as vm'
                    }
                }
            })
    }

})();
(function(){
    'use strict'

    angular // this is for formatting
        .module('app.settings.translations')
        .controller('TranslationsController', TranslationsController);

        /** @ngInject */
        function TranslationsController($scope,$timeout,TranslationsAdapter,SweetAlert,ErrorUtility,DefaultSite,SitesService,MiscUtility){
            var vm = this
            vm.translations = {}
            vm.availableLanguages = {}
            vm.newTranslation = {}
            vm.isEditing = false
            vm.sites = []
            vm.DefaultSite = DefaultSite
            vm.selectedSiteId = DefaultSite.id
            vm.isDefaultSiteSelected = false
            var savedTranslations = null
            vm.isAFilterSelected = false
            vm.filter = {
                siteId: vm.selectedSiteId,
                lang:'',
                query:''
            }

            $scope.$on('$viewContentLoaded',function(event){
                getTranslations()
            })

            $scope.$on('siteChanged',function(site){
                console.log("siteChanged")
                getTranslations()
                initSites()
            })

            vm.addATranslation = addATranslation
            vm.toggleEditing = toggleEditing
            vm.callModifyTranslations = callModifyTranslations
            vm.getSites = getSites
            vm.languageFilter = languageFilter
            vm.searchFilter = searchFilter
            vm.getSiteName = SitesService.getSiteName

            function refreshTranslations(){
                getTranslations()
            }

            function loadAvailableLanguages(langsToTranslations) {
                for(var lang in langsToTranslations){
                    if(!vm.availableLanguages.hasOwnProperty(lang)){
                        vm.availableLanguages[lang] = {name: lang, value: lang, isHidden: true}
                    }
                }
            }
            
            function getTranslations(){
                vm.translations = {}
                
                TranslationsAdapter.getTranslations(
                    function(data,error){
                        if(error){
                              ErrorUtility.showErrorMessage({title: 'Get Translations', description: 'Error while getting the translations list'})
                        }else{
                            console.log("getTranslations",data)
                            var langsToTranslations = data
                            
                            //load languages
                            loadAvailableLanguages(langsToTranslations.base)
                            for(var siteId in langsToTranslations.specific){
                                for(var lang in langsToTranslations.specific[siteId]){
                                    loadAvailableLanguages(langsToTranslations.specific[siteId])
                                }
                            }

                            //order langsToTranslations languages keys
                            var newLangsToTranslationsObj = {base:{},specific:{}}
                            for(var langKey in vm.availableLanguages){
                                
                                if(langsToTranslations.base.hasOwnProperty(langKey)){
                                    newLangsToTranslationsObj.base[langKey] = langsToTranslations.base[langKey]
                                }
                                for(var siteId in langsToTranslations.specific){
                                    if(langsToTranslations.specific[siteId].hasOwnProperty(langKey)){
                                        if(newLangsToTranslationsObj.specific[siteId]){
                                            newLangsToTranslationsObj.specific[siteId][langKey] = langsToTranslations.specific[siteId][langKey]
                                        }else{
                                            newLangsToTranslationsObj.specific[siteId] = {}
                                            newLangsToTranslationsObj.specific[siteId][langKey] = langsToTranslations.specific[siteId][langKey]
                                        }
                                    } 
                                }
                            }
                            savedTranslations = angular.copy(newLangsToTranslationsObj)
                            vm.translations = newLangsToTranslationsObj
                        }
                    })
            }

            initSites()

            function getSites(callback) {
                console.log("getSites trigger")
                
                SitesService.getSites(function (sites) {
                    console.log("getSites",sites)
                    vm.sites = sites

                    if(typeof callback !== 'undefined')
                        callback(sites)
                })
            }

            function setSelectedSiteInfo(siteId) {
                vm.selectedSiteId = siteId
                vm.isDefaultSiteSelected = (siteId == DefaultSite.id)
                console.log("selectedSite",vm.selectedSiteId,"isDefaultSiteSelected",vm.isDefaultSiteSelected)
                
                //set page filters
                vm.newTranslation.siteId = siteId
                vm.filter.siteId = siteId
            }

            function initSites(params) {
                getSites(function(){
                    setSelectedSiteInfo(SitesService.getSelectedSite())
                })
            }

            function languageFilter(langKey) {

                if(!vm.isAFilterSelected){
                    vm.isAFilterSelected = true
                }
                var languages = Object.values(vm.availableLanguages)

                if(langKey === undefined){
                    //enable all languages
                    languages.forEach(function (langObj) {
                        langObj.isHidden = false
                    })
                    return
                }

                languages.forEach(function (langObj) {
                    if(langObj.name !== langKey){
                        langObj.isHidden = true
                    }
                })

                vm.availableLanguages[langKey].isHidden = false
            }

            function searchFilter(translation){
                if(!vm.filter.query || vm.filter.query == ''){
                    return true
                }

                var query = vm.filter.query.toLowerCase()
                return translation.key.toLowerCase().indexOf(query) !== -1 || translation.value.toLowerCase().indexOf(query) !== -1
            }

            function toggleEditing(){
                if(!vm.isEditing){
                    vm.translationsNotModified = angular.copy(vm.translations)
                }
                else{
                    vm.translations = vm.translationsNotModified
                }
                vm.isEditing = !vm.isEditing
            }

            function addATranslation(){
                if (vm.newTranslation==undefined || Object.keys(vm.newTranslation).length==0){
                    ErrorUtility.showErrorMessage({title:'Add a Translation',description:'Invalid input'})
                    return
                }
                if (vm.newTranslation.siteId === undefined || vm.newTranslation.siteId === null){
                    ErrorUtility.showErrorMessage({title:'Add a Translation',description:'Invalid site'})
                    return
                }
                if (vm.newTranslation.lang === undefined || vm.newTranslation.lang === null || vm.newTranslation.lang === ''){
                    ErrorUtility.showErrorMessage({title:'Add a Translation',description:'Invalid translation language'})
                    return
                }
                if (vm.newTranslation.key === undefined || vm.newTranslation.key === null || vm.newTranslation.key === ''){
                    ErrorUtility.showErrorMessage({title:'Add a Translation',description:'Invalid translation key'})
                    return
                }
                if (vm.newTranslation.value === undefined || vm.newTranslation.value === null || vm.newTranslation.value === ''){
                    ErrorUtility.showErrorMessage({title:'Add a Translation',description:'Invalid translation value'})
                    return
                }


                var dataToSend = angular.copy(savedTranslations)
                var newLangTranslation = { key: vm.newTranslation.key.toUpperCase(), value: vm.newTranslation.value }
                
                if(vm.newTranslation.siteId === DefaultSite.id){
                    console.warn('addATranslation all cities selected')
                    var baseTranslations = dataToSend.base[vm.newTranslation.lang]
                    
                    if(baseTranslations){
                        console.warn('addATranslation base EXISTS')
                        baseTranslations.push(newLangTranslation)
                    }else{
                        console.warn('addATranslation base does NOT EXISTS')
                        dataToSend.base[vm.newTranslation.lang] = [newLangTranslation]
                    }
                }else{
                    console.warn('addATranslation site specific selected',vm.newTranslation.siteId)
                    var specificTranslations = dataToSend.specific[vm.newTranslation.siteId]

                    if(specificTranslations){
                        var specificTranslationsLang = specificTranslations[vm.newTranslation.lang]
                        if(specificTranslationsLang){
                            specificTranslationsLang.push(newLangTranslation)
                        }else{
                            specificTranslations[vm.newTranslation.lang] = [newLangTranslation]
                        }
                    }else{
                        console.warn('addATranslation case specific does not exists')
                        dataToSend.specific[vm.newTranslation.siteId] = {}
                        dataToSend.specific[vm.newTranslation.siteId][vm.newTranslation.lang] = [newLangTranslation]
                    }
                }

                modifyTranslations(dataToSend)
            }

            function allTranslationsKeysToUppercase(translationsLangs) {
                for(var lang in translationsLangs){
                    translationsLangs[lang].forEach(function(objLang){
                        objLang.key = objLang.key.toUpperCase()
                    })
                }
            }

            function callModifyTranslations(){

                var dataToSend = angular.copy(vm.translations)

                //check if key is uppercase
                allTranslationsKeysToUppercase(dataToSend.base)
                for(var siteId in dataToSend.specific){
                    allTranslationsKeysToUppercase(dataToSend.specific[siteId])
                }
                modifyTranslations(dataToSend)
            }

            function modifyTranslations(dataToSend){

                if (dataToSend){
                    console.log("dataToSend", dataToSend)

                    TranslationsAdapter.modifyTranslations(dataToSend,function(data,error){
                        if(error){
                            vm.translations = angular.copy(savedTranslations)
                            ErrorUtility.showErrorMessage({title:"Update Translations",description:"There was an error while updating the translations!"})
                        }
                        else{
                            SweetAlert.swal("Update Translations","Successfully updated the translations!","success")
                            refreshTranslations()
    
                            if(vm.isEditing)
                                vm.isEditing = false
                        }
                    })
                }
            }

        }
})();


(function ()
{
    'use strict';

    angular
        .module('app.settings.permission', ['app.settings.permission.role-details'])
        .value('PermissionsListPage', 'app.settings.permission')
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.settings.permission',{
                url: "/permissions",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/permissions/permissions.html',
                        controller : 'PermissionsController as vm'
                    }
                }
            })

        // Navigation
        msNavigationServiceProvider.saveItem('settings.permission', {
            title : 'Permissions',
            icon  : 'icon-account-key',
            state: 'app.settings.permission',
            weight: 5
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("settings.permission")
        
        if(!active) {
            msNavigationService.deleteItem("settings.permission")
        }
    }

})();

(function() {
    'use strict'

    angular
        .module("app.settings.permission")
        .controller("PermissionsController",PermissionsController)

        /** @ngInject */
        function PermissionsController($scope, PermissionsAdapter,DialogFactory,SweetAlert,ErrorUtility) {
            var vm = this

            vm.roles = []

            vm.permissionsGroups = []
            vm.isAddingRole = false

            $scope.$on('$viewContentLoaded',function(event){
                //getPermissions()
                getRoles()
            })

            //TODO CHECK IF USER HAS PERMISIONS LIST PERMISSION
            var permissionsGrouped = [
                {
                    name: 'Activate all the permissions',
                    permissions: [
                        {   
                            description:'A permission to rule them all',
                            permission:'admin'
                        }
                    ]
                },
                {
                    name: 'Required permissions',
                    permissions: [
                        {   
                            description:'Can fetch current service settings',
                            permission:'admin.service.setting.get'
                        },
                        {   
                            description:'Can fetch sites list',
                            permission:'admin.service.site.get'
                        },
                        {   
                            description:'Can fetch user\'s status ',
                            permission:'admin.user.status'
                        },
                        {   
                            description:'Can fetch roles list',
                            permission:'admin.permission.role.get'
                        },
                        {   
                            description:'Can fetch user\'s roles',
                            permission:'admin.user.role.get'
                        },
                        {   
                            description:'Can fetch geofencing areas list',
                            permission:'admin.service.geofencing.get'
                        },
                        {   
                            description:'Can fetch damages list',
                            permission:'admin.service.expense.get'
                        },
                        {   
                            description:'Enable logging',
                            permission:'admin.log'
                        }
                    ]
                },
                {
                    name: 'General Permissions',
                    permissions: [
                        {   
                            description:'Enable the entire service',
                            permission:'admin.service.enable'
                        },
                        {   
                            description:'Disable the entire service',
                            permission:'admin.service.disable'
                        }
                    ]
                },
                {
                    name: 'Dashboard List Page',
                    permissions: [
                        {   
                            description:'Can see fleet status counters',
                            permission:'admin.analytics.fleet'
                        },
                        {   
                            description:'Can see vehicles status counters',
                            permission:'admin.analytics.vehicle.status'
                        },
                        {   
                            description:'Can see trips status counters',
                            permission:'admin.analytics.trip.status'
                        },
                        {   
                            description:'Can see users status counters',
                            permission:'admin.analytics.user.status'
                        }
                        // //'' it's includes in .fleet
                        // ,{   
                        //     description:'',
                        //     permission:'admin.analytics.fleet.battery'
                        // }
                    ]
                },
                {
                    name: 'Map Page',
                    permissions: [
                        {   
                            description:'Can see vehicles on the map',
                            permission:'admin.sharing.vehicle.map.get'
                        },
                        {   
                            description:'Can see vehicle details',
                            permission:'admin.sharing.vehicle.info'
                        },
                        {   
                            description:'Can watch vehicles positions',
                            permission:'admin.sharing.vehicle.map.watch'
                        }
                    ]
                },
                // {
                //     name: 'Analytics Page',
                //     permissions: [
                //         {   
                //             description:'Can see vehicles heatmap',
                //             permission:'admin.analytics.heatmap'
                //         },
                //         {   
                //             description:'Can see bookings stats',
                //             permission:'admin.analytics.booking'
                //         },
                //         {   
                //             description:'Can see economics stats',
                //             permission:'admin.analytics.business'
                //         }
                //     ]
                // },
                {
                    name: 'Reports List Page',
                    permissions: [
                        {   
                            description:'Can see reports list',
                            permission:'admin.service.damage.get'
                        },
                        {   
                            description:'Can see report details',
                            permission:'admin.service.damage.info'
                        }
                    ]
                },
                {
                    name: 'Vehicles List Page',
                    permissions: [
                        {   
                            description:'Can see vehicles list',
                            permission:'admin.sharing.vehicle.get'
                        },
                        {   
                            description:'Can see vehicle details',
                            permission:'admin.sharing.vehicle.info'
                        },
                        {   
                            description:'Can watch vehicles positions',
                            permission:'admin.sharing.vehicle.map.watch'
                        },
                        {   
                            description:'Can add vehicles',
                            permission:'admin.sharing.vehicle.create'
                        },
                        // shared in required permissions
                        // {   
                        //     description:'Can see sites list',
                        //     permission:'admin.service.site.get'
                        // }
                    ]
                },
                {
                    name: 'Vehicle Details Page',
                    permissions: [
                        {   
                            description:'Can update vehicle details',
                            permission:'admin.sharing.vehicle.put'
                        },
                        //shared in required permisions
                        // {   
                        //     description:'',
                        //     permission:'admin.service.site.get'
                        // },
                        {   
                            description:'Can delete vehicle',
                            permission:'admin.sharing.vehicle.delete'
                        },
                        {   
                            description:'Can see vehicle\'s trips',
                            permission:'admin.personal.trip.vehicle.get'
                        },
                        {   
                            description:'Can see vehicle\'s logs',
                            permission:'admin.personal.vehicle.log.status.get'
                        },
                        //shared in required permissions
                        // {   
                        //     description:'',
                        //     permission:'admin.service.expense.get'
                        // },
                        {   
                            description:'Can see vehicle\'s reports',
                            permission:'admin.personal.vehicle.damage.get'
                        },
                        {   
                            description:'Can act on a scooter (override specific actions)',
                            permission:'admin.maintenance.sharing.scooter'
                        },
                        {   
                            description:'Can start a scooter',
                            permission:'admin.maintenance.sharing.scooter.start'
                        },
                        {   
                            description:'Can stop a scooter',
                            permission:'admin.maintenance.sharing.scooter.stop'
                        },
                        // {   
                        //     description:'Can free a scooter when parked',
                        //     permission:'admin.maintenance.sharing.scooter.end'
                        // },
                        {   
                            description:'Can turn on a scooter',
                            permission:'admin.maintenance.sharing.scooter.on'
                        },
                        {   
                            description:'Can turn off a scooter',
                            permission:'admin.maintenance.sharing.scooter.off'
                        },
                        {   
                            description:'Can act on scooter\'s trunk',
                            permission:'admin.maintenance.sharing.scooter.trunk'
                        },
                        {   
                            description:'Can open scooter\'s saddle',
                            permission:'admin.maintenance.sharing.scooter.manage.saddle.open'
                        },
                        {   
                            description:'Can locate a scooter',
                            permission:'admin.maintenance.sharing.scooter.locate'
                        },
                        {   
                            description:'Can act on a kick scooter',
                            permission:'admin.maintenance.sharing.kick'
                        },
                        {   
                            description:'Can act with Segway\'s specific commands',
                            permission:'admin.segway.passThrough'
                        },
                        {   
                            description:'Can act with OKAI\'s specific commands',
                            permission:'admin.okai.passThrough'
                        },
                        {   
                            description:'Can act on a bike',
                            permission:'admin.maintenance.sharing.bike'
                        },
                        {   
                            description:'Can enable a horseshoe lock',
                            permission:'admin.maintenance.sharing.bike.horseshoe-lock.lock'
                        },
                        {   
                            description:'Can act on a car',
                            permission:'admin.maintenance.sharing.car'
                        },
                        {   
                            description:'Can see vehicle\'s additional actions',
                            permission:'admin.personal.vehicle.action.get'
                        },
                        {   
                            description:'Can act on vehicle\'s additional actions',
                            permission:'admin.personal.vehicle.action.send'
                        },
                        {   
                            description:'Can set vehicle to available',
                            permission:'admin.maintenance.sharing.vehicle.available'
                        },
                        {   
                            description:'Can set vehicle to unavailable',
                            permission:'admin.maintenance.sharing.vehicle.unavailable'
                        },
                        {   
                            description:'Can manually free a vehicle (Leave command)',
                            permission:'admin.maintenance.sharing.vehicle.leave'
                        },
                        {   
                            description:'Can manually start a trip',
                            permission:'admin.personal.trip.start'
                        },
                        {   
                            description:'Can manually stop a trip',
                            permission:'admin.personal.trip.stop'
                        },
                        {   
                            description:'Can add vehicle\'s image',
                            permission:'admin.sharing.vehicle.image.create'
                        },
                        {   
                            description:'Can update vehicle\'s image',
                            permission:'admin.sharing.vehicle.image.update'
                        },
                        {   
                            description:'Can delete vehicle\'s image',
                            permission:'admin.sharing.vehicle.image.delete'
                        },
                        {   
                            description:'Can see vehicle\'s documents list',
                            permission:'admin.sharing.vehicle.document.get'
                        },
                        {   
                            description:'Can add vehicle\'s documents',
                            permission:'admin.sharing.vehicle.document.create'
                        },
                        {   
                            description:'Can update vehicle\'s documents',
                            permission:'admin.sharing.vehicle.document.update'
                        },
                        {   
                            description:'Can delete vehicle\'s documents',
                            permission:'admin.sharing.vehicle.document.delete'
                        }
                    ]
                },
                {
                    name: 'Trips List Page',
                    permissions: [
                        {   
                            description:'Can see trips list',
                            permission:'admin.personal.trip.get'
                        },
                        {   
                            description:'Can see trip details',
                            permission:'admin.personal.trip.info'
                        }
                    ]
                },
                {
                    name: 'Trip Details Page',
                    permissions: [
                        {   
                            description:'Can see trip\'s positions',
                            permission:'admin.personal.trip.position'
                        },
                        {   
                            description:'Can see trip\'s logs',
                            permission:'admin.personal.trip.log'
                        },
                        {   
                            description:'Can see trip\'s end images',
                            permission:'admin.personal.trip.picture.stop'
                        },
                    ]
                },
                // {
                //     name: 'Maintenance List Page',
                //     permissions: [
                //         {   
                //             description:'Can see maintenance records list',
                //             permission:'admin.maintenance.get'
                //         },
                //         {   
                //             description:'Can see maintenance record details',
                //             permission:'admin.maintenance.info'
                //         }
                //     ]
                // },
                {
                    name: 'Users List Page',
                    permissions: [
                        {   
                            description:'Can see users list',
                            permission:'admin.user.get'
                        },
                        {   
                            description:'Can see user details',
                            permission:'admin.user.info'
                        },
                        {   
                            description:'Can register admins',
                            permission:'admin.user.admin.create'
                        },
                    ]
                },
                {
                    name: 'User Details Page',
                    permissions: [
                        // shared in required permissions
                        // {   
                        //     description:'',
                        //     permission:'admin.user.status'
                        // },
                        {   
                            description:'Can update user\'s details',
                            permission:'admin.user.update'
                        },
                        {   
                            description:'Can upload user\'s selfie',
                            permission:'admin.user.avatar.update'
                        },
                        {   
                            description:'Can upload user\'s driving license',
                            permission:'admin.user.license.update'
                        },
                        {   
                            description:'Can accept user\'s driving license',
                            permission:'admin.user.license.accept'
                        },
                        {   
                            description:'Can reject user\'s driving license',
                            permission:'admin.user.license.reject'
                        },
                        {   
                            description:'Can revoke user\'s driving license',
                            permission:'admin.user.license.not.valid'
                        },
                        {   
                            description:'Can upload user\'s identity document',
                            permission:'admin.user.document.update'
                        },
                        {   
                            description:'Can accept user\'s identity document',
                            permission:'admin.user.document.accept'
                        },
                        {   
                            description:'Can reject user\'s identity document',
                            permission:'admin.user.document.reject'
                        },
                        {   
                            description:'Can revoke user\'s identity document',
                            permission:'admin.user.document.not.valid'
                        },
                        {   
                            description:'Can see user\'s trips',
                            permission:'admin.user.trip.get'
                        },
                        {   
                            description:'Can see user\'s transactions',
                            permission:'admin.user.transaction.get'
                        },
                        {   
                            description:'Can retry user\'s transactions',
                            permission:'admin.user.transaction.retry'
                        },
                        {   
                            description:'Can see user\'s payment methods',
                            permission:'admin.user.payment.get'
                        },
                        // not needed
                        // {   
                        //     description:'',
                        //     permission:'admin.user.payment.create'
                        // },
                        {   
                            description:'Can delete user\'s payment methods',
                            permission:'admin.user.payment.delete'
                        },
                        {   
                            description:'Can charge user\'s payment method',
                            permission:'admin.user.payment.charge'
                        },
                        {   
                            description:'Can see user\'s invoices',
                            permission:'admin.user.invoice.get'
                        },
                        {   
                            description:'Can see user\'s referred users',
                            permission:'admin.user.referral.get'
                        },
                        {   
                            description:'Can see user\'s legacy coupons',
                            permission:'admin.user.coupon.get'
                        },
                        {   
                            description:'Can see user\'s coupons',
                            permission: 'admin.user.bonus.coupon.get'
                        },
                        {   
                            description: 'Can see user\'s store orders',
                            permission: 'admin.user.order.get'
                        },
                        // shared in required permissions
                        // {   
                        //     description:'Can get user\'s roles',
                        //     permission:'admin.user.role.get'
                        // },
                        // {   
                        //     description:'Can get roles',
                        //     permission:'admin.permission.role.get'
                        // },
                        {   
                            description:'Can assign roles to the user',
                            permission:'admin.user.role.add'
                        },
                        {   
                            description:'Can remove user roles',
                            permission:'admin.user.role.remove'
                        },
                        {   
                            description:'Can block user',
                            permission:'admin.user.block'
                        },
                        {   
                            description:'Can unblock user',
                            permission:'admin.user.unblock'
                        },
                        {   
                            description:'Can reset user\'s password',
                            permission:'admin.user.password.reset'
                        },
                        {   
                            description:'Can activate user in a site',
                            permission:'admin.user.site.activate'
                        },
                        {   
                            description:'Can deactivate user from a site',
                            permission:'admin.user.site.deactivate'
                        },
                        {
                            description:'Can add user free minutes',
                            permission:'admin.user.freemillis.update.add'
                        },
                        {   
                            description:'Can remove user free minutes',
                            permission:'admin.user.freemillis.update.remove'
                        },
                        {   
                            description:'Can deactivate a user account',
                            permission:'admin.user.deactivate'
                        },
                    ]
                },
                {
                    name: 'Tickets List Page',
                    permissions: [
                        {   
                            description:'Can see tickets list',
                            permission:'admin.service.invoice.get'
                        },
                        // {   
                        //     description:'Can see invoice details',
                        //     permission:'admin.service.invoice.info'
                        // },
                        {   
                            description:'Can create/rectify tickets',
                            permission:'admin.service.invoice.create'
                        },
                        //shared with users list
                        // {   
                        //     description:'Can get users list (related to create tickets)',
                        //     permission:'admin.user.get'
                        // }
                    ]
                },
                {
                    name: 'Coupons List Page',
                    permissions: [
                        {   
                            description:'Can see coupons list',
                            permission:'admin.service.coupon.get'
                        },
                        {   
                            description:'Can see coupon\'s users counter',
                            permission:'admin.service.coupon.user'
                        },
                        {   
                            description:'Can see coupon details',
                            permission:'admin.service.coupon.info'
                        },
                        {   
                            description:'Can add coupons',
                            permission:'admin.service.coupon.create'
                        }
                    ]
                },
                {
                    name: 'Coupon Details Page',
                    permissions: [
                        // {   
                        //     description:'',
                        //     permission:'admin.service.coupon.info'
                        // },
                        // {   
                        //     description:'',
                        //     permission:'admin.service.coupon.user'
                        // },
                        {   
                            description:'Can update coupons',
                            permission:'admin.service.coupon.update'
                        },
                        {   
                            description:'Can set a coupon as referral',
                            permission:'admin.service.coupon.referral'
                        },
                        {   
                            description:'Can delete coupons',
                            permission:'admin.service.coupon.delete'
                        }
                    ]
                },
                {
                    name: 'Bonus Templates List Page',
                    permissions: [
                        {   
                            description: 'Can see templates list',
                            permission: 'admin.sharing.bonus.template.get'
                        },
                        {   
                            description: 'Can add a template',
                            permission: 'admin.sharing.bonus.template.create'
                        },
                    ]
                },
                {
                    name: 'Store Page',
                    permissions: [
                        {   
                            description: 'Can see store items list',
                            permission: 'admin.sharing.bonus.shop.item.get'
                        },
                        {   
                            description: 'Can add an item',
                            permission: 'admin.sharing.bonus.shop.item.create'
                        },
                    ]
                },
                {
                    name: 'Campaigns List Page',
                    permissions: [
                        {   
                            description: 'Can see campaigns list',
                            permission: 'admin.sharing.bonus.coupon.template.get'
                        },
                        {   
                            description: 'Can see campaign details',
                            permission: 'admin.sharing.bonus.coupon.template.info'
                        },
                        {   
                            description: 'Can add a campaign',
                            permission: 'admin.sharing.bonus.coupon.template.create'
                        },
                    ]
                },
                {
                    name: 'Campaign Details Page',
                    permissions: [
                        {   
                            description: 'Can see coupons list',
                            permission: 'admin.sharing.bonus.coupon.get'
                        },
                        {   
                            description: 'Can add a redeem code ',
                            permission: 'admin.sharing.bonus.coupon.create'
                        },
                    ]
                },
                {
                    name: 'Geofencing List Page',
                    permissions: [
                        // shared in required permissions
                        // {   
                        //     description:'Can see geofences list',
                        //     permission:'admin.service.geofencing.get'
                        // },
                        {   
                            description:'Can see geofencing area details',
                            permission:'admin.service.geofencing.info'
                        },
                        {   
                            description:'Can see geofencing area\'s fare',
                            permission:'admin.sharing.rate.get'
                        },
                        {   
                            description:'Can add geofencing areas',
                            permission:'admin.service.geofencing.create'
                        },
                        {   
                            description:'Can update geofencing areas',
                            permission:'admin.service.geofencing.update'
                        },
                        {   
                            description:'Can delete geofencing areas',
                            permission:'admin.service.geofencing.delete'
                        },
                        {   
                            description:'Can see the "View" geofence',
                            permission:'admin.service.geofencing.topojson.view.get'
                        },
                        {   
                            description:'Can modify the "View" geofence [1/2]',
                            permission:'admin.service.geofencing.topojson.view.create'
                        },
                        {   
                            description:'Can modify the "View" geofence [2/2]',
                            permission:'admin.service.geofencing.topojson.view.activate'
                        },
                        {   
                            description:'Can see the "Logic" geofence',
                            permission:'admin.service.geofencing.topojson.logic.get'
                        },
                        {   
                            description:'Can modify the "Logic" geofence [1/2]',
                            permission:'admin.service.geofencing.topojson.logic.create'
                        },
                        {   
                            description:'Can modify the "Logic" geofence [2/2]',
                            permission:'admin.service.geofencing.topojson.logic.activate'
                        },
                        {   
                            description:'Can see the "Markers" geofence',
                            permission:'admin.service.geofencing.topojson.descriptor.get'
                        },
                        {   
                            description:'Can modify the "Markers" geofence [1/2]',
                            permission:'admin.service.geofencing.topojson.descriptor.create'
                        },
                        {   
                            description:'Can modify the "Markers" geofence [2/2]',
                            permission:'admin.service.geofencing.topojson.descriptor.activate'
                        },
                        //no link fare at the moment
                        // {   
                        //     description:'',
                        //     permission:'admin.service.geofencing.rate.link'
                        // },
                        // {   
                        //     description:'',
                        //     permission:'admin.service.geofencing.rate.unlink'
                        // }
                    ]
                },
                {
                    name: 'Devices List Page',
                    permissions: [
                        {   
                            description:'Can see devices list',
                            permission:'admin.device.get'
                        },
                        {   
                            description:'Can attach devices to the vehicle',
                            permission:'admin.device.attach'
                        },
                        //shared with vehicles list page
                        // {   
                        //     description:'Can see vehicles list (related to attach/detach device)',
                        //     permission:'admin.sharing.vehicle.get'
                        // },
                        {   
                            description:'Can detach devices to a vehicle',
                            permission:'admin.device.detach'
                        },
                        {   
                            description:'Can change devices to vehicles',
                            permission:'admin.device.change'
                        }
                    ]
                },
                {
                    name: 'Damages List Page',
                    permissions: [
                        //shared in required permissions
                        // {   
                        //     description:'',
                        //     permission:'admin.service.expense.get'
                        // },
                        {   
                            description:'Can add damages',
                            permission:'admin.service.expense.create'
                        },
                        {   
                            description:'Can delete damages',
                            permission:'admin.service.expense.delete'
                        }
                    ]
                },
                //no fares list at the moment
                // {
                //     name: 'Fares List Page',
                //     permissions: [
                //         {   
                //             description:'',
                //             permission:'admin.sharing.rate.get'
                //         },
                //         {   
                //             description:'',
                //             permission:'admin.sharing.rate.info'
                //         },
                //         {   
                //             description:'',
                //             permission:'admin.sharing.rate.default'
                //         },
                //         {   
                //             description:'',
                //             permission:'admin.sharing.rate.create'
                //         },
                //         {   
                //             description:'',
                //             permission:'admin.sharing.rate.update'
                //         },
                //         {   
                //             description:'',
                //             permission:'admin.sharing.rate.delete'
                //         }
                //     ]
                // },
                {
                    name: 'Permisions List Page',
                    permissions: [
                        //using local at the moment
                        // {   
                        //     description:'',
                        //     permission:'admin.permission.available'
                        // },
                        //shared in required permissions
                        // {   
                        //     description:'',
                        //     permission:'admin.permission.role.get'
                        // },
                        {   
                            description:'Can create roles',
                            permission:'admin.permission.role.create'
                        },
                        {   
                            description:'Can update roles name',
                            permission:'admin.permission.role.update'
                        },
                        {   
                            description:'Can delete roles',
                            permission:'admin.permission.role.delete'
                        },
                        {   description:'Can add permissions to a role',
                            permission:'admin.permission.role.permission.add'
                        },
                        //new endpoints
                        // {   
                        //     description:'Can update permissions to a role',
                        //     permission:'admin.permission.role.permission.update'
                        // },
                        {   description:'Can delete the permissions of a role',
                            permission:'admin.permission.role.permission.delete'
                        },
                        {   description:'Can see role details',
                            permission:'admin.permission.role.info'
                        },
                        
                    ]
                },
                {
                    name: 'Role details Page',
                    permissions: [
                        //duplicate in permission list page
                        // {   description:'Can see role details',
                        //     permission:'admin.permission.role.info'
                        // },
                        {   description:'Can see the admins list by role',
                            permission:'admin.user.role.get.member'
                        },
                    ]
                },
                {
                    name: 'Service Settings Page',
                    permissions: [
                        //shared in required permissions
                        // {   
                        //     description:'Can see service settings',
                        //     permission:'admin.service.setting.get'
                        // },
                        {   
                            description:'Can update service settings',
                            permission:'admin.service.setting.update'
                        },
                        {   
                            description:'Can see translations',
                            permission:'admin.service.i18n.get'
                        },
                        {
                            description:'Can update translations',
                            permission:'admin.service.i18n.update'
                        },
                        {
                            description:'Can update invoices',
                            permission:'admin.service.setting.invoice'
                        }
                    ]
                },
            ]

            vm.permissionsGroups = permissionsGrouped
            
            vm.addRole = addRole
            vm.addRoleButtonAction = addRoleButtonAction
            vm.getNonHiddenElements = getNonHiddenElements
            vm.roleHasPermission = roleHasPermission
            vm.permissionButtonAction = permissionButtonAction
            vm.modifyButtonAction = modifyButtonAction
            vm.deleteButtonAction = deleteButtonAction

            function addRoleButtonAction(event){
                var element = angular.element(event.delegateTarget)
                element.toggleClass("rotated")
                vm.isAddingRole? vm.roles.shift() : vm.roles.unshift({name: "Role name", hidden: true})
                vm.isAddingRole = !vm.isAddingRole
                
            }

            function addRole(){
                PermissionsAdapter.addRole(vm.roles[0], function(response, error){
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Add Role',description:'Error while adding the new role!'})
                    }else{
                        var addButton = document.getElementById("newRoleButton")
                        addRoleButtonAction({delegateTarget: addButton})
                        getRoles()
                    }
                })
            }

            //now disabled to support only custom permissions (local)
            // function getPermissions(){
            //     PermissionsAdapter.getPermissions(function(response, error){
            //         if(error){
            //             ErrorUtility.showErrorMessage({title:'Get Permissions List',description:'Error while getting the permissions list'})
            //         }else{
            //             var enabledGroups = ["admin","admin.sharing.vehicle"]
            //             var groups = []
            //             enabledGroups.forEach(function (groupName) {
            //                 var group = response.group.find(function (elem) {
            //                     return elem.name == groupName
            //                 })
            //                 console.log("group",group)
            //                 if(typeof group != "undefined"){
            //                     groups.push(group)
            //                 }
            //             })
            //             console.log("groups",groups)
            //             // response.list.sort(function(a,b){
            //             //     return a.localeCompare(b)
            //             // })
            //             vm.permissionsGroups = groups
            //             console.log(vm.permissionsGroups)
            //         }
            //     })
            // }

            function getRoles(){
                PermissionsAdapter.getRoles(function(response, error){
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Get Roles List',description:'Error while getting the roles list!'})
                    }else{
                        vm.roles = response;
                        hasPermissionsGroupAllPermissions();
                        // console.log("roles",vm.roles)
                    }
                })
            }

            function hasPermissionsGroupAllPermissions(permissionsGroupToFilter) {
                var permissionsGroups = vm.permissionsGroups
                if(typeof permissionsGroupToFilter !== "undefined"){
                    var permissionGroupFound = permissionsGroups.find(function(po){
                        return po.name == permissionsGroupToFilter.name
                    })
                    if(permissionGroupFound){
                        permissionsGroups = [permissionGroupFound]
                    }
                }

                permissionsGroups.forEach(function (permissionsGroup) {
                    var grantedPermissions = {}
                    var permissionsGroupPermissions = permissionsGroup.permissions
                    
                    permissionsGroup.permissions.forEach(function (permissionObj) {
                        vm.roles.forEach(function (role) {
                            var list = grantedPermissions[role.id]
                            if(list == undefined){
                                list = []
                                grantedPermissions[role.id] = list
                            }
                            if(roleHasPermission(role,permissionObj.permission)){
                                list.push(permissionObj)
                            }
                        })
                    })
                    for(var roleId in grantedPermissions){
                        // console.log("grantedPermissions",grantedPermissions,"permissionsGroupPermissions",permissionsGroupPermissions,"check",grantedPermissions[roleId].length,permissionsGroupPermissions.length)
                        permissionsGroup[roleId] = {
                            nOfGranted: grantedPermissions[roleId].length,
                            nOfPermissions: permissionsGroupPermissions.length,
                            nOfRemaining: permissionsGroupPermissions.length - grantedPermissions[roleId].length,
                            allGranted:false,
                            noneGranted:false
                        }
                        if(grantedPermissions[roleId].length > 0){
                            if(grantedPermissions[roleId].length === permissionsGroupPermissions.length){
                                permissionsGroup[roleId].allGranted = true
                            }
                        }else{
                            permissionsGroup[roleId].noneGranted = true
                        }
                    }
                })
            }

            function getNonHiddenElements(element){
                return !element.hidden
            }

            function roleHasPermission(role, permission){
                if(!role.Permissions){
                    return false
                }

                if(role.Permissions.length == 0){
                    role[permission] = false
                    return false
                }

                for(var index in role.Permissions){
                    var permissionObj = role.Permissions[index]
                    if(permissionObj.name == permission){
                        role[permission] = true
                        return true 
                    }
                }
                role[permission] = false
                return false
            }


            function permissionButtonAction(role, permission,permissionsGroup){
                var hasPermission = (role[permission] == undefined)? roleHasPermission(role, permission) : role[permission]
                if(!hasPermission){
                    PermissionsAdapter.addPermissionToRole(role.id, permission, function(response, error){
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Add Permission',description:'Error while adding a permission '+role.name+'!'})
                            role[permission] = false
                        }else{
                            role[permission] = true
                            role.Permissions.push({name: permission})
                            hasPermissionsGroupAllPermissions(permissionsGroup)
                            SweetAlert.swal('Add Permission','The permission was succesfully added to '+role.name+'!','success')
                        }
                    })
                }else{
                    PermissionsAdapter.removePermissionFromRole(role.id, permission, function(response, error){
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Remove Permission',description:'Error while removing a permission from '+role.name+'!'})
                            role[permission] = true
                        }else{
                            role[permission] = false
                            removePermissionFromObj(role.Permissions, permission)
                            hasPermissionsGroupAllPermissions(permissionsGroup)
                            SweetAlert.swal('Remove Permission','The permission was succesfully removed from '+role.name+'!','success')
                        }
                    })
                }
            }

            function modifyButtonAction(role){
                if(!role.isBeingModified){
                    role.isBeingModified = true
                }else{
                    PermissionsAdapter.editRole(role.id, role, function(response, error){
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Edit Role',description:'Error while editing this role!'})
                        }else{
                            role.isBeingModified = false
                            getRoles()
                        }
                    })
                }
            }

            function deletePermissionConfirmDialog(role,ev){

                DialogFactory.confirm("Delete a role","Are you sure you want to delete this role?",ev)
                    .then(
                        function ok() {
                            PermissionsAdapter.deleteRole(role.id, function(response, error){
                                if(error){
                                    ErrorUtility.showErrorMessage({title:'Delete Role',description:'Error while deleting this role!'})
                                }else{
                                    SweetAlert.swal('Delete Role','The role was succesfully deleted!','success')
                                    getRoles()
                                }
                            })
                        }
                    )
            }

            function deleteButtonAction(role,ev){
                if(!role.isBeingModified){
                    deletePermissionConfirmDialog(role,ev)
                }else{
                    role.isBeingModified = false
                }
            }

            function removePermissionFromObj(permissions, name){
                for(var index in permissions){
                    var permission = permissions[index]
                    if(permission.name == name){
                        permissions[index] = {}
                    }
                }
            }

        }

})();

(function () {
    'use strict';

    angular.module('app.settings.geofencing', []).config(config).run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider
            .state('app.settings.geofencing', {
                url: '/geofencing',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/geofencing/geofencing-manager.html',
                        controller: 'GeofencingController as vm',
                    },
                },
            })
            .state('app.settings.newGeofencing', {
                url: 'https://dashboard-v2.2hire.io/settings/geofencing',
                external: true,
            });

        // Navigation
        msNavigationServiceProvider.saveItem('settings.geofencing', {
            title: 'Legacy Geofencing',
            icon: 'icon-map-marker-radius',
            state: 'app.settings.geofencing',
            weight: 0,
        });
        msNavigationServiceProvider.saveItem('settings.geofencingNew', {
            title: 'Geofencing',
            icon: 'icon-map-marker-radius',
            state: 'app.settings.newGeofencing',
            weight: 1,
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled('settings.geofencing');

        if (!active) {
            msNavigationService.deleteItem('settings.geofencing');
        }

        if (!AppConfigurations.isPageEnabled('settings.geofencingNew')) {
            msNavigationService.deleteItem('settings.geofencingNew');
        }
    }
})();

(function(){
    'use strict';

    angular
        .module("app.settings.geofencing")
        .controller("GeofencingController", GeofencingController)

    /** @ngInject */
    function GeofencingController(
        $scope,
        GeofencesAdapter,
        FaresAdapter,
        MapDrawingUtilities,
        DialogFactory,
        FareType,
        FareUtility,
        ServiceSettings,
        MiscUtility,
        SitesService,
        SweetAlert,
        GeofenceUtility,
        VehicleTypes,
        toDateFilter,
        ErrorUtility,
        GeofenceService,
        DefaultSite,
        MapProvider
    ) {
        var vm = this;
        vm.MapProvider = MapProvider;
        var todayDateTime;
        vm.toDateFilter = toDateFilter;
        vm.getSiteName = SitesService.getSiteName;

        vm.getCurrencyValue = MiscUtility.getCurrencyValue;
        vm.previusInfoWindow = null;
        vm.drawingManager = null;
        vm.isDrawingArea = false;
        vm.isAreaDetail = false;
        vm.isEditing = false;

        vm.vehicleType = VehicleTypes;

        vm.polygonsLoaded = false;

        vm.areas = [];
        vm.fares = [];

        vm.drawingTools = {
            hand: false,
            polygon: true,
            polygonMinus: false,
        };

        vm.fareType = FareType;

        vm.polygons = [];
        vm.polygonsCords = [];

        vm.title = 'Current geofencing area';

        vm.currentArea = {};
        vm.currentActiveAreas = [];

        vm.newArea = {
            id: 0,
            registrationDate: null,
            latestReview: null,
            name: '',
            vehicleType: null,
        };

        vm.polygonHistory = [];

        /*vm.mapData = {
            defaultCenter:{
                lat : 0,
                lng: 0
            },
            center: {
                latitude : MapDefaults.center.latitude, 
                longitude: MapDefaults.center.longitude
            },
            zoom  : MapDefaults.zoom,
            options:{
                mapTypeControl: false,
                streetViewControl: false,
                scrollwheel: false,
                clickableIcons: false
            },
            stationMarkers: {},
            vehicleMarkers: {},
            events:{
                tilesloaded: function (map) {
                    
                },
                 click: function (map) {
                     if(vm.previusInfoWindow){
                        vm.previusInfoWindow.close()
                        vm.previusInfoWindow = null
                     }
                 }
            }
        }*/

        $scope.$on('refreshServiceSettings', function (event) {
            console.warn('settings changed');
            init();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    SitesService.getSites(function () {
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        vm.timezone = ServiceSettings.getSiteTimezone(vm.selectedSiteId);

                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                        todayDateTime = MiscUtility.createTzMoment(null, vm.selectedSiteId).startOf('day').valueOf();
                    });

                    //refresh interface
                    $scope.$applyAsync();
                }
            });
        }
        init();

        $scope.$on('siteChanged', function (site) {
            console.log('siteChanged');
            SitesService.getSites(function () {
                vm.selectedSiteId = SitesService.getSelectedSite();
            });
            refreshGeofencingAreas();
        });

        vm.onMapInit = function (map) {
            if (vm.mapInitialized) {
                return;
            }

            vm.mainMap = map;
            vm.mapInitialized = true;

            vm.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYGON,
                drawingControl: false,
                polygonOptions: {
                    editable: true,
                    fillColor: '#CE3655',
                    fillOpacity: 0.3,
                    strokeColor: '#CE3655',
                },
            });

            if (!vm.polygonsLoaded) {
                console.log('Loading polygons from map');
                getGeofencingAreas();
            }

            google.maps.event.addListener(vm.drawingManager, 'polygoncomplete', handlePolygonCompletion);
        };

        // This method is called on refreshGeofencingAreas and getGeofencingAreas
        function updateGeofenceFunction(response, error) {
            if (error) {
                ErrorUtility.showErrorMessage({
                    title: 'Get Geofencing Area List',
                    description: 'Error while getting the geofencing area list',
                });
            } else {
                vm.areas = response;
                vm.currentActiveAreas = [];
                console.log('geofence', response[0]);
                var polygons = null;

                for (var index in vm.areas) {
                    var area = vm.areas[index];
                    polygons = MapDrawingUtilities.convertServerAreaToPolygons(area.zonas, {
                        vehicleType: area.vehicleType,
                    });
                    //console.log("Polygons",polygons)
                    area.polygons = polygons;

                    setCurrentActiveAreaOnMap(area);
                }
                //console.log("Areas",vm.areas)
                //set map center and zoom
                if (vm.mainMap && vm.currentActiveAreas.length > 0) {
                    //var polygons = vm.currentActiveAreas[0].polygons
                    //vm.mainMap.setCenter(polygons[0].getPath().getAt(0))
                    //vm.mainMap.setZoom(10)
                    GeofenceUtility.fitMapToGeofenceAreas(vm.mainMap, vm.currentActiveAreas);
                }
                vm.polygonsLoaded = true;
            }
        }

        // updates the store directly from the API, without requesting storage first.
        function refreshGeofencingAreas() {
            if (vm.polygonsLoaded) {
                removeActiveAreasPolygons();
            }

            GeofenceService.refreshGeofencingAreas(updateGeofenceFunction);
            // getAvailableFares()
        }

        // get geofence from the storage, if not avaiable returns the API results.
        function getGeofencingAreas() {
            if (vm.polygonsLoaded) {
                removeActiveAreasPolygons();
            }
            GeofenceService.getGeofencingAreas(updateGeofenceFunction);
            // getAvailableFares()
        }

        function updateNewAreaData() {
            console.log('Updating data');

            var geometryFactory = new jsts.geom.GeometryFactory();

            var id = vm.areas.length > 0 ? vm.areas[vm.areas.length - 1].id + 1 : 1;
            var registrationDate = moment.tz(vm.timezone).valueOf();
            var latestReview = registrationDate;
            var fare = {};

            vm.newArea.id = id;
            vm.newArea.registrationDate = registrationDate;
            vm.newArea.latestReview = latestReview;
            vm.newArea.fare = fare.price ? { value: fare.price, unit: fare.unit } : null;

            var area = 0;
            for (var polygonIndex in vm.polygons) {
                var paths = vm.polygons[polygonIndex].getPaths();

                area += google.maps.geometry.spherical.computeArea(paths.getAt(0));

                for (var index = 1; index < paths.length; index++) {
                    area -= google.maps.geometry.spherical.computeArea(paths.getAt(index));
                }
            }

            vm.newArea.area = area / (1000 * 1000); // meters to km and ^2

            //console.log("New area",vm.newArea)
        }

        function handlePolygonCompletion(polygon) {
            saveLastPolygon();
            vm.polygons.push(polygon);
            if (vm.drawingTools.polygon) {
                //console.log("isPolygon", vm.polygons)

                if (MapDrawingUtilities.checkPolygonIntersection(polygon, vm.polygons)) {
                    polygon.setMap(null);
                    vm.polygons.pop();
                    vm.polygonHistory.pop();
                    alert('Geofencing areas cannot intersect');
                }

                setUpListenersOnPolygons();

                $scope.$apply(function () {
                    updateNewAreaData();
                });

                return;
            }
            if (vm.drawingTools.polygonMinus) {
                polygon.setMap(null);
                if (vm.polygons.length == 1) {
                    return;
                }
                for (var polygonIndex = 0; polygonIndex <= vm.polygons.length - 2; polygonIndex++) {
                    var tempPolygon = vm.polygons[polygonIndex];
                    var intersectionType = MapDrawingUtilities.checkSinglePolygonIntersection(polygon, tempPolygon);
                    if (intersectionType != 0) {
                        var polygonIsClockwise = MapDrawingUtilities.isPolygonClockwise(polygon);
                        var polygon2IsClockwise = MapDrawingUtilities.isPolygonClockwise(tempPolygon);
                        if (intersectionType == 2) {
                            var newCoords = polygon.getPath();
                            if (polygonIsClockwise == polygon2IsClockwise) {
                                newCoords = MapDrawingUtilities.reversePolygonCoords(polygon);
                            }
                            var coordsArray = tempPolygon.getPaths();

                            // remove intersecting holes in polygon
                            if (coordsArray.length > 1) {
                                var arr = coordsArray.getArray();
                                for (var pt = arr.length - 1; pt > 0; pt--) {
                                    var coordsArr = arr[pt].getArray();
                                    var isHoleWithinHole = MapDrawingUtilities.isInsidePolygon(
                                        coordsArr,
                                        newCoords.getArray()
                                    );
                                    if (isHoleWithinHole) {
                                        coordsArray.removeAt(pt);
                                    }
                                }
                            }

                            coordsArray.push(newCoords);
                            vm.polygons.pop();
                            setUpListenersOnPolygons();
                            $scope.$apply(function () {
                                updateNewAreaData();
                            });
                            return;
                        }

                        if (intersectionType == 3) {
                            var coordsArray = tempPolygon.getPaths();
                            var polArray = polygon.getPath().getArray();

                            // remove intersecting shapes in polygon
                            if (coordsArray.length > 1) {
                                var arr = coordsArray.getArray();
                                for (var pt = arr.length - 1; pt > 0; pt--) {
                                    var coordsArr = arr[pt].getArray();
                                    var isHoleWithinHole = MapDrawingUtilities.isInsidePolygon(coordsArr, polArray);
                                    if (isHoleWithinHole) {
                                        coordsArray.removeAt(pt);
                                    }
                                }
                            }
                        }

                        var resultPolygon = MapDrawingUtilities.getPolygonByDifference(tempPolygon, polygon);
                        var coords = MapDrawingUtilities.getCoordsFromJsts(resultPolygon);
                        if (
                            MapDrawingUtilities.isPolygonClockwise(tempPolygon) !=
                            MapDrawingUtilities.areCoordsClockwise(coords)
                        ) {
                            coords = MapDrawingUtilities.reverseCoords(coords);
                        }
                        tempPolygon.setPath(coords);
                        var polygonPaths = tempPolygon.getPaths();
                        //console.log("Paths",polygonPaths, "MainPath", tempPolygon.getPath())

                        for (var index = 1; index < polygonPaths.length; index++) {
                            var currentPath = polygonPaths.getAt(index);
                            var intersection = MapDrawingUtilities.checkIfCoordsIntersect(coords, currentPath);
                            // coords are the new coordinates, elements to delete should not be contained in new polygon
                            if (intersection != 3) {
                                //console.log("Intersection",intersection)

                                // console.log("removing path at", index)

                                polygonPaths.removeAt(index);
                            }
                        }

                        vm.polygons.pop();
                        setUpListenersOnPolygons();
                        $scope.$apply(function () {
                            updateNewAreaData();
                        });
                    }
                }
            }
        }

        function saveLastPolygon() {
            if (vm.polygons.length > 0) {
                var polygonsToSave = [];
                for (var index in vm.polygons) {
                    var tempPolygon = vm.polygons[index];
                    var pathsArray = [];
                    var paths = tempPolygon.getPaths().forEach(function (element) {
                        var coordsArray = [];
                        element.forEach(function (element) {
                            var coord = { lat: element.lat(), lng: element.lng() };
                            coordsArray.push(coord);
                        });
                        pathsArray.push(coordsArray);
                    });
                    var newPolygon = new google.maps.Polygon({
                        paths: pathsArray,
                        editable: true,
                        fillColor: '#CE3655',
                        fillOpacity: 0.3,
                        strokeColor: '#CE3655',
                    });
                    polygonsToSave.push(newPolygon);
                }
                vm.polygonHistory.push(polygonsToSave);
                // console.log("History", vm.polygonHistory)
            }
        }

        function undoPolygon(event) {
            if (vm.polygonHistory.length == 0) {
                bringDownNewAreaView();
                return;
            }
            var element = angular.element(event.delegateTarget);
            element.toggleClass('animating');
            for (var index in vm.polygons) {
                vm.polygons[index].setMap(null);
            }
            vm.polygons = vm.polygonHistory[vm.polygonHistory.length - 1];
            for (var index in vm.polygons) {
                vm.polygons[index].setMap(vm.mainMap);
            }
            vm.polygonHistory.pop();
            updateNewAreaData();
            setTimeout(function () {
                element.toggleClass('animating');
            }, 500);
        }

        function setUpListenersOnPolygons() {
            for (var index in vm.polygons) {
                var tempPolygon = vm.polygons[index];

                var paths = tempPolygon.getPaths();
                paths.forEach(function (path) {
                    // console.log("Path",path)
                    // google.maps.event.clearListeners(path, "set_at")
                    path.setAtListener ? path.setAtListener.remove() : console.log('No set_at listener on path');
                    path.setAtListener = google.maps.event.addListener(path, 'set_at', function () {
                        // saveLastPolygon()
                        $scope.$apply(function () {
                            updateNewAreaData();
                        });
                    });
                    path.insertAtListener
                        ? path.insertAtListener.remove()
                        : console.log('No insert_at listener on path');
                    // google.maps.event.clearListeners(path, "insert_at")
                    path.insertAtListener = google.maps.event.addListener(path, 'insert_at', function () {
                        // saveLastPolygon()
                        $scope.$apply(function () {
                            updateNewAreaData();
                        });
                    });
                    // google.maps.event.clearListeners(path, "remove_at")
                    path.removeAtListener
                        ? path.removeAtListener.remove()
                        : console.log('No remove_at listener on path');
                    path.removeAtListener = google.maps.event.addListener(path, 'remove_at', function () {
                        // saveLastPolygon()
                        $scope.$apply(function () {
                            updateNewAreaData();
                        });
                    });
                });
            }
        }

        function bringDownNewAreaView() {
            for (var index in vm.polygons) {
                vm.polygons[index].setMap(null);
            }
            vm.polygons = [];
            vm.newArea = {
                id: 0,
                registrationDate: null,
                latestReview: null,
                fare: 'Not set',
                name: '',
                vehicleType: null,
            };
        }

        function addGeofencingAreaButtonAction(event) {
            if (Number(vm.selectedSiteId) === DefaultSite.id) {
                SweetAlert.swal(
                    'You must select a site!',
                    'Inserting geofences is not allowed when viewing All Sites, please select a site and try again',
                    'error'
                );
                return;
            }

            var element = angular.element(event.delegateTarget);
            element.toggleClass('rotated');
            //case add a new area
            if (!vm.isDrawingArea) {
                removeActiveAreasPolygons();
                vm.polygons = [];

                vm.mainMap.setOptions({ scrollwheel: true });
                vm.drawingManager.setMap(vm.mainMap);
                vm.isDrawingArea = true;
                vm.title = 'New geofencing area';
            } else {
                revertAddGeofencingAreaAction();
            }
        }

        function revertAddGeofencingAreaAction(params) {
            vm.mainMap.setOptions({ scrollwheel: false });
            vm.drawingManager.setMap(null);
            bringDownNewAreaView();
            vm.isDrawingArea = false;
            vm.title = 'Current geofencing area';
            var area = {};
        }

        function handDrawingToolClicked() {
            vm.drawingManager.setDrawingMode(null);
            vm.drawingTools.polygon = false;
            vm.drawingTools.polygonMinus = false;
            vm.drawingTools.hand = true;
        }

        function polygonDrawingToolClicked() {
            vm.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
            vm.drawingTools.hand = false;
            vm.drawingTools.polygonMinus = false;
            vm.drawingTools.polygon = true;
        }

        function polygonMinusDrawingToolClicked() {
            vm.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
            vm.drawingTools.hand = false;
            vm.drawingTools.polygonMinus = true;
            vm.drawingTools.polygon = false;
        }

        function addGeofencingArea() {
            if (!vm.isDrawingArea || vm.polygons.length == 0) {
                return;
            }
            // console.log("Polygons when saving new area",vm.polygons)

            var data = MapDrawingUtilities.convertPolygonsToServerArea(vm.polygons);
            var dataToUpload = {
                active: false,
                zonas: data,
                name: vm.newArea.name,
                vehicleType: vm.newArea.vehicleType,
            };
            // console.log("dataToSend",dataToUpload)
            GeofencesAdapter.addGeofenceArea(dataToUpload, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Add Geofencing Area',
                        description: 'There was an error while adding the new geofencing area',
                    });
                } else {
                    var addButton = angular.element(document.getElementById('addAreaButton'));
                    addButton.toggleClass('rotated');
                    // console.log("Polygons when saving new area",vm.polygons)

                    revertAddGeofencingAreaAction();

                    setPolygonsToEditable(false);
                    removePolygons(vm.polygons);
                    goBackToGeofencesList();
                    // addAreaButtonAction({delegateTarget: addButton})
                    SweetAlert.swal('Add Geofencing Area', 'Succesfully added!', 'success');
                    refreshGeofencingAreas();
                }
            });
        }

        function setCurrentActiveAreaOnMap(area) {
            if (area.active) {
                vm.currentActiveAreas.push(area);
                setPolygonsOnMap(area.polygons);
            }
        }

        function setPolygonsOnMap(polygons) {
            polygons.forEach(function (polygon) {
                polygon.setMap(vm.mainMap);
            }, this);
        }

        function removePolygons(polygons) {
            console.log('remove polygons on map');
            vm.polygonsLoaded = false;
            polygons.forEach(function (polygon) {
                polygon.setMap(null);
            }, this);
        }

        function removeActiveAreasPolygons() {
            vm.currentActiveAreas.forEach(function (area) {
                removePolygons(area.polygons);
            });
        }

        function viewGeofenceButtonAction(area) {
            console.log('view geofence button pressed');
            vm.title = 'Geofence id ' + area.id;
            vm.currentArea = area;
            vm.isAreaDetail = true;
            vm.polygons = area.polygons;
            // console.log("Current area:",area)
            // console.log("Current area polygons",vm.polygons)

            removeActiveAreasPolygons();
            setPolygonsOnMap(vm.polygons);

            // vm.mainMap.setCenter(vm.polygons[0].getPath().getAt(0))
            // vm.mainMap.setZoom(10)
            GeofenceUtility.fitMapToGeofenceAreas(vm.mainMap, [area]);
        }

        function areaButtonAction(area) {
            //one button different behaviour
            //case user clicks for area details(VIEW)
            if (!vm.isAreaDetail) {
                viewGeofenceButtonAction(area);
                return;
            }
            //case user clicks for deactivate a geofencing area
            if (vm.currentArea.active) {
                DialogFactory.confirm(
                    'Deactivate Geofence Area',
                    'Are you sure you want to deactivate this geofence area?'
                ).then(function ok() {
                    GeofencesAdapter.updateGeofenceArea(
                        vm.currentArea.id,
                        { active: false },
                        function (response, error) {
                            if (error) {
                                ErrorUtility.showErrorMessage({
                                    title: 'Deactivate Geofencing Area',
                                    description: 'There was an error while deactivating this geofencing area',
                                });
                            } else {
                                vm.currentArea.active = false;
                                vm.isDrawingArea = false;
                                setPolygonsToEditable(false);
                                removePolygons(vm.polygons);
                                goBackToGeofencesList();
                                refreshGeofencingAreas();
                                vm.isEditing = false;
                                SweetAlert.swal('Deactivate Geofencing Area', 'Successfully deactivated!', 'success');
                            }
                        }
                    );
                });
            } else {
                //case user clicks for activate a geofencing area
                DialogFactory.confirm(
                    'Activate Geofence Area',
                    'Are you sure you want to activate this geofence area?'
                ).then(function ok() {
                    GeofencesAdapter.updateGeofenceArea(
                        vm.currentArea.id,
                        { active: true },
                        function (response, error) {
                            if (error) {
                                ErrorUtility.showErrorMessage({
                                    title: 'Activate Geofencing Area',
                                    description: 'There was an error while activating this geofencing area',
                                });
                            } else {
                                vm.currentArea.active = true;
                                vm.isDrawingArea = false;
                                setPolygonsToEditable(false);
                                removePolygons(vm.polygons);
                                goBackToGeofencesList();
                                refreshGeofencingAreas();
                                vm.isEditing = false;
                                SweetAlert.swal('Activate Geofencing Area', 'Successfully activated!', 'success');
                            }
                        }
                    );
                });
            }
        }

        var savedPolygons = null;
        function editAreaButtonAction() {
            console.log('Edit button pressed');
            if (vm.isEditing) {
                var data = MapDrawingUtilities.convertPolygonsToServerArea(vm.polygons);
                var dataToUpload = {
                    active: false,
                    zonas: data,
                    name: vm.currentArea.name,
                    vehicleType: vm.currentArea.vehicleType,
                };
                //don't deactivate area if only name is changed
                if (vm.savedGeofenceAreaName) {
                    if (vm.savedGeofenceAreaName != vm.currentArea.name) {
                        dataToUpload.active = vm.currentArea.active;
                    }
                }
                console.log('dataToUpload', dataToUpload);
                GeofencesAdapter.updateGeofenceArea(vm.currentArea.id, dataToUpload, function (response, error) {
                    if (error) {
                        ErrorUtility.showErrorMessage({
                            title: 'Update Geofencing Area',
                            description: 'There was an error while updating this geofencing area',
                        });
                    } else {
                        if (response.updated) {
                            vm.isEditing = false;
                            vm.mainMap.setOptions({ scrollwheel: false });
                            vm.isDrawingArea = false;
                            setPolygonsToEditable(false);
                            vm.mainMap.setOptions({ scrollwheel: false });
                            vm.drawingManager.setMap(null);
                            removePolygons(vm.polygons);
                            goBackToGeofencesList();
                            refreshGeofencingAreas();
                            vm.savedGeofenceAreaName = null;
                            SweetAlert.swal('Update Geofencing Area', 'Successfully updated!', 'success');
                        } else {
                            ErrorUtility.showErrorMessage({
                                title: 'Update Geofencing Area',
                                description: 'There was an error while updating this geofencing area',
                            });
                        }
                    }
                });
            } else {
                console.log('Starting editing');
                vm.isEditing = true;
                savedPolygons = angular.copy(vm.polygons);
                setPolygonsToEditable(true);
                vm.mainMap.setOptions({ scrollwheel: true });
                vm.drawingManager.setMap(vm.mainMap);
                vm.isDrawingArea = true;
                vm.savedGeofenceAreaName = vm.currentArea.name;
            }
        }

        function closeAreaButtonAction() {
            if (vm.isEditing) {
                removePolygons(vm.polygons);
                setPolygonsOnMap(savedPolygons);
                vm.polygons = savedPolygons;
                vm.mainMap.setOptions({ scrollwheel: false });
                vm.drawingManager.setMap(null);
                vm.isDrawingArea = false;
                setPolygonsToEditable(false);
                vm.isEditing = false;
            } else {
                DialogFactory.confirm(
                    'Delete a geofencing area',
                    'Are you sure you want to delete this geofencing area?'
                ).then(function success() {
                    GeofencesAdapter.deleteGeofencingArea(vm.currentArea.id, function (response, error) {
                        if (error) {
                            ErrorUtility.showErrorMessage({
                                title: 'Delete Geofencing Area',
                                description: 'There was an error while deleting this geofencing area',
                            });
                        } else {
                            vm.isDrawingArea = false;
                            setPolygonsToEditable(false);
                            removePolygons(vm.polygons);
                            goBackToGeofencesList();
                            refreshGeofencingAreas();
                            SweetAlert.swal('Delete Geofencing Area', 'Successfully deleted!', 'success');
                        }
                    });
                });
            }
        }

        function setPolygonsToEditable(bool) {
            vm.polygons.forEach(function (polygon) {
                polygon.setEditable(bool);
            });
        }

        function goBackButtonAction() {
            vm.mainMap.setOptions({ scrollwheel: true });
            vm.isDrawingArea = false;
            vm.isEditing = false;
            setPolygonsToEditable(false);
            removePolygons(vm.polygons);
            goBackToGeofencesList();
            getGeofencingAreas();
        }

        function goBackToGeofencesList() {
            vm.title = 'Current geofencing area';
            vm.currentArea = {};
            vm.isAreaDetail = false;
            vm.polygons = [];
        }

        // disabled until new server fares handling
        // function getAvailableFares(){
        //     FaresAdapter.getFares(function(response, error){
        //         if(error){
        //             ErrorUtility.showErrorMessage({title:'Get Fares',description:'Error while getting the fares list'})
        //         }else{
        //             vm.fares = response
        //         }
        //     })
        // }

        // function setGeofenceFare(idGeofence, idFare, completionHandler){
        //     GeofencesAdapter.addFareToGeofenceArea(idGeofence, idFare, completionHandler)
        // }

        // function removeGeofenceFare(idGeofence, idFare, completionHandler){
        //     GeofencesAdapter.removeFareFromGeofenceArea(idGeofence, idFare, completionHandler)
        // }

        // function addOrDeleteFareToGeofence(fare, geofence){

        //     DialogFactory.confirm("Geofence Fare","Modify this fare for this geofence area?").then(
        //         function ok(){
        //             if(!(geofence.RateSharing && geofence.RateSharing.length>0)){
        //                 setGeofenceFare(geofence.id,fare.id,function (response,error) {
        //                     if(!error){
        //                         console.log("response after add fare",response)

        //                         GeofencesAdapter.getGeofenceArea(geofence.id,function (geofenceAreaUpdated,error) {
        //                             if(error){
        //                                 ErrorUtility.showErrorMessage({title:'Get Geofencing Area',description:'Error while getting the geofencing area'})
        //                                 $state.go("app.settings.geofencing")
        //                             }
        //                             else{
        //                                 geofence.RateSharing = geofenceAreaUpdated.RateSharing;
        //                             }
        //                         })
        //                     }
        //                 })
        //             }
        //             else {
        //                 var hasThisGeofenceThisFare = false;

        //                 geofence.RateSharing.forEach(function (activeFare) {

        //                     if(activeFare.id == fare.id){

        //                         hasThisGeofenceThisFare = true;

        //                         removeGeofenceFare(geofence.id,fare.id, function (response,error) {
        //                             if(!error){
        //                                 console.log("response after delete fare",response)

        //                                 GeofencesAdapter.getGeofenceArea(geofence.id,function (geofenceAreaUpdated,error) {
        //                                     if(error){
        //                                         ErrorUtility.showErrorMessage({title:'Get Geofencing Area',description:'Error while getting the geofencing area'})
        //                                         $state.go("app.settings.geofencing")
        //                                     }
        //                                     else{
        //                                         geofence.RateSharing = geofenceAreaUpdated.RateSharing;
        //                                     }
        //                                 })
        //                             }
        //                         })
        //                     }
        //                 })

        //                 if(!hasThisGeofenceThisFare){

        //                     setGeofenceFare(geofence.id,fare.id,function (response,error) {
        //                         if(!error){
        //                             console.log("response after add fare",response)

        //                             GeofencesAdapter.getGeofenceArea(geofence.id,function (geofenceAreaUpdated,error) {
        //                                 if(error){
        //                                     ErrorUtility.showErrorMessage({title:'Get Geofencing Area',description:'Error while getting the geofencing area'})
        //                                     $state.go("app.settings.geofencing")
        //                                 }
        //                                 else{
        //                                     geofence.RateSharing = geofenceAreaUpdated.RateSharing;
        //                                 }
        //                             })
        //                         }
        //                         else {
        //                             DialogFactory.alert("Error with server","The fare hasn't been add to geofencing area")
        //                         }
        //                     })
        //                 }
        //             }
        //     })

        // }

        // function isFareActiveOnGeofence(fare, geofence){

        //     var hasThisFare = false;

        //     if(geofence.RateSharing){
        //         hasThisFare = geofence.RateSharing.some(function (activeFare) {
        //             return activeFare.id == fare.id
        //         })
        //     }

        //     return hasThisFare
        // }

        // function getCurrentActiveGeofenceFare(geofenceArea) {
        //     var activeFares = null;
        //     var activeFare = null

        //     if(geofenceArea.RateSharing){
        //         //get the one still active,  NOW DISABLE BECAUSE OF ONE FARE
        //         activeFares= geofenceArea.RateSharing.filter(function (activeFare) {
        //             var fareStartTime = moment.tz(activeFare.start, vm.timezone).startOf('day').valueOf();

        //             var fareEndTime = moment.tz(activeFare.end, vm.timezone).startOf('day').valueOf();

        //             return (fareEndTime>=todayDateTime || activeFare.unlimited)
        //         })
        //         // console.log("Active geofence fares ",activeFares)

        //         if(activeFares){
        //             activeFare = activeFares.find(function (activeFare) {

        //                 var fareEndTime = moment.tz(activeFare.end, vm.timezone).startOf('day').valueOf();

        //                 return (fareEndTime>=todayDateTime)
        //             })
        //             if(!activeFare){
        //                 activeFare = activeFares.find(function (activeFare) {

        //                     return (activeFare.unlimited)
        //                 })
        //             }
        //         }
        //     }
        //     // console.log("activefare",activeFare)

        //     return activeFare
        // }

        vm.handDrawingToolClicked = handDrawingToolClicked;
        vm.polygonDrawingToolClicked = polygonDrawingToolClicked;
        vm.polygonMinusDrawingToolClicked = polygonMinusDrawingToolClicked;
        vm.undoPolygon = undoPolygon;
        vm.addGeofencingAreaButtonAction = addGeofencingAreaButtonAction;
        vm.addGeofencingArea = addGeofencingArea;
        vm.editAreaButtonAction = editAreaButtonAction;
        vm.closeAreaButtonAction = closeAreaButtonAction;
        vm.goBackButtonAction = goBackButtonAction;
        vm.areaButtonAction = areaButtonAction;

        // vm.getFareTypeDescription = FareUtility.getFareTypeDescription
        // vm.isFareActiveOnGeofence = isFareActiveOnGeofence
        // vm.addOrDeleteFareToGeofence = addOrDeleteFareToGeofence
        // vm.getCurrentActiveGeofenceFare = getCurrentActiveGeofenceFare
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.settings.fares',
            [
                
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.settings.fares',{
                url: "/fares",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/fares/fares-list.html',
                        controller : 'FaresController as vm'
                    }
                }
            })

        // Navigation
        msNavigationServiceProvider.saveItem('settings.fares', {
            title : 'Fares',
            icon  : 'icon-currency-usd',
            state: "app.settings.fares",
            weight: 4
        });

    }

})();
(function(){
    'use strict'

    angular
        .module("app.settings.fares")
        .controller("FaresController", FaresController)

        /** @ngInject */
        function FaresController($scope, FaresAdapter, $state, ShowToast, DialogFactory,toDateFilter,GenerateCSVService,FareType,FareUtility,ServiceSettings,MiscUtility,toNumberFilter,SweetAlert,SitesService,ErrorUtility,DefaultSite) {
            var vm = this

            vm.fares = []
            vm.isAddingFare = false
            vm.getCurrencyValue = MiscUtility.getCurrencyValue

            function initNewFare(){
                vm.newFare = {
                    name: null,
                    prices: [
                        {
                            type: null,
                            status: null,
                            value: null,
                            price: null,
                        },
                        {
                            type: null,
                            status: null,
                            value: null,
                            price: null,
                        }
                    ],                    
                    start: null,
                    end: null,
                    unlimited: false,
                    vat:null
                }
            }
            initNewFare()

            /*vm.fareTypes = {
                minutes: {value: 0, description: "Minute"},
                //km: {value: 1, description: "kilometer"},
                prepaidMinutes: {value: 2,description: "PrepaidMinutes"},
                halfHour: {value: -1, description: "Half Hour"}//internal

            }*/
            vm.fareType = FareType

            $scope.$on('refreshServiceSettings',function (event) {
                init()
            })
            
            function init() {
                ServiceSettings.getServiceSettings(function(settings, error){
                    if(settings.loaded){
                        // timezone is only used to create a new fare.
                        // when creating a new fare the service must be selected
                        SitesService.getSites(function(){
                            vm.selectedSiteId = SitesService.getSelectedSite()
                            vm.timezone = ServiceSettings.getSiteTimezone(vm.selectedSiteId)
                        })
                    }
                    $scope.$applyAsync()
                });
            }
            init()

            $scope.$on('$viewContentLoaded',function(event){
                getFares()
            })

            $scope.$on('siteChanged', function (site) {
                SitesService.getSites(function(){
                    vm.selectedSiteId = SitesService.getSelectedSite();
                })
                getFares()
            })

            vm.getFares = getFares
            vm.addFareButtonAction = addFareButtonAction
            vm.addFare = addFare
            vm.getFareTypeDescription = getFareTypeDescription
            vm.modifyButtonAction = modifyButtonAction
            vm.deleteButtonAction = deleteButtonAction
            vm.goToGeofence = goToGeofence
            vm.setFareAsDefault = setFareAsDefault
            vm.exportListAsCSV = exportListAsCSV

            function getFares(){
                FaresAdapter.getFares(function(response, error){
                    if(!error){
                        response.forEach(function (fare) {
                            //change fare type to half hour to present to the app,minutes and half hour type are the same in server but value represents minutes
                            if(fare.value == 30){
                                fare.type = vm.fareType.HALF_HOUR.value
                            }
                        })
                        vm.fares = response
                        console.log("Fares: ",vm.fares)
                    }else{
                        console.log(error)
                    }
                })
            }

            function addFareButtonAction(event){
                if(Number(vm.selectedSiteId) === DefaultSite.id) {
                    SweetAlert.swal(
                        "You must select a site!",
                        "Inserting fares is not allowed when viewing All Sites, please select a site and try again",
                        "error"
                    );
                    return;
                }
                
                var element = angular.element(event.delegateTarget)
                element.toggleClass("rotated")
                vm.isAddingFare = !vm.isAddingFare
            }

            function addFare(){
                console.log("addFAre")
                if(vm.timezone === null || vm.timezone === undefined) {
                    ErrorUtility.showErrorMessage({title:'Fares',description:'Unable to save fare. Error while retrieving timezone'})
                    return;
                }
                var data = angular.copy(vm.newFare)
                data.start = MiscUtility.shiftJstoMoment(data.start, data.SiteId ? data.SiteId : null).startOf('day').valueOf()
                data.end = data.end ? MiscUtility.shiftJstoMoment(data.end, data.SiteId ? data.SiteId : null).endOf('day').valueOf() : moment.tz(vm.timezone).endOf('day').valueOf()
                
                /*for(var index in data){
                    if(data[index] == null){ return }
                }*/
                //check fare type,set value 1 if minutes
                if(data.prices[0].type == vm.fareType.MINUTES.value){
                    data.prices[0].value = 1
                }
                if(data.prices[1].type == vm.fareType.MINUTES.value){
                    data.prices[1].value = 1
                }
                //check fare type,set value 30 if half hours and change type to minutes for server!!
                if(data.prices[0].type == vm.fareType.HALF_HOUR.value){
                    data.prices[0].type = vm.fareType.MINUTES.value
                    data.prices[0].value = 30
                }
                if(data.prices[1].type == vm.fareType.HALF_HOUR.value){
                    data.prices[1].type = vm.fareType.MINUTES.value
                    data.prices[1].value = 30
                }
                data.prices[0].price = parseFloat(data.prices[0].price)
                data.prices[1].price = parseFloat(data.prices[1].price)
                data.prices[0].status = 'running'
                data.prices[1].status = 'parked'

                //console.log("date",new Date(data.start),new Date(data.end))
                //console.log("dataToSend",data)

                FaresAdapter.addFare(data,function(response, error){
                    if(!error){
                        initNewFare()

                        var button = document.getElementById("newFareButton")
                        addFareButtonAction({delegateTarget: button})

                        getFares()
                    }else{
                        console.log(error)
                    }
                })
            }

            function modifyButtonAction(fare){
                if(fare.SiteId === null || fare.SiteId === undefined) {
                    ErrorUtility.showErrorMessage({ title:'Fares', description:'Fare editing is not available for this fare. timezone not available!' })
                    return;
                }
                if(!fare.isBeingModified){
                    fare.isBeingModified = true

                    fare.startDate = MiscUtility.shiftMomentToJs(fare.start, fare.SiteId);
                    fare.endDate = MiscUtility.shiftMomentToJs(fare.end, fare.SiteId);

                } else {
                    console.log("currentFare:",fare)

                    var data = {
                        name: null,
                        prices: [
                            {
                                type: null,
                                status: null,
                                value: null,
                                price: null,
                            },
                            {
                                type: null,
                                status: null,
                                value: null,
                                price: null,
                            }
                        ],                    
                        start: null,
                        end: null,
                        unlimited: false,
                        vat:null
                    }
                    
                    data.start = MiscUtility.shiftJstoMoment(fare.startDate, data.SiteId ? data.SiteId : null).startOf('day').valueOf();
                    data.end = MiscUtility.shiftJstoMoment(fare.endDate, data.SiteId ? data.SiteId : null).endOf('day').valueOf();
                    
                    if(data.start === null && data.end === null) {
                        ErrorUtility.showErrorMessage({ title:'Fares', description:'Unable to save fare. Error parsing service timezone!' })
                        return;
                    } else {
                        data.start = data.start.startOf('day').valueOf();
                        data.end = data.start.endOf('day').valueOf();
                    }

                    // if(fare.end instanceof Date) {
                    //     data.end = moment(fare.end).tz(vm.timezone).endOf('day').valueOf()
                    //     // fare.end.setHours(23,59,59)
                    //     // data.end = fare.end.getTime()
                    // }
                    // else{
                    //     data.end = fare.end
                    // }
                    //data.end = fare.end instanceof Date ? fare.end.getTime() : fare.end

                    data.name = fare.name
                    data.prices[0].type = fare.prices[0].type
                    data.prices[0].status = fare.prices[0].status
                    data.prices[0].value = fare.prices[0].value
                    data.prices[0].price = parseFloat(fare.prices[0].price)

                    data.prices[1].type = fare.prices[1].type
                    data.prices[1].status = fare.prices[1].status
                    data.prices[1].value = fare.prices[1].value
                    data.prices[1].price = parseFloat(fare.prices[1].price)

                    data.unlimited = fare.unlimited
                    data.vat = fare.vat

                    //console.log("date",new Date(data.start),new Date(data.end))
                    // console.log("dataToSend",data); 

                    FaresAdapter.updateFare(fare.id, data, function(response, error){
                        if(!error){
                            fare.isBeingModified = false
                            getFares()
                        }else{
                            console.log(error)
                        }
                    })
                    
                }
            }

            function deletFareConfirmDialog(fare,ev){

                DialogFactory.confirm("Delete a fare","Are you sure you want to delete this fare?",ev)
                    .then(
                        function ok() {
                            FaresAdapter.deleteFare(fare.id, function(response, error){
                                if(!error){
                                    getFares()
                                }else{
                                    console.log(error)
                                }
                            })
                        }
                    )
            }

            function deleteButtonAction(fare,ev){
                if(!fare.isBeingModified){
                    deletFareConfirmDialog(fare,ev)
                }else{
                    fare.isBeingModified = false
                }
            }

            function getFareTypeDescription(fare){
               return FareUtility.getFareTypeDescription(fare)
            }

            function setFareAsDefault(fare) {

                FaresAdapter.setAsDefault(fare.id,function (response,error) {
                    if(!error){
                        getFares()
                    }
                    else {
                        console.log(error)
                        DialogFactory.alert("Update Error","Error setting fare as default")
                    }
                })

            }

            function goToGeofence(){
                $state.go("app.settings.geofencing")
            }

            function exportListAsCSV() {
                var outputArray = []
                var outputString = ""
                const semicolonString=";"
                const endLineString="\n"
                // const priceString = "€ "
                const spaceString = " "
                const percentString = " %"
                const dateTimeFormat ="dd/MM/yyyy HH:mm:ss"

                //header
                outputString="Fare name"+semicolonString+"Start"+semicolonString+"End"+semicolonString
                    +"Currency Symbol"+semicolonString+"Price Running"+semicolonString+"Description(Running)"+semicolonString+"Price Parked"+semicolonString+"Description(Parked)"+semicolonString+"Vat "+semicolonString+"Default"+endLineString
                outputArray.push(outputString)

                vm.fares.forEach(function (fare) {
                    outputString = fare.name + semicolonString
                    outputString += toDateFilter(fare.start,dateTimeFormat,fare.SiteId) + semicolonString
                    outputString += (fare.unlimited ? 'No limit' : toDateFilter(fare.end,dateTimeFormat,fare.SiteId)) + semicolonString
                    outputString += ServiceSettings.getCurrencySymbol(fare.SiteId) + semicolonString
                    outputString += toNumberFilter(fare.prices[0].price) + semicolonString
                    outputString += vm.getFareTypeDescription(fare.prices[0]) + semicolonString
                    outputString += toNumberFilter(fare.prices[1].price) + semicolonString
                    outputString += vm.getFareTypeDescription(fare.prices[1]) + semicolonString
                    outputString += fare.vat + percentString + semicolonString
                    outputString += fare.defaultService ? 'Yes' : 'No'
                    outputString += endLineString
                    outputArray.push(outputString)
                })

                GenerateCSVService.generate(outputArray)
            }
        }

})();

/**
 * Created by alex on 03/05/18.
 */

(function(){
    'use strict';
    angular.module('app.settings.device')
        .controller('DevicesListController', DevicesListController)
        .factory('DeviceDialogFactory',DeviceDialogFactory)

    /** @ngInject */
    function DevicesListController(DeviceAdapter, $scope, DeviceStatus,VehicleBookingStatus,DeviceDialogFactory,FiltersFactory,OrderRequestParamFactory,ServiceSettings,ErrorUtility){
        var vm = this
                
        vm.devices = []

        vm.deviceStatus = DeviceStatus

        vm.filters = {}

        vm.selectedSearchFilter = null
        vm.searchFilters = {
            deviceId: FiltersFactory.createDeviceWithIdFilter(),
            deviceCode: FiltersFactory.createDeviceWithCodeFilter(),
            deviceVersion: FiltersFactory.createDeviceWithVersionFilter(),
            deviceOnline: FiltersFactory.createDeviceWithOnlineFilter(),
            deviceVehicleId: FiltersFactory.createDeviceWithVehicleIdFilter(),
            deviceAssignedVehicle: FiltersFactory.createDeviceWithAssignedVehicleFilter(),
            deviceVehicleReferenceCode: FiltersFactory.createDeviceWithVehicleReferenceCodeFilter(),
            deviceVehicleLicensePlate: FiltersFactory.createDeviceWithVehicleLicensePlateFilter()
        }

        vm.filterRequestParam = null
        vm.orderRequestParam = null
        vm.selectedOrderBy = {orderBy: OrderRequestParamFactory.orderByDeviceId, ascOrder: false}

        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })
        
        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){

                    vm.tableFields = {
                        id: { name: "Device id", orderBy: OrderRequestParamFactory.orderByDeviceId, defaultSort:true, class:"vehicleRowCellSmall", key:'id'},
                        name: { name: "Name", orderBy: OrderRequestParamFactory.orderByDeviceCode, class:"vehicleRowCellBig", key:'name'},
                        /* siteId: { name: "Site", key: 'SiteId',hideCsv: true, hide: !SitesService.isDefaultSiteSelected(), type:'render', render: function(val, obj){ return SitesService.getSiteName(obj.SiteId) }}, */
                        version: { name: "Version", orderBy: OrderRequestParamFactory.orderByDeviceVersion, class:"vehicleRowCellBig", key: 'version'},
                        online: { name: "Online", orderBy: OrderRequestParamFactory.orderByDeviceOnline, class:"vehicleRowCellIcon", type:'icon-boolean', icon: {
                            key: 'online',
                            true: 'icon-check-circle',
                            false: 'icon-close-circle-outline'
                        }, key:'online'},
                        vehicleId: { name: "Vehicle id", orderBy: OrderRequestParamFactory.orderByDeviceVehicleId, class:"vehicleRowCellSmall", key:'vehicle.id', type:'render', render: function(val, obj) { return obj.vehicle ? obj.vehicle.id : 'No vehicle assigned'}},
                        vehicle: {name: "Vehicle", orderBy: OrderRequestParamFactory.orderByDeviceVehicleReferenceCode, class:"vehicleRowCellBigger", type:'link', link:{goto: "app.vehicle.details",gotoParams: "vehicleId", key:'vehicle.id', class: function(o){ return o.vehicle ? 'userLink' : ''}}, render: function(val, obj){ return obj.vehicle ? obj.vehicle.reference_code : 'No vehicle assigned' }},
                        vehicleStatus: {name: "Vehicle status", class:"vehicleRowCellSmall", type:'render', render: function(val, obj){ return obj.vehicle ? obj.vehicle.status : '' }},
                        vehicleLastUpdate: {name: "Last Update", class:"vehicleRowCellBigger rowCellAlignLeft", type:'render', render: function(val, obj) { return obj.vehicle ? (obj.vehicle.lastUpdate): "No updates"}},
                        manage: {name: "Manage", class:"vehicleRowCellIcon", type:'icon-click',hideCsv: true, icon:{ class:'icon-information-outline', click:function(obj, $event){ return vm.openManageDeviceDialog($event, obj) }, aria: 'Open Dialog' }},
                    }
                }
            });
        }
        init();

        $scope.$on('siteChanged', function (site) {
            console.log('siteChanged in devices')
            vm.applyFiltersTrigger();
        })

        vm.refreshDevices = refreshDevices
        vm.vehicleBookingStatus = VehicleBookingStatus
        vm.openManageDeviceDialog = openManageDeviceDialog
        
        function refreshDevices(paginationRequestParam, callback, updateInterface){
            if(updateInterface === undefined) {
                updateInterface = true;
            }

            DeviceAdapter.getDevices(paginationRequestParam,
                function (data,error) {
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Get Devices List',description:'Error while getting the devices list!'})
                        if (callback !== undefined) {
                            callback(data, error)
                        }
                    } else{
                        if(updateInterface){
                            var devices = (typeof data.data !== "undefined") ? data.data : data
                            if(devices) {
                                vm.devices = devices;
                            }
                        }
                        if (callback !== undefined) {
                            callback(data, error)
                        }
                    }
                }
            )
        }

        function openManageDeviceDialog(event,device){
            DeviceDialogFactory.manage(event,device)
                .then(
                    function ok(refresh){
                        console.log("exit dialog")
                        if(refresh){
                            vm.refreshDevices()
                        }
                    }
                )
        }
    }

    /** @ngInject */
    function DeviceDialogFactory($mdDialog,$document,DeviceStatus) {

        return{
            manage: function (ev,device) {

                var dialogType = device.status == DeviceStatus.DETACHED.value ? 'add' : 'edit'

                return $mdDialog.show({
                    controller         : 'DeviceManageDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/settings/devices/dialogs/device-manage-dialog.html',
                    parent             : angular.element($document.body),//angular.element($document.find('#content-container'))
                    targetEvent        : ev,
                    clickOutsideToClose: false,
                    locals             : {
                        Device : device,
                        DialogType: dialogType
                    }
                });
            }
        }
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.settings.damage', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.settings.damage',{
                url: "/damages",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/damages/damagesList.html',
                        controller : 'DamagesController as vm'
                    }
                }
            })

        // Navigation
        msNavigationServiceProvider.saveItem('settings.damage', {
            title : 'Damages',
            icon  : 'icon-alert-box',
            state: "app.settings.damage",
            weight: 2
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("settings.damage")
        
        if(!active) {
            msNavigationService.deleteItem("settings.damage")
        }
    }

})();

(function(){
    'use strict'

    angular
        .module("app.settings.damage")
        .controller("DamagesController",DamagesController)

        /** @ngInject */
        function DamagesController($scope, ExpensesAdapter,toDateFilter,GenerateCSVService,DialogFactory, MiscUtility, toNumberFilter, SweetAlert, SitesService,ErrorUtility,ServiceSettings) {
            var vm = this

            vm.damages = []
            vm.isAddingDamage = false

            vm.newDamage = {
                name: null,
                description: null,
                price: null
            }

            vm.getCurrencyValue = MiscUtility.getCurrencyValue

            $scope.$on('$viewContentLoaded',function(event){
                updateDamages()
            })

            $scope.$on('siteChanged', function (site) {
                SitesService.getSites(function(){
                    vm.selectedSiteId = SitesService.getSelectedSite();
                })
            })

            $scope.$on('refreshServiceSettings',function (event) {
                init();
            })
          
            function init() {
                ServiceSettings.getServiceSettings(function(settings, error){
                    if(settings.loaded){
                        SitesService.getSites(function(){
                            vm.selectedSiteId = SitesService.getSelectedSite()                    
                            vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                        })
                    }
                });
            }
        
            init();

            function updateDamages(){
                ExpensesAdapter.getExpenses(function(response, error){
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Get Damages List',description:'Error while getting the damages list!'})
                    }else{
                        vm.damages = response
                        // console.log(vm.damages)
                    }
                })
            }

            function addDamageButtonAction(event){

                var element = angular.element(event.delegateTarget)
                element.toggleClass("rotated")
                vm.isAddingDamage = !vm.isAddingDamage
            }

            function addDamage(){
                ExpensesAdapter.addExpense(vm.newDamage, function(response, error){
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Add Damage',description:'Error while adding the new damage!'})
                    }else{
                        var addButton = document.getElementById("newDamageButton")
                        addDamageButtonAction({delegateTarget: addButton})
                        vm.newDamage = {
                            name: null,
                            description: null,
                            price: null
                        }
                        updateDamages()
                    }
                })
            }

            function modifyButtonAction(damage){
                if(!damage.isBeingModified){
                    damage.isBeingModified = true
                }else{
                    ExpensesAdapter.editExpense(damage.id, damage, function(response, error){
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Edit Damage',description:'Error while editing the damage!'})
                        }else{
                            damage.isBeingModified = false
                            updateDamages()
                        }
                    })
                    
                }
            }

            function deleteDamageConfirmDialog(damage,ev){

                DialogFactory.confirm("Delete a damage","Are you sure you want to delete this damage?",ev)
                    .then(
                        function ok() {
                            ExpensesAdapter.deleteExpense(damage.id, function(response, error){
                                if(error){
                                    ErrorUtility.showErrorMessage({title:'Delete Damage',description:'Error while deleting the damage!'})
                                }else{
                                    updateDamages()
                                }
                            })
                        }
                    )
            }

            function deleteButtonAction(damage,ev){
                if(!damage.isBeingModified){
                    deleteDamageConfirmDialog(damage,ev)
                }else{
                    damage.isBeingModified = false
                }
            }
            
            function exportListAsCSV() {
                var outputArray = []
                var outputString = ""
                const semicolonString=";"
                const endLineString="\n"
                // const priceString = "€ "
                const dateTimeFormat ="dd/MM/yyyy HH:mm:ss"
                
                //header
                outputString="Damage name"+semicolonString+"Description"+semicolonString+"Currency Symbol"+semicolonString+"Price"+semicolonString
                    +"Created at"+semicolonString+"Updated at"+endLineString
                outputArray.push(outputString)

                vm.damages.forEach(function (damage) {
                    outputString = damage.name + semicolonString
                    outputString += damage.description + semicolonString
                    outputString += ServiceSettings.getCurrencySymbol(damage.SiteId) + semicolonString
                    outputString += toNumberFilter(damage.price) + semicolonString
                    outputString += toDateFilter(damage.created_at,dateTimeFormat,damage.SiteId) + semicolonString
                    outputString += (damage.updated_at ? toDateFilter(damage.updated_at,dateTimeFormat,damage.SiteId) : "")
                    outputString += endLineString
                    outputArray.push(outputString)
                })

                GenerateCSVService.generate(outputArray)
            }

            vm.updateDamages = updateDamages
            vm.addDamageButtonAction = addDamageButtonAction
            vm.addDamage = addDamage
            vm.modifyButtonAction = modifyButtonAction
            vm.deleteButtonAction = deleteButtonAction
            vm.exportListAsCSV = exportListAsCSV
        }
})();


(function ()
{
    'use strict';

    angular
        .module('app.settings.api-settings', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.settings.api-settings',{
                url: "/api-settings",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/apisettings/apiSettings.html',
                        controller : 'ApiSettings as vm'
                    }
                }
            })

        // Navigation
        msNavigationServiceProvider.saveItem('settings.api-settings', {
            title : 'Service settings',
            icon  : 'icon-code-braces',
            state: "app.settings.api-settings",
            weight: 11
        });

    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("settings.api-settings")
        
        if(!active) {
            msNavigationService.deleteItem("settings.api-settings")
        }
    }

})();

(function(){
    'use strict'

    angular
        .module("app.settings.api-settings")
        .controller("ApiSettings", ApiSettings)

        /** @ngInject */
        function ApiSettings($scope,$timeout,SweetAlert,ApiSettingsAdapter,DialogFactory,MultiVehicleType,SitesService,DefaultSite,ErrorUtility,MiscUtility) {
            var vm = this
            var rawServiceSettings = null
            var savedServiceSettings = null
            vm.currentServiceSettings = {base: {},specific:{},hardcoded:{}}
            vm.canUploadSettings = false
            
            vm.sites = []
            var rawMillisecondsProperties = [
                'booking.multi_vehicle.setupTime.XTYPEX',
                'booking.multi_vehicle.bookingTime.XTYPEX',
                'movo.pricing.multi_vehicle.time_thresholds.XTYPEX.thresholds.ms'
            ]
            var millisecondsProperties = [] //['login.freeMilliseconds']
            
            for(var key in MultiVehicleType){
                var multiVehicleValue = MultiVehicleType[key].value

                rawMillisecondsProperties.forEach(function (property) {
                    millisecondsProperties.push(property.replace("XTYPEX",multiVehicleValue))
                })
            }
                        
            $scope.$on('$viewContentLoaded',function(event){
                //TO DO: fix me, queue getSites call because now sites refresh do a double setSites (because of site specific permissions)
                $timeout(function(){
                    refreshPage()
                },2000)
            })

            $scope.$on('siteChanged', function (site) {
                console.log('ApiSettings: siteChanged',site)
                refreshPage()
            })

            vm.refreshPage = refreshPage
            vm.filterSelectedSite = filterSelectedSite
            vm.getCurrentSettings = getCurrentSettings
            vm.callUpdateBaseServiceSettings = callUpdateBaseServiceSettings
            vm.callUpdateSpecificServiceSettings = callUpdateSpecificServiceSettings

            function refreshPage(){
                getCurrentSettings()
            }

            function getServiceSites(cb) {

                SitesService.getSites(
                    function (sites,error) {
                        if(error){

                        }else{
                            // console.log("ApiSettings getSites:",sites)
                            vm.sites = sites
    
                            if(typeof cb !== "undefined"){
                                cb(sites,error)
                            }
                        }
                    }
                )
            }

            function resetServiceSettings(cb) {

                vm.currentServiceSettings = {base: {},specific:{},hardcoded:{}}
                vm.sites.forEach(function (site) {
                    if(site.id !== DefaultSite.id)
                        vm.currentServiceSettings.specific[site.id] = {}
                })
            }

            function transformMillisecondsPropertiesTo(settings,unitScale){
                
                if(settings == null || typeof settings == "undefined" || !unitScale){
                    console.warn("transformMillisecondsPropertiesTo: invalid input")
                    return
                }

                millisecondsProperties.forEach(function(property){
                    var keysToInspect = property.split(".")
                    var setting = settings
                    
                    keysToInspect.forEach(function(key,index){
                        if(index==keysToInspect.length-1){
                            if(typeof setting !== "string" && typeof setting.length === "number"){
                                setting.forEach(function (elem) {
                                    if(unitScale == "seconds"){
                                        elem[key] = parseInt(elem[key])/1000
                                    }else if(unitScale == "milliseconds"){
                                        elem[key] = parseInt(elem[key]) * 1000
                                    }
                                })
                            }
                            else if(setting.hasOwnProperty(key)){
                                if(unitScale == "seconds"){
                                    setting[key] = parseInt(setting[key])/1000
                                }else if(unitScale == "milliseconds"){
                                    setting[key] = parseInt(setting[key]) * 1000
                                }
                            }
                        }
                        else if(setting.hasOwnProperty(key)){
                            setting = setting[key]
                        }
                    })                   
                })
            }
            // TODO: adjust this fn to support other virtual fields. Maybe support different conversions
            function transformFormSpecificPropertiesTo(settings, siteId, type, deleteData){

                if(type === "credit"){
                    const signupMillis = settings && settings.login && settings.login.freeMilliseconds
                    if(typeof signupMillis !== "string"){
                        return
                    }
                    // console.log("transformFormSpecificPropertiesTo credit",settings,"siteId",siteId, "millis",signupMillis)
                    const credit = MiscUtility.generateCreditValue(signupMillis, siteId)
                    if(credit == null){
                        console.error("transformFormSpecificPropertiesTo: credit is null")
                        return
                    }
                    settings.formSpecific = {freeCredit: credit}
                    // console.log("settings",settings)
                } else if(type === "milliseconds"){
                    const signupCredit = settings && settings.formSpecific && settings.formSpecific.freeCredit
                    // console.log("transformFormSpecificProperties to millis",settings,"siteId",siteId, "credit",signupCredit)
                    if(typeof signupCredit === "undefined" || signupCredit === null){
                        return
                    }
                    const milliseconds = MiscUtility.generateMillisecondsValue(signupCredit, siteId)
                    if(milliseconds == null){
                        console.error("transformFormSpecificPropertiesTo: milliseconds is null")
                        return
                    }
                    if(settings.login && settings.login.freeMilliseconds != null){
                        settings.login.freeMilliseconds = milliseconds
                    } else {
                        settings.login = {freeMilliseconds: milliseconds}
                    }
                    // console.log("settings",settings)
                }
            }

            function convertServiceSettingsFromServerDataFormat(serviceSettings) {
                //trasform in seconds
                transformMillisecondsPropertiesTo(serviceSettings.hardcoded,"seconds")
                transformMillisecondsPropertiesTo(serviceSettings.base,"seconds")
                transformFormSpecificPropertiesTo(serviceSettings.hardcoded, DefaultSite.id, "credit")
                transformFormSpecificPropertiesTo(serviceSettings.base, DefaultSite.id, "credit")
                for(var key in serviceSettings.specific){
                    transformMillisecondsPropertiesTo(serviceSettings.specific[key],"seconds")
                    transformFormSpecificPropertiesTo(serviceSettings.specific[key], key, "credit")
                }
            }

            function convertServiceSettingsToServerDataFormat(serviceSettings) {

                transformMillisecondsPropertiesTo(serviceSettings.base,"milliseconds")
                transformFormSpecificPropertiesTo(serviceSettings.base, DefaultSite.id, "milliseconds")
                for(var key in serviceSettings.specific){
                    transformMillisecondsPropertiesTo(serviceSettings.specific[key],"milliseconds")
                    transformFormSpecificPropertiesTo(serviceSettings.specific[key], key, "milliseconds")
                }
            }
            // NOTE delete temporary form fields stored in the serviceSetting obj
            function deleteTemporaryData(serviceSettings){
                const base = serviceSettings.base
                delete base.formSpecific
                for(var key in serviceSettings.specific){
                    const specific = serviceSettings.specific[key]
                    delete specific.formSpecific
                }
            }

            var prevValue = null
            function initServiceSettingsSitesHandlers() {
                $timeout(function(){
                    angular.forEach(document.getElementsByClassName('inputField'),function(input,key){
                        
                        input.removeEventListener("keydown",function (event) {
                        })
                        
                        input.addEventListener("keydown",function(event){
                            // console.log("keydown","code",event.keyCode,"value",event.target.value)
                            
                            if(event.target.value){
                                prevValue = event.target.value
                            }
                        })
                        input.removeEventListener("keyup",function (event) {
                        })
                        
                        input.addEventListener("keyup",function(event){
                            //  console.log("keyup","code",event.keyCode,"value",event.target.value,typeof event.target.value)
                            // if( (event.keyCode == 8 || (prevKeyCode && prevKeyCode==91 && event.keyCode==88)) && event.target.value == ""){
                            //     event.preventDefault()
                            //     event.stopPropagation()
                            //     event.target.value = prevValue
                            // }
                            // prevKeyCode = event.keyCode
                            if(event.target.value == "" && prevValue != ""){
                                // console.log("prev",prevValue)
                                input.value = prevValue
                                //trigger jQuery events to update ng-model
                                $(input).triggerHandler('input')
                                $(input).triggerHandler('change')
                            }
                        })
                    })
                },1000)
            }

            function getCurrentSettings(){
                vm.canUploadSettings = false
                
                if(vm.sites.length>0){

                    ApiSettingsAdapter.getSettings(function(response, error){
                        if(error){
                            ErrorUtility.showErrorMessage({title:'Get Service Settings',description:'Error while getting the service settings!'})
                        }else{
                            resetServiceSettings()

                            rawServiceSettings = angular.copy(response)
                            // console.log("rawSettings",rawServiceSettings)

                            vm.isDefaultSiteSelected = SitesService.isDefaultSiteSelected()
                            SitesService.getSites(function(){
                                vm.selectedSite = SitesService.getSelectedSite()
                            })
                            // console.warn("isDefaultSiteSelected",vm.isDefaultSiteSelected,vm.selectedSite)

                            convertServiceSettingsFromServerDataFormat(response)

                            vm.currentServiceSettings.hardcoded = response.hardcoded
                            vm.currentServiceSettings.base = MiscUtility.deepMergeObjects(response.base,response.hardcoded)
                            vm.currentServiceSettings.specific = MiscUtility.deepMergeObjects(response.specific,vm.currentServiceSettings.specific)
                            savedServiceSettings = angular.copy(vm.currentServiceSettings)
                            // console.log("vm.currentServiceSettings",vm.currentServiceSettings)
                            //checkIfNewPricingIsActivated(response.base)
                            //checkIfNewPricingIsActivated(response.specific)
                            vm.canUploadSettings = true
                            initServiceSettingsSitesHandlers()
                        }
                    })
                }else{
                    getServiceSites(getCurrentSettings)
                }
            }

            function callUpdateBaseServiceSettings() {

                //cause the app have to send all the settings for all the sites every time be sure to have dowloaded all the settings correctly
                if(!vm.canUploadSettings){
                    ErrorUtility.showErrorMessage({title:'Update Service Settings',description:'There was an error with the latest downloaded service settings and is impossible to update them now. Downloading them again...if no errors please modify and update them again'})
                    refreshPage()
                    return
                }

                //cause the app attaches the selected site in all the requests and the server do not update base settings if a siteId is attached in the update request
                if(!SitesService.isDefaultSiteSelected()){
                    ErrorUtility.showErrorMessage({title:'Update Service Settings',description:'To update the default service settings please select \'All cities\'!'})
                    return
                }

                if(Object.keys(vm.currentServiceSettings.base).length == 0){
                    ErrorUtility.showErrorMessage({title:'Update Service Settings',description:'The service settings are empty!'})
                    return
                }
                console.log("callUpdateBaseServiceSettings")

                try {
                    var newBaseServiceSettings = angular.copy(vm.currentServiceSettings.base)
                    validateAndUpdateServiceSettings(newBaseServiceSettings)
                    // console.log("callUpdateBaseServiceSettings",newBaseServiceSettings)
                    // console.log("all settings to send",{hardcoded: savedServiceSettings.hardcoded, base: newBaseServiceSettings, specific: savedServiceSettings.specific})
                    callUpdateServiceSettings({hardcoded: savedServiceSettings.hardcoded, base: newBaseServiceSettings, specific: savedServiceSettings.specific})
                } catch (error) {
                    console.log(error)
                    ErrorUtility.showErrorMessage({title: "Error parsing Service Settings", description: "There was an error parsing the service settings, please try to insert the data again"})
                }

            }

            function callUpdateSpecificServiceSettings(siteIdToUpdate) {

                //cause the app have to send all the settings for all the sites every time be sure to have dowloaded all the settings correctly
                if(!vm.canUploadSettings){
                    ErrorUtility.showErrorMessage({title:'Update Service Settings',description:'There was an error with the latest downloaded service settings and is impossible to update them now. Downloading them again...if no errors please modify and update them again'})
                    refreshPage()
                    return
                }

                //cause the app attaches the selected site in all the requests and the server do not update site specific settings when no siteId is attached in the update request
                if(SitesService.isDefaultSiteSelected()){
                    ErrorUtility.showErrorMessage({title:'Update Service Settings',description:'To update the site specific service settings please select the appropriate site in the toolbar!'})
                    return
                }

                if(Object.keys(vm.currentServiceSettings.specific[siteIdToUpdate]).length == 0){
                    ErrorUtility.showErrorMessage({title:'Update Service Settings',description:'The service settings are empty!'})
                    return
                }

                console.log("callUpdateSpecificServiceSettings",siteIdToUpdate)
                var serviceSettingsToSend = {hardcoded: savedServiceSettings.hardcoded, base: savedServiceSettings.base, specific: {}}
                
                try {
                    for(var siteId in vm.currentServiceSettings.specific){
                        if(siteId == siteIdToUpdate){
                            var newSpecificSettings = angular.copy(vm.currentServiceSettings.specific[siteId])
                            validateAndUpdateServiceSettings(newSpecificSettings)
                            serviceSettingsToSend.specific[siteId] = newSpecificSettings
                        }else{
                            serviceSettingsToSend.specific[siteId] = savedServiceSettings.specific[siteId]
                        }
                    }
                    // console.log("callUpdateSpecificServiceSettings",serviceSettingsToSend.specific[siteIdToUpdate])
                    // console.log("all settings to send",serviceSettingsToSend)
                    callUpdateServiceSettings(serviceSettingsToSend,siteIdToUpdate)
                } catch (error) {
                    console.log(error)
                    ErrorUtility.showErrorMessage({title: "Error parsing Service Settings", description: "There was an error parsing the service settings, please try to insert the data again"})
                }

            }

            function validateAndUpdateServiceSettings(serviceSettings){

                if(!serviceSettings){
                    return
                }

                for(var multiVehicleKey in MultiVehicleType){
                    var multiVehicleValue = MultiVehicleType[multiVehicleKey].value
                    
                    var availabilityFrames = []
                    
                    //check availabity if array (trasform object to array)
                    if(serviceSettings.service && serviceSettings.service.availability && serviceSettings.service.availability[multiVehicleValue] && serviceSettings.service.availability[multiVehicleValue].frames){
                        for (var index in serviceSettings.service.availability[multiVehicleValue].frames){
                            availabilityFrames.push(serviceSettings.service.availability[multiVehicleValue].frames[index]) 
                        }
                        if(availabilityFrames.length>0){
                            serviceSettings.service.availability[multiVehicleValue].frames = availabilityFrames
                        }
                    }

                    //check low battery
                    if(serviceSettings.service && serviceSettings.service.vehicle && serviceSettings.service.vehicle.lowBattery){
                        var lowBatteryValue = serviceSettings.service.vehicle.lowBattery[multiVehicleValue]
                        if(lowBatteryValue === null || typeof lowBatteryValue === "undefined"){
                            console.log("lowBatteryValue not valid",lowBatteryValue)
                            delete serviceSettings.service.vehicle.lowBattery[multiVehicleValue]
                        }
                        if(Object.keys(serviceSettings.service.vehicle.lowBattery).length===0){
                            delete serviceSettings.service.vehicle.lowBattery
                        }
                    }

                }
                //check vat
                if(serviceSettings.movo && serviceSettings.movo.pricing && serviceSettings.movo.pricing.vat){
                    var pricingVAT = serviceSettings.movo.pricing.vat.value
                    if(pricingVAT === null || typeof pricingVAT === "undefined"){
                        console.log("pricingVAT not valid",pricingVAT)
                        delete serviceSettings.movo.pricing.vat
                    }
                    
                }
                
            }

            function callUpdateServiceSettings(serviceSettings,siteId){
                var siteName = (siteId ? SitesService.getSiteName(siteId) : 'Default')
                
                console.log("serviceSettings to send",serviceSettings)

                DialogFactory.confirm("Update "+ siteName +" Service Settings", "Are you sure you want to update the "+ siteName +" service settings?").then(
                    function ok(){
                        var serviceSettingsToSend = angular.copy(serviceSettings)
                        var savedData = angular.copy(serviceSettingsToSend)

                        //trasform  booking settings time seconds in milliseconds
                        convertServiceSettingsToServerDataFormat(serviceSettingsToSend)
                        deleteTemporaryData(serviceSettingsToSend)
                        console.log("after conversion, dataToSend",serviceSettingsToSend)

                        updateServiceSettings(serviceSettingsToSend,
                            function(response,error){
                                if(error){
                                    ErrorUtility.showErrorMessage({title:'Update Service Settings',description:'Error updating the '+siteName+' service setting!'})
                                    vm.currentServiceSettings = savedData
                                }else{
                                    if(response.updated){
                                        SweetAlert.swal('Update Service Settings', siteName+" Service settings successfully updated!","success")
                                        getCurrentSettings()
                                    }
                                    else{
                                        ErrorUtility.showErrorMessage({title:'Update Service Settings',description:'Error updating the '+siteName+' service setting!'})
                                        vm.currentServiceSettings = savedData
                                    }
                                }
                            })
                    })
            }

            function updateServiceSettings(dataToSend,callback){
                
                console.log("dataToSend", dataToSend)

                ApiSettingsAdapter.updateSettings(dataToSend, 
                    function(response, error){
                        if(error){
                            if(typeof callback != "undefined"){
                                callback(null,error)
                            }
                        }else{
                            if(typeof callback != "undefined"){
                                callback(response,null)
                            }
                        }
                })
            }


            function filterSelectedSite(site) {
                if(site.id == DefaultSite.id){
                    return false
                }
                else if(SitesService.isDefaultSiteSelected()){
                    return true
                }
                else{
                    return vm.selectedSite == site.id
                }
            }

        }

})();

/**
 * Created by alex on 05/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.rent.manage')
        .controller('ReservationManagerController', ReservationManagerController);

    /** @ngInject */
    function ReservationManagerController(RentBookingStatus,AliveReservations,$mdDialog,$document,ReservationAdapter,ShowToast,MiscUtility)
    {
        var vm = this;

        // Options

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the status column
                    targets: 4,
                    render : function (cellData, type, rowData, rowMeta)
                    {

                        // Get last order status
                        //var orderStatusId = vm.reservations[rowMeta.row].status;

                        var currentStatus = RentBookingStatus[cellData];

                        if ( type === 'display' )
                        {

                            return '<span class="status ' + currentStatus.color + '">' + currentStatus.name + '</span>';
                        }

                        if ( type === 'filter' )
                        {
                            return currentStatus.name;
                        }

                        return cellData;
                    }
                },
                 {
                 // Target the actions column
                 targets           : 9,
                 responsivePriority: 1,
                 filterable        : false,
                 sortable          : false
                 }
            ],
            initComplete: function () {

                var api = this.api();
                var searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        // Data

        function filterAliveReservations(aliveReservations,ServiceSettings){

            vm.aliveReservations = [];

            var pastReservations = 0;

            var todayDate = null;
            ServiceSettings.getServiceSettings(function(settings){
                if(settings.loaded) {
                    todayDate = MiscUtility.serviceTodayDate();
                }
            });


            vm.aliveReservations = aliveReservations;

            /*aliveReservations.forEach(function (reservation) {

                if(reservation.start >= todayDate){

                    vm.aliveReservations.push(reservation)
                }else{
                    pastReservations++;
                }
            });*/

            console.log("Past reservations hided",pastReservations)
        }

        filterAliveReservations(AliveReservations);

        // Methods
        vm.openAssignVehicleDialog = openAssignVehicleDialog;
        vm.refreshAliveReservations = refreshAliveReservations;
        vm.deleteAliveReservation = deleteAliveReservation;

        //////////

        function refreshAliveReservations() {

            ReservationAdapter.getAliveReservations(
                function (aliveReservations,error) {

                    if(!error){

                        filterAliveReservations(aliveReservations);
                    }
            })
        }

        function deleteAliveReservation (aliveReservation,index){

            var reservationId = aliveReservation.id;

            if(reservationId){

                ReservationAdapter.deleteReservation(reservationId,
                    function (data,error) {
                        if(!error){

                            vm.aliveReservations.splice(index,1)
                        }
                        else {
                            ShowToast.only("Error deleting reservation,retry")
                        }
                    })
            }
        }

        function openAssignVehicleDialog(aliveReservation,event) {

            $mdDialog.show({
                controller         : 'AssignVehicleDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/rent/manage/dialogs/assign-vehicle-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : event,
                //clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        AliveReservation : aliveReservation,
                        AliveReservations: vm.aliveReservations
                    }
                }
            })
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.rent.gantt-chart')
        .controller('GanttChartController', GanttChartController);

    /** @ngInject */
    function GanttChartController($mdDialog, $document, $animate, $scope, $timeout, GanttObjectModel, ganttDebounce, moment, $window, $mdSidenav,CurrentNewRentalBooking,CurrentNewUser,GanttAdapter,RentalBookingType,RentalBookingColor,ServiceSettings, MiscUtility)
    {
        var vm = this;
        /**
         * 
         * 
         * 
         * 
         * 
         * 
         * THIS SECTION NEEDS TO BE UDPATED TO USE MOMENTJS INSTEAD OF THE TODATE() methods
         * 
         * 
         * 
         * 
         * 
         * 
         * 
         * 
         * 
         */

        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })
        
        var objectModel;

        //my code: handle columns in gantt table

        var COLUMNS = [
            {
            'columnsModel':'model.class',
            'columnsHeader':'Class'
            },
            {'columnsModel':'model.name',
                'columnsHeader':'Vehicle'}
            ,
            {'columnsModel':'model.washed',
                'columnsHeader':'Washed'}
            ,/*
            {'columnsModel':'model.address',
                'columnsHeader':'Address'}
            ,*/
            {'columnsModel':'model.status',
                'columnsHeader':'Status'}
            ,
            {'columnsModel':'model.km',
                'columnsHeader':'Km'}
            ,
            {'columnsModel':'model.fuel_level',
                'columnsHeader':'Fuel'}
            /*,
            {'columnsModel':'from',
                'columnsHeader':'Start Time'}
            ,
            {'columnsModel':'to',
                'columnsHeader':'End Time'}*/
        ];

        var columnsModels = [];
        var columnsHeaders = {};
        var columnsClasses = {};

        function initGanttTable () {

            var currentModel;
            for (var i = 0; i < COLUMNS.length; i++) {

                currentModel = COLUMNS[i].columnsModel;

                columnsModels.push(currentModel);
                columnsHeaders[currentModel] = COLUMNS[i].columnsHeader;
                columnsClasses[currentModel] = 'gantt-column-name'
            }
        }
        initGanttTable();

        var todayDate = MiscUtility.serviceTodayDate();
        var fromDate = moment(todayDate).tz(vm.timezone).subtract(15, 'days').toDate();
        var toDate = moment(todayDate).tz(vm.timezone).add(3, 'months').toDate();

        //end my code


        // Data
        
        vm.live = {};
        vm.options = {
            mode                    : 'custom',
            scale                   : 'day',
            sortMode                : undefined,
            sideMode                : 'Table',
            daily                   : true,
            maxHeight               : 300,
            width                   : true,
            zoom                    : 1,
            rowSortable             : true,
            columns                 : columnsModels,

                //['model.class','model.name','model.description','model.vcs','model.park','model.status','model.km','model.gas'/*,'from', 'to'*/],

            treeTableColumns        : ['from', 'to'],
            columnsHeaders          : columnsHeaders ,

                /*{
                    'model.class': "Class",
                    'model.name': 'Vehicle',
                    'model.description': "Description",
                    'model.vcs': "vcs",
                    'model.park': "park",
                    'model.status': "status",
                    'model.km': "km",
                    'model.gas': "gas"/*,
                    'from'      : 'Start Time',
                    'to'        : 'End Time'
                }*/

            columnsClasses          : columnsClasses, /*{

                'model.class': 'gantt-column-name',
                    'model.name': 'gantt-column-name',
                    'model.description': 'gantt-column-name',
                    'model.washed': 'gantt-column-name',
                    'model.park': 'gantt-column-name',
                    'model.status': 'gantt-column-name',
                    'model.km': 'gantt-column-name',
                    'model.gas': 'gantt-column-name'/*,
                    'from'      : 'gantt-column-from',
                    'to'        : 'gantt-column-to'
                },*/

            columnsFormatters       : {
                'from': function (from)
                {
                    return angular.isDefined(from) ? from.format('MMM DD, HH:mm') : undefined;
                },
                'to'  : function (to)
                {
                    return angular.isDefined(to) ? to.format('MMM DD, HH:mm') : undefined;
                }
            },
            treeHeaderContent       : '{{getHeader()}}',
            columnsHeaderContents   : {
                'model.class': '{{getHeader()}}',
                'model.name': '{{getHeader()}}',
                'from'      : '{{getHeader()}}',
                'to'        : '{{getHeader()}}'
            },
            autoExpand              : 'both',
            taskOutOfRange          : 'truncate',
            fromDate                : fromDate,
            toDate                  : toDate,
            rowContentEnabled       : true,
            rowContent              : '{{row.model.name}}',
            taskContentEnabled      : true,
            taskContent             :
                '<i ng-click="scope.vm.editDialog($event, \'task\',task, row)" class="gantt-task-edit-button icon-pencil s12 icon"\n aria-label="edit task">\n</i>' +
                '\n<span class="gantt-task-name">\n{{task.model.name}}\n' +
                    '<md-tooltip md-direction="top" class="gantt-chart-task-tooltip">\n ' +
                        '<div layout="column" layout-align="center center">\n ' +
                            '<div class="tooltip-name">\n{{task.model.name}}\n</div>\n' +
                            '<div class="tooltip-date">\n' +
                                '<span>\n{{task.model.from.format(\'MMM DD, HH:mm\')}}\n</span>\n' +
                                '<span>-</span>\n' +
                                '<span>\n{{task.model.to.format(\'MMM DD, HH:mm\')}}\n</span>\n' +
                            '</div>\n' +
                        '</div>\n' +
                    '</md-tooltip>\n' +
                '</span>',
            allowSideResizing       : true,
            labelsEnabled           : true,
            currentDate             : 'line',
            currentDateValue        : moment.tz(vm.timezone).toDate(),
            draw                    : true,
            readOnly                : false,
            groupDisplayMode        : 'group',
            filterTask              : '',
            filterRow               : '',
            timeFrames              : {
                'day'    : {
                    start  : moment('8:00', 'HH:mm'),
                    end    : moment('20:00', 'HH:mm'),
                    working: true,
                    default: true
                },
                'noon'   : {
                    start  : moment('12:00', 'HH:mm'),
                    end    : moment('13:30', 'HH:mm'),
                    working: false,
                    default: true
                },
                'weekend': {
                    working: false
                },
                'holiday': {
                    working: false,
                    color  : 'red',
                    classes: ['gantt-timeframe-holiday']
                }
            },
            dateFrames              : {
                'weekend'    : {
                    evaluator: function (date)
                    {
                        return date.isoWeekday() === 6 || date.isoWeekday() === 7;
                    },
                    targets  : ['weekend']
                },
                '11-november': {
                    evaluator: function (date)
                    {
                        return date.month() === 10 && date.date() === 11;
                    },
                    targets  : ['holiday']
                }
            },
            timeFramesWorkingMode   : 'hidden',
            timeFramesNonWorkingMode: 'visible',
            columnMagnet            : '15 minutes',
            timeFramesMagnet        : true,
            dependencies            : true,
            canDraw                 : function (event)
            {
                var isLeftMouseButton = event.button === 0 || event.button === 1;
                return vm.options.draw && !vm.options.readOnly && isLeftMouseButton;
            },
            drawTaskFactory         : function ()
            {
                return {
                    id   : 1,//ganttUtils.randomUuid(),  // Unique id of the task.
                    stubReservation : true,
                    name : '', // Name shown on top of each task.
                    //color: '#AA8833',//'#284678'//'#AA8833' // Color of the task in HEX format (Optional).,
                    classes : [RentalBookingColor.NOT_SAVED]
                };
            },
            api                     : function (ganttApi)
            {
                // API Object is used to control methods and events from angular-gantt.
                vm.api = ganttApi;

                vm.api.core.on.ready($scope, function ()
                {
                    // When gantt is ready, load data.
                    // `data` attribute could have been used too.
                    vm.load();

                    // DOM events
                    vm.api.directives.on.new($scope, function (directiveName, directiveScope, element)
                    {
                        /**
                         * Gantt Task
                         */
                        if ( directiveName === 'ganttTask' )
                        {
                            /*element.on('mousedown touchstart', function (event)
                            {
                                console.log("task1");
                                event.preventDefault();
                                event.stopPropagation();

                                vm.live.row = directiveScope.task.row.model;

                                if ( angular.isDefined(directiveScope.task.originalModel) )
                                {
                                    vm.live.task = directiveScope.task.originalModel;
                                }
                                else
                                {
                                    vm.live.task = directiveScope.task.model;
                                }
                                $scope.$digest();
                            });*/

                        }

                        /**
                         * Gantt Row
                         */
                        else if ( directiveName === 'ganttRow' )
                        {

                            element.on('click', function (event)
                            {
                                event.stopPropagation();
                            });

                            /*element.on('mousedown touchstart', function (event)
                            {
                                console.log("task2");
                                event.stopPropagation();

                                vm.live.row = directiveScope.row.model;

                                $scope.$digest();
                            });*/

                        }

                        /**
                         * Gantt Row Label
                         */
                        else if ( directiveName === 'ganttRowLabel' )
                        {
                            // Fix for double trigger due to gantt-sortable plugin
                            element.off('click');

                            element.on('click', function (event)
                            {
                                event.preventDefault();

                                //editDialog(event, 'row', directiveScope.row,null);
                            });

                            element.on('mousedown touchstart', function ()
                            {
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }
                    });

                    vm.api.tasks.on.rowChange($scope, function (task)
                    {
                        vm.live.row = task.row.model;
                    });

                    vm.api.tasks.on.draw($scope,function (newTask) {

                        var rowTasks = newTask.row.model.tasks;

                        var newTaskFromDateTime = moment(newTask.model.from).tz(vm.timezone).valueOf();
                        var newTaskToDateTime = moment(newTask.model.to).tz(vm.timezone).valueOf();
                        var currentTaskFromDate,currentTaskFromDateTime,currentTaskToDateTime;

                        var taskOverlapped;
                        var rowTaskLength = rowTasks.length;

                        rowTasks.forEach(function (currentTask,index) {

                            currentTaskFromDate = moment(currentTask.from).tz(vm.timezone).toDate();//create a temp date to prevent time issue when comparing two dates

                            currentTaskFromDateTime = moment(currentTaskFromDate).tz(vm.timezone).valueOf();

                            currentTaskToDateTime = moment(currentTask.to).tz(vm.timezone).valueOf();

                            if( newTaskFromDateTime < currentTaskFromDateTime && newTaskToDateTime >= currentTaskFromDateTime){

                                taskOverlapped = currentTask;

                            }

                            if(taskOverlapped){
                                if(currentTask.id == newTask.model.id){//if current task is new task
                                    newTask.taskOverlapped = true;
                                    rowTasks.splice(index,1); //delete new task
                                    $scope.$apply();
                                }
                            }

                        })


                    });

                    vm.api.tasks.on.drawEnd($scope,function (newTask) {

                        //open editDialog on drawTask
                        if(!newTask.taskOverlapped){
                            newTask.taskOverlapped = false;
                            editDialog(null,'task',newTask,newTask.row);
                        }
                    })


                    objectModel = new GanttObjectModel(vm.api);
                });


            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.search = search;
        vm.setSortMode = setSortMode;
        vm.addDialog = addDialog;
        vm.editDialog = editDialog;
        vm.canAutoWidth = canAutoWidth;
        vm.getColumnWidth = getColumnWidth;
        vm.load = load;
        vm.reload = reload;

        //////////

        vm.checkDate = function (string) {


            if(string == 'from'){

                if(vm.options.fromDate.getTime() >= vm.options.toDate.getTime()) {
                    console.log("from")
                    var fromDate = vm.options.fromDate;
                    vm.options.toDate = moment(fromDate).tz(vm.timezone).add(3, 'months').toDate();
                    //vm.options.toDate.setMonth(vm.options.toDate.getMonth() + 3)
                }
            }
            else if(string == 'to'){

                if(vm.options.toDate.getTime() <= vm.options.fromDate.getTime()) {
                    console.log("to")
                    var toDate = vm.options.toDate;
                    vm.options.fromDate = moment(toDate).tz(vm.timezone).subtract(3, 'months').toDate();
                    //vm.options.fromDate.setMonth(vm.options.fromDate.getMonth() - 3)
                }
            }

            console.log(vm.options.fromDate,'to',vm.options.toDate);
        }

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Set Gantt Chart height at the init
            calculateHeight();

            angular.element($window).on('resize', function ()
            {
                $scope.$apply(function ()
                {
                    calculateHeight();
                });
            });

            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    // vm.timezone = ServiceSettings.getSiteTimezone(siteId);
                }
            });
        }

        /**
         * Max Height Fix
         */
        function calculateHeight()
        {
            vm.options.maxHeight = $document.find('#chart-container').offsetHeight;
        }

        /**
         * Add New Row
         */
        function addDialog(ev)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/rent/gantt-chart/dialogs/add-edit/add-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                //clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'add'
                    }
                }
            });
        }

        /**
         * Edit Dialog
         */
        function editDialog(ev, formView, formData, rowData)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/rent/gantt-chart/dialogs/add-edit/edit-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'edit',
                        formView  : formView, //task or row
                        formData  : formData, //task or row
                        rowData: rowData  //row
                    }
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         * @param sidenavId
         */
        function search(option, keyword)
        {
            if ( option === 'rows' )
            {
                vm.options.filterRow = keyword;
            }
            else if ( option === 'tasks' )
            {
                vm.options.filterTask = keyword;
            }
        }

        /**
         * Sort Mode
         * @param mode
         */
        function setSortMode(mode)
        {
            vm.options.sortMode = mode;

            if ( angular.isUndefined(mode) )
            {
                vm.options.rowSortable = true;
            }
            else
            {
                vm.options.rowSortable = false;
            }
        }

        /**
         * Side Mode
         */
        $scope.$watch('vm.options.sideMode', function (newValue, oldValue)
        {
            if ( newValue !== oldValue )
            {
                vm.api.side.setWidth(undefined);

                $timeout(function ()
                {
                    vm.api.columns.refresh();
                });
            }
        });

        function canAutoWidth(scale)
        {
            if ( scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/) )
            {
                return false;
            }

            return true;
        }

        function getColumnWidth(widthEnabled, scale, zoom)
        {
            if ( !widthEnabled && vm.canAutoWidth(scale) )
            {
                return undefined;
            }

            if ( scale.match(/.*?week.*?/) )
            {
                return 150 * zoom;
            }

            if ( scale.match(/.*?month.*?/) )
            {
                return 300 * zoom;
            }

            if ( scale.match(/.*?quarter.*?/) )
            {
                return 500 * zoom;
            }

            if ( scale.match(/.*?year.*?/) )
            {
                return 800 * zoom;
            }

            return 40 * zoom;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value) {
            return this.filter(function (x) {
                return x.id === value;
            })[0];
        };

        function addCurrentRentalBookingInGantt(currentRentalBooking) {

            //check if currentRentalBooking exists in Gantt data
            var rowTasks = vm.data.getById(currentRentalBooking.vehicle).tasks;

            rowTasks.forEach(function (task,index) {

                if( (task.id != currentRentalBooking.id) && (index == rowTasks.length-1)){

                    console.log("in addCurrentRentalBookingInGantt not found task")
                    rowTasks.push(currentRentalBooking)
                }
            });
        }

        // Reload data action
        function load() {

            GanttAdapter.getGanttReservations(function (rentalBookings,error) {

                if(!error){

                    vm.data = rentalBookings;

                    vm.data.forEach(function (row) {

                        row.tasks.forEach(function (task) {

                            if( task.type == RentalBookingType.RESERVATION){
                                task.classes = [RentalBookingColor.RESERVATION]
                            }else if(task.type == RentalBookingType.RENTAL_AGREEMENT){
                                task.classes = [RentalBookingColor.RENTAL_AGREEMENT]
                            }

                        })

                    })

                    //check if the admin was adding a rentalBooking
                    var currentNewRentalBooking = CurrentNewRentalBooking.getData();
                    var currentNewUser = CurrentNewUser.getData();

                    if( currentNewRentalBooking && currentNewUser) {

                        console.log("currentNewRentalBooking exist,new user case, open task dialog");


                        //add rentalBooking to Gantt data because it not exist
                        addCurrentRentalBookingInGantt(currentNewRentalBooking);

                        //open dialog (event,formView,taskData,rowData)
                        editDialog(null,'task',currentNewRentalBooking,{});

                        //clear CurrentNewRentalBooking
                        CurrentNewRentalBooking.clear();
                        console.log("CurrentNewRentalBooking cleared",CurrentNewRentalBooking.getData());

                        CurrentNewUser.clear();
                        console.log("CurrentNewUser cleared", CurrentNewUser.getData());

                    }else if(currentNewRentalBooking){

                        //case rentalBooking in gantt data exists
                        console.log("currentNewRentalBooking exist, open task dialog");

                        addCurrentRentalBookingInGantt(currentNewRentalBooking);

                        //open dialog (event,formView,taskData,rowData)
                        editDialog(null,'task',currentNewRentalBooking,{});

                        //clear CurrentNewRentalBooking
                        CurrentNewRentalBooking.clear();
                        console.log("CurrentNewRentalBooking cleared",CurrentNewRentalBooking.getData());
                    }
                }
            });


            //vm.timespans = Timespans.data;

            // Fix for Angular-gantt-chart issue
            $animate.enabled(true);
            $animate.enabled($document.find('#gantt'), false);

        }

        /**
         * Reload Data
         */
        function reload()
        {

            load();

            /*msApi.resolve('ganttChart.tasks@get', function (response)
            {
                vm.data = response.data;
            });

            msApi.resolve('ganttChart.timespans@get', function (response)
            {
                vm.timespans = response.data;
            });*/

        }

        // Visual two way binding.
        var ganttDebounceValue = 1000;

        var listenTaskJson = ganttDebounce(function (taskJson)
        {
            if ( angular.isDefined(taskJson) )
            {
                var task = angular.fromJson(taskJson);
                objectModel.cleanTask(task);
                var model = vm.live.task;
                angular.extend(model, task);
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.taskJson', listenTaskJson);

        var listenRowJson = ganttDebounce(function (rowJson)
        {
            if ( angular.isDefined(rowJson) )
            {
                var row = angular.fromJson(rowJson);
                objectModel.cleanRow(row);
                var tasks = row.tasks;

                delete row.tasks;
                var rowModel = vm.live.row;

                angular.extend(rowModel, row);

                var newTasks = {};
                var i, l;

                if ( angular.isDefined(tasks) )
                {
                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        objectModel.cleanTask(tasks[i]);
                    }

                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        newTasks[tasks[i].id] = tasks[i];
                    }

                    if ( angular.isUndefined(rowModel.tasks) )
                    {
                        rowModel.tasks = [];
                    }

                    for ( i = rowModel.tasks.length - 1; i >= 0; i-- )
                    {
                        var existingTask = rowModel.tasks[i];
                        var newTask = newTasks[existingTask.id];

                        if ( angular.isUndefined(newTask) )
                        {
                            rowModel.tasks.splice(i, 1);
                        }
                        else
                        {
                            objectModel.cleanTask(newTask);
                            angular.extend(existingTask, newTask);

                            delete newTasks[existingTask.id];
                        }
                    }
                }
                else
                {
                    delete rowModel.tasks;
                }

                angular.forEach(newTasks, function (newTask)
                {
                    rowModel.tasks.push(newTask);
                });
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.rowJson', listenRowJson);

        $scope.$watchCollection('vm.live.task', function (task)
        {
            vm.live.taskJson = angular.toJson(task, true);
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });

        $scope.$watchCollection('vm.live.row', function (row)
        {
            vm.live.rowJson = angular.toJson(row, true);
            if ( angular.isDefined(row) && angular.isDefined(row.tasks) && row.tasks.indexOf(vm.live.task) < 0 )
            {
                vm.live.task = row.tasks[0];
            }
        });

        $scope.$watchCollection('vm.live.row.tasks', function ()
        {
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });


    }

})();

/**
 * Created by Alex on 23/12/16.
 */

(function () {

    'use strict';

    angular.module('app.rent.gantt-chart')
        .factory("GanttAdapter",GanttAdapter);

    /** @ngInject */
    function GanttAdapter($http,AppSettings) {

        function getGanttReservations(completionHandler) {

            var x = "app/data/gantt-chart/tasks.json";

            $http.get(AppSettings.getBaseUrl() + '/api/rent/gantt')
                .then(function success(response) {

                    console.log("success in GanttAdapter.getGanttReservations");

                    completionHandler(response.data.data,null);
                },
                function error(response) {

                    var error = response.data.error;

                    console.log("error in GanttAdapter.getGanttReservations",error,response);

                    completionHandler(null,error);

                }
            )
        }

        return{

            getGanttReservations : getGanttReservations
        }

    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {

        $stateProvider
            .state('app.pages_rentalAgreement_invoice', {
                url      : '/invoice/rental-agreement',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/rentalAgreement/rentalAgreement.html',
                        controller : 'RentalAgreementInvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi) {
                        //only for testing
                        return msApi.resolve('invoice@get');
                    },
                    RentalAgreement: function ($stateParams,RentalAgreementAdapter,$q,$timeout) {

                        var rentalAgreementId = $stateParams.rentalAgreement.id;
                        console.log("before $stateParams.rentalAgreement")

                        if($stateParams.rentalAgreement == null){

                            console.log("after $stateParams.rentalAgreement,case null")

                            var deferred = $q.defer();

                            $timeout(function () {

                                deferred.reject();

                                $state.go('app.rent.gantt-chart')
                            });

                            return deferred.promise;
                        }
                        else {
                            return RentalAgreementAdapter.getRentalAgreement(rentalAgreementId);
                        }
                    }
                },
                params:{
                    rentalAgreement: null
                },
                bodyClass: 'invoice printable'
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');

        // Api
        msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);

        /* Navigation
        msNavigationServiceProvider.saveItem('pages.invoice', {
            title : 'Invoice',
            icon  : 'icon-receipt',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('pages.invoice.modern', {
            title : 'Modern',
            state : 'app.pages_invoice_modern'
        });

        msNavigationServiceProvider.saveItem('pages.invoice.compact', {
            title : 'Compact',
            state : 'app.pages_invoice_compact'
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('RentalAgreementInvoiceController', RentalAgreementInvoiceController);

    /** @ngInject */
    function RentalAgreementInvoiceController($scope,Invoice,RentalAgreement, DocumentTypes,ServiceSettings,MiscUtility,SitesService)
    {
        var vm = this;
        
        // Data
        vm.invoice = Invoice.data;
        vm.rentalAgreement = RentalAgreement;

        vm.documentTypes = DocumentTypes;

        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })
        
        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    SitesService.getSites(function(){
                        vm.selectedSiteId = SitesService.getSelectedSite()    
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                    })
                }
            });
        }
        init()

        // Methods

        vm.getDocumentType = function (type){
            for (var key in vm.documentTypes) {
                if (type == vm.documentTypes[key].value)
                    return vm.documentTypes[key].name
            }

            return "Unknown";
        };

        vm.printRentalAgreement = function () {

            var printContents = document.getElementById('invoice-container').innerHTML;
            var popupWin = window.open('', '', 'width=1000,height=1000');
            popupWin.document.open();
            popupWin.document.write('<html><head></head><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();

        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.maintenance', [
            "app.maintenance.detail"
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.maintenance',{
                url  : '/maintenance',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/maintenance/maintenance-list.html',
                        controller : 'MaintenanceController as vm'
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/vehicle');

        msNavigationServiceProvider.saveItem('Maintenance', {
            title: 'Maintenance',
            icon : 'icon-timetable',
            state: 'app.maintenance',
            weight: 25
        });



    }
})();
(function(){
    'use strict';

    angular.module("app.maintenance")
        .controller("AddMaintenanceRecordDialogController",AddMaintenanceRecordDialogController)

        /** @ngInject */
        function AddMaintenanceRecordDialogController($scope,$state,$mdDialog, VehicleSharingAdapter, MaintenanceAdapter,MaintenanceType,MaintenanceCategory,MaintenanceUtility,ErrorUtility){
            var vm = this
            vm.vehicles = []

            vm.maintenanceType = MaintenanceType
            vm.maintenanceCategories = MaintenanceCategory

            vm.dataToSend = {
                status: 0,
                description: "",
                eta: 0,
                category: 0,
                type: 0,
                vehicle: -1
            }


            VehicleSharingAdapter.getVehicles(function(vehicles,error){
                if(!error){
                    vm.vehicles = vehicles
                    console.log("vehicles",vm.vehicles)
                }else{
                    console.log(error)
                }
            })

            vm.closeDialog = closeDialog
            vm.callAddRecord = callAddRecord
            vm.getTypeText = getTypeText
            vm.filterNotMaintenance = filterNotMaintenance

            vm.querySearch   = querySearch;
            vm.selectedItemChange = selectedItemChange;
            vm.searchTextChange   = searchTextChange;

            function callAddRecord(){
                console.log("vm.dataToSend",vm.dataToSend)

                if(vm.dataToSend.vehicle != -1){
                    MaintenanceAdapter.addRecord(vm.dataToSend, function(record, error){
                        if(!error){
                            closeDialog()
                            $state.go("app.maintenance.detail",{maintenanceId: record.id})
                        }else{
                            ErrorUtility.showErrorMessage({title:'Add Maintenance record',description:'Error while adding the maintenance record!'})
                        }
                    })
                }
            }


            function querySearch (query) {
                if(vm.vehicles.length>0){
                    var results = query ? vm.vehicles.filter( createFilterFor(query) ) : vm.vehicles

                    return results;
                }
                else
                    return []

            }

            /**
             * Create filter function for a query string
             */
            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);

                return function filterFn(vehicle) {
                    return (vehicle.reference_code.toLowerCase().indexOf(lowercaseQuery) != -1) || (vehicle.license_plate.toLowerCase().indexOf(lowercaseQuery) != -1);
                };

            }

            function selectedItemChange(vehicle) {
                console.log("item changed",vehicle)
                vm.dataToSend.vehicle = vehicle.id
            }

            function searchTextChange(text) {
                console.log("search text changed",text)
            }

            function getTypeText(record) {
                return MaintenanceUtility.getMaintenanceTypeDescription(record)
            }

            function filterNotMaintenance(value){
                return !value.inMaintenance
            }

            function closeDialog() {
                $mdDialog.hide()
            }
        }
})();
(function ()
{
    'use strict';

    angular
        .module('app.maintenance.detail', [

        ])
        .config(config)

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.maintenance.detail',{
                url  : '/info',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/maintenance/details/maintenance-details.html',
                        controller : 'MaintenanceDetailController as vm'
                    }
                },
                params:{maintenanceId:null}
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/vehicle');
    }
})();
(function(){
    'use strict';

    angular.module("app.maintenance.detail")
        .controller("MaintenanceDetailController", MaintenanceDetailController)

        /** @ngInject */
        function MaintenanceDetailController($scope, MaintenanceAdapter, $stateParams, $state, UserService, SessionStorageService,LocalStorageService,MiscData,MaintenanceUtility,MaintenanceStatus,MaintenanceType,MaintenanceCategory,SweetAlert) {
            
            var vm = this

            vm.userId = UserService.currentUserId ? UserService.currentUserId : SessionStorageService.getItem(MiscData.USERID)
            console.log("User id", UserService ,vm.userId, UserService.currentUserId)
            vm.record = {}
            vm.comments = []
            vm.newComment = {description: null}
            vm.disableEditMaintenanceDetails = true
            var recordBeforeChanges = null
            vm.maintenanceStatus = MaintenanceStatus
            vm.maintenanceType = MaintenanceType
            vm.maintenanceCategories = MaintenanceCategory

            var maintenanceId = $stateParams.maintenanceId

            vm.refreshRecord = getRecord
            vm.addComment = addComment
            vm.checkForEnterAndSendComment = checkForEnterAndSendComment
            vm.getTypeText = getTypeText
            vm.getStatusText = getStatusText
            vm.updateRecord = updateRecord
            vm.advanceStatus = advanceStatus
            vm.goBackAStatus = goBackAStatus
            vm.blockMaintenance = blockMaintenance
            vm.closeMaintenance = closeMaintenance
            vm.unblockMaintenance = unblockMaintenance
            vm.enableMaintenanceDetailsChange = enableMaintenanceDetailsChange
            vm.disableMaintenanceDetailsChange = disableMaintenanceDetailsChange
            vm.goBack = goBack

            $scope.$on('$viewContentLoaded',function(event){

                if(maintenanceId == null){

                    console.log('page refreshed')
                    try{
                        maintenanceId = LocalStorageService.getItem('detailsId')

                        if(maintenanceId && maintenanceId != '') {
                            getRecord()
                            getRecordComments()
                        }
                        else{
                            return $state.go("app.maintenance")
                        }
                    }
                    catch (err){
                        console.log("No localStorage to use for get detailsId")
                        return $state.go("app.maintenance")
                    }
                }
                else {
                    try{
                        LocalStorageService.setItem('detailsId',maintenanceId)
                        getRecord()
                        getRecordComments()
                    }
                    catch (err){
                        console.log("No localStorage to use for store detailsId")
                        getRecord()
                        getRecordComments()
                    }
                }

            })

            $scope.$on('$destroy',function (event) {
                try{
                    LocalStorageService.removeItem('detailsId')
                }
                catch (err){

                }
            })


            function advanceStatus(){
                updateRecordStatus(vm.record.status + 1)
            }

            function goBackAStatus(){
                updateRecordStatus(vm.record.status - 1)
            }

            function blockMaintenance(){
                updateRecordStatus(3)
            }

            function unblockMaintenance(){
                updateRecordStatus(1)
            }

            function closeMaintenance(){
                MaintenanceAdapter.finishRecord(vm.record.id, function(status, error){
                    if(!error){
                        $state.go("app.maintenance")
                    }else{
                        console.log(error)
                    }
                })
            }

            function updateRecord() {
                var dataToSend = {
                    description: vm.record.description,
                    type: vm.record.type,
                    status: vm.record.status,
                    category: vm.record.category
                }
                console.log("dataToSend",dataToSend)

                MaintenanceAdapter.updateRecord(vm.record.id, dataToSend , function(status, error){
                    if(!error){
                        recordBeforeChanges = null
                        vm.disableEditMaintenanceDetails = true
                    }else{
                        console.log(error)
                        SweetAlert.swal("Update maintenance record", "error updating info", "error");
                        vm.record = recordBeforeChanges
                        vm.disableEditMaintenanceDetails = true
                    }
                })
            }

            function updateRecordStatus(toStatus){
                MaintenanceAdapter.updateRecord(vm.record.id, {status: toStatus}, function(status, error){
                    if(!error){
                        vm.record.status = toStatus
                    }else{
                        console.log(error)
                    }
                })
            }

            function getRecord(){

                if(!maintenanceId){ console.error("Param id not found"); return }
                MaintenanceAdapter.getRecord(maintenanceId, function(record, error){
                    if(!error){
                        vm.record = record
                        console.log("record",vm.record)
                    }else{
                        console.log(error)
                    }
                })
            }

            function getRecordComments(){
                if(!maintenanceId){ console.error("Param id not found"); return }
                MaintenanceAdapter.getRecordComments(maintenanceId, function(comments, error){
                    if(!error){
                        vm.comments = comments
                    }else{
                        console.log(error)
                    }
                })
            }

            function addComment(){
                if(!vm.newComment.description || vm.newComment.description == ""){ return }
                MaintenanceAdapter.addCommentToRecord(maintenanceId, vm.newComment, function(response, error){
                    if(!error){
                        getRecordComments()
                        vm.newComment.description = null
                    }else{
                        console.log(error)
                    }
                })
            }

            function checkForEnterAndSendComment(event){
                if(event.keyCode == 13){ addComment() }
            }

            function getStatusText(record){
                return MaintenanceUtility.getMaintenanceStatusDescription(record)
            }

            function getTypeText(record) {
                return MaintenanceUtility.getMaintenanceTypeDescription(record)
            }

            function enableMaintenanceDetailsChange() {
                vm.disableEditMaintenanceDetails = !vm.disableEditMaintenanceDetails;
                recordBeforeChanges = angular.copy(vm.record);
            }

            function disableMaintenanceDetailsChange() {
                vm.disableEditMaintenanceDetails = !vm.disableEditMaintenanceDetails;
                vm.record = angular.copy(recordBeforeChanges);
            }

            function goBack(){
                $state.go("app.maintenance")
            }
        }

})();
/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.invoice')
        .controller('ManageInvoiceDialogController', ManageInvoiceDialogController)

    /** @ngInject */
    function ManageInvoiceDialogController($scope,SweetAlert,$q,$timeout,$mdDialog,Invoice,dialogType,InvoiceType,InvoiceElementType,InvoicesAdapter,UserAdapter,MiscUtility,ErrorUtility,FiltersRequestParamFactory){

        $scope.searchText = ""
        $scope.selectedUser = null
        $scope.dialogTypes = {add:"add",edit:"edit"}
        $scope.invoice = null
        $scope.newInvoice = {price:0,description:"",newTotal: 0}

        $scope.dialogType = dialogType
        if(dialogType == "edit"){
            $scope.invoice = Invoice
            $scope.newInvoice.newTotal = Invoice.totalPrice
        }
        else{
        }
        console.log("dialogType",$scope.dialogType)
        console.log("curr invoice",Invoice)

        $scope.closeDialog = closeDialog
        $scope.updateTotalPrice = updateTotalPrice
        $scope.getCurrencyValue = MiscUtility.getCurrencyValue

        $scope.searchOptions = [
            { 
                name:'ID',
                key: 'id',
                filter: FiltersRequestParamFactory.createUserWithIdFilter,
                filterType: 'number',
                adapter: UserAdapter.getUsers
            },
            { 
                name:'E-Mail',
                key: 'email',
                filter: FiltersRequestParamFactory.createUserWithEmailFilter,
                filterType: 'string',
                adapter: UserAdapter.getUsers
            },
            { 
                name:'Full Name',
                key: 'fullName',
                filter: FiltersRequestParamFactory.createUserWithFullNameFilter,
                filterType: 'string',
                adapter: UserAdapter.getUsers
            }
        ];

        $scope.callAddInvoice = callAddInvoice
        $scope.callRectifyInvoice = callRectifyInvoice

        
        $scope.setUser = setUser;
        function setUser(user) {
            $scope.selectedUser = user
        }

        function callAddInvoice(){

            var deferred = $q.defer()

            if(!$scope.newInvoice.price || !$scope.newInvoice.description){
                SweetAlert.swal("Add Ticket","Please insert a valid input!","error")
                deferred.reject()

            }else{
                var dataToSend = {
                    userId: $scope.selectedUser.id,
                    type: InvoiceType.TICKET.value,
                    elements:[
                        {
                            price: $scope.newInvoice.price,
                            description: $scope.newInvoice.description,
                            type : InvoiceElementType.GENERIC
                        }
                    ]
                }
                
                console.log("dataToSend",dataToSend)
    
                InvoicesAdapter.addInvoice(dataToSend,function(data,error){
                    if(error){
                        ErrorUtility.showErrorMessage({title:"Add Ticket",description:"Error while adding a ticket!"})
                        deferred.reject(error)
                        
                    }
                    else{
                        SweetAlert.swal("Add Ticket","New ticket added!","success")
                        deferred.resolve(data)
                        closeDialog(true)
                    }
                })
            }

            return deferred.promise
        }

        function callRectifyInvoice(){
            var deferred = $q.defer()

            if(!$scope.newInvoice.price || !$scope.newInvoice.description){
                SweetAlert.swal("Rectify Ticket","Please insert a valid input!","error")
                deferred.reject()

            }else{

                var dataToSend= {
                    userId: $scope.invoice.UserId,
                    parentId: $scope.invoice.id,
                    type: InvoiceType.RECTIFIED_TICKET.value,
                    elements: [{
                        price : $scope.newInvoice.price,
                        description : $scope.newInvoice.description,
                        type: InvoiceElementType.GENERIC
                    }]
                }
                console.log(dataToSend)

                InvoicesAdapter.rectifyInvoice(dataToSend,
                    function(data,error){
                        if(error){
                            ErrorUtility.showErrorMessage({title: "Rectify Ticket", description: "There was an error while rectifying this ticket"})
                            deferred.reject(error)
                        }
                        else{
                            SweetAlert.swal("Rectify Ticket", "This ticket was successfully rectified!", 'success')
                            deferred.resolve(data)
                            closeDialog(true)
                        }
                    })
            }

            return deferred.promise
        }

        function updateTotalPrice(){
            if(typeof $scope.newInvoice.price == "number" && !Number.isNaN($scope.newInvoice.price)){
                var parsedTotalPrice = Invoice ? parseFloat(Invoice.totalPrice) : 0
                var totalPrice = parsedTotalPrice * 100
                var parsedNewPrice = parseFloat($scope.newInvoice.price)
                totalPrice += (parsedNewPrice * 100)
                $scope.newInvoice.newTotal = totalPrice / 100
            }
        }

        function closeDialog(value) {
            $mdDialog.hide(value)
        }
    }

})();

/**
 * Created by alex on 27/06/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.invoice.details',[])
        .config(config)
        .value("InvoiceDetailsPage","app.invoice.details");

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {

        $stateProvider
            .state('app.invoice.details',{
                url  : '/info',
                views: {
                    'content@app' : {
                        templateUrl: 'app/main/invoices/details/invoice-details.html',
                        controller : 'InvoiceDetailsController as vm'
                    }
                },
                resolve:{
                    Invoice: function (AppRequirements,$state,$q,$timeout,$stateParams,InvoicesAdapter,InvoicesListPage,LocalStorageService) {
                        var detailsId = ''

                        function goToInvoices() {
                            var deferred = $q.defer();
                            $timeout(function(){
                                $state.go(InvoicesListPage)
                                deferred.reject();
                            })
                            return deferred.promise;
                        }

                        //handle reload with localstorage
                        if($stateParams.invoice ==null){
                            console.log('page refreshed')
                            var detailsId = ''
                            try{
                                detailsId = LocalStorageService.getItem('detailsId')
                                if(detailsId && detailsId != '') {
                                    return InvoicesAdapter.getInvoice(detailsId)
                                }
                                else{
                                     return goToInvoices()
                                }
                            }
                            catch (err){
                                console.log("No localStorage to use for get detailsId")
                                return goToInvoices()
                            }
                        }
                        else {
                            detailsId = $stateParams.invoice.id
                            try{
                                LocalStorageService.setItem('detailsId',detailsId)
                                return InvoicesAdapter.getInvoice(detailsId)
                            }
                            catch (err){
                                console.log("No localStorage to use for store detailsId")
                                return InvoicesAdapter.getInvoice(detailsId)
                            }
                        }
                    }
                },
                params:{invoice:null}
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/invoices/details');
    }
})();

/**
 * Created by alex on 24/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.invoice.details')
        .controller('InvoiceDetailsController', InvoiceDetailsController);

    /** @ngInject */
    function InvoiceDetailsController($scope,ToHireDefaultColor,$state,Invoice,InvoiceType,InvoiceStatus,InvoiceUtility,InvoicesAdapter,SweetAlert,InvoicesListPage,InvoiceDetailsPage,UserDetailsPage,TripDetailsPage,VehicleDetailsPage,VehicleUtility, ServiceSettings,MiscUtility,ErrorUtility,SitesService) {

        var vm = this;
        
        vm.getCurrencyValue = MiscUtility.getCurrencyValue
        
        // Data
        vm.invoice = Invoice;
        vm.toHireDefaultColor = ToHireDefaultColor;
        vm.isBeforeTicketInvoice = (Invoice.type === InvoiceType.TICKET.value)
        console.log("current invoice",vm.invoice);
        console.log("isBeforeTicketInvoice",vm.isBeforeTicketInvoice);

        vm.invoiceType = InvoiceType;
        vm.invoiceStatus = InvoiceStatus;
        vm.invoiceUserType = {
            PRIVATE_USER:{value:0,name:"Private user"},
            COMPANY:{value:1,name:"Company"}
        }
        vm.disableEditInvoiceDetails = true;
        vm.totalPrice = 0
        vm.totalMinutes = 0
        var dataBeforeChanges = null

        generateUsefulData()

        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })
        
        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    SitesService.getSites(function(){
                        vm.todayDate = MiscUtility.serviceTodayDate(SitesService.getSelectedSite());
                    })
                }
            });
        }
        init()

        //clean localstorage from detailsid for refreshing page,when user clicks in another page
        $scope.$on('$destroy',function (event) {
            try{
                LocalStorageService.removeItem('detailsId')
            }
            catch (err){

            }
        })

        // Methods
        // vm.upgradeToInvoice = upgradeToInvoice

        vm.openDocument = openDocument
        vm.enableEditInvoiceTypeChange = enableEditInvoiceTypeChange
        vm.disableEditInvoiceTypeChange = disableEditInvoiceTypeChange
        vm.getInvoiceTypeDescription = getInvoiceTypeDescription
        vm.getInvoiceStatusDescription = getInvoiceStatusDescription
        vm.getVehicleShortAddress = getVehicleShortAddress
        vm.goToInvoicesPage = goToInvoicesPage
        vm.goToInvoiceDetailsPage = goToInvoiceDetailsPage
        vm.goToUserDetailsPage = goToUserDetailsPage
        vm.goToTripDetailsPage =goToTripDetailsPage
        vm.goToVehicleDetailsPage = goToVehicleDetailsPage

        function generateUsefulData() {
            vm.invoice.Booking.forEach(function (booking) {
                vm.totalPrice += booking.price
                booking.Trip.duration = parseInt((booking.Trip.end - booking.Trip.start)/60000)
                vm.totalMinutes += booking.Trip.duration
            })
            //init if null cause server
            if(!vm.invoice.additional_data)
                vm.invoice.additional_data = {user_type: vm.invoiceUserType.PRIVATE_USER.value}
        }

        // function upgradeToInvoice() {

        //     if(vm.isBeforeTicketInvoice){

        //         var dataToSend = {
        //             type: vm.invoiceType.INVOICE.value,
        //             additional_data:vm.invoice.additional_data
        //         }

        //         console.log("dataToSend",dataToSend)

        //         InvoicesAdapter.upgradeInvoiceType(vm.invoice.id,dataToSend,
        //             function (upgradedInvoice,error) {
        //                 if(!error){
        //                     console.log(upgradedInvoice)
        //                     SweetAlert.swal('Upgrade to Invoice','Successfully upgraded to invoice',"success")
        //                     vm.goToInvoiceDetailsPage(upgradedInvoice)
        //                 }
        //                 else {
        //                     ErrorUtility.showErrorMessage({title:'Upgrade to Invoice',description:'Error upgrading to invoice'})
        //                 }
        //         })
        //     }
        // }

        function openDocument() {
            if(vm.invoice.PDF[0])
                window.open(vm.invoice.PDF[0].location)
            else
                alert ('No document')
        }

        function enableEditInvoiceTypeChange() {
            vm.disableEditInvoiceDetails = false
            dataBeforeChanges = angular.copy(vm.invoice)
        }
        function disableEditInvoiceTypeChange() {
            vm.disableEditInvoiceDetails = true
            vm.invoice = dataBeforeChanges
        }

        function getInvoiceTypeDescription() {
            return InvoiceUtility.getInvoiceTypeDescription(vm.invoice)
        }
        function getInvoiceStatusDescription(invoice) {
            return InvoiceUtility.getInvoiceStatusDescription(invoice)
        }
        function getVehicleShortAddress(obj) {
            return VehicleUtility.getVehicleShortAddress(obj)
        }

        function goToInvoicesPage() {
            $state.go(InvoicesListPage)
        }
        function goToInvoiceDetailsPage(invoice) {
            $state.go(InvoiceDetailsPage,{invoice:invoice})
        }
        function goToUserDetailsPage(user) {
            $state.go(UserDetailsPage,{user:user})
        }
        function goToTripDetailsPage(trip) {
            $state.go(TripDetailsPage,{trip:trip})
        }
        function goToVehicleDetailsPage(vehicle) {
            $state.go(VehicleDetailsPage,{vehicle:vehicle})
        }
    }
})();

/**
 * Created by alex on 24/04/18.
 */
(function ()
{
    'use strict';
    angular
        .module('app.damage-report',[])
        .value("DamagesReportsListPage",'app.damage-report')
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.damage-report',{
                url: "/damages-reports",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/damage-report/damage-report-list.html',
                        controller : 'DamageReportListController as vm'
                    }
                }
            })

        // Navigation
        msNavigationServiceProvider.saveItem('damage-report', {
            title : 'Reports',
            icon  : 'icon-alert-box',
            state: "app.damage-report",
            weight: 10
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("damage-report")
        
        if(!active) {
            msNavigationService.deleteItem("damage-report")
        }
    }
})();

/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular
        .module('app.damage-report')
        .controller('DamageReportDetailsDialogController', DamageReportDetailsDialogController)

    /** @ngInject */
    function DamageReportDetailsDialogController($mdDialog,DamageReport,ServiceAdapter,ErrorUtility){

        var vm = this

        vm.currentDamageReport = DamageReport

        vm.selectDamageReportImage = selectDamageReportImage
        vm.closeDialog = closeDialog
        
        getDamageReport(DamageReport)

        function getDamageReport(dr) {
            ServiceAdapter.getDamage(dr.id,function (damageReport,error) {
                if(error){
                    ErrorUtility.showErrorMessage({title:'Get Report detail',description:'Error getting the report detail'})
                }else{
                    vm.currentDamageReport = damageReport
                    //open first image
                    selectDamageReportImage(0)
                }
            })
        }

        function selectDamageReportImage(index){
            vm.selectedDamageReportImage = {number:0,location:""}
            if(vm.currentDamageReport.media && vm.currentDamageReport.media.length>0){
                vm.selectedDamageReportImage.number = index
                vm.selectedDamageReportImage.location = vm.currentDamageReport.media[index].location
            }
        }

        function closeDialog(value) {

            $mdDialog.hide(value)

        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.coupon-legacy', ['app.coupon-legacy.details'])
        .value('CouponsListPage', 'app.coupon-legacy')
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.coupon-legacy', {
            url: '/coupon-legacy',
            views: {
                'content@app': {
                    templateUrl: 'app/main/coupon-legacy/coupons-list.html',
                    controller: 'CouponsController as vm',
                },
            },
        });

        // Navigation
        msNavigationServiceProvider.saveItem('coupon-legacy', {
            title: 'Coupons legacy',
            icon: 'icon-ticket',
            state: 'app.coupon-legacy',
            weight: 40,
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled('coupon-legacy');

        if (!active) {
            msNavigationService.deleteItem('coupon-legacy');
        }
    }
})();

/**
 * Created by alex on 28/06/17.
 */

(function () {
    'use strict';

    angular // this is for formatting
        .module('app.coupon-legacy')
        .controller('CouponAddDialogController', CouponAddDialogController);

    /** @ngInject */
    function CouponAddDialogController(
        $scope,
        SweetAlert,
        $mdDialog,
        CouponsAdapter,
        CouponType,
        ServiceSettings,
        MiscUtility,
        ErrorUtility,
        SitesService,
        ServiceData,
        CouponUtility
    ) {
        var vm = this;

        vm.closeDialog = closeDialog;
        vm.addCoupon = addCoupon;
        vm.couponTypes = CouponType;

        vm.newCoupon = {
            name: null,
            unlimited_join: false,
            unlimited_finish: false,
            join_count: 0,
            finish: null,
            start: null,
            type: null,
            value: null,
            code: null,
            cashback: null,
        };

        $scope.$on('refreshServiceSettings', function (event) {
            init();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    SitesService.getSites(function () {
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        vm.timezone = ServiceSettings.getSiteTimezone(vm.selectedSiteId);
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                    });
                }
            });
        }
        init();

        function validateCoupon(coupon) {
            var isValid = true;
            var message = '';
            if (!coupon.name || !coupon.code || !coupon.start) {
                isValid = false;
                message = 'Check Fields: Name, Code, From Date';
            } else if (!coupon.finish && !coupon.unlimited_finish) {
                isValid = false;
                message = 'Check Fields: To Date';
            } else if (!coupon.unlimited_join && (coupon.join_count === null || coupon.join_count === undefined)) {
                isValid = false;
                message = 'Check Fields: Max Users';
            } else if (
                coupon.type === null ||
                coupon.value === null ||
                coupon.type === undefined ||
                coupon.value === undefined
            ) {
                isValid = false;
                message = 'Check Fields: Value, Type';
            } else if (
                coupon.type === vm.couponTypes.REFERRAL.value &&
                (coupon.cashback === null || coupon.cashback === undefined)
            ) {
                isValid = false;
                message = 'Check Fields: Cashback';
            }

            if (!isValid) {
                SweetAlert.swal('Missing Fields!', message, 'error');
            }

            return isValid;
        }

        function checkIfCouponReferralExists(callback) {
            ServiceData.refresh(function (service, error) {
                if (error) {
                    callback(null, error);
                } else {
                    callback(service.referralCouponId, null);
                }
            });
        }

        function callAddCoupon(newCoupon) {
            if (!newCoupon) {
                console.warn('callAddCoupon: invalid newCoupon', newCoupon);
                return;
            }
            // console.log("callAddCoupon: newCoupon",newCoupon)

            CouponsAdapter.addCoupon(newCoupon, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Add a new coupon',
                        description: 'Error while adding a new coupon!',
                    });
                } else {
                    closeDialog(true);
                    SweetAlert.swal('Add a new coupon', 'A new coupon was successfully added!', 'success');
                }
            });
        }

        function addCoupon() {
            // console.log("start add coupon", vm.newCoupon);
            if (vm.timezone === null || vm.timezone === undefined) {
                ErrorUtility.showErrorMessage({
                    title: 'Add New Coupon',
                    description: 'Error loading timezone ' + vm.timezone,
                });
                return;
            }

            var data = angular.copy(vm.newCoupon);

            var formIsValid = validateCoupon(data);
            if (!formIsValid) {
                return;
            }
            data.start = MiscUtility.shiftJstoMoment(vm.newCoupon.start, vm.selectedSiteId).startOf('day');
            if (vm.newCoupon.unlimited_finish) {
                data.finish = data.start.clone().endOf('day');
            } else {
                data.finish = MiscUtility.shiftJstoMoment(vm.newCoupon.finish, vm.selectedSiteId).endOf('day');
            }
            data.start = data.start.valueOf();
            data.finish = data.finish.valueOf();

            // console.log("start",vm.newCoupon.start)
            // console.log("start tz",data.start)
            // console.log("end",vm.newCoupon.finish)
            // console.log("end tz",data.finish)
            // console.log("dataToSend", data)

            //coupon consistency checks
            if (data.type !== vm.couponTypes.REFERRAL.value) {
                data.cashback = null;
            } else {
                // NOTE converts cashback value from credit to minutes
                const minutesValue = CouponUtility.generateMinutesValue(data.cashback, vm.selectedSiteId);
                if (minutesValue == null) {
                    ErrorUtility.showErrorMessage({
                        title: 'Add New Coupon',
                        description: 'Error while generating the coupon value, please try again!',
                    });
                    return;
                }
            }
            // NOTE converts coupon value from credit to minutes
            const minutesValue = CouponUtility.generateMinutesValue(data.value, vm.selectedSiteId);
            if (minutesValue == null) {
                ErrorUtility.showErrorMessage({
                    title: 'Add New Coupon',
                    description: 'Error while generating the coupon value, please try again!',
                });
                return;
            }
            // NOTE substitute coupon value to minutes
            data.value = minutesValue;

            // console.log("dataToSend", data)
            if (data.type !== vm.couponTypes.REFERRAL.value) {
                callAddCoupon(data);
            } else {
                checkIfCouponReferralExists(function (referralCouponId, error) {
                    if (error) {
                        ErrorUtility.showErrorMessage({
                            title: 'Add a new coupon',
                            description: 'Error while adding a new coupon!',
                        });
                    } else {
                        var exists =
                            typeof referralCouponId !== 'undefined' &&
                            referralCouponId !== null &&
                            typeof parseInt(referralCouponId) === 'number';
                        if (exists) {
                            ErrorUtility.showErrorMessage({
                                title: 'Add a new coupon',
                                description:
                                    'A referral coupon already exists (ID: ' +
                                    referralCouponId +
                                    ")! You can't create a new one!",
                            });
                        } else {
                            callAddCoupon(data);
                        }
                    }
                });
            }
        }

        function closeDialog(value) {
            $mdDialog.hide(value);
        }
    }
})();

/**
 * Created by alex on 27/06/17.
 */
(function () {
    'use strict';

    angular
        .module('app.coupon-legacy.details', [])
        .config(config)
        .value('CouponDetailsPage', 'app.coupon-legacy.details');

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.coupon-legacy.details', {
            url: '/{couponId:int}',
            views: {
                'content@app': {
                    templateUrl: 'app/main/coupon-legacy/details/coupon-details.html',
                    controller: 'CouponDetailsController as vm',
                },
            },
            resolve: {
                Coupon: function (
                    AppRequirements,
                    $state,
                    $q,
                    $stateParams,
                    $timeout,
                    CouponsAdapter,
                    CouponsListPage
                ) {
                    var deferred = $q.defer();
                    var couponId = $stateParams.couponId;

                    if (typeof couponId == undefined) {
                        $timeout(function () {
                            deferred.reject();
                            $state.go(CouponsListPage);
                        });
                    }

                    CouponsAdapter.getCoupon(couponId, function (response, error) {
                        if (!error) {
                            deferred.resolve(response);
                        } else {
                            deferred.reject(error);
                            $state.go(CouponsListPage);
                        }
                    });
                    return deferred.promise;
                },
            },
            params: {
                coupon: null,
            },
        });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/settings/coupons/details');
    }
})();

(function () {
    'use strict';

    angular // this is for formatting
        .module('app.coupon-legacy.details')
        .controller('CouponDetailsController', CouponDetailsController);

    /** @ngInject */
    function CouponDetailsController(
        $scope,
        CouponsAdapter,
        $state,
        toDateFilter,
        DialogFactory,
        CouponType,
        CouponUtility,
        SweetAlert,
        Coupon,
        CouponsListPage,
        ServiceSettings,
        MiscUtility,
        ErrorUtility,
        SitesService,
        DefaultSite
    ) {
        var vm = this;

        vm.redeemed = null;
        vm.updateMaxDates = updateMaxDates;
        vm.modifyCouponAction = modifyCouponAction;
        vm.deleteCouponAction = deleteCouponAction;
        vm.setAsReferral = setAsReferral;
        vm.getCouponDescription = CouponUtility.getCouponTypeDescription;
        vm.reloadCoupon = reloadCoupon;
        vm.couponTypes = CouponType;
        vm.DefaultSite = DefaultSite;
        vm.generateCouponValue = generateCreditValue;

        var notModified = null;

        vm.updateRedeemed = getCouponUsers;

        $scope.$on('refreshServiceSettings', function (event) {
            console.log('service settings changed');
            init();
            vm.applyUpdateTableData();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    vm.coupon = Coupon;
                    // use the coupon's timezone
                    vm.timezone = settings && settings[Coupon.SiteId] && settings[Coupon.SiteId].timezone;
                    vm.todayDate = MiscUtility.serviceTodayDate(vm.coupon.SiteId);
                    updateMaxDates();

                    vm.redeemedHeaders = {
                        id: {
                            name: 'User ID',
                            key: 'User.id',
                            class: 'cellId',
                            type: 'link',
                            link: {
                                goto: 'app.user.details',
                                gotoParams: 'userId',
                                key: 'User.id',
                                class: function (o) {
                                    return 'userLink';
                                },
                            },
                            render: function (val, obj) {
                                return obj.User ? obj.User.id : '';
                            },
                        },
                        userFullName: {
                            name: 'Full Name',
                            key: 'User.name',
                            ellipsis: true,
                            type: 'render',
                            render: function (value, object) {
                                return object.User ? object.User.fullName : '';
                            },
                        },
                        userStatus: {
                            name: 'Status',
                            key: 'User.name',
                            type: 'render',
                            render: function (value, object) {
                                return object.User ? object.User.statusHuman : '';
                            },
                        },
                        userEmail: {
                            name: 'Email',
                            key: 'User.email',
                            ellipsis: true,
                            type: 'render',
                            render: function (value, object) {
                                return object.User ? object.User.email : '';
                            },
                        },
                        activation: {
                            name: 'Activation Date',
                            key: 'created_at',
                            class: 'cellDate',
                            type: 'render',
                            render: function (value, object) {
                                return toDateFilter(object.created_at, 'dateTime', object.User.SiteId);
                            },
                        },
                        registration: {
                            name: 'Registration Date',
                            key: 'created_at',
                            class: 'cellDate',
                            type: 'render',
                            render: function (value, object) {
                                return toDateFilter(object.User.created_at, 'dateTime', object.User.SiteId);
                            },
                        },
                        siteId: {
                            name: 'Reg. Site',
                            key: 'User.SiteId',
                            hide: !SitesService.isDefaultSiteSelected(),
                            type: 'render',
                            render: function (val, obj) {
                                return obj.User ? SitesService.getSiteName(obj.User.SiteId) : '';
                            },
                        },
                    };

                    $scope.$applyAsync();
                }
            });
        }
        init();

        $scope.$on('siteChanged', function (site) {
            console.log('site changed');
            reloadCoupon();
        });

        function updateMaxDates() {
            vm.fromMaxDate = vm.coupon.finishDate
                ? vm.coupon.finishDate
                : MiscUtility.shiftMomentToJs(vm.coupon.finish, vm.coupon.SiteId);
            vm.toMinDate = vm.coupon.startDate
                ? vm.coupon.startDate
                : MiscUtility.shiftMomentToJs(vm.coupon.start, vm.coupon.SiteId);
        }

        function generateCreditValue(coupon) {
            return MiscUtility.generateCreditValue(coupon.value * 60000, coupon.SiteId);
        }

        function modifyCouponAction() {
            var coupon = vm.coupon;

            if (vm.timezone === null || vm.timezone === undefined) {
                ErrorUtility.showErrorMessage({
                    title: 'Coupon Details',
                    description: 'Unable to modify coupon. Error getting the timezone',
                });
                return;
            }

            if (!vm.coupon.isBeingModified) {
                notModified = angular.copy(coupon);
                vm.coupon.isBeingModified = true;
                coupon.startDate = MiscUtility.shiftMomentToJs(coupon.start, coupon.SiteId);

                console.log('start tz', coupon.startDate);
                console.log('end', coupon.finishDate);

                if (coupon.unlimited_finish) {
                    coupon.finishDate = coupon.startDate;
                } else {
                    coupon.finishDate = MiscUtility.shiftMomentToJs(coupon.finish, coupon.SiteId);
                }
                updateMaxDates();
                console.log('end tz', coupon.finishDate);

                coupon.creditValue = generateCreditValue(coupon);
            } else {
                DialogFactory.confirm('Modify Coupon', 'Are you sure you want to modify this coupon?').then(
                    function ok() {
                        coupon.start = MiscUtility.shiftJstoMoment(
                            coupon.startDate,
                            coupon.SiteId ? coupon.SiteId : null
                        );

                        if (coupon.unlimited_finish) {
                            coupon.finish = coupon.start.clone().endOf('day').valueOf();
                        } else {
                            coupon.finish = MiscUtility.shiftJstoMoment(
                                coupon.finishDate,
                                coupon.SiteId ? coupon.SiteId : null
                            )
                                .endOf('day')
                                .valueOf();
                        }
                        coupon.start = coupon.start.startOf('day').valueOf();

                        if (coupon.type === CouponType.REFERRAL.value) {
                            const minutesValue = CouponUtility.generateMinutesValue(coupon.cashback, coupon.SiteId);
                            if (minutesValue == null) {
                                ErrorUtility.showErrorMessage({
                                    title: 'Edit Coupon',
                                    description: 'Error while generating the coupon value, please try again!',
                                });
                                return;
                            }
                            coupon.cashback = minutesValue;
                        }

                        const minutesValue = CouponUtility.generateMinutesValue(coupon.creditValue, coupon.SiteId);
                        if (minutesValue == null) {
                            ErrorUtility.showErrorMessage({
                                title: 'Edit Coupon',
                                description: 'Error while generating the coupon value, please try again!',
                            });
                            return;
                        }
                        coupon.value = minutesValue;
                        // console.log("data to send", coupon)

                        CouponsAdapter.editCoupon(coupon.id, coupon, function (response, error) {
                            if (error || !response.updated) {
                                coupon = notModified;
                                ErrorUtility.showErrorMessage({
                                    title: 'Edit Coupon',
                                    description: 'Error while editing the coupon!',
                                });
                            } else {
                                notModified = null;
                                vm.coupon.isBeingModified = false;
                                SweetAlert.swal('Edit Coupon', 'This coupon was successfully modified!', 'success');
                                vm.coupon = coupon;
                            }
                        });
                    }
                );
            }
        }

        function deleteCouponConfirmDialog() {
            DialogFactory.confirm('Delete Coupon', 'Are you sure you want to delete this coupon?').then(function ok() {
                CouponsAdapter.deleteCoupon(vm.coupon.id, function (response, error) {
                    if (error) {
                        ErrorUtility.showErrorMessage({
                            title: 'Delete Coupon',
                            description: 'Error while deleting this coupon!',
                        });
                    } else {
                        SweetAlert.swal('Delete Coupon', 'This coupon was successfully deleted!', 'success');
                        // vm.coupons.splice(index,1)
                        //getCoupons()
                        $state.go(CouponsListPage);
                    }
                });
            });
        }

        function deleteCouponAction() {
            if (!vm.coupon.isBeingModified) {
                deleteCouponConfirmDialog();
            } else {
                vm.coupon.isBeingModified = false;
                vm.coupon = notModified;
            }
        }

        function setAsReferral() {
            CouponsAdapter.setCouponAsReferral(vm.coupon.id, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Set coupon as referral',
                        description: 'Error while set as referrall!',
                    });
                } else {
                    reloadCoupon(function (response, error) {
                        if (!error) {
                            // deferred.resolve(response)
                            vm.coupon = response;
                            SweetAlert.swal(
                                'Set coupon as referral',
                                'This coupon was successfully set as referral!',
                                'success'
                            );
                        } else {
                            ErrorUtility.showErrorMessage({
                                title: 'Set coupon as referral',
                                description: 'Error while set as referrall!',
                            });
                        }
                    });
                }
            });
        }

        function reloadCoupon(callback) {
            if (callback) {
                CouponsAdapter.getCoupon(vm.coupon.id, callback);
            } else {
                CouponsAdapter.getCoupon(vm.coupon.id, function (response, error) {
                    if (!error) {
                        // deferred.resolve(response)
                        console.log('Response', response);
                        vm.coupon = response;
                    } else {
                        ErrorUtility.showErrorMessage({
                            title: 'Get Coupon details',
                            description: 'Error while getting the coupon details!',
                        });
                        $state.go(CouponsListPage);
                    }
                });
            }
        }

        // function callGetCouponUsers(coupon,count){
        //     getCouponUsersTimeouts[count] = $timeout(function(){
        //         getCouponUsers(coupon)
        //     },count * 500)
        // }

        function getCouponUsers(callback, updateInterface) {
            if (updateInterface === undefined) {
                updateInterface = true;
            }
            if (!vm.coupon) {
                return;
            }

            vm.coupon.redeemedCount = '...';

            CouponsAdapter.getCouponUsers(vm.coupon.id, {}, function getHandler(response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Coupon Users',
                        description: 'Error while getting the coupon users list!',
                    });
                    if (callback) {
                        callback(response, error);
                    }
                } else {
                    if (updateInterface) {
                        vm.redeemed = response.data ? response.data : response;
                    }
                    if (callback) {
                        callback(response.data ? response.data : response, error);
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.coupon.template')
        .controller('CouponTemplateListController', CouponTemplateListController)
        .factory('CouponTemplateDialogFactory', CouponTemplateDialogFactory);

    /** @ngInject */
    function CouponTemplateListController(
        $scope,
        $stateParams,
        $timeout,
        MiscUtility,
        ErrorUtility,
        ServiceSettings,
        SitesService,
        CouponBonusAdapter,
        FiltersRequestParamFactory,
        CouponTemplateDialogFactory,
        AppConfigurations
    ) {
        var vm = this;

        // Data
        vm.templates = [];
        vm.isAddTemplateEnabled = AppConfigurations.isActionEnabled('couponBonusTemplate.list.addTemplate');

        vm.filters = {};

        vm.searchFilters = {
            // id: FiltersFactory.createBonusTemplateWithIdFilter(),
            // type: FiltersFactory.createBonusTemplateWithTypeFilter(),
            // hidden: FiltersFactory.createBonusTemplateWithHiddenFilter(),
            // disabled: FiltersFactory.createBonusTemplateWithDisabledFilter(),
        };

        $scope.$on('refreshServiceSettings', function (event) {
    init();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    SitesService.getSites(function () {
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        var timezone = settings && settings[vm.selectedSiteId] && settings[vm.selectedSiteId].timezone;

                        // vm.timezone = timezone;
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);

                        vm.tableFields = AppConfigurations.getCouponBonusTemplateList();
                    });
                    $scope.$applyAsync();
                }
            });
        }
        init();

        // NOTE open addTemplateDialog if user is redirect to do so
        if ($stateParams.action == 'createCouponTemplate' && vm.isAddTemplateEnabled) {
            // NOTE wait for a smooth page transition
            $timeout(function () {
                openAddTemplateDialog(null, $stateParams.bonusTemplate);
            }, 500);
        }

        $scope.$on('siteChanged', function (site) {
            SitesService.getSites(function () {
                vm.selectedSiteId = SitesService.getSelectedSite();
            });
            vm.applyFiltersTrigger();
        });

        vm.refreshTemplates = refreshTemplates;
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger;
        vm.openAddTemplateDialog = openAddTemplateDialog;

        function refreshTemplates(paginationRequestParam, callback, updateInterface) {
            if (updateInterface === undefined) {
                updateInterface = true;
            }
            // NOTE example paginationRequestParam:  {limit: number, offset: number, filters: obj, order: [string, string][]}
            var filterParams = FiltersRequestParamFactory.createAnAndFilter([
                // FiltersRequestParamFactory.createBonusTemplateWithHiddenFilter(false),
                // FiltersRequestParamFactory.createBonusTemplateWithDisabledFilter(false),
            ]);

            if (!paginationRequestParam.filters || Object.keys(paginationRequestParam.filters).length == 0) {
                paginationRequestParam.filters = filterParams;
            }

            // var params = FiltersRequestParamFactory.mergeObjects(
            //     filterParam,
            //     paginationFilterRequestParam
            // );

            CouponBonusAdapter.getTemplates(paginationRequestParam, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Campaign List',
                        description: 'Error getting the template list!',
                    });

                    if (callback !== undefined) {
                        callback(data, error);
                    }
                } else {
                    if (updateInterface) {
                        var templates = typeof data.data !== 'undefined' ? data.data : data;
                        if (templates) {
                            vm.templates = templates;
                        }
                    }
                    if (callback !== undefined) {
                        callback(data, error);
                    }
                }
            });
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger() {
            vm.applyFiltersTrigger();
        }

        function openAddTemplateDialog(ev, bonusTemplate) {
            CouponTemplateDialogFactory.create(ev, bonusTemplate).then(function ok(refresh) {
                if (refresh) {
                    vm.applyFiltersTrigger();
                }
            });
        }
    }

    /** @ngInject */
    function CouponTemplateDialogFactory($mdDialog, $document) {
        return {
            create: function (ev, bonusTemplate) {
                return $mdDialog.show({
                    controller: 'CouponTemplateAddDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/coupon/template/dialogs/coupon-template-add-dialog.html',
                    parent: angular.element('body'), //$document.find('#content-container')),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: { BonusTemplate: bonusTemplate },
                });
            },
        };
    }
})();

/**
 * Created by andrea on 25/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.catalog.station')
        .controller('StationListController', StationListController);

    /** @ngInject */
    function StationListController(Stations,$mdDialog,$document,RentStationAdapter) {

        var vm = this;


        // Options

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    targets: 0,
                    width: "45%"
                },
                {
                    // Target the description column
                    targets: 1,
                    width  : '50%'
                },
                {
                    // Target the actions column
                    targets: 2,
                    width  : '5%',
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                },
               /*,
                 {
                 // Target the actions column
                 targets           : 9,
                 responsivePriority: 1,
                 filterable        : false,
                 sortable          : false
                 }*/
            ],
            initComplete: function () {

                var api = this.api();
                var searchBox = angular.element('body').find('#station-list-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        //Data

        vm.stations = Stations;


        function openStationDialog(ev, station) {
            $mdDialog.show({
                controller         : 'StationDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalog/station/dialogs/station-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Station : station,
                    Stations: vm.stations
                }
            }).then(function (shouldReload) {
                if(shouldReload){
                    RentStationAdapter.getStations(function (stations,error) {
                        if(error){
                            console.log("Couldn't reload stations",error)
                        }else{
                            vm.stations = stations
                        }
                    })
                }
            })
        }

        vm.openStationDialog = openStationDialog

    }
}());
/**
 * Created by andrea on 25/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.catalog.station')
        .controller('FareListController', FareListController);

    /** @ngInject */
    function FareListController(Fares,$mdDialog,$document,RateAdapter, MiscUtility)
    {
        var vm = this;

        // Methods
        vm.getCurrencyValue = MiscUtility.getCurrencyValue

        // Options

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    targets: 0,
                    width: "30%"
                },
                {
                    // Target the description column
                    targets: 1,
                    width  : '30%'
                },
                {
                    // Target the actions column
                    targets: 4,
                    width  : '5%',
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
                /*,
                 {
                 // Target the actions column
                 targets           : 9,
                 responsivePriority: 1,
                 filterable        : false,
                 sortable          : false
                 }*/
            ],
            initComplete: function () {

                var api = this.api();
                var searchBox = angular.element('body').find('#fare-list-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        //Data


        vm.fares = Fares;
        

        function openFareDialog(ev, fare) {
            $mdDialog.show({
                controller         : 'FareDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalog/fare/dialogs/fare-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Fare : fare,
                    Fares: vm.fares
                }
            }).then(function (shouldReload) {
                if(shouldReload){
                    RateAdapter.getRates(function (fares,error) {
                        if(error){
                            console.log("Couldn't reload fares",error)
                        }else{
                            vm.fares = fares
                        }
                    })
                }
            })
        }

        vm.openFareDialog = openFareDialog

    }
}());
/**
 * Created by andrea on 24/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.catalog.category')
        .controller('CategoryListController', CategoryListController);

    /** @ngInject */
    function CategoryListController(Categories,$mdDialog,$document) {

        var vm = this;

        // Options

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    targets: 0,
                    width: "15%"
                },
                {
                    // Target the description column
                    targets: 1,
                    width  : '50%'
                },
                {
                    // Target the type column
                    targets: 2,
                    width  : '20%'
                },
                {
                    // Target the actions column
                    targets: 3,
                    width:'10%'
                },
                {
                    targets: 4,
                    width:"5%",
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }/*,
                 {
                 // Target the actions column
                 targets           : 9,
                 responsivePriority: 1,
                 filterable        : false,
                 sortable          : false
                 }*/
            ],
            initComplete: function () {

                var api = this.api();
                var searchBox = angular.element('body').find('#category-list-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        //Data

        vm.categories = Categories;


        function openCategoryDialog(ev, category) {
            $mdDialog.show({
                controller         : 'CategoryDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalog/category/dialogs/category-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Category : category,
                    Categories: vm.categories
                }
            })
        }

        vm.openCategoryDialog = openCategoryDialog

    }
}());
(function () {
    'use strict';

    angular
        .module('app.bonus.template')
        .controller('BonusTemplateListController', BonusTemplateListController)
        .factory("BonusTemplateDialogFactory", BonusTemplateDialogFactory);

    /** @ngInject */
    function BonusTemplateListController(
        $scope,
        $timeout,
        $stateParams,
        toDateFilter,
        FiltersFactory,
        OrderRequestParamFactory,
        MiscUtility,
        ErrorUtility,
        ServiceSettings,
        SitesService,
        DefaultSite,
        BonusAdapter,
        FiltersRequestParamFactory,
        BonusTemplateDialogFactory,
        BonusTemplateValidityTimeType,
        AppConfigurations
    ) {
        var vm = this;

        // Data
        vm.templates = []
        vm.isAddTemplateEnabled = AppConfigurations.isActionEnabled('bonusTemplate.list.addTemplate');

        vm.filters = {}

        vm.searchFilters = {
            id: FiltersFactory.createBonusTemplateWithIdFilter(),
            type: FiltersFactory.createBonusTemplateWithTypeFilter(),
            hidden: FiltersFactory.createBonusTemplateWithHiddenFilter(),
            disabled: FiltersFactory.createBonusTemplateWithDisabledFilter(),
        }
        
        $scope.$on('refreshServiceSettings', function (event) {
            init();
        })

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    SitesService.getSites(function () {
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        var timezone = settings && settings[vm.selectedSiteId] && settings[vm.selectedSiteId].timezone;

                        // vm.timezone = timezone;
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);

                        vm.tableFields = {
                            id: {
                                name: 'Template Id',
                                orderBy: OrderRequestParamFactory.orderById,
                                defaultSort: true,
                                class: 'vehicleRowCellSmall',
                                key: 'id',
                            },
                            type: { name: 'Type', class: 'vehicleRowCellSmall', key: 'type' },
                            description: {
                                name: 'Description',
                                class: 'vehicleRowCellBig alignLeft',
                                ellipsis: true,
                                key: 'description',
                            },
                            // properties: { name: "properties", class: "vehicleRowCellVeryBig alignLeft", ellipsis: true, key: 'properties', type: 'render', render: function (v, o) { return JSON.stringify(o.properties) },
                            fromDate: {
                                name: 'From',
                                class: 'vehicleRowCellMedium alignLeft',
                                key: 'fromDate',
                                type: 'render',
                                render: function (v, o) {
                                    return getFromDate(o);
                                },
                            },
                            toDate: {
                                name: 'To',
                                class: 'vehicleRowCellMedium alignLeft',
                                key: 'toDate',
                                type: 'render',
                                render: function (v, o) {
                                    return getToDate(o);
                                },
                            },
                            limits: {
                                name: 'Limits',
                                class: 'vehicleRowCellVeryBig alignLeft',
                                ellipsis: true,
                                key: 'limits',
                                type: 'render',
                                render: function (v, o) {
                                    return getLimitsDescription(o);
                                },
                            },
                            constraints: {
                                name: 'Constraints',
                                class: 'vehicleRowCellVeryBig alignLeft',
                                ellipsis: true,
                                key: 'constraints',
                                type: 'render',
                                render: function (v, o) {
                                    return getConstraintDescription(o);
                                },
                            },
                            // hidden: {
                            //     name: 'Hidden',
                            //     class: 'vehicleRowCellSmall',
                            //     key: 'hiddennnn',
                            //     type: 'render',
                            //     render: function (v, o) {
                            //         return o.hidden ? 'yes' : 'no';
                            //     },
                            // },
                            disabled: {
                                name: 'Disabled',
                                class: 'vehicleRowCellSmall',
                                key: 'disabled',
                                type: 'render',
                                render: function (v, o) {
                                    return o.disabled ? 'yes' : 'no';
                                },
                            },
                            creationDate: {
                                name: 'Creation date',
                                class: 'vehicleRowCellMedium',
                                type: 'render',
                                render: function (v, o) {
                                    return toDateFilter(o.created_at, 'dateTime', o.SiteId || DefaultSite.id);
                                },
                            },
                            modificationDate: {
                                name: 'Modification date',
                                class: 'vehicleRowCellMedium',
                                type: 'render',
                                render: function (v, o) {
                                    return toDateFilter(o.updated_at, 'dateTime', o.SiteId || DefaultSite.id);
                                },
                            },
                            site: {
                                name: 'Site',
                                class: 'vehicleRowCell preventLastChildShrink',
                                type: 'render',
                                render: function (v, o) {
                                    return o.SiteId !== undefined && o.SiteId !== null
                                        ? SitesService.getSiteName(o.SiteId)
                                        : 'No site';
                                },
                            },
                            // details: {
                            //     name: "Details", class: "", key: 'details', type: 'icon-link', icon: {
                            //         goto: "",
                            //         gotoParams: "userId",
                            //         icon: "icon-information-outline",
                            //         key: "id",
                            //     }
                            // }
                        };
                    });
                    $scope.$applyAsync();
                }
            });
        }
        init();

        // NOTE open addTemplateDialog if user is redirect to do so
        if ($stateParams.action == 'createTemplate' && vm.isAddTemplateEnabled) {
            // NOTE wait for a smooth page transition
            $timeout(function () {
                openAddTemplateDialog(null, $stateParams.nextAction);
            }, 500);
        }

        $scope.$on('siteChanged', function (site) {
            SitesService.getSites(function () {
                vm.selectedSiteId = SitesService.getSelectedSite();
            });
            vm.applyFiltersTrigger();
        });

        vm.refreshTemplates = refreshTemplates;
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger;
        vm.openAddTemplateDialog = openAddTemplateDialog;

        function getLimitsDescription(template) {
            if (!template || !template.limits) {
                return '';
            }

            const limits = template.limits;
            const limitsParts = [];
            if (limits.forValidity && Object.keys(limits.forValidity).length > 0) {
                if (
                    limits.forValidity.price &&
                    limits.forValidity.price.value &&
                    !isNaN(limits.forValidity.price.value / 100)
                ) {
                    limitsParts.push('Up to ' + limits.forValidity.price.value / 100 + '€');
                }
                if (limits.forValidity.count) {
                    limitsParts.push('Up to ' + limits.forValidity.count + ' trips');
                }
            }

            if (limits.perBooking && Object.keys(limits.perBooking).length > 0) {
                if (
                    limits.perBooking.price &&
                    limits.perBooking.price.value &&
                    !isNaN(limits.perBooking.price.value / 100)
                ) {
                    limitsParts.push('Up to ' + limits.perBooking.price.value / 100 + '€ per trip');
                }
            }

            const timeWindowParts = [];
            // TODO support multiple time windows
            if (limits.perTimeWindow && Object.keys(limits.perTimeWindow).length > 0) {
                const firstTimeWindow = limits.perTimeWindow[0];
                if (firstTimeWindow && firstTimeWindow.limits && Object.keys(firstTimeWindow.limits).length > 0) {
                    if (
                        firstTimeWindow.limits.price &&
                        firstTimeWindow.limits.price.value &&
                        !isNaN(firstTimeWindow.limits.price.value / 100)
                    ) {
                        timeWindowParts.push('Up to ' + firstTimeWindow.limits.price.value / 100 + '€');
                    }
                    if (firstTimeWindow.limits.count) {
                        timeWindowParts.push('Up to ' + firstTimeWindow.limits.count + ' trips');
                    }
                }

                if (firstTimeWindow && firstTimeWindow.window && Object.keys(firstTimeWindow.window).length > 0) {
                    if (firstTimeWindow.window.duration && !isNaN(firstTimeWindow.window.duration / (60 * 1000))) {
                        timeWindowParts.push(
                            'resets every ' + firstTimeWindow.window.duration / (60 * 1000) + ' minutes'
                        );
                    }
                }
            }
            const limitsDescr = (limitsParts.length > 0 && limitsParts.join(', or ')) || '';
            const timeWindowDescr =
                (timeWindowParts.length > 0 && (limitsDescr ? ', ' : '') + timeWindowParts.join(', or ')) || '';

            return limitsDescr + timeWindowDescr;
        }

        function getValidityTimeRange(template) {
            if (!template || !template.constraints || !template.constraints.validityTime) {
                return '';
            }
            const validityTimeStart = template.constraints.validityTime[0];
            var start = '';
            switch (validityTimeStart.type) {
                case BonusTemplateValidityTimeType.UNBOUNDED.value:
                    start = 'No limit';
                    break;
                case BonusTemplateValidityTimeType.TIMESTAMP.value:
                    start = toDateFilter(validityTimeStart.timestamp, 'dateTime', template.SiteId || DefaultSite.id);
                    break;
                case BonusTemplateValidityTimeType.DURATION_FROM_ACQUISITION.value:
                    start = validityTimeStart.duration / (60 * 1000) + ' min from purchase ';
                    break;
            }

            const validityTimeEnd = template.constraints.validityTime[1];
            var end = '';
            switch (validityTimeEnd.type) {
                case BonusTemplateValidityTimeType.UNBOUNDED.value:
                    end = 'No limit';
                    break;
                case BonusTemplateValidityTimeType.TIMESTAMP.value:
                    end = toDateFilter(validityTimeEnd.timestamp, 'dateTime', template.SiteId || DefaultSite.id);
                    break;
                case BonusTemplateValidityTimeType.DURATION_FROM_ACQUISITION.value:
                    end = validityTimeEnd.duration / (60 * 1000) + ' min from purchase ';
                    break;
            }
            return [start, end];
        }

        function getFromDate(template) {
            const range = getValidityTimeRange(template);
            return range[0] || '';
        }

        function getToDate(template) {
            const range = getValidityTimeRange(template);
            return range[1] || '';
        }

        function getConstraintDescription(template) {
            if (!template || !template.constraints) {
                return '';
            }
            var parts = [];
            if (template.constraints.currency) {
                parts.push(template.constraints.currency + ' currency');
            }

            if (template.constraints.siteIds && Array.isArray(template.constraints.siteIds)) {
                parts.push(
                    'Valid for ' +
                        template.constraints.siteIds
                            .map(function (siteId) {
                                return SitesService.getSiteName(siteId);
                            })
                            .join(',')
                );
            } else {
                parts.push('Valid for All sites');
            }

            return parts.length > 0 ? parts.join(', ') : '';
        }

        function refreshTemplates(paginationRequestParam, callback, updateInterface) {
            if (updateInterface === undefined) {
                updateInterface = true;
            }
            // NOTE example paginationRequestParam:  {limit: number, offset: number, filters: obj, order: [string, string][]}
            var filterParams = FiltersRequestParamFactory.createAnAndFilter([
                FiltersRequestParamFactory.createBonusTemplateWithHiddenFilter(false),
                FiltersRequestParamFactory.createBonusTemplateWithDisabledFilter(false),
            ]);

            if (!paginationRequestParam.filters || Object.keys(paginationRequestParam.filters).length == 0) {
                paginationRequestParam.filters = filterParams;
            }

            // var params = FiltersRequestParamFactory.mergeObjects(
            //     filterParam,
            //     paginationFilterRequestParam
            // );

            BonusAdapter.getTemplates(paginationRequestParam, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Template List',
                        description: 'Error getting the template list!',
                    });

                    if (callback !== undefined) {
                        callback(data, error);
                    }
                } else {
                    if (updateInterface) {
                        var templates = typeof data.data !== 'undefined' ? data.data : data;
                        if (templates) {
                            vm.templates = templates;
                        }
                    }
                    if (callback !== undefined) {
                        callback(data, error);
                    }
                }
            });
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger() {
            vm.applyFiltersTrigger();
        }

        function openAddTemplateDialog(ev, nextAction) {
            BonusTemplateDialogFactory.create(ev, nextAction).then(function ok(refresh) {
                if (refresh) {
                    vm.applyFiltersTrigger();
                }
            });
        }
    }

    /** @ngInject */
    function BonusTemplateDialogFactory($mdDialog, $document) {
        return {
            create: function (ev, nextAction) {
                return $mdDialog.show({
                    controller: 'BonusTemplateAddDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/bonus/template/dialogs/bonus-template-add-dialog.html',
                    parent: angular.element('body'), //$document.find('#content-container')),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: { nextAction: nextAction },
                });
            },
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.bonus.shopItem')
        .controller('ShopItemListController', ShopItemListController)
        .factory('ShopItemDialogFactory', ShopItemDialogFactory);

    /** @ngInject */
    function ShopItemListController(
        $scope,
        $timeout,
        $stateParams,
        toDateFilter,
        toCurrencyFilter,
        toNumberFilter,
        OrderRequestParamFactory,
        MiscUtility,
        ErrorUtility,
        FiltersFactory,
        ServiceSettings,
        SitesService,
        DefaultSite,
        BonusAdapter,
        ShopItemDialogFactory,
        AppConfigurations
    ) {
        var vm = this;

        // Data
        vm.shopItems = [];
        vm.isAddItemEnabled = AppConfigurations.isActionEnabled('shopItem.list.addItem');

        vm.filters = {};

        vm.searchFilters = {
            id: FiltersFactory.createShopItemWithIdFilter(),
            userVisible: FiltersFactory.createShopItemWithUserVisibleFilter(),
        };


        $scope.$on('refreshServiceSettings', function (event) {
            init();
        });

        $scope.$on('siteChanged', function (site) {
            SitesService.getSites(function () {
                vm.selectedSiteId = SitesService.getSelectedSite();
            });
            vm.applyFiltersTrigger();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    SitesService.getSites(function () {
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        var timezone = settings && settings[vm.selectedSiteId] && settings[vm.selectedSiteId].timezone;

                        // vm.timezone = timezone;
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);

                        vm.tableFields = {
                            id: {
                                name: 'Item Id',
                                orderBy: OrderRequestParamFactory.orderById,
                                defaultSort: true,
                                class: 'vehicleRowCellSmall',
                                key: 'id',
                            },
                            templateId: { name: 'Template Id', class: 'vehicleRowCellSmall', key: 'BonusTemplateId' },
                            description: {
                                name: 'Description',
                                class: 'vehicleRowCellVeryBig alignLeft',
                                ellipsis: true,
                                key: 'BonusTemplate.description',
                                type: 'render',
                                render: function (v, o) {
                                    return (o.BonusTemplate && o.BonusTemplate.description) || '';
                                },
                            },
                            price: {
                                name: 'Price',
                                class: 'vehicleRowCellBig',
                                key: 'price',
                                type: 'render',
                                render: function (v, o) {
                                    return o.price && o.price.value
                                        ? toCurrencyFilter(o.price.value / 100, o.SiteId)
                                        : 'N/A';
                                },
                                csv: function (v, o) {
                                    return o.price && o.price.value ? toNumberFilter(o.price.value / 100) : '';
                                },
                            },
                            userVisible: {
                                name: 'On sale',
                                class: 'vehicleRowCellSmall',
                                key: 'userVisible',
                                type: 'render',
                                render: function (v, o) {
                                    return o.userVisible ? 'yes' : 'no';
                                },
                            },
                            creationDate: {
                                name: 'Creation date',
                                class: 'vehicleRowCellBig',
                                type: 'render',
                                render: function (v, o) {
                                    return toDateFilter(o.created_at, 'dateTime', o.SiteId || DefaultSite.id);
                                },
                            },
                            modificationDate: {
                                name: 'Modification date',
                                class: 'vehicleRowCellBig',
                                type: 'render',
                                render: function (v, o) {
                                    return toDateFilter(o.updated_at, 'dateTime', o.SiteId || DefaultSite.id);
                                },
                            },
                            site: {
                                name: 'Site',
                                class: 'vehicleRowCell',
                                type: 'render',
                                render: function (v, o) {
                                    return o.SiteId !== undefined && o.SiteId !== null
                                        ? SitesService.getSiteName(o.SiteId)
                                        : 'No site';
                                },
                                hide: !SitesService.isDefaultSiteSelected(),
                            },
                            // details: {
                            //     name: "Details", class: "", key: 'details', type: 'icon-link', icon: {
                            //         goto: "",
                            //         gotoParams: "userId",
                            //         icon: "icon-information-outline",
                            //         key: "id",
                            //     }
                            // }
                        };
                    });
                    $scope.$applyAsync();
                }
            });
        }
        init();

        if ($stateParams.action == 'createShopItem' && vm.isAddItemEnabled) {
            $timeout(function () {
                openAddShopItemDialog(null, $stateParams.template);
            }, 500);
        }

        vm.refreshShopItems = refreshShopItems;
        vm.openAddShopItemDialog = openAddShopItemDialog;
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger;

        function refreshShopItems(paginationRequestParam, callback, updateInterface) {
            if (updateInterface === undefined) {
                updateInterface = true;
            }
            BonusAdapter.getShopItems(paginationRequestParam, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Shop List',
                        description: 'Error getting the shop list!',
                    });

                    if (callback !== undefined) {
                        callback(data, error);
                    }
                } else {
                    if (updateInterface) {
                        var shopItems = typeof data.data !== 'undefined' ? data.data : data;
                        if (shopItems) {
                            vm.shopItems = shopItems;
                        }
                    }
                    if (callback !== undefined) {
                        callback(data, error);
                    }
                }
            });
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger() {
            vm.applyFiltersTrigger();
        }

        function openAddShopItemDialog(ev, template) {
            ShopItemDialogFactory.create(ev, template).then(function ok(refresh) {
                if (refresh) {
                    vm.applyFiltersTrigger();
                }
            });
        }
    }

    /** @ngInject */
    function ShopItemDialogFactory($mdDialog, $document) {
        return {
            create: function (ev, template){
                return $mdDialog.show({
                    controller         : 'ShopItemAddDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/bonus/shopItem/dialogs/shop-item-add-dialog.html',
                    parent             : angular.element("body"),//$document.find('#content-container')),
                    targetEvent        : ev,
                    clickOutsideToClose: true,
                    locals             : {
                        Template: template
                    }
                });
            },
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
/**
 * Created by alex on 24/01/17.
 */

(function ()
{
    'use strict';

    angular
        .module('app.vehicle')
        .controller('VehicleListController', VehicleListController)
        .factory('VehicleDialogFactory',VehicleDialogFactory);

    /** @ngInject */
    function VehicleListController(VehicleSharingAdapter, $mdDialog, $state, $scope, $document, VehicleUtility, VehicleStatus, ErrorUtility, VehicleDetailsPage, UserDetailsPage, FiltersFactory, VehicleDialogFactory, AppConfigurations, ServiceSettings, SitesService){

        var vm = this;

        var vehicleStatusColor = {
            "free":"md-green-500-bg",
            "booked":"md-yellow-500-bg",
            "unlocked":"md-yellow-500-bg",
            "running":"md-yellow-500-bg",
            "parked":"md-yellow-500-bg",
            "locked":"md-yellow-500-bg"

        }
        vm.mainMap = null
        vm.mapInitialized = false
        vm.markerClusterer = {}

        vm.vehicles = []
        vm.allVehicles = []
        vm.allVehiclesLength = "..."
        vm.vehiclesViewed = "..."
        vm.allVehiclesEnabled = false

        vm.hashedVehicles = {}

        vm.vehicleStatus = VehicleStatus
        vm.searchBarText = ""
        vm.searchBinded = false
        vm.isBulkActionsEnabled = AppConfigurations.isActionEnabled('vehicle.list.bulkActions');
        /*vm.vehicleFilters = {
            free: { description: "Free", id: "free", color: ToHireDefaultColor.green, filterIsOn: true, vehicles: [] },
            booked: { description: "Booked", id: "booked", color: ToHireDefaultColor.blue, filterIsOn: true, vehicles: [] },
            parked: { description: "Paused", id: "parked", color: ToHireDefaultColor.azure, filterIsOn: true, vehicles: [] },
            using: { description: "In use", id: "using", color: ToHireDefaultColor.purple, filterIsOn: true, vehicles: [] },
            maintenance: { description: "Maintenance", id: "maintenance", color: ToHireDefaultColor.maintenanceRed, filterIsOn: true, vehicles: [] }
        }*/

        vm.filters = {
            // miscStatus: FiltersFactory.createMiscStatusFilter(),
            // batteryStatus: FiltersFactory.createBatteryStatusFilter(),
            // vehicleExternalStatus: FiltersFactory.createVehicleExternalStatusFilter(),
            // vehicleStatus: FiltersFactory.createVehicleStatusFilter()
        }

        vm.searchFilters = {
            vehicleReferenceCode: FiltersFactory.createVehicleWithReferenceCodeFilter(),
            vehicleId: FiltersFactory.createVehicleWithIdFilter(),
            vehicleLicensePlate: FiltersFactory.createVehicleWithLicensePlateFilter(),
            vehicleOnline: FiltersFactory.createVehicleWithOnlineFilter(),
            vehicleType: FiltersFactory.createVehicleWithTypeFilter(),
            vehicleDeviceType: FiltersFactory.createVehicleWithDeviceTypeFilter(),
            vehicleBoundingBox: FiltersFactory.createVehicleWithinBoundingBoxFilter(),
            vehicleBrand: FiltersFactory.createVehicleWithBrandFilter(),
            vehicleModelName: FiltersFactory.createVehicleWithModelNameFilter(),
            vehicleCurrentUser: FiltersFactory.createVehicleWithCurrentUserFilter(),
            miscStatus: FiltersFactory.createMiscStatusFilter(),
            batteryStatus: FiltersFactory.createBatteryStatusFilter(),
            // vehicleExternalStatus: FiltersFactory.createVehicleExternalStatusFilter(),
            vehicleStatus: FiltersFactory.createVehicleStatusFilter(),
            createVehicleWithHiddenFilter: FiltersFactory.createVehicleWithHiddenFilter(),
        }

        // vm.resetFilters = resetFilters;

        vm.filterRequestParam = null

        // $scope.$on('$viewContentLoaded', 
        //     function(event){
        //         refreshVehicles()
        //     }
        // )

        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    $scope.$applyAsync()

                    SitesService.getSites(function(){
                        vm.tableFields = AppConfigurations.getVehicleListTableFields()
                    })
                }
            });
        }
        
        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })
        init()

        $scope.$on('siteChanged', function (site) {
            console.log('siteChanged in vehicles')
            vm.applyFiltersTrigger();
        })

        // $scope.$on('$destroy', function () {
        //      console.log("scope destroy,destroy markers")
        // })


        //Methods
        vm.openVehicleAddDialog = openVehicleAddDialog;
        vm.openVehiclesBulkUpdateDialog = openVehiclesBulkUpdateDialog
        vm.refreshVehicles = refreshVehicles;
        vm.goToVehicleDetails = goToVehicleDetails
        vm.generateVehicleDetailsLink = generateVehicleDetailsLink
        vm.generateCurrentUserDetailsLink = generateCurrentUserDetailsLink        
        vm.previusInfoWindow = null
        vm.markerClusterer = null
        vm.getVehicleExternalStatuses = getVehicleExternalStatuses
        vm.hasVehicleACurrentBooking = VehicleUtility.hasVehicleACurrentBooking
        vm.getVehicleCurrentUser = VehicleUtility.getVehicleCurrentUser
        vm.getVehicleLastMoved = VehicleUtility.getVehicleLastMoved
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger

        /**
         * Will update the data, in this case the vehicles. 
         * Checks for callback, if non is passed will simply update the vehicles in the scope.
         */
        function refreshVehicles(paginationRequestParam, callback, updateInterface) {
            if(updateInterface === undefined) {
                updateInterface = true;
            }
            if(updateInterface) {
                vm.allVehiclesLength = "..."
                vm.vehiclesViewed = "..."
            }
            // if($stateParams.searchFor) {
            //     console.log("stateParams",$stateParams.searchFor)
            //     vm.applyFiltersTrigger($stateParams.searchFor)
            //     $stateParams.searchFor = null;
            // } else {
            getVehicles(paginationRequestParam,
                function(data,error){
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Get Vehicles List',description:'Error while getting the vehicles list!'})
                        if (callback !== undefined) {
                            callback(data, error);
                        }
                     } else{
                        if(updateInterface){
                            // console.log("last vehicles",data[0])
                            var vehicles = (typeof data.data !== "undefined") ? data.data : data
                            vm.vehicles = vehicles
                            vm.vehiclesViewed = vehicles.length
                            vm.allVehiclesLength = (typeof data.count !== "undefined") ? data.count : data.length
    
                            //setMarkerForVehicles(vehicles)
                            vm.onVehiclesRefresh(vehicles)
                        }
                        if (callback !== undefined) {
                            callback(data, error);
                        }
                    }
                }
            )
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger(){
            vm.applyFiltersTrigger();
        }

        // function applySearchForFilter(searchFor){
        //     //var entireWord = searchFor.key.toString()
        //     //vm.searchBarQueryLength.value = entireWord.length
        //     //vm.searchBarText = searchFor.label
        //     //searchInHashedTrips(entireWord.split(" "))
            
        //     var filterObj = FiltersFactory.getFilterObj(searchFor.filterKey)

        //     if(filterObj.hasOwnProperty('valueType')){
        //         // vm.searchFilters = filterObj
        //         // vm.searchFilters.selected = searchFor.value
        //         vm.searchFilters[searchFor.filterKey].selected = searchFor.value
        //     }else{
        //         vm.filters[searchFor.filterKey].selected.push(searchFor.value)
        //     }
            
        //     // callApplyFilters()
        //     vm.applyFiltersTrigger();
        // }

        // function refreshVehicles(){
        //     vm.vehicles = []
        //     vm.allVehicles = []
        //     // vm.allVehiclesLength = "..."
        //     // vm.vehiclesViewed = "..."
        //     vm.allVehiclesEnabled = false

        //     if($stateParams.searchFor){
        //         console.log("stateParams",$stateParams.searchFor)
        //         vm.applyFiltersTrigger($stateParams.searchFor)
        //         // applySearchForFilter($stateParams.searchFor)
        //     }
        //     else{
        //         // callGetVehicles()
        //         vm.applyFiltersTrigger();
        //     }

        //     /*VehicleSharingAdapter.getVehicles(
        //         {},
        //         function(vehicles){
        //             //sortListByLastMoved()
        //             vm.allVehiclesLength = vehicles.length
        //             console.log("all vehicles,",vm.allVehiclesLength)

        //             /*vm.hashedVehicles = {}
        //             if($stateParams.searchFor){
        //                 hashVehicles(vm.allVehicles,
        //                     function(){
        //                         applySearchForFilter($stateParams.searchFor)
        //                     }
        //                 )
        //             }else{
        //                 //check if search was active
        //                 if(vm.searchBarText!=""){
        //                     hashVehicles(vm.allVehicles,applySearch)
        //                 }
        //                 else{
        //                     hashVehicles(vm.allVehicles)
        //                 }
        //             }
        //         }
        //     )*/
        // }

        // function resetTablePageIndex(){
        //     vm.currentTablePageIndex = 1
        // }

        // function goToTablePageWithIndex(pageIndex){
        //     vm.currentTablePageIndex = pageIndex
        //     goToTablePage()
        // }

        // function goToTablePage(type){
        //     console.log("goToTablePage",vm.currentTablePageIndex,type)

        //     if(vm.currentTablePageIndex === 0 || typeof vm.currentTablePageIndex === 'undefined' || vm.currentTablePageIndex === null){
        //         console.log("currentTablePageIndex not valid")
        //         vm.currentTablePageIndex = 1
        //     }

        //     if(type === 'prev'){

        //         vm.currentTablePageIndex--
        //         console.log("getPrevTablePage",vm.currentTablePageIndex)
                
        //         if(vm.currentTablePageIndex < 1){
        //             console.log("currentTablePageIndex is 0, reset to 1")
        //             vm.currentTablePageIndex = 1
        //             return
        //         }
        //     }else if(type === 'next'){
                
        //         vm.currentTablePageIndex++
        //         console.log("getNextTablePage",vm.currentTablePageIndex)
        //     }
        //     else{
        //         console.log("case goTo")
        //     }

        //     callGetVehicles()
        // }

        // function callGetVehicles(params,onCompletionHandler){
        //     vm.vehicles = []
        //     // vm.allVehiclesLength = "..."
        //     // vm.vehiclesViewed = "..."
        //     var paginationRequestParam = {
        //         limit: vm.tablePageLimit,
        //         offset: vm.tablePageLimit * (vm.currentTablePageIndex-1)
        //     }

        //     if(vm.filterRequestParam !== null && typeof vm.filterRequestParam === "object" && Object.keys(vm.filterRequestParam).length>0){
        //         //check if a filter was selected
        //         console.log("callGetVehicles: filter param exists")
        //         paginationRequestParam = FiltersRequestParamFactory.mergeObjects(vm.filterRequestParam,paginationRequestParam)
        //     }

        //     if(vm.orderRequestParam !== null && typeof vm.orderRequestParam === "object" && Object.keys(vm.orderRequestParam).length>0){
        //         //check if orderBy was selected
        //         console.log("callGetVehicles: order param exists")
        //         paginationRequestParam = FiltersRequestParamFactory.mergeObjects(vm.orderRequestParam,paginationRequestParam)
        //     }

        //     if(typeof params !== "undefined" && typeof params === "object" && Object.keys(params).length>0){
        //         console.log("callGetVehicles: params passed")
        //         paginationRequestParam = FiltersRequestParamFactory.mergeObjects(params,paginationRequestParam)
        //     }

        //     console.log("paginationRequestParam",paginationRequestParam)


        //     // updateVehicles(paginationRequestParam,
        //     //     function(vehicles,error){
        //     //         if(error){
        //     //             if(typeof onCompletionHandler !== "undefined")
        //     //                 onCompletionHandler([],null)
        //     //         }else{
        //     //             console.log("last vehicles",vehicles[0])
        //     //             // vm.vehiclesViewed = vehicles.length
        //     //             // vm.vehicles = vehicles
                        
        //     //             //setMarkerForVehicles(vehicles)
        //     //             vm.onVehiclesRefresh(vehicles)

        //     //             if(typeof onCompletionHandler !== "undefined"){
        //     //                 onCompletionHandler(vehicles,null)
        //     //             }
        //     //         }
        //     // })
        // }

        function getVehicles(params,onCompletionHandler){

            if(typeof params == "undefined"){
                params = {}
            }
            // vm.isDownloadingData = true

            VehicleSharingAdapter.getVehicles(
                params,
                function(data,error){
                    // vm.isDownloadingData = false
                    if(error){
                        onCompletionHandler([],error)
                    }else{
                        // var vehicles = (typeof data.data !== "undefined") ? data.data : data
                        // vm.allVehiclesLength = (typeof data.count !== "undefined") ? data.count : data.length
                        if(typeof onCompletionHandler !== "undefined"){
                            onCompletionHandler(data,null)
                        }
                    }
            })

        }

        /*function hashVehicles(vehiclesArray,applySearchForFilterTrigger){
            async.forEachOf(vehiclesArray, function(vehicle, key, callback){
                var outputString = ""
                for(var keyInObject in vehicle){
                    var tempValue = vehicle[keyInObject]
                    if(!(tempValue instanceof Object)){
                        if(keyInObject == "sender"){ continue }
                        if(keyInObject == "inMaintenance"){ tempValue = tempValue? "maintenance" : "active" }
                        if(keyInObject == "online")
                            outputString += ((tempValue ? "online" : "offline")+",").toLowerCase()
                        if(tempValue)
                            outputString += ((tempValue + ",").toLowerCase())
                    }else{
                        if(keyInObject == "bookings" && tempValue.length > 0){
                            outputString += ((vehicle.currentUser + ",").toLowerCase())
                        }
                        if(keyInObject == "external_status"){
                            for (var vehicleStatusName in tempValue){
                                var isVehicleInStatus = tempValue[vehicleStatusName]
                                if(!isVehicleInStatus && (vehicleStatusName == VehicleExternalStatus.OUTSIDE_OPERATING_AREA.value)){
                                    outputString += "inside"+ ","
                                }
                                if(isVehicleInStatus){
                                    outputString += vehicleStatusName + ","
                                }
                            }
                        }
                    }
                }
                vm.hashedVehicles[outputString] = key
                callback()
            },function(error){
                console.log("finished hashing")
                
                //apply filter passed as state parameter
                if(applySearchForFilterTrigger){
                    applySearchForFilterTrigger()
                }
            })
        }*/

        /*vm.applySearch = applySearch
        function applySearch(){

            if(FiltersFactory.isAfilterSelected()){
                showAllVehicles(true)
                resetFilters()
            }

            if(vm.searchBarText == ""){
                console.log("empty string")
                //vm.searchBarQueryLength.value = 0
                showAllVehicles()
                return
            }

            var words = vm.searchBarText.split(" ")
            //delete space after word
            if(words.length>1 && words[words.length-1]==""){
                words = words.slice(0,words.length-2)
            }
            searchInHashedVehicles(words)
        }*/

        /*function searchInHashedVehicles(words){

            //check if can toggle to all vehicles
            if(!toggleToAllVehicles()){
                return
            }

            async.forEachOf(vm.hashedVehicles, function(hashIndex, hashString, callback){
                var vehicle = vm.vehicles[hashIndex]
                var wordNotExists = false

                words.forEach(function (word) {
                    word = word.toLowerCase()
                    
                    if(hashString.indexOf(word)==-1){
                        wordNotExists = true
                    }
                })
                //consider filters
                if(wordNotExists){
                    vehicle.isHidden = true
                }
                else{
                    vehicle.isHidden = false
                }
                
                setTimeout(callback,0)
            },
            function(error){
                $scope.$apply(function(){
                    calculateViewedVehicles()
                    showOrHideVehicleMarkers()
                })
            })
        }*/

        /*vm.toggleToAllVehicles = toggleToAllVehicles
        function toggleToAllVehicles(){
            var done = false
            if(vm.allVehicles.length==0){
                SweetAlert.swal("Search in all vehicles","Downloading data... wait a few more seconds","error")
                done = false
            }
            else if(!vm.allVehiclesEnabled){
                vm.vehicles = vm.allVehicles
                vm.vehiclesViewed = vm.allVehicles.length
                console.log("toggleToAllVehicles",vm.allVehicles.length)
                vm.allVehiclesEnabled = true
                done = true
            }
            else{
                done=true
            }
            return done
        }*/

        /*function calculateViewedVehicles(){
            console.log("calculateViewedVehicles")
            vm.vehiclesViewed = 0
            vm.vehicles.forEach(function(vehicle){
                if(!vehicle.isHidden){
                    vm.vehiclesViewed+=1
                }
            })
        }*/
        // function callApplyFilters(){
        //     $timeout.cancel(vm.applyFiltersTimeout)
        //     vm.applyFiltersTimeout = $timeout(function(){
        //         applyFilters()
        //     },1200)
        // }

        // function createFilterRequestParam(){

        //     var filtersFunctions = []
        //     for(var key in vm.filters){
        //         filtersFunctions.push(vm.filters[key].filter)
        //     }
        //     for(var key in vm.searchFilters){
        //         filtersFunctions.push(vm.searchFilters[key].filter)
        //     }

        //     var selectedFiltersQuery = []
        //     var filter = {}
        //     filtersFunctions.forEach(function (getFilter) {
        //         filter = getFilter()
        //         if(Object.keys(filter).length>0){
        //             selectedFiltersQuery.push(filter)
        //         }
        //     })

        //     return FiltersRequestParamFactory.createAFilterRequestParam(FiltersRequestParamFactory.createAnAndFilter(selectedFiltersQuery))
        // }

        // function applyFilters(){
        //     var syncronous = true
        //     vm.vehiclesViewed = 0

        //     //disable after server side filtering
        //     /*check if can toggle to all vehicles
        //     if(!toggleToAllVehicles()){
        //         return
        //     }*/
        //     if(vm.currentTablePageIndex !== 1){
        //         resetTablePageIndex()
        //     }
            
        //     if(!FiltersFactory.isAfilterSelected()){
        //         console.log("None filter selected, show all")
        //         //showAllVehicles(syncronous)
        //         //reset table page state
        //         vm.filterRequestParam = null
        //         goToTablePageWithIndex(1)
        //         return
        //     }else {
        //         //reset search bar
        //         /*if(vm.searchBarText != ""){
        //             console.log("reset search bar before apply filters")
        //             vm.searchBarText = ""
        //             showAllVehicles(syncronous)
        //         }*/
        //     }
            
        //     vm.filterRequestParam = createFilterRequestParam()
        //     callGetVehicles()

        //     /*for (var markerIndex in vm.mapData.vehicleMarkers) {
        //         var marker = vm.mapData.vehicleMarkers[markerIndex]

        //         var isVisible = filtersFunctions.every(function (filterFunc) {
        //             //marker.vehicle
        //             return filterFunc(marker.vehicle)
        //         })

        //         //set visibility in list
        //         marker.vehicle.isHidden = !isVisible
        //         //set visibility in map
        //         if (!isVisible){
        //             vm.markerClusterer.removeMarker(marker)
        //         }
        //         else{
        //             vm.vehiclesViewed+=1
        //         }
        //     }*/
        // }

        // function resetFilters(){
        //     for(var key in vm.filters){
        //         vm.filters[key].selected = []
        //     }
        //     // resetSearchFilters()
        // }

        // function resetSearchFilters(exceptKey){
        //     for(var key in vm.searchFilters){
        //         if(typeof exceptKey !== "undefined"){
        //             if(exceptKey !== key)
        //                 vm.searchFilters[key].selected = null 
        //         }else{
        //             vm.searchFilters[key].selected = null
        //         }
        //     }
        // }

        /*function showOrHideVehicleMarkers(){
            console.log("showOrHideVehicleMarkers")
            for(var key in vm.mapData.vehicleMarkers){
                var marker = vm.mapData.vehicleMarkers[key]

                if(marker.vehicle.isHidden){
                    vm.markerClusterer.removeMarker(marker)
                }
                else{
                    vm.markerClusterer.addMarker(marker)
                }
            }
        }*/

        /*vm.filterHiddenVehicles = function(vehicle){
            return !vehicle.isHidden
        }

        function showAllVehicles(sync){
            console.log("showAllVehicles")
            if(sync){
                console.log("showAllVehicles sync")
                vm.vehicles.forEach(function(vehicle){
                    vehicle.isHidden = false
                })
                vm.vehiclesViewed = vm.vehicles.length
            }
            else{
                async.forEachOf(vm.vehicles,
                    function(vehicle,index,callback){
                        vehicle.isHidden = false
                        callback()
                    },function(error){
                        $scope.$applyAsync(function(){
                            vm.vehiclesViewed = vm.vehicles.length
                        })
                    })
            }

            showAllVehicleMarkers()
        }

        function sortListBy(property){
            if(vm.sortProperty && !vm.sortReversed){
                vm.sortProperty = null
                vm.sortReversed = false
                //console.log("Sorting by", property, "reversed", vm.sortReversed)
                return
            }
            vm.sortProperty = property
            vm.sortReversed = !vm.sortReversed
            //console.log("Sorting by", property, "reversed", vm.sortReversed)
        }*/

        /*function goToScooterOnMap(vehicle){
            for(var markerIndex in vm.mapData.vehicleMarkers){
                var marker = vm.mapData.vehicleMarkers[markerIndex]
                if(marker.vehicle.id == vehicle.id){
                    vm.mainMap.setCenter(new google.maps.LatLng(vehicle.latitude, vehicle.longitude))
                    vm.mainMap.setZoom(12)
                    google.maps.event.trigger(marker, 'click')
                    $location.hash("vehiclesMap")                 
                    $anchorScroll()
                    return
                }
            }
        }*/

        /*function vheicleFilterSelectedWithLevel(level){
            level.filterIsOn? hideMarkersWithLevel(level) : showMarkersWithLevel(level)
        }

        function showMarkersWithLevel(level){
            for(var markerIndex in vm.markers){
                var marker = vm.markers[markerIndex]
                if(level.id == "maintenance"){
                    if(marker.vehicle.inMaintenance){
                        marker.setMap(vm.mainMap)
                        vm.markerClusterer.addMarker(marker)
                    }
                    continue
                }
                if(marker.vehicle.status == level.id && !marker.vehicle.inMaintenance){
                    marker.setMap(vm.mainMap)
                    vm.markerClusterer.addMarker(marker)
                }else{
                    
                    if(level.id == "using"){
                        if(marker.vehicle.status == "unlocked" || marker.vehicle.status == "locked" || marker.vehicle.status == "running" || marker.vehicle.status == "trunkIsOpen"){
                            marker.setMap(vm.mainMap)
                            vm.markerClusterer.addMarker(marker)
                        }
                        continue
                    }
                }
            }
        }

        function hideMarkersWithLevel(level){
            for(var markerIndex in vm.markers){
                var marker = vm.markers[markerIndex]
                if(level.id == "maintenance"){
                    if(marker.vehicle.inMaintenance){
                        marker.setMap(null)
                        vm.markerClusterer.removeMarker(marker)
                    }
                    continue
                }
                if(marker.vehicle.status == level.id && !marker.vehicle.inMaintenance){
                    marker.setMap(null)
                    vm.markerClusterer.removeMarker(marker)
                }else{
                    
                    if(level.id == "using"){
                        if(marker.vehicle.status == "unlocked" || marker.vehicle.status == "locked" || marker.vehicle.status == "running" || marker.vehicle.status == "trunkIsOpen"){
                            marker.setMap(null)
                            vm.markerClusterer.removeMarker(marker)
                        }
                        continue
                    }
                }
            }
        }*/

        function openVehicleAddDialog(ev, vehicle) {
            $mdDialog.show({
                controller         : 'VehicleAddDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/vehicle/dialogs/vehicle-add-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            }).then(function (refresh) {
                if(refresh){
                    vm.applyFiltersTrigger();
                }
            });

        }

        function openVehiclesBulkUpdateDialog(ev) {
            VehicleDialogFactory.showVehiclesBulkUpdate(ev)
                .then(function(){
                    // console.log("update vehicles closed")
                })

        }

        function generateVehicleDetailsLink(vehicle){
            return $state.href(VehicleDetailsPage,{vehicleId: vehicle.id})
        }

        function goToVehicleDetails(vehicle,event){
            event.stopPropagation()
            return $state.go(VehicleDetailsPage,{vehicleId: vehicle.id})
        }
        
        function generateCurrentUserDetailsLink(vehicle){
            return vm.hasVehicleACurrentBooking(vehicle) ? $state.href(UserDetailsPage,{userId: vehicle.bookings[0].user.id}) : ""
        }

        function getVehicleExternalStatuses(vehicle) {
            return VehicleUtility.getVehicleExternalStatuses(vehicle)
        }

    }

    /** @ngInject */
    function VehicleDialogFactory($mdDialog,$document) {

        return{
            show: function (ev,vehicle,vehicles) {

                return $mdDialog.show({
                    controller         : 'VehicleDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/vehicle/dialogs/vehicle-dialog.html',
                    parent             : angular.element($document.body),//angular.element($document.find('#content-container'))
                    targetEvent        : ev,
                    clickOutsideToClose: true,
                    locals             : {
                        Vehicle : vehicle,
                        Vehicles: vehicles
                    }
                });
            },
            showTestAction: function(ev,vehicle){
                return $mdDialog.show({
                    controller         : 'VehicleTestActionDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/vehicle/dialogs/vehicle-test-action-dialog.html',
                    parent             : angular.element($document.body),
                    targetEvent        : ev,
                    locals: {
                        Vehicle : vehicle
                    }
                });
            },
            showTootGif: function(ev){
                return $mdDialog.show({
                    controller         : 'VehicleTootGifDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/vehicle/dialogs/vehicle-toot-gif-dialog.html',
                    parent             : angular.element($document.body),
                    targetEvent        : ev,
                    clickOutsideToClose: true
                });
            },
            showVehiclesBulkUpdate: function(ev){
                return $mdDialog.show({
                    controller         : 'VehicleBulkUpdateDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/vehicle/dialogs/vehicle-bulk-update-dialog.html',
                    parent             : angular.element($document.body),
                    targetEvent        : ev,
                    clickOutsideToClose: false
                })
            }
        }
    }
}());

/**
 * Created by alex on 05/01/17.
 */
(function () {

    angular
        .module('app.utility')
        .value('AppConstants', {
            REFRESHDATAINTERVAL: 5 * 60 * 1000,
            CSVPAGELIMIT: 2000,
        })
        .value('ToHireDefaultColor', {
            blue: '#284678',
            azure: '#13A7BF',
            grey: '#5B5B5B',
            yellow: '#E5C14E',
            lobster: '#E75C42',
            criticalRed: '#D01616',
            purple: '#521945',
            maintenanceRed: '#D01006',
            green: '#1BA125',
            fuchsia: '#E33497',
            violet: '#9745E2',
            pink: '#FF4758',
        })
        .value('RentBookingStatus', [
            { id: 0, name: 'CREATED', color: 'md-yellow-500-bg' },
            { id: 1, name: 'ASSIGNED', color: 'md-green-500-bg' },
            { id: 2, name: 'ERROR', color: 'md-red-500-bg' },
            { id: 3, name: 'STARTED', color: 'md-blue-500-bg' },
            { id: 4, name: 'READY', color: 'md-blue-500-bg' },
            { id: 5, name: 'FINISHED', color: 'md-blue-500-bg' },
            { id: 6, name: 'NOT_PAYED', color: 'md-red-500-bg' },
            { id: 7, name: 'PAYMENT_PENDING', color: 'md-yellow-500-bg' },
            { id: 8, name: 'PAYMENT_REFUSED', color: 'md-red-500-bg' },
            { id: 9, name: 'PAYMENT_ACCEPTED', color: 'md-blue-500-bg' },
            { id: 10, name: 'CANCELLED', color: 'md-red-500-bg' },
        ])
        .value('TokenData', {
            TOKEN: 'token',
            EXPIRE: 'expire',
        })
        .value('ServiceTokenData', {
            TOKEN: 'serviceToken',
            COMPANY: 'companyName',
        })
        .value('MiscData', {
            ISUSERLOGGED: 'isUserLogged',
            USERID: 'userId',
            SITE: 'site',
            TIMEZONE: 'timezone',
            DETAILSID: 'detailsId',
            USERSITE: 'userSite'
        })
        .constant('DefaultSite', {
            id: -1,
            name: 'All cities',
        })
        .constant('ServerDomain', {
            TOHIRE: 'core.2hire.io',
        })
        .value('RentalBookingType', {
            RESERVATION: 0,
            RENTAL_AGREEMENT: 1,
        })
        .value('RentalBookingColor', {
            RESERVATION: 'md-red-400-bg',
            RENTAL_AGREEMENT: 'md-blue-400-bg',
        })
        .value('CategoryTypes', {
            CAR: { value: 'car', name: 'Car' },
            SCOOTER: { value: 'scooter', name: 'Scooter' },
            BIKE: { value: 'bike', name: 'Bike' },
            ALL: { value: 'all', name: 'All' },
        })
        .value('DocumentTypes', {
            IDENTITY_CARD: { value: 'id_card', name: 'Identity Card' },
            PASSPORT: { value: 'passport', name: 'Passport' },
        })
        .value('VehicleTypes', {
            SCOOTER: { value: 'scooter', name: 'Scooter' },
            KICK_SCOOTER: { value: 'kick', name: 'Kick Scooter' },
            CAR: { value: 'car', name: 'Car' },
            BIKE: { value: 'bike', name: 'Bike' },
        })
        .value('MultiVehicleType', {
            // BASE : {value: "base", name: "Default"},
            SCOOTER: { value: 'scooter', name: 'Scooter' },
            KICK_SCOOTER: { value: 'kick', name: 'Kick Scooter' },
            CAR: { value: 'car', name: 'Car' },
            BIKE: { value: 'bike', name: 'Bike' },
        })
        .value('VehicleStatusColor', {
            free: '#4CAF50',
            booked: '#284678',
            unlocked: '#284678',
            running: '#284678',
            parked: '#284678',
            locked: '#284678',
        })
        .value('VehicleDocumentTypes', {
            REGISTRATION_CERTIFICATE: { value: 0, name: 'Vehicle registration certificate' },
            REGISTRATION_BOOK: { value: 1, name: 'Vehicle registration book' },
            INSURANCE: { value: 2, name: 'Vehicle insurance' },
            ROAD_TAX: { value: 3, name: 'Road Tax' },
        })
        .value('PersonTypes', {
            PERSON: { value: 'person', name: 'Person' },
            LEGAL_ENTITY: { value: 'legal_entity', name: 'Legal Entity' },
        })
        .value('FuelTypes', {
            GASOLINE: { value: 'gasoline', name: 'Gasoline' },
            DIESEL: { value: 'diesel', name: 'Diesel' },
            BIODIESEL: { value: 'biodiesel', name: 'Biodiesel' },
            ELECTRICITY: { value: 'electricity', name: 'Electricity' },
            HYDROGEN: { value: 'hydrogen', name: 'Hydrogen' },
            PROPANE: { value: 'propane', name: 'Propane' },
            ETHANOL: { value: 'ethanol', name: 'Ethanol' },
            CNG: { value: 'cng', name: 'Compressed Natural Gas' },
        })
        .value('DamageStatus', {
            CREATED: 0,
            REVIEWED: 1,
            PROCESSING: 2,
            FIXED: 3,
            NOT_CREATED: 4,
        })
        .value('DamageStatusViewer', [
            { value: 0, name: 'Created' },
            { value: 1, name: 'Reviewed' },
            { value: 2, name: 'Processing' },
            { value: 3, name: 'Fixed' },
            { value: 4, name: 'Not Created' },
        ])
        .value('DamageInstantSpotted', {
            BEFORE: 0,
            DURING: 1,
            AFTER: 2,
        })
        .value('DamageInstantSpottedViewer', [
            { value: 0, name: 'Before booking' },
            { value: 1, name: 'During' },
            { value: 2, name: 'After' },
        ])
        .value('VehicleStatus', {
            FREE: { value: 'free', name: 'Free' },
            BOOKED: { value: 'booked', name: 'Booked' },
            UNLOCKED: { value: 'unlocked', name: 'Unlocked' },
            RUNNING: { value: 'running', name: 'Running' },
            TRUNKISOPEN: { value: 'trunkIsOpen', name: 'Trunk open' },
            PARKED: { value: 'parked', name: 'Parked' },
            LOCKED: { value: 'locked', name: 'Locked' },
            UNAVAILABLE: { value: 'unavailable', name: 'Unavailable' },
        })
        .value('VehicleTripStatus', {
            BOOKED: { value: 0, name: 'Booked' },
            PRE_RIDING: { value: 1, name: 'Pre riding' },
            RIDING: { value: 2, name: 'Riding' },
            PAUSED: { value: 3, name: 'Paused' },
            FINISHED: { value: 4, name: 'Finished' },
        })
        .value('VehicleBookingStatus', {
            CREATED: { value: 0, name: 'Booked' },
            STARTED: { value: 1, name: 'Riding' },
            FINISHED: { value: 2, name: 'Finished' },
            DELETED: { value: 3, name: 'Deleted' },
        })
        .value('VehicleExternalStatus', {
            PARKED: { value: 'parked', name: 'Parked' },
            TRIP: { value: 'trip', name: 'Trip' },
            PAUSED: { value: 'paused', name: 'Paused' },
            OUTSIDE_OPERATING_AREA: { value: 'outside_operating_area', name: 'Outside Area' },
            LOW_BATTERY: { value: 'low_battery', name: 'Low Battery' },
            MAINTENANCE: { value: 'repair_shop', name: 'Maintenance' },
            CONNECTION_ISSUE: { value: 'connection_issues', name: 'Connection Issue' },
            ACTION_NEEDED: { value: 'action_needed', name: 'Action Needed' },
        })
        .value('UserSexType', {
            MALE: { value: 'male', name: 'Male' },
            FEMALE: { value: 'female', name: 'Female' },
        })
        .value('UserStatus', {
            INCOMPLETE_SIGN_UP: { value: 0, name: 'Incomplete sign up' },
            FULLY_REGISTERED: { value: 1, name: 'Fully registered' },
            VERIFICATION_PENDING: { value: 2, name: 'Verification pending' },
            ACTIVATED_USER: { value: 3, name: 'Activated user' },
            PAYMENT_PENDING: { value: 4, name: 'Payment pending' },
            ID_EXPIRED: { value: 5, name: 'ID expired' },
            DRIVING_LICENSE_EXPIRED: { value: 6, name: 'Driving license expired' },
            PAYMENT_METHOD_EXPIRED: { value: 7, name: 'Payment method expired' },
            BLOCKED_USER: { value: 8, name: 'Blocked user' },
            MISSING_PAYMENT: { value: 9, name: 'Missing payment' },
            MISSING_ID: { value: -2, name: 'Missing ID' },
            MISSING_DRIVING_LICENSE: { value: -3, name: 'Missing DL' },
            MISSING_AVATAR: { value: -4, name: 'Missing Selfie' },
        })
        .value('UserPaymentStatus', {
            NONE: { value: 'none', name: 'None' },
            CREATED: { value: 'created', name: 'Created' },
            AUTHORIZED: { value: 'authorized', name: 'Authorized' },
            AUTHORIZATION_PENDING: { value: 'authorization_pending', name: 'Authorization pending' },
            AUTHORIZATION_FAILED: { value: 'authorization_failed', name: 'Authorization failed' },
            AUTHORIZATION_ERROR: { value: 'authorization_error', name: 'Authorization error' },
            CAPTURED_PENDING: { value: 'capture_pending', name: 'Pending' },
            CAPTURED: { value: 'captured', name: 'Paid' },
            CAPTURED_FAILED: { value: 'capture_failed', name: 'Failed' },
            CAPTURED_ERROR: { value: 'capture_error', name: 'Error' },
            RETRYING: { value: 'retrying', name: 'Retrying' },
            REFUNDED: { value: 'refunded', name: 'Refunded' },
            DO_NOT_RETRY: { value: 'do_not_retry', name: 'Do not retry' },
            PREAUTHORIZATION_PENDING: { value: 'preauthorization_pending', name: 'Pre-authorization pending' },
            PREAUTHORIZATION_FAILED: { value: 'preauthorization_failed', name: 'Pre-authorization failed' },
            PREAUTHORIZATION_ERROR: { value: 'preauthorization_error', name: 'Pre-authorization error' },
            PREAUTHORIZED: { value: 'preauthorized', name: 'Pre-authorized' },
            CANCELLATION_PENDING: { value: 'cancellation_pending', name: 'Cancellation pending' },
            CANCELLATION_FAILED: { value: 'cancellation_failed', name: 'Cancellation failed' },
            CANCELLATION_ERROR: { value: 'cancellation_error', name: 'Cancellation error' },
            CANCELLED: { value: 'cancelled', name: 'Cancelled' },
            ADJUSTMENT_PENDING: { value: 'adjustment_pending', name: 'Adjustment pending' },
            ADJUSTMENT_FAILED: { value: 'adjustment_failed', name: 'Adjustment failed' },
            ADJUSTMENT_ERROR: { value: 'adjustment_error', name: 'Adjustment error' },
            ADJUSTED: { value: 'adjusted', name: 'Adjusted' },
        })
        .value('UserDocumentStatus', {
            WAITING_FOR_APPROVAL: { value: -1, name: 'Waiting for approval' },
            NOT_VALID: { value: 0, name: 'Not valid' },
            VALID: { value: 1, name: 'Valid' },
            REJECTED: { value: 2, name: 'Rejected' },
        })
        .value('UserLicenseStatus', {
            WAITING_FOR_APPROVAL: { value: -1, name: 'Waiting for approval' },
            NOT_VALID: { value: 0, name: 'Not valid' },
            VALID: { value: 1, name: 'Valid' },
            REJECTED: { value: 2, name: 'Rejected' },
        })
        .value('MaintenanceStatus', {
            OPEN: { value: 0, name: 'Open' },
            WORKING: { value: 1, name: 'Working' },
            FINISHED: { value: 2, name: 'Finished' },
            BLOCKED: { value: 3, name: 'Blocked' },
        })
        .value('MaintenanceType', {
            GENERIC: { value: 0, name: 'Generic' },
            CLEANING: { value: 1, name: 'Cleaning' },
            FUELING: { value: 2, name: 'Fueling' },
            REPAIRING: { value: 3, name: 'Repairing' },
            TESTING: { value: 4, name: 'Testing' },
            NOT_FOUND: { value: 5, name: 'Incorrect position' },
            FLAT_TIRE: { value: 6, name: 'Flat tire' },
            NO_BATTERY: { value: 7, name: 'No battery' },
            REPAIR_MIRRORS: { value: 8, name: 'Repair mirrors' },
            DIRTY_SCOOTER: { value: 9, name: 'Dirty scooter' },
            TOP_CASE: { value: 10, name: 'Top case' },
        })
        .value('MaintenanceCategory', {
            MINOR_ACTION: { value: 0, name: 'Minor action' },
            MAJOR_ACTION: { value: 1, name: 'Major action' },
        })
        .value('FareType', {
            MINUTES: { value: 0, name: 'Minute' },
            KM: { value: 1, name: 'Kilometer' },
            HALF_HOUR: { value: -1, name: 'Half Hour' }, //INTERNAL
        })
        .value('OutsideAreaFareType', {
            ONE_TIME: { value: 0, name: 'One time' },
            MINUTES: { value: 1, name: 'Min' },
        })
        .value('PaymentRequestType', {
            TRIP: { value: 0, name: 'Each trip' },
            DAY: { value: 1, name: 'Each day' },
            WEEK: { value: 2, name: 'Each week' },
            MONTH: { value: 3, name: 'Each month' },
        })
        .value('InvoiceFileType', {
            HTML: { value: 0, name: 'HTML' },
            LATEX: { value: 1, name: 'LATEX' },
        })
        .value('InvoiceType', {
            TICKET: { value: 0, name: 'Ticket' },
            RECTIFIED_TICKET: { value: 1, name: 'Rectified' },
            // INVOICE: { value: 2, name: "Invoice" }
        })
        .value('InvoiceElementType', {
            BOOKING: 0,
            GENERIC: 1,
            MANUAL_TRANSACTION: 2,
            LONG_TERM_BOOKING: 3,
            SHOP_ORDER: 4,
        })
        .value('InvoiceStatus', {
            ACTIVE: { value: 0, name: 'Active' },
            TRANSFER: { value: 1, name: 'Revoked' },
        })
        .value('MatchedTripStatus', {
            READY: { value: 'ready', name: 'Ready' },
            PENDING: { value: 'pending', name: 'Pending' },
            FAILED: { value: 'failed', name: 'Failed' },
        })
        .value('CouponType', {
            // KM: {value: 0, name: "Km"},
            MINUTES: { value: 1, name: 'Credit' },
            // PERCENTAGE: {value: 2, name: "%"},
            REFERRAL: { value: 3, name: 'Credit(Referral)' },
            NEW_USERS: { value: 4, name: 'Credit(New users)' },
        })
        .value('DeviceStatus', {
            DETACHED: { value: 0, name: 'Detached' },
            ATTACHED: { value: 1, name: 'Attached' },
        })
        .value('DeviceType', {
            PERSONAL: { value: 0, name: '2hire' },
            NIU: { value: 1, name: 'NIU' },
            SEGWAY: { value: 3, name: 'Segway' },
            CONCOX: { value: 4, name: 'Concox' },
            OMNILOCK: { value: 5, name: 'Omnilock' },
            OKAI: { value: 6, name: 'Okai' },
            OMNI_NINEBOT: { value: 7, name: 'Omni-Ninebot' },
            TWOAA: { value: 8, name: '2hireAsAdapter' },
        })
        .value('VehicleGeofenceOptions', {
            DEFAULT: { color: '#7C97C4', opacity: 0.3, zIndex: 10 },
            SCOOTER: { color: '#7C97C4', opacity: 0.3, zIndex: 10 },
            KICK_SCOOTER: { color: '#00ff00', opacity: 0.1, zIndex: 1 },
        })
        .value('VehicleServiceGroupTag', {
            movo: {
                MOVO: { value: 0, name: 'Movo' },
                MUVU: { value: 1, name: 'Muvu' },
            },
            kirrk: {
                KIRRK: { value: 0, name: 'Kirrk' },
            },
            govolt: {
                GOVOLT: { value: 0, name: 'GoVolt' },
            },
            ride: {
                RIDE: { value: 0, name: 'Ride' },
            },
        })
        .value('MovoUnavailableDescriptor', {
            NONE: { value: 0, name: 'None' },
            WAREHOUSE: { value: 1, name: 'Warehouse' },
            MAINTENANCE: { value: 2, name: 'Maintenance' },
            TRANSPORTATION: { value: 3, name: 'Transportation' },
            WANTED: { value: 4, name: 'Wanted' },
            STOLEN: { value: 5, name: 'Stolen' },
            FAILED_STOP: { value: 6, name: 'Failed Stop' },
        })
        .value('TransactionTag', {
            BOOKING: 'booking',
            SHOP_ORDER: 'shop_order',
            MANUAL: 'manual',
            LONG_TERM_BOOKING: 'long_term_booking',
        })
        .value('ClientType', {
            UNKNOWN: { value: 0, name: 'Standard' },
            CABIFY: { value: 1, name: 'Cabify' },
            TELEPASS_PAY: { value: 2, name: 'Telepass Pay' },
        })
        .value('OkaiCommand', {
            REBOOT: 0x3,
            POWEROFF: 0x4,
            HEAD_LAMP_ON: 0x9,
            HEAD_LAMP_OFF: 0xa,
            WARN: 0xb,
            ECU_UNLOCK: 0xf,
            ECU_LOCK: 0x10,
            THROTTLE_ON: 0x18,
            THROTTLE_OFF: 0x19,
            BATTERY_COMPARTMENT_UNLOCK: 0x13,
            BATTERY_COMPARTMENT_LOCK: 0x14,
        })
        .value('BonusTemplateType', {
            CREDIT: { value: 'CREDIT', name: 'Credit' },
            PASS: { value: 'PASS', name: 'Pass' },
        })
        .value('BonusTemplateValidityTimeType', {
            UNBOUNDED: { value: 'UNBOUNDED', name: 'No limit' },
            TIMESTAMP: { value: 'TIMESTAMP', name: 'Date' },
            DURATION_FROM_ACQUISITION: { value: 'DURATION_FROM_ACQUISITION', name: 'Duration from acquisition' },
        })
        .value('CouponTemplateValidityTimeType', {
            UNBOUNDED: { value: 'UNBOUNDED', name: 'No limit' },
            TIMESTAMP: { value: 'TIMESTAMP', name: 'Date' },
        })
        .value('MapProvider', {
            GOOGLE_MAPS: 0,
            MAPBOX: 1,
        });
})();

/**
 * Created by Alex on 22/12/16.
 */

(function ()
{
    'use strict';

    angular
        .module('app.utility')
        .factory('MiscUtility',MiscUtilityFactory)
        .factory('EnrichDataUtility',EnrichDataUtilityFactory)
        .factory('HttpHeadersManager',HttpHeadersManagerFactory)
        .factory('LocalStorageService',LocalStorageServiceFactory)
        .factory('SessionStorageService',SessionStorageServiceFactory)
        .factory('ShowToast',ShowToastFactory)
        .factory('DialogFactory',DialogFactory)
        .factory('VehicleUtility',VehicleUtilityFactory)
        .factory('MapUtility',MapUtilityFactory)
        .factory('OrderRequestParamFactory',OrderRequestParamFactory)
        .factory('FiltersRequestParamFactory',FiltersRequestParamFactory)
        .factory("FiltersFactory",FiltersFactory)
        .factory('TripUtility',TripUtilityFactory)
        .factory('UserUtility',UserUtilityFactory)
        .factory('MaintenanceUtility',MaintenanceUtilityFactory)
        .factory('FareUtility',FareUtilityFactory)
        .factory('TransactionUtility',TransactionUtilityFactory)
        .factory('InvoiceUtility',InvoiceUtilityFactory)
        .factory('DamageUtility',DamageUtilityFactory)
        .factory('CouponUtility',CouponUtilityFactory)
        .factory('DeviceUtility',DeviceUtilityFactory)
        .factory('GeofenceUtility',GeofenceUtilityFactory)
        .service('CurrentNewRentalBooking',CurrentNewRentalBooking)
        .service('CurrentNewUser',CurrentNewUser)
        .service('CategoryService',CategoryService)
        .service('RentStationService',RentStationService)
        .service('RateService',RateService)
        .service('UserService',UserService)
        .service('GeofenceService',GeofenceService)
        .service('AppSettings',AppSettings)
        .service('AppConfigurations',AppConfigurations)
        .service('ServiceData',ServiceData)
        .service('ServiceSettings',ServiceSettings)
        .service('SitesService',SitesService)
        .service('LogInUtility',LogInUtility)
        .service('LogInService',LogInService)
        .service('GenericAppData',GenericAppDataService)
        .filter('toDate',ToDateFilter)
        .filter('toNumber',ToNumberFilter)
        .filter('toCurrency',ToCurrencyFilter)
        .directive('ngModel', TimeFormatFixer)
        .directive('ngUploadChange', DetectUploadChange)
        .directive('numberConverter', ToggleNumber)
        .factory('ErrorUtility',ErrorUtilityFactory)
        .factory("MyHttpInterceptor",MyHttpInterceptor)
        .service("GenerateCSVService",GenerateCSVService)
        .factory("MapDrawingUtilities", MapDrawingUtilities)
        .factory("NewDashboardGatewayUtility", NewDashboardGatewayUtility)

    /** @ngInject */
    function MiscUtilityFactory(ServiceSettings, toCurrencyFilter, DefaultSite, $interval, $timeout, AppConstants){
        
        function isMobileDevice() {
            var isMobileDevice = false
            if (
                navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i)
            ) {
                isMobileDevice = true;
                console.warn('You are on a mobile device!');
            }
            return isMobileDevice
        }

        function isIOS() {
            return (
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i)
            );
        }

        function shiftMomentToJs(utc, siteId) {
            return ServiceSettings.getServiceSettings(function(settings){
                var tempDate;
                var siteTimezone = ServiceSettings.getSiteTimezone(siteId);
                
                if(siteTimezone === undefined || siteTimezone === null) {
                    console.warn('shiftMomentToJs: no timezone for this site return null', siteTimezone)
                    return null;
                }
                
                if(utc !== null && utc !== undefined) {
                    tempDate = moment.tz(utc, siteTimezone);
                } else {
                    tempDate = moment.tz(siteTimezone);
                }
                return new Date(tempDate.year(), tempDate.month(), tempDate.date(), tempDate.hours(), tempDate.minute(), tempDate.second());
            })
        }
        
        function shiftJstoMoment(jsDate, siteId) {
            return ServiceSettings.getServiceSettings(function(settings){
                var timezone = ServiceSettings.getSiteTimezone(siteId)

                if(timezone === undefined || timezone === null){
                    console.warn('shiftJstoMoment: no timezone for this site return null', timezone)
                    return null
                }

                return moment.tz({ year: jsDate.getFullYear(), month: jsDate.getMonth(), day: jsDate.getDate(), hour: jsDate.getHours(), minute: jsDate.getMinutes(), second: jsDate.getSeconds() }, timezone)
            })
        }

        function createTzMoment(utc, siteId){
            return ServiceSettings.getServiceSettings(function(settings){
                var timezone = ServiceSettings.getSiteTimezone(siteId);

                if(siteId === DefaultSite.id){
                    timezone = moment.tz.guess()
                    // console.warn('createTzMoment: no timezone for this all cities, use browser one', timezone,siteId,settings)
                }

                if(timezone === undefined || timezone === null){
                    console.warn('createTzMoment: no timezone for this site return null', timezone)
                    return null
                }

                return utc ? moment.tz(utc, timezone) : moment.tz(timezone); 
            });
        }

        function serviceTodayDate(siteId) {
            return ServiceSettings.getServiceSettings(function(settings){
                var tempDate = null
                var timezone = ServiceSettings.getSiteTimezone(siteId)

                if(siteId === DefaultSite.id){
                    // console.warn('serviceTodayDate: all cities selected, use browser timezone', timezone, siteId, settings)
                    timezone = moment.tz.guess()
                }

                if(timezone === undefined || timezone === null) {
                    // console.warn('serviceTodayDate: no timezone for this siteId, set base settings', timezone, siteId, settings)
                    timezone = settings.timezone // selected site
                }
        
                if(timezone === undefined || timezone === null){
                    console.warn('serviceTodayDate: no default timezone return null', timezone)
                    return null
                }
                
                tempDate = moment.tz(timezone)

                return new Date(tempDate.year(), tempDate.month(), tempDate.date(), tempDate.hours(), tempDate.minute(), tempDate.second())
            })
        }

        function getCurrencyValue(price, siteId, format) {
            return toCurrencyFilter(price, siteId, format)
        }

        function internalMergeObject(objA,objB) {
            //merge A in B
            if(Object.keys(objA).length == 0){
                return objB
            }

            if(Object.keys(objB).length == 0){
                return objA
            }

            for(var key in objA){

                if(objA[key] === null || objA[key] === undefined){
                    // console.warn("key in A is null",key,objA[key])
                    continue
                }

                if(typeof objA[key] !== "object" || Array.isArray(objA[key])){
                    // console.log("replace A in B",objA[key],objB[key])
                    objB[key] = objA[key]
                }else{

                    if(objB.hasOwnProperty(key)){
                        // console.log("objA[key] is obj",objA[key],objB[key])
                        objB[key] = deepMergeObjects(objA[key],objB[key])
                    }
                    else{
                        // console.log("add A in B",objA[key],objB)
                        objB[key] = objA[key]
                    }
                }
            }
            return objB
        }

        function deepMergeObjects(objA,objB) {
            return internalMergeObject(objA,angular.copy(objB))
        }

        function limitQueue(limit){
            
            var queue = {
                queued: [],
                limit: limit,
                resolved: 0,
                active: 0,
                aborted: false,
                started: false,
                ended: false,
                endCallback: null,
                startSize: 0
            }

            function join(fn){
                queue.queued.push(fn)
                queue.startSize = queue.queued.length
            }

            function onLimitQueueEnd(){
                if(queue.ended){
                    // console.warn("queue already ended",queue)
                    return
                }
                queue.ended = true
                queue.started = false

                if(queue.endCallback){
                    if(queue.aborted){
                        queue.endCallback({reason: "abort"})
                    }else{
                        queue.endCallback()
                    }
                }
            }

            function runOrStand(){
                // console.log("runOrStand start active",queue.active,"limit",queue.limit,"resolved", queue.resolved)
                
                if(queue.aborted){
                    // console.warn("queue aborted", queue)
                    return
                }

                if(queue.queued.length == 0){
                    // console.warn("empty queue")
                    return
                }

                if(queue.active >= queue.limit){
                    // console.warn("limit exceeded, active", queue.active)
                    return
                }
                
                const fn = queue.queued.shift()
                queue.active++
                
                fn(function(){
                    queue.active -= 1
                    queue.resolved +=1

                    if(queue.resolved == queue.startSize){
                        onLimitQueueEnd()
                    }else{
                        runOrStand()
                    }
                })
            }

            function start(cb){

                if(queue.started){
                    console.warn("start: limit queue already started")
                    return
                }

                queue.started = true

                if(!cb){
                    console.warn("start: null callback",cb)
                }else{
                    queue.endCallback = cb
                }

                for(var i = 0; i < queue.limit; i++){
                    runOrStand()
                }
            }

            function abort(){
                console.warn("queue abort", queue)
                queue.aborted = true
                onLimitQueueEnd()
            }

            return { join: join, start: start, abort: abort}
        }

        function createRefreshDataInterval(fn, intervalTime){

            if(!fn || isNaN(intervalTime)){
                console.warn("createRefreshDataInterval: invalid input", fn, intervalTime)
                return null
            }

            var obj = {
                fn: fn,
                intervalTime: intervalTime,
                intervalId: -1,
                start: startInterval,
                stop: stopInterval,
                reset: resetInterval
            }
            
            function startInterval(){

                if(obj.intervalId != -1){
                    console.warn("startInterval: another interval is running, reset")
                    stopInterval()
                }

                obj.intervalId = $interval(obj.fn, obj.intervalTime)
            }

            function stopInterval(){
                if(obj.intervalId == -1){
                    // console.warn("stopInterval: interval was already stopped")
                    return
                }
                $interval.cancel(obj.intervalId)
                obj.intervalId = -1
            }

            function resetInterval(){
                stopInterval()
                startInterval()
            }

            return obj
        }

        function downloadPaginatedData(paginationFilterRequestParam, getDataFunction, cb) {
            var limit = paginationFilterRequestParam.limit || AppConstants.CSVPAGELIMIT
            var offset = paginationFilterRequestParam.offset || 0
            const startTime = moment().valueOf()
            var allData = []
            var errorCounter = 0
            var downloadStopped = false

            function getHandler(data, error) {

                if(downloadStopped){
                    return
                }

                var localData = data.hasOwnProperty('data') ? data.data : data
                if (error) {
                    if (errorCounter > 5) {
                        cb(null, true)
                    } else {
                        errorCounter++;
                        $timeout(
                            function () {
                                getDataFunction(paginationFilterRequestParam, getHandler, false)
                            },
                            errorCounter * 1000
                        )
                    }
                } else {
                    errorCounter = 0;
                    if (localData.length == 0) {
                        console.log("end downloading all data, elapsed seconds", moment().valueOf() - startTime)
                        cb(allData, null)
                    } else {
                        allData = allData.concat(localData)
                        offset = offset + limit
                        paginationFilterRequestParam.offset = offset
                        getDataFunction(paginationFilterRequestParam, getHandler, false)
                    }
                }
            }

            console.log("start downloading all data", startTime)
            getDataFunction(paginationFilterRequestParam, getHandler, false)
            
            function stopDownload(){
                downloadStopped = true
            }

            return stopDownload
        }

        function generateCreditValue(millis, siteId){
            if(typeof siteId === "undefined" || siteId === null){
                console.warn("generateCreditValue: invalid siteId",siteId)
                return null
            }
            const millisToCredit = ServiceSettings.getMillisToCredit(siteId)
            // console.log("millisToCredit",millisToCredit)
            return (Math.floor(millis * millisToCredit * 100) / 100)
        }
        
        function generateMillisecondsValue(credit, siteId){
            if(typeof siteId === "undefined" || siteId === null){
                console.warn("generateMillisecondsValue: invalid siteId",siteId)
                return null
            }
            const millisToCredit = ServiceSettings.getMillisToCredit(siteId)
            // console.log("millisToCredit",millisToCredit)
            const millis = Math.round(credit / millisToCredit)
            // console.log("millis value", millis)
            return millis
        }

        return {
            isMobileDevice: isMobileDevice,
            isIOS: isIOS,
            shiftMomentToJs: shiftMomentToJs,
            shiftJstoMoment: shiftJstoMoment,
            createTzMoment: createTzMoment,
            serviceTodayDate: serviceTodayDate,
            getCurrencyValue: getCurrencyValue,
            deepMergeObjects: deepMergeObjects,
            createLimitQueue: limitQueue,
            createRefreshDataInterval: createRefreshDataInterval,
            downloadPaginatedData: downloadPaginatedData,
            generateCreditValue: generateCreditValue,
            generateMillisecondsValue: generateMillisecondsValue,
        };
    }

    /** @ngInject */
    function EnrichDataUtilityFactory(toDateFilter,VehicleUtility,DeviceUtility,DeviceType,DeviceStatus,TripUtility,TransactionUtility,InvoiceElementType,UserUtility,DamageUtility,AppSettings){
        function generateVehicleUsefulData(vehicles){

            if(!vehicles){
                console.warn("EnrichDataUtilityFactory.generateVehicleUsefulData: invalid input",vehicles)
                return
            }

            vehicles.forEach(function(vehicle){
                
                VehicleUtility.parseVehicleExtraInfo(vehicle)

                vehicle.lastMoved = VehicleUtility.getVehicleLastMoved(vehicle)
                vehicle.lastUpdate = vehicle.fixtaken ? toDateFilter(vehicle.fixtaken,"dateTime", vehicle.SiteId) : "No updates"
                
                vehicle.currentUser = VehicleUtility.getVehicleCurrentUser(vehicle)
                vehicle.lastUser = VehicleUtility.getVehicleLastUser(vehicle)
                vehicle.externalStatusHuman = VehicleUtility.getVehicleExternalStatuses(vehicle)
                vehicle.km = parseInt(vehicle.km)
                vehicle.total_percentage = parseInt(vehicle.total_percentage)
                //set default device provider
                vehicle.deviceType = (typeof vehicle.deviceType != "undefined" && vehicle.deviceType != null) ? vehicle.deviceType : DeviceType.PERSONAL.value
                vehicle.deviceTypeHuman = DeviceUtility.getDeviceTypeDescription(vehicle)
                if(vehicle.user){
                    generateUserUsefulData([vehicle.user])
                }

            })
        }

        function generateDeviceUsefulData(devices){

            if(!devices){
                console.warn("EnrichDataUtilityFactory.generateDeviceUsefulData: invalid input",devices)
                return
            }

            devices.forEach(function(device){
                if(!device.status){

                    if(device.vehicle){
                        generateVehicleUsefulData([device.vehicle])
                        device.status = DeviceStatus.ATTACHED.value
                    }
                    else{
                        device.status = DeviceStatus.DETACHED.value
                    }
                }
            })
        }

        function generateTripUsefulData(trips){
            if(!trips){
                console.warn("EnrichDataUtilityFactory.generateTripUsefulData: invalid input",trips)
            }
            trips.forEach(function (trip) {

                trip.duration = TripUtility.calculateTripDuration(trip)
                trip.totalKm = TripUtility.calculateTripTotalKm(trip)
                trip.isHanged = TripUtility.isVehicleHangedToTrip(trip)
                
                if(trip.User){
                    generateUserUsefulData([trip.User])
                }

                if(trip.Vehicle){
                    generateVehicleUsefulData([trip.Vehicle])
                }
            })
        }

        function generateInvoiceUsefulData(invoices){

            if(!invoices){
                console.warn("EnrichDataUtilityFactory.generateInvoiceUsefulData: invalid input",invoices)
                return
            }
            const serviceName = AppSettings.getServiceName().replace(/-test.*$/g,"").replace(/-multisite.*$/g,"").toLowerCase();

            invoices.forEach(function(invoice){
                invoice.totalPrice = 0
                invoice.description = ""
                invoice.paymentStatusHuman = ""
                var invoicePriceParts = []
                
                if(invoice.elements){
                    invoice.elements.forEach(function(elem){
                        invoicePriceParts.push(elem.Resource)
                        if(elem.type == InvoiceElementType.GENERIC){
                            invoice.description = (elem.Resource.description || "")
                        }
                        else if(elem.type == InvoiceElementType.BOOKING){
                            if(elem.Resource){
                                invoice.description = 
                                    serviceName === "movo" ? 
                                        "Viaje MOVO alquiler de vehiculo por minutos" 
                                        : ("Trip for vehicle ID: " + (elem.Resource.VehicleId || ""))
                                if(elem.Resource.Transactions.length>0)
                                    invoice.paymentStatusHuman = TransactionUtility.getTransactionStatusDescription(elem.Resource.Transactions[0])
                            }
                        } else if (elem.type == InvoiceElementType.MANUAL_TRANSACTION){
                            invoice.description = TransactionUtility.getTransactionDescription(elem.Resource)
                            if(elem.Resource){
                                invoice.paymentStatusHuman = TransactionUtility.getTransactionStatusDescription(elem.Resource)
                            }
                        } else if (elem.type == InvoiceElementType.LONG_TERM_BOOKING){
                            if(elem.Resource && elem.Resource.Transaction){
                                invoice.description = "Long Term Sharing ID: " + elem.Resource.id
                                invoice.paymentStatusHuman = TransactionUtility.getTransactionStatusDescription(elem.Resource.Transaction)
                                elem.Resource.price = elem.Resource.Transaction.price
                            }
                        } else if (elem.type == InvoiceElementType.SHOP_ORDER){
                            if(elem.Resource && elem.Resource.Transaction){
                                // console.log("elem",elem.Resource)
                                const shopOrder = elem.Resource;
                                invoice.description = 'Store Order ID: ' + shopOrder.id;
                                invoice.paymentStatusHuman = TransactionUtility.getTransactionStatusDescription(
                                    shopOrder.Transaction
                                );
                                elem.Resource.price = shopOrder.Transaction.price;
                            }
                        }
                    })
                    invoicePriceParts.forEach(function(pricePartObj){
                        invoice.totalPrice += pricePartObj.price
                    })
                }
                if(invoice.User){
                    generateUserUsefulData([invoice.User])
                }
            })
        }

        const userPermissions = {
            none: 0,
            car: 1,
            scooter: 2,
            bike: 3
        }

        function generateUserUsefulData(users){
            if(!users){
                console.warn("EnrichDataUtilityFactory.generateUserUsefulData: invalid input",users)
            }
            users.forEach(function(user){
                //permission
                user.permissionsHuman = "" + (user.accessForBike? 'Bike ' : '') + (user.accessForCar? 'Car ': '') + (user.accessForScooter? 'Scooter' : '')
                user.permissions = []
                //set permissions for filters access
                if(user.accessForBike){
                    user.permissions.push(userPermissions.bike)
                }
                if(user.accessForCar){
                    user.permissions.push(userPermissions.car)
                }
                if(user.accessForScooter){
                    user.permissions.push(userPermissions.scooter)
                }
                if(user.permissions.length == 0){
                    user.permissions.push(userPermissions.none)
                }
                if(user.permissionsHuman == ""){
                    user.permissionsHuman = "No permissions"
                }
                user.paymentStatus = user.lastPaymentStatus
                user.paymentStatusHuman = UserUtility.getUserPaymentStatusDescription(user)

                //user status
                /* old style
                if(user.validEmail && user.validID && user.validLicensePlate == 1 && user.validSMS){
                    user.statusHuman = "Registered"
                    user.userStatus = vm.userStatuses.registered
                }
                if(!user.validEmail || !user.validID || !user.validSMS){
                    user.statusHuman = "Missing validation"
                    user.userStatus = vm.userStatuses.missingValidation
                }
                if(user.validLicensePlate != 1){
                    user.statusHuman = "License not approved"
                    user.userStatus = vm.userStatuses.missingLicense
                }*/

                UserUtility.generateUserStatus(user)

                UserUtility.generateUserFullName(user)
            })
        }

        function generateDamageUsefulData(damageReports){
            if(typeof damageReports == "undefined" || damageReports == null){
                console.warn("EnrichDataUtilityFactory.generateDamageUsefulData: no input",damageReports)
            }
            damageReports.forEach(function(damageReport){
                DamageUtility.generateDamageOtherDamageDescriptions(damageReport)

                if(damageReport.user) {
                    generateUserUsefulData([damageReport.user])
                }

                if(damageReport.vehicle){
                    generateVehicleUsefulData([damageReport.vehicle])
                }
            })
            DamageUtility.generateDamagePartsDescriptions(damageReports)
        }

        return {
            generateVehicleUsefulData:generateVehicleUsefulData,
            generateDeviceUsefulData:generateDeviceUsefulData,
            generateTripUsefulData: generateTripUsefulData,
            generateInvoiceUsefulData: generateInvoiceUsefulData,
            generateUserUsefulData: generateUserUsefulData,
            generateDamageUsefulData: generateDamageUsefulData
        }
    }
    
    /** @ngInject */
    function HttpHeadersManagerFactory($http) {
        var authorizationHeader = 'Authorization';
        var authorizationHeaderValue = 'Bearer ';
        var serviceTokenHeader = 'X-SERVICE-TOKEN';
        //$http.defaults.headers.common["Content-Type"] = "text/plain";
        // NOTE use this for tatooine stage server
        // $http.defaults.headers.common['X-ENV']= "stage" ;
        return {
            setCommon: function (headerName, headerValue) {
                $http.defaults.headers.common[headerName] = headerValue;
            },
            setCommonAuthorization: function (token) {
                $http.defaults.headers.common.Authorization = authorizationHeaderValue + token;
            },
            setCommonServiceToken: function (serviceToken) {
                $http.defaults.headers.common[serviceTokenHeader] = serviceToken;
            },
            getHeaders: function () {
                return {
                    Authorization: $http.defaults.headers.common.Authorization,
                    'X-SERVICE-TOKEN': $http.defaults.headers.common[serviceTokenHeader],
                };
            },
        };
    }

    /** @ngInject */
    function LocalStorageServiceFactory() {

        return {
            setItem: function (key,data){

                //data is always stored as string
                localStorage.setItem(key,data);
            },
            getItem: function (key) {
                //need to cast if item is not a string
                return localStorage.getItem(key)
            },
            removeItem: function(key){
                localStorage.removeItem(key);
            },
            clear : function () {
                localStorage.clear();
            }
        }
    }

    /** @ngInject */
    function SessionStorageServiceFactory() {

        return {
            setItem: function (key,data){

                //data is always stored as string
                sessionStorage.setItem(key,data);

            },
            getItem: function (key) {
                //need to cast if item is not a string
                return sessionStorage.getItem(key)
            },
            removeItem: function(key){

                sessionStorage.removeItem(key);

            },
            clear : function () {
                sessionStorage.clear();
            }
        }
    }

    /** @ngInject */
    function ShowToastFactory($mdToast,$document) {

        var show =  function (text) {
            return $mdToast.show(
                        $mdToast.simple()
                            .textContent(text)
                            .position('top right')
                        //.hideDelay(30000)
            )
        };
        var isInfoToastDisplayed = false
        var isServiceDisabledToastDisplayed = false
        var createInfoToast = function (text,cssClass) {

            return $mdToast.show({
                hideDelay: false,
                position: 'top left',
                template: 
                '<md-toast ng-click="vm.hideToast()">' +
                    '<div class="md-toast-content">' +
                        text +
                        '<md-button class="warningToastClose" ng-click="vm.hideToast()"> X </md-button>' +
                    '</div>' +
                '</md-toast>',
                controller: function ToastController($mdToast){
                    var vm = this;
                    
                    vm.hideToast = hideToast;
                
                    function hideToast() {
                        isServiceDisabledToastDisplayed = false
                        $mdToast.hide();
                    }
                },
                controllerAs: 'vm',
                toastClass: cssClass,
                parent: $document.find('#toolbar')
            })
        }

        function showWarningToast(text) {
            return createInfoToast(text,'warningToast')
        }

        return {
            only : function(text) {
                return show(text);
            },
            withAction: function(text,action){
                return $mdToast.show(
                            $mdToast.simple()
                                .textContent(text)
                                .action(action)
                                .highlightAction(true)
                                .highlightClass('md-accent')
                                .position('top right')
                )
            },
            warning: showWarningToast,
            showServiceDisabled: function(){
                if(isServiceDisabledToastDisplayed){
                    return
                }
                isServiceDisabledToastDisplayed = true
                return showWarningToast('ALL VEHICLES ARE CURRENTLY DISABLED IN ALL SITES')
            },
            hideCurrent: function(){
                isServiceDisabledToastDisplayed = false
                $mdToast.hide()
            },
        };
    }

    /** @ngInject */
    function DialogFactory($mdDialog,$document) {

        return {
            alert : function (title,content,ev) {
                return $mdDialog.show(

                        $mdDialog.alert()
                            .parent(angular.element($document.body))
                            .clickOutsideToClose(true)
                            .title(title)
                            .textContent(content)
                            .ariaLabel('Alert Dialog')
                            .ok('Ok!')
                            .multiple(true)
                            .targetEvent(ev)
                        );
            },
            confirm: function (title,content,ev,okText,cancelText,isHtmlContent) {
                var dialog = $mdDialog.confirm()
                            .parent(angular.element($document.body))
                            .clickOutsideToClose(false)
                            .title(title)
                            .ariaLabel('delete'+title)
                            .ok(okText ? okText: 'OK')
                            .cancel(cancelText ? cancelText: 'CANCEL')
                            .multiple(true)
                            .targetEvent(ev)
                isHtmlContent ? dialog.htmlContent(content) : dialog.textContent(content)

                return $mdDialog.show(dialog)
                        
            }
        }

    }
 
    /** @ngInject */
    function ToDateFilter(ServiceSettings,$rootScope,MiscUtility){
        
        function toDateFilterApply(settings, input, format, siteId){
            const timezone = ServiceSettings.getSiteTimezone(siteId);
            if(!timezone) {
                // console.warn("toDateFilter: no timezone for this siteId",siteId,settings)
                return 'Timezone not available';
            }

            var defaultFormat = $rootScope.defaultDateFormat || 'DD/MM/YYYY';
            if(format == "dateTime"){
                format = "DD/MM/YYYY HH:mm:ss"
            } else format = (format || defaultFormat);

            // in moment yyyy is YYYY and dd is DD.
            format = format.replace('yyyy', 'YYYY').replace('dd', 'DD');

            var date;

            if (input!=null && input!="" && input!=0) {
                if(input instanceof Date){
                    // case is JS Date
                    date = MiscUtility.shiftJstoMoment(input, siteId)
                } else {
                    //check if timestamp is a string
                    const parsedInput = Number(input)
                    date = moment(isNaN(parsedInput) ? input : parsedInput)
                }
                // else if (typeof input == "string") {
                //     if (moment(input,moment.ISO_8601,true).isValid()){
                //         date = moment(input)
                //     } else {
                //         input = parseInt(input); //epochUnix
                //     }
                // }
                // if (typeof input == "number") {
                //     date = moment(input) // case date is unix timestamp in milliseconds
                // }

                if (input instanceof moment) {
                    // momentJs are already timezoned
                    date = input;
                    const offset = date.clone().utcOffset() / 60;
                    const offsetFormatted = format.includes('HH') ? ' GMT' + (offset > 0 ? '+'+ offset : offset) : '';
                    return timezone ? date.format(format) + offsetFormatted : date.format(format);
                }

                const offset = date.clone().tz(timezone).utcOffset() / 60;
                const offsetFormatted = format.includes('HH') ? ' GMT' + (offset > 0 ? '+'+ offset : offset) : '';
                return timezone ? date.tz(timezone).format(format) + offsetFormatted : date.format(format);
            }
            else{
                return ''
            }
        }

        function toDateFilter(input,format,siteId){
            return ServiceSettings.getServiceSettings(function(settings, error){
                if(error) {
                    return'Error retrieving settings';
                }else{
                    return toDateFilterApply(settings, input, format, siteId);
                }
            })
        }
        toDateFilter.$stateful = true

        return toDateFilter
    }

    /** @ngInject */
    function ToNumberFilter(numberFilter,$rootScope){
        /* filter for epochUnix , Date() and '2015-03-03 10:10:10' */
        /* use angular dateFilter to format date */
        /* my format preferred dd/MM/yyyy HH:mm:ss*/

        return function (input,format){
            var defaultFormat = 2;
            if(!format) {
                format = defaultFormat;
            }
            var output = numberFilter(input, format);
            return output;
        }
    };

    /** @ngInject */
    function ToCurrencyFilter(numberFilter, ServiceSettings, $rootScope){
        function toCurrencyFilter(input, siteId, numberFormat){
            return ServiceSettings.getServiceSettings(function(settings,error){
                if(error){
                    return 'N/A'
                }else{

                    if(input == null) {
                        return '';
                    }
                    
                    var output;
                    var defaultFormat = 2;
                    var currencySymbol = ServiceSettings.getCurrencySymbol(siteId)
                    if(!numberFormat) {
                        numberFormat = defaultFormat;
                    }
                    output = numberFilter(input, numberFormat);
                    return currencySymbol ? currencySymbol +  ' ' + output  : output;
                }
            })
        }
        toCurrencyFilter.$stateful = true

        return toCurrencyFilter
    };

    /** @ngInject */
    function TimeFormatFixer() {
        return {
            require: '?ngModel',
            link: function(scope, elem, attr, ngModel) {

                if( !ngModel )
                    return;

                if( attr.type !== 'time' )
                    return;

                ngModel.$formatters.unshift(function(value) {
                    return value.replace(/:00\.000$/, '')
                });
            }
        }
    }

    /** @ngInject */
    function DetectUploadChange() {
        return{
            scope:{
                ngUploadChange:"&"
            },
            link:function($scope, $element, $attrs){
                $element.on("change",function(event){
                    $scope.$apply(function(){
                        $scope.ngUploadChange({$event: event})
                    })
                })
                $scope.$on("$destroy",function(){
                    $element.off();
                });
            }
        }
    }

    /** @ngInject */
    function ToggleNumber() {
        return {
            priority: 1,
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attr, ngModel) {
              function toModel(value) {
                return "" + value; // convert to string
              }
        
              function toView(value) {
                return parseInt(value); // convert to number
              }
        
              ngModel.$formatters.push(toView);
              ngModel.$parsers.push(toModel);
            }
          };
    }

        /** @ngInject */
    function CurrentNewRentalBooking() {

        var currentRentalBooking = {data:null};

        this.setData = function (newCurrentRentalBooking) {

            currentRentalBooking.data = newCurrentRentalBooking;
        };

        this.getData = function(){

            return currentRentalBooking.data;
        };

        this.clear = function () {

            currentRentalBooking.data = null;
        }
    }

    /** @ngInject */
    function CurrentNewUser() {

        var currentUser = {data:null};

        this.setData = function (newCurrentUser) {

            currentUser.data = newCurrentUser;
        };

        this.getData = function(){

            return currentUser.data;
        };

        this.clear = function () {

            currentUser.data = null;
        }
    }

    /** @ngInject */
    function CategoryService(CategoryAdapter,$q) {

        var categories = null;

        function getCategories(callback) {

            CategoryAdapter.getCategories(function (categories,error) {

                if(!error){
                    callback(categories,null);
                }
                else {
                    callback(null,error)
                }
            })
        }

        this.getCategories = function () {

            var deferred = $q.defer();

            if(!categories){

                console.log("CategoriesService: categories is null");

                getCategories(function callback(categs,error) {

                    if(!error){

                        categories = categs;
                        deferred.resolve(categories);
                    }
                    else{
                        deferred.reject(error);
                    }
                })
            }else{

                deferred.resolve(categories);
            }

            return deferred.promise
        };

        this.refresh = function () {

            getCategories(function callback(categs,error) {

                if(!error){
                    console.log("CategoriesService: categories refreshed")
                    categories = categs;
                }
                else {
                    categories = null;
                    console.log("CategoriesService: error refresh,force value to null")
                }
            })
        }

    }

    /** @ngInject */
    function RentStationService(RentStationAdapter,$q) {

        var rentStations = null;

        function getRentStations(callback) {

            RentStationAdapter.getStations(function (newRentStations,error) {

                if(!error){
                    callback(newRentStations,null);
                }
                else {
                    callback(null,error)
                }
            })
        }

        this.getRentStations = function () {

            var deferred = $q.defer();

            if(!rentStations){

                console.log("RentStationService: rentStations is null");

                getRentStations(function callback(newRentStations,error) {

                    if(!error){

                        rentStations = newRentStations;
                        deferred.resolve(rentStations);
                    }
                    else{
                        deferred.reject(error);
                    }
                })
            }else{

                deferred.resolve(rentStations);
            }

            return deferred.promise
        };

        this.refresh = function () {

            getRentStations(function callback(newRentStations,error) {

                if(!error){
                    console.log("RentStationService: rentStations refreshed")
                    rentStations = newRentStations;
                }
                else {
                    rentStations = null;
                    console.log("RentStationService: error refresh,force value to null")
                }
            })
        }

    }

    /** @ngInject */
    function RateService(RateAdapter,$q) {

        var rates = null;

        function getRates(callback) {

            RateAdapter.getRates(function (rates,error) {

                if(!error){
                    callback(rates,null);
                }
                else {
                    callback(null,error)
                }
            })
        }

        this.getRates = function () {

            var deferred = $q.defer();

            if(!rates){

                console.log("RatesService: rates is null");

                getRates(function callback(newRates,error) {

                    if(!error){

                        rates = newRates;
                        deferred.resolve(rates);
                    }
                    else{
                        deferred.reject(error);
                    }
                })
            }else{

                deferred.resolve(rates);
            }

            return deferred.promise
        };

        this.refresh = function () {

            getRates(function callback(newRates,error) {

                if(!error){
                    console.log("RatesService: rates refreshed");
                    rates = newRates;
                }
                else {
                    rates = null;
                    console.log("RatesService: error refresh,force value to null");
                }
            })
        }
    }

    /** @ngInject */
    function UserService(UserAdapter,$q) {

        var users = null;
        this.currentUserId = null

        function getUsers(callback) {

            UserAdapter.getUsers(function (users,error) {

                if(!error){
                    callback(users,null);
                }
                else {
                    callback(null,error)
                }
            })
        }

        this.getUsers = function () {

            var deferred = $q.defer();

            if(!users){

                console.log("UserService: users is null");

                getUsers(function callback(newUsers,error) {

                    if(!error){

                        users = newUsers;
                        deferred.resolve(users);
                    }
                    else{
                        deferred.reject(error);
                    }
                })
            }else{

                deferred.resolve(users);
            }

            return deferred.promise
        };

        this.refresh = function () {

            getUsers(function callback(newUsers,error) {

                if(!error){
                    console.log("UserService: users refreshed");
                    users = newUsers;
                }
                else {
                    users = null;
                    console.log("UserService: error refresh,force value to null");
                }
            })
        }
    }

    /** @ngInject */
    function GeofenceService(GeofencesAdapter, MapDrawingUtilities) {
        var geofences = null

        /**
         *  Get the geofence from the storage. 
         *  If not available request the storage update.
         *  @param {function} callback (response, error) => {}
         */
        this.getGeofencingAreas = function(callback) {
            if(geofences) {
                if(callback !== undefined) {
                    // console.log("getGeofencingAreas ", geofences)
                    callback(geofences, null)
                } else {
                    console.warn('Missing callback function in getGeofencingAreas')
                }
            } else {
                this.refreshGeofencingAreas(callback)
            }
        }

        /**
         *  Call the API directly and update the store. 
         *  This method is used when the store needs to be 
         *  updated unconditionally.
         *  @param {function} callback (response, error) => {}
         */
        this.refreshGeofencingAreas = function(callback) {
            GeofencesAdapter.getGeofenceAreas(function(areas, error){
                if(error){
                    console.error("refreshGeofencingAreas error", error)
                    if(callback !== undefined) {
                        callback(null, error);
                    }
                }else{
                    geofences = areas;
    
                    // for(var index in areas){
                    //     var area = areas[index]
                    //     var polygons = MapDrawingUtilities.convertServerAreaToPolygons(area.zonas,{vehicleType: area.vehicleType})
                    //     geofences[index].polygons = polygons
                    // }
    
                    // console.log("refreshGeofencingAreas success ", areas)
                    if(callback !== undefined) {
                        callback(geofences, null);
                    }
                }
            })
        }
    }

    /** @ngInject */
    function AppSettings(LocalStorageService, MiscData){
        const defaultBaseUrl = 'https://core.2hire.io/v4/admin';
        
        var data = {
            baseUrl: defaultBaseUrl,
            currentSite: null,
            currentService: null
        }

        //FIX ME: first init of selectedsite for restricted site permission for endpoints
        var siteId = LocalStorageService.getItem(MiscData.SITE)
        if(siteId){
            setSelectedSite({id: siteId, name: ''})
        }

        this.setBaseUrlToDefault = function(){
            data.baseUrl = defaultBaseUrl
        }

        this.setBaseUrl = function(newBaseUrl){
            if(newBaseUrl===undefined || newBaseUrl===null || newBaseUrl===""){
                console.warn("AppSettings.setBaseUrl: invalid input",newBaseUrl)
                return
            }
            // console.warn("AppSettings.setBaseUrl: old baseUrl",data.baseUrl)
            if(newBaseUrl.indexOf("http") === -1){
                // console.warn("AppSettings.setBaseUrl: no http, set https",newBaseUrl)
                newBaseUrl = "https://"+newBaseUrl
            }
            if(newBaseUrl.indexOf("v4") === -1){
                // console.warn("AppSettings.setBaseUrl: no v4 version, set v4")
                newBaseUrl += "/v4/admin"
            }
            // console.warn("AppSettings.setBaseUrl: new baseUrl is ",newBaseUrl)
            data.baseUrl = newBaseUrl
        }

        this.getBaseUrl = function(){
            if(!data.baseUrl){
                console.warn("AppSettings.getBaseUrl: invalid baseurl",data.baseUrl)
            }
            return data.baseUrl
        }

        function setSelectedSite(site){
            if(!site || Object.keys(site).length==0){
                console.warn("AppSettings.setSelectedSite: invalid site",site)
                return
            }

            data.currentSite = site
        }

        this.setSelectedSite = setSelectedSite

        this.getSelectedSite = function(){
            return data.currentSite
        }

        this.setCurrentServiceData = function(serviceData){
            data.currentService = serviceData
        }

        this.getServiceName = function(){
            return data.currentService.name
        }
    }

    /** @ngInject */
    function AppConfigurations(
        ServiceData, 
        ServiceSettings,
        SitesService,
        OrderRequestParamFactory,
        VehicleUtility,
        TripUtility,
        UserUtility,
        toNumberFilter,
        toDateFilter,
        toCurrencyFilter,
        DeviceType,
        UserDetailsPage,
        LocalStorageService,
        ServiceTokenData,
        DefaultSite,
        CouponBonusUtility,
        CouponTemplateDetailPage,
        InvoiceUtility,
        InvoiceType,
        InvoicesDialogFactory
    ) {

        const VehicleTableFields = function (){
            return {
                referenceCode: {
                    name: "Ref. Code",
                    orderBy: OrderRequestParamFactory.orderByVehicleReferenceCode,
                    class: "vehicleRowCellVeryBig",
                    key: "reference_code",
                },
                id: {
                    name: "Vehicle id",
                    orderBy: OrderRequestParamFactory.orderById,
                    class: "vehicleRowCellSmall",
                    key: "id",
                    type: "link",
                    link: {
                        goto: "app.vehicle.details",
                        gotoParams: "vehicleId",
                        key: "id",
                        class: function (o) {
                            return "userLink";
                        },
                    },
                    render: function (val, obj) {
                        return obj.id;
                    },
                },
                deviceProvider: { name: "Connectivity provider", key: "deviceTypeHuman" },
                deviceId: {
                    name: "Device Id",
                    hide: true,
                    type: "render",
                    render: function (v, o) {
                        return o.deviceType == DeviceType.PERSONAL.value
                            ? o.core_board
                                ? o.core_board.id
                                : "No device"
                            : o.deviceId;
                    },
                },
                licensePlate: {
                    name: "License plate",
                    orderBy: OrderRequestParamFactory.orderByVehicleLicensePlate,
                    class: "vehicleRowCellBig",
                    key: "license_plate",
                },
                online: {
                    name: "Online",
                    orderBy: OrderRequestParamFactory.orderByVehicleOnlineStatus,
                    class: "vehicleRowCellSmall vehicleRowCellIcon",
                    type: "icon-boolean",
                    icon: { key: "online", true: "icon-check-circle", false: "icon-close-circle-outline" },
                    key: "icon",
                },
                address: {
                    name: "Street",
                    class: "vehicleRowCellVeryBig",
                    key: "address",
                    ellipsis: true,
                    type: "render",
                    render: function (v, o) {
                        return o.address ? VehicleUtility.getVehicleShortAddress(o) : "No address found";
                    },
                },
                userFullName: {
                    name: "Current user",
                    class: "vehicleRowCellVeryBig",
                    key: "currentUser",
                    ellipsis: true,
                    type: "link",
                    link: {
                        goto: "app.user.details",
                        gotoParams: "userId",
                        key: "bookings.0.user.id",
                        class: function (o) {
                            return VehicleUtility.hasVehicleACurrentBooking(o) ? "userLink" : "preventClick";
                        },
                    },
                    render: function (val, obj) {
                        return obj.currentUser;
                    },
                }, //sortId:"currentUser"
                totalPercentage: {
                    name: "Fuel level",
                    orderBy: OrderRequestParamFactory.orderByVehicleFuelLevel,
                    class: "vehicleRowCellSmall",
                    key: "total_percentage",
                    type: "render",
                    // removed tooltip -> tooltip:function(v,o) {return VehicleUtility.getBatteryLabel(o.total_percentage)}
                    render: function (v, o) {
                        return !isNaN(parseInt(o.total_percentage)) ? o.total_percentage + " %" : "";
                    },
                    csv: function (v, o) {
                        return !isNaN(parseInt(o.total_percentage)) ? o.total_percentage : "";
                    },
                },
                batteryVoltage: {
                    name: "Battery voltage",
                    class: "vehicleRowCellSmall",
                    key: "battery.percentage",
                    type: "render",
                    render: function (v, o) {
                        return o.battery ? toNumberFilter(o.battery.value_V, 2) + " V" : "N/A";
                    },
                    csv: function (v, o) {
                        return o.battery ? o.battery.value_V : "N/A";
                    },
                },
                deviceBatteryVoltage: {
                    name: "Battery voltage",
                    class: "vehicleRowCellSmall",
                    key: "",
                    type: "render",
                    render: function (v, o) {
                        return o.core_board ? toNumberFilter(o.core_board.value_V, 2) + " V" : "N/A";
                    },
                    csv: function (v, o) {
                        return o.core_board ? toNumberFilter(o.core_board.value_V, 2) : "N/A";
                    },
                },
                // status: { name: "Status", class:"vehicleRowCell", key:'externalStatusHuman'},
                lastMoved: {
                    name: "Last moved",
                    orderBy: OrderRequestParamFactory.orderByVehicleLastMoved,
                    defaultSort: true,
                    class: "vehicleRowCellBigger",
                    key: "lastMoved",
                },
                lastGPSUpdate: {
                    name: "Last GPS Update",
                    orderBy: OrderRequestParamFactory.orderByVehicleLastGPSUpdate,
                    class: "vehicleRowCellBigger",
                    key: "fixtaken",
                    type: "render",
                    render: function (val, obj) {
                        return val ? moment(val).fromNow() : "No Data";
                    },
                    csv: function (val, obj) {
                        return obj.fixtaken ? moment().diff(obj.fixtaken, "minutes") : "No Data";
                    },
                },
                km: {
                    name: "Total km",
                    orderBy: OrderRequestParamFactory.orderByVehicleTotalKm,
                    class: "vehicleRowCellBig",
                    key: "km",
                    type: "render",
                    render: function (v, o) {
                        return o.km + " km";
                    },
                },
                status: { name: "Status", class: "status", key: "status" },
                siteId: {
                    name: "Site",
                    class: "vehicleRowCell",
                    key: "SiteId",
                    hide: !SitesService.isDefaultSiteSelected(),
                    type: "render",
                    render: function (val, obj) {
                        return obj.SiteId !== undefined && obj.SiteId !== null
                            ? SitesService.getSiteName(obj.SiteId)
                            : "No Site";
                    },
                },
                detailsButton: {
                    name: "Details",
                    class: "vehicleRowCellDetailsButton",
                    key: "details",
                    type: "icon-link",
                    icon: {
                        goto: "app.vehicle.details",
                        gotoParams: "vehicleId",
                        icon: "icon-information-outline",
                        key: "id",
                    },
                },
            };
        }

        const DefaultVehicleListTableFields = [
            {key: "referenceCode", params: {}},
            {key: "id", params: {}},
            {key: "deviceProvider", params: {}},
            {key: "deviceId", params: {}},
            {key: "licensePlate", params: {}},
            {key: "online", params: {}},
            {key: "address", params: {}},
            {key: "userFullName", params: {}},
            {key: "totalPercentage", params: {}},
            {key: "lastMoved", params: {}},
            {key: "km", params: {}},
            {key: "status", params: {}},
            {key: "siteId", params: {}},
            {key: "detailsButton", params: {}},
        ]

        const GovoltVehicleListTableFields = [
            {key: "referenceCode", params: {}},
            {key: "id", params: {}},
            {key: "deviceProvider", params: {}},
            {key: "deviceId", params: {}},
            {key: "licensePlate", params: {}},
            {key: "online", params: {}},
            {key: "address", params: {}},
            {key: "userFullName", params: {}},
            {key: "totalPercentage", params: {}},
            {key: "batteryVoltage", params: {render: function(v, o){ return o.battery && o.deviceType === DeviceType.PERSONAL.value ? toNumberFilter(o.battery.percentage, 2) + ' V' : 'N/A'}, csv: function(v, o){ return o.battery && o.deviceType === DeviceType.PERSONAL.value ? o.battery.percentage: 'N/A'}}},
            // {key: "status", params: {}},
            {key: "lastMoved", params: {type:"render", render: function(v,o){ const lb = VehicleUtility.getVehicleLastBooking(o); return lb ? moment(lb.updated_at).fromNow() : 'Never moved'}, csv: function(v,o){ const lb = VehicleUtility.getVehicleLastBooking(o); return lb ? moment().diff(lb.updated_at,"minutes") : 'Never moved'}}},
            {key: "km", params: {}},
            {key: "status", params: {}},
            {key: "siteId", params: {}},
            {key: "detailsButton", params: {}},
        ]

        const RideVehicleListTableFields = [
            {key: "referenceCode", params: {}},
            {key: "id", params: {}},
            {key: "deviceProvider", params: {}},
            {key: "deviceId", params: {}},
            {key: "licensePlate", params: {}},
            {key: "online", params: {}},
            {key: "address", params: {}},
            {key: "userFullName", params: {}},
            {key: "totalPercentage", params: {}},
            {key: "deviceBatteryVoltage", params: {}},
            // {key: "status", params: {}},
            {key: "lastMoved", params: {}},
            {key: "lastGPSUpdate", params: {}},
            {key: "km", params: {}},
            {key: "status", params: {}},
            {key: "siteId", params: {}},
            {key: "detailsButton", params: {}},
        ]

        const eGapVehicleListTableFields = [
            {key: "id", params: {}},
            {key: "deviceId", params: {}},
            {key: "licensePlate", params: {}},
            {key: "online", params: {}},
            {key: "address", params: {}},
            {key: "totalPercentage", params: {}},
            {key: "km", params: {}},
            {key: "status", params: {}},
            {key: "siteId", params: {}},
            {key: "detailsButton", params: {}},
        ]

        const easyBikeVehicleListTableFields = [
            {key: "referenceCode", params: {}},
            {key: "id", params: {}},
            {key: "deviceProvider", params: {}},
            {key: "deviceId", params: {}},
            {key: "licensePlate", params: {}},
            {key: "online", params: {}},
            {key: "address", params: {}},
            {key: "userFullName", params: {}},
            {key: "batteryVoltage", params: {render: function(v, o){ return o.battery && toNumberFilter(o.battery.value_V / 100, 2) + ' V'}, csv: function(v, o){ return o.battery && toNumberFilter(o.battery.value_V / 100, 2) + ' V'}}},
            {key: "lastMoved", params: {}},
            {key: "km", params: {}},
            {key: "status", params: {}},
            {key: "siteId", params: {}},
            {key: "detailsButton", params: {}},
        ]
        
        const TripTableFields = function(){
            return { 
                id: { name: "Trip Id", orderBy: OrderRequestParamFactory.orderById, class:"vehicleRowCellSmall", key:'id', type:'link', link:{goto: "app.trip.details",gotoParams: "tripId", key:'id', class:function(o){ return 'userLink'}}, render: function(val, object) { return val }},
                vehicleReferenceCode: { name: "Ref. Code", orderBy: OrderRequestParamFactory.orderByTripVehicleReferenceCode, class:"vehicleRowCellBig", key:'Vehicle.reference_code', type:'render', render: function(val, object) { return object.Vehicle ? object.Vehicle.reference_code : ''} },
                vehicleId: { name: "Vehicle Id", orderBy: OrderRequestParamFactory.orderByTripVehicleId, class:"vehicleRowCellSmall", key:'Vehicle.id', type:'link', link:{ goto: "app.vehicle.details", gotoParams: "vehicleId", key:'Vehicle.id', class:function(o){ return 'userLink'} }, render: function(val, object) { return object.Vehicle ? object.Vehicle.id : ''}},
                vehicleLicensePlate: { name: "License plate", orderBy: OrderRequestParamFactory.orderByTripVehicleLicensePlate, class:"vehicleRowCellBig", key:'Vehicle.license_plate', type:'render', render: function(val, object) { return object.Vehicle ? object.Vehicle.license_plate : '' } },
                deviceProvider:{ name: "Device Provider", class:"vehicleRowCellSmall", key:'Vehicle.deviceTypeHuman', type:'render', render: function(val, object) { return object.Vehicle ? object.Vehicle.deviceTypeHuman : ''}},
                vehicleStartAddress: { name: "Start address", class:"vehicleRowCellVeryBig alignLeft", key:'StartPosition', type:'link', link:{goto: "app.trip",activatesFilter:true, gotoParams: "tripId", key:'id',class:function(o){ return 'userLink'}}, render: function(val, object) { return object.StartPosition && object.StartPosition.address ? VehicleUtility.getVehicleShortAddress(object.StartPosition) : 'No address found'}},
                vehicleEndAddress: { name: "End address", class:"vehicleRowCellVeryBig alignLeft", key:'FinishPosition', type:'link', link:{goto: "app.trip",activatesFilter:true, gotoParams: "tripId", key:'id', class:function(o){ return 'userLink'}}, render: function(val, object) { return object.FinishPosition && object.FinishPosition.address ? VehicleUtility.getVehicleShortAddress(object.FinishPosition) : 'No address found'}},
                userId: { name:"User Id", orderBy: OrderRequestParamFactory.orderByTripUserId, class:"vehicleRowCellSmall", key:'User.id', type: 'render', render: function(val, object) { return object.User ? object.User.id : '' }},
                userFullName: { name: "User full name", class:"vehicleRowCellVeryBig alignLeft", key:'User.fullName', type: 'link',link: {goto: "app.user.details",gotoParams: "userId", key:'User.id', class:function(o){ return 'userLink'}}, render: function(val, object) { return object.User ? object.User.fullName: '' }}, //sortId:"surname"
                starTime: { name: "Started", orderBy: OrderRequestParamFactory.orderByTripStart, defaultSort:true, class:"vehicleRowCellVeryBig", key:'start', type: 'render', render: function(val, object) { return toDateFilter(object.start, 'dateTime', object.SiteId) }}, //sortId: "start"
                status: { name: "Trip status", key:'', type: 'render', render: function(val, object) { return TripUtility.getTripStatusDescription(object) }}, //sortId: "Booking.status"
                duration: { name: "Duration", class: "vehicleRowCellSmall", key:'duration', type: 'render', render: function(val, object) { return object.FinishPosition ? object.duration +' min' : 'N/A' }}, //sortId: "duration"
                distance: { name: "Distance covered", class:"centered", key:'totalKm', type:'render', render: function(val, object) { return object.FinishPosition ? val + ' km' : "N/A"}}, //sortId: "Booking.distance"
                currencySymbol: { name: "Currency Symbol", hide: true, type:'render', render:function(val, object){ return object.FinishPosition && object.Booking && object.Booking.price != null ? ServiceSettings.getCurrencySymbol(object.SiteId) : 'N/A' }},
                price: { name: "Price", class:"centered", key:'Booking.price', type:'render', render: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.price != null ? toCurrencyFilter(object.Booking.price, object.SiteId) : 'N/A' }, csv: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.price != null ? toNumberFilter(object.Booking.price) : '' } }, //sortId: "Booking.price"
                priceDetailed: { name: "Cost", key:'detailedPriceCell', type:'render', render: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.price!=null ? '<div style="width:100%">'+'<div class="vehicleRowCellPrice">'+toCurrencyFilter(object.Booking.price, object.SiteId)+'</div><div class="vehicleRowCellPriceDetails"><div>'+toCurrencyFilter(object.Booking.detailedPrice.free, object.SiteId)+'</div><div>'+toCurrencyFilter(object.Booking.detailedPrice.prepaid, object.SiteId)+'</div></div></div>' : 'N/A' }, csv: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.price != null ? toNumberFilter(object.Booking.price) : '' } }, //sortId: "Booking.price",
                priceRunning: { name: "Running price", key:'Booking.detailedPrice.running', type:'render', render: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toCurrencyFilter(object.Booking.detailedPrice.running, object.SiteId) : 'N/A' }, csv: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toNumberFilter(object.Booking.detailedPrice.running) : '' } },
                priceFree: { name: "Free price", key:'Booking.detailedPrice.free', type:'render', render: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toCurrencyFilter(object.Booking.detailedPrice.free, object.SiteId) : 'N/A' }, csv: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toNumberFilter(object.Booking.detailedPrice.free) : '' } },
                pricePrepaid: { name: "Prepaid price", key:'Booking.detailedPrice.prepaid', type:'render', render: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toCurrencyFilter(object.Booking.detailedPrice.prepaid, object.SiteId) : 'N/A' }, csv: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toNumberFilter(object.Booking.detailedPrice.prepaid) : '' } },
                priceParked: { name: "Parked price", key:'Booking.detailedPrice.parked', type:'render', render: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toCurrencyFilter(object.Booking.detailedPrice.parked, object.SiteId) : 'N/A' }, csv: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toNumberFilter(object.Booking.detailedPrice.parked) : '' } },
                priceOutOfGeofence: { name: "Out of geofence price", key:'Booking.detailedPrice.outOfGeoFence', type:'render', render: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toCurrencyFilter(object.Booking.detailedPrice.outOfGeoFence, object.SiteId) : 'N/A' }, csv: function(val, object) { return object.FinishPosition && object.Booking && object.Booking.detailedPrice != null ? toNumberFilter(object.Booking.detailedPrice.outOfGeoFence) : '' } },
                site: { name: "Site", class:"vehicleRowCellSmall", key: 'SiteId', hide: !SitesService.isDefaultSiteSelected(), type:'render', render: function(val, obj){ return obj.SiteId !== undefined && obj.SiteId !== null ? SitesService.getSiteName(obj.SiteId) : "No Site"}},
                clientType: { name: "Client type", class: "vehicleRowCellSmall", key: 'User.clientTypeHuman', type: 'render', render: function(val, object) { return object.User && object.User.clientTypeHuman || ""}},
                detailsButton: { name: "Details", class:"vehicleRowCellIcon", key:'details', type:'icon-link', icon: { goto: "app.trip.details", gotoParams: "tripId", icon: "icon-information-outline", key: "id" } }
            }
        }

        const DefaultTripListTableFields = [
            {key: "id", params: {}},
            {key: "vehicleReferenceCode", params: {}},
            {key: "vehicleId", params: {}},
            {key: "deviceProvider", params: {}},
            {key: "vehicleStartAddress", params: {}},
            {key: "vehicleEndAddress", params: {}},
            {key: "userId", params: {}},
            {key: "userFullName", params: {}},
            {key: "starTime", params: {}},
            {key: "status", params: {}},
            {key: "duration", params: {}},
            {key: "distance", params: {}},
            {key: "currencySymbol", params: {}},
            {key: "price", params: {}},
            {key: "site", params: {}},
            {key: "detailsButton", params: {}},
        ]

        const RideTripListTableFields = [
            {key: "id", params: {}},
            {key: "vehicleReferenceCode", params: {}},
            {key: "vehicleId", params: {}},
            {key: "deviceProvider", params: {}},
            {key: "vehicleStartAddress", params: {}},
            {key: "vehicleEndAddress", params: {}},
            {key: "userId", params: {}},
            {key: "userFullName", params: {}},
            {key: "starTime", params: {}},
            {key: "status", params: {}},
            {key: "duration", params: {}},
            {key: "distance", params: {}},
            {key: "currencySymbol", params: {}},
            {key: "priceDetailed", params: {}},
            {key: "priceRunning", params: {hide: true}},
            {key: "priceFree", params: {hide: true}},
            {key: "pricePrepaid", params: {hide: true}},
            {key: "priceParked", params: {hide: true}},
            {key: "priceOutOfGeofence", params: {hide: true}},
            {key: "site", params: {}},
            {key: "detailsButton", params: {}},
        ]
        
        const GovoltTripListTableFields = [
            {key: "id", params: {}},
            {key: "vehicleLicensePlate", params: {}},
            {key: "vehicleId", params: {}},
            {key: "deviceProvider", params: {}},
            {key: "vehicleStartAddress", params: {}},
            {key: "vehicleEndAddress", params: {}},
            {key: "userId", params: {}},
            {key: "userFullName", params: {}},
            {key: "starTime", params: {}},
            {key: "status", params: {}},
            {key: "duration", params: {}},
            {key: "distance", params: {}},
            {key: "currencySymbol", params: {}},
            {key: "price", params: {}},
            {key: "site", params: {}},
            {key: "clientType", params: {}},
            {key: "detailsButton", params: {}},
        ]

        const MovotTripListTableFields = [
            {key: "id", params: {}},
            {key: "vehicleReferenceCode", params: {}},
            {key: "vehicleId", params: {}},
            {key: "deviceProvider", params: {}},
            {key: "vehicleStartAddress", params: {}},
            {key: "vehicleEndAddress", params: {}},
            {key: "userId", params: {}},
            {key: "userFullName", params: {}},
            {key: "starTime", params: {}},
            {key: "status", params: {}},
            {key: "duration", params: {}},
            {key: "distance", params: {}},
            {key: "currencySymbol", params: {}},
            {key: "price", params: {}},
            {key: "site", params: {}},
            {key: "clientType", params: {}},
            {key: "detailsButton", params: {}},
        ]
        const UserTableFields = function () {
            return {
                id: { name:"User Id", orderBy: OrderRequestParamFactory.orderByUserId, defaultSort:true, class:"vehicleRowCellSmall", type:'link', link:{goto: "app.user.details",gotoParams: "userId", key:'id', class:function(o){ return 'userLink' }}, render: function(val, obj){ return obj.id }},
                fullName: { name: "Full Name", orderBy: OrderRequestParamFactory.orderByUserSurname, class:"vehicleRowCellVeryBig alignLeft", ellipsis: true, key:'fullName'},
                email: { name: "Email", orderBy: OrderRequestParamFactory.orderByUserEmail, class:"vehicleRowCellVeryBig alignLeft", ellipsis: true, type:'email',render: function(v, o) {return o.email }},
                phoneNumber: { name: "Phone number", class:"vehicleRowCellBig", key:'tel' },
                status: { name: "User status", class:"vehicleRowCellBig centered", key: 'statusHuman' },
                paymentStatus: { name: "Last payment",/* orderBy: OrderRequestParamFactory.orderByUserLastPaymentStatus,*/ class:"vehicleRowCellBig centered", key:'paymentStatusHuman'},
                permissions: { name: "Permissions", class:"vehicleRowCellBig centered hide-xs hide-sm", key:'permissionsHuman'},
                creationDate: { name: "Registration date", orderBy: OrderRequestParamFactory.orderByUserRegistrationDate, class:"vehicleRowCellBigger", type:'render', render: function(v, o) {return UserUtility.isAdminWithoutSite(o) ? toDateFilter(o.created_at, 'dateTime', DefaultSite.id) :  toDateFilter(o.created_at, 'dateTime', o.SiteId) }},
                registrationSite: { name: "Registration site", class: "vehicleRowCellBigger", type:'render', render: function(v, o) {return o.SiteId!== undefined && o.SiteId!== null ? SitesService.getSiteName(o.SiteId) : 'No site'}},
                clientType: { name: "Client type", class: "vehicleRowCell centered", key: "clientTypeHuman"},
                lastUpdate: { name: "Last update", class: "vehicleRowCellBigger", orderBy: OrderRequestParamFactory.orderByLastUpdate, type:'render', render: function(v, o) {return toDateFilter(o.updated_at, 'dateTime', typeof o.SiteId === "number" ? o.SiteId : DefaultSite.id)}},
                details: { name: "Details",class:"",key:'details', type:'icon-link', icon: {
                    goto: UserDetailsPage,
                    gotoParams: "userId",
                    icon: "icon-information-outline",
                    key: "id",
                }}
            }
        }

        const DefaultUserListTableFields = [
            {key: "id", params: {}},
            {key: "fullName", params: {}},
            {key: "email", params: {}},
            {key: "phoneNumber", params: {}},
            {key: "status", params: {}},
            {key: "paymentStatus", params: {}},
            {key: "permissions", params: {}},
            {key: "creationDate", params: {}},
            {key: "registrationSite", params: {}},
            {key: "details", params: {}},
        ]
        const MovoUserListTableFields = [
            {key: "id", params: {}},
            {key: "fullName", params: {}},
            {key: "email", params: {}},
            {key: "phoneNumber", params: {}},
            {key: "status", params: {}},
            {key: "paymentStatus", params: {}},
            {key: "permissions", params: {}},
            {key: "creationDate", params: {}},
            {key: "registrationSite", params: {}},
            {key: "clientType", params: {}},
            {key: "details", params: {}},
        ]
        
        const GovoltUserListTableFields = [
            {key: "id", params: {}},
            {key: "fullName", params: {}},
            {key: "email", params: {}},
            {key: "phoneNumber", params: {}},
            {key: "status", params: {}},
            {key: "paymentStatus", params: {}},
            {key: "permissions", params: {}},
            {key: "creationDate", params: {}},
            {key: "registrationSite", params: {}},
            {key: "clientType", params: {}},
            {key: "details", params: {}},
        ]

        const AllwaysUserListTableFields = [
            {key: "id", params: {}},
            {key: "fullName", params: {}},
            {key: "email", params: {}},
            {key: "phoneNumber", params: {}},
            {key: "status", params: {}},
            {key: "paymentStatus", params: {}},
            {key: "permissions", params: {}},
            {key: "creationDate", params: {}},
            {key: "registrationSite", params: {}},
            {key: "lastUpdate", params: {}},
            {key: "details", params: {}},
        ]

        const InvoiceTableFields = function () {
            return {
                id: {
                    name: 'Ticket Id',
                    class: 'vehicleRowCellSmall',
                    key: 'id'
                },
                code: {
                    name: 'Code',
                    orderBy: OrderRequestParamFactory.orderByInvoiceCode,
                    class: 'vehicleRowCellVeryBig',
                    key: 'code',
                },
                userId: {
                    name: 'User Id',
                    class: 'vehicleRowCellSmall',
                    key: 'User.id',
                    type: 'render',
                    render: function name(val, obj) {
                        return obj.User ? obj.User.id : '';
                    },
                },
                userFullName: {
                    name: 'User full name',
                    orderBy: OrderRequestParamFactory.orderByInvoiceUserId,
                    class: 'vehicleRowCellVeryBig',
                    ellipsis: true,
                    type: 'link',
                    link: {
                        goto: 'app.user.details',
                        gotoParams: 'userId',
                        key: 'User.id',
                        class: function (o) {
                            return 'userLink';
                        },
                    },
                    render: function (val, obj) {
                        return obj.User ? obj.User.fullName : '';
                    },
                },
                type: {
                    name: 'Type',
                    orderBy: OrderRequestParamFactory.orderByInvoiceType,
                    class: 'vehicleRowCellSmall',
                    ellipsis: true,
                    type: 'render',
                    render: function (val, obj) {
                        return InvoiceUtility.getInvoiceTypeDescription(obj);
                    },
                },
                // status: { name:"Status", class:"vehicleRowCellSmall", type:'render', render: function(val, obj) { return vm.getInvoiceStatusDescription(obj) }}, //sortId:"status",
                pdf: {
                    name: 'pdf',
                    class: 'vehicleRowCellSmall vehicleRowCellIcon',
                    type: 'icon-click',
                    icon: {
                        class: 'icon-link',
                        click: function (obj, $event) {
                            InvoiceUtility.openPdf(obj);
                        },
                        aria: 'Open PDF',
                    },
                    csv: function (v, o) {
                        return o.PDF[0] && o.PDF[0].location ? o.PDF[0].location : 'No PDF available';
                    },
                },
                creationDate: {
                    name: 'Issue Date',
                    orderBy: OrderRequestParamFactory.orderByInvoiceCreationDate,
                    defaultSort: true,
                    class: 'vehicleRowCellBigger',
                    type: 'render',
                    render: function (val, obj) {
                        return toDateFilter(obj.created, 'dateTime', obj.SiteId);
                    },
                },
                transactionUpdateDate: {
                    name: 'Last Transaction Update',
                    class: 'vehicleRowCellBigger',
                    type: 'render',
                    render: function (val, obj) {
                        const transaction = InvoiceUtility.getTransaction(obj);
                        // NOTE infer site from invoice, it is undefined in transaction
                        const siteId = obj.SiteId || DefaultSite.id;
                        return transaction
                            ? toDateFilter(
                                  transaction.updated_at,
                                  'dateTime',
                                  siteId
                              )
                            : '';
                    },
                },
                //updateDate: { name: "Modification date",sortId:"updated_at",class:""},
                parentCode: {
                    name: 'Rectified Sale',
                    class: 'vehicleRowCellBig',
                    type: 'render',
                    render: function (val, obj) {
                        return obj.parent ? obj.parent.code : '';
                    },
                }, //sortId:"parent.code"
                description: {
                    name: 'Description',
                    class: 'vehicleRowCellVeryBig',
                    key: 'description',
                    ellipsis: true,
                },
                paymentStatus: {
                    name: 'Transaction',
                    class: 'vehicleRowCellBig transactionStatus centered',
                    key: 'paymentStatusHuman',
                }, //sortId:"paymentStatusHuman"
                currencySymbol: {
                    name: 'Currency Symbol',
                    hide: true,
                    type: 'render',
                    render: function (val, o) {
                        return ServiceSettings.getCurrencySymbol(o.SiteId);
                    },
                },
                total: {
                    name: 'Total',
                    class: 'centered',
                    type: 'render',
                    render: function (v, o) {
                        return toCurrencyFilter(o.totalPrice, o.SiteId);
                    },
                    csv: function (v, o) {
                        return toNumberFilter(o.totalPrice);
                    },
                }, //sortId:"totalPrice"
                siteId: {
                    name: 'Site',
                    class: 'vehicleRowCell',
                    key: 'SiteId',
                    hide: !SitesService.isDefaultSiteSelected(),
                    type: 'render',
                    render: function (val, obj) {
                        return obj.SiteId !== undefined && obj.SiteId !== null
                            ? SitesService.getSiteName(obj.SiteId)
                            : 'No Site';
                    },
                },
                action: {
                    name: 'Action',
                    class: 'vehicleRowCellAction',
                    // type: 'render',
                    // render: function(v, o){ return '<md-button class="md-raised button30pxHeight" ng-click="vm.rectifyThisInvoice(' + o + ',$event)">' + (o.type == vm.invoiceType.TICKET.value ? 'Rectify' : 'Rectified') + '</md-button>'    }
                    type: 'button',
                    button: {
                        class: 'md-raised button30pxHeight',
                        click: function (invoice, ev) {
                            if (invoice && invoice.type == InvoiceType.TICKET.value) {
                                // FIXME refresh invoice list page after a rectified ticket creation
                                InvoicesDialogFactory.manage(ev, invoice)
                            }
                        },
                        aria: 'rectify',
                    },
                    render: function (v, o) {
                        return o.type == InvoiceType.TICKET.value ? 'Rectify' : 'Rectified';
                    },
                },
            };
        }

        const DefaultInvoiceListTableFields = [
            { key: 'id', params: {} },
            { key: 'code', params: {} },
            { key: 'userId', params: {} },
            { key: 'userFullName', params: {} },
            { key: 'type', params: {} },
            { key: 'pdf', params: {} },
            { key: 'creationDate', params: {} },
            { key: 'parentCode', params: {} },
            { key: 'description', params: {} },
            { key: 'paymentStatus', params: {} },
            { key: 'currencySymbol', params: {} },
            { key: 'total', params: {} },
            { key: 'siteId', params: {} },
            { key: 'action', params: {} },
        ];

        const AllwaysInvoiceListTableFields = [
            { key: 'id', params: {} },
            { key: 'code', params: {} },
            { key: 'userId', params: {} },
            { key: 'userFullName', params: {} },
            { key: 'type', params: {} },
            { key: 'pdf', params: {} },
            { key: 'creationDate', params: {} },
            { key: 'transactionUpdateDate', params: {} },
            { key: 'total', params: {} },
            { key: 'description', params: {} },
            { key: 'paymentStatus', params: {} },
            { key: 'currencySymbol', params: {} },
            { key: 'parentCode', params: {} },
            { key: 'siteId', params: {} },
            { key: 'action', params: {} },
        ];

        const CouponBonusTemplateTableFields = function () {
            return {
                id: {
                    name: 'Campaign Id',
                    orderBy: OrderRequestParamFactory.orderById,
                    defaultSort: true,
                    class: 'vehicleRowCellSmall',
                    key: 'id',
                    type: 'link',
                    link: {
                        goto: CouponTemplateDetailPage,
                        gotoParams: 'templateId',
                        key: 'id',
                        class: function (o) {
                            return 'userLink';
                        },
                    },
                    render: function (val, obj) {
                        return obj.id;
                    },
                },
                name: {
                    name: 'Name',
                    class: 'vehicleRowCellBig alignLeft',
                    ellipsis: true,
                    key: 'name',
                },
                // properties: { name: "properties", class: "vehicleRowCellVeryBig alignLeft", ellipsis: true, key: 'properties', type: 'render', render: function (v, o) { return JSON.stringify(o.properties) },
                fromDate: {
                    name: 'From',
                    class: 'vehicleRowCellMedium alignLeft',
                    key: 'fromDate',
                    type: 'render',
                    render: function (v, o) {
                        return CouponBonusUtility.getFromDate(o);
                    },
                },
                toDate: {
                    name: 'To',
                    class: 'vehicleRowCellMedium alignLeft',
                    key: 'toDate',
                    type: 'render',
                    render: function (v, o) {
                        return CouponBonusUtility.getToDate(o);
                    },
                },
                bonusTemplateId: {
                    name: 'TemplateId',
                    class: 'vehicleRowMedium',
                    key: 'BonusTemplate.id',
                    type: 'render',
                    render: function (v, o) {
                        return o.BonusTemplateId;
                    },
                },
                constraints: {
                    name: 'Constraints',
                    class: 'vehicleRowCellVeryBig alignLeft',
                    ellipsis: true,
                    key: 'constraints',
                    type: 'render',
                    render: function (v, o) {
                        return CouponBonusUtility.getConstraintDescription(o);
                    },
                },
                disabled: {
                    name: 'Disabled',
                    class: 'vehicleRowCellSmall',
                    key: 'disabled',
                    type: 'render',
                    render: function (v, o) {
                        return o.disabled !== 0 ? 'yes' : 'no';
                    },
                },
                onlyNewUser: {
                    name: 'Only New User',
                    class: 'vehicleRowCellMedium',
                    key: 'onlyNewUser',
                    type: 'render',
                    render: function (v, o) {
                        return o.onlyNewUser ? 'yes' : 'no';
                    },
                },
                purchased: {
                    name: 'Valid as payment',
                    class: 'vehicleRowCellSmall',
                    key: 'onlyNewUser',
                    type: 'render',
                    render: function (v, o) {
                        return o.purchased ? 'yes' : 'no';
                    },
                },
                creationDate: {
                    name: 'Creation date',
                    class: 'vehicleRowCellMedium',
                    type: 'render',
                    render: function (v, o) {
                        return toDateFilter(o.created_at, 'dateTime', o.SiteId || DefaultSite.id);
                    },
                },
                modificationDate: {
                    name: 'Modification date',
                    class: 'vehicleRowCellMedium',
                    type: 'render',
                    render: function (v, o) {
                        return toDateFilter(o.updated_at, 'dateTime', o.SiteId || DefaultSite.id);
                    },
                },
                site: {
                    name: 'Site',
                    class: 'vehicleRowCell preventLastChildShrink',
                    type: 'render',
                    render: function (v, o) {
                        return o.SiteId !== undefined && o.SiteId !== null
                            ? SitesService.getSiteName(o.SiteId)
                            : 'No site';
                    },
                },
                details: {
                    name: 'Details',
                    class: '',
                    key: 'details',
                    type: 'icon-link',
                    icon: {
                        goto: CouponTemplateDetailPage,
                        gotoParams: 'templateId',
                        icon: 'icon-information-outline',
                        key: 'id',
                    },
                },
            };
        };

        const DefaultCouponBonusTemplateListTableFields = [
            { key: 'id', params: {} },
            { key: 'name', params: {} },
            { key: 'fromDate', params: {} },
            { key: 'toDate', params: {} },
            { key: 'bonusTemplateId', params: {} },
            { key: 'constraints', params: {} },
            { key: 'disabled', params: {} },
            { key: 'onlyNewUser', params: {} },
            { key: 'purchased', params: {} },
            { key: 'creationDate', params: {} },
            { key: 'modificationDate', params: {} },
            { key: 'site', params: {} },
            { key: 'details', params: {} },
        ];

        const MovoCouponBonusTemplateListTableFields = [
            { key: 'id', params: {} },
            { key: 'name', params: {} },
            { key: 'fromDate', params: {} },
            { key: 'toDate', params: {} },
            { key: 'bonusTemplateId', params: {} },
            { key: 'constraints', params: {} },
            { key: 'disabled', params: {} },
            { key: 'onlyNewUser', params: {} },
            { key: 'creationDate', params: {} },
            { key: 'modificationDate', params: {} },
            { key: 'site', params: {} },
            { key: 'details', params: {} },
        ];

        const defaultActivePages = [
            'dashboard',
            'map',
            'damage-report',
            'vehicle',
            'trip',
            'user',
            'invoice',
            'coupon-legacy',
            'bonus',
            'bonus.template',
            'bonus.shopItem',
            'coupon-template',
            'settings',
            'settings.geofencing',
            'settings.device',
            'settings.damage',
            'settings.permission',
            'settings.api-settings',
        ];

        const twoHireActivePages = ["*"];

        const movoActivePages = defaultActivePages;
        const elerentActivePages = defaultActivePages.concat('settings.geofencingNew');
        const cosmicActivePages = defaultActivePages.concat('settings.geofencingNew');
        const easyBikeActivePages = defaultActivePages.concat('settings.geofencingNew');
        const megoMobilityActivePages = defaultActivePages.concat('settings.geofencingNew');

        const eGapActivePages = [
            'vehicle',
            'user',
            'settings',
            'settings.permission',
            'settings.api-settings',
            'settings.geofencing'
        ]

        const telepassActivePages = [
            'dashboard',
            'map',
            'vehicle',
            'trip',
        ]

        const driversoActivePages = [
            'map',
            'vehicle',
            'trip',
            'user',
        ]

        const bipiActivePages = [
            'map',
            'vehicle',
            'trip',
            'user',
        ]

        const DefaultMapConfigs = {
            center: {
                latitude: 41.9027835, 
                longitude: 12.4963655,
            },
            zoom: 12
        }

        const MovoMapConfigs = {
            center: {
                latitude: 40.435451, 
                longitude: -3.692558,
            },
            zoom: 12
        }

        //serviceName: object
        const appConfigurations = {
            default: {
                table: {
                    vehicle: {
                        list: {
                            fields: DefaultVehicleListTableFields,
                        },
                    },
                    trip: {
                        list: {
                            fields: DefaultTripListTableFields,
                        },
                    },
                    user: {
                        list: {
                            fields: DefaultUserListTableFields,
                        },
                    },
                    invoice: {
                        list: {
                            fields: DefaultInvoiceListTableFields,
                        }
                    },
                    couponBonusTemplate: {
                        list: {
                            fields: DefaultCouponBonusTemplateListTableFields,
                        },
                    },
                },
                module: {
                    pages: defaultActivePages,
                },
                map: {
                    configs: DefaultMapConfigs,
                },
                actions: {
                    bonusTemplate: {
                        list: {
                            addTemplate: false,
                        },
                    },
                    shopItem: {
                        list: {
                            addItem: false,
                        },
                    },
                    couponBonusTemplate: {
                        list: {
                            addTemplate: false,
                        },
                        detail: {
                            addCode: false,
                        },
                    },
                    user: {
                        detail: {
                            manageUserSites: false,
                        },
                    },
                    vehicle: { list: { bulkActions: false } },
                },
            },
            '2hire': {
                module: {
                    pages: twoHireActivePages,
                },
                actions: {
                    bonusTemplate: {
                        list: {
                            addTemplate: true,
                        },
                    },
                    shopItem: {
                        list: {
                            addItem: true,
                        },
                    },
                    couponBonusTemplate: {
                        list: {
                            addTemplate: true,
                        },
                        detail: {
                            addCode: true,
                        },
                    },
                    actions: {
                        user: {
                            detail: {
                                manageUserSites: true,
                            },
                        },
                    },
                },
            },
            movo: {
                module: {
                    pages: movoActivePages,
                },
                map: {
                    configs: MovoMapConfigs,
                },
                table: {
                    user: {
                        list: {
                            fields: MovoUserListTableFields,
                        },
                    },
                    trip: {
                        list: {
                            fields: MovotTripListTableFields,
                        },
                    },
                    couponBonusTemplate: {
                        list: {
                            fields: MovoCouponBonusTemplateListTableFields,
                        },
                    },
                },
            },
            govolt: {
                table: {
                    vehicle: {
                        list: {
                            fields: GovoltVehicleListTableFields,
                        },
                    },
                    trip: {
                        list: {
                            fields: GovoltTripListTableFields,
                        },
                    },
                    user: {
                        list: {
                            fields: GovoltUserListTableFields,
                        },
                    },
                },
                actions: {
                    user: {
                        detail: {
                            manageUserSites: true,
                        },
                    },
                    vehicle: { list: { bulkActions: true } },
                },
            },
            ride: {
                table: {
                    vehicle: {
                        list: {
                            fields: RideVehicleListTableFields,
                        },
                    },
                    trip: {
                        list: {
                            fields: RideTripListTableFields,
                        },
                    },
                },
            },
            'e-gap': {
                table: {
                    vehicle: {
                        list: {
                            fields: eGapVehicleListTableFields,
                        },
                    },
                },
                module: {
                    pages: eGapActivePages,
                },
            },
            telepass: {
                module: {
                    pages: telepassActivePages,
                },
            },
            elerent: {
                module: {
                    pages: elerentActivePages,
                },
                actions: {
                    vehicle: { list: { bulkActions: true } },
                },
            },
            allways: {
                table: {
                    user: {
                        list: {
                            fields: AllwaysUserListTableFields,
                        },
                    },
                    invoice: {
                        list: {
                            fields: AllwaysInvoiceListTableFields,
                        }
                    }
                },
            },
            driverso: {
                module: {
                    pages: driversoActivePages,
                },
            },
            bipi: {
                module: {
                    pages: bipiActivePages,
                },
            },
            tino: {
                actions: {
                    user: {
                        detail: {
                            manageUserSites: true,
                        },
                    },
                },
            },
            cosmic: {
                module: {
                    pages: cosmicActivePages,
                },
                actions: {
                    vehicle: { list: { bulkActions: true } },
                    user: {
                        detail: {
                            manageUserSites: true,
                        },
                    }
                },
            },
            easybike: {
                table: {
                    vehicle: {
                        list: {
                            fields: easyBikeVehicleListTableFields,
                        },
                    },
                },
                module: {
                    pages: easyBikeActivePages,
                },
                actions: {
                    user: {
                        detail: {
                            manageUserSites: true,
                        },
                    }
                },
            },
            giraff: {
                actions: {
                    vehicle: { list: { bulkActions: true } },
                },
            },
            megomobility: {
                module: {
                    pages: megoMobilityActivePages,
                },
                actions: {
                    user: {
                        detail: {
                            manageUserSites: true,
                        },
                    }
                },
            }
        };

        function getAppConfiguration(configKey, serviceName){

            if(!configKey || configKey.split(".") && configKey.split(".")[0]==""){
                console.warn("getAppConfiguration: invalid input",configKey)
                return null
            }
            // NOTE pass serviceName i think it is not good, do it only for page module purpose (and the fact service data it is not yet loaded at module declaration)
            var serviceName = serviceName || ServiceData.getServiceName()
            const currentServiceName = serviceName.replace(/-test.*$/g,"").replace(/-multisite.*$/g,"").toLowerCase()

            const objPath = configKey.split(".")
            objPath.unshift(currentServiceName)
            const specificServiceConfig = objPath.reduce(function(prev, key){ return prev && prev[key] }, appConfigurations)
            var defaultServiceConfig = null

            if(specificServiceConfig == undefined){
                objPath.splice(0, 1, "default")
                defaultServiceConfig = objPath.reduce(function(prev, key){ return prev && prev[key] }, appConfigurations)
            }
            return specificServiceConfig !== undefined ? specificServiceConfig : defaultServiceConfig
        }

        this.getVehicleListTableFields = function(){
            const specificTableFields = getAppConfiguration("table.vehicle.list.fields")
            const tableFieldsObj = VehicleTableFields()
            return specificTableFields.map(function (obj){ return Object.assign(tableFieldsObj[obj.key], obj.params) })
        }

        this.getTripListTableFields = function(){
            const specificTableFields = getAppConfiguration("table.trip.list.fields")
            const tableFieldsObj = TripTableFields()
            return specificTableFields.map(function (obj){ return Object.assign(tableFieldsObj[obj.key], obj.params) })
        }

        this.getUserListTableFields = function(){
            const specificTableFields = getAppConfiguration("table.user.list.fields")
            const tableFieldsObj = UserTableFields()
            return specificTableFields.map(function(obj){ return Object.assign(tableFieldsObj[obj.key], obj.params) })
        }

        //TODO prevent to duplicate this fn for every table declaration
        this.getInvoiceListTableFields = function(){
            const specificTableFields = getAppConfiguration('table.invoice.list.fields');
            const tableFieldsObj = InvoiceTableFields();
            return specificTableFields.map(function (obj) {
                return Object.assign(tableFieldsObj[obj.key], obj.params);
            });
        }
        
        //TODO prevent to duplicate this fn for every table declaration
        this.getCouponBonusTemplateList = function(){
            const specificTableFields = getAppConfiguration('table.couponBonusTemplate.list.fields');
            const tableFieldsObj = CouponBonusTemplateTableFields();
            return specificTableFields.map(function (obj) {
                return Object.assign(tableFieldsObj[obj.key], obj.params);
            });
        }

        this.isPageEnabled = function (pageName) {
            // FIXME pass serviceName i think it is not good, do it only for page module purpose (and the fact service data it is not yet loaded at module declaration)
            const serviceNameRaw = LocalStorageService.getItem(ServiceTokenData.COMPANY) || "";
            const serviceName = serviceNameRaw.replace(/-test.*$/g, "").replace(/-multisite.*$/g, "");
            const pageModuleConfig = getAppConfiguration("module.pages", serviceName);
            return (
                pageModuleConfig.includes(pageName) || (pageModuleConfig.length === 1 && pageModuleConfig.includes("*"))
            );
        }

        this.getMapConfigs = function () {
            const mapConfigs = getAppConfiguration("map.configs")
            return mapConfigs
        }

        this.isActionEnabled = function(action) {
            const isEnabled = getAppConfiguration( "actions." + action );
            return isEnabled;
        }
    }

    /** @ngInject */
    function ServiceData(ServiceTokenData, LocalStorageService, ServiceAdapter, ShowToast, AppSettings){
        var serviceData = null

        function getServiceFromName(callback){
            var serviceName = LocalStorageService.getItem(ServiceTokenData.COMPANY)
            if(!serviceName){
                console.warn("ServiceData.getServiceFromName: invalid serviceName",serviceName)
                return
            }

            ServiceAdapter.getServiceFromName({name: serviceName.toLowerCase()}, function(service, error){
                if(error){
                    if(callback){
                        callback(null,error)
                    }
                }else{
                    // console.log("ServiceData.getServiceFromName: service data",service)
                    setServiceData(service)

                    if(callback){
                        callback(service,null)
                    }
                }
            })
        }

        function checkIfServiceIsEnabled(){
            // console.log("checkIfServiceIsEnabled",serviceData.isEnabled)
            
            if(!serviceData.isEnabled) {
                ShowToast.showServiceDisabled()
            }else{
                ShowToast.hideCurrent()
            }
        }

        this.checkIfServiceIsEnabled = checkIfServiceIsEnabled

        this.getServiceData = function(callback){
            if(!serviceData){
                console.log("ServiceData.getServiceData: serviceData is null, refresh")
                getServiceFromName(callback)
            }else{
                callback(serviceData,null)
            }
        }

        function setServiceData (newServiceData){
            // console.log("setServiceData: new data",newServiceData)
            serviceData = {
                id: newServiceData.id,
                name: newServiceData.name,
                domain: newServiceData.domain,
                isEnabled: (typeof newServiceData.canBook === "boolean") ? newServiceData.canBook : true,
                isFree: newServiceData.free,
                isTesting: newServiceData.inTesting,
                isMultisite: newServiceData.multisite,
                permissionsEnabled: newServiceData.enablePermission,
                referralCouponId: newServiceData.ReferralCouponId

            }
            // console.log("setServiceData: current data",serviceData)
            if(serviceData){
                AppSettings.setCurrentServiceData(serviceData)
            }
        }

        this.getServiceName = function(){

            if(serviceData == null){
                console.warn("ServiceData.getServiceName: serviceData is null")
                return ""
            }

            return serviceData.name
        }

        this.setServiceData = setServiceData

        this.refresh = function(callback){
            getServiceFromName(function (service,error) {
                if(error){
                    console.log("ServiceData.refresh: error refresh")
                    callback(null,error)
                }
                else {
                    console.log("ServiceData.refresh: service data refreshed")
                    callback(serviceData,null)
                }
            })
        }
    }

    /** @ngInject */
    function ServiceSettings(ApiSettingsAdapter, LocalStorageService, SessionStorageService, TokenData, DefaultSite, $mdDateLocale, $rootScope, AppSettings) {
        var isCurrentlyFetching = false;
        var baseServiceSettings = null;
        var settings = null  // active settings

        function setDateLocaleConfigs(){
            const selectedSite = AppSettings.getSelectedSite()
            var timezone = getSiteTimezone(selectedSite.id)
            if(!timezone){
                timezone = moment.tz.guess()
                console.warn("ServiceSettings.setDateLocaleConfigs: no timezone,set browser timezone",timezone)
            }

            //date config
            $mdDateLocale.formatDate = function (date) {
                var dateString = ""
                if(date instanceof Date){
                    dateString = moment.tz({year: date.getFullYear(),month: date.getMonth(),day: date.getDate(), hour: date.getHours(), minute: date.getMinutes(), second: date.getSeconds()},timezone).format('DD/MM/YYYY')
                }
                if(dateString == "Invalid date"){
                    dateString = ""
                }
                return dateString
            }

            $mdDateLocale.parseDate = function(dateString) {
                // console.log(dateString,timezone)
                var m = moment.tz(dateString, 'DD/MM/YYYY', timezone)
                return m.isValid() ? m.toDate() : new Date(NaN) //toDate should not be used bu unfortunatly datepicker support only js date
            }
        }
        
        function setSettingsFromObject(newSettings,siteId){

            if(settings==null){
                settings = {}
            }
            
            if(siteId !== undefined) {
                settings[siteId] = parseSettings(newSettings);
            } else {
                var parsedNewSettings = parseSettings(newSettings);
                Object.keys(parsedNewSettings).forEach(function(key){
                    settings[key] = parsedNewSettings[key];
                });

            }
        }

        function parseSettings(newSettings){
            // TODO: think if is useful to set timezone and currencySymbol to null if them do not exist
            const settings = {
                timezone: (newSettings && newSettings.service && newSettings.service.timezone) || null,
                currencySymbol: (newSettings && newSettings.payment && newSettings.payment.currencyInfo && newSettings.payment.currencyInfo.symbol) || null,
            }
            const millisToCredit = (newSettings && newSettings.movo && newSettings.movo.pricing && newSettings.movo.pricing.millisToCredit && newSettings.movo.pricing.millisToCredit.value ) || null;
            if(millisToCredit !== null){
                settings.millisToCredit = millisToCredit
            }
            return settings
        }

        /**
         * Adapter to get settings of active service. 
         * Runs the callback with timezone as first parameter, error as second.
         */
        this.fetchServiceSettings = function(callback) {
            if(isCurrentlyFetching) {
                console.warn('ApiSettingsAdapter.fetchServiceSettings: isCurrentlyFetching')
                return //callback(null, true);
            } else {
                isCurrentlyFetching = true;
            }

            //prevent getSettings loops when user logout and toDateFilter is still triggered
            var isUserLogged = LocalStorageService.getItem(TokenData.TOKEN) || SessionStorageService.getItem(TokenData.TOKEN)
            if(!isUserLogged){
                console.warn('ApiSettingsAdapter.fetchServiceSettings: fetch when user logout')
                return
            }

            ApiSettingsAdapter.getSettings(function(response, error){
                // console.log("serviceSett",response)
                isCurrentlyFetching = false;
                if(!error){
                    
                    if(response.hasOwnProperty('base') && response.hasOwnProperty('hardcoded') && response.hasOwnProperty('specific')) {
                        
                        const selectedSite = AppSettings.getSelectedSite() // avoid circular dependnecy with SitesService.getselectedsite
                        if(!selectedSite || Object.keys(selectedSite).length==0){
                            console.warn("ServiceSettings.getSettings: selectedSite", selectedSite)
                            callback(null, 'Error with selectedSite')
                            return
                        }
                        
                        const siteId = selectedSite.id
                        
                        // TODO:  Update with the "recursive merge" algorithm.
                        baseServiceSettings = Object.assign(response.hardcoded, response.base)
                        // console.log("parse default settings", baseServiceSettings)
                        setSettingsFromObject(baseServiceSettings)

                        // set the specificSettings object
                        const specificServiceSettingsSitesId = Object.keys(response.specific)
                        if(response.specific && specificServiceSettingsSitesId.length > 0) {
                            specificServiceSettingsSitesId.forEach(function(siteId) {
                                setSettingsFromObject(response.specific[siteId], siteId)
                            })
                        }

                        // console.log("settings",settings)
                    }
                    else { // fallback to old API
                        setSettingsFromObject(response)
                    }
                    // NOTE set date getter to show timezoned date. Is this still needed?
                    setDateLocaleConfigs();
                    settings.loaded = true

                    if(settings.loaded) {
                        $rootScope.$broadcast('refreshServiceSettings')
                        callback(settings, null)
                    } else {
                        callback(null, 'Error while retrieving timezone. Response was not valid')
                    }
                }else{
                    console.log(error)
                    if(callback) {
                        callback(null, error)
                    }
                }
            })
        }

        /**
         * Get settings of specific service (can be different from the active service). 
         */
        // this.getSpecificServiceSettings = function(siteId, callback){
        //     if(callback) {
        //         return callback(settings[siteId])
        //     } else {
        //         return specificSettings[siteId];
        //     }
        // }

        /**
         * @param {number} siteId Site ID 
         * @param {function} callback callback fn 
         */
        this.getServiceSettings = function(callback) {
            if(callback) {
                if(settings==null){
                    // console.warn("ServiceSettings.getServiceSettings: settings null")
                }
                return settings ? callback(settings, null) : this.fetchServiceSettings(callback);
            } else {
                console.warn('Missing callback on getTimezone()');
            }
        }
        
        this.updateServiceSettings = function(callback) {
            this.fetchServiceSettings(function (settings, error) {
                if(!error) {
                    if(callback){
                        return callback(settings)
                    }
                } else {
                    if(callback){
                        return callback(null, 'Error Loading service settings')
                    }
                }
            })
        }

        /**
         * This method gets the current data from the specific site settings, 
         * if the value is not present, it defaults to default service settings.
         * @param {string} value the key we need 
         * @param {number} siteId the Site ID 
         */
        function getSiteValue(value, siteId) {
            
            if(settings === null){
                console.warn('ServiceSettings.getCurrentValue: settings null',value,siteId)
                return null
            }

            if(siteId === DefaultSite.id) {
                // console.warn("ServiceSettings.getSiteValue: use default site",value)
                return settings[value] ? settings[value] : null
            }

            return siteId && settings[siteId] && typeof settings[siteId][value] !== "undefined" ? settings[siteId][value] : null;
        }
        // NOTE: this should be the the only fn to access to settings in order to use specific if exists or default otherwise
        // The fn getSiteValue is used to access to default or site id
        function getSiteSetting(value, siteId){

            if(settings === null){
                console.warn('ServiceSettings.getSiteSetting: settings null',value,siteId)
                return null
            }

            const siteValue = siteId && settings[siteId] && typeof settings[siteId][value] !== "undefined" ? settings[siteId][value] : null
            if(siteValue == null){
                // console.log("getSiteSetting: get default")
                return settings[value] ? settings[value] : null
            }
            return siteValue
        }

        this.getDefaultTimezone = function() {
            return getSiteValue('timezone', DefaultSite.id);
        }

        function getSiteTimezone(siteId) {
            return getSiteValue('timezone', siteId);
        }

        this.getSiteTimezone = getSiteTimezone;

        this.getCurrencySymbol = function(siteId) {
            return getSiteValue('currencySymbol', siteId);
        }

        this.getMillisToCredit = function(siteId) {
            return getSiteSetting("millisToCredit", siteId);
        }
    }

    /** @ngInject */
    function SitesService(SitesAdapter,SessionStorageService,LocalStorageService,MiscData,DefaultSite,UserAdapter,AppSettings,ErrorUtility) {
        var allSites = []
        var sites = null
        var sitesLoaded = false
        var defaultSite = {id: DefaultSite.id,name: DefaultSite.name}
        var selectedSite = null
        var self = this
        this.isServiceMultisite = false
        var restrictedSite = null

        function checkIfUserIsSiteRestricted(allSites,callback){
            //check if user is site restricted loading user's info and in case re-init sites
            UserAdapter.getUserStatus(function(response, error){
                if(!error){
                    var user = response.user
                    
                    if(user.SiteId !== undefined && user.SiteId !== null){
                        console.warn("SitesService.getSites: user is site restricted")
                        setSelectedSite(getSite(user.SiteId),true)
                        if (!SessionStorageService.getItem(MiscData.USERSITE)) {
                            SessionStorageService.setItem(MiscData.USERSITE, user.SiteId)
                        }
                    }else{
                        sites = allSites
                    }

                    //FIX ME: improve the point calling get status  
                    if(!SessionStorageService.getItem(MiscData.USERID)){
                        SessionStorageService.setItem(MiscData.USERID, response.user.id)
                    }

                    sitesLoaded = true
                    
                    callback(sites,null)
                }else{
                    callback(null,error)
                }
            })
        }

        function getSites(callback) {
            sitesLoaded = false
            
            SitesAdapter.getSites(function(newSites,error) {
                if(!error){

                    if(!newSites || !Array.isArray(newSites)){
                        console.warn("SitesService inner getSites: invalid sites get", newSites);
                        return
                    }
                    
                    if(newSites.length>0){
                        self.isServiceMultisite = true
                    }
                    newSites.sort(function(s1,s2){
                        return s1.name > s2.name ? 1 : -1;
                    });
                    allSites = newSites
                    allSites.unshift(defaultSite)
                    sites = allSites

                    var selectedSiteSaved = LocalStorageService.getItem(MiscData.SITE)
                    var siteId = parseInt(selectedSiteSaved)
                    
                    if(selectedSiteSaved && !isNaN(siteId)){
                        setSelectedSite(getSite(siteId))
                    }
                    else {
                        console.warn("SitesService.refresh: selectedSite is NOT saved yet or is NaN, set default")
                        setSelectedSite(defaultSite)
                    }

                    //disabled first set, do it after check restricted site
                    // sites = [selectedSite]
                    
                    // callback(sites,null)
                    //do the restricted site check syncronously
                    checkIfUserIsSiteRestricted(allSites,callback)
                }
                else {
                    callback(null,error)
                    ErrorUtility.showErrorMessage({title:'Get Sites',description:'Error while getting the sites list!'})
                }
            })
        }

        this.getSites = function (callback) {
            if(!sitesLoaded){
                console.log("SitesService: sites are null")
                getSites(callback)
            } else {
                callback(sites)
            }

        };

        this.setSites = function (newSites) {
            if(!newSites || !Array.isArray(newSites)){
                console.warn("SitesService.setSites: invalid sites set", newSites);
                return
            }
            this.isServiceMultisite = true
            newSites.sort(function(s1,s2){
                return s1.name > s2.name ? 1 : -1;
            });
            sites = newSites
        }

        function setSelectedSite(site,isRestricted,callback) {

            if(site === undefined || site === null){
                console.warn('SitesService.setSelectedSite: site is invalid',site)
                return
            }

            selectedSite = site
            LocalStorageService.setItem(MiscData.SITE,site.id)

            // FIX ME: improve
            // store selected site even in AppSettings baecause of using SitesService triggers circular dependecy injection with http in the interceptor
            AppSettings.setSelectedSite(site)
            
            if(isRestricted){
                restrictedSite = site
                sites = [restrictedSite]
            }
            if(typeof callback !== "undefined"){
                callback()
            }
        }

        this.setSelectedSite = setSelectedSite

        this.getSelectedSite = function () {
            return (selectedSite && selectedSite.id) || null
        }

        var getSite = function(siteId){

            var siteFound = null

            if(!sites){
                console.warn('SitesService.getSite: sites are not loaded yet',sites)
                return siteFound
            }

            if(siteId === undefined){
                console.warn('SitesService.getSite: siteId is invalid',siteId)
                return siteFound
            }

            siteFound = allSites.find(function (site) {
                return (site.id == siteId)
            })

            return siteFound
        }
        
        this.getSite = getSite

        this.getSiteName = function (siteId) {

            var site = getSite(siteId)
            
            if(!site){
                // console.warn("SitesService.getSiteName: no site found")
                // setSelectedSite(defaultSite)
                // site = defaultSite
            }

            return site ? site.name : ""
        }

        this.getSiteId = function (siteName) {
            for (var i = 0; i < sites.length; i++) {
                if (sites[i].name === siteName) {
                    return sites[i].id
                }
            }
        }

        this.isDefaultSiteSelected = function(){
            return selectedSite.id == DefaultSite.id
        }

        this.isUserSiteResctricted = function(){
            console.log("isUserSiteResctricted",restrictedSite !== null)
            return restrictedSite !== null
        }

        this.refresh = function (callback) {
            getSites(function (newSites,error) {
                if(!error){
                    // console.log("SitesService: sites refreshed")
                    sites = newSites
                    callback(newSites,null)
                }
                else {
                    sites = null
                    callback(null,error)
                    console.log("SitesService: error refresh,force value to null")
                }
            })
        }
    }

    /** @ngInject */
    function LogInUtility(ServiceAdapter,AppSettings,LogInService,ServerDomain,HttpHeadersManager){

        function getServiceInfo(serviceName,callback){
            if(!serviceName){
                console.warn("LogInUtility.getServiceInfo: invalid serviceName", serviceName)
                return
            }
            ServiceAdapter.getServiceFromName({name: serviceName.toLowerCase()}, function(service, error){
                if(error){
                    if(callback){
                        callback(null,error)
                    }
                }else{
                    // console.log("LogInUtility.getServiceInfo: service data",service)
                    if(callback){
                        callback(service,null)
                    }
                }
            })
        }

        function handleServiceInfo(service){
            var serviceTokenCode = service.token

            if(serviceTokenCode){
                setServiceTokenHeader(serviceTokenCode)
                
            }else{
                console.error("LogInUtility.handleServiceInfo: serviceTokenCode is invalid",serviceTokenCode)
                throw {type:'invalidServiceToken', description:''}
            }

            LogInService.saveCompanyLogInData(service.name, serviceTokenCode)
            
            if(service.domain){                                        
                AppSettings.setBaseUrl(service.domain)
            }else{
                console.error("LogInUtility.handleServiceInfo: service domain is invalid",service.domain)
                throw {type:'invalidServiceDomain', description:''}
            }
        }

         function setServiceTokenHeader(serviceTokenCode){
            if(!serviceTokenCode){
                console.warn("LogInUtility.setServiceTokenHeader: invalid serviceTokenCode",serviceTokenCode)
                return
            }
            // console.warn("LogInUtility.setServiceTokenHeader: serviceTokenCode for header",serviceTokenCode)
            HttpHeadersManager.setCommonServiceToken(serviceTokenCode)
        }

        this.setServiceTokenHeader = setServiceTokenHeader

        function setAuthorizationHeader(tokenCode){
            if(!tokenCode){
                console.warn("LoginUtility.setAuthorizationHeader: invalid tokenCode",tokenCode)
                return
            }
            // console.warn("LoginUtility.setAuthorizationHeader: tokenCode for header",tokenCode)
            HttpHeadersManager.setCommonAuthorization(tokenCode)
        }
        this.setAuthorizationHeader = setAuthorizationHeader
        
        this.doCompanyLogIn = function(serviceName, callback){
            // console.log("LogInUtility.doCompanyLogIn: first step, look for baseUrl")
            
            AppSettings.setBaseUrlToDefault()
            // do a first call to getServiceInfo (with the default 2hire domain) to load the current service domain to set the app's base url
            getServiceInfo(serviceName, function(service, error){
                if(error){
                    if(callback){
                        callback(null,error)
                    }
                }else{
                    
                    try{
                        // set the new app's base url and service token from the current service info
                        handleServiceInfo(service)
                        
                        if(service.domain && service.domain === ServerDomain.TOHIRE){
                            // console.log("LogInUtility.doCompanyLogIn: same domain, prevent next look up for service token")
                            callback(service,null)
                        }else{
                            // console.log("LogInUtility.doCompanyLogIn: second step, look for serviceToken")
                            // do a second call (now with the new base url set from the current service domain) to load the new service token
                            getServiceInfo(serviceName, function(service, error){
                                if(error){
                                    if(callback){
                                        callback(null,error)
                                    }
                                }else{
                                    try{
                                        handleServiceInfo(service)
                                        
                                        if(callback){
                                            callback(service,null)
                                        }
                                    }catch(error){
                                        if(callback){
                                            callback(null,error)
                                        }
                                    }
                                }
                            })
                        }
                    }catch(error){
                        if(callback){
                            callback(null,error)
                        }
                    }
                    
                }
            })
        }
    }

    /** @ngInject */
    function LogInService(LocalStorageService,SessionStorageService,TokenData,ServiceTokenData,MiscData) {

        this.saveCompanyLogInData = function(serviceName,serviceTokenCode){

            if(!serviceName || !serviceTokenCode){
                console.warn("LogInService.companyLogIn: invalid input",serviceName,serviceTokenCode)
                return
            }

            //service token is stored in localStorage only,it must be always present
            LocalStorageService.setItem(ServiceTokenData.COMPANY, serviceName)
            LocalStorageService.setItem(ServiceTokenData.TOKEN, serviceTokenCode)            
        }

        this.saveLoginData = function(tokenCode,tokenExpire,keepData){
            if(!tokenCode || !tokenExpire){
                console.warn("LogInService.login: invalid input",tokenCode,tokenExpire)
                return
            }
            if(typeof keepData === "undefined"){
                keepData=true
            }
            if(keepData){
                LocalStorageService.setItem(TokenData.TOKEN, tokenCode)
                LocalStorageService.setItem(TokenData.EXPIRE, tokenExpire)
            }else{
                SessionStorageService.setItem(TokenData.TOKEN, tokenCode)
                SessionStorageService.setItem(TokenData.EXPIRE, tokenExpire)
            }
        }

        this.logOut = function(){

            LocalStorageService.removeItem(TokenData.TOKEN)
            LocalStorageService.removeItem(TokenData.EXPIRE)
            SessionStorageService.removeItem(TokenData.TOKEN)
            SessionStorageService.removeItem(TokenData.EXPIRE)

            //remove userId and isUserLogged in session storage
            SessionStorageService.removeItem(MiscData.USERID)
            SessionStorageService.removeItem(MiscData.USERSITE)
            SessionStorageService.removeItem(MiscData.ISUSERLOGGED)

            LocalStorageService.removeItem(MiscData.DETAILSID)
            LocalStorageService.removeItem(MiscData.ISUSERLOGGED)

            //SitesService clear
            LocalStorageService.removeItem(MiscData.SITE)
            console.log("LogInService.logOut: storage cleaned,reset app state")            
        }
    }

    /** @ngInject */
    function GenericAppDataService(){
        var genericAppData = {sortList:{},filters:{}}
        
        this.setSortListInfo = function(info){
            genericAppData.sortList = info
        }

        this.getSortListInfo = function(){
            return genericAppData.sortList
        }

        this.setFiltersInfo = function(info){
            genericAppData.filters = info
        }

        this.getFiltersInfo = function(){
            return genericAppData.filters
        }
    }

    /** @ngInject */
    function VehicleUtilityFactory(VehicleTypes,VehicleStatus,VehicleExternalStatus,VehicleBookingStatus,toDateFilter,UserUtility,MovoUnavailableDescriptor) {

        function getIconUrl(vehicleType) {

            var iconUrl="";

            switch (vehicleType){

                case VehicleTypes.CAR.value:
                    iconUrl = 'assets/icons/pin/pin-car.svg';
                    break;

                case VehicleTypes.SCOOTER.value:
                    iconUrl = 'assets/icons/pin/pin-scooter.svg';
                    break;

            }

            return iconUrl
        }

        function getIconUrl(vehicleType, status, isInMaintenance, accessories){
            var iconUrl=""
            var vehicleTypeIconLabel = ""
            var referenceCode = (accessories && accessories.referenceCode) || ""
            
            switch (vehicleType){

                case VehicleTypes.CAR.value:
                    vehicleTypeIconLabel = "Car"
                    if (referenceCode.toLowerCase().indexOf("birò") !== -1 ||
                        referenceCode.toLowerCase().indexOf("biro") !== -1
                    ) {
                        vehicleTypeIconLabel = "biro/Biro"
                    }
                    break;
                case VehicleTypes.SCOOTER.value:
                    vehicleTypeIconLabel = "Scooter"
                    if (referenceCode.toLowerCase().indexOf("birò") !== -1 ||
                        referenceCode.toLowerCase().indexOf("biro") !== -1
                    ) {
                        vehicleTypeIconLabel = "biro/Biro"
                    }
                    break
                case VehicleTypes.KICK_SCOOTER.value:
                    vehicleTypeIconLabel = "KickScooter"
                    break
                case VehicleTypes.BIKE.value:
                    vehicleTypeIconLabel = "Bike"
                    break
                default:
                    vehicleTypeIconLabel = "Car"

            }
            if(isInMaintenance){
                iconUrl = "assets/icons/pin/"+vehicleTypeIconLabel+"_Maintenance.svg"
            }
            else{
                switch(status){
                    case VehicleStatus.FREE.value:
                        iconUrl = "assets/icons/pin/"+vehicleTypeIconLabel+"_Free.svg"
                        break
                    case VehicleStatus.BOOKED.value:
                        iconUrl = "assets/icons/pin/"+vehicleTypeIconLabel+"_Booked.svg"
                        break
                    case VehicleStatus.PARKED.value:
                        iconUrl = "assets/icons/pin/"+vehicleTypeIconLabel+"_Parked.svg"
                        break
                    case VehicleStatus.UNAVAILABLE.value:
                        iconUrl = "assets/icons/pin/"+vehicleTypeIconLabel+"_Maintenance.svg"
                        break
                    case 'tripStart':
                        iconUrl = "assets/icons/pin/"+vehicleTypeIconLabel+"_Booked.svg"
                        break
                    case 'tripPause':
                        iconUrl = "assets/icons/pin/"+vehicleTypeIconLabel+"_Pause.svg"
                        break
                    case 'tripEnd':
                        iconUrl = "assets/icons/pin/"+vehicleTypeIconLabel+"_FinishTrip.svg"
                        break
                    default:
                        iconUrl = "assets/icons/pin/"+vehicleTypeIconLabel+"_Using.svg"
                }
            }

            return iconUrl
        }

        function getAllIconUrls() {
            const output = []
            for (var type in VehicleTypes) {
                for(var status in VehicleStatus) {
                    output.push(getIconUrl(VehicleTypes[type].value, VehicleStatus[status].value))
                }
                output.push(getIconUrl(VehicleTypes[type].value, 'tripStart'))
                output.push(getIconUrl(VehicleTypes[type].value, 'tripPause'))
                output.push(getIconUrl(VehicleTypes[type].value, 'tripEnd'))
            }
            for(var status in VehicleStatus) {
                output.push(getIconUrl(VehicleTypes.SCOOTER.value, VehicleStatus[status].value, false, 'biro'))
            }
            output.push(getIconUrl(VehicleTypes.SCOOTER.value, 'tripStart', 'biro'))
            output.push(getIconUrl(VehicleTypes.SCOOTER.value, 'tripPause', 'biro'))
            output.push(getIconUrl(VehicleTypes.SCOOTER.value, 'tripEnd', 'biro'))

            return output
        }

        var commaString = ","

        function getVehicleShortAddress(vehicle) {
            var shortAddress = "No address"

            if(vehicle && vehicle.address){
                var addressSplitted = vehicle.address.split(',')
                shortAddress = addressSplitted[0]
                var spaceIndex = addressSplitted[1] ? addressSplitted[1].lastIndexOf(" ") : -1
                //append second string only if is not zip code
                if (spaceIndex == 0){
                    shortAddress += commaString + addressSplitted[1]
                }
            }
            return shortAddress
        }

        function getVehicleExternalStatusDescription(statusNameToFind) {
            var statusDescription = ""
            for (var status in VehicleExternalStatus){
                if(VehicleExternalStatus[status].value == statusNameToFind){
                    statusDescription = VehicleExternalStatus[status].name
                    break
                }
            }

            return statusDescription
        }

        function getVehicleExternalStatuses(vehicle) {

            if(!vehicle){
                console.warn("getVehicleExternalStatuses: invalid input")
                return ''
            }

            var vehicleStatuses = []
            var descr = ''

            if(vehicle.status == VehicleStatus.UNAVAILABLE.value){
                descr = getVehicleUnavailableStatusDescription(vehicle)
            }else{
                for( var statusName in vehicle.external_status){
        
                    if(vehicle.external_status[statusName]){
                        vehicleStatuses.push(getVehicleExternalStatusDescription(statusName))
                        break
                    }
                }
                descr = vehicleStatuses[0]
            }

            return descr
        }

        function getVehicleUnavailableStatusDescription(vehicle){
            
            if(!vehicle){
                console.warn("getVehicleUnavailableStatusDescription: invalid input")
                return ''
            }
            
            var descr = ''
            if(
                vehicle.status == VehicleStatus.UNAVAILABLE.value 
                && vehicle.movoUnavailableDescriptor !== undefined 
                && vehicle.movoUnavailableDescriptor !== MovoUnavailableDescriptor.NONE.value
            ){
                const unavailableDescrObj = Object.values(MovoUnavailableDescriptor).find(function(descriptionObj){ return descriptionObj.value == vehicle.movoUnavailableDescriptor })
                descr = unavailableDescrObj ? unavailableDescrObj.name : ''
            }

            return descr
        }

        /** unused function */
        function getVehicleStatusDescription(vehicle){
            if(!vehicle){
                console.warn("getVehicleStatusDescription: invalid input")
                return ''
            }
            var descr=''

            if(vehicle.status == VehicleStatus.UNAVAILABLE.value){
                descr = getVehicleUnavailableStatusDescription(vehicle)
            }else{
                descr = vehicle ? vehicle.status : ''
            }

            return descr
        }

        function hasVehicleACurrentBooking(vehicle){

            if(!vehicle){
                console.warn("hasVehicleACurrentBooking: invalid input",vehicle)
                return null
            }

            var hasACurrentBooking = false
            var lastBooking = getVehicleLastBooking(vehicle)
            if(lastBooking){
                hasACurrentBooking = (lastBooking.status != VehicleBookingStatus.FINISHED.value)
                                && (lastBooking.status != VehicleBookingStatus.DELETED.value)
            }
            return hasACurrentBooking
        }

        function getVehicleCurrentUser(vehicle){

            if(!vehicle){
                console.warn("getVehicleCurrentUser: invalid input",vehicle)
                return null
            }

            var currentUser = 'No user assigned'
            var lastBooking = getVehicleLastBooking(vehicle)

            if(lastBooking && (lastBooking.status != VehicleBookingStatus.FINISHED.value) && (lastBooking.status != VehicleBookingStatus.DELETED.value)){
                if(lastBooking.user){
                    UserUtility.generateUserFullName(lastBooking.user)
                    currentUser = lastBooking.user.fullName
                }else{
                    currentUser = ''
                }
            }
            return currentUser
        }

        function getVehicleLastUser(vehicle){
            var lastUser = 'No user'
            var lastBooking = getVehicleLastBooking(vehicle)
            if(lastBooking && lastBooking.user){
                UserUtility.generateUserFullName(lastBooking.user)
                lastUser = lastBooking.user.fullName
            }
            return lastUser
        }

        function getVehicleLastBooking(vehicle){
            if(!vehicle){
                console.warn("getVehicleLastBooking: invalid input",vehicle)
                return null
            }
            var lastBooking = null
            if(vehicle.bookings && vehicle.bookings.length>0){
                lastBooking = vehicle.bookings[0]
            }
            return lastBooking
        }

        function getVehicleLastMoved(vehicle){

            if(!vehicle){
                console.warn("getVehicleLastMoved: invalid input",vehicle)
                return null
            }
            var lastBooking = getVehicleLastBooking(vehicle)
            return lastBooking && toDateFilter(lastBooking.updated_at,"dateTime", vehicle.SiteId) || "Never moved"
        }
        
        function isVehicleInUse(vehicle){
            var inUse = false

            if(vehicle && vehicle.status != VehicleStatus.FREE.value && vehicle.status != VehicleStatus.UNAVAILABLE.value){
                inUse =  true
            }
            return inUse
        }

        function isVehicleInMaintenance(vehicle){
            var isInMaintenance = false

            if(vehicle && vehicle.inMaintenance){
                isInMaintenance = true
            }

            return isInMaintenance
        }

        function isVehicleActive(vehicle){
            var isActive = false

            if(vehicle && vehicle.online && vehicle.total_percentage > 25 && !vehicle.inMaintenance && vehicle.status != VehicleStatus.UNAVAILABLE.value){
                isActive = true
            }

            return isActive
        }

        var vehicleExtraInfoKeys = [
            'movoGroupTag',
            'movoUnavailableDescriptor'
        ]

        function parseVehicleExtraInfo(vehicle){
            if(!vehicle.extraInfo){
                console.warn("no vehicle extra info")
                return
            }
            var vehicleInfo = null

            for(var infoKey in vehicle.extraInfo){
                vehicleInfo = vehicle.extraInfo[infoKey]

                if(typeof vehicleInfo !== "undefined" && vehicleInfo !== null){
                    vehicle[infoKey] = vehicleInfo
                }          
            }

        }

        function generateVehicleExtraInfo(vehicle){

            if(vehicle.extraInfo === undefined || vehicle.extraInfo === null){
                vehicle.extraInfo = {}
            }

            vehicleExtraInfoKeys.forEach(function(infoKey){
                if((typeof vehicle[infoKey] !== "undefined") && vehicle[infoKey] !== null){
                    vehicle.extraInfo[infoKey] = vehicle[infoKey]
                }
            })
        }

        return{
            getIconUrl:getIconUrl,
            getVehicleShortAddress: getVehicleShortAddress,
            getVehicleExternalStatuses:getVehicleExternalStatuses,
            getVehicleStatusDescription:getVehicleStatusDescription,
            getVehicleLastBooking: getVehicleLastBooking,
            hasVehicleACurrentBooking:hasVehicleACurrentBooking,
            getVehicleCurrentUser:getVehicleCurrentUser,
            getVehicleLastUser:getVehicleLastUser,
            getVehicleLastMoved:getVehicleLastMoved,
            isVehicleInUse:isVehicleInUse,
            isVehicleInMaintenance:isVehicleInMaintenance,
            isVehicleActive: isVehicleActive,
            parseVehicleExtraInfo:parseVehicleExtraInfo,
            generateVehicleExtraInfo:generateVehicleExtraInfo,
            getAllIconUrls: getAllIconUrls,
        }
    }

    /** @ngInject */
    function MapUtilityFactory(
        VehicleUtility,
        $state,
        $interval,
        VehicleDetailsPage,
        UserDetailsPage,
        VehicleTypes,
        VehicleSharingAdapter,
        DeviceType,
        VehicleStatus,
        SweetAlert,
        toDateFilter,
        MapProvider
    ) {
        var infoWindow = null;
        var linkString = '';
        var clickFunction = null;
        var vehiclesNeverBeenOnline = 0;

        var fakePositions = [
            { lat: 41.900982, lng: 12.504613 },
            { lat: 41.900831, lng: 12.504851 },
            { lat: 41.900648, lng: 12.505131 },
            { lat: 41.900465, lng: 12.505454 },
            { lat: 41.900188, lng: 12.5059 },
            { lat: 41.899749, lng: 12.506479 },
            { lat: 41.899373, lng: 12.507155 },
        ];

        var watcherPositionStatusType = {
            STARTED: 'started',
            PAUSED: 'paused',
            STOPPED: 'stopped',
        };

        var currentClickedMarker;
        var activeVehiclesWatchers = {};
        var lastClickedVehicleWatcher = { watcher: null };
        var vehiclesWatcherIntervalId = -1;

        //var watcherPositionStatus = watcherPositionStatusType.STOPPED
        var linkString;
        var clickFunction;
        var mockupBehaviour = false; //!!!
        var watcherPositionInterval = mockupBehaviour ? 1000 : 5000;

        var lastVehiclePosition = null;

        function panTo(vehicleId, newPosition) {
            if (typeof newPosition === 'undefined') {
                newPosition = lastVehiclePosition;
            }

            if (!newPosition || (newPosition.lat === 0 && newPosition.lng === 0)) {
                return;
            }

            //DISABLED
            //var currentVehicleWatcher = activeVehiclesWatchers[vehicleId]

            /*if(currentVehicleWatcher && currentVehicleWatcher.marker && currentVehicleWatcher.marker.getMap())
                currentVehicleWatcher.marker.getMap().panTo(newPosition)*/
        }

        function updateVehicleMarker(vehicleId, newPosition) {
            var currentVehicleWatcher = activeVehiclesWatchers[vehicleId];
            if (currentVehicleWatcher) currentVehicleWatcher.marker.setPosition(newPosition);
        }

        function updateVehicleMarkerAndPath(vehicleId, newPosition) {
            var currentVehicleWatcher = activeVehiclesWatchers[vehicleId];
            if (currentVehicleWatcher) {
                currentVehicleWatcher.marker.setPosition(newPosition);
                currentVehicleWatcher.path.getPath().push(new google.maps.LatLng(newPosition.lat, newPosition.lng));
            }
        }

        function updateVehicleMarkerPositionAndPanTo(vehicle) {
            var newPosition = { lat: vehicle.latitude, lng: vehicle.longitude };
            updateVehicleMarker(vehicle.id, newPosition);

            /*if(lastClickedVehicleWatcher.watcher.vehicleId === vehicle.id)
                panTo(vehicle.id,newPosition)*/
        }

        function getVehiclesMapInfo(vehiclesIdToUpdate, callback) {
            if (!vehiclesIdToUpdate || vehiclesIdToUpdate.length == 0) {
                console.warn('getVehiclesMapInfo: invalid input', vehiclesIdToUpdate);
                return;
            }

            VehicleSharingAdapter.getVehiclesMapInfo(
                { vehicles: vehiclesIdToUpdate },
                function (vehiclesUpdated, error) {
                    if (error) {
                    } else {
                        if (typeof callback !== 'undefined') {
                            // console.log("vehiclesUpdated",vehiclesUpdated)

                            var currentVehicleWatcher = null;
                            var currentVehicle = null;

                            vehiclesUpdated.forEach(function (newVehicleInfo) {
                                currentVehicleWatcher = activeVehiclesWatchers[newVehicleInfo.id];

                                if (currentVehicleWatcher) {
                                    //update vehicle info
                                    currentVehicle = currentVehicleWatcher.marker.vehicle;
                                    currentVehicle.latitude = newVehicleInfo.latitude;
                                    currentVehicle.longitude = newVehicleInfo.longitude;
                                    currentVehicle.total_percentage = newVehicleInfo.total_percentage;
                                    currentVehicle.status = newVehicleInfo.status;

                                    callback(currentVehicle);

                                    if (currentVehicle.status == VehicleStatus.FREE.value) {
                                        // console.log("the vehicle wacthed now is in free status, stop")
                                        stopWatchingPosition(currentVehicle);

                                        currentVehicleWatcher.marker.setOptions({
                                            icon: generateMarkerIconObj(
                                                VehicleUtility.getIconUrl(
                                                    currentVehicle.type,
                                                    currentVehicle.status,
                                                    currentVehicle.inMaintenance,
                                                    { referenceCode: vehicle.reference_code }
                                                )
                                            ),
                                        });
                                    }

                                    //update only currentClickedMarker not lastClickedWatcher
                                    if (currentClickedMarker.vehicle.id == currentVehicle.id) {
                                        generateInfoWindowContent(currentVehicle, currentClickedMarker);
                                    }
                                }
                            });
                        }
                    }
                }
            );
        }

        function getVehicleUpdatedInfo(vehicleId, callback) {
            if (vehicleId == -1) {
                return;
            }

            getVehiclesMapInfo([vehicleId], callback);
        }

        function refreshMapAfterStopWatchingPosition(vehicleId) {
            getVehicleUpdatedInfo(vehicleId, updateVehicleMarkerPositionAndPanTo);
        }

        function addNewPositionInPathAndUpdateMarker(vehicleId, newPosition) {
            var currentVehicleWatcher = activeVehiclesWatchers[vehicleId];

            if (currentVehicleWatcher) {
                updateVehicleMarkerAndPath(vehicleId, newPosition);

                /*if(lastClickedVehicleWatcher.watcher.vehicleId === vehicleId)
                    panTo(vehicleId,newPosition)*/
            }
        }

        function refreshVehiclesMapInfo(vehiclesIdToUpdate) {
            if (mockupBehaviour) {
                if (i < fakePositions.length) {
                    lastVehiclePosition = fakePositions[i];

                    addNewPositionInPathAndUpdateMarker(vehiclesIdToUpdate[0], lastVehiclePosition);

                    i++;
                } else {
                    i = 0;
                }
            } else {
                getVehiclesMapInfo(vehiclesIdToUpdate, function (vehicle) {
                    lastVehiclePosition = { lat: vehicle.latitude, lng: vehicle.longitude };

                    addNewPositionInPathAndUpdateMarker(vehicle.id, lastVehiclePosition);
                });
            }
        }

        function getCurrentVehicleWatcher() {
            return lastClickedVehicleWatcher;
        }

        function startWatchingPosition(vehicle) {
            var vehicleId = vehicle.id;

            if (vehicle.status == VehicleStatus.FREE.value) {
                console.warn('Not started watching position, vehicle is in free state');
                SweetAlert.swal('Start watching position', 'The vehicle is in free status', 'error');
                return;
            }
            // console.log("Start watching position,","vehicleId",vehicleId)

            var position = currentClickedMarker.getPosition();
            var currentVehicleWatcher = currentClickedMarker.vehicleWatcher;
            lastClickedVehicleWatcher.watcher = currentVehicleWatcher;

            if (currentVehicleWatcher && currentVehicleWatcher.path.getMap() == null) {
                currentVehicleWatcher.path.setMap(currentVehicleWatcher.marker.getMap());
            }

            activeVehiclesWatchers[vehicleId] = currentVehicleWatcher;

            if (position) {
                if (mockupBehaviour) {
                    console.log('mockupBehaviour', mockupBehaviour);
                    position = fakePositions[0];
                    updateVehicleMarkerAndPath(vehicleId, position);
                }
            }
            watchVehiclePosition(vehicle);
        }

        function startWatchVehiclesPositions() {
            // console.warn("watchVehiclePosition: start vehicles watcher")

            vehiclesWatcherIntervalId = $interval(function () {
                var vehiclesIdToUpdate = [];
                var vehicleWatcher = null;

                for (var vehicleId in activeVehiclesWatchers) {
                    vehicleWatcher = activeVehiclesWatchers[vehicleId];

                    if (vehicleWatcher.status == watcherPositionStatusType.STARTED) {
                        vehiclesIdToUpdate.push(vehicleId);
                    }
                }

                // console.warn("startWatchVehiclesPositions: ",vehiclesIdToUpdate.length,vehiclesIdToUpdate)

                if (vehiclesIdToUpdate && vehiclesIdToUpdate.length > 0) {
                    refreshVehiclesMapInfo(vehiclesIdToUpdate);
                } else {
                    stopWatchVehiclesPositions();
                }
            }, watcherPositionInterval);
        }

        function stopWatchVehiclesPositions() {
            if (vehiclesWatcherIntervalId == -1) {
                console.warn('stopWatchVehiclesPositions: watcher already stopped');
                return;
            }
            // console.log("stopped all vehicles watcher")
            $interval.cancel(vehiclesWatcherIntervalId);
            vehiclesWatcherIntervalId = -1;
        }

        function watchVehiclePosition(vehicle) {
            var vehicleId = vehicle.id;

            //init first position and set watcher
            getVehicleUpdatedInfo(vehicleId);

            var currentVehicleWatcher = activeVehiclesWatchers[vehicleId];

            if (currentVehicleWatcher) {
                currentVehicleWatcher.status = watcherPositionStatusType.STARTED;
            }

            if (vehiclesWatcherIntervalId == -1) {
                startWatchVehiclesPositions();
            }
        }

        function pauseWatchingPosition(vehicle) {
            var vehicleId = vehicle.id;

            // console.log("pause watching position")
            var currentVehicleWatcher = activeVehiclesWatchers[vehicleId];

            // if(currentVehicleWatcher && currentVehicleWatcher.intervalId != -1){
            if (currentVehicleWatcher) {
                if (infoWindow) {
                    infoWindow.close();
                }

                // $interval.cancel(currentVehicleWatcher.intervalId)

                currentVehicleWatcher.status = watcherPositionStatusType.PAUSED;
            }
        }

        function resetVehicleWatcher(currentVehicleWatcher) {
            currentVehicleWatcher.status = watcherPositionStatusType.STOPPED;
            currentVehicleWatcher.intervalId = -1;

            currentVehicleWatcher.path.setPath([]);
            currentVehicleWatcher.path.setMap(null);

            delete activeVehiclesWatchers[currentVehicleWatcher.vehicleId];
            currentVehicleWatcher.vehicleId = -1;
        }

        function stopWatchingPosition(vehicle, doRefresh) {
            var vehicleId = vehicle.id ? vehicle.id : vehicle;

            if (typeof doRefresh == 'undefined') doRefresh = true;

            //mockup behaviour
            if (mockupBehaviour) {
                i = 0;
            }
            var currentVehicleWatcher = activeVehiclesWatchers[vehicleId];

            // if(currentVehicleWatcher && currentVehicleWatcher.intervalId != -1){
            if (currentVehicleWatcher) {
                // console.log("stop watching position")

                // $interval.cancel(currentVehicleWatcher.intervalId)

                if (doRefresh) {
                    refreshMapAfterStopWatchingPosition(currentVehicleWatcher.vehicleId);
                }

                resetVehicleWatcher(currentVehicleWatcher);
            }
        }

        function stopVehiclesWatchers(doRefresh) {
            if (typeof doRefresh == 'undefined') doRefresh = true;

            lastClickedVehicleWatcher.watcher = null;

            for (var vehicleId in activeVehiclesWatchers) {
                stopWatchingPosition(activeVehiclesWatchers[vehicleId].marker.vehicle, doRefresh);
            }
        }

        function updateInfoWindowContent(marker) {
            var watcherPositionStatus = marker.vehicleWatcher.status;

            switch (watcherPositionStatus) {
                case watcherPositionStatusType.STOPPED:
                    linkString = 'Start watching position';
                    clickFunction = startWatchingPosition;
                    break;

                case watcherPositionStatusType.STARTED:
                    linkString = 'Pause watching position';
                    clickFunction = pauseWatchingPosition;
                    break;

                case watcherPositionStatusType.PAUSED:
                    linkString = 'Restart watching position';
                    clickFunction = watchVehiclePosition;
                    break;
            }
        }

        function generateTemplate(vehicle) {
            return (
                "<div style='display:flex'>" +
                "<h3>Ref. Code: <a class='userLink' href='" +
                generateVehicleDetailsLink(vehicle) +
                "'>" +
                vehicle.reference_code +
                '</a></h3>' +
                "<md-icon style='width: 15px;min-width: 15px;height: 15px;min-height: 15px;font-size: 15px;margin-left:18px;margin-top:17px;" +
                (vehicle.online ? 'color: #4BB543;' : 'color:red') +
                "' class=" +
                (vehicle.online ? 'icon-check-circle' : 'icon-close-circle-outline') +
                '></md-icon>' +
                '</div>' +
                "<div style='display:flex'>" +
                "<p style='margin:0px'><label style='font-weight: normal;'>ID: </label>" +
                vehicle.id +
                '</p>' +
                "<p style='margin:0px'>, <label style='font-weight: normal;'>Device: </label>" +
                (vehicle.deviceType == DeviceType.PERSONAL.value
                    ? vehicle.core_board
                        ? vehicle.core_board.id
                        : 'No device'
                    : vehicle.deviceTypeHuman) +
                '</p>' +
                '</div>' +
                "<p><label style='font-weight: normal;'>Plate: </label>" +
                vehicle.license_plate +
                '</p>' +
                (vehicle.type == VehicleTypes.CAR.value
                    ? "<p style='margin-top:0px'><label style='font-weight: normal;'>Manufacturer: </label>" +
                      vehicle.brand +
                      '</p>' +
                      "<p><label style='font-weight: normal;'>Model: </label>" +
                      vehicle.model_name +
                      '</p>'
                    : '') +
                "<div style='display:flex'>" +
                "<p style='margin:0px'><label style='font-weight: normal;'>Status: </label>" +
                vehicle.externalStatusHuman +
                '</p>' +
                "<p style='margin:0px'>, <label style='font-weight: normal;'>State: </label>" +
                vehicle.status +
                '</p>' +
                '</div>' +
                "<p><label style='font-weight: normal;'>" +
                (vehicle.type == VehicleTypes.CAR.value ? 'Fuel' : 'Battery') +
                ' level: </label>' +
                vehicle.total_percentage +
                '%</p>' +
                "<p><label style='font-weight: normal;'>Rider: </label>" +
                (VehicleUtility.hasVehicleACurrentBooking(vehicle)
                    ? "<a class='userLink' href='" +
                      generateUserDetailsLink(vehicle.bookings[0].user) +
                      "'>" +
                      vehicle.currentUser +
                      '</a>'
                    : vehicle.currentUser) +
                '</p>' +
                "<p><label style='font-weight: normal;'>Last GPS Update: </label>" +
                toDateFilter(vehicle.fixtaken, 'dateTime', vehicle.SiteId) +
                '</p>' +
                "<p><label style='font-weight: normal'>Last moved: </label>" +
                vehicle.lastMoved +
                '</p>'
            );
        }

        function getPopupContent(vehicle) {
            // This is missing the vehicle watch functionality
            return generateTemplate(vehicle);
        }

        function generateInfoWindowContent(vehicle, marker) {
            /*var template = "<div layout='column'>"
                + "<p><b>"+$scope.vehicle.license_plate+ "</b></p>"
                + "<a ng-click=' "+ clickFunction +" '>" + linkString + "</a>"+
                "</div>"

            var compiledContent = $compile(template)($scope)
            infoWindow.setContent(compiledContent[0])
            infoWindow.open(map,vehicleMarker)*/

            updateInfoWindowContent(marker);

            var template = generateTemplate(vehicle);

            var container = document.createElement('div');
            container.innerHTML = template;
            container.style.marginBottom = '4px';
            var div = document.createElement('a');
            div.innerText = linkString;
            div.onclick = function () {
                clickFunction(vehicle);
                updateInfoWindowContent(marker);
                this.innerText = linkString;
            };
            container.appendChild(div);

            infoWindow.setContent(container);
        }

        function generateVehicleDetailsLink(vehicle) {
            if (!vehicle) {
                return '';
            }
            return $state.href(VehicleDetailsPage, { vehicleId: vehicle.id });
        }

        function generateUserDetailsLink(user) {
            if (!user) {
                return '';
            }
            return $state.href(UserDetailsPage, { userId: user.id });
        }

        function generateMarkerIconObj(iconUrl) {
            return {
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(30, 74), //increase x right dir,y down direction
                url: iconUrl,
            };
        }

        function generateMarker(vehicle, mapProvider) {
            switch (mapProvider) {
                case MapProvider.GOOGLE_MAPS:
                    return new google.maps.Marker({
                        position: { lat: vehicle.latitude, lng: vehicle.longitude },
                        options: {
                            icon: generateMarkerIconObj(
                                VehicleUtility.getIconUrl(vehicle.type, vehicle.status, vehicle.inMaintenance, {
                                    referenceCode: vehicle.reference_code,
                                })
                            ),
                        },
                        vehicle: vehicle,
                        vehicleWatcher: {
                            status: watcherPositionStatusType.STOPPED,
                            path: new google.maps.Polyline({
                                strokeColor: '#284678',
                                strokeOpacity: 0.7,
                                strokeWeight: 8,
                            }),
                            marker: null,
                            vehicleId: vehicle.id,
                            intervalId: -1,
                        },
                    });
                case MapProvider.MAPBOX:
                    const imageString = VehicleUtility.getIconUrl(vehicle.type, vehicle.status, vehicle.inMaintenance, {
                        referenceCode: vehicle.reference_code,
                    });
                    const image = document.createElement('img');
                    image.src = imageString;
                    // TODO handle vehicle and vehicleWatcher
                    return new mapboxgl.Marker({
                        anchor: 'bottom',
                        element: image,
                    }).setLngLat([vehicle.longitude, vehicle.latitude]);

                default:
                    console.error('unknown mapprovider', mapProvider);
                    break;
            }
        }

        function generateVehicleMarker(vehicle, mapBounds, mapProvider) {
            var vehicleMarker = null;

            if (infoWindow == null && mapProvider === MapProvider.GOOGLE_MAPS) {
                infoWindow = new google.maps.InfoWindow();
            }
            var position = { latitude: vehicle.latitude, longitude: vehicle.longitude };

            //check if scooter never been online
            if (position.latitude == 0 && position.longitude == 0) {
                vehiclesNeverBeenOnline += 1;
            } else {
                // extend map bounds with vehicle position
                if (mapBounds) {
                    switch (mapProvider) {
                        case MapProvider.GOOGLE_MAPS:
                            mapBounds.extend({ lat: position.latitude, lng: position.longitude });
                            break;
                        case MapProvider.MAPBOX:
                            mapBounds.extend([position.longitude, position.latitude]);
                            break;
                        default:
                            console.error('unknown mapprovider', mapProvider);
                            break;
                    }
                }
            }

            vehicleMarker = generateMarker(vehicle, mapProvider);
            if (vehicleMarker.vehicleWatcher) {
                vehicleMarker.vehicleWatcher.marker = vehicleMarker;
            }

            //update current active vehicleWatcher
            var activeVehicleWatcher = activeVehiclesWatchers[vehicle.id];
            if (activeVehicleWatcher) {
                vehicleMarker.vehicleWatcher.status = activeVehicleWatcher.status;
                vehicleMarker.vehicleWatcher.path = activeVehicleWatcher.path;
                vehicleMarker.vehicleWatcher.intervalId = activeVehicleWatcher.intervalId;
                activeVehiclesWatchers[vehicle.id] = vehicleMarker.vehicleWatcher;
            }

            switch (mapProvider) {
                case MapProvider.GOOGLE_MAPS:
                    vehicleMarker.addListener('click', function () {
                        currentClickedMarker = vehicleMarker;

                        //update lastClickedVehicleWatcher only when vehicleWatcher is active
                        if (vehicleMarker.vehicleWatcher.intervalId != -1) {
                            lastClickedVehicleWatcher.watcher = vehicleMarker.vehicleWatcher;
                        }

                        if (infoWindow) {
                            infoWindow.close();
                        }

                        generateInfoWindowContent(vehicle, vehicleMarker);
                        infoWindow.open(vehicleMarker.getMap(), vehicleMarker);
                    });
                    break;
                case MapProvider.MAPBOX:
                    vehicleMarker.setPopup(new mapboxgl.Popup().setHTML(getPopupContent(vehicle)));
                    break;
                default:
                    console.error('unknown mapprovider', mapProvider);
                    break;
            }

            return vehicleMarker;
        }

        function generateVehicleMarkers(vehicles, mapBounds, mapProvider) {
            var vehicleMarkers = {};

            vehicles.forEach(function (vehicle) {
                vehicleMarkers[vehicle.id] = generateVehicleMarker(vehicle, mapBounds, mapProvider);
            });

            console.warn('vehiclesNeverBeenOnline', vehiclesNeverBeenOnline);
            vehiclesNeverBeenOnline = 0;

            return vehicleMarkers;
        }

        function generateTripMarker(trip, map, type) {
            if (infoWindow == null) {
                infoWindow = new google.maps.InfoWindow();
            }
            var latLng = {};
            var iconObj = null;

            if (type == 'start') {
                latLng = { lat: trip.StartPosition.latitude, lng: trip.StartPosition.longitude };
                iconObj = generateMarkerIconObj(
                    VehicleUtility.getIconUrl(trip.Vehicle.type, 'tripStart', false, {
                        referenceCode: trip.Vehicle.reference_code,
                    })
                );
            }
            if (type == 'parked') {
                var vehicle = trip;
                latLng = { lat: vehicle.latitude, lng: vehicle.longitude };
                iconObj = generateMarkerIconObj(
                    VehicleUtility.getIconUrl(vehicle.type, 'tripPause', false, {
                        referenceCode: vehicle.reference_code,
                    })
                );
            }
            if (type == 'end') {
                latLng = { lat: trip.FinishPosition.latitude, lng: trip.FinishPosition.longitude };
                iconObj = generateMarkerIconObj(
                    VehicleUtility.getIconUrl(trip.Vehicle.type, 'tripEnd', false, {
                        referenceCode: trip.Vehicle.reference_code,
                    })
                );
            }

            var startMarker = new google.maps.Marker({
                position: latLng,
                options: {
                    icon: iconObj,
                },
                map: map,
                trip: trip,
            });

            startMarker.addListener('click', function () {
                if (infoWindow) {
                    infoWindow.close();
                }
                if (type == 'start') {
                    infoWindow.setContent(
                        '<h3>Start point</h3>' +
                            '<p>Address: ' +
                            VehicleUtility.getVehicleShortAddress(this.trip.StartPosition) +
                            '</p>' +
                            '<p>Km: ' +
                            (this.trip.StartPosition ? this.trip.StartPosition.km : '') +
                            (this.trip.Vehicle.type == VehicleTypes.CAR.value ? ', Fuel' : ', Battery') +
                            ' level: ' +
                            this.trip.StartPosition.total_percentage +
                            '%</p>' +
                            '<p>' +
                            '</p>' +
                            '<p>Started at: ' +
                            toDateFilter(this.trip.start, 'dateTime', this.trip.SiteId) +
                            '</p>' +
                            (trip.User ? '<p>Rider: ' + trip.User.fullName + '</p>' : '')
                    );
                }

                if (type == 'parked') {
                    var vehicle = trip;
                    infoWindow.setContent(
                        '<h3>Parked point</h3>' +
                            '<p>Address: ' +
                            VehicleUtility.getVehicleShortAddress(vehicle) +
                            '</p>' +
                            '<p>Km: ' +
                            (vehicle.km !== null ? vehicle.km : 'No km') +
                            (vehicle.type == VehicleTypes.CAR.value ? ', Fuel' : ', Battery') +
                            ' level: ' +
                            vehicle.total_percentage +
                            '%</p>' +
                            '<p>' +
                            '</p>' +
                            '<p>Parked at: ' +
                            toDateFilter(vehicle.updated_at, 'dateTime', vehicle.SiteId) +
                            '</p>'
                    );
                }

                if (type == 'end') {
                    infoWindow.setContent(
                        '<h3>End point</h3>' +
                            '<p>Address: ' +
                            VehicleUtility.getVehicleShortAddress(this.trip.FinishPosition) +
                            '</p>' +
                            '<p>Km: ' +
                            (this.trip.FinishPosition ? this.trip.FinishPosition.km : 'No km') +
                            (this.trip.Vehicle.type == VehicleTypes.CAR.value ? ', Fuel' : ', Battery') +
                            ' level: ' +
                            (this.trip.FinishPosition ? this.trip.FinishPosition.total_percentage + '%' : 'No data') +
                            '</p>' +
                            '<p>' +
                            '</p>' +
                            '<p>Ended at: ' +
                            toDateFilter(this.trip.end, 'dateTime', this.trip.SiteId) +
                            '</p>' +
                            (trip.User ? '<p>Rider: ' + trip.User.fullName + '</p>' : '')
                    );
                }

                infoWindow.open(startMarker.getMap(), startMarker);
            });
            return startMarker;
        }

        function generateTripStartMarker(trip, map) {
            return generateTripMarker(trip, map, 'start');
        }

        function generateTripEndMarker(trip, map) {
            return generateTripMarker(trip, map, 'end');
        }

        function generateTripParkedMarker(vehicle, map) {
            return generateTripMarker(vehicle, map, 'parked');
        }

        function fitMapToPoints(map, points) {
            if (
                typeof map === 'undefined' ||
                map === null ||
                typeof points === 'undefined' ||
                points === null ||
                !Array.isArray(points)
            ) {
                console.log('MapUtility.fitMapToBounds: invalid input', map, points);
                return;
            }

            var bounds = new google.maps.LatLngBounds();

            points.forEach(function (point) {
                if (point.lat != 0 && point.lng != 0) {
                    bounds.extend(point);
                }
            });
            map.fitBounds(bounds);
        }

        return {
            generateMarkerIconObj: generateMarkerIconObj,
            generateVehicleMarker: generateVehicleMarker,
            generateVehicleMarkers: generateVehicleMarkers,
            getCurrentVehicleWatcher: getCurrentVehicleWatcher,
            stopVehiclesWatchers: stopVehiclesWatchers,
            generateTripStartMarker: generateTripStartMarker,
            generateTripEndMarker: generateTripEndMarker,
            generateTripParkedMarker: generateTripParkedMarker,
            fitMapToPoints: fitMapToPoints,
            getPopupContent: getPopupContent,
        };
    }

    /** @ngInject */
    function OrderRequestParamFactory(){

        function orderById(order){
            if(typeof order != "string")
                return {}

            return ['id',order]
        }

        function orderByDataId(order){
            return orderById(order)
        }

        function orderByCouponCode(order){
            if(typeof order != "string")
                return {}

            return ['code',order]
        }

        function orderByCouponStartDate(order){
            if(typeof order != "string")
                return {}

            return ['start',order]
        }

        function orderByCouponFinishDate(order){
            if(typeof order != "string")
                return {}

            return ['finish',order]
        }

        function orderByCouponCreationgDate(order){
            if(typeof order != "string")
                return {}

            return ['created_at',order]
        }

        function orderByVehicleReferenceCode(order){
            if(typeof order != "string")
                return {}

            return ['reference_code',order]
        }

        function orderByVehicleLicensePlate(order){
            if(typeof order != "string")
                return {}

            return ['license_plate',order]
        }

        function orderByVehicleOnlineStatus(order){
            if(typeof order != "string")
                return {}

            return ['online',order]
        }

        function orderByVehicleFuelLevel(order){
            if(typeof order != "string")
                return {}

            return ['total_percentage',order]
        }

        function orderByVehicleTotalKm(order){
            if(typeof order != "string")
                return {}

            return ['km',order]
        }

        function orderByVehicleLastMoved(order){
            if(typeof order != "string")
                return {}

            return ['Bookings.updated_at',order]
        }

        function orderByVehicleLastGPSUpdate(order){
            if(typeof order != "string")
                return {}

            return ['fixtaken',order]
        }

        function orderByUserSurname(order){
            if(typeof order != "string")
                return {}

            return ['surname',order]
        }

        function orderByUserEmail(order){
            if(typeof order != "string")
                return {}

            return ['email',order]
        }

        function orderByUserLastPaymentStatus(order){
            if(typeof order != "string")
                return {}

            return ['lastPaymentStatus',order]
        }

        function orderByUserRegistrationDate(order){
            if(typeof order != "string")
                return {}

            return ['created_at',order]
        }

        function orderByTripVehicleLicensePlate(order){
            if(typeof order != "string")
                return {}

            return ['Vehicle.license_plate',order]
        }

        function orderByTripVehicleReferenceCode(order){
            if(typeof order != "string")
                return {}

            return ['Vehicle.reference_code',order]
        }

        function orderByTripUserId(order){
            if(typeof order != "string")
                return {}

            return ['User.id',order]
        }

        function orderByTripStart(order){
            if(typeof order != "string")
                return {}

            return ['created_at',order]
        }

        function orderByInvoiceCode(order){
            if(typeof order != "string")
                return {}

            return ['code',order]
        }

        function orderByInvoiceUserId(order){
            if(typeof order != "string")
                return {}

            return ['User.id',order]
        }

        function orderByInvoiceType(order){
            if(typeof order != "string")
                return {}

            return ['type',order]
        }

        function orderByInvoiceCreationDate(order){
            if(typeof order != "string")
                return {}

            return ['created_at',order]
        }

        function orderByDeviceCode(order){
            if(typeof order != "string")
                return {}

            return ['code',order]
        }

        function orderByDeviceVersion(order){
            if(typeof order != "string")
                return {}

            return ['version',order]
        }

        function orderByDeviceOnline(order){
            if(typeof order != "string")
                return {}

            return ['Vehicle.online',order]
        }

        function orderByDeviceVehicleReferenceCode(order){
            if(typeof order != "string")
                return {}

            return ['Vehicle.reference_code',order]
        }

        function orderByDamageReportCreationDate(order){
            if(typeof order != "string")
                return {}

            return ['created_at',order]
        }

        function orderByDamageReportVehicleReferenceCode(order){
            if(typeof order != "string")
                return {}

            return ['Vehicle.reference_code',order]
        }
        function orderByDamageReportUserId(order){
            if(typeof order != "string")
                return {}

            return ['User.id',order]
        }

        function orderByLastUpdate(order){
            if(typeof order != "string")
                return {}

            return ['updated_at',order]
        }

        function createAOrderRequestParam(orderParams){

            if(typeof orderParams == "undefined" || orderParams == null)
                return {}
            
            var orderRequestParam = {order:[[]]}
            orderParams.forEach(function(orderParam){
                orderRequestParam['order'][0].push(orderParam)
            })
            return orderRequestParam
        }

        function orderByVehicleId(order){
            return typeof order === "string" ? ['Vehicle.id', order] : {};
        }
        return {
            orderById:orderById,
            orderByDataId:orderByDataId,
            orderByCouponId:orderById,
            orderByCouponCode:orderByCouponCode,
            orderByCouponStartDate:orderByCouponStartDate,
            orderByCouponFinishDate:orderByCouponFinishDate,
            orderByCouponCreationgDate:orderByCouponCreationgDate,
            orderByVehicleId:orderByVehicleId,
            orderByVehicleReferenceCode:orderByVehicleReferenceCode,
            orderByVehicleLicensePlate:orderByVehicleLicensePlate,
            orderByVehicleOnlineStatus:orderByVehicleOnlineStatus,
            orderByVehicleFuelLevel:orderByVehicleFuelLevel,
            orderByVehicleTotalKm:orderByVehicleTotalKm,
            orderByVehicleLastMoved:orderByVehicleLastMoved,
            orderByVehicleLastGPSUpdate:orderByVehicleLastGPSUpdate,
            orderByUserId:orderById,
            orderByUserSurname:orderByUserSurname,
            orderByUserEmail:orderByUserEmail,
            orderByUserLastPaymentStatus:orderByUserLastPaymentStatus,
            orderByUserRegistrationDate:orderByUserRegistrationDate,
            orderByTripId:orderById,
            orderByTripVehicleId:orderByVehicleId,
            orderByTripVehicleLicensePlate:orderByTripVehicleLicensePlate,
            orderByTripVehicleReferenceCode:orderByTripVehicleReferenceCode,
            orderByTripUserId:orderByTripUserId,
            orderByTripStart:orderByTripStart,
            orderByInvoiceCode:orderByInvoiceCode,
            orderByInvoiceUserId:orderByInvoiceUserId,
            orderByInvoiceType:orderByInvoiceType,
            orderByInvoiceId:orderById,
            orderByInvoiceCreationDate:orderByInvoiceCreationDate,
            orderByDeviceId:orderById,
            orderByDeviceCode:orderByDeviceCode,
            orderByDeviceVersion:orderByDeviceVersion,
            orderByDeviceOnline:orderByDeviceOnline,
            orderByDeviceVehicleId:orderByVehicleId,
            orderByDeviceVehicleReferenceCode:orderByDeviceVehicleReferenceCode,
            createAOrderRequestParam:createAOrderRequestParam,
            orderByDamageReportId:orderById,
            orderByDamageReportCreationDate:orderByDamageReportCreationDate,
            orderByDamageReportVehicleId:orderByVehicleId,
            orderByDamageReportVehicleReferenceCode:orderByDamageReportVehicleReferenceCode,
            orderByDamageReportUserId: orderByDamageReportUserId,
            orderByLastUpdate:orderByLastUpdate,
        }
    }

    /** @ngInject */
    function FiltersRequestParamFactory(VehicleStatus,VehicleBookingStatus,VehicleTripStatus,UserStatus,UserDocumentStatus,UserLicenseStatus,MiscUtility) {

        // TODO use this filter param for all id ones
        function createIdFilter(id){
            if (typeof id !== "number") {
                return {}
            }
 
            return {
                _self: {
                    id: id
                }
            }
        }
        
        function createSelfDateRangeFilter(range){
            if(typeof range[0] !== "number" || typeof range[1] !== "number"){
                return {}
            }

            const start = range[0];
            const end = range[1];
 
            return{
                _self:{
                    created_at: [start, end],
                }
            }
        }

        function createVehicleStatusFilter(statuses){
            
            if(statuses.length==0){
                return {}
            }

            return {
                _self:{
                    status: statuses
                }
            }
        }

        function createVehicleExternalStatusFilter(statuses){
            
            if(statuses.length==0){
                return {}
            }

            return {
                _virtual:{
                    external_status: statuses
                }
            }
        }

        function createVehicleBatteryLevelFilter(batteryLevelRanges){
            
            return createVehicleFuelLevelFilter(batteryLevelRanges)
        }

        function createVehicleFuelLevelFilter(fuelLevelRanges){
            if(fuelLevelRanges.length==0){
                return {}
            }

            if(!(typeof fuelLevelRanges[0] == "object" && fuelLevelRanges[0].length>0)){
                fuelLevelRanges = [fuelLevelRanges]
            }
            
            return {
                _self: {
                    total_percentage: fuelLevelRanges
                }
            }
        }

        function createVehicleInOnlineStatusFilter(online){

            if(typeof online === "undefined"){
                online = true
            }else{
                if(typeof online === "string"){
                    online = (online == 'true')
                }
            }
            
            return {
                _self: {
                    online: online
                }
            }
        }

        function createVehicleActiveStatusFilter(){

            //online,total_percentage>25,status!=unavailable,!inMaintenace
            var possibleVehicleStatuses = []
            for(var key in VehicleStatus){
                var status = VehicleStatus[key].value
                if(status != VehicleStatus.UNAVAILABLE.value)
                    possibleVehicleStatuses.push(status)
            }

            return createAnAndFilter(
                [
                    createVehicleInOnlineStatusFilter(),
                    createVehicleStatusFilter(possibleVehicleStatuses),
                    createVehicleBatteryLevelFilter([25,100]),
                    createVehicleInMaintenanceStatusFilter(false)
                ]
            )
        }

        function createVehicleHasACurrentBookingFilter(){

            return {
                        bookings:{
                           _self:{
                               status: [
                                   VehicleBookingStatus.CREATED.value,
                                   VehicleBookingStatus.STARTED.value
                                ]
                           }
                        }
                    }
        }

        function createVehicleInUseStatusFilter(){

            //status!=free,status!=unavailable
            var possibleVehicleStatuses = []
            for(var key in VehicleStatus){
                var status = VehicleStatus[key].value
                if(status != VehicleStatus.FREE.value && status != VehicleStatus.UNAVAILABLE.value)
                    possibleVehicleStatuses.push(status)
            }
            // console.log("createVehicleActiveStatusFilter",possibleVehicleStatuses)

            return createVehicleStatusFilter(possibleVehicleStatuses)
        }

        function createVehicleInMaintenanceStatusFilter(inMaintenance){

            if(typeof inMaintenance === "undefined"){
                inMaintenance = true
            }

            return {
                        _self:{
                            inMaintenance: inMaintenance
                        }
                    }
        }

        function createVehicleWithReferenceCodeFilter(refCode){
            if(typeof refCode !== "string"){
                return {}
            }

            return {
                _self: {
                    reference_code : refCode
                }
            }
        }

        function createVehicleWithBrandFilter(brand){
            if(typeof brand !== "string"){
                return {}
            }

            return {
                _self: {
                    brand : brand
                }
            }
        }

        function createVehicleWithModelNameFilter(modelName){
            if(typeof modelName !== "string"){
                return {}
            }

            return {
                _self: {
                    model_name : modelName
                }
            }
        }

        function createVehicleWithTypeFilter(vehicleTypes){
            if(!vehicleTypes || vehicleTypes.length == 0){
                return {}
            }

            return {
                _self: {
                    type : vehicleTypes
                }
            }
        }

        function createInnerVehicleWithTypesFilter(vehicleTypes){
            if(!vehicleTypes || vehicleTypes.length == 0){
                return {}
            }

            return {
                Vehicle: createVehicleWithTypeFilter(vehicleTypes)
            }
        }

        function createVehicleWithDeviceTypeFilter(deviceTypes){

            if(!deviceTypes || deviceTypes.length == 0){
                return {}
            }

            return {
                _self: {
                    deviceType : deviceTypes
                }
            }
        }

        function createVehicleWithinBoundingBoxFilter(boundingBox){
            if(!boundingBox || !boundingBox.latitudeRange || !boundingBox.longitudeRange){
                return {}
            }
            return {
                _self: {
                    latitude : boundingBox.latitudeRange,
                    longitude : boundingBox.longitudeRange
                }
            }
        }

        function createInnerVehicleWithDeviceTypesFilter(deviceTypes){

            if(!deviceTypes || deviceTypes.length == 0){
                return {}
            }

            return {
                Vehicle: createVehicleWithDeviceTypeFilter(deviceTypes)
            }
        }

        function createVehicleWithIdFilter(vehicleId){
            if(typeof vehicleId !== "number"){
                return {}
            }

            return {
                _self: {
                    id : vehicleId
                }
            }
        }

        function createVehicleWithLicensePlateFilter(vehicleLicensePlate){
            if(typeof vehicleLicensePlate !== "string"){
                return {}
            }

            return {
                _self: {
                    license_plate : vehicleLicensePlate
                }
            }
        }

        function createVehicleWithCurrentUserFilter(userFullName){
            if(typeof userFullName !== "string"){
                return {}
            }
            return createAnAndFilter(
                [
                    createVehicleHasACurrentBookingFilter(),
                    {
                        bookings:{
                            user: {
                                _virtual:{
                                    fullName: userFullName
                                }
                            }
                        }
                    }
                ]
            )
        }

        function createVehicleWithLastMovedDateFilter(dateTime){
            if(typeof dateTime !== "number"){
                return {}
            }
 
            return{
                bookings:{
                    _self:{
                        updated_at: [dateTime,dateTime]
                    }
                }
            }
        }

        function createVehicleWithHiddenFilter(hidden){
            if(typeof hidden !== "boolean"){
                return {}
            }
 
            return {
                _virtual: {
                    hidden: hidden
                }
            }
        }

        function createTripWithIdFilter(tripId){
            if(typeof tripId !== "number"){
                return {}
            }
 
            return{
                _self:{
                    id: tripId
                }
            }
        }

        function createTripWithStatusFilter(status){
            if(typeof status !== "number"){
                return {}
            }
            var bookingParamRequest = {
                Booking:{
                    _self:{
                        status: []
                    }
                }
            }
            var vehicleAndBookingParamRequest = {
                Booking:{
                    _self:{
                        status: []
                    }
                },
                Vehicle:{
                    _self:{
                        status:[]
                    }
                }
            }
            
            switch(status){
                case VehicleTripStatus.BOOKED.value:
                    bookingParamRequest.Booking._self.status.push(VehicleBookingStatus.CREATED.value)
                    return bookingParamRequest
                    break;
                case VehicleTripStatus.PRE_RIDING.value:
                    vehicleAndBookingParamRequest.Booking._self.status.push(VehicleBookingStatus.CREATED.value,VehicleBookingStatus.STARTED.value)
                    vehicleAndBookingParamRequest.Vehicle._self.status.push(VehicleStatus.UNLOCKED.value)
                    return vehicleAndBookingParamRequest
                    break;
                case VehicleTripStatus.RIDING.value:
                    bookingParamRequest.Booking._self.status.push(VehicleBookingStatus.STARTED.value)
                    return bookingParamRequest
                    break;
                case VehicleTripStatus.PAUSED.value:
                    vehicleAndBookingParamRequest.Booking._self.status.push(VehicleBookingStatus.STARTED.value)
                    vehicleAndBookingParamRequest.Vehicle._self.status.push(VehicleStatus.PARKED.value)
                    return vehicleAndBookingParamRequest
                    break;
                case VehicleTripStatus.FINISHED.value:
                    bookingParamRequest.Booking._self.status.push(VehicleBookingStatus.FINISHED.value)
                    return bookingParamRequest
                    break;
            }
        }

        function createTripWithVehicleIdFilter(vehicleId){
            if(typeof vehicleId !== "number"){
                return {}
            }
 
            return{
                Vehicle:{
                    _self:{
                        id: vehicleId
                    }
                }
            }
        }

        function createTripWithVehicleReferenceCodeFilter(refCode){
            if(typeof refCode !== "string"){
                return {}
            }

            return{
                Vehicle:{
                    _self: {
                        reference_code : refCode
                    }
                }
            }
        }

        function createTripWithVehicleLicensePlateFilter(licensePlate){
            if(typeof licensePlate !== "string"){
                return {}
            }

            return{
                Vehicle:{
                    _self: {
                        license_plate : licensePlate
                    }
                }
            }
        }

        function createTripWithUserFilter(userFullName){
            if(typeof userFullName !== "string"){
                return {}
            }
 
            return{
                User:{
                    _virtual:{
                        fullName: userFullName
                    }
                }
            }
        }

        function createTripWithUserIdFilter(userId){
            if(typeof userId !== "number"){
                return {}
            }

            return {
                User:{
                    _self: {
                        id: userId
                    }
                }
            }
        }

        function createUserWithStatusFilter(selectedStatuses){
            if(!selectedStatuses || selectedStatuses.length==0){
                return {}
            }
            var filterObj = {_self:{},_virtual:{}}

            //check to support old users
            selectedStatuses.forEach(function(userStatusValue){
                if( userStatusValue === UserStatus.BLOCKED_USER.value ){
                    filterObj._self['block'] = true
                } else if ( userStatusValue === UserStatus.MISSING_PAYMENT.value ){
                    filterObj._self['block'] = false
                    filterObj._self['paymentCreated'] = false
                } else if ( userStatusValue === UserStatus.MISSING_ID.value ){
                    //case user not uploaded the ID or is revoked or rejected
                    filterObj._self['block'] = false
                    filterObj._self['paymentCreated'] = true
                    filterObj._self['validDocument'] = [UserDocumentStatus.NOT_VALID.value,UserDocumentStatus.REJECTED.value]
                } else if( userStatusValue === UserStatus.MISSING_DRIVING_LICENSE.value ){
                    //case user not uploaded the DL or is revoked or rejected
                    filterObj._self['block'] = false
                    filterObj._self['paymentCreated'] = true
                    filterObj._self['validDocument'] = [UserDocumentStatus.WAITING_FOR_APPROVAL.value,UserDocumentStatus.VALID.value]
                    filterObj._self['validLicensePlate'] = [UserLicenseStatus.NOT_VALID.value,UserLicenseStatus.REJECTED.value ]
                } else if( userStatusValue === UserStatus.MISSING_AVATAR.value ){
                    //case user not uploaded the selfie
                    filterObj._self['block'] = false
                    filterObj._self['paymentCreated'] = true
                    filterObj._self['validDocument'] = [UserDocumentStatus.WAITING_FOR_APPROVAL.value, UserDocumentStatus.VALID.value]
                    filterObj._self['validLicensePlate'] = [UserLicenseStatus.WAITING_FOR_APPROVAL.value, UserDocumentStatus.VALID.value]
                    filterObj._virtual.hasAvatar = false
                } else if( userStatusValue === UserStatus.VERIFICATION_PENDING.value ){
                    //case user uploaded ID and DL
                    filterObj._self['block'] = false
                    filterObj._self['paymentCreated'] = true
                    filterObj._virtual.validationPending = true
                    filterObj._virtual.hasAvatar =  true
                }else{
                    //case activated user
                    filterObj._self['block'] = false
                    filterObj._self['paymentCreated'] = true
                    filterObj._self['validDocument'] = [UserDocumentStatus.VALID.value]
                    filterObj._self['validLicensePlate'] = [UserLicenseStatus.VALID.value]
                    filterObj._virtual.hasAvatar = true
                }
            })

            return filterObj
        }

        function createUserWithLastPaymentStatusFilter(lastPaymentStatuses){
            if(!lastPaymentStatuses || lastPaymentStatuses.length==0){
                return {}
            }

            return {
                _self:{
                    lastPaymentStatus: lastPaymentStatuses
                }
            }
        }

        function createUserWithIdFilter(userId){
            if(typeof userId !== "number"){
                return {}
            }
 
            return{
                _self:{
                    id: userId
                }
            }
        }

        function createUserWithFullNameFilter(userFullName){
            if(typeof userFullName !== "string"){
                return {}
            }
 
            return{
                _virtual:{
                    fullName: userFullName
                }
            }
        }

        function createUserWithEmailFilter(userEmail){
            if(typeof userEmail !== "string"){
                return {}
            }
 
            return{
                _self:{
                    email: userEmail
                }
            }
        }

        function createUserWithPhoneNumberFilter(userPhoneNumber){
            if(typeof userPhoneNumber !== "string"){
                return {}
            }
 
            return{
                _self:{
                    tel: userPhoneNumber
                }
            }
        }

        function createReportByIdFilter(id){
            if(typeof id !== "number"){
                return {}
            }
 
            return{
                _self:{
                    id: id
                }
            }
        }

        function createReportByVehicleIdFilter(id){
            if(typeof id !== "number"){
                return {}
            }
 
            return{
                _virtual:{
                    VehicleId: id
                }
            }
        }

        function createReportByUserIdFilter(id){
            if(typeof id !== "number"){
                return {}
            }
 
            return{
                _virtual:{
                    UserId: id
                }
            }
        }

        function createInvoiceWithTypeFilter(invoiceType){
            if(typeof invoiceType !== "number"){
                return {}
            }
 
            return{
                _self:{
                    type: invoiceType
                }
            }
        }

        function createInvoiceWithStatusFilter(invoiceStatus){
            if(typeof invoiceStatus !== "number"){
                return {}
            }
 
            return{
                _self:{
                    status: invoiceStatus
                }
            }
        }

        function createInvoiceWithCodeFilter(invoiceCode){
            if(typeof invoiceCode !== "string"){
                return {}
            }

            return {
                _self:{
                    code:invoiceCode
                }
            }
        }

        function createInvoiceWithUserFilter(userFullName){
            if(typeof userFullName !== "string"){
                return {}
            }

            return {
                User:{
                    _virtual: {
                        fullName: userFullName
                    }
                }
            }
        }

        function createInvoiceWithUserIdFilter(userId){
            if(typeof userId !== "number"){
                return {}
            }

            return {
                User:{
                    _self: {
                        id: userId
                    }
                }
            }
        }

        function createDeviceWithIdFilter(deviceId){
            if(typeof deviceId !== "number"){
                return {}
            }

            return {
                _self:{
                    id: deviceId
                }
            }
        }

        function createDeviceWithCodeFilter(deviceCode){
            if(typeof deviceCode !== "string"){
                return {}
            }

            return {
                _self:{
                    code: deviceCode
                }
            }
        }

        function createDeviceWithVersionFilter(deviceVersion){
            if(typeof deviceVersion !== "string"){
                return {}
            }

            return {
                _self:{
                    version: deviceVersion
                }
            }
        }

        function createDeviceWithOnlineStatusFilter(online){
            if(typeof online === "undefined"){
                online = true
            }else{
                if(typeof online === "string"){
                    online = (online == 'true')
                }
            }
            
            return {
                _virtual: {
                    online: online
                }
            }
        }

        function createDeviceWithVehicleIdFilter(vehicleId){
            if(typeof vehicleId !== "number"){
                return {}
            }

            return {
                vehicle: {
                    _self:{
                        id: vehicleId
                    }
                }
            }
        }

        function createDeviceWithVehicleReferenceCodeFilter(vehicleRefCode){
            if(typeof vehicleRefCode !== "string"){
                return {}
            }

            return {
                vehicle: {
                    _self:{
                        reference_code: vehicleRefCode
                    }
                }
            }
        }

        function createDeviceWithVehicleLicensePlateFilter(vehicleLicensePlate){
            if(typeof vehicleLicensePlate !== "string"){
                return {}
            }

            return {
                vehicle: {
                    _self:{
                        license_plate: vehicleLicensePlate
                    }
                }
            }
        }

        function createDeviceWithAssignedVehicleFilter(assigned){
            if(typeof assigned === "undefined"){
                assigned = true
            }else{
                if(typeof assigned === "string"){
                    assigned = (assigned == 'true')
                }
            }
            
            return {
                _virtual: {
                    associated: assigned
                }
            }
        }

        function createCouponWithCodeFilter(code){
            if(typeof code !== "string"){
                return {}
            }
 
            return{
                _self:{
                    code: code
                }
            }
        }

        function createCouponWithRangeFilter(range){
            if(typeof range[0] !== "number" || typeof range[1] !== "number"){
                return {}
            }

            const start = range[0];
            const end = range[1];

            return{
                _self:{
                    start: [start, end],
                    finish: [start, end]
                }
            }
        }

        function createCouponWithUnlimitedFinishFilter(unlimited_finish){
            if(typeof unlimited_finish !== "boolean"){
                return {}
            }
 
            return{
                _self:{
                    unlimited_finish: unlimited_finish
                }
            }
        }

        function createBonusTemplateWithHiddenFilter(boolValue){
            if (typeof boolValue !== "boolean") {
                return {}
            }
 
            return {
                _self: {
                    hidden: boolValue
                }
            }
        }

        function createBonusTemplateWithDisabledFilter(boolValue){
            if (typeof boolValue !== "boolean") {
                return {}
            }
 
            return {
                _self: {
                    disabled: boolValue
                }
            }
        }

        function createBonusTemplateWithTypeFilter(types){
            if(!Array.isArray(types) || types.length == 0){
                return {}
            }

            return {
                _self: {
                    type : types
                }
            }
        }

        function createShopItemWithUserVisibleFilter(boolValue){
            if (typeof boolValue !== "boolean") {
                return {}
            }
 
            return {
                _self: {
                    userVisible: boolValue
                }
            }
        }

        function createAnAndFilter(filterParts){
            if(typeof filterParts == "undefined")
                return {}

            var outputFilter = {}
            filterParts.forEach(function(filterPart){
                
                if(Object.keys(filterPart).length>0){ 

                    // for(var key in filterPart){
                        
                    //     if(outputFilter.hasOwnProperty(key)){
                    //         for(var keyInObject in filterPart[key]){
                    //             //this not works above 2' level of tree properties                                
                    //             if(outputFilter[key].hasOwnProperty(keyInObject)){ //handle case of merge two array
                    //                 var elemToAdd = filterPart[key][keyInObject]
                    //                 var arrayOld = outputFilter[key][keyInObject]

                    //                 if(typeof elemToAdd == 'string'){
                    //                     if(arrayOld.indexOf(elemToAdd)==-1){
                    //                         outputFilter[key][keyInObject].push(elemToAdd)
                    //                     }

                    //                 }else if(elemToAdd.hasOwnProperty('length')){
                    //                     elemToAdd.forEach(function(elem){
                    //                         if(arrayOld.indexOf(elem)==-1){
                    //                             outputFilter[key][keyInObject].push(elem)
                    //                         }
                    //                     })
                    //                 }
                    //             }
                    //             else{
                    //                 outputFilter[key][keyInObject] = filterPart[key][keyInObject]
                    //             }
                    //         }
                    //     }
                    //     else{
                    //         outputFilter[key] = filterPart[key]
                    //     }
                    // }

                    outputFilter = MiscUtility.deepMergeObjects(filterPart,outputFilter)
                }

            })

            return outputFilter
        }

        function createAFilterRequestParam(filterObj){
            var filterRequestParam = {filters: {}}
            if(typeof filterObj != "undefined" && typeof filterObj === "object"){
                filterRequestParam.filters = filterObj
            }

            return filterRequestParam
        }

        //utils that merge two simple objects at first level
        function mergeObjects(o1,o2){
            if(typeof o1 != "object" || typeof o2 != "object"){
                console.warn("ob1 or ob2 not object")
                return {}
            }
            if(Object.keys(o1).length == 0){
                console.warn("ob1 empty")
                if(Object.keys(o2).length == 0){
                    console.warn("ob2 empty")
                    return {}
                }else{
                    return o2
                }
            }
            if(Object.keys(o2).length == 0){
                console.warn("ob2 empty")
                if(Object.keys(o1).length == 0){
                    console.warn("ob1 empty")
                    return {}
                }else{
                    return o1
                }
            }
            var ob1 = angular.copy(o1)
            var ob2 = angular.copy(o2)
            for(var key1 in ob1){
                if(!ob2.hasOwnProperty(key1)){
                    ob2[key1] = ob1[key1]
                }else{
                    for(var key2 in ob1[key1]){
                        if(!ob2[key1].hasOwnProperty(key2)){
                            ob2[key1][key2] = ob1[key1][key2]
                        }
                    }
                }
            }
            return ob2
        }

        return {
            createIdFilter: createIdFilter,
            createSelfDateRangeFilter:createSelfDateRangeFilter,
            createAFilterRequestParam:createAFilterRequestParam,
            createAnAndFilter:createAnAndFilter,
            createCouponWithRangeFilter: createCouponWithRangeFilter,
            createCouponWithUnlimitedFinishFilter: createCouponWithUnlimitedFinishFilter,
            createCouponWithCodeFilter: createCouponWithCodeFilter,
            createVehicleStatusFilter:createVehicleStatusFilter,
            createVehicleExternalStatusFilter:createVehicleExternalStatusFilter,
            createVehicleInOnlineStatusFilter:createVehicleInOnlineStatusFilter,
            createVehicleBatteryLevelFilter:createVehicleBatteryLevelFilter,
            createVehicleFuelLevelFilter:createVehicleFuelLevelFilter,
            createVehicleActiveStatusFilter:createVehicleActiveStatusFilter,
            createVehicleHasACurrentBookingFilter:createVehicleHasACurrentBookingFilter,
            createVehicleInUseStatusFilter:createVehicleInUseStatusFilter,
            createVehicleInMaintenanceStatusFilter:createVehicleInMaintenanceStatusFilter,
            createVehicleWithReferenceCodeFilter:createVehicleWithReferenceCodeFilter,
            createVehicleWithIdFilter:createVehicleWithIdFilter,
            createVehicleWithLicensePlateFilter:createVehicleWithLicensePlateFilter,
            createVehicleWithCurrentUserFilter:createVehicleWithCurrentUserFilter,
            createVehicleWithLastMovedDateFilter:createVehicleWithLastMovedDateFilter,
            createVehicleWithBrandFilter:createVehicleWithBrandFilter,
            createVehicleWithModelNameFilter:createVehicleWithModelNameFilter,
            createVehicleWithTypeFilter:createVehicleWithTypeFilter,
            createInnerVehicleWithTypesFilter:createInnerVehicleWithTypesFilter,
            createVehicleWithDeviceTypeFilter:createVehicleWithDeviceTypeFilter,
            createVehicleWithinBoundingBoxFilter:createVehicleWithinBoundingBoxFilter,
            createInnerVehicleWithDeviceTypesFilter:createInnerVehicleWithDeviceTypesFilter,
            createVehicleWithHiddenFilter:createVehicleWithHiddenFilter,
            createTripWithIdFilter:createTripWithIdFilter,
            createTripWithStatusFilter:createTripWithStatusFilter,
            createTripWithVehicleIdFilter:createTripWithVehicleIdFilter,
            createTripWithVehicleReferenceCodeFilter:createTripWithVehicleReferenceCodeFilter,
            createTripWithVehicleLicensePlateFilter:createTripWithVehicleLicensePlateFilter,
            createTripWithUserFilter:createTripWithUserFilter,
            createTripWithUserIdFilter:createTripWithUserIdFilter,
            createUserWithStatusFilter:createUserWithStatusFilter,
            createUserWithLastPaymentStatusFilter:createUserWithLastPaymentStatusFilter,
            createUserWithIdFilter:createUserWithIdFilter,
            createUserWithFullNameFilter:createUserWithFullNameFilter,
            createUserWithEmailFilter:createUserWithEmailFilter,
            createUserWithPhoneNumberFilter:createUserWithPhoneNumberFilter,
            createReportByIdFilter: createReportByIdFilter,
            createReportByVehicleIdFilter: createReportByVehicleIdFilter,
            createReportByUserIdFilter: createReportByUserIdFilter,
            createInvoiceWithTypeFilter:createInvoiceWithTypeFilter,
            createInvoiceWithStatusFilter:createInvoiceWithStatusFilter,
            createInvoiceWithCodeFilter:createInvoiceWithCodeFilter,
            createInvoiceWithUserFilter:createInvoiceWithUserFilter,
            createInvoiceWithUserIdFilter:createInvoiceWithUserIdFilter,
            createDeviceWithIdFilter:createDeviceWithIdFilter,
            createDeviceWithCodeFilter:createDeviceWithCodeFilter,
            createDeviceWithVersionFilter:createDeviceWithVersionFilter,
            createDeviceWithOnlineStatusFilter:createDeviceWithOnlineStatusFilter,
            createDeviceWithVehicleIdFilter:createDeviceWithVehicleIdFilter,
            createDeviceWithVehicleReferenceCodeFilter:createDeviceWithVehicleReferenceCodeFilter,
            createDeviceWithVehicleLicensePlateFilter:createDeviceWithVehicleLicensePlateFilter,
            createDeviceWithAssignedVehicleFilter:createDeviceWithAssignedVehicleFilter,
            createBonusTemplateWithHiddenFilter: createBonusTemplateWithHiddenFilter,
            createBonusTemplateWithDisabledFilter: createBonusTemplateWithDisabledFilter,
            createBonusTemplateWithTypeFilter: createBonusTemplateWithTypeFilter,
            createShopItemWithUserVisibleFilter: createShopItemWithUserVisibleFilter,
            mergeObjects:mergeObjects
        }
    }

    /** @ngInject */
    function FiltersFactory(ToHireDefaultColor,FiltersRequestParamFactory,VehicleTypes,DeviceType,VehicleExternalStatus,VehicleTripStatus,UserStatus,UserPaymentStatus,InvoiceType,InvoiceStatus,SitesService,DefaultSite,ErrorUtility,MiscUtility,BonusTemplateType) {
        
        var filters = {
            // miscStatusLocal: {
            //     name: "Availability",
            //     options:{
            //         multiple: false
            //     },
            //     selected: [],
            //     values: [
            //         { description: "Active", value: "active"},
            //         { description: "Assigned", value: "assigned"},
            //         { description: "In Use", value: "using"},
            //         { description: "Maintenance", value: "maintenance"}
            //     ],
            //     filter: isVehicleInMiscStatusFilter
            // },
            miscStatus: {
                name: "Availability",
                options:{
                    multiple: false
                },
                selected: [],
                description: "Options",
                valueType: "dropdown",
                values: [
                    { description: "Active", value: "active"},
                    { description: "Assigned", value: "assigned"},
                    { description: "In Use", value: "using"},
                    { description: "Maintenance", value: "maintenance"}
                ],
                filter: searchVehicleWithMiscStatusFilter
            },
            // batteryStatusLocal: {
            //     name: "Battery Status",
            //     options:{
            //         multiple: true
            //     },
            //     selected: [],
            //     values: [
            //         { description: "Full charged", value: "full", color: ToHireDefaultColor.blue},
            //         { description: "Up to 50%", value: "half", color: ToHireDefaultColor.azure},
            //         { description: "Low charge", value: "low", color: ToHireDefaultColor.lobster},
            //         { description: "Critical level", value: "critical", color: ToHireDefaultColor.criticalRed}
            //     ],
            //     filter: isVehicleInBatteryStatusFilter
            // },
            batteryStatus: {
                name: "Fuel Level",
                options:{
                    multiple: true
                },
                selected: [],
                description: "Status",
                valueType: "multiselect",
                values: [
                    { description: "High", value: "high", color: ToHireDefaultColor.blue, tooltip: "80% to 100%"},
                    { description: "Medium", value: "medium", color: ToHireDefaultColor.azure, tooltip: "50% to 79%"},
                    { description: "Low", value: "low", color: ToHireDefaultColor.lobster, tooltip: "16% to 49%"},
                    { description: "Critical", value: "critical", color: ToHireDefaultColor.criticalRed, tooltip: "0% to 15%"}
                ],
                filter: searchVehicleWithBatteryStatusFilter
            },
            // fuelLevelStatusLocal: {
            //     name: "Fuel level",
            //     options:{
            //         multiple: true
            //     },
            //     selected: [],
            //     values: [
            //         { description: "Full", value: "full", color: ToHireDefaultColor.blue},
            //         { description: "Up to 50%", value: "half", color: ToHireDefaultColor.azure},
            //         { description: "Low", value: "low", color: ToHireDefaultColor.lobster},
            //         { description: "Critical", value: "critical", color: ToHireDefaultColor.criticalRed}
            //     ],
            //     filter: isVehicleInFuelLevelStatusFilter
            // },
            fuelLevelStatus: {
                name: "Fuel level",
                options:{
                    multiple: true
                },
                selected: [],
                values: [
                    { description: "Full", value: "full", color: ToHireDefaultColor.blue, tooltip: "80% to 100%"},
                    { description: "Up to 50%", value: "half", color: ToHireDefaultColor.azure, tooltip: "50% to 79%"},
                    { description: "Low", value: "low", color: ToHireDefaultColor.lobster, tooltip: "16% to 49%"},
                    { description: "Critical", value: "critical", color: ToHireDefaultColor.criticalRed, tooltip: "0% to 15%"}
                ],
                filter: searchVehicleWithFuelLevelStatusFilter
            },
            // vehicleExternalStatusLocal: {
            //     name: "Vehicle Status",
            //     options:{
            //         multiple: true
            //     },
            //     selected: [],
            //     values: [],
            //     filter: isVehicleInExternalStatusFilter
            // },
            vehicleExternalStatus: {
                name: "Vehicle Status",
                options:{
                    multiple: true
                },
                selected: [],
                description: "Status",
                valueType: "multiselect",
                values: [],
                filter: searchVehicleWithExternalStatusFilter
            },
            // vehicleStatusLocal: {
            //     name: "Vehicle State",
            //     options:{
            //         multiple: true
            //     },
            //     selected: [],
            //     values: [
            //         { description: "Free", value: "free", color: ToHireDefaultColor.green, filterIsOn: true},
            //         { description: "Booked", value: "booked", color: ToHireDefaultColor.blue, filterIsOn: true},
            //         { description: "Unlocked", value: "unlocked", color: ToHireDefaultColor.blue, filterIsOn: true},
            //         { description: "Running", value: "running", color: ToHireDefaultColor.purple, filterIsOn: true},
            //         { description: "Trunk Open", value: "trunkIsOpen", color: ToHireDefaultColor.purple, filterIsOn: true},
            //         { description: "Parked", value: "parked", color: ToHireDefaultColor.purple, filterIsOn: true},
            //         { description: "Locked", value: "locked", color: ToHireDefaultColor.purple, filterIsOn: true},
            //         { description: "Unavailable", value: "unavailable", color: ToHireDefaultColor.maintenanceRed, filterIsOn: true}
            //     ],
            //     filter: isVehicleInStatusFilter
            // },
            vehicleStatus: {
                name: "Status",
                options:{
                    multiple: true
                },
                selected: [],
                description: "Vehicle Status",
                valueType: "multiselect",
                values: [
                    { description: "Free", value: "free", color: ToHireDefaultColor.green, filterIsOn: true},
                    { description: "Booked", value: "booked", color: ToHireDefaultColor.blue, filterIsOn: true},
                    { description: "Unlocked", value: "unlocked", color: ToHireDefaultColor.blue, filterIsOn: true},
                    { description: "Running", value: "running", color: ToHireDefaultColor.purple, filterIsOn: true},
                    { description: "Trunk Open", value: "trunkIsOpen", color: ToHireDefaultColor.purple, filterIsOn: true},
                    { description: "Parked", value: "parked", color: ToHireDefaultColor.purple, filterIsOn: true},
                    { description: "Locked", value: "locked", color: ToHireDefaultColor.purple, filterIsOn: true},
                    { description: "Unavailable", value: "unavailable", color: ToHireDefaultColor.maintenanceRed, filterIsOn: true}
                ],
                filter: searchVehicleWithStatusFilter
            },
            vehicleReferenceCode: {
                name: "Ref. Code",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Ref. Code",
                filter: searchVehicleWithReferenceCode
            },
            vehicleId: {
                name: "ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "Vehicle ID",
                filter: searchVehicleWithId
            },
            vehicleLicensePlate: {
                name: "License Plate",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "License Plate",
                filter: searchVehicleWithLicensePlate
            },
            vehicleOnline: {
                name: "Online",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"boolean",
                description: "Online",
                filter: searchVehicleWithOnline
            },
            vehicleCurrentUser: {
                name: "Current User",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Current User",
                filter: searchVehicleWithCurrentUser
            },
            vehicleLastMovedDate:{
                name: "Last Moved",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"date",
                description: "Last Moved",
                filter: searchVehicleWithLastMovedDate
            },
            vehicleBrand: {
                name: "Manufacturer",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Manufacturer",
                filter: searchVehicleWithBrand
            },
            vehicleModelName: {
                name: "Model name",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Model name",
                filter: searchVehicleWithModelName
            },
            vehicleType: {
                name: "Type",
                options:{
                    multiple: true
                },
                selected: [],
                valueType: "multiselect",
                description: "Type",
                values: [],
                filter: searchVehicleWithType
            },
            vehicleDeviceType: {
                name: "Device Provider",
                options:{
                    multiple: true
                },
                selected: [],
                valueType: "multiselect",
                description: "Provider",
                values: [],
                filter: searchVehicleWithDeviceType
            },
            vehicleBoundingBox: {
                name: "Bounding Box",
                options:{
                    multiple: false
                },
                selected: [null,null],
                valueType: "multiinput",
                description: "Bounding Box",
                filter: searchVehicleWithinBoundingBox
            },
            vehicleHidden: {
                name: "Hidden",
                options:{
                    multiple: false
                },
                selected: null,
                valueType: "boolean",
                description: "Hidden",
                filter: searchVehicleWithHidden
            },
            couponCode: {
                name: "Code",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Code",
                filter: searchCouponWithCode
            },
            couponRange: {
                name: "Validity Range",
                options:{
                    multiple: false
                },
                selected: [null, null],
                valueType:"dateRange",
                description: "Validity Range",
                filter: searchCouponWithRange
            },
            couponUnlimitedFinish: {
                name: "Unlimited Finish",
                options:{
                    multiple: false
                },
                valueType:"boolean",
                description: "Unlimited Finish",
                filter: searchCouponWithUnlimitedFinish
            },
            couponCreation: {
                name: "Creation Date",
                options:{
                    multiple: false
                },
                selected: [null, null],
                valueType:"dateRange",
                description: "Creation Date",
                filter: searchCouponWithCreationDate
            },
            tripId:{
                name: "ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "ID",
                filter: searchTripWithId
            },
            tripDateRange: {
                name: "Trip Date",
                options:{
                    multiple: false
                },
                selected: [null, null],
                valueType:"dateRange",
                description: "Trip Date",
                filter: searchTripWithDateRange
            },
            tripStatus:{
                name: "Trip Status",
                options:{
                    multiple: false
                },
                selected: null,
                description: "Status",
                valueType: "dropdown",
                values: [],
                filter: searchTripWithStatus
            },
            tripDateStart:{
                name: "Start date",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"date",
                description: "Start date",
                filter: function(){
                    return {}
                }
            },
            tripDateEnd:{
                name: "End date",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"date",
                description: "End date",
                filter: searchTripWithDateEnd
            },
            tripVehicleId: {
                name: "Vehicle ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "Vehicle ID",
                filter: searchTripWithVehicleId
            },
            tripVehicleLicensePlate: {
                name: "Vehicle License Plate",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Vehicle License Plate",
                filter: searchTripWithVehicleLicensePlate
            },
            tripVehicleReferenceCode: {
                name: "Vehicle Ref. Code",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Vehicle Ref. Code",
                filter: searchTripWithVehicleReferenceCode
            },
            tripVehicleType: {
                name: "Vehicle Type",
                options:{
                    multiple: true
                },
                selected: [],
                valueType: "multiselect",
                description: "Type",
                values: [], 
                filter: searchTripWithVehicleType
            },
            tripDeviceType: {
                name: "Device Provider",
                options:{
                    multiple: true
                },
                selected: [],
                valueType: "multiselect",
                description: "Provider",
                values: [],
                filter: searchTripWithDeviceType
            },
            tripUser:{
                name: "User",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "User",
                filter: searchTripWithUser
            },
            tripUserId:{
                name: "User ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "User ID",
                filter: searchTripWithUserId
            },
            userStatus:{
                name: "User Status",
                options:{
                    multiple: false
                },
                selected: null,
                description: "Status",
                valueType: "dropdown",
                values: [
                    {description: UserStatus.ACTIVATED_USER.name, value: UserStatus.ACTIVATED_USER.value},
                    {description: UserStatus.VERIFICATION_PENDING.name, value: UserStatus.VERIFICATION_PENDING.value},
                    {description: UserStatus.BLOCKED_USER.name, value: UserStatus.BLOCKED_USER.value},
                    {description: UserStatus.MISSING_PAYMENT.name, value: UserStatus.MISSING_PAYMENT.value},
                    {description: UserStatus.MISSING_ID.name, value: UserStatus.MISSING_ID.value},
                    {description: UserStatus.MISSING_DRIVING_LICENSE.name, value: UserStatus.MISSING_DRIVING_LICENSE.value},
                    {description: UserStatus.MISSING_AVATAR.name, value: UserStatus.MISSING_AVATAR.value},
                ],
                filter: searchUserWithStatus
            },
            userLastPaymentStatus:{
                name: "Payment Status",
                options:{
                    multiple: true
                },
                selected: [],
                description: "Status",
                valueType: "multiselect",
                values: [],
                filter: searchUserWithLastPaymentStatus
            },
            userId:{
                name: "User ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "User ID",
                filter: searchUserWithId
            },
            userFullName:{
                name: "Full Name",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Full Name",
                filter: searchUserWithFullName
            },
            userEmail:{
                name: "Email",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Email",
                filter: searchUserWithEmail
            },
            userPhoneNumber:{
                name: "Phone number",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Phone number",
                filter: searchUserWithPhoneNumber
            },
            userRegistrationDateRange: {
                name: "Registration Range",
                options:{
                    multiple: false
                },
                selected: [null, null],
                valueType:"dateRange",
                description: "Registration Date",
                filter: searchUserRegistrationWithRange
            },
            damageReportDateRange: {
                name: "Creation Range",
                options:{
                    multiple: false
                },
                selected: [null, null],
                valueType:"dateRange",
                description: "Creation date",
                filter: searchDamageReportsWithRange
            },
            reportId:{
                name: "ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "ID",
                filter: searchReportById
            },
            reportVehicleId:{
                name: "Vehicle ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "Vehicle ID",
                filter: searchReportByVehicleId
            },
            reportVehicleType:{
                name: "Vehicle Type",
                options:{
                    multiple: true
                },
                selected: [],
                valueType: "multiselect",
                description: "Type",
                values: [],
                filter: searchReportByVehicleType
            },
            reportDeviceType:{
                name: "Device Provider",
                options:{
                    multiple: true
                },
                selected: [],
                valueType: "multiselect",
                description: "Provider",
                values: [],
                filter: searchReportByDeviceType
            },
            reportUserId:{
                name: "User ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number", 
                description: "User ID",
                filter: searchReportByUserId
            },
            reportDateStart:{
                name: "Start date",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"date",
                description: "Start date",
                filter: function(){
                    return {}
                }
            },
            reportDateEnd:{
                name: "End date",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"date",
                description: "End date",
                filter: searchDamageReportWithDateEnd
            },
            invoiceType:{
                name: "Ticket Type",
                options:{
                    multiple: false
                },
                description: "Type",
                valueType: "dropdown",
                selected: null,
                values: [],
                filter: searchInvoiceWithType
            },
            invoiceStatus:{
                name: "Ticket Status",
                options:{
                    multiple: false
                },
                selected: null,
                description: "Status",
                valueType: "dropdown",
                values: [],
                filter: searchInvoiceWithStatus
            },
            invoiceDateStart:{
                name: "Start date",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"date",
                description: "Start date",
                filter: function(){
                    return {}
                }
            },
            invoiceDateRange: {
                name: "Issue Date",
                options:{
                    multiple: false
                },
                selected: [null, null],
                valueType:"dateRange",
                description: "Issue Date",
                filter: searchInvoiceWithDateRange
            },
            invoiceDateEnd:{
                name: "End date",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"date",
                description: "End date",
                filter: searchInvoiceWithDateEnd
            },
            invoiceCode:{
                name: "Ticket Code",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Ticket Code",
                filter: searchInvoiceWithCode
            },
            invoiceUser:{
                name: "User",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "User",
                filter: searchInvoiceWithUser
            },
            invoiceUserId:{
                name: "User ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "User ID",
                filter: searchInvoiceWithUserId
            },
            deviceId:{
                name: "ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "ID",
                filter: searchDeviceWithId
            },
            deviceCode:{
                name: "Name",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Name",
                filter: searchDeviceWithCode
            },
            deviceVersion:{
                name: "Version",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Version",
                filter: searchDeviceWithVersion
            },
            deviceOnline: {
                name: "Online",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"boolean",
                description: "Online",
                filter: searchDeviceWithOnline
            },
            deviceVehicleId:{
                name: "Vehicle ID",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"number",
                description: "Vehicle ID",
                filter: searchDeviceWithVehicleId
            },
            deviceVehicleReferenceCode:{
                name: "Vehicle Ref.Code",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Vehicle Ref.Code",
                filter: searchDeviceWithVehicleReferenceCode
            },
            deviceVehicleLicensePlate:{
                name: "Vehicle License Plate",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"string",
                description: "Vehicle License Plate",
                filter: searchDeviceWithVehicleLicensePlate
            },
            deviceAssignedVehicle: {
                name: "Assigned",
                options:{
                    multiple: false
                },
                selected: null,
                valueType:"boolean",
                description: "Assigned",
                filter: searchDeviceWithAssignedVehicle
            },
        }
        var returnFiltersObj = {}

        // TODO refactor all duplicate filter initialization to use this patter
        // TODO maybe think if this covers all the cases and not produce duplicated code too
        function addFilter(createOptions) {

            if (filters.hasOwnProperty(createOptions.key)) {
                console.warn("Already set filter", createOptions.key, createOptions.name);
                return
            }

            const words = createOptions.key.split("-")
            if (words.length<2) {
                console.warn("Wrong filter key name, less 2 words", createOptions.key)
                return
            }

            // An example createTripWithIdFilter
            const createFilterFnName = "create" + words[0] + "With" + words[1] + "Filter"

            function createFilter() {
                return function () {
                    filters[createOptions.key].selected = null
                    return filters[createOptions.key]
                }
            }

            function createMultiSelectFilter() {
                return function(){
                    filters[createOptions.key].selected = null
                    return filters[createOptions.key]
                }
            }

            switch (createOptions.type) {
                case "number":
                    filters[createOptions.key] = {
                        name: createOptions.name,
                        options: {
                            multiple: false
                        },
                        selected: null,
                        valueType: createOptions.type,
                        description: createOptions.description,
                        filter: function () {
                            var selectedValue = filters[createOptions.key].selected
            
                            if(selectedValue == null){
                                return {}
                            }
                            
                            if(typeof selectedValue !== "number"){
                                selectedValue = parseInt(selectedValue)
                            }
                            return createOptions.createFilterRequestParam(selectedValue)
                        }
                    }

                    returnFiltersObj[createFilterFnName] = createFilter(createOptions)

                    break;
                case "boolean":
                    filters[createOptions.key] = {
                        name: createOptions.name,
                        options: {
                            multiple: false
                        },
                        selected: null,
                        valueType: createOptions.type,
                        description: createOptions.description,
                        filter: function () {
                            var selectedValue = filters[createOptions.key].selected
            
                            if(typeof selectedValue !== "boolean"){
                                return {}
                            }

                            return createOptions.createFilterRequestParam(selectedValue)
                        }
                    }

                    returnFiltersObj[createFilterFnName] = createFilter(createOptions)

                    break;
                case "multiselect":
                    filters[createOptions.key] = {
                        name: "Type",
                        options:{
                            multiple: true
                        },
                        selected: [],
                        valueType: "multiselect",
                        description: "Type",
                        values: [],
                        filter: function () {
                            var selectedValues = filters[createOptions.key].selected
            
                            if(!selectedValues){
                                return {}
                            }
 
                            return createOptions.createFilterRequestParam(selectedValues)
                        }
                    }

                    returnFiltersObj[createFilterFnName] = createMultiSelectFilter(createOptions)

            }
        }
        // New filter initialization
        // TODO use this initialization rather than the old one in the vm.filters obj
        addFilter({ type: "number", key: "BonusTemplate-Id", name: "ID", description: "Template ID", createFilterRequestParam: FiltersRequestParamFactory.createIdFilter });
        addFilter({ type: "boolean", key: "BonusTemplate-Hidden", name: "Hidden", description: "Template Hidden", createFilterRequestParam: FiltersRequestParamFactory.createBonusTemplateWithHiddenFilter });
        addFilter({ type: "boolean", key: "BonusTemplate-Disabled", name: "Disabled", description: "Template Disabled", createFilterRequestParam: FiltersRequestParamFactory.createBonusTemplateWithDisabledFilter });
        addFilter({ type: "multiselect", key: "BonusTemplate-Type", name: "Type", description: "Template type", createFilterRequestParam: FiltersRequestParamFactory.createBonusTemplateWithTypeFilter });
        addFilter({ type: "number", key: "ShopItem-Id", name: "ID", description: "Shop Item ID", createFilterRequestParam: FiltersRequestParamFactory.createIdFilter });
        addFilter({ type: "boolean", key: "ShopItem-UserVisible", name: "On sale", description: "Shop Item on sale", createFilterRequestParam: FiltersRequestParamFactory.createShopItemWithUserVisibleFilter });

        function initFilter(filteKey,enumCollection) {
            for(var statusObj in enumCollection){
                var value = enumCollection[statusObj].value
                if(typeof value == "number" && !filters[filteKey].options.multiple){
                    value = String(value)
                }
                filters[filteKey].values.push({ description: enumCollection[statusObj].name, value: value})
            }
        }
        // initFilter("vehicleExternalStatusLocal",VehicleExternalStatus)
        initFilter("vehicleExternalStatus", VehicleExternalStatus)
        initFilter("vehicleType", VehicleTypes)
        initFilter("tripVehicleType", VehicleTypes)
        initFilter("reportVehicleType", VehicleTypes)
        initFilter("vehicleDeviceType", DeviceType)
        initFilter("tripDeviceType", DeviceType)
        initFilter("reportDeviceType", DeviceType)
        initFilter("tripStatus", VehicleTripStatus)
        initFilter("userLastPaymentStatus", UserPaymentStatus)
        initFilter("invoiceType", InvoiceType)
        initFilter("invoiceStatus", InvoiceStatus)
        initFilter("BonusTemplate-Type", BonusTemplateType)

        // function isVehicleInMiscStatusFilter(vehicle){
        //     var selectedStatuses = filters.miscStatusLocal.selected

        //     return selectedStatuses.length == 0
        //     || selectedStatuses.some(
        //         function (status) {
        //             var isInStatus = false

        //             if (status == "active") {
        //                 isInStatus = VehicleUtility.isVehicleActive(vehicle)
        //             }
        //             else if (status == "assigned") {
        //                 isInStatus = VehicleUtility.hasVehicleACurrentBooking(vehicle)
        //             }
        //             else if (status == "using"){
        //                 isInStatus =  VehicleUtility.isVehicleInUse(vehicle)
        //             }
        //             else if (status == "maintenance") {
        //                 isInStatus = VehicleUtility.isVehicleInMaintenance(vehicle)
        //             }
        //             return isInStatus
        //         })
        // }

        function searchVehicleWithMiscStatusFilter(){
            var selectedStatuses = filters.miscStatus.selected

            if(!selectedStatuses){
                return {}
            }
            
            //check if selectedStatuses isd not an array cause select not multiple 
            if(selectedStatuses && !(typeof selectedStatuses === "object" && selectedStatuses.hasOwnProperty('length'))){
                if(typeof selectedStatuses === "string"){
                    if(selectedStatuses != ""){
                        selectedStatuses = [selectedStatuses]
                    }
                    else{
                        selectedStatuses = []
                    }
                }          
            }
            
            var selectedFilter = {}

            selectedStatuses.forEach(function(status){
                if (status == "active") {
                    selectedFilter = FiltersRequestParamFactory.createVehicleActiveStatusFilter()
                }
                else if (status == "assigned") {
                    selectedFilter = FiltersRequestParamFactory.createVehicleHasACurrentBookingFilter()
                }
                else if (status == "using"){
                    selectedFilter = FiltersRequestParamFactory.createVehicleInUseStatusFilter()
                }
                else if (status == "maintenance") {
                    selectedFilter = FiltersRequestParamFactory.createVehicleInMaintenanceStatusFilter()
                }
            })

            return selectedFilter

        }

        // function isVehicleInBatteryStatusFilter(vehicle) {

        //     var selectedStatuses = filters.batteryStatusLocal.selected

        //     return selectedStatuses.length == 0 
        //         || selectedStatuses.some(
        //             function(status){
        //                 var isInBatteryStatus = false
        //                 switch (status) {
        //                     case 'full':
        //                         isInBatteryStatus = vehicle.total_percentage > 50
        //                         break
        //                     case 'half':
        //                         isInBatteryStatus = vehicle.total_percentage > 25 && vehicle.total_percentage <= 50
        //                         break
        //                     case 'low':
        //                         isInBatteryStatus = vehicle.total_percentage > 5 && vehicle.total_percentage <= 25
        //                         break
        //                     case 'critical':
        //                         isInBatteryStatus = vehicle.total_percentage <=5
        //                         break
        //                 }
        //                 return isInBatteryStatus
        //             }
        //         )
        // }

        function searchVehicleWithBatteryStatusFilter(){
            
            var selectedStatuses = filters.batteryStatus.selected

            if(!selectedStatuses){
                return {}
            }

            var batteryLevelRanges = []
            selectedStatuses.forEach(function(status){
                switch (status) {
                    case 'high':
                        batteryLevelRanges.push([80,100])
                        break
                    case 'medium':
                        batteryLevelRanges.push([50,79])
                        break
                    case 'low':
                        batteryLevelRanges.push([16,49])
                        break
                    case 'critical':
                        batteryLevelRanges.push([0,15])
                        break
                }
            })

            return FiltersRequestParamFactory.createVehicleBatteryLevelFilter(batteryLevelRanges)
        }

        // function isVehicleInFuelLevelStatusFilter(vehicle) {

        //     var selectedStatuses = filters.fuelLevelStatusLocal.selected

        //     return selectedStatuses.length == 0 
        //         || selectedStatuses.some(
        //             function(status){
        //                 var isInFuelLevelStatus = false
        //                 switch (status) {
        //                     case 'full':
        //                         isInFuelLevelStatus = vehicle.total_percentage > 50
        //                         break
        //                     case 'half':
        //                         isInFuelLevelStatus = vehicle.total_percentage > 25 && vehicle.total_percentage <= 50
        //                         break
        //                     case 'low':
        //                         isInFuelLevelStatus = vehicle.total_percentage > 10 && vehicle.total_percentage <= 25
        //                         break
        //                     case 'critical':
        //                         isInFuelLevelStatus = vehicle.total_percentage <=10
        //                         break
        //                 }
        //                 return isInFuelLevelStatus
        //             }
        //         )
        // }

        function searchVehicleWithFuelLevelStatusFilter(){
            
            var selectedStatuses = filters.fuelLevelStatus.selected

            if(!selectedStatuses){
                return {}
            }

            var fuelLevelRanges = []
            selectedStatuses.forEach(function(status){
                switch (status) {
                    case 'full':
                        fuelLevelRanges.push([80,100])
                        break
                    case 'half':
                        fuelLevelRanges.push([50,79])
                        break
                    case 'low':
                        fuelLevelRanges.push([16,49])
                        break
                    case 'critical':
                        fuelLevelRanges.push([0,15])
                        break
                }
            })

            return FiltersRequestParamFactory.createVehicleFuelLevelFilter(fuelLevelRanges)
        }

        // function isVehicleInExternalStatusFilter(vehicle) {

        //     var selectedStatuses = filters.vehicleExternalStatusLocal.selected

        //     return selectedStatuses.length == 0
        //         || selectedStatuses.some(
        //             function(status){
        //                 var isInExternalStatus = false

        //                 for (var externalStatusName in vehicle.external_status) {
        //                     isInExternalStatus = isInExternalStatus || (status == externalStatusName && vehicle.external_status[externalStatusName])
        //                 }
        //                 return isInExternalStatus
        //             })
        // }

        function searchVehicleWithExternalStatusFilter(){
            var selectedStatuses = filters.vehicleExternalStatus.selected

            if(!selectedStatuses){
                return {}
            }

            return FiltersRequestParamFactory.createVehicleExternalStatusFilter(selectedStatuses)
        }

        // function isVehicleInStatusFilter(vehicle) {

        //     var selectedStatuses = filters.vehicleStatusLocal.selected

        //     return selectedStatuses.length == 0
        //         || selectedStatuses.some(
        //             function (status) {
        //                 return (status == vehicle.status)
        //             })
        // }

        function searchVehicleWithStatusFilter(){
            var selectedStatuses = filters.vehicleStatus.selected
            
            if(!selectedStatuses){
                return {}
            }

            return FiltersRequestParamFactory.createVehicleStatusFilter(selectedStatuses)
        }

        function searchVehicleWithId(){
            var selectedValue = filters.vehicleId.selected
            if(selectedValue == null){
                return {}
            }
            if(typeof selectedValue !== "number"){
                selectedValue = parseInt(selectedValue)
            }
            return FiltersRequestParamFactory.createVehicleWithIdFilter(selectedValue)
        }

        function searchVehicleWithReferenceCode(){
            var selectedValue = filters.vehicleReferenceCode.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createVehicleWithReferenceCodeFilter(selectedValue)
        }

        function searchVehicleWithLicensePlate(){
            var selectedValue = filters.vehicleLicensePlate.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createVehicleWithLicensePlateFilter(selectedValue)
        }

        function searchVehicleWithOnline(){
            var selectedValue = filters.vehicleOnline.selected

            if(typeof selectedValue !== "boolean"){
                return {}
            }
            return FiltersRequestParamFactory.createVehicleInOnlineStatusFilter(selectedValue)
        }

        function searchVehicleWithCurrentUser(){
            var selectedValue = filters.vehicleCurrentUser.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createVehicleWithCurrentUserFilter(selectedValue)
        }

        function searchVehicleWithLastMovedDate(){
            var selectedValue = filters.vehicleLastMovedDate.selected
            if(typeof selectedValue !== "number"){
                return {}
            }
            return FiltersRequestParamFactory.createVehicleWithLastMovedDateFilter(selectedValue)
        }

        function searchVehicleWithBrand(){
            var selectedValue = filters.vehicleBrand.selected
            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createVehicleWithBrandFilter(selectedValue)
        }

        function searchVehicleWithModelName(){
            var selectedValue = filters.vehicleModelName.selected
            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createVehicleWithModelNameFilter(selectedValue)
        }

        function getValueFromName(name, collection) {
            var value = null
            if(!collection){
                console.warn("getValueFromName: invalid input",name,collection)
                return value
            }
            name = name.toLowerCase()
            
            for(var key in collection){
                var obj = collection[key]
                if(obj.name.toLowerCase().indexOf(name) === 0){
                    value = obj.value
                    break
                }
            }
            return value
        }

        function searchVehicleWithType(){
            var selectedValues = filters.vehicleType.selected
            
            if(!selectedValues){
                return {}
            }
            
            // selectedValue = getValueFromName(selectedValue,VehicleTypes)
            
            // if(typeof selectedValue === "undefined" || selectedValue === null){
            //     SweetAlert.swal("Search query","The query inserted is invalid!","error")
            //     return {}
            // }
            return FiltersRequestParamFactory.createVehicleWithTypeFilter(selectedValues)
        }

        function searchVehicleWithDeviceType(){
            var selectedValues = filters.vehicleDeviceType.selected
            
            if(!selectedValues){
                return {}
            }

            return FiltersRequestParamFactory.createVehicleWithDeviceTypeFilter(selectedValues)
        }

        function searchVehicleWithinBoundingBox(){
            var selectedValues = filters.vehicleBoundingBox.selected
            
            if(selectedValues[0] == null || selectedValues[1] == null){
                return {}
            }

            const nortWestPoint = selectedValues[0].trim().split(",")
            const southEstPoint = selectedValues[1].trim().split(",")
            const latitudeRange = [Math.min(Number(nortWestPoint[0]),Number(southEstPoint[0])),Math.max(Number(nortWestPoint[0]),Number(southEstPoint[0]))]
            const longitudeRange = [Math.min(Number(nortWestPoint[1]),Number(southEstPoint[1])),Math.max(Number(nortWestPoint[1]),Number(southEstPoint[1]))]
            
            if(latitudeRange.includes(NaN) || longitudeRange.includes(NaN)){
                ErrorUtility.showErrorMessage({title:'Filtering Error', description:'Invalid bounding box'})
                return {}
            }
            return FiltersRequestParamFactory.createVehicleWithinBoundingBoxFilter({latitudeRange: latitudeRange, longitudeRange: longitudeRange})
        }

        function searchVehicleWithHidden(){
            var selectedValue = filters.vehicleHidden.selected

            if(typeof selectedValue !== "boolean"){
                return {}
            }
            return FiltersRequestParamFactory.createVehicleWithHiddenFilter(selectedValue)
        }
        
        function searchCouponWithCode(){
            var selectedValue = filters.couponCode.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createCouponWithCodeFilter(selectedValue)
        }

        function searchUserRegistrationWithRange(){
            var selectedValue = filters.userRegistrationDateRange.selected

            var selectedStartValue = selectedValue[0]
            var selectedEndValue = selectedValue[1]
            if(selectedValue[0] == null || selectedValue[1] == null){
                return {}
            }
            
            const dateRangeMillisec = convertDateRangeToMillisec(selectedStartValue,selectedEndValue)

            if(dateRangeMillisec == null){
                return {}
            }
            
            return FiltersRequestParamFactory.createSelfDateRangeFilter([dateRangeMillisec.start,dateRangeMillisec.end])
        }

        function searchDamageReportsWithRange(){
            var selectedValue = filters.damageReportDateRange.selected

            var selectedStartValue = selectedValue[0]
            var selectedEndValue = selectedValue[1]
            if(selectedValue[0] == null || selectedValue[1] == null){
                return {}
            }
            
            const dateRangeMillisec = convertDateRangeToMillisec(selectedStartValue,selectedEndValue)

            if(dateRangeMillisec == null){
                return {}
            }
            
            return FiltersRequestParamFactory.createSelfDateRangeFilter([dateRangeMillisec.start, dateRangeMillisec.end])
        }

        function searchCouponWithRange(){
            var selectedValue = filters.couponRange.selected

            var selectedStartValue = selectedValue[0]
            var selectedEndValue = selectedValue[1]
            if(selectedValue[0] == null || selectedValue[1] == null){
                return {}
            }
            
            const dateRangeMillisec = convertDateRangeToMillisec(selectedStartValue,selectedEndValue)

            if(dateRangeMillisec == null){
                return {}
            }
            
            return FiltersRequestParamFactory.createCouponWithRangeFilter([dateRangeMillisec.start, dateRangeMillisec.end])
        }

        function searchCouponWithUnlimitedFinish(){
            var selectedValue = filters.couponUnlimitedFinish.selected

            if(typeof selectedValue !== "boolean"){
                return {}
            }
            
            return FiltersRequestParamFactory.createCouponWithUnlimitedFinishFilter(selectedValue)
        }

        function searchCouponWithCreationDate(){
            var selectedValue = filters.couponCreation.selected
            if(selectedValue[0] == null || selectedValue[1] == null){
                return {}
            }
            const dateRangeMillisec = convertDateRangeToMillisec(selectedValue[0],selectedValue[1])
            
            if(dateRangeMillisec == null){
                return {}
            }

            return FiltersRequestParamFactory.createSelfDateRangeFilter([dateRangeMillisec.start, dateRangeMillisec.end])
        }

        function searchTripWithId(){
            var selectedValue = filters.tripId.selected
            if(selectedValue == null){
                return {}
            }
            if(typeof selectedValue !== "number"){
                selectedValue = parseInt(selectedValue)
            }
            return FiltersRequestParamFactory.createTripWithIdFilter(selectedValue)
        }

        function searchTripWithVehicleId(){
            var selectedValue = filters.tripVehicleId.selected
            if(selectedValue == null){
                return {}
            }
            if(typeof selectedValue !== "number"){
                selectedValue = parseInt(selectedValue)
            }
            return FiltersRequestParamFactory.createTripWithVehicleIdFilter(selectedValue)
        }

        function searchTripWithVehicleLicensePlate(){
            var selectedValue = filters.tripVehicleLicensePlate.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createTripWithVehicleLicensePlateFilter(selectedValue)
        }

        function searchTripWithVehicleReferenceCode(){
            var selectedValue = filters.tripVehicleReferenceCode.selected
            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createTripWithVehicleReferenceCodeFilter(selectedValue)
        }

        function searchTripWithVehicleType(){
            var selectedValues = filters.tripVehicleType.selected
            // if(typeof selectedValue !== "string" || selectedValue == ''){
            //     return {}
            // }

            if(!selectedValues){
                return {}
            }

            return FiltersRequestParamFactory.createInnerVehicleWithTypesFilter(selectedValues)
        }

        function searchTripWithDeviceType(){
            var selectedValues = filters.tripDeviceType.selected
            
            if(!selectedValues){
                return {}
            }
            
            return FiltersRequestParamFactory.createInnerVehicleWithDeviceTypesFilter(selectedValues)
        }

        function searchTripWithStatus(){
            var selectedValue = filters.tripStatus.selected
            
            //cause 0 as number not valid option in select

            if(typeof selectedValue == "string"){
                selectedValue = parseInt(selectedValue)
                if(!(selectedValue>=0)){
                    return {}
                }
            }
            else if(typeof selectedValue !== "number"){
                return {}
            }
            
            return FiltersRequestParamFactory.createTripWithStatusFilter(selectedValue)
        }

        function convertDateRangeToMillisec(startDate,endDate){
            const siteId = SitesService.getSelectedSite()
            
            if(siteId == undefined || siteId == null){
                ErrorUtility.showErrorMessage({title:'Filtering Error',description:'Invalid selected site'})
                return null
            }
            var newStartDate = null
            var newEndDate = null

            if(siteId !== DefaultSite.id) {
                // when the site is not defaultSite use the active service settings.
                newStartDate = MiscUtility.shiftJstoMoment(startDate,siteId)
                newEndDate = MiscUtility.shiftJstoMoment(endDate,siteId)

            } else {
                // use browser timezone
                console.warn("convertDateRangeToMillisec: default site selected use browser timezone")
                newStartDate = moment(startDate)
                newEndDate = moment(endDate)
            }
            
            if(newStartDate == null || newEndDate == null){
                ErrorUtility.showErrorMessage({title:'Filtering Error',description:'Invalid timezone for the selected site'})
                return null
            }

            newStartDate = newStartDate.startOf('day')
            newEndDate = newEndDate.endOf('day')

            return {
                start: newStartDate.valueOf(),
                end: newEndDate.valueOf()
            }
        }

        function searchTripWithDateRange() {
            var selectedValue = filters.tripDateRange.selected

            var selectedStartValue = selectedValue[0]
            var selectedEndValue = selectedValue[1]
            if(selectedValue[0] == null || selectedValue[1] == null){
                return {}
            }
            
            const dateRangeMillisec = convertDateRangeToMillisec(selectedStartValue,selectedEndValue)

            if(dateRangeMillisec == null){
                return {}
            }
            
            return FiltersRequestParamFactory.createSelfDateRangeFilter([dateRangeMillisec.start,dateRangeMillisec.end])
        }

        function searchTripWithDateEnd(){ 
            var selectedStartValue = filters.tripDateStart.selected
            var selectedEndValue = filters.tripDateEnd.selected

            if(typeof selectedStartValue === "undefined" || selectedStartValue == null || typeof selectedEndValue === "undefined" || selectedEndValue == null){
                return {}
            }
            const dateRangeMillisec = convertDateRangeToMillisec(selectedStartValue,selectedEndValue)

            if(dateRangeMillisec == null){
                return {}
            }

            return FiltersRequestParamFactory.createSelfDateRangeFilter([dateRangeMillisec.start,dateRangeMillisec.end])
        }

        function searchTripWithUser(){
            var selectedValue = filters.tripUser.selected
            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createTripWithUserFilter(selectedValue)
        }

        function searchTripWithUserId(){
            
            var selectedValue = filters.tripUserId.selected
            
            if(selectedValue == null){
                return {}
            }
            
            if(typeof selectedValue !== "number"){
                selectedValue = parseInt(selectedValue)
            }

            return FiltersRequestParamFactory.createTripWithUserIdFilter(selectedValue)
        }

        function searchUserWithStatus(){
            var selectedStatus = filters.userStatus.selected
            if(selectedStatus == null || selectedStatus == ''){//erase selection return ''
                return {}
            }

            //check if number value (now do it in initFilters)
            /*selectedStatuses = selectedStatuses.map(function(status){
                if(typeof status == "string"){
                    status = parseInt(status)
                }
                return status
            })*/

            return FiltersRequestParamFactory.createUserWithStatusFilter([selectedStatus])
        }

        function searchUserWithLastPaymentStatus(){
            var selectedStatuses = filters.userLastPaymentStatus.selected

            return FiltersRequestParamFactory.createUserWithLastPaymentStatusFilter(selectedStatuses)
        }

        function searchUserWithId(){
            var selectedValue = filters.userId.selected
            if(selectedValue == null){
                return {}
            }
            if(typeof selectedValue !== "number"){
                selectedValue = parseInt(selectedValue)
            }
            return FiltersRequestParamFactory.createUserWithIdFilter(selectedValue)
        }

        function searchUserWithFullName(){
            var selectedValue = filters.userFullName.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }

            return FiltersRequestParamFactory.createUserWithFullNameFilter(selectedValue)
        }

        function searchUserWithEmail(){
            var selectedValue = filters.userEmail.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }

            return FiltersRequestParamFactory.createUserWithEmailFilter(selectedValue)
        }

        function searchUserWithPhoneNumber(){
            var selectedValue = filters.userPhoneNumber.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }

            return FiltersRequestParamFactory.createUserWithPhoneNumberFilter(selectedValue)
        }

        function searchReportById() {
            var selectedValue = filters.reportId.selected
            if(!selectedValue){
                return {}
            }
            
            return FiltersRequestParamFactory.createReportByIdFilter(selectedValue)
        }
        function searchReportByVehicleId() {
            var selectedValue = filters.reportVehicleId.selected

            if(typeof selectedValue === "undefined" || selectedValue == null){
                return {}
            }

            return FiltersRequestParamFactory.createReportByVehicleIdFilter(selectedValue)
        }

        function searchReportByVehicleType() {
            var selectedValues = filters.reportVehicleType.selected
            
            if(!selectedValues){
                return {}
            }

            return FiltersRequestParamFactory.createInnerVehicleWithTypesFilter(selectedValues)
        }

        function searchReportByDeviceType() {
            var selectedValues = filters.reportDeviceType.selected
            
            if(!selectedValues){
                return {}
            }

            return FiltersRequestParamFactory.createInnerVehicleWithDeviceTypesFilter(selectedValues)
        }

        function searchReportByUserId() {
            var selectedValue = filters.reportUserId.selected

            if(typeof selectedValue === "undefined" || selectedValue == null){
                return {}
            }

            return FiltersRequestParamFactory.createReportByUserIdFilter(selectedValue)
        }

        function searchDamageReportWithDateEnd(){
            var selectedStartValue = filters.reportDateStart.selected
            var selectedEndValue = filters.reportDateEnd.selected

            if(typeof selectedStartValue === "undefined" || selectedStartValue == null || typeof selectedEndValue === "undefined" || selectedEndValue == null){
                return {}
            }

            const dateRangeMillisec = convertDateRangeToMillisec(selectedStartValue,selectedEndValue)

            if(dateRangeMillisec == null){
                return {}
            }

            return FiltersRequestParamFactory.createSelfDateRangeFilter([dateRangeMillisec.start, dateRangeMillisec.end])
        }

        function searchInvoiceWithType(){
            var selectedValue = filters.invoiceType.selected

            if(selectedValue == null){
                return {}
            }
            //cause 0 as number not valid option in select
            if(typeof selectedValue == "string"){
                selectedValue = parseInt(selectedValue)
                if(!(selectedValue>=0)){
                    return {}
                }
            }else if(typeof selectedValue != "number"){
                return {}
            }

            return FiltersRequestParamFactory.createInvoiceWithTypeFilter(selectedValue)
        }

        function searchInvoiceWithStatus(){
            var selectedValue = filters.invoiceStatus.selected
            if(selectedValue == null){
                return {}
            }
            //cause 0 as number not valid option in select
            if(typeof selectedValue == "string"){
                selectedValue = parseInt(selectedValue)
                if(!(selectedValue>=0)){
                    return {}
                }
            }else if(typeof selectedValue != "number"){
                return {}
            }

            return FiltersRequestParamFactory.createInvoiceWithStatusFilter(selectedValue)
        }

        function searchInvoiceWithDateRange(){
            var selectedValue = filters.invoiceDateRange.selected

            var selectedStartValue = selectedValue[0]
            var selectedEndValue = selectedValue[1]
            if(selectedValue[0] == null || selectedValue[1] == null){
                return {}
            }
            
            const dateRangeMillisec = convertDateRangeToMillisec(selectedStartValue,selectedEndValue)

            if(dateRangeMillisec == null){
                return {}
            }
            
            return FiltersRequestParamFactory.createSelfDateRangeFilter([dateRangeMillisec.start,dateRangeMillisec.end])
        }

        function searchInvoiceWithDateEnd(){
            var selectedStartValue = filters.invoiceDateStart.selected
            var selectedEndValue = filters.invoiceDateEnd.selected

            if(typeof selectedStartValue === "undefined" || selectedStartValue == null || typeof selectedEndValue === "undefined" || selectedEndValue == null){
                return {}
            }
            const dateRangeMillisec = convertDateRangeToMillisec(selectedStartValue,selectedEndValue)

            if(dateRangeMillisec == null){
                return {}
            }

            return FiltersRequestParamFactory.createSelfDateRangeFilter([dateRangeMillisec.start,dateRangeMillisec.end])
        }

        function searchInvoiceWithCode(){
            var selectedValue = filters.invoiceCode.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }

            return FiltersRequestParamFactory.createInvoiceWithCodeFilter(selectedValue)
        }

        function searchInvoiceWithUser(){
            var selectedValue = filters.invoiceUser.selected

            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }

            return FiltersRequestParamFactory.createInvoiceWithUserFilter(selectedValue)
        }

        function searchInvoiceWithUserId(){
            
            var selectedValue = filters.invoiceUserId.selected
            
            if(selectedValue == null){
                return {}
            }
            
            if(typeof selectedValue !== "number"){
                selectedValue = parseInt(selectedValue)
            }

            return FiltersRequestParamFactory.createInvoiceWithUserIdFilter(selectedValue)
        }

        function searchDeviceWithId(){
            
            var selectedValue = filters.deviceId.selected
            
            if(selectedValue == null){
                return {}
            }
            
            if(typeof selectedValue !== "number"){
                selectedValue = parseInt(selectedValue)
            }

            return FiltersRequestParamFactory.createDeviceWithIdFilter(selectedValue)
        }

        function searchDeviceWithCode(){
            
            var selectedValue = filters.deviceCode.selected
            
            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }

            return FiltersRequestParamFactory.createDeviceWithCodeFilter(selectedValue)
        }

        function searchDeviceWithVersion(){
            
            var selectedValue = filters.deviceVersion.selected
            
            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }

            return FiltersRequestParamFactory.createDeviceWithVersionFilter(selectedValue)
        }

        function searchDeviceWithOnline(){
            var selectedValue = filters.deviceOnline.selected

            if(typeof selectedValue !== "boolean"){
                return {}
            }
            return FiltersRequestParamFactory.createDeviceWithOnlineStatusFilter(selectedValue)
        }

        function searchDeviceWithVehicleId(){
            var selectedValue = filters.deviceVehicleId.selected

            if(selectedValue == null){
                return {}
            }
            
            if(typeof selectedValue !== "number"){
                selectedValue = parseInt(selectedValue)
            }
            return FiltersRequestParamFactory.createDeviceWithVehicleIdFilter(selectedValue)
        }

        function searchDeviceWithVehicleReferenceCode(){
            var selectedValue = filters.deviceVehicleReferenceCode.selected
            
            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createDeviceWithVehicleReferenceCodeFilter(selectedValue)
        }

        function searchDeviceWithVehicleLicensePlate(){
            var selectedValue = filters.deviceVehicleLicensePlate.selected
            
            if(typeof selectedValue !== "string" || selectedValue == ''){
                return {}
            }
            return FiltersRequestParamFactory.createDeviceWithVehicleLicensePlateFilter(selectedValue)
        }

        function searchDeviceWithAssignedVehicle(){
            var selectedValue = filters.deviceAssignedVehicle.selected

            if(typeof selectedValue !== "boolean"){
                return {}
            }
            return FiltersRequestParamFactory.createDeviceWithAssignedVehicleFilter(selectedValue)
        }

        function isAfilterSelected(){
            var isAfilterSelected = false
            for (var filterKey in filters) {
                var filter = filters[filterKey]
                //console.log(filter.selected)
                if(typeof filter.selected === "number"){
                    isAfilterSelected = true
                }
                else if(typeof filter.selected === "boolean"){
                    isAfilterSelected = true
                }
                else if( filter.selected instanceof Date){
                    isAfilterSelected = true
                }
                else if (filter.selected && filter.selected.length > 0) {
                    isAfilterSelected = true
                }
            }
            return isAfilterSelected
        }

        returnFiltersObj = Object.assign(returnFiltersObj, {
            // createMiscStatusLocalFilter:function(){
            //     filters.miscStatusLocal.selected = []
            //     return filters.miscStatusLocal
            // },
            createMiscStatusFilter : function(){
                filters.miscStatus.selected = []
                return filters.miscStatus
            },
            // createBatteryStatusLocalFilter : function(){
            //     filters.batteryStatusLocal.selected = []
            //     return filters.batteryStatusLocal
            // },
            createBatteryStatusFilter : function(){
                filters.batteryStatus.selected = []
                return filters.batteryStatus
            },
            createFuelLevelStatusLocalFilter : function(){
                filters.fuelLevelStatusLocal.selected = []
                return filters.fuelLevelStatusLocal
            },
            createFuelLevelStatusFilter : function(){
                filters.fuelLevelStatus.selected = []
                return filters.fuelLevelStatus
            },
            // createVehicleExternalStatusLocalFilter:function(){
            //     filters.vehicleExternalStatusLocal.selected = []
            //     return filters.vehicleExternalStatusLocal
            // },
            createVehicleExternalStatusFilter : function(){
                filters.vehicleExternalStatus.selected = []
                return filters.vehicleExternalStatus
            },
            // createVehicleStatusLocalFilter:function(){
            //     filters.vehicleStatusLocal.selected = []
            //     return filters.vehicleStatusLocal
            // },
            createVehicleStatusFilter : function(){
                filters.vehicleStatus.selected = []
                return filters.vehicleStatus
            },
            createVehicleWithReferenceCodeFilter: function(){
                filters.vehicleReferenceCode.selected = null
                return filters.vehicleReferenceCode
            },
            createVehicleWithIdFilter: function(){
                filters.vehicleId.selected = null
                return filters.vehicleId
            },
            createVehicleWithLicensePlateFilter: function(){
                filters.vehicleLicensePlate.selected = null
                return filters.vehicleLicensePlate
            },
            createVehicleWithOnlineFilter: function(){
                filters.vehicleOnline.selected = null
                return filters.vehicleOnline
            },
            createVehicleWithCurrentUserFilter: function(){
                filters.vehicleCurrentUser.selected = null
                return filters.vehicleCurrentUser
            },
            createVehicleWithLastMovedDateFilter: function(){
                filters.vehicleLastMovedDate.selected = null
                return filters.vehicleLastMovedDate
            },
            createVehicleWithBrandFilter: function(){
                filters.vehicleBrand.selected = null
                return filters.vehicleBrand
            },
            createVehicleWithModelNameFilter: function(){
                filters.vehicleModelName.selected = null
                return filters.vehicleModelName
            },
            createVehicleWithTypeFilter: function(){
                filters.vehicleType.selected = []
                return filters.vehicleType
            },
            createVehicleWithDeviceTypeFilter: function(){
                filters.vehicleDeviceType.selected = []
                return filters.vehicleDeviceType
            },
            createVehicleWithinBoundingBoxFilter: function(){
                filters.vehicleBoundingBox.selected = [null,null]
                return filters.vehicleBoundingBox
            },
            createVehicleWithHiddenFilter: function(){
                filters.vehicleHidden.selected = null
                return filters.vehicleHidden
            },
            createCouponWithCodeFilter: function(){
                filters.couponCode.selected = null
                return filters.couponCode
            },
            createCouponWithRangeFilter: function(){
                filters.couponRange.selected = [null, null]
                return filters.couponRange
            },
            createCouponWithUnlimitedFinishFilter: function(){
                filters.couponUnlimitedFinish.selected = null
                return filters.couponUnlimitedFinish
            },
            createCouponWithCreatedAtFilter: function(){
                filters.couponCreation.selected = [null, null]
                return filters.couponCreation
            },
            createTripWithIdFilter:function(){
                filters.tripId.selected = null
                return filters.tripId
            },
            createTripWithDatesRangeFilter: function(){
                filters.tripDateRange.selected = [null, null]
                return filters.tripDateRange
            },
            createTripWithStatusFilter: function(){
                filters.tripStatus.selected = null
                return filters.tripStatus
            },
            createTripWithStartDateFilter:function(){
                filters.tripDateStart.selected = null
                return filters.tripDateStart
            },
            createTripWithEndDateFilter:function(){
                filters.tripDateEnd.selected = null
                return filters.tripDateEnd
            },
            createTripWithUserFilter:function(){
                filters.tripUser.selected = null
                return filters.tripUser
            },
            createTripWithUserIdFilter:function(){
                filters.tripUserId.selected = null
                return filters.tripUserId
            },
            createTripWithVehicleIdFilter: function(){
                filters.tripVehicleId.selected = null
                return filters.tripVehicleId
            },
            createTripWithVehicleLicensePlateFilter:function(){
                filters.tripVehicleLicensePlate.selected = null
                return filters.tripVehicleLicensePlate
            },
            createTripWithVehicleReferenceCodeFilter: function(){
                filters.tripVehicleReferenceCode.selected = null
                return filters.tripVehicleReferenceCode
            },
            createTripWithVehicleTypeFilter: function(){
                filters.tripVehicleType.selected = []
                return filters.tripVehicleType
            },
            createTripWithDeviceTypeFilter: function(){
                filters.tripDeviceType.selected = []
                return filters.tripDeviceType
            },
            createUserWithStatusFilter:function(){
                filters.userStatus.selected = []
                return filters.userStatus
            },
            createUserWithLastPaymentStatusFilter:function(){
                filters.userLastPaymentStatus.selected = []
                return filters.userLastPaymentStatus
            },
            createUserWithIdFilter:function(){
                filters.userId.selected = null
                return filters.userId
            },
            createUserWithFullNameFilter:function(){
                filters.userFullName.selected = null
                return filters.userFullName
            },
            createUserWithEmailFilter:function(){
                filters.userEmail.selected = null
                return filters.userEmail
            },
            createUserWithPhoneNumberFilter:function(){
                filters.userPhoneNumber.selected = null
                return filters.userPhoneNumber
            },
            createUserWithRegistrationDateRangeFilter:function(){
                filters.userRegistrationDateRange.selected = [null,null]
                return filters.userRegistrationDateRange
            },
            createDamageReportWithDateRangeFilter: function(){
                filters.damageReportDateRange.selected = [null, null]
                return filters.damageReportDateRange;
            },
            createReportWithId:function(){
                filters.reportId.selected = null
                return filters.reportId
            },
            createReportWithVehicleIdFilter:function(){
                filters.reportVehicleId.selected = null
                return filters.reportVehicleId
            },
            createReportWithVehicleTypeFilter:function(){
                filters.reportVehicleType.selected = []
                return filters.reportVehicleType
            },
            createReportWithDeviceTypeFilter:function(){
                filters.reportDeviceType.selected = []
                return filters.reportDeviceType
            },
            createReportUserId:function(){
                filters.reportUserId.selected = null
                return filters.reportUserId
            },
            createDamageReportWithDateStartFilter:function(){
                filters.reportDateStart.selected = null
                return filters.reportDateStart
            },
            createDamageReportWithDateEndFilter:function(){
                filters.reportDateEnd.selected = null
                return filters.reportDateEnd
            },
            createInvoiceWithTypeFilter:function(){
                filters.invoiceType.selected = null
                return filters.invoiceType
            },
            createInvoiceWithStatusFilter:function(){
                filters.invoiceStatus.selected = null
                return filters.invoiceStatus
            },
            createInvoiceWithDateStartFilter:function(){
                filters.invoiceDateStart.selected = null
                return filters.invoiceDateStart
            },
            createInvoiceWithDateRangeFilter:function(){
                filters.invoiceDateRange.selected = [null,null]
                return filters.invoiceDateRange
            },
            createInvoiceWithDateEndFilter:function(){
                filters.invoiceDateEnd.selected = null
                return filters.invoiceDateEnd
            },
            createInvoiceWithCodeFilter:function(){
                filters.invoiceCode.selected = null
                return filters.invoiceCode
            },
            createInvoiceWithUserFilter:function(){
                filters.invoiceUser.selected = null
                return filters.invoiceUser
            },
            createInvoiceWithUserIdFilter:function(){
                filters.invoiceUserId.selected = null
                return filters.invoiceUserId
            },
            createDeviceWithIdFilter:function(){
                filters.deviceId.selected = null
                return filters.deviceId
            },
            createDeviceWithCodeFilter:function(){
                filters.deviceCode.selected = null
                return filters.deviceCode
            },
            createDeviceWithVersionFilter:function(){
                filters.deviceVersion.selected = null
                return filters.deviceVersion
            },
            createDeviceWithOnlineFilter:function(){
                filters.deviceOnline.selected = null
                return filters.deviceOnline
            },
            createDeviceWithVehicleIdFilter:function(){
                filters.deviceVehicleId.selected = null
                return filters.deviceVehicleId
            },
            createDeviceWithVehicleReferenceCodeFilter:function(){
                filters.deviceVehicleReferenceCode.selected = null
                return filters.deviceVehicleReferenceCode
            },
            createDeviceWithVehicleLicensePlateFilter:function(){
                filters.deviceVehicleLicensePlate.selected = null
                return filters.deviceVehicleLicensePlate
            },
            createDeviceWithAssignedVehicleFilter:function(){
                filters.deviceAssignedVehicle.selected = null
                return filters.deviceAssignedVehicle
            },
            getFilterObj:function(filterKey){
                return filters[filterKey]
            },
            getFilterByName: function(name) {
                for(var key in filters) {
                    if(filters[key].hasOwnProperty('name') &&  filters[key].name === name) {
                        return filters[key]
                    }
                }
                return null
            },
            isAfilterSelected: isAfilterSelected
        });
        
        return returnFiltersObj;
    }

    /** @ngInject */
    function TripUtilityFactory(VehicleTripStatus,VehicleBookingStatus,ServiceSettings) {
        function calculateTripTotalKm(trip) {
            var totalKm = 0
            var startTripKm = 0
            var finishTripKm = 0

            if(trip.StartPosition && trip.FinishPosition){
                startTripKm = trip.StartPosition.km ? trip.StartPosition.km : 0
                finishTripKm = trip.FinishPosition.km ? trip.FinishPosition.km : 0
                totalKm = parseInt(finishTripKm - startTripKm)
            }

            return totalKm
        }

        function calculateTripDuration(trip) {
            var duration = 0

            if(trip.end > trip.start)
                duration = parseInt((trip.end - trip.start)/60000)

            return duration
        }

        function getTripStatusDescription(trip){

            function getTripStatusDescr(statusSearched){
                var descr = ''
                for( var statusKey in VehicleTripStatus){
                    if(VehicleTripStatus[statusKey].value == statusSearched){
                        descr = VehicleTripStatus[statusKey].name
                        break;
                    }
                }
                return descr
            }

            var descr = 'Error'
            if (trip.Booking !== undefined && trip.Booking !== null){
                //if booking status is not finished use vehicle trip status
                if(trip.Booking.status ? (trip.Booking.status != VehicleBookingStatus.FINISHED.value) : false){
                    descr = getTripStatusDescr(trip.Vehicle.trip_status)
                }
                else{
                    descr = VehicleBookingStatus.FINISHED.name
                }
            }
            else{
                descr = trip.Vehicle ? getTripStatusDescr(trip.Vehicle.trip_status) : descr
            }
            return descr
        }

        function isVehicleHangedToTrip(trip){
            return ServiceSettings.getServiceSettings(function(settings){
                // FIXME: fix wrong get timezone
                const timezone = settings && settings.timezone;
                var hanged = false
                if(!trip){
                    console.warn("isVehicleHangedAtThisTrip, trip undefined",trip)
                }
    
                if(trip.FinishPosition){
                    if(trip.Booking && (trip.Booking.status == VehicleBookingStatus.STARTED.value)){
                        if( (moment.tz(timezone).valueOf() - (moment(trip.Booking.updated_at).tz(timezone).valueOf()) ) >= 3*60*1000 ){
                            hanged = true
                        }
                    }
                }
                return hanged
            });
        }

        return {
            calculateTripTotalKm: calculateTripTotalKm,
            calculateTripDuration: calculateTripDuration,
            getTripStatusDescription: getTripStatusDescription,
            isVehicleHangedToTrip: isVehicleHangedToTrip
        }
    }

    /** @ngInject */
    function UserUtilityFactory(UserLicenseStatus,UserDocumentStatus,UserPaymentStatus,UserStatus,ClientType, MiscUtility) {

        function getUserLicenseStatusDescription(user){
            var statusValue = -1
            var descr = ""
            if(user){
                for(var status in UserLicenseStatus){

                    statusValue = UserLicenseStatus[status].value

                    if(user.validLicensePlate == statusValue){
                        descr = UserLicenseStatus[status].name
                    }
                }
            }
            return descr
        }

        function getUserDocumentStatusDescription(user){
            var statusValue = -1
            var descr = ""
            if(user){
                for(var status in UserDocumentStatus){

                    statusValue = UserDocumentStatus[status].value

                    if(user.validDocument == statusValue){
                        descr = UserDocumentStatus[status].name
                        break
                    }
                }
            }
            return descr
        }

        function getUserPaymentStatusDescription(user) {
            var statusValue = -1
            var descr = ""
            if(user){
                for (var status in UserPaymentStatus) {

                    statusValue = UserPaymentStatus[status].value

                    if (user.lastPaymentStatus == statusValue) {
                        descr = UserPaymentStatus[status].name
                        break
                    }
                }
            }

            //descr = descr ? descr : UserPaymentStatus.ERROR.name
            return descr
        }

        function getUserStatusDescription(user) {
            var statusValue = -1
            var descr = ""
            if(user){

                for (var status in UserStatus) {

                    statusValue = UserStatus[status].value

                    if (user.status == statusValue) {
                        descr = UserStatus[status].name
                        break
                    }
                }
            }
            return descr
        }

        function generateUserFullName(user){
            
            if(!user){
                console.warn("UserUtility.generateUserFullName : invalid input user",user)
            }
            
            user.fullName = (user.name ? user.name : '') + (user.surname ? ' '+user.surname : '')
            if(user.fullName == '')
                user.fullName = user.id

        }

        function generateUserStatus(user){
            if(!user){
                console.warn("UserUtility.generateUserStatus : invalid input user",user)
            }

            //prevent empty status
            user.status = (user.status === undefined || user.status === null) ? UserStatus.INCOMPLETE_SIGN_UP.value : user.status
            user.oldStatus = user.status
            user.oldStatusHuman = getUserStatusDescription(user)

            //check to support old users
            if(user.status !== UserStatus.ACTIVATED_USER.value){  
                if(user.block){
                    user.status = UserStatus.BLOCKED_USER.value
                }
                else if(!user.paymentCreated){
                    user.status = UserStatus.MISSING_PAYMENT.value
                } else if(
                    user.validDocument === UserDocumentStatus.NOT_VALID.value ||
                    user.validDocument === UserDocumentStatus.REJECTED.value
                ){
                    //case user not uploaded the ID or is revoked or rejected
                    user.status = UserStatus.MISSING_ID.value
                } else if(
                    //case user not uploaded the DL or is revoked or rejected
                    user.validLicensePlate === UserLicenseStatus.NOT_VALID.value ||
                    user.validLicensePlate === UserLicenseStatus.REJECTED.value    
                ){
                    user.status = UserStatus.MISSING_DRIVING_LICENSE.value
                } else if(
                    //case user not uploaded the selfie
                    user.Avatar === null ||
                    user.Avatar === undefined || 
                    user.Avatar.length === 0
                ){
                    user.status = UserStatus.MISSING_AVATAR.value
                } else if(
                    user.validDocument === UserDocumentStatus.WAITING_FOR_APPROVAL.value ||
                    user.validLicensePlate === UserLicenseStatus.WAITING_FOR_APPROVAL.value
                ){
                    //case user uploaded ID and DL
                    user.status = UserStatus.VERIFICATION_PENDING.value
                }else{
                    user.status = UserStatus.ACTIVATED_USER.value
                }
            }

            user.statusHuman = getUserStatusDescription(user)
            user.clientTypeHuman = getClientTypeDescription(user)
        }

        function setUserAdditionalData(user,additionalData){
            if(!user || !additionalData){
                console.warn("setUserAdditional: no user additionalData")
                return
            }
            var userInfo = null
            var additionalInfo = null
            for(var infoKey in additionalData){
                userInfo = additionalData[infoKey]

                if(typeof userInfo !== "undefined" && userInfo !== null){
                    additionalInfo = userExtraInfoKeys.find(function(additionalInfo){
                        return additionalInfo.key == infoKey
                    })
                    // console.log("additionalInfo",additionalInfo)
                    if(additionalInfo){
                        user[additionalInfo.matchWith] = userInfo
                    }
                }          
            }

        }

        function generateUserAdditionalData(user){
            var userAdditionaData = {}
            
            if(typeof user === "undefined" || user === null){
                console.warn("generateUserAdditional: no user")
                return userAdditionaData
            }

            userExtraInfoKeys.forEach(function(additionalInfo){
                if(typeof user[additionalInfo.matchWith] !== "undefined" && user[additionalInfo.matchWith] !== null){
                    userAdditionaData[additionalInfo.key] = user[additionalInfo.matchWith]
                }
            })
            return userAdditionaData
        }

        function isAdminWithoutSite(user) {
            if(!user){
                console.warn("UserUtility.isAdminWithoutSite : invalid input", user)
                return false
            }

            return (user.role && user.role === "admin" && user.SiteId == null) || false
        }

        function getClientTypeDescription(user){
            if(!user){
                console.warn("UserUtility.getClientTypeDescription : invalid input", user)
                return ""
            }

            if(!user.createdBy || user.createdBy === ClientType.UNKNOWN.value){
                // console.warn("unknown", user, user.createdBy)
                return ClientType.UNKNOWN.name
            }
            var clientTypeObj = Object.values(ClientType).find(function(ct){
                // console.log(ct,user.createdBy,ct.value == user.createdBy)
                return ct.value == user.createdBy
            })
            
            return clientTypeObj.name || ""
        }

        function getUserFreeMinutes(user){

            if(!user){
                console.warn("UserUtility.getUserFreeMinutes : invalid input user",user)
                return
            }

            return Math.floor(user.freeMinutes) || 0
        }

        function getUserFreeCredit(user){
            const siteId = user.SiteId
            return MiscUtility.generateCreditValue(user.freeMilliseconds, siteId)
        }

        return {
            getUserLicenseStatusDescription: getUserLicenseStatusDescription,
            getUserDocumentStatusDescription: getUserDocumentStatusDescription,
            getUserPaymentStatusDescription: getUserPaymentStatusDescription,
            getUserStatusDescription: getUserStatusDescription,
            generateUserFullName: generateUserFullName,
            generateUserStatus: generateUserStatus,
            getUserFreeMinutes: getUserFreeMinutes,
            setUserAdditionalData: setUserAdditionalData,
            generateUserAdditionalData: generateUserAdditionalData,
            isAdminWithoutSite: isAdminWithoutSite,
            getUserFreeCredit: getUserFreeCredit
        }
    }

    /** @ngInject */
    function MaintenanceUtilityFactory(MaintenanceStatus,MaintenanceType,MaintenanceCategory) {

        function getMaintenanceStatusDescription(maintenance){
            var statusValue = -1
            var descr = ""
            for(var status in MaintenanceStatus){

                statusValue = MaintenanceStatus[status].value

                if(maintenance.status == statusValue){
                    descr = MaintenanceStatus[status].name
                    break
                }
            }
            return descr
        }

        function getMaintenanceTypeDescription(maintenance) {
            var statusValue = -1
            var descr = ""
            for(var status in MaintenanceType){

                statusValue = MaintenanceType[status].value

                if(maintenance.type == statusValue){
                    descr = MaintenanceType[status].name
                    break
                }
            }
            return descr
        }

        function getMaintenanceCategoryDescription(maintenance) {
            var statusValue = -1
            var descr = ""
            for(var status in MaintenanceCategory){

                statusValue = MaintenanceCategory[status].value

                if(maintenance.category == statusValue){
                    descr = MaintenanceCategory[status].name
                    break
                }
            }
            return descr
        }

        return {
            getMaintenanceStatusDescription:getMaintenanceStatusDescription,
            getMaintenanceTypeDescription:getMaintenanceTypeDescription,
            getMaintenanceCategoryDescription:getMaintenanceCategoryDescription
        }
    }

    /** @ngInject */
    function InvoiceUtilityFactory(InvoiceType,InvoiceStatus,InvoiceElementType,TransactionUtility,numberFilter) {

        function getInvoiceTypeDescription(invoice) {
            var statusValue = -1
            var descr = ""
            for(var status in InvoiceType){

                statusValue = InvoiceType[status].value

                if(invoice.type == statusValue){

                    descr = InvoiceType[status].name
                    break
                }
            }
            return descr
        }
        function getInvoiceStatusDescription(invoice) {
            var statusValue = -1
            var descr = ""
            for(var status in InvoiceStatus){

                statusValue = InvoiceStatus[status].value

                if(invoice.status == statusValue){

                    descr = InvoiceStatus[status].name
                    break
                }
            }
            return descr
        }

        function openPdf(invoice) {
            if (invoice.PDF[0]) {
                window.open(invoice.PDF[0].location, '_blank');
            } else {
                alert('No PDF avaiable');
            }
        };

        function getTransaction(invoice) {
            if (!invoice) {
                console.warn('InvoiceUtility.getTransaction: invalid iput', invoice);
                return null;
            }
            if (!invoice.elements) {
                console.warn('InvoiceUtility.getTransaction: invoice has no elements', invoice);
                return null;
            }

            // FIXME: actually the backend does not support multiple transaction for the same invoice.
            //      What if do we have this case?
            const transaction = invoice.elements.find(function (elem) {
                if (elem.type == InvoiceElementType.BOOKING) {
                    if (elem.Resource) {
                        if (elem.Resource.Transactions.length > 0) return elem.Resource.Transactions[0];
                    }
                } else if (elem.type == InvoiceElementType.MANUAL_TRANSACTION) {
                    if (elem.Resource) {
                        return elem.Resource;
                    }
                } else if (
                    elem.type == InvoiceElementType.LONG_TERM_BOOKING ||
                    elem.type == InvoiceElementType.SHOP_ORDER
                ) {
                    if (elem.Resource && elem.Resource.Transaction) {
                        return elem.Resource.Transaction;
                    }
                }
            });

            return transaction;
        }

        return {
            getInvoiceTypeDescription: getInvoiceTypeDescription,
            getInvoiceStatusDescription: getInvoiceStatusDescription,
            openPdf: openPdf,
            getTransaction: getTransaction,
        }
    }

    /** @ngInject */
    function TransactionUtilityFactory(UserPaymentStatus, TransactionTag){

        function getTransactionStatusDescription(transaction){
            var statusValue = -1
            var descr = "Unknown status"
            for(var status in UserPaymentStatus){

                statusValue = UserPaymentStatus[status].value

                if(transaction.status == statusValue){

                    descr = UserPaymentStatus[status].name
                    break
                }
            }
            return descr
        }

        function isTransactionProcessing(transaction){
            var isProcessing = false

            isProcessing = transaction.status == UserPaymentStatus.CREATED.value 
                    || transaction.status == UserPaymentStatus.AUTHORIZED.value
                    || transaction.status == UserPaymentStatus.AUTHORIZATION_PENDING.value
                    || transaction.status == UserPaymentStatus.CAPTURED_PENDING.value
                    || transaction.status == UserPaymentStatus.RETRYING.value
                    || transaction.status == UserPaymentStatus.PREAUTHORIZATION_PENDING.value
                    || transaction.status == UserPaymentStatus.PREAUTHORIZED.value
                    || transaction.status == UserPaymentStatus.ADJUSTMENT_PENDING.value
                    || transaction.status == UserPaymentStatus.ADJUSTED.value
                    || transaction.status == UserPaymentStatus.CANCELLATION_PENDING.value

            return isProcessing
        }

        function isTransactionCompleted(transaction){

            return transaction.status == UserPaymentStatus.CAPTURED.value
        }

        function isTransactionFailed(transaction){
            var isFailed = false

            isFailed = transaction.status == UserPaymentStatus.AUTHORIZATION_FAILED.value
                || transaction.status == UserPaymentStatus.AUTHORIZATION_ERROR.value
                || transaction.status == UserPaymentStatus.CAPTURED_FAILED.value
                || transaction.status == UserPaymentStatus.PREAUTHORIZATION_FAILED.value
                || transaction.status == UserPaymentStatus.PREAUTHORIZATION_ERROR.value
                || transaction.status == UserPaymentStatus.ADJUSTMENT_FAILED.value
                || transaction.status == UserPaymentStatus.ADJUSTMENT_ERROR.value
                || transaction.status == UserPaymentStatus.CANCELLATION_FAILED.value
                || transaction.status == UserPaymentStatus.CANCELLATION_ERROR.value
            
            return isFailed
        }

        function isTransactionRetryable(transaction){
            return (
                (transaction.status == UserPaymentStatus.AUTHORIZATION_FAILED.value ||
                    transaction.status == UserPaymentStatus.ADJUSTMENT_FAILED.value) &&
                (getTag(transaction) === TransactionTag.MANUAL || getTag(transaction) === TransactionTag.BOOKING)
            );
        }

        function isTransactionRefunded(transaction){
            return transaction.status == UserPaymentStatus.REFUNDED.value
        }

        function isTransactionBlockedForRetry(transaction){
            return transaction.status == UserPaymentStatus.DO_NOT_RETRY.value
        }

        function isTransactionCancelled(transaction){
            return transaction.status == UserPaymentStatus.CANCELLED.value
        }

        function isTransactionAPreauthorizationFailure(transaction){
            return transaction.status == UserPaymentStatus.PREAUTHORIZATION_FAILED.value
                || transaction.status == UserPaymentStatus.PREAUTHORIZATION_ERROR.value
        }

        function getTag(transaction){

            if(!transaction){
                console.warn("getTag: invalid param transaction",transaction)
                return null
            }
            
            if(transaction.BookingId){
                return TransactionTag.BOOKING
            }

            if(!transaction.description){
                console.warn("getTag: invalid description",transaction)
                return null
            }
            
            if (transaction.description.startsWith("Manual")) {
                return TransactionTag.MANUAL
            } else if (transaction.description.startsWith("Order ID")) {
                return TransactionTag.SHOP_ORDER
            } else if(transaction.description.startsWith("LongTermBooking ID")){
                return TransactionTag.LONG_TERM_BOOKING
            } else {
                console.warn("getTag: unknown tag",transaction)
               return null
            }
        }

        function getTransactionDescription(transaction){
            
            if(!transaction){
                console.warn("getTransactionDescription: invalid param transaction",transaction)
                return ""
            }

            const tag = getTag(transaction)
            if(!tag){
                return ""
            }

            if(!transaction.description){
                return ""
            }

            var split = null

            switch(tag){
                case TransactionTag.BOOKING:
                    return "Standard Trip"
                case TransactionTag.MANUAL:
                    var match = transaction.description.match(/Manual \[[0-9]+\]: (.*)/)
                    return match && match[1].trim() || "Manual charge"
                case TransactionTag.SHOP_ORDER:
                    split = transaction.description.split(":")
                    return split && ("Shop order " + (split[1].trim())) || "Shop order"
                case TransactionTag.LONG_TERM_BOOKING:
                    split = transaction.description.split(":")
                    return split && ("Long Term Sharing ID: " + (split[1].trim())) || "Long Term Sharing"
                default :
                    return ""
            }

        }

        function getTransactionSiteId(transaction){
            if(!transaction){
                console.warn("TransactionUtility.getTransactionSiteId: invalid transaction",transaction)
                return null
            }

            const tag = getTag(transaction)
            if(!tag){
                return null
            }

            switch (tag) {
                case TransactionTag.BOOKING:
                    return transaction.Booking.SiteId;
                case TransactionTag.MANUAL:
                    const match = transaction.description.match(/Manual \[([0-9]+)\]:/);
                    return match && match[1] || null;
                case TransactionTag.SHOP_ORDER:
                    // FIXME we should use the transaction siteId but it hasn't it in the model, we should use the shop order siteId 
                    // but we have not it here.
                    // Waiting for Bonus CRUD merge, does it will arrive?
                    console.warn("TransactionUtility.getTransactionSiteId: unimplemented parse siteId for Shop Order transaction, where's BONUS CRUD?")
                    return null;
                case TransactionTag.LONG_TERM_BOOKING:
                    return transaction.LongTermBooking && transaction.LongTermBooking.SiteId || null
                default :
                    console.warn("TransactionUtility.getTransactionSiteId: unknown SiteId for ", transaction);
                    return null;
            }
        }

        return{
            getTransactionStatusDescription:getTransactionStatusDescription,
            isTransactionProcessing:isTransactionProcessing,
            isTransactionCompleted:isTransactionCompleted,
            isTransactionFailed:isTransactionFailed,
            isTransactionRetryable:isTransactionRetryable,
            isTransactionRefunded:isTransactionRefunded,
            isTransactionBlockedForRetry:isTransactionBlockedForRetry,
            getTag:getTag,
            getTransactionDescription:getTransactionDescription,
            getTransactionSiteId:getTransactionSiteId,
            isTransactionCancelled:isTransactionCancelled,
            isTransactionAPreauthorizationFailure:isTransactionAPreauthorizationFailure,
        }
    }

    /** @ngInject */
    function CouponUtilityFactory(CouponType, MiscUtility){

        function getCouponTypeDescription(coupon){
            var statusValue = -1
            var descr = ""
            if(coupon){
                for(var status in CouponType){

                    statusValue = CouponType[status].value

                    if(coupon.type == statusValue){

                        descr = CouponType[status].name
                        break
                    }
                }
            }
            return descr
        }

        function generateMinutesValue(creditValue, siteId){

            if(creditValue == null || siteId == null){
                console.warn("CouponUtility.generateMinutesValue: invalid input", creditValue, siteId)
                return null
            }
            const milliseconds = MiscUtility.generateMillisecondsValue(creditValue, siteId)
            if(milliseconds == null){
                console.warn("CouponUtility.generateMinutesValue: invalid converted millis", milliseconds)
                return null
            }
            const minutesValue = Math.round((milliseconds / 60000) * 100) / 100
            // console.log("minutes", minutesValue)
            return !Number.isNaN(minutesValue) ? minutesValue : null
        }
        
        return {
            getCouponTypeDescription: getCouponTypeDescription,
            generateMinutesValue: generateMinutesValue,
        }
    }

    /** @ngInject */
    function DeviceUtilityFactory(DeviceType,DeviceStatus){

        function getDeviceTypeDescription(device){

            var descr = DeviceType.PERSONAL.name

            if(typeof device == "undefined" || device == null){
                console.warn("DeviceUtilityFactory.getDeviceTypeDescription: no device")
                return descr
            }
            for(var typeKey in DeviceType){
                var typeObj = DeviceType[typeKey]
                if(typeObj.value == device.deviceType){
                    descr = typeObj.name
                    break
                }
            }

            return descr
        }

        function getDeviceStatusDescription(device){

            var descr = ""

            if(typeof device == "undefined" || device == null){
                console.warn("DeviceUtilityFactory.getDeviceStatusDescription: no device")
                return descr
            }
            for(var statusKey in DeviceStatus){
                var status = DeviceStatus[statusKey]
                if(device.status == status.value){
                    descr = status.name
                    break
                }
            }

            return descr
        }

        return {
            getDeviceTypeDescription: getDeviceTypeDescription,
            getDeviceStatusDescription: getDeviceStatusDescription
        }
    }

    /** @ngInject */
    function GeofenceUtilityFactory(MapUtility){

        function fitMapToGeofenceAreas(map,areas) {
            var points = []

            if(typeof map === "undefined" || map === null || typeof areas === "undefined" || areas === null || !Array.isArray(areas)){
                console.log("GeofenceUtility.fitMapToGeofenceAreas: invalid input",map,areas)
                return
            }

            areas.forEach(function(activeArea){
                if(activeArea.zonas){
                    activeArea.zonas.forEach(function(zona){
                        if(!zona.exclude){
                            points = points.concat(zona.points.reduce(function(curr,currPoints){
                                return curr.concat({lat: currPoints[0],lng: currPoints[1]})
                            },[]))
                        }
                    })    
                }
            })
            // console.log("points",points)
            MapUtility.fitMapToPoints(map,points)
        }
        return{
            fitMapToGeofenceAreas:fitMapToGeofenceAreas
        }
    }

    /** @ngInject */
    function DamageUtilityFactory(DamageInstantSpottedViewer,ExpensesAdapter) {

        var expenses = null

        function getDamageInstantSpottedDescription(damage) {
            var statusValue = -1
            var descr = ""
            for(var status in DamageInstantSpottedViewer){

                statusValue = DamageInstantSpottedViewer[status].value

                if(damage.instantSpotted == statusValue){

                    descr = DamageInstantSpottedViewer[status].name
                    break
                }
            }
            return descr
        }

        function getDamageStatusDescription(damage) {
            var statusValue = -1
            var descr = ""
            for(var status in DamageStatusViewer){

                statusValue = DamageStatusViewer[status].value

                if(damage.status == statusValue){ //check if status is the correct damage property

                    descr = DamageStatusViewer[status].name
                    break
                }
            }
            return descr
        }

        function getExpenses(cb){

            if(expenses){
                if(typeof cb !== "undefined"){
                    cb(expenses)
                }
            }
            else{
                console.log("DamageUtility: getExpenses and saved it locally")
                ExpensesAdapter.getExpenses(
                    function(data,error){
                        if(!error){
                            expenses = data
                            //fill description in each part
                            if(typeof cb !== "undefined"){
                                cb()
                            }
                        }
                    })
            }
        }

        function getDamagePartDescription(part){
            var descr=""

            expenses.forEach(function(exp){
                if(exp.id == part.code){
                    descr = exp.description
                }
            })

            if (descr === "" && !part.code && part.description) {
                descr = part.description
            }
            
            return descr
        }

        function generateDamagePartsDescriptions(damageReports){
            if(typeof damageReports == "undefined" || damageReports == null){
                console.warn("generateDamagePartsDescriptions: no input")
            }
                        
            getExpenses(function(){
                damageReports.forEach(function(damageReport){
                
                    if(damageReport.parts){
                        damageReport.parts.forEach(function(part){
                            part.description = getDamagePartDescription(part)
                        })
                    }
                })
            })
        }

        function generateDamageOtherDamageDescriptions(damageReport){

            if(typeof damageReport == "undefined" || damageReport == null){
                console.warn("generateDamageOtherDamageDescriptions: no input")
            }
            
            var otherDamageHuman = "" 
            if(damageReport.other_damage && typeof damageReport.other_damage !== "string"){
                damageReport.other_damage.forEach(function(label){
                    if(otherDamageHuman == "")
                        otherDamageHuman = label
                    else{
                        otherDamageHuman+=","+label
                    }
                })
            }
            damageReport.other_damage_human = otherDamageHuman
        }
        
        return {
            getDamageInstantSpottedDescription:getDamageInstantSpottedDescription,
            getDamageStatusDescription:getDamageStatusDescription,
            getDamagePartDescription:getDamagePartDescription,
            generateDamagePartsDescriptions:generateDamagePartsDescriptions,
            generateDamageOtherDamageDescriptions:generateDamageOtherDamageDescriptions
        }
    }

    /** @ngInject */
    function FareUtilityFactory(FareType) {

        function getFareTypeDescription(fare) {
            var statusValue = -1
            var descr = ""
            if(fare){
                for(var status in FareType){

                    statusValue = FareType[status].value

                    if(fare.type == statusValue){

                        descr = FareType[status].name
                        break
                    }
                }
            }
            return descr
        }

        return {
            getFareTypeDescription:getFareTypeDescription
        }
    }

    /** @ngInject */
    function ErrorUtilityFactory(LogInService,SweetAlert,$location,LoginPageUrl){

        var alertDisplayed = false
        var alertMessages = []

        function checkServerResponseError(response){

            if(typeof response.data === "undefined" || response.data === null){
                showErrorMessage({title:'Response Error',description:'There was an error with the server response'})
                return
            }
            var error = response.data.error
            var errorType = null
            switch (error.type) {
                case "no_access_get":
                    errorType = "retrieve"
                    break
                case "no_access_post":
                    errorType = "create"
                    break
                case "no_access_put":
                    errorType = "modify"
                    break
                case "no_access_delete":
                    errorType = "delete"
                    break
                case "no_access_manage":
                    errorType = "manage"
                    break
                case "no_token":
                    //TO DO: fix this after other services execpt movo has log enpoint
                    if(response.config.url.indexOf("api/log") == -1){
                        LogInService.logOut()
                        showErrorMessage({title:"Token Error",description:"Your token is not more valid, please log in"})
                        $location.path(LoginPageUrl)
                    }
                    break
                case "expire_token":
                    //TO DO: fix this after other services execpt movo has log enpoint
                    if(response.config.url.indexOf("api/log") == -1){
                        LogInService.logOut()
                        showErrorMessage({title:"Token Expired",description:"Your token expired and is not more valid, please log in"})
                        $location.path(LoginPageUrl)
                    }
                    break
            }
            
            if(errorType){
                // $rootScope.$emit("permissionsError", errorType)
                //TO DO: fix this after other services execpt movo has log enpoint
                if(response.config.url.indexOf("api/log") == -1){
                    showErrorMessage({title:"Error performing action",description: "You don't have the permissions to " + errorType + " this resource"})
                }
            }
        }

        function showErrorMessage(messageObj){
            
            if(alertDisplayed){
                console.warn("an alert is displayed wait until closure",messageObj)
                if(alertMessages.length === 0){
                    alertMessages.push(messageObj)
                }
                else{
                    var prevMessageObj = alertMessages[alertMessages.length-1]
                    if(messageObj.title !== prevMessageObj.title){
                        var prevPrevMessageObj = alertMessages[alertMessages.length-2]
                        if(typeof prevPrevMessageObj === 'undefined' || prevPrevMessageObj.title !== messageObj.title){
                            alertMessages.push(messageObj)
                        }
                    }
                }
                return
            }else{
                alertMessages.push(messageObj)
            }

            alertDisplayed = true
            SweetAlert.swal(
                {
                    title: messageObj.title,
                    text: messageObj.description,
                    type: "error"
                },
                function(){
                    alertDisplayed = false
                    alertMessages.shift()
                    if(alertMessages.length>0){
                        setTimeout(function(){
                            showErrorMessage(alertMessages.shift())
                        },1000)
                    }
                }
            )
            //prevent bug when multiple Sweetalert is displayed and the next one override the prevoius without call the callback
            setTimeout(function(){
                alertDisplayed = false
            },6000)
        }

        return{
            checkServerResponseError:checkServerResponseError,
            showErrorMessage:showErrorMessage
        }
    }

    function MyHttpInterceptor($q,DefaultSite,ErrorUtility,AppSettings) {
        return {
            // optional method
            'request': function(config) {

                //not using SitesService cause http circular dependency
                if(config.url.indexOf('admin') != -1 && !(config.url.indexOf('login') != -1)){
                    const currentSite = AppSettings.getSelectedSite()//LocalStorageService.getItem(MiscData.SITE)
                    var currentSiteId = (currentSite && currentSite.id != DefaultSite.id) ? currentSite.id : null
                    if(currentSiteId){
                        if(config.params){
                            config.params['site'] = currentSiteId
                        }else{
                            config.params = {'site': currentSiteId}
                        }
                    }
                    // console.log("request",config.method,config.url,config.params)
                    // console.log("request",config.url)
                }
                // do something on success
                return config;
            },
            // optional method
            // 'requestError': function(rejection) {
            //     console.log("requesterror",rejection)
            //     // do something on error
            //     // if (canRecover(rejection)) {
            //     //     return responseOrNewPromise
            //     // }
            //     return $q.resolve(rejection);
            // },
            // optional method
            // 'response': function(response) {
            //     // do something on success
            //     return response;
            // },
            // optional method
            'responseError': function(response) {
                // do something on error
                console.log("responseError", response)
                if(response.status === -1){
                    //TO DO: better handling of this error 
                    // ErrorUtility.showErrorMessage({title:'Connection Error',description:'Check your internet connection!'})
                }
                else {
                    ErrorUtility.checkServerResponseError(response)
                }
                return $q.reject(response)
            }
        }
    }

    function GenerateCSVService(){

        function generate(outputArray){

            // "ufeff" is the order byte indicaetor. This allows for symbols such as "€" to render correctly
            var blob = new Blob(["\ufeff"].concat(outputArray), {type: "text/csv; charset=utf-8"})
            var objUrl = window.URL.createObjectURL(blob)

            var fileName = prompt("Please enter a file name", "File name")
            if(!fileName){ return }
            fileName += ".csv"

            var downloadLink = document.createElement("a")
            downloadLink.download = fileName
            downloadLink.innerHTML = "Download File"
            downloadLink.href = objUrl
            downloadLink.onclick = function destroyClickedElement(event){
                document.body.removeChild(event.target)
            }
            downloadLink.style.display  = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
        }

        return{
            generate:generate
        }
    }

        /** @ngInject */
        function MapDrawingUtilities(VehicleTypes,VehicleGeofenceOptions){
        
            function reversePolygonCoords(polygon){
                var coords = []
                var path = polygon.getPath().getArray()
                // console.log("start path",path)
                coords.push(path[0])

                for(var pointIndex = path.length - 1; pointIndex > 0; pointIndex--){
                    var point = path[pointIndex]
                    var coord = point
                    coords.push(coord)
                }
                var trashPolygon = new google.maps.Polygon({paths: coords})
                var outputCoords = trashPolygon.getPath()
                trashPolygon = null
                // console.log("end path",outputCoords)
                return outputCoords
            }
    
            function reverseCoords(coords){
                var output = [coords[0]]
                for(var index = coords.length - 1; index > 0; index--){
                    output.push(coords[index])
                }
                return output;
            }

            function convertPointsInCoords(points){
                var coords = []
                points.forEach(function(point) {
                    coords.push(new google.maps.LatLng({lat: point[0], lng: point[1]}))
                }, this);
                return coords
            }
    
            function getCoordsFromJsts(polygon){
                var coords = polygon.getCoordinates().map(function (coord) {
                    return { lat: coord.x, lng: coord.y };
                })
                return coords
            }
    
    
            function checkPolygonIntersection(polygon, polygons){
                if(polygons.length == 1){ return }
                var geometryFactory = new jsts.geom.GeometryFactory()
                
                // var jstsShell = geometryFactory.createLinearRing(cords)
                var jstsPolygon = createJstsPolygon(geometryFactory, polygon)
    
                for(var polygonIndex = 0; polygonIndex <= polygons.length - 2; polygonIndex++){
                    var tempPolygon = polygons[polygonIndex]
                    
                    // var tempShell = geometryFactory.createLinearRing(tempCords)
                    var jstsTempPolygon = createJstsPolygon(geometryFactory, tempPolygon)
    
                    var intersection = jstsPolygon.intersection(jstsTempPolygon)
                    if(intersection.shell.points.coordinates.length > 0){
                        return true
                    }
                }
                return false
            }
    
            function checkIfCoordsIntersect(coord1, coord2){
                var pol1 = new google.maps.Polygon({
                    paths: coord1
                })
                var pol2 = new google.maps.Polygon({
                    paths: coord2
                })
    
                return checkSinglePolygonIntersection(pol1, pol2)
            }
    
            //Return 0 if no intersection, 1 with intersection, 2 if polygon1 is contained in polygon2, 3 the other way around
            function checkSinglePolygonIntersection(polygon1, polygon2){
                var geometryFactory = new jsts.geom.GeometryFactory()
                var jstsPolygon1 = createJstsPolygon(geometryFactory, polygon1)
                var jstsPolygon2 = createJstsPolygon(geometryFactory, polygon2)
                var intersection = jstsPolygon1.intersection(jstsPolygon2)
                if(intersection.shell.points.coordinates.length > 0){
                    if(jstsPolygon2.difference(jstsPolygon1).shell.points.coordinates.length > 0){
                        if(jstsPolygon1.difference(jstsPolygon2).shell.points.coordinates.length > 0){
                            return 1
                        }else{
                            return 2
                        }
                    }else{
                        return 3
                    }
                    return 1
                }
                return 0
            }
    
            function getPolygonByDifference(polygon, difference){
                var geometryFactory = new jsts.geom.GeometryFactory()
                var jstsPolygon = createJstsPolygon(geometryFactory, polygon)
                var differencePolygon = createJstsPolygon(geometryFactory, difference)
                return jstsPolygon.difference(differencePolygon)
            }


            /**
             * Given lat() lng() array, check if polygon1 is inside polygon2
             * @return boolean
             */
            function isInsidePolygon(polygon1, polygon2) {

                var factory1 = new jsts.geom.GeometryFactory();
                var polygonRing1 = createJstsFromArray(factory1, polygon1);


                var factory2 = new jsts.geom.GeometryFactory();
                var polygonRing2 = createJstsFromArray(factory2, polygon2);

                return polygonRing2.contains(polygonRing1);

            }
    
            function isPolygonClockwise(polygon){
                var path = polygon.getPath().getArray()
                var area = 0
                for(var pointIndex in path){
                    var point = path[pointIndex]
                    var nextPoint = path[0]
                    if(pointIndex < path.length-1){
                        var nextIndex = parseInt(pointIndex) + 1
                        nextPoint = path[nextIndex]
                    }
                    var cord1 = {lat: point.lat(), lng: point.lng()}
                    var cord2 = {lat: nextPoint.lat(), lng: nextPoint.lng()}
                    area += (cord2.lat - cord1.lat)*(cord2.lng + cord1.lng)
                }
                var isCurrentPolygonClockWise = area < 0
                return isCurrentPolygonClockWise
            }
    
            function areCoordsClockwise(coords){
                var area = 0
                for(var index in coords){
                    var point = coords[index]
                    var nextPoint = coords[0]
                    if(index < coords.length-1){
                        var nextIndex = parseInt(index) + 1
                        nextPoint = coords[nextIndex]
                    }
                    area += (nextPoint.lat - point.lat) * (nextPoint.lng + point.lng)
    
                }
                return area < 0
            }
    
            function createJstsPolygon(geometryFactory, polygon) {
                var path = polygon.getPath()
                var coordinates = path.getArray().map(function name(coord) {
                    return new jsts.geom.Coordinate(coord.lat(), coord.lng());
                });
                if(coordinates[0].compareTo(coordinates[coordinates.length-1]) != 0) 
                    coordinates.push(coordinates[0]);
                var shell = geometryFactory.createLinearRing(coordinates);
                return geometryFactory.createPolygon(shell);
            }

            function createJstsFromArray(geometryFactory, arr) {
                var coordinates = arr.map(function name(coord) {
                    return new jsts.geom.Coordinate(coord.lat(), coord.lng());
                });
                if(coordinates[0].compareTo(coordinates[coordinates.length-1]) != 0) 
                    coordinates.push(coordinates[0]);
                var shell = geometryFactory.createLinearRing(coordinates);
                return geometryFactory.createPolygon(shell);
            }
    
    
            function createJstsPolygonWithHoles(geometryFactory, polygon){
                var paths = polygon.getPaths()
                //console.log("Paths",paths)
                var coordinates = []
                for(var pathIndex = 0; pathIndex <= paths.length - 1; pathIndex++){
                    var path = paths.getAt(pathIndex).getArray().map(function name(coord) {
                        return new jsts.geom.Coordinate(coord.lat(), coord.lng());
                    })
                    coordinates.push(path)
                }
                //console.log("Coordinates", coordinates)
                var shells = []
                for(var index in coordinates){
                    var currentCoord = coordinates[index]
                    if(currentCoord[0].compareTo(currentCoord[currentCoord.length - 1]) != 0){
                        currentCoord.push(currentCoord[0])
                    }
                    var shell = geometryFactory.createLinearRing(coordinates[index])
                    shells.push(shell)
                }
                //console.log("Sheels",shells)
                if(shells.length > 1){
                    var firstShell  = shells.shift()
                    return geometryFactory.createPolygon(firstShell, shells)
                }
                return geometryFactory.createPolygon(shells[0]);
    
            }

            function createPolygon(paths,options){
                var geofenceOptions = getGeofenceOptions(options);
                var polygon = new google.maps.Polygon({
                    paths: paths,
                    fillColor: geofenceOptions.color,
                    fillOpacity: geofenceOptions.opacity,
                    strokeColor: geofenceOptions.color,
                    zIndex: geofenceOptions.zIndex
                })

                return polygon
            }
    
            function convertServerAreaToPolygons(zonas,options){
                var outputPolygons = []
                
                var lastPolygon = null
                
                for(var index in zonas){
                    var zona = zonas[index]
                    if(zona.exclude){
                        if(index==0){
                            console.warn("first area is a excluded area")
                            break
                        }
                        var excludedCoords = convertPointsInCoords(zona.points)
                        if(excludedCoords){
                            //excludedCoords are reversed by default
                            lastPolygon.getPaths().push(new google.maps.MVCArray(excludedCoords))
                        }else{
                            console.warn("excluded coords of a area are invalid",excludedCoords)
                        }
                    }else{
                        var coords = convertPointsInCoords(zona.points)
                        if(coords){
                            lastPolygon = createPolygon([coords], options)
                            outputPolygons.push(lastPolygon)
                        }else{
                            console.warn("coords of a area are invalid",coords)
                        }
                    }
                }
                // legacy code when we believed that polygons holes were not consegutives to the outer path
                // for(var index in excludedZonas){
                //     var zona = excludedZonas[index]
                //     var coords = convertPointsInCoords(zona.points)
                //     var excludedPolygon = new google.maps.Polygon({
                //         paths: coords
                //     })
                //     //console.log("Temp polygon", excludedPolygon)
                //     for(var polIndex in outputPolygons){
                //         var polygon = outputPolygons[polIndex]
                //         var polygonIntersection = checkSinglePolygonIntersection(polygon, excludedPolygon)
                //         if( polygonIntersection != 0){
                //             var newCords = excludedPolygon.getPath()
                //             if(isPolygonClockwise(polygon) == isPolygonClockwise(excludedPolygon)){
                //                 newCords = reversePolygonCoords(excludedPolygon)
                //             }
                //             //Adding hole's coords to polygon
                //             polygon.getPaths().push(newCords)
                //             break
                //         }
                //     }
                // }
    
                return outputPolygons
            }
    
    
            function convertPolygonsToServerArea(polygons){
                var zonas = []
                polygons.forEach(function(polygon) {
                    var paths = polygon.getPaths()
                    //console.log("Paths",paths)
                    var pathCoords = []
                    for(var index = 0; index < paths.length; index++){
                        var path = paths.getAt(index)
                        //console.log("Path", path)
                        var points = path.getArray().map(function name(coord) {
                            return [coord.lat(), coord.lng()]
                        })
                        pathCoords.push(points)
                    }
                    for(var index = 0; index < pathCoords.length; index++ ){
                        var zona = { points: pathCoords[index] }
                        zona.exclude = index > 0
                        zonas.push(zona)
                    }
                    
                }, this);
    
                return zonas
            }

            function getGeofenceOptions(options) {
                var geofenceOptions = {
                    color: VehicleGeofenceOptions.DEFAULT.color,
                    opacity: VehicleGeofenceOptions.DEFAULT.opacity,
                    zIndex: VehicleGeofenceOptions.DEFAULT.zIndex,
                };
                if (options) {
                    switch (options.vehicleType) {
                        case VehicleTypes.SCOOTER.value:
                            geofenceOptions.color = VehicleGeofenceOptions.SCOOTER.color;
                            geofenceOptions.opacity = VehicleGeofenceOptions.SCOOTER.opacity;
                            geofenceOptions.zIndex = VehicleGeofenceOptions.SCOOTER.zIndex;
                            break;
                        case VehicleTypes.KICK_SCOOTER.value:
                            geofenceOptions.color = VehicleGeofenceOptions.KICK_SCOOTER.color;
                            geofenceOptions.opacity = VehicleGeofenceOptions.KICK_SCOOTER.opacity;
                            geofenceOptions.zIndex = VehicleGeofenceOptions.KICK_SCOOTER.zIndex;
                            break;
                    }
                }
                return geofenceOptions;
            }

            function convertZonaPointsTo(zonaPoints) {
                if (!zonaPoints) {
                    console.warn('convertZonaPointsTo: invalid input', zonaPoints);
                    return [];
                }
                return zonaPoints
                    .map(function (point) {
                        return point.slice(0).reverse();
                    })
                    .concat([zonaPoints[0].slice(0).reverse()]);
            }

            function convertServerAreasToGeoJson(areas, onlyActive) {
                if (!areas) {
                    console.warn('convertServerAreasToGeoJson: invalid areas', areas);
                    return {
                        type: 'FeatureCollection',
                        features: [],
                    };
                }
                var onlyActive = onlyActive !== undefined ? onlyActive : false;
                return {
                    type: 'FeatureCollection',
                    features: areas.reduce(function (acc, area) {
                        return acc.concat(
                            area.zonas
                                .filter(function (zona) {
                                    return zona.points.length >= 3 && (!onlyActive || area.active);
                                })
                                .reduce(function (acc, zona) {
                                    if (!zona.exclude) {
                                        const geofenceOptions = getGeofenceOptions({ vehicleType: area.vehicleType });
                                        acc.push({
                                            type: 'Feature',
                                            properties: {
                                                vehicleType: area.vehicleType,
                                                name: area.name,
                                                active: area.active,
                                                fillColor: geofenceOptions.color,
                                                fillOpacity: geofenceOptions.opacity,
                                                lineColor: geofenceOptions.color,
                                            },
                                            geometry: {
                                                type: 'Polygon',
                                                coordinates: [convertZonaPointsTo(zona.points)],
                                            },
                                        });
                                    } else {
                                        const feature = acc[acc.length - 1];
                                        if (feature) {
                                            feature.geometry.coordinates.push(convertZonaPointsTo(zona.points));
                                        } else {
                                            console.warn(
                                                'convertServerAreasToGeoJson: exclude zona before outer shape area',
                                                zona,
                                                acc
                                            );
                                        }
                                    }
                                    return acc;
                                }, [])
                        );
                    }, []),
                };
            }
    
            return {
                reversePolygonCoords: reversePolygonCoords,
                reverseCoords: reverseCoords,
                getCoordsFromJsts: getCoordsFromJsts,
                checkPolygonIntersection: checkPolygonIntersection,
                checkIfCoordsIntersect: checkIfCoordsIntersect,
                checkSinglePolygonIntersection: checkSinglePolygonIntersection,
                getPolygonByDifference: getPolygonByDifference,
                isPolygonClockwise: isPolygonClockwise,
                areCoordsClockwise: areCoordsClockwise,
                createJstsPolygon: createJstsPolygon,
                createJstsPolygonWithHoles: createJstsPolygonWithHoles,
                convertServerAreaToPolygons: convertServerAreaToPolygons,
                convertPolygonsToServerArea: convertPolygonsToServerArea,
                convertPointsInCoords: convertPointsInCoords,
                isInsidePolygon: isInsidePolygon,
                convertServerAreasToGeoJson: convertServerAreasToGeoJson,
            };
    
        }

        function NewDashboardGatewayUtility(){

            function openUrl(url){
                var token = localStorage.getItem('token');
                var serviceName = localStorage.getItem('companyName');
                var userId = localStorage.getItem('userId');
                var siteId = localStorage.getItem('site');
                var userSite = localStorage.getItem('userSite');

                if (typeof token === 'undefined' || token === null) {
                    token = sessionStorage.getItem('token');
                }
                if (typeof serviceName === 'undefined' || serviceName === null) {
                    serviceName = sessionStorage.getItem('companyName');
                }
                if (typeof userId === 'undefined' || userId === null) {
                    userId = sessionStorage.getItem('userId');
                }
                if (typeof siteId === 'undefined' || siteId === null) {
                    siteId = sessionStorage.getItem('site');
                }
                if (typeof userSite === 'undefined' || userSite === null) {
                    userSite = sessionStorage.getItem('userSite');
                }

                if (token && serviceName && userId) {
                    var compositeURL =
                        url + '?token=' + token + '&serviceName=' + serviceName + '&userID=' + userId;
                    if (siteId && siteId !== -1 && siteId !== '-1' && userSite) {
                        compositeURL += '&siteID=' + siteId;
                    }
                    window.open(compositeURL);
                } else {
                    console.error('Token and service name not available');
                }
            }
    
            return{
                openUrl: openUrl
            }
        }

})();

(function ()
{
    'use strict';

    angular
        .module('app.user')
        .controller('UsersListController', UsersListController)
        .factory('UserDialogFactory',UserDialogFactory)

    /** @ngInject */
    function UsersListController (
        $scope,
        $mdDialog,
        UserAdapter,
        UserService,
        UserDialogFactory,
        UserStatus,
        UserPaymentStatus,
        FiltersFactory,
        OrderRequestParamFactory,
        ServiceSettings,
        MiscUtility,
        SitesService,
        ErrorUtility,
        AppConfigurations
    ){
        var vm = this;

        // Data
        vm.contacts = []
        vm.allUsersLength = "..."
        vm.usersViewed = "..."
        vm.allUsersEnabled = false


        vm.userStatus = UserStatus

        vm.userPaymentStatus = UserPaymentStatus

        vm.filters = {
            // userStatus: FiltersFactory.createUserWithStatusFilter(),
            // userLastPaymentStatus: FiltersFactory.createUserWithLastPaymentStatusFilter(),
            // userRegistrationDateStart: FiltersFactory.createUserWithRegistrationDateStartFilter(),
            // userRegistrationDateEnd: FiltersFactory.createUserWithRegistrationDateEndFilter()
        }

        vm.searchFilters = {
            userId : FiltersFactory.createUserWithIdFilter(),
            userFullName: FiltersFactory.createUserWithFullNameFilter(),
            userEmail: FiltersFactory.createUserWithEmailFilter(),
            userPhoneNumber: FiltersFactory.createUserWithPhoneNumberFilter(),
            userStatus: FiltersFactory.createUserWithStatusFilter(),
            userLastPaymentStatus: FiltersFactory.createUserWithLastPaymentStatusFilter(),
            userRegistrationDate: FiltersFactory.createUserWithRegistrationDateRangeFilter(),
        }

        vm.filterRequestParam = null
        vm.orderRequestParam = null
        vm.selectedOrderBy = {orderBy: OrderRequestParamFactory.orderByUserId, ascOrder: false}
        
        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })

        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    SitesService.getSites(function(){
                        vm.selectedSiteId = SitesService.getSelectedSite()
    
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);

                        vm.tableFields = AppConfigurations.getUserListTableFields()
                    })
                    $scope.$applyAsync()
                }

            });
        }
        init()
        
        $scope.$on('siteChanged', function (site) {
            console.log('siteChanged in users')
            SitesService.getSites(function(){
                vm.selectedSiteId = SitesService.getSelectedSite();
            })
            vm.applyFiltersTrigger();
        })

        // Methods
        vm.refreshUsers = refreshUsers
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteContact = deleteContact;
        // vm.resetFilters = resetFilters
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger

        function refreshUsers (paginationRequestParam, callback, updateInterface) {
            if(updateInterface === undefined) {
                updateInterface = true;
            }
            if(updateInterface){
                vm.allUsersLength = "..."
                vm.usersViewed = "..."
            }
            // if($stateParams.searchFor) {
            //     console.log("stateParams",$stateParams.searchFor)
            //     vm.applyFiltersTrigger($stateParams.searchFor)
            //     $stateParams.searchFor = null;
            // } else {
            UserAdapter.getUsers(
                paginationRequestParam,
                function(data, error){
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Get Users List',description:'Error getting the users list!'})

                        if (callback !== undefined) {
                            callback(data, error)
                        }
                    } else {
                        if(updateInterface){
                            var users = (typeof data.data !== "undefined") ? data.data : data
                            if(users) {
                                // console.log("last user",users[0])
                                vm.contacts = users;
                            }
                            vm.allUsersLength = (typeof data.count !== "undefined") ? data.count : data.length
                            vm.usersViewed = users.length
                        }
                        if (callback !== undefined) {
                            callback(data, error)
                        }
                    }
                }
            )
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger(){
            vm.applyFiltersTrigger();
        }

        // function resetFilters(){
        //     resetStaticFilters()
        // }

        // function resetStaticFilters(){
        //     for(var key in vm.filters){
        //         vm.filters[key].selected = null
        //     }
        //     vm.applyFiltersTrigger()
        // }

        function openContactDialog(ev,contact) {
            UserDialogFactory.addUser(ev)
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev) {

            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete the contact?')
                .htmlContent('<b>' + contact.fullName+'</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {

                deleteContact(contact);
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact) {

            UserAdapter.deleteUser(contact.id,
                function (data, error){
                    if (!error){
                        vm.contacts.splice(vm.contacts.indexOf(contact), 1);
                        UserService.refresh();
                    }
            })
        }

    }

    /** @ngInject */
    function UserDialogFactory($mdDialog, $document) {
        return {
            addUser: function (ev){

                return $mdDialog.show({
                    controller         : 'AddUserDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/user/dialogs/user-add-dialog.html',
                    parent             : angular.element($document.body),//$document.find('#content-container')),
                    targetEvent        : ev,
                    clickOutsideToClose: true,
                    locals             : {}
                });
            },
            showMakeManualPayment: function (ev, user, paymentMethod){

                return $mdDialog.show({
                    controller         : 'MakeManualPaymentDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/user/dialogs/payment/make-manual-payment-dialog.html',
                    parent             : angular.element("body"),//$document.find('#content-container')),
                    targetEvent        : ev,
                    clickOutsideToClose: true,
                    locals             : {
                        User : user,
                        PaymentMethod : paymentMethod
                    }
                });
            },
            changeFreeMinutes: function (ev,user){

                return $mdDialog.show({
                    controller         : 'UserChangeFreeMinutesDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/user/dialogs/user-change-free-minutes-dialog.html',
                    parent             : angular.element($document.body),//$document.find('#content-container')),
                    targetEvent        : ev,
                    clickOutsideToClose: false,
                    locals             : {
                        User : user
                    }
                });
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.trip', [
            'app.trip.list',
            'app.trip.details'
        ])
        .value('TripsListMapPage','app.trip')
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.trip',{
                url  : '/trip',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/trip/trip-list-map.html',
                        controller : 'TripListMapController as vm'
                    }
                },
                params:{searchFor:{filterKey:null, value:null}}
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/vehicle');

        msNavigationServiceProvider.saveItem('trip', {
            title: 'Trips',
            icon : 'icon-map-marker-multiple',
            state: 'app.trip.list',
            weight: 20
        });

    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("trip")
        
        if(!active) {
            msNavigationService.deleteItem("trip")
        }
    }
})();

(function(){
    'use strict';
    angular.module('app.trip')
        .controller('TripListMapController', TripListMapController)

    /** @ngInject */
    function TripListMapController(TripsAdapter,$scope,$state,$timeout,$stateParams,TripDetailsPage,MatchedTripStatus,SweetAlert,VehicleStatus,SitesService,MapUtility,FiltersFactory,FiltersRequestParamFactory,OrderRequestParamFactory,MiscUtility,ErrorUtility,ServiceSettings){
        var vm = this


        vm.trips = []
        vm.matchedTripStatus = MatchedTripStatus

        vm.tripsViewed = "..."
        vm.allTripsLength = "..."
        vm.tablePageLimit = 50
        vm.currentTablePageIndex = 1

        vm.selectedSearchFilter = null
        vm.searchFilters = {
            tripId: FiltersFactory.createTripWithIdFilter(),
            tripVehicleReferenceCode: FiltersFactory.createTripWithVehicleReferenceCodeFilter(),
            tripVehicleId: FiltersFactory.createTripWithVehicleIdFilter(),
            tripVehicleLicensePlate: FiltersFactory.createTripWithVehicleLicensePlateFilter(),
            tripVehicleType: FiltersFactory.createTripWithVehicleTypeFilter(),
            tripDeviceType: FiltersFactory.createTripWithDeviceTypeFilter(),
            tripUserId: FiltersFactory.createTripWithUserIdFilter(),
            tripUser: FiltersFactory.createTripWithUserFilter()
        }
        vm.filterRequestParam = null

        vm.cachedTrips = { };

        vm.orderByPossibilities = [
            {name: 'ID', orderBy: OrderRequestParamFactory.orderByTripId},
            {name: 'Started', orderBy: OrderRequestParamFactory.orderByTripStart},
            {name: 'Vehicle ID', orderBy: OrderRequestParamFactory.orderByTripVehicleId},
            {name: 'Vehicle Ref.code', orderBy: OrderRequestParamFactory.orderByTripVehicleReferenceCode},
            {name: 'Vehicle License Plate', orderBy: OrderRequestParamFactory.orderByTripVehicleLicensePlate},
            {name: 'User ID', orderBy: OrderRequestParamFactory.orderByTripUserId}
        ]
        vm.selectedOrderBy = null
        vm.orderRequestParam = null

        vm.getCurrencyValue = MiscUtility.getCurrencyValue

        function setDefaultOrder() {
            vm.selectedOrderBy = {orderBy: OrderRequestParamFactory.orderByTripId, ascOrder: false}
            vm.orderRequestParam = OrderRequestParamFactory.createAOrderRequestParam([vm.selectedOrderBy.orderBy(vm.selectedOrderBy.ascOrder ? 'ASC' : 'DESC')])
        }
        setDefaultOrder()

        vm.onMapInit = function (map) {
            if(vm.mapInitialized){
                return
            }
            vm.mainMap = map
            vm.mapInitialized = true
        }

        vm.focusedTripData = {
            startPoint:{ latitude: 0, longitude: 0, marker: null },
            pausedPoints:[],
            endPoint:{ latitude: 0, longitude: 0, marker: null },
            polyline:null,
            points: [],
            trip: null
        }

        $scope.$on('refreshServiceSettings',function (event) {
            init();
        }) 

        function init() {
            ServiceSettings.getServiceSettings(function(settings) {
                SitesService.getSites(function(){
                    vm.selectedSiteId = SitesService.getSelectedSite()
                })
                $scope.$applyAsync()
            });
        }

        init()

        $scope.$on('siteChanged', function (site) {
            console.log('siteChanged in trips')
            refreshTrips()
        })

        vm.refreshTrips = refreshTrips
        vm.goToListView = goToListView
        vm.goToTripDetails = goToTripDetails
        vm.showTripOnMap = showTripOnMap
        vm.toggleOriginalOrMatchedTripPath = toggleOriginalOrMatchedTripPath

        vm.callGetTrips = callGetTrips
        vm.resetFilters = resetFilters
        vm.resetSearchFilters = resetSearchFilters
        vm.callApplyOrderBy = callApplyOrderBy
        vm.applyOrderBy = applyOrderBy
        vm.goToTablePage = goToTablePage


        // function applySearchForFilter(searchFor){
        //     var filterObj = FiltersFactory.getFilterObj(searchFor.filterKey)

        //     if(filterObj.hasOwnProperty('valueType')){
        //         vm.selectedSearchFilter = filterObj
        //         vm.selectedSearchFilter.selected = searchFor.value
        //     }else{
        //         vm.filters[searchFor.filterKey].selected = searchFor.value
        //     }
            
        //     // callApplyFilters()
        //     vm.applyFilterRowTrigger()
        // }

        function refreshTrips() {

            vm.tripsViewed = "..."
            vm.allTripsLength = "..."
            // console.log("stateparam",$stateParams)
            // if(typeof $stateParams != "undefined" && $stateParams != null && typeof $stateParams.tripId != "undefined"){
            //     // applySearchForFilter({filterKey:'tripId',value: $stateParams.tripId})
            //     vm.applyFilterRowTrigger({filterKey:'tripId',value: $stateParams.tripId})
            //     $stateParams = null
            // }
            
            vm.applyFilterRowTrigger()
        }

        function callGetTrips(params,onCompletionHandler){
            
            vm.trips = []
            vm.tripsViewed = "..."
            vm.allTripsLength = "..."
            
            var paginationRequestParam = {
                limit: vm.tablePageLimit,
                offset: vm.tablePageLimit * (vm.currentTablePageIndex-1)
            }

            if(vm.filterRequestParam !== null && typeof vm.filterRequestParam === "object" && Object.keys(vm.filterRequestParam).length>0){
                //check if a filter was selected
                console.log("callGetTrips: filter param exists")
                paginationRequestParam = FiltersRequestParamFactory.mergeObjects(vm.filterRequestParam,paginationRequestParam)
            }

            if(vm.orderRequestParam !== null && typeof vm.orderRequestParam === "object" && Object.keys(vm.orderRequestParam).length>0){
                //check if orderBy was selected
                console.log("callGetTrips: order param exists")
                paginationRequestParam = FiltersRequestParamFactory.mergeObjects(vm.orderRequestParam,paginationRequestParam)
            }

            if(typeof params !== "undefined" && typeof params === "object" && Object.keys(params).length>0){
                paginationRequestParam = FiltersRequestParamFactory.mergeObjects(params,paginationRequestParam)
            }

            console.log("paginationRequestParam",paginationRequestParam)

            getTrips(paginationRequestParam,
                function(trips,error){
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Get Trips List',description:'Error while getting the trips list!'})

                        if(typeof onCompletionHandler !== "undefined")
                            onCompletionHandler([],error)
                    }else{
                        console.log("last trips",trips[0])
                        vm.tripsViewed = trips.length
                        vm.trips = trips
                        if(typeof onCompletionHandler !== "undefined")
                            onCompletionHandler(trips,null)
                    }
            })
        }

        function getTrips(params,onCompletionHandler){

            if(typeof params == "undefined"){
                params = {}
            }
            vm.isDownloadingData = true

            TripsAdapter.getTrips(
                params,
                function(data,error){
                    vm.isDownloadingData = false
                    if(error){
                        if(typeof onCompletionHandler !== "undefined")
                            onCompletionHandler([],error)
                    } else {
                        var trips = (typeof data.data !== "undefined") ? data.data : data
                        vm.allTripsLength = (typeof data.count !== "undefined") ? data.count : data.length

                        if(trips.length>0){
                            showTripOnMap(trips[0])
                        }

                        if(typeof onCompletionHandler !== "undefined"){
                            onCompletionHandler(trips,null)
                        }  
                        
                    }
                }
            )
        }

        function resetSearchFilters(exceptKey){
            for(var key in vm.searchFilters){
                if(typeof exceptKey !== "undefined"){
                    if(exceptKey !== key)
                        vm.searchFilters[key].selected = null 
                }else{
                    vm.searchFilters[key].selected = null
                }
                
            }
        }

        function resetFilters(){
            //GenericAppData.setFiltersInfo({})
            resetSearchFilters()
            goToTablePageWithIndex(1)
        }

        function resetSearchFilters(exceptKey){
            for(var key in vm.searchFilters){
                if(typeof exceptKey !== "undefined"){
                    if(exceptKey !== key)
                        vm.searchFilters[key].selected = null 
                }else{
                    vm.searchFilters[key].selected = null
                }
            }
        }

        function callApplyOrderBy(orderBy){
            $timeout.cancel(vm.applyOrderByTimeout)
            
            if(vm.selectedOrderBy.orderBy === orderBy){
                return
            }
            
            if(orderBy == null){
                setDefaultOrder()
                goToTablePageWithIndex(1)
                //force md-select model to be updated
                vm.applyOrderByTimeout = $timeout(function(){
                    setDefaultOrder()
                },1000)
                return
            }else {
                vm.selectedOrderBy.orderBy = orderBy
            }

            vm.applyOrderByTimeout = $timeout(function(){
                applyOrderBy()
            },1000)
        }

        function applyOrderBy(){
            console.log("apply order by",vm.selectedOrderBy)

            if(vm.currentTablePageIndex !== 1){
                resetTablePageIndex()
            }

            vm.orderRequestParam = OrderRequestParamFactory.createAOrderRequestParam([vm.selectedOrderBy.orderBy(vm.selectedOrderBy.ascOrder ? 'ASC' : 'DESC')])
            
            // callGetTrips()
            vm.applyFilterRowTrigger()
        }

        function resetTablePageIndex(){
            vm.currentTablePageIndex = 1
        }

        function goToTablePageWithIndex(pageIndex){
            vm.currentTablePageIndex = pageIndex
            goToTablePage()
        }

        function goToTablePage(type){

            if(vm.currentTablePageIndex === 0 || typeof vm.currentTablePageIndex === 'undefined' || vm.currentTablePageIndex === null){
                console.log("currentTablePageIndex not valid")
                vm.currentTablePageIndex = 1
            }

            if(type === 'prev'){

                vm.currentTablePageIndex--
                
                if(vm.currentTablePageIndex < 1){
                    console.log("currentTablePageIndex is 0, reset to 1")
                    vm.currentTablePageIndex = 1
                    return
                }
            }else if(type === 'next'){

                vm.currentTablePageIndex++
            }
            else{
                console.log("case goTo")
            }

            // callGetTrips()
            vm.applyFilterRowTrigger()
        }

        function toggleOriginalOrMatchedTripPath() {

            if(!vm.polyline){
                var path = []

                if(vm.savedTripPaths.matched.length>0){
                    path = vm.savedTripPaths.matched
                }
                else {
                    path = vm.savedTripPaths.raw
                    vm.isMatchedTripShown = false
                }

                setPolylineOnMap(path)
            }
            else {

                if(vm.savedTripPaths.matched.length==0){
                    SweetAlert.swal("No Matched Trip","No matched trip path is avaiable!","error")
                    vm.isMatchedTripShown = true
                    return
                }
                else{
                    if(vm.isMatchedTripShown){
                        updatePolylinePath(vm.savedTripPaths.raw)
                    }
                    else {
                        updatePolylinePath(vm.savedTripPaths.matched)
                    }
                }
            }
        }

        function updatePolylinePath(path) {
            if(vm.polyline && path)
                vm.polyline.setPath(path)
        }

        function setPolylineOnMap(path) {

            vm.polyline = new google.maps.Polyline({
                path: path,
                strokeColor: "#2587F1",
                strokeOpacity: 1.0,
                strokeWeight: 4
            })
            vm.polyline.setMap(vm.mainMap)

            //bind to global polyline
            vm.focusedTripData.polyline = vm.polyline

            //polyline onClick : search nearest point where clicked
            google.maps.event.addListener(vm.polyline, 'click', function (e) {
                var clickedPosition = e.latLng;

                var needle = {
                    minDistance: 9999999999, //silly high
                    index: -1,
                    latlng: null
                };
                vm.polyline.getPath().forEach(function (routePoint, index) {
                    var dist = google.maps.geometry.spherical.computeDistanceBetween(clickedPosition, routePoint);
                    if (dist < needle.minDistance) {
                        needle.minDistance = dist;
                        needle.index = index;
                        needle.latlng = routePoint;
                    }
                });
                // The clicked point on the polyline
                console.log("Clicked position", clickedPosition.toString());
                // The closest point in the polyline
                console.log("Closest position: " + needle.latlng);
                // The closest point index in the polyline
                console.log("Closest position index: " + needle.index);
            });
        }

        function updateTripPositions(trip, responseData) {
            var startPoint = trip.StartPosition
            var endPoint = trip.FinishPosition
            var originalTrip = responseData.raw
            var matchedTrip = responseData.matched
            var path = []
            vm.polyline = null
            vm.savedTripPaths = {raw:[],matched:[]}
            vm.isMatchedTripShown = true
            //check with path to use original or matched

            //calculate and save original trip path
            var originalTripPath = []
            originalTrip.forEach(function (point) {
                originalTripPath.push({lat: point.latitude, lng: point.longitude})
            })
            vm.savedTripPaths.raw = originalTripPath
            path = originalTripPath

            //calculate and save matched trip path only if ready status
            if (matchedTrip.status == vm.matchedTripStatus.READY.value){
                console.log("Matched trip path exists")
                var matchedTripPath = google.maps.geometry.encoding.decodePath(matchedTrip.polyline)
                if(startPoint){
                    matchedTripPath.unshift({lat: startPoint.latitude, lng: startPoint.longitude})
                }
                //add end trip point in decoded polyline matching with endpoint marker
                if(endPoint){
                    matchedTripPath.push({lat: endPoint.latitude, lng: endPoint.longitude})
                }
                vm.savedTripPaths.matched = matchedTripPath
                path = matchedTripPath
            }

            //init path
            toggleOriginalOrMatchedTripPath()

            //check if trip is still in progress so set end point as last point
            // if (!endPoint) {
            //     var lastPoint = path[path.length - 1]
            //     endPoint = {latitude: lastPoint.lat, longitude: lastPoint.lng}

            //     vm.focusedTripData.endPoint.latitude = endPoint.longitude
            //     vm.focusedTripData.endPoint.longitude = endPoint.longitude
            //     vm.focusedTripData.endPoint.marker = endMarker
            // }

            fitMapBounds(path)
        }

        function updateFocusedtripData(trip) {
            var startPoint = trip.StartPosition
            var endPoint = trip.FinishPosition
            
            vm.focusedTripData.startPoint.marker ? vm.focusedTripData.startPoint.marker.setMap(null) : ''
            vm.focusedTripData.pausedPoints.length>0 ? vm.focusedTripData.pausedPoints.forEach(function(pausedPoint){pausedPoint.marker.setMap(null)}) : ''
            vm.focusedTripData.endPoint.marker ? vm.focusedTripData.endPoint.marker.setMap(null) : ''
            vm.focusedTripData.polyline ? vm.focusedTripData.polyline.setMap(null) : ''

            var startMarker = MapUtility.generateTripStartMarker(trip,vm.mainMap)

            vm.focusedTripData.startPoint.latitude = startPoint.latitude
            vm.focusedTripData.startPoint.longitude = startPoint.longitude
            vm.focusedTripData.startPoint.marker = startMarker

            if(trip.StatusChanges){

                vm.parkedStatuses = trip.StatusChanges.filter(function(vehicle){
                    return vehicle.status == VehicleStatus.PARKED.value
                })

                if(vm.parkedStatuses && vm.parkedStatuses.length>0){
                    vm.focusedTripData.pausedPoints = []
                    vm.parkedStatuses.forEach(function(vehicleParked){
                        vehicleParked['SiteId'] = trip.SiteId
                        vm.focusedTripData.pausedPoints.push({marker: MapUtility.generateTripParkedMarker(vehicleParked,vm.mainMap)})
                    })
                }
            }

            //check if trip is still in progress,else create end point
            var endMarker = null
            if(endPoint){
                endMarker = MapUtility.generateTripEndMarker(trip,vm.mainMap)

                vm.focusedTripData.endPoint.latitude = endPoint.latitude
                vm.focusedTripData.endPoint.longitude = endPoint.longitude
                vm.focusedTripData.endPoint.marker = endMarker
            }
        }

        function showTripOnMap(trip){
            console.log('click',trip)
            if(!trip.StartPosition)
                return
            
            if(!trip.Vehicle)
                return
            
            trip.isFocused = true
            vm.focusedTripData.trip ? vm.focusedTripData.trip.isFocused = false : ''
            vm.focusedTripData.trip = trip

            var cachedTrip = vm.cachedTrips[trip.id];
            
            vm.shownGeofenceVehicleTypes = [trip.Vehicle.type]
            
            if(cachedTrip !== undefined && cachedTrip !== null) {
                updateFocusedtripData(cachedTrip.trip)
                updateTripPositions(cachedTrip.trip, cachedTrip.pathResponse)
            } else {
                TripsAdapter.getTrip(trip.id,function (trip,error) {
                    if(error){
                        SweetAlert.swal("Show trip","Error while getting info from server","error")
                    }else{
                        updateFocusedtripData(trip)            
                        TripsAdapter.getTripPositions(trip.id, function(responseData, error){
                            if(!error){
                                updateTripPositions(trip, responseData)
    
                                vm.cachedTrips[trip.id] = {
                                    trip: trip,
                                    pathResponse: responseData
                                }    
                            } else {
                                console.log(error)
                            }
                        })
                    }
                })
            }

            //call getTrip to get statusChanges
            
        }

        function fitMapBounds(points) {
            var bounds = new google.maps.LatLngBounds()

            points.forEach(function (point) {
                bounds.extend(point)
                bounds.extend(point)
            })
            vm.mainMap.fitBounds(bounds)
        }

        function goToListView() {
            $state.go("app.trip.list")
        }

        function goToTripDetails(trip) {
            $state.go(TripDetailsPage,{tripId: trip.id});
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sample', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.sample', {
                url    : '/sample',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sample/sample.html',
                        controller : 'SampleController as vm'
                    }
                },
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sample');

        // Api
        msApiProvider.register('sample', ['app/data/sample/sample.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title : 'SAMPLE',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('fuse.sample', {
            title    : 'Sample',
            icon     : 'icon-tile-four',
            state    : 'app.sample',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SAMPLE.SAMPLE_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(SampleData)
    {
        var vm = this;

        // Data
        vm.helloText = SampleData.data.helloText;

        // Methods

        //////////
    }
})();

(function(){
    'use strict'

    angular
        .module('app.notification-center',[

        ])
        .config(config)

    /** @ngInject */
    function config(){
        
    }
})();
(function(){
    'use strict'

    angular
        .module('app.notification-center')
        .directive("notificationCenter", NotificationCenter)
        .controller("NotificationCenterController", NotificationCenterController)
        .factory("WebSocketFactory",WebSocketFactory)
        .factory("NotificationCenterUtility",NotificationCenterUtility)


    /** @ngInject */
    function NotificationCenter(){
        return{
            restrict:'E',
            scope:{
                count:'='
            },
            controller: ['$scope', '$mdSidenav',"NotificationCenterUtility", NotificationCenterController],
            templateUrl:'app/main/notification-center/notificationCenter.html'
        }

    }
    
    /** @ngInject */
    function NotificationCenterController($scope, $mdSidenav,NotificationCenterUtility){
        var vm = this

        $scope.vm = vm

        vm.toggleSidenav = function(id){
            console.log("Toggle notification center")
            $mdSidenav(id).toggle()
        }

        var loremIpsum = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."

        vm.notifications = {
            geofencing: [],
            notification: [],
            vehicle: []
        }

        vm.notificationCount = 0
        vm.filersCollapsed = true

        checkNotificationCount()


        function checkNotificationCount(){
            vm.notificationCount = vm.notifications.geofencing.length + vm.notifications.vehicle.length + vm.notifications.notification.length
        }

        console.warn("I'm the notification controller")

        var topicTypes = {
            NOTIFICATION:"notification",
            GEOFENCING:"geofencing",
            VEHICLE:"vehicle",
            RESPONSE:"response",
            ERROR:"error"
        }

        vm.topicsSubscription = {
            geofencing:{
                subscribed:false,
                topicName:"Geofencing",
                topic:"geofencing"
            },
            vehicle:{
                subscribed:false,
                topicName:"Vehicle",
                topic:"vehicle"
            },
            notification:{
            subscribed:false,
                topicName:"Notification",
                topic:"notification"
            }
        }

        var topics = [];

        for(var key in vm.topicsSubscription){
            var topicSubscription = vm.topicsSubscription[key]
            if(topicSubscription.subscribed){
                topics.push(topicSubscription.topic)
            }
        }

        NotificationCenterUtility.openAndSubscribeToTopics(topics,onTopicMessageHandler)

        function onTopicMessageHandler(message) {

            console.log("ws message",message)
            //ShowToast.only(event.data)

            $scope.$apply(function () {

                if(message.data!= true){
                    switch (message.type){
                        case topicTypes.GEOFENCING:
                            vm.notifications.geofencing.push(message.data)
                            break;
                        case topicTypes.NOTIFICATION:
                            vm.notifications.notification.push(message.data)
                            break;

                        case topicTypes.VEHICLE:
                            vm.notifications.vehicle.push(message.data)
                            break;
                    }
                    checkNotificationCount()
                }


            })
        }

        function toggleTopicSubscription(topic) {
            var topicSubscription = vm.topicsSubscription[topic]

            if(topicSubscription.subscribed){
                NotificationCenterUtility.unsubscribeToTopic(topic)
            }
            else{
                NotificationCenterUtility.subscribeToTopic(topic)
            }

        }

        vm.toggleTopicSubscription = toggleTopicSubscription
    }

    /** @ngInject */
    function WebSocketFactory() {

        function create(wsUrl,topics) {

            var webSocket = new WebSocket(wsUrl)

            if(typeof topics != "undefined" && topics!=null){

                webSocket.onopen = function (event) {

                    var topic= null

                    for (var topicKey in topics){

                        topic = topics[topicKey]

                        console.log("subscribe to topic " ,topic)

                        webSocket.send(
                            JSON.stringify({
                                type: topic,
                                data:{
                                    listen: true
                                }})
                        )
                    }
                }
            }

            return webSocket
        }

        return {
            create : create
        }
    }

    function NotificationCenterUtility(WebSocketFactory,LocalStorageService,SessionStorageService,TokenData,ServiceTokenData,ShowToast) {

        var notificationCenterWS = null


        function isConnected() {
            var connected = notificationCenterWS != null
            console.log("ws connected: ",connected)
            return  connected
        }

        function sendWsMessage(message) {
            if(message){
                notificationCenterWS.send(
                    JSON.stringify(message)
                )
            }
        }

        function openAndSubscribeToTopics(topics,onMessageHandler) {

            var token = LocalStorageService.getItem(TokenData.TOKEN)
            var serviceToken = null;

            if(typeof token != "undefined"){
                serviceToken = LocalStorageService.getItem(ServiceTokenData.TOKEN)
            }
            else {
                token = SessionStorageService.getItem(TokenData.TOKEN)
                serviceToken = SessionStorageService.getItem(ServiceTokenData.TOKEN)
            }

            var wsUrl = "wss://core.2hire.io/v3/admin/ws/"+serviceToken+"/"+token

            notificationCenterWS = WebSocketFactory.create(wsUrl,topics)

            notificationCenterWS.onmessage = function (event) {

                onMessageHandler(JSON.parse(event.data))

            }
        }

        function subscribeToTopic(topic) {

            if(isConnected() && topic){

                sendWsMessage({
                    type:   topic,
                    data:{
                        listen: true
                    }
                })
            }
        }

        function unsubscribeToTopic(topic) {

            if(isConnected() && topic){

                sendWsMessage({
                    type:   topic,
                    data:{
                        listen: false
                    }
                })
            }
        }

        return{
            openAndSubscribeToTopics: openAndSubscribeToTopics,
            subscribeToTopic: subscribeToTopic,
            unsubscribeToTopic: unsubscribeToTopic
        }

    }

})();
(function(){
    'use strict';
    
    angular.module("app.maintenance")
        .controller("MaintenanceController", MaintenanceController)

        /** @ngInject */
        function MaintenanceController(MaintenanceAdapter, $scope, toDateFilter, DefaultSite, $mdDialog, $document,MaintenanceStatus,MaintenanceType,MaintenanceCategory,MaintenanceUtility,ServiceSettings,MiscUtility,SweetAlert,SitesService) {
            var vm = this
            
            vm.records = []
            vm.searchResults = []
            vm.searchResultsFound = {}
            vm.searchBinded = false
            vm.searchBarQueryLength = { value: 0}
            vm.hashedRecords = {};

            vm.tableFields = {
                recordId: { name: "Record id", sortId: "id",class:"vehicleRowCellSmall", key:'id'},
                vehicleId: { name: "Vehicle id", sortId: "Vehicle.id", class:"vehicleRowCellSmall", type:'render', render: function(v, o){ return o.Vehicle ? o.Vehicle.id : ''}},
                vehicleType: { name: "Vehicle type", type:'render', render: function(v, o){ return o.Vehicle ? o.Vehicle.type : ''} },
                plate: { name: "License plate", sortId: "Vehicle.license_plate", type:'link', link:{goto: "app.vehicle.details",gotoParams: "vehicle", key:'id'}, render: function(val, obj){ return obj.Vehicle ? obj.Vehicle.license_plate : '' } },
                reference_code: { name: "Ref. code" ,sortId: "Vehicle.reference_code", class:"vehicleRowCellBig", type:'render', render: function(v, o){ return o.Vehicle ? o.Vehicle.reference_code : ''}},
                creationDate:{ name: "Creation date", sortId: "start", class:"vehicleRowCellBig"}, type:'render', render:function(v, o){ return o.start ? toDateFilter(o.start, 'dateTime', o.SiteId) : '' },
                completionDate:{ name: "Completion date", sortId: "end", class:"vehicleRowCellBigger", type:'render', render:function(v, o){ return o.end ? toDateFilter(o.end, 'dateTime', o.SiteId) : 'Not completed' }},
                status:{ name: "Status", sortId: "status", type:'render', render:function(v, o){ return vm.getStatusText(o) }  },
                category:{ name: "Category", sortId: "category", type:'render', render:function(v, o){ return vm.getCategoryText(o) }  },
                type:{ name: "Type", sortId: "type", type:'render', render:function(v, o){ return vm.getTypeText(o) } },
                details:{ name: "Go to details",type:'icon-link', icon: {
                    goto: "app.maintenance.detail",
                    gotoParams: "maintenanceId",
                    icon: "icon-information-outline",
                    key: "id",
                } }
            }

            vm.filters = {
                maintenanceState: {
                    selected: null,
                    values: [],
                    descriptions: []
                },
                maintenanceType: {
                    selected: null,
                    values: [],
                    descriptions: []
                },
                maintenanceCategory: {
                    selected: null,
                    values: [],
                    descriptions: []
                }
            }
            vm.maintenanceStatus = MaintenanceStatus
            vm.maintenanceType = MaintenanceType
            vm.maintenanceCategory = MaintenanceCategory

            for (var status in MaintenanceStatus){
                vm.filters.maintenanceState.values.push(MaintenanceStatus[status].value)
                vm.filters.maintenanceState.descriptions.push(MaintenanceStatus[status].name)
            }
            for (var status in MaintenanceType){
                vm.filters.maintenanceType.values.push(MaintenanceType[status].value)
                vm.filters.maintenanceType.descriptions.push(MaintenanceType[status].name)
            }
            for (var status in MaintenanceCategory){
                vm.filters.maintenanceCategory.values.push(MaintenanceCategory[status].value)
                vm.filters.maintenanceCategory.descriptions.push(MaintenanceCategory[status].name)
            }

            vm.dateFilters = {
                start: null,
                end: null
            }

            vm.getStatusText = getStatusText
            vm.getTypeText = getTypeText
            vm.getCategoryText = getCategoryText
            vm.refreshRecords = refreshRecords
            vm.resetFilters = resetFilters
            vm.recordHiddenFilter = recordHiddenFilter
            vm.openRecordAddDialog = openRecordAddDialog

            $scope.$on('refreshServiceSettings',function (event) {
                init();
            })

            function init() {
                ServiceSettings.getServiceSettings(function(settings, error){
                    if(settings.loaded){
                        SitesService.getSites(function(){
                            vm.selectedSiteId = SitesService.getSelectedSite();

                            vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);
                        })
                    }
                });
            }
            init();

            $scope.$on('siteChanged', function (site) {
                console.log('siteChanged in maintenance')
                SitesService.getSites(function(){
                    vm.selectedSiteId = SitesService.getSelectedSite();
                })
                vm.applyFiltersTrigger();
            })

            vm.updateList = updateList

            function updateList (paginationRequestParam, callback, updateInterface) {
                if(updateInterface === undefined) {
                    updateInterface = true;
                }
                MaintenanceAdapter.getRecords(
                    paginationRequestParam,
                    function(records, error){
                        if(error){
                            if (callback !== undefined) {
                                callback(records, error)
                            }
                        }
                        else{

                            if(updateInterface){
                                vm.records = records
        
                                for(var recordIndex in vm.records){
                                    var record = vm.records[recordIndex]
                                    record.start = MiscUtility.createTzMoment(record.created_at, record.SiteId).valueOf()
                                    if(!record.end){
                                        if(record.updated_at && record.status == vm.maintenanceStatus.FINISHED.value){
                                            record.end = MiscUtility.createTzMoment(record.updated_at, record.SiteId).valueOf()
                                        }
                                    }
                                }
                                // console.log("last maintenance record:",vm.records[0])
                                hashRecords(vm.records)
                            }

                            if (callback !== undefined) {
                                callback(records, error);
                            }
                        }
                        
                    }
                )
            }

            function hashRecords(records){
                async.forEachOf(records, function(value, key, callback){
                    var outputString = ""
                    for(var keyInObject in value){
                        var tempValue = value[keyInObject]
                        if(!(tempValue instanceof Object)){
                            if(keyInObject == "sender"){ continue }
                            if(keyInObject == "status"){ tempValue = getStatusText(tempValue) }
                            if(keyInObject == "type"){ tempValue = getTypeText(tempValue) }
                            if(keyInObject == "created_at" || keyInObject == "deleted_at"){ tempValue = toDateFilter(tempValue, "dateTime", value.SiteId) }
                            outputString = outputString + ((tempValue + ",").toLowerCase())
                        }else{
                            if(keyInObject == "Vehicle"){
                                outputString = outputString + ((tempValue.model_name + " " + tempValue.id + " " + tempValue.license_plate + ",").toLowerCase())
                            }
                        }
                        
                    }
                    vm.hashedRecords[outputString] = key
                    callback()
                },function(error){
                    console.log("finished", vm.hashedRecords)
                    if(!vm.searchBinded){
                        var searchBox = angular.element('body').find('#maintenance-list-search');


                        // Bind an external input as a table wide search box
                        if ( searchBox.length > 0 ){

                            searchBox.on('keyup', function (event){
                                
                                
                                var words = event.target.value.split(" ")
                                searchInHashedRecords(words)
                            })
                            vm.searchBinded = true
                        }
                    }
                })
            }

            function searchInHashedRecords(keys){
                vm.searchResults = []
                vm.searchResultsFound = {}
                for(var wordIndex in keys){
                    var word = keys[wordIndex].toLowerCase()
                    async.forEachOf(vm.hashedRecords, function(value, key, callback){
                        if(key.indexOf(word) != -1){
                            if(!vm.searchResultsFound[vm.records[value].id]){
                                vm.searchResults.push(vm.records[value])
                                vm.searchResultsFound[vm.records[value].id] = true
                            }
                            
                        }
                        setTimeout(callback,0)
                    },
                    function(error){
                        $scope.$apply(function(){
                            vm.searchBarQueryLength.value = keys.length
                        })
                    })
                }
            }


            // function hideOrShowByMaintenanceStatus(filters, isFilterNumber){
            //     console.log(filters)
            //     var selectedRecords = {}
            //     if(filters.length == 0){ return }
            //     for(var filterIndex in filters){
            //         var filter = filters[filterIndex]
            //         for(var recordIndex in vm.records){
            //             var record = vm.records[recordIndex]
            //             if(record.isHidden){ continue }
            //             if(record.status == filter){
            //                 selectedRecords[record.id] = true
            //             }
            //         }
            //     }
            //     for(var recordIndex in vm.records){
            //         var record = vm.records[recordIndex]
            //         if(!selectedRecords[record.id]){
            //             record.isHidden = true
            //         }
            //     }
            // }

            // function hideOrShowByMaintenanceType(filters, isFilterNumber){
            //     var selectedRecords = {}
            //     if(filters.length == 0){ return }
            //     for(var filterIndex in filters){
            //         var filter = filters[filterIndex]
            //         for(var recordIndex in vm.records){
            //             var record = vm.records[recordIndex]
            //             if(record.isHidden){ continue }
            //             if(record.type == filter){
            //                 selectedRecords[record.id] = true
            //             }
            //         }
            //     }
            //     for(var recordIndex in vm.records){
            //         var record = vm.records[recordIndex]
            //         if(!selectedRecords[record.id]){
            //             record.isHidden = true
            //         }
            //     }
            // }

            // function hideOrShowByMaintenanceCategory(filters, isFilterNumber){
            //     var selectedRecords = {}
            //     if(filters.length == 0){ return }
            //     for(var filterIndex in filters){
            //         var filter = filters[filterIndex]
            //         for(var recordIndex in vm.records){
            //             var record = vm.records[recordIndex]
            //             if(record.isHidden){ continue }
            //             if(record.category == filter){
            //                 selectedRecords[record.id] = true
            //             }
            //         }
            //     }
            //     for(var recordIndex in vm.records){
            //         var record = vm.records[recordIndex]
            //         if(!selectedRecords[record.id]){
            //             record.isHidden = true
            //         }
            //     }
            // }

            // function hideOrShowByDate(){
            //     if(!vm.dateFilters.start || !vm.dateFilters.end){ return }
            //     for(var recordIndex in vm.records){
            //         var record = vm.records[recordIndex]
            //         var startFilter = vm.dateFilters.start.getTime()
            //         var endFilter = vm.dateFilters.end.getTime()
            //         var startDate = new Date(record.created_at)
            //         var endDate = new Date(record.updated_at)
            //         if(!(startFilter < startDate.getTime() && endFilter > endDate.getTime())){
            //             record.isHidden = true
            //         }else{
            //             record.isHidden = false
            //         }
            //     }
            // }

            function resetFilters(){
                for(var recordIndex in vm.records){
                    var record = vm.records[recordIndex]
                    record.isHidden = false
                }
                vm.dateFilters.start = null
                vm.dateFilters.end = null
                for(var filterIndex in vm.filters){
                    vm.filters[filterIndex].selected = null
                }
                vm.applyFiltersTrigger();
            }

            // function showEveryRecord(){
            //     for(var recordIndex in vm.records){
            //         vm.records[recordIndex].isHidden = false
            //     }
            // }

            function getStatusText(record){
                return MaintenanceUtility.getMaintenanceStatusDescription(record)
            }

            function getTypeText(record) {
                return MaintenanceUtility.getMaintenanceTypeDescription(record)
            }

            function getCategoryText(record) {
                return MaintenanceUtility.getMaintenanceCategoryDescription(record)
            }

            function refreshRecords(){
                vm.applyFiltersTrigger();
            }

            // function sortListBy(property){
            //     if(vm.sortProperty && !vm.sortReversed){
            //         vm.sortProperty = null
            //         vm.sortReversed = false
            //         return
            //     }
            //     vm.sortProperty = property
            //     vm.sortReversed = !vm.sortReversed
            // }

            function recordHiddenFilter(value){
                return !value.isHidden
            }

            // function goToDetails(recordId) {
            //     $state.go("app.maintenance.detail",{maintenanceId: recordId})
            // }

            // function goToVehicleDetail(vehicle){
            //     $state.go("app.vehicle.details",{vehicle: vehicle})
            // }

            // function exportListAsCSV() {
            //     var valuesToWrite = []
            //     var outputArray = []
            //     var outputString = ""
            //     const semicolonString=";"
            //     const endLineString="\n"
            //     const dateTimeFormat = "dd/MM/yyyy HH:mm:ss"
            //     var headerListLength = Object.keys(vm.tableFields).length
            //     var index = 0
            //     for (var key in vm.tableFields) {
            //         if(index<=headerListLength-2){
            //             outputString+=vm.tableFields[key].name
            //             if(index == headerListLength-2){
            //                 outputString+=endLineString
            //             }
            //             else{
            //                 outputString+=semicolonString
            //             }
            //             index++
            //         }
            //     }

            //     if(vm.searchBarQueryLength.value>0){
            //         valuesToWrite = vm.searchResults
            //     }
            //     else {
            //         valuesToWrite = vm.records
            //     }

            //     valuesToWrite.forEach(function (record) {

            //         if (!record.isHidden){
            //             outputString += record.id + semicolonString
            //             outputString += record.Vehicle.id + semicolonString
            //             outputString += record.Vehicle.type + semicolonString
            //             outputString += record.Vehicle.license_plate + semicolonString
            //             outputString += record.Vehicle.reference_code + semicolonString
            //             outputString += toDateFilter(record.start,dateTimeFormat) + semicolonString
            //             outputString += (record.end ? toDateFilter(record.end,dateTimeFormat) : 'Not completed') + semicolonString
            //             outputString += vm.getStatusText(record) + semicolonString
            //             outputString += vm.getCategoryText(record) + semicolonString
            //             outputString += vm.getTypeText(record)
            //             outputString += endLineString
            //         }
            //     })
            //     outputArray.push(outputString)

            //     GenerateCSVService.generate(outputArray)
            // }


            function openRecordAddDialog(ev, vehicle) {
                if(Number(vm.selectedSiteId) === DefaultSite.id) {
                    SweetAlert.swal(
                        "You must select a site!",
                        "Inserting maintenance records is not allowed when viewing All Sites, please select a site and try again",
                        "error"
                    );
                    return;
                }
                
                return $mdDialog.show({
                    controller         : 'AddMaintenanceRecordDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/maintenance/dialogs/maintenance-add-record-dialog.html',
                    parent             : angular.element($document.body),
                    targetEvent        : ev,
                    clickOutsideToClose: true
                });

            }

        }

})();

/**
 * Created by alex on 23/08/17.
 */

(function () {
    'use strict';

    angular
        .module('app.invoice')
        .controller('InvoicesController', InvoicesController)
        .factory('InvoicesDialogFactory', InvoicesDialogFactory);

    /** @ngInject */
    function InvoicesController(
        $scope,
        InvoicesAdapter,
        $state,
        InvoiceUtility,
        TransactionUtility,
        InvoiceStatus,
        InvoiceType,
        InvoiceDetailsPage,
        InvoicesDialogFactory,
        FiltersFactory,
        OrderRequestParamFactory,
        ServiceSettings,
        MiscUtility,
        SweetAlert,
        SitesService,
        ErrorUtility,
        DefaultSite,
        ServiceData,
        AppConfigurations
    ) {
        var vm = this;

        vm.invoices = [];
        vm.allInvoices = [];
        vm.invoicesViewed = '...';
        vm.allInvoicesLength = '...';
        vm.allInvoicesEnabled = false;

        vm.invoiceStatus = InvoiceStatus;
        vm.invoiceType = InvoiceType;

        vm.enableBulkCharge = false;

        vm.tablePageLimit = 50;
        vm.currentTablePageIndex = 1;

        vm.filters = {
            // invoiceType: FiltersFactory.createInvoiceWithTypeFilter(),
            //invoiceStatus: FiltersFactory.createInvoiceWithStatusFilter(),
            // invoiceDataStart: FiltersFactory.createInvoiceWithDateStartFilter(),
            // invoiceDataEnd: FiltersFactory.createInvoiceWithDateEndFilter(),
        };

        vm.searchFilters = {
            // invoiceStatus: FiltersFactory.createInvoiceWithStatusFilter(),
            invoiceCode: FiltersFactory.createInvoiceWithCodeFilter(),
            invoiceUserId: FiltersFactory.createInvoiceWithUserIdFilter(),
            invoiceUser: FiltersFactory.createInvoiceWithUserFilter(),
            invoiceType: FiltersFactory.createInvoiceWithTypeFilter(),
            invoiceDate: FiltersFactory.createInvoiceWithDateRangeFilter(),
        };

        // vm.resetFilters = resetFilters;

        vm.filterRequestParam = null;
        vm.orderRequestParam = null;
        vm.selectedOrderBy = { orderBy: OrderRequestParamFactory.orderByInvoiceCode, ascOrder: false };

        $scope.$on('refreshServiceSettings', function (event) {
            init();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings, error) {
                if (settings.loaded) {
                    SitesService.getSites(function () {
                        vm.selectedSiteId = SitesService.getSelectedSite();
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);

                        vm.tableFields = AppConfigurations.getInvoiceListTableFields();
                    });
                }
            });
        }
        init();

        $scope.$on('siteChanged', function (site) {
            console.log('siteChanged in invoices');
            SitesService.getSites(function () {
                vm.selectedSiteId = SitesService.getSelectedSite();
            });
            vm.applyFiltersTrigger();
        });

        vm.goToInvoiceDetails = goToInvoiceDetails;
        vm.getInvoiceTypeDescription = getInvoiceTypeDescription;
        vm.getInvoiceStatusDescription = getInvoiceStatusDescription;
        vm.getInvoicePaymentStatusDescription = getInvoicePaymentStatusDescription;
        vm.rectifyThisInvoice = rectifyThisInvoice;
        vm.addAInvoice = addAInvoice;
        vm.addBulkCharges = addBulkCharges;
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger;
        vm.refreshInvoices = refreshInvoices;

        function getServiceData() {
            ServiceData.getServiceData(function (service, error) {
                if (error) {
                } else {
                    if (service.name && (service.name.indexOf('movo') !== -1 || service.name.indexOf('2hire') !== -1)) {
                        vm.enableBulkCharge = true;
                    }
                }
            });
        }
        getServiceData();

        function refreshInvoices(paginationRequestParam, callback, updateInterface) {
            if (updateInterface === undefined) {
                updateInterface = true;
            }
            if (updateInterface) {
                vm.invoicesViewed = '...';
                vm.allInvoicesLength = '...';
            }
            // if($stateParams.searchFor) {
            //     console.log("stateParams",$stateParams.searchFor)
            //     vm.applyFiltersTrigger($stateParams.searchFor)
            //     $stateParams.searchFor = null;
            // } else {

            //check paginationRequestParam if rectify invoice call
            if (typeof paginationRequestParam == 'undefined' || paginationRequestParam == null) {
                paginationRequestParam = {
                    limit: vm.tablePageLimit,
                    offset: vm.tablePageLimit * (vm.currentTablePageIndex - 1),
                };
            }

            InvoicesAdapter.getInvoices(paginationRequestParam, function (data, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Invoices List',
                        description: 'Error while getting the invoices list!',
                    });

                    if (callback !== undefined) {
                        callback(data, error);
                    }
                } else {
                    if (updateInterface) {
                        var invoices = typeof data.data !== 'undefined' ? data.data : data;
                        vm.allInvoicesLength = typeof data.count !== 'undefined' ? data.count : data.length;
                        vm.invoicesViewed = invoices.length;
                        if (invoices) {
                            vm.invoices = invoices;
                        }
                    }

                    if (callback !== undefined) {
                        callback(data, error);
                    }
                }
            });
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger() {
            vm.applyFiltersTrigger();
        }

        // function resetFilters(){
        //     resetStaticFilters()
        // }

        // function resetStaticFilters(){
        //     for(var key in vm.filters){
        //         vm.filters[key].selected = null
        //     }
        //     vm.applyFiltersTrigger()
        // }

        function goToInvoiceDetails(invoice) {
            $state.go(InvoiceDetailsPage, { invoice: invoice });
        }

        function getInvoiceTypeDescription(invoice) {
            return InvoiceUtility.getInvoiceTypeDescription(invoice);
        }
        function getInvoiceStatusDescription(invoice) {
            return InvoiceUtility.getInvoiceStatusDescription(invoice);
        }
        function getInvoicePaymentStatusDescription(transaction) {
            return TransactionUtility.getTransactionStatusDescription(transaction);
        }

        function rectifyThisInvoice(invoice, ev) {
            if (invoice && invoice.type == vm.invoiceType.TICKET.value) {
                InvoicesDialogFactory.manage(ev, invoice).then(function ok(refresh) {
                    if (refresh) {
                        refreshInvoices();
                    }
                });
            }
        }

        function addAInvoice(ev) {
            if (Number(vm.selectedSiteId) === DefaultSite.id) {
                SweetAlert.swal(
                    'You must select a site!',
                    'Inserting invoices is not allowed when viewing All Sites, please select a site and try again',
                    'error'
                );
                return;
            }

            InvoicesDialogFactory.manage(ev).then(function ok(refresh) {
                if (refresh) {
                    refreshInvoices();
                }
            });
        }

        function addBulkCharges(ev) {
            InvoicesDialogFactory.showBulkChargesDialog(ev).then(function ok(refresh) {
                if (refresh) {
                    refreshInvoices();
                }
            });
        }
    }
})();

/** @ngInject */
function InvoicesDialogFactory($mdDialog, $document) {
    return {
        manage: function (ev, invoice) {
            var dialogType = invoice ? 'edit' : 'add';

            return $mdDialog.show({
                controller: 'ManageInvoiceDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/invoices/dialogs/invoice-manage-dialog.html',
                parent: angular.element($document.body), //angular.element($document.find('#content-container'))
                targetEvent: ev,
                locals: {
                    Invoice: invoice,
                    dialogType: dialogType,
                },
            });
        },
        showBulkChargesDialog: function (ev) {
            return $mdDialog.show({
                controller: 'BulkChargesDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/invoices/dialogs/bulk-charges/bulk-charges-dialog.html',
                parent: angular.element($document.body), //angular.element($document.find('#content-container'))
                targetEvent: ev,
            });
        },
    };
}

/**
 * Created by alex on 08/02/17.
 */
(function () {

    'use strict';

    angular.module('app.obd_data',[])
        .config(config);


    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider,msNavigationServiceProvider) {

        $stateProvider
            .state('app.obd_data',{
                url:"/obd-data",
                views:{
                    'content@app':{
                        templateUrl:"app/main/data/obd-data.html",
                        controller:"ObdDataListController as vm"
                    }
                }
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/data');

        msNavigationServiceProvider.saveItem('obd_data', {
            title: 'OBD Data',
            icon : 'icon-data',
            state: 'app.obd_data',
            weight:20
        });
    }


})();

/**
 * Created by alex on 08/02/17.
 */
(function () {

    'use strict'

    angular.module('app.obd_data')
        .controller('ObdDataListController',ObdDataListController)


    /** @ngInject */
    function ObdDataListController($scope,DTOptionsBuilder,DTColumnBuilder,$q,$interval,$timeout,ServiceSettings) {

        var vm = this;
        var pastTime = null;
        vm.obdData =[];
        
        // Options

        vm.dtInstance={}

        vm.dtOptions = DTOptionsBuilder
            .fromFnPromise(function() {
                var deferred = $q.defer();

                deferred.resolve(vm.obdData)

                return deferred.promise;
            })
            .withPaginationType('simple')
            .withDisplayLength(20)
            .withOption('lengthMenu', [10, 20, 30, 50, 100])
            .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('scrollY', 'auto')
            .withOption('responsive',true)

        vm.dtColumns = [
            DTColumnBuilder.newColumn('license_plate').withTitle('License Plate'),
            DTColumnBuilder.newColumn('type').withTitle('Type'),
            DTColumnBuilder.newColumn('value').withTitle('Value'),
            DTColumnBuilder.newColumn('time').withTitle('Received')
        ];

        /*vm.dtOptions = {

            initComplete: function () {

                var api = this.api();
                var searchBox = angular.element('body').find('#obdData-list-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            scrollY: 'auto',
            responsive: true
        };*/

        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })
        
        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    SitesService.getSites(function(){
                        vm.selectedSiteId = SitesService.getSelectedSite()
                        pastTime = MiscUtility.createTzMoment().valueOf() - 10000;
                    })
                }
            });
        }
        init()

        $interval(function () {

            vm.dtInstance.changeData(function () {
                var deferred = $q.defer();
                var time = (MiscUtility.createTzMoment().valueOf() - pastTime) / 1000;
                time.toPrecision(2);
                vm.obdData.unshift({license_plate: 2, type: "type", value: "value",time:time})

                deferred.resolve(vm.obdData)

                return deferred.promise;
            })

        },2000);

        //Data


        //Methods
    }
})();

/**
 * Created by alex on 10/01/17.
 */
(function () {

    'use strict';

    angular.module('app.dashboard',[])
        .value("DashboardPage","app.dashboard")
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider,$translatePartialLoaderProvider) {

        $stateProvider
            .state('app.dashboard',{
                url: "/dashboard",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard-home.html',
                        controller : 'DashboardController as vm'
                    }
                }
            });



        msNavigationServiceProvider.saveItem('dashboard',{
            title : 'Dashboard',
            icon  : 'icon-tile-four',
            state: 'app.dashboard',
            weight: 1
        });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dashboard');

        // Api
        // msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);

        //chart js color;

        //ChartJsProvider.setOptions({ colors : [ '#803690', '#00ADF9', '#DCDCDC', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'] });
        // ChartJsProvider.setOptions({ colors : ['#9c51d4', '#d9d6d6', '#494ccc', '#4dc3f0', '#3ebcb3', '#63d773', '#f6a341', '#e24a50'] })

    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("dashboard")
        
        if(!active) {
            msNavigationService.deleteItem("dashboard")
        }
    }

})();

/**
 * Created by alex on 10/01/17.
 */
(function () {

    'use strict';

    angular.module('app.dashboard')
        .controller('DashboardController',DashboardController);

    /** @ngInject */
    function DashboardController($state,$scope,VehicleAnalyticsAdapter,UserAnalyticsAdapter,TripAnalyticsAdapter,ToHireDefaultColor, MapUtility,TripsListPage,VehiclesListPage,VehicleTripStatus,VehicleStatus,VehicleExternalStatus,UserStatus,UsersListPage,ServiceSettings,MiscUtility,SitesService,AppConstants) {

        var vm = this;

        // Data

        // vm.dashboardData = DashboardData;
        vm.toHireDefaultColor = ToHireDefaultColor;
        // vm.projects = vm.dashboardData.projects;
        vm.previusInfoWindow = null
        vm.vehicleTripStatus = VehicleTripStatus
        vm.vehicleStatus = VehicleStatus
        vm.vehicleExternalStatus = VehicleExternalStatus
        vm.userStatus = UserStatus

        var refreshDataInterval = MiscUtility.createRefreshDataInterval(refreshWidgets, AppConstants.REFRESHDATAINTERVAL)
        //set date

        vm.batteriesStatuses = {
            fullCharge: { description: "Full charged", id: "full", color: ToHireDefaultColor.blue, filterIsOn: true, batteries: [] },
            halfBattery: { description: "Up to 50%", id: "half", color: ToHireDefaultColor.azure, filterIsOn: true, batteries: [] },
            lowCharge: { description: "Low charge", id: "low", color: ToHireDefaultColor.lobster, filterIsOn: true, batteries: [] },
            critical: { description: "Critical level", id: "critical", color: ToHireDefaultColor.criticalRed, filterIsOn: true, batteries: [] }
        }

        vm.vehicles = {
            active: { isLoading: false, data: [], encounteredError: false, updated: null },
            inactive: { isLoading: false, data: [], encounteredError: false, updated: null },
            underMaintenance: { isLoading: false, data:[], encounteredError: false, updated: null },
            trip: { isLoading: false, data: [], encounteredError: false, updated: null },
            parked: { isLoading: false, data: [], encounteredError: false, updated: null },
            //paused: { isLoading: false, data: [], encounteredError: false, updated: null },
            outsideOperatingArea: { isLoading: false, data: [], encounteredError: false, updated: null },
            lowBattery: { isLoading: false, data: [], encounteredError: false, updated: null },
            connectionIssue: { isLoading: false, data: [], encounteredError: false, updated: null },
            actionNeeded: { isLoading: false, data:[], encounteredError: false, updated: null }
        }

        vm.users = {
            incompleteSignUp: { isLoading: false, data: [], encounteredError: false, updated: null },
            verificationPending: { isLoading: false, data: [], encounteredError: false, updated: null },
            fullyRegistered: { isLoading: false, data:[], encounteredError: false, updated: null }
        }

        vm.trips = {
            booked: { isLoading: false, data: [], encounteredError: false, updated: null },
            riding: { isLoading: false, data:[], encounteredError: false, updated: null },
            paused: { isLoading: false, data: [], encounteredError: false, updated: null },
            finished: { isLoading: false, data: [], encounteredError: false, updated: null }
        }

        vm.activeScooters = { value: 0 };
        vm.inactiveScooters = { value: 0 };
        vm.maintenanceScooters = { value: 0 };

        vm.tripScooters = { value: 0 };
        vm.parkedScooters = { value: 0 };
        vm.pausedScooters = { value: 0 };
        vm.outsideOperatingAreaScooters = { value: 0 };
        vm.lowBatteryScooters = { value: 0 };
        vm.connectionIssueScooters = { value: 0 };
        vm.actionNeededScooters = { value: 0 };
        vm.unavailableScooters = { value: 0 };

        vm.fullBatteries = { value: 0 };
        vm.halfChargedBatteries = { value: 0 };
        vm.lowBatteries = { value: 0 };
        vm.criticalLowBatteries = { value: 0 };

        vm.activatedUsers = { value: 0 };
        vm.incompleteSignUpUsers = { value: 0 };
        vm.fullyRegisteredUsers = { value: 0 };
        vm.blockedUsers = { value: 0 };
        vm.paymentFailedUsers = { value: 0 };

        vm.bookedTrips = { value: 0 };
        vm.ridingTrips = { value: 0 };
        vm.preRidingTrips = { value: 0 };
        vm.pausedTrips = { value: 0 };
        vm.finishedTrips = { value: 0 };

        vm.mapMarkers = []

        vm.markerClusterer = null
        vm.mapBounds = null

        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })

        function init() {
            ServiceSettings.getServiceSettings(function(settings){
                if(settings.loaded) {
                    SitesService.getSites(function(){
                        vm.selectedSiteId = SitesService.getSelectedSite()
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);

                        var aDay = 86400000;
                        var SevenDaysAgo = vm.todayDate.getTime() - aDay;

                        vm.options = {
                            fromDate: new Date(SevenDaysAgo),
                            toDate: vm.todayDate,
                        }
                    })
                }

            });
        }

        // cause if resolve viewContentLoaded seems to be triggered before
        $scope.$on('$viewContentLoaded', function(){
            vm.refreshWidgets()
        })

        $scope.$on('siteChanged', function (site) {
            console.log('siteChanged in dashboard page')
            vm.refreshWidgets()
        })

        $scope.$on('$destroy', function () {
            if(refreshDataInterval){
                refreshDataInterval.stop()
                refreshDataInterval = null
            }
        })

        // vm.onMapInit = function (map) {
            
        //     if(vm.mapInitialized){
        //         return
        //     }
        //     vm.mainMap = map
        //     vm.mapInitialized = true
        //     updateBatteriesAndRelatedMarkers()
        // }


        function refreshWidgets() {

            refreshCurrentVehiclesStatusWidgets()
            refreshUsersStatusWidget()
            refreshTripsStatusWidget()

            // if(vm.mainMap){
            //     updateBatteriesAndRelatedMarkers()
            // }
        }
        vm.refreshWidgets = refreshWidgets

        vm.updateActiveScooters = updateActiveScooters
        vm.updateInactiveScooters = updateInactiveScooters
        /*vm.updateScootersUnderMaintenance = updateScootersUnderMaintenance
        vm.updateTripScooters = updateTripScooters
        vm.updateParkedScooters = updateParkedScooters
        vm.updatePausedScooters = updatePausedScooters
        vm.updateOutsideOperatingAreaScooters = updateOutsideOperatingAreaScooters
        vm.updateLowBatteryScooters = updateLowBatteryScooters
        vm.updateConnectionIssueScooters = updateConnectionIssueScooters
        vm.updateActionNeededScooters = updateActionNeededScooters*/

        /*vm.updateIncompleteSignUpUsers = updateIncompleteSignUpUsers
        vm.updateVerificationPendingUsers = updateVerificationPendingUsers
        vm.updateFullyRegisteredUsers = updateFullyRegisteredUsers*/

        /*vm.updateBookedTrips = updateBookedTrips
        vm.updateRidingTrips = updateRidingTrips
        vm.updatePausedTrips = updatePausedTrips
        vm.updateFinishedTrips = updateFinishedTrips*/

        vm.batteryFilterSelectedWithLevel = batteryFilterSelectedWithLevel
        vm.focusBatteryOnMap = focusBatteryOnMap

        vm.refreshWidgetsOnDateChange = function () {
            console.log('not implemented')
        };

        vm.goToDetails = function(vehicle){
            $state.go("app.vehicle.details",{vehicle: vehicle})
        }
        vm.goToVehiclesWithStatus = function(vehicleStatus){
            console.log("goToVehiclesList status",vehicleStatus)
            console.log("goToVehiclesList",typeof vehicleStatus)

            var searchForObj = {filterKey: "",value: ""}
            
            if(typeof vehicleStatus == "string"){
                searchForObj.filterKey = 'vehicleStatus'
                searchForObj.value = vehicleStatus
            }
            else{
                searchForObj.filterKey = 'vehicleStatus'
                searchForObj.value = vehicleStatus.value                
            }
            $state.go(VehiclesListPage,{searchFor: searchForObj})
        }
        vm.goToVehiclesWithExternalStatus = function(vehicleStatus){
            console.log("goToVehiclesList ext status",vehicleStatus)
            console.log("goToVehiclesList",typeof vehicleStatus)

            var searchForObj = {filterKey: "",value: ""}
            
            if(typeof vehicleStatus == "string"){
                searchForObj.filterKey = 'vehicleExternalStatus'
                searchForObj.value = vehicleStatus
            }
            else{
                searchForObj.filterKey = 'vehicleExternalStatus'
                searchForObj.value = vehicleStatus.value                
            }
            $state.go(VehiclesListPage,{searchFor: searchForObj})
        }
        vm.goToTripsList = function(vehicleTripStatus){
            console.log("goToTripsList",vehicleTripStatus)
            var searchForObj = {filterKey: "",value: ""}

            if(typeof vehicleTripStatus == "string"){
                searchForObj.filterKey = 'tripStatus'
                searchForObj.value = String(vehicleTripStatus)
            }
            else{
                searchForObj.filterKey = 'tripStatus'
                searchForObj.value = String(vehicleTripStatus.value)
            }
            $state.go(TripsListPage,{searchFor: searchForObj})
        }
        vm.goToUsersList = function(userStatus){
            console.log("goToUsersList",userStatus)
            $state.go(UsersListPage,{searchFor: {filterKey: "userStatus",value: userStatus.value}})
        }
        vm.goToUserDetails = function(user){
            $state.go("app.user.details",{user: user})
        }
        
        function refreshCurrentVehiclesStatusWidgets() {

            vm.activeScooters = { value: '...' };
            vm.inactiveScooters = { value: '...' };
            vm.maintenanceScooters = { value: '...' };

            vm.tripScooters = { value: '...' };
            vm.parkedScooters = { value: '...' };
            vm.pausedScooters = { value: '...' };
            vm.outsideOperatingAreaScooters = { value: '...' };
            vm.lowBatteryScooters = { value: '...' };
            vm.connectionIssueScooters = { value: '...' };
            vm.actionNeededScooters = { value: '...' };
            vm.unavailableScooters = { value: '...' };

            vm.fullBatteries = { value: '...' };
            vm.halfChargedBatteries = { value: '...' };
            vm.lowBatteries = { value: '...' };
            vm.criticalLowBatteries = { value: '...' };

            VehicleAnalyticsAdapter.getFleetStatus(function(response, error){
                if(error){
                    console.log(error)
                }else{
                    // console.log("fleetStatus",response)
                    vm.activeScooters.value = response.active
                    vm.inactiveScooters.value = response.inactive
                    vm.maintenanceScooters.value = response.maintenance
                    //vm.scooterError.value = response.vehicle_error

                    /*vm.fullBatteries.value = response.battery_full_charge
                    vm.halfChargedBatteries.value = response.battery_50
                    vm.lowBatteries.value = response.battery_swap_low
                    vm.criticalLowBatteries.value = response.battery_swap_high*/
                    if(refreshDataInterval){
                        refreshDataInterval.reset()
                    }
                }
            })

            VehicleAnalyticsAdapter.getVehiclesStatus(function(response, error){
                if(error){
                    console.log(error)
                }else{
                    // console.log("vehiclesStatus",response)

                    vm.tripScooters.value = response.trip
                    vm.parkedScooters.value = response.parked
                    vm.pausedScooters.value = response.paused
                    vm.outsideOperatingAreaScooters.value = response.outside_geofence
                    vm.lowBatteryScooters.value = response.low_battery
                    vm.connectionIssueScooters.value = response.connection_issues
                    vm.maintenanceScooters.value = response.repair_shop
                    vm.actionNeededScooters.value = response.minor_action_needed + response.major_action_needed
                    vm.unavailableScooters.value = response.unavailable
                }
            })
        }

        function updateActiveScooters(){
            if(vm.vehicles.active.updated != null && (moment().valueOf() - vm.vehicles.active.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.active.isLoading = true
            VehicleAnalyticsAdapter.getActiveScooters(function(response, error){
                vm.vehicles.active.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.active.encounteredError = true
                }else{
                    vm.vehicles.active.updated = moment().valueOf()
                    vm.vehicles.active.data = response
                }
            })
        }

        function updateInactiveScooters(){
            if(vm.vehicles.inactive.updated != null && (moment().valueOf() - vm.vehicles.inactive.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.inactive.isLoading = true
            VehicleAnalyticsAdapter.getInactiveScooters(function(response, error){
                vm.vehicles.inactive.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.inactive.encounteredError = true
                }else{
                    vm.vehicles.inactive.updated = moment().valueOf()
                    vm.vehicles.inactive.data = response
                }
            })
        }

        /*function updateScootersUnderMaintenance(){
            if(vm.vehicles.underMaintenance.updated != null && (moment().valueOf() - vm.vehicles.underMaintenance.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.underMaintenance.isLoading = true
            VehicleAnalyticsAdapter.getScootersInMaintenance(function(response, error){
                vm.vehicles.underMaintenance.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.underMaintenance.encounteredError = true
                }else{
                    vm.vehicles.underMaintenance.updated = moment().valueOf()
                    vm.vehicles.underMaintenance.data = response
                }
            })
        }

        function updateTripScooters(){
            if(vm.vehicles.trip.updated != null && moment().valueOf() - vm.vehicles.trip.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.trip.isLoading = true
            VehicleAnalyticsAdapter.getVehicleInterventionNeeded(function(response, error){
                vm.vehicles.actionNeeded.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.actionNeeded.encounteredError = true
                }else{
                    vm.vehicles.actionNeeded.updated = moment().valueOf()
                    vm.vehicles.actionNeeded.data = response
                }
            })
        }
        function updateParkedScooters(){
            if(vm.vehicles.parked.updated != null && (moment().valueOf() - vm.vehicles.parked.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.parked.isLoading = true
        }
        function updatePausedScooters(){
            if(vm.vehicles.paused.updated != null && (moment().valueOf() - vm.vehicles.paused.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.paused.isLoading = true
        }
        function updateOutsideOperatingAreaScooters(){
            if(vm.vehicles.outsideOperatingArea.updated != null && (moment().valueOf() - vm.vehicles.outsideOperatingArea.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.outsideOperatingArea.isLoading = true
        }
        function updateLowBatteryScooters(){
            if(vm.vehicles.lowBattery.updated != null && (moment().valueOf() - vm.vehicles.lowBattery.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.lowBattery.isLoading = true
        }
        function updateConnectionIssueScooters(){
            if(vm.vehicles.connectionIssue.updated != null && (moment().valueOf() - vm.vehicles.connectionIssue.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.connectionIssue.isLoading = true
        }
        function updateActionNeededScooters(){
            if(vm.vehicles.actionNeeded.updated != null && (moment().valueOf() - vm.vehicles.actionNeeded.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.actionNeeded.isLoading = true
            VehicleAnalyticsAdapter.getVehicleInterventionNeeded(function(response, error){
                vm.vehicles.actionNeeded.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.actionNeeded.encounteredError = true
                }else{
                    vm.vehicles.actionNeeded.updated = moment().valueOf()
                    vm.vehicles.actionNeeded.data = response
                }
            })
        }

        function updateVehicleInError(){
            if(vm.vehicles.scooterError.updated != null && (moment().valueOf() - vm.vehicles.scooterError.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.vehicles.scooterError.isLoading = true
            VehicleAnalyticsAdapter.getVehicleInError(function(response, error){
                vm.vehicles.scooterError.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.scooterError.encounteredError = true
                }else{
                    vm.vehicles.scooterError.updated = moment().valueOf()
                    vm.vehicles.scooterError.data = response
                }
            })
        }*/

        function refreshUsersStatusWidget() {

            vm.activatedUsers = { value: '...' };
            vm.incompleteSignUpUsers = { value: '...' };
            vm.fullyRegisteredUsers = { value: '...' };
            vm.blockedUsers = { value: '...' };
            vm.paymentFailedUsers = { value: '...' };

            UserAnalyticsAdapter.getUsersStatus(function(response, error){
                if(error){
                    console.error(error)
                }else{
                    // console.log("userStatus",response)
                    vm.activatedUsers.value = response.activated
                    vm.incompleteSignUpUsers.value = response.incomplete_sign_up
                    vm.fullyRegisteredUsers.value = response.verification_pending
                    vm.blockedUsers.value = response.blocked
                    vm.paymentFailedUsers.value = response.payment_failed
                }
            })
        }

        /*function updateIncompleteSignUpUsers(){
            if(vm.users.incompleteSignUp.updated != null && (moment().valueOf() - vm.users.incompleteSignUp.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.users.incompleteSignUp.isLoading = true

            /*UserAnalyticsAdapter.getUserIncompleteSignUp(function(response, error){
                vm.vehicles.scooterError.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.scooterError.encounteredError = true
                }else{
                    vm.vehicles.scooterError.updated = moment().valueOf()
                    vm.vehicles.scooterError.data = response
                }
            })
        }

        function updateVerificationPendingUsers(){
            if(vm.users.verificationPending.updated != null && (moment().valueOf() - vm.users.verificationPending.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.users.verificationPending.isLoading = true

            /*UserAnalyticsAdapter.getUserIncompleteSignUp(function(response, error){
                vm.vehicles.scooterError.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.scooterError.encounteredError = true
                }else{
                    vm.vehicles.scooterError.updated = moment().valueOf()
                    vm.vehicles.scooterError.data = response
                }
            })
        }

        function updateFullyRegisteredUsers(){
            if(vm.users.fullyRegistered.updated != null && (moment().valueOf() - vm.users.fullyRegistered.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.users.fullyRegistered.isLoading = true

            /*UserAnalyticsAdapter.getUserIncompleteSignUp(function(response, error){
                vm.vehicles.scooterError.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.scooterError.encounteredError = true
                }else{
                    vm.vehicles.scooterError.updated = moment().valueOf()
                    vm.vehicles.scooterError.data = response
                }
            })
        }*/

        function refreshTripsStatusWidget() {

            vm.bookedTrips = { value: '...' };
            vm.ridingTrips = { value: '...' };
            vm.preRidingTrips = { value: '...' };
            vm.pausedTrips = { value: '...' };
            vm.finishedTrips = { value: '...' };

            TripAnalyticsAdapter.getTripsStatus(function (response,error) {

                if(error){
                    console.log('getTripsStatus error',error)
                }else {
                    // console.log('getTripsStatus',response)
                    vm.bookedTrips.value = response.booked
                    vm.preRidingTrips.value = response.pre_riding
                    vm.ridingTrips.value = response.riding
                    vm.pausedTrips.value = response.paused
                    vm.finishedTrips.value = response.finished
                }
            })
        }

        /*function updateBookedTrips(){
            if(vm.trips.booked.updated != null && (moment().valueOf() - vm.trips.booked.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.trips.booked.isLoading = true

            /*UserAnalyticsAdapter.getUserIncompleteSignUp(function(response, error){
                vm.vehicles.scooterError.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.scooterError.encounteredError = true
                }else{
                    vm.vehicles.scooterError.updated = moment().valueOf()
                    vm.vehicles.scooterError.data = response
                }
            })
        }

        function updateRidingTrips(){
            if(vm.trips.riding.updated != null && (moment().valueOf() - vm.trips.riding.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.trips.riding.isLoading = true

            /*UserAnalyticsAdapter.getUserIncompleteSignUp(function(response, error){
                vm.vehicles.scooterError.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.scooterError.encounteredError = true
                }else{
                    vm.vehicles.scooterError.updated = moment().valueOf()
                    vm.vehicles.scooterError.data = response
                }
            })
        }

        function updatePausedTrips(){
            if(vm.trips.paused.updated != null && (moment().valueOf() - vm.trips.paused.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.trips.paused.isLoading = true

            /*UserAnalyticsAdapter.getUserIncompleteSignUp(function(response, error){
                vm.vehicles.scooterError.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.scooterError.encounteredError = true
                }else{
                    vm.vehicles.scooterError.updated = moment().valueOf()
                    vm.vehicles.scooterError.data = response
                }
            })
        }

        function updateFinishedTrips(){
            if(vm.trips.finished.updated != null && (moment().valueOf() - vm.trips.finished.updated.getTime()) < 60000){ // If data isn't older than 1 min
                return
            }
            vm.trips.finished.isLoading = true

            /*UserAnalyticsAdapter.getUserIncompleteSignUp(function(response, error){
                vm.vehicles.scooterError.isLoading = false
                if(error){
                    console.error(error)
                    vm.vehicles.scooterError.encounteredError = true
                }else{
                    vm.vehicles.scooterError.updated = moment().valueOf()
                    vm.vehicles.scooterError.data = response
                }
            })
        }*/


        ////map

        var batteriesSectionsUpdated = 0

        // function addMarkerClusters(newMarkers){
        //     if(!vm.markerClusterer){
        //         vm.markerClusterer = new MarkerClusterer(vm.mainMap, [],{imagePath: "assets/icons/pin/Cluster_Pin_"})
        //     }else{
        //         // vm.markerClusterer.clearMarkers()
        //         if(newMarkers){
        //             vm.markerClusterer.addMarkers(newMarkers)
        //         }else{
        //             console.warn("addMarkerClusters: newMarkers null",newMarkers)
        //         }
        //     }
        //     vm.mainMap.fitBounds(vm.mapBounds)
        // }

        // function updateBatteriesAndRelatedMarkers(){
        //     ///clean for refresh
        //     vm.mapMarkers.forEach(function (marker) {
        //         marker.setMap(null)
        //         marker = null
        //     })
        //     vm.mapMarkers = []
        //     vm.mapBounds = null;
            
        //     if(vm.markerClusterer){
        //         vm.markerClusterer.clearMarkers()
        //     }
        //     ///end clean

        //     VehicleAnalyticsAdapter.getFullBatteries(function(response, error){
        //         if(error){
        //             console.error(error)
        //         }else{
        //             vm.batteriesStatuses.fullCharge.batteries = response
                    
        //             addMarkerClusters(setBatteriesMarkersOnMainMap(response, "full"))
        //         }
        //     })

        //     VehicleAnalyticsAdapter.getBatteriesUpToFiftyPercent(function(response, error){
        //         if(error){
        //             console.error(error)
        //         }else{
        //             vm.batteriesStatuses.halfBattery.batteries = response

        //             addMarkerClusters(setBatteriesMarkersOnMainMap(response, "half"))
        //         }
        //     })

        //     VehicleAnalyticsAdapter.getLowBatteries(function(response, error){
        //         if(error){
        //             console.error(error)
        //         }else{
        //             vm.batteriesStatuses.lowCharge.batteries = response

        //             addMarkerClusters(setBatteriesMarkersOnMainMap(response, "low"))
        //         }
        //     })

        //     VehicleAnalyticsAdapter.getCriticalLowBatteries(function(response, error){
        //         if(error){
        //             console.error(error)
        //         }else{
        //             vm.batteriesStatuses.critical.batteries = response

        //             addMarkerClusters(setBatteriesMarkersOnMainMap(response, "critical"))
        //         }
        //     })
        // }

        // function setBatteriesMarkersOnMainMap(batteries, level){
        //     //function called for each type of battery status
        //     var batteryIcon = "assets/icons/pin/Battery_full.svg"
        //     var position = null

        //     if(!vm.mapBounds){
        //         vm.mapBounds = new google.maps.LatLngBounds()
        //     }
        //     var newMarkers = []

        //     batteries.forEach(function (battery) {
        //         //console.log("Setting marker for battery", battery, "with level", level)
        //         if(level == "full"){ batteryIcon = "assets/icons/pin/Battery_Full.svg" }
        //         if(level == "half"){ batteryIcon = "assets/icons/pin/Battery_Azzurro.svg" }
        //         if(level == "low"){ batteryIcon = "assets/icons/pin/Battery_Low.svg" }
        //         if(level == "critical"){ batteryIcon = "assets/icons/pin/Battery_dead.svg" }
        //         position = new google.maps.LatLng(battery.Vehicle.latitude,battery.Vehicle.longitude)
        //         var marker = new google.maps.Marker({
        //             position: position,
        //             options: {
        //                 icon: MapUtility.generateMarkerIconObj(batteryIcon)
        //             },
        //             vehicle: battery.vehicle,
        //             batteryId: battery.id,
        //             batteryLevel: level
        //         })
        //         //extend bounds with position
        //         if(position.lat()!=0 && position.lng()!=0){
        //             vm.mapBounds.extend(position)
        //         }

        //         vm.mapMarkers.push(marker)
        //         newMarkers.push(marker)
                
        //     })
        //     return newMarkers
        // }

        function batteryFilterSelectedWithLevel(level){
            level.filterIsOn? hideMarkersWithLevel(level) : showMarkersWithLevel(level)
        }

        function showMarkersWithLevel(level){
            console.warn("showmarkerwithlevel",level)
            for(var markerIndex in vm.mapMarkers){
                var marker = vm.mapMarkers[markerIndex]
                if(marker.batteryLevel == level.id){
                    marker.setMap(vm.mainMap)
                    vm.markerClusterer.addMarker(marker)
                }
            }
        }

        function hideMarkersWithLevel(level){
            console.warn("hidemarkerlev",level)
            for(var markerIndex in vm.mapMarkers){
                var marker = vm.mapMarkers[markerIndex]
                if(marker.batteryLevel == level.id){
                    marker.setMap(null)
                    vm.markerClusterer.removeMarker(marker)
                }
            }
        }

        function focusBatteryOnMap(battery){
            console.warn("focusbattery",battery)
            for(var markerIndex in vm.mapMarkers){
                var marker = vm.mapMarkers[markerIndex]
                if(marker.batteryId == battery.id){
                    vm.mainMap.setCenter(marker.getPosition())
                    var infoWindowTemplate = "<h2>Percentage: " +
                        battery.percentage +
                    "%</h2>" + 
                    "<p>Vehicle plate: " +
                        battery.Vehicle.license_plate +
                    "</p>"
                    var infowindow = new google.maps.InfoWindow({
                        content: infoWindowTemplate
                    })
                    if(vm.previusInfoWindow){
                        vm.previusInfoWindow.close()
                    }

                    infowindow.open(vm.mainMap, marker)
                    vm.previusInfoWindow = infowindow
                    for(var batteryStatusIndex in vm.batteriesStatuses){
                        var tempId = vm.batteriesStatuses[batteryStatusIndex].id
                        if(tempId == marker.batteryLevel && vm.batteriesStatuses[batteryStatusIndex].filterIsOn == false){
                            batteryFilterSelectedWithLevel(vm.batteriesStatuses[batteryStatusIndex])
                            vm.batteriesStatuses[batteryStatusIndex].filterIsOn = true
                        }
                    }
                    vm.mainMap.setZoom(15)
                    $location.hash("batteryMap")
                    $anchorScroll()
                }
            }
        }

    }

})();

/**
 * Created by alex on 24/04/18.
 */
(function()
{
    'use strict';

    angular
        .module("app.damage-report")
        .controller("DamageReportListController",DamageReportListController)
        .factory("DamageReportDialogFactory",DamageReportDialogFactory)

    /** @ngInject */
    function DamageReportListController($scope,$state,$stateParams,ServiceAdapter,toDateFilter,DamageReportDialogFactory,UserDetailsPage,VehicleDetailsPage,FiltersFactory,OrderRequestParamFactory,ServiceSettings,MiscUtility,ErrorUtility,SitesService){

        var vm = this
        // vm.damagesReports = []
        
        vm.damagesViewed = "..."
        vm.alldamagesLength = "..."

        vm.dateFilters = {start:null,end:null}
        vm.searchBarText = ""
        vm.searchResults = []
        vm.searchBarQueryLength = { value: 0}
        vm.sortProperty = null
        vm.sortReversed = false
        vm.hashedDamagesReports = {}

        // $scope.$on('$viewContentLoaded',function(event){
            // refreshDamagesReports()
        // })

        $scope.$on('refreshServiceSettings',function (event) {
            init();
        })
        
        function init() {
            ServiceSettings.getServiceSettings(function(settings, error){
                if(settings.loaded){
                    SitesService.getSites(function(){
                        vm.selectedSiteId = SitesService.getSelectedSite()
                        vm.todayDate = MiscUtility.serviceTodayDate(vm.selectedSiteId);

                        vm.tableFields = {
                            Id: {
                                name: "Id",
                                class: "vehicleRowCellSmall",
                                key: "id",
                                orderBy: OrderRequestParamFactory.orderByDamageReportId,
                                defaultSort: true,
                            },
                            vehicleId: {
                                name: "Vehicle Id",
                                class: "vehicleRowCellSmall",
                                key: "vehicle.id",
                                orderBy: OrderRequestParamFactory.orderByDamageReportVehicleId,
                                type: "link",
                                link: {
                                    goto: "app.vehicle.details",
                                    gotoParams: "vehicleId",
                                    key: "vehicle.id",
                                    class: function (o) {
                                        return "userLink";
                                    },
                                },
                                render: function (val, obj) {
                                    return obj.vehicle ? obj.vehicle.id : "";
                                },
                            },
                            vehicleRefCode: {
                                name: "Vehicle",
                                class: "vehicleRowCellBig alignLeft",
                                orderBy: OrderRequestParamFactory.orderByDamageReportVehicleReferenceCode,
                                ellipsis: true,
                                type: "render",
                                render: function (val, obj) {
                                    return obj.vehicle ? obj.vehicle.reference_code : "";
                                },
                            },
                            vehicleDeviceType: {
                                name: "Device Provider",
                                class: "vehicleRowCellSmall",
                                key: "vehicle.deviceTypeHuman",
                                type: "render",
                                render: function (val, obj) {
                                    return obj.vehicle ? obj.vehicle.deviceTypeHuman : "";
                                },
                            },
                            description: {
                                name: "Description",
                                class: "vehicleRowCellVeryBig alignLeft",
                                key: "description",
                                ellipsis: true,
                                type: "render",
                                render: function (v, o) {
                                    return o.description;
                                },
                            },
                            creationDate: {
                                name: "Creation date",
                                class: "vehicleRowCellBig",
                                orderBy: OrderRequestParamFactory.orderByDamageReportCreationDate,
                                type: "render",
                                render: function (v, o) {
                                    return o.created_at
                                        ? toDateFilter(o.created_at, "dateTime", o.vehicle ? o.vehicle.SiteId : null)
                                        : "";
                                },
                            },
                            userId: {
                                name: "User Id",
                                class: "vehicleRowCellSmall alignLeft",
                                key: "User.id",
                                orderBy: OrderRequestParamFactory.orderByDamageReportUserId,
                                type: "link",
                                link: {
                                    goto: "app.user.details",
                                    gotoParams: "userId",
                                    key: "user.id",
                                    class: function (o) {
                                        return "userLink";
                                    },
                                },
                                render: function (val, obj) {
                                    return obj.user ? obj.user.id : "";
                                },
                            },
                            userFullName: {
                                name: "User full name",
                                class: "vehicleRowCellBig alignLeft",
                                ellipsis: true,
                                type: "render",
                                render: function (val, obj) {
                                    return obj.user ? obj.user.fullName : "";
                                },
                            },
                            userEmail: {
                                name: "User Email",
                                class: "vehicleRowCellBig alignLeft",
                                ellipsis: true,
                                type: "email",
                                render: function (val, obj) {
                                    return obj.user ? obj.user.email : "";
                                },
                            },
                            siteId: {
                                name: "Site",
                                class: "vehicleRowCellSmall",
                                key: "vehicle.SiteId",
                                hide: !SitesService.isDefaultSiteSelected(),
                                type: "render",
                                render: function (val, obj) {
                                    return obj.vehicle ? SitesService.getSiteName(obj.vehicle.SiteId) : "No Site";
                                },
                            },
                            details: {
                                name: "Details",
                                class: "",
                                type: "icon-click",
                                icon: {
                                    class: "icon-information-outline",
                                    click: function (obj, $event) {
                                        vm.selectThisDamageReport(obj, $event);
                                    },
                                    aria: "Open Damage Report",
                                },
                                hideCsv: true,
                            },
                        };
                    })
                }
            });
        }
        init()


        $scope.$on('siteChanged',function (event) {
            console.log('siteChanged in damages reports')
            vm.applyFiltersTrigger()
        })
            
        vm.selectThisDamageReport = selectThisDamageReport
        vm.goToUserDetails = goToUserDetails
        vm.goToVehicleDetails = goToVehicleDetails
        vm.callApplyFiltersTrigger = callApplyFiltersTrigger

        vm.filters = {
            // damageReportDataStart: FiltersFactory.createDamageReportWithDateStartFilter(),
            // damageReportDataEnd: FiltersFactory.createDamageReportWithDateEndFilter(),
        }

        vm.searchFilters = {
            reportId: FiltersFactory.createReportWithId(),
            reportVehicleId: FiltersFactory.createReportWithVehicleIdFilter(),
            reportVehicleType: FiltersFactory.createReportWithVehicleTypeFilter(),
            reportDeviceType: FiltersFactory.createReportWithDeviceTypeFilter(),
            reportUserId: FiltersFactory.createReportUserId(),
            damageReportDate: FiltersFactory.createDamageReportWithDateRangeFilter(),
        }

        vm.refreshDamagesReports = refreshDamagesReports

        function refreshDamagesReports (paginationRequestParam,callback, updateInterface) {
            if(updateInterface === undefined) {
                updateInterface = true;
            }
            
            if(updateInterface) {
                vm.damagesViewed = "..."
                vm.alldamagesLength = "..."
            }
            // if($stateParams.searchFor) {
            //     console.log("stateParams",$stateParams.searchFor)
            //     vm.applyFiltersTrigger($stateParams.searchFor)
            //     $stateParams.searchFor = null;
            // } else {
            //TO DO re-enable paginationRequestParam after server side sorting
            ServiceAdapter.getDamages(paginationRequestParam,
                function (data,error) {
                    if(error){
                        ErrorUtility.showErrorMessage({title:'Get Reports List',description:'Error while getting the reports list!'})

                        if (callback !== undefined) {
                            callback(data, error)
                        }
                    }
                    else{
                        if(updateInterface){
                            var damagesReports = (typeof data.data !== "undefined") ? data.data : data
                            vm.alldamagesLength = (typeof data.count !== "undefined") ? data.count : data.length
                            vm.damagesViewed = damagesReports.length
                            vm.damagesReports = damagesReports
                            // console.log('last damagesReport', damagesReports[0])
                        }

                        if (callback !== undefined) {
                            callback(data, error)
                        }
                    }
                }
            )
        }

        // use the generic-table method to update the data.
        function callApplyFiltersTrigger(){
            vm.applyFiltersTrigger();
        }

        function selectThisDamageReport(report,ev){
            DamageReportDialogFactory.showDetails(ev,report)
        }

        function goToUserDetails(user){
            if(!user)
                return
            $state.go(UserDetailsPage,{user:{id:user.id}})
        }

        function goToVehicleDetails(vehicle){
            if(!vehicle)
                return
            $state.go(VehicleDetailsPage,{vehicle:{id:vehicle.id}})
        }
        
    }

/** @ngInject */
function DamageReportDialogFactory($mdDialog,$document) {

    return{
        showDetails: function (ev,report) {

            return $mdDialog.show({
                controller         : 'DamageReportDetailsDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/damage-report/dialogs/damage-report-details-dialog.html',
                parent             : angular.element($document.body),//angular.element($document.find('#content-container'))
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    DamageReport : report,
                }
            });
        }
    }
}
})();

(function () {
    'use strict';

    angular // this is for formatting
        .module('app.coupon-legacy')
        .controller('CouponsController', CouponsController);

    /** @ngInject */
    function CouponsController(
        $scope,
        $timeout,
        CouponsAdapter,
        toDateFilter,
        CouponType,
        CouponUtility,
        SweetAlert,
        FiltersFactory,
        $document,
        $mdDialog,
        OrderRequestParamFactory,
        ServiceSettings,
        DefaultSite,
        SitesService,
        ErrorUtility,
        MiscUtility,
        toCurrencyFilter
    ) {
        var vm = this;

        vm.couponsCount = '...';
        vm.allCouponsCount = '...';

        vm.coupons = [];
        vm.isAddingCoupon = false;
        var getCouponUsersTimeouts = [];

        vm.couponTypes = CouponType;
        var getCouponsTimeout = null;

        // $scope.$on('$viewContentLoaded',function(event){
        //     getCouponsTimeout = $timeout(function(){
        //         getCoupons()
        //     },500)
        // })

        $scope.$on('refreshServiceSettings', function (event) {
            init();
        });

        function init() {
            ServiceSettings.getServiceSettings(function (settings) {
                SitesService.getSites(function () {
                    vm.selectedSiteId = SitesService.getSelectedSite();

                    vm.tableFields = {
                        id: {
                            name: 'ID',
                            key: 'id',
                            orderBy: OrderRequestParamFactory.orderByCouponId,
                            defaultSort: true,
                            ellipsis: true,
                        },
                        name: { name: 'Name', key: 'name', ellipsis: true, class: 'cellBig' },
                        code: {
                            name: 'Code',
                            key: 'code',
                            orderBy: OrderRequestParamFactory.orderByCouponCode,
                            class: 'cellBig',
                        },
                        from: {
                            name: 'From',
                            key: 'start',
                            orderBy: OrderRequestParamFactory.orderByCouponStartDate,
                            class: 'cellMedium',
                            type: 'render',
                            render: function (val, object) {
                                return toDateFilter(object.start, null, object.SiteId);
                            },
                        },
                        to: {
                            name: 'To',
                            key: 'finish',
                            orderBy: OrderRequestParamFactory.orderByCouponFinishDate,
                            class: 'cellMedium',
                            type: 'render',
                            render: function (val, object) {
                                return object.unlimited_finish
                                    ? 'No limit'
                                    : toDateFilter(object.finish, null, object.SiteId);
                            },
                        },
                        maxusers: {
                            name: 'Max Users',
                            key: 'unlimited_join',
                            type: 'render',
                            render: function (value, object) {
                                return object.unlimited_join ? 'No limit' : object.join_count;
                            },
                        },
                        value: {
                            name: 'Value',
                            key: 'value',
                            class: 'cellMedium',
                            type: 'render',
                            render: function (v, o) {
                                return o.type == CouponType.MINUTES.value ||
                                    o.type == CouponType.REFERRAL.value ||
                                    o.type == CouponType.NEW_USERS.value
                                    ? toCurrencyFilter(
                                          MiscUtility.generateCreditValue(o.value * 60000, DefaultSite.id),
                                          DefaultSite.id
                                      )
                                    : o.value + ' ' + CouponUtility.getCouponTypeDescription(o);
                            },
                        },
                        cashback: {
                            name: 'Cashback',
                            key: 'cashback',
                            type: 'render',
                            render: function (v, o) {
                                return o.cashback != null
                                    ? toCurrencyFilter(
                                          MiscUtility.generateCreditValue(o.cashback * 60000, DefaultSite.id),
                                          DefaultSite.id
                                      )
                                    : '';
                            },
                        },
                        created_at: {
                            name: 'Created',
                            orderBy: OrderRequestParamFactory.orderByCouponCreationgDate,
                            key: 'created_at',
                            class: 'cellBigger',
                            type: 'render',
                            render: function (value, object) {
                                return toDateFilter(object.created_at, 'dateTime', object.SiteId);
                            },
                        },
                        updated_at: {
                            name: 'Modified',
                            key: 'updated_at',
                            class: 'cellBigger',
                            type: 'render',
                            render: function (value, object) {
                                return toDateFilter(object.updated_at, 'dateTime', object.SiteId);
                            },
                        },
                        redeemed: { name: 'Redeem Count', key: 'redeemedCount' },
                        siteId: {
                            name: 'Site',
                            key: 'SiteId',
                            hide: !SitesService.isDefaultSiteSelected(),
                            type: 'render',
                            render: function (val, obj) {
                                return obj.SiteId !== undefined && obj.SiteId !== null
                                    ? SitesService.getSiteName(obj.SiteId)
                                    : 'No Site';
                            },
                        },
                        details: {
                            name: 'Details',
                            key: 'details',
                            type: 'icon-link',
                            icon: {
                                goto: 'app.coupon-legacy.details',
                                gotoParams: 'couponId',
                                icon: 'icon-information-outline',
                                key: 'id',
                            },
                        },
                    };
                });
            });
        }
        init();

        $scope.$on('siteChanged', function (site) {
            console.log('siteChanged in coupons');
            SitesService.getSites(function () {
                vm.selectedSiteId = SitesService.getSelectedSite();
            });
            vm.applyFiltersTrigger();
        });

        $scope.$on('$destroy', function () {
            console.log('cancel getCouponUsersTimeout');
            if (getCouponsTimeout) {
                $timeout.cancel(getCouponsTimeout);
            }
            if (getCouponUsersTimeouts) {
                console.log('destroy timeout', getCouponUsersTimeouts.length);
                getCouponUsersTimeouts.forEach(function (cut) {
                    console.log('delete');
                    $timeout.cancel(cut);
                });
            }
        });

        vm.addCouponAction = addCouponAction;
        vm.getCouponDescription = CouponUtility.getCouponTypeDescription;
        vm.onNewCouponTypeChange = onNewCouponTypeChange;
        vm.getCouponUsers = getCouponUsers;
        vm.getCoupons = getCoupons;

        vm.searchFilters = {
            code: FiltersFactory.createCouponWithCodeFilter(),
            range: FiltersFactory.createCouponWithRangeFilter(),
            unlimited_finish: FiltersFactory.createCouponWithUnlimitedFinishFilter(),
            created_at: FiltersFactory.createCouponWithCreatedAtFilter(),
        };

        //handle referral coupon type. At the moment it is in minutes,unlimited_finish and it has cashback property
        function onNewCouponTypeChange(coupon) {
            if (coupon.type == vm.couponTypes.REFERRAL.value) {
                coupon.unlimited_finish = true;
                coupon.unlimited_join = true;
                coupon.join_count = 0;
                coupon.finish = null;
            } /*
                else {
                    coupon.unlimited_finish = false;
                    coupon.unlimited_join = false;
                }*/
        }

        function getCoupons(paginationParams, onCompletionHandler, updateInterface) {
            if (updateInterface === undefined) {
                updateInterface = true;
            }

            if (getCouponsTimeout) {
                $timeout.cancel(getCouponsTimeout);
            }
            if (getCouponUsersTimeouts) {
                getCouponUsersTimeouts.forEach(function (cut) {
                    $timeout.cancel(cut);
                });
            }

            CouponsAdapter.getCoupons(paginationParams, function (response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Coupons List',
                        description: 'Error while getting the coupons list!',
                    });

                    if (onCompletionHandler !== undefined) {
                        onCompletionHandler(response, error);
                    }
                } else {
                    if (updateInterface) {
                        vm.coupons = [];
                        vm.couponsCount = '...';
                        vm.allCouponsCount = '...';

                        // console.log("last coupon", response[0])

                        getCouponUsersTimeouts = [];
                        vm.coupons = typeof response.data !== 'undefined' ? response.data : response;

                        vm.allCouponsCount = typeof response.count !== 'undefined' ? response.count : vm.coupons.length;
                        vm.couponsCount = vm.coupons.length;

                        delayedCouponsUsersCount(vm.coupons);
                    }

                    if (onCompletionHandler !== undefined) {
                        onCompletionHandler(response, error);
                    }
                }
            });
        }

        function delayedCouponsUsersCount(coupons) {
            var count = 0;
            for (var i = 0; i < coupons.length; i++) {
                var coupon = coupons[i];
                coupon.redeemedCount = '...';
                callGetCouponUsers(coupon, count);
                count++;
            }
        }

        function callGetCouponUsers(coupon, count) {
            getCouponUsersTimeouts[count] = $timeout(function () {
                getCouponUsers(coupon);
            }, count * 1000);
        }

        function getCouponUsers(coupon) {
            if (!coupon) {
                return;
            }

            coupon.redeemedCount = '...';

            CouponsAdapter.getCouponUsers(coupon.id, { limit: 0, offset: 0 }, function getHandler(response, error) {
                if (error) {
                    ErrorUtility.showErrorMessage({
                        title: 'Get Coupon Users',
                        description: 'Error getting coupon users list',
                    });
                } else {
                    coupon.redeemedCount = response.count;
                }
            });
        }

        function addCouponAction(event) {
            if (Number(vm.selectedSiteId) === DefaultSite.id) {
                SweetAlert.swal(
                    'You must select a site!',
                    'Inserting coupons is not allowed when viewing All Sites, please select a site and try again',
                    'error'
                );
                return;
            }

            $mdDialog
                .show({
                    controller: 'CouponAddDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/coupon-legacy/dialogs/coupon-add-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,
                })
                .then(function (refresh) {
                    if (refresh) {
                        vm.applyFiltersTrigger();
                    }
                });
        }
    }
})();

(function () {
    ('use strict');

    angular // this is for formatting
        .module('app.coupon.template')
        .factory('CouponBonusUtility', CouponBonusUtilityFactory);

    /** @ngInject */
    function CouponBonusUtilityFactory(CouponTemplateValidityTimeType, toDateFilter, SitesService) {
        function getValidityTimeRange(template) {
            if (!template || !template.constraints || !template.constraints.validityTime) {
                return '';
            }
            const validityTimeStart = template.constraints.validityTime[0];
            var start = '';
            switch (validityTimeStart.type) {
                case CouponTemplateValidityTimeType.UNBOUNDED.value:
                    start = 'No limit';
                    break;
                case CouponTemplateValidityTimeType.TIMESTAMP.value:
                    start = toDateFilter(validityTimeStart.timestamp, 'dateTime', template.SiteId || DefaultSite.id);
                    break;
                case CouponTemplateValidityTimeType.DURATION_FROM_ACQUISITION.value:
                    start = validityTimeStart.duration / (60 * 1000) + ' min from purchase ';
                    break;
            }

            const validityTimeEnd = template.constraints.validityTime[1];
            var end = '';
            switch (validityTimeEnd.type) {
                case CouponTemplateValidityTimeType.UNBOUNDED.value:
                    end = 'No limit';
                    break;
                case CouponTemplateValidityTimeType.TIMESTAMP.value:
                    end = toDateFilter(validityTimeEnd.timestamp, 'dateTime', template.SiteId || DefaultSite.id);
                    break;
                case CouponTemplateValidityTimeType.DURATION_FROM_ACQUISITION.value:
                    end = validityTimeEnd.duration / (60 * 1000) + ' min from purchase ';
                    break;
            }
            return [start, end];
        }

        function getFromDate(template) {
            const range = getValidityTimeRange(template);
            return range[0] || '';
        }

        function getToDate(template) {
            const range = getValidityTimeRange(template);
            return range[1] || '';
        }

        function getConstraintDescription(template) {
            if (!template || !template.constraints) {
                return '';
            }
            var parts = [];
            // NOTE show onlyNewUser attribute as a constraint
            if (template.onlyNewUser) {
                parts.push('Only new user');
            }

            if (template.constraints.useLimit != undefined) {
                parts.push(template.constraints.useLimit + ' redeem/s per code');
            }

            if (template.constraints.siteIds && Array.isArray(template.constraints.siteIds)) {
                parts.push(
                    'Valid for ' +
                        template.constraints.siteIds
                            .map(function (siteId) {
                                return SitesService.getSiteName(siteId);
                            })
                            .join(',')
                );
            } else {
                parts.push('Valid for All sites');
            }

            return parts.length > 0 ? parts.join(', ') : '';
        }

        return {
            getFromDate: getFromDate,
            getToDate: getToDate,
            getConstraintDescription: getConstraintDescription,
        };
    }
})();

(function(){
    'use strict';
    angular.module("app.analytics",[

    ])
        .config(config)

    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider){

        $stateProvider
            .state('app.analytics',{
                url  : '/analytics',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/analytics/analytics-home.html',
                        controller : 'AnalyticsController as vm'
                    }
                }
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/vehicle');

        msNavigationServiceProvider.saveItem('Analytics', {
            title: 'Analytics',
            icon : 'icon-chart-bar',
            state: 'app.analytics',
            weight: 10
        });
    }

})();
(function(){
    'use strict'

    angular.module("app.analytics")
        .controller("AnalyticsController", AnalyticsController)


        /** @ngInject */
        function AnalyticsController($scope, ToHireDefaultColor, toDateFilter,RideAnalyticsAdapter, BusinessAnalyticsAdapter, UserAnalyticsAdapter,GenerateCSVService,ServiceSettings,MiscUtility,ErrorUtility,SitesService,DefaultSite) {
            var vm = this

            var today, aMonthAgo, aDayAgo, todayMidnight, aYearAgo;

            $scope.$on('refreshServiceSettings',function (event) {
                init();
            })

            function init() {
                ServiceSettings.getServiceSettings(function(settings, error){
                    if(settings.loaded){
                        // Because the analytics data is not filtered by site, 
                        // we use the browser time to display the dates
                        vm.selectedSiteId = DefaultSite.id;
                        vm.dataCurrency = '' // settings && settings.currencySymbol;

                        today = MiscUtility.createTzMoment(null, vm.selectedSiteId);

                        aMonthAgo = today.clone().subtract(1, 'months').toDate()
                        aDayAgo = today.clone().subtract(1, 'days').toDate()
                        todayMidnight = today.clone().endOf('day').toDate()
                        aYearAgo = today.clone().subtract(1, 'years').toDate()
            
                        vm.aMonthAgo = aMonthAgo
                        vm.aDayAgo = aDayAgo
                        vm.aYearAgo = aYearAgo
                        vm.todayDate = today.toDate();


                        vm.avgRidesGraph = {
                            data:[],
                            options:{
                                elements:{
                                    point:{
                                        radius: 3
                                    },
                                    line:{
                                        tension: 0,
                                        fill: false,
                                        borderWidth: 4,
                                        borderColor: "#4173C4",
                                        borderJoinStyle: "round"
                                    }
                                },
                                responsive: true,
                                maintainAspectRatio: false,
                                scales:{
                                    xAxes:[
                                        {
                                            gridLines:{
                                                display: false
                                            }
                                        }
                                    ]
                                }
                            },
                            labels:[],
                            series:['Average rides'],
                            chart: null,
                            periodFilter: aMonthAgo,
                            endPeriodFilter: todayMidnight,
                            minImportantValue: 0,
                            maxImportantValue: 0,
                            resolution: "day",
                            dataId: "ridesPerScooter",
                            isLoading: false
                        }

                        vm.fleetRides = {
                            data:[],
                            options:{
                                elements:{
                                    point:{
                                        radius: 3
                                    },
                                    line:{
                                        tension: 0,
                                        fill: false,
                                        borderWidth: 4,
                                        borderColor: "#4173C4",
                                        borderJoinStyle: "round"
                                    }
                                },
                                responsive: true,
                                maintainAspectRatio: false,
                                scales:{
                                    xAxes:[
                                        {
                                            gridLines:{
                                                display: false
                                            }
                                        }
                                    ]
                                }
                            },
                            labels:[],
                            series:['Rides per day'],
                            chart: null,
                            periodFilter: aMonthAgo,
                            endPeriodFilter: todayMidnight,
                            minImportantValue: 0,
                            maxImportantValue: 0,
                            resolution: "day",
                            dataId: "fleetRides",
                            isLoading: false
                        }

                        vm.avgDistance = {
                            data:[],
                            options:{
                                elements:{
                                    point:{
                                        radius: 3
                                    },
                                    line:{
                                        tension: 0,
                                        fill: false,
                                        borderWidth: 4,
                                        borderColor: "#FF5D7E",
                                        borderJoinStyle: "round"
                                    }
                                },
                                responsive: true,
                                maintainAspectRatio: false,
                                scales:{
                                    xAxes:[
                                        {
                                            gridLines:{
                                                display: false
                                            }
                                        }
                                    ]
                                },
                                tooltips: {
                                    callbacks: {
                                        label: function(tooltipItem, chart) {
                                            return tooltipItem.yLabel + "km"
                                        }
                                    }
                                }
                            },
                            labels:[],
                            series:['Average distance per ride'],
                            chart: null,
                            periodFilter: aMonthAgo,
                            endPeriodFilter: todayMidnight,
                            minImportantValue: 0,
                            maxImportantValue: 0,
                            resolution: "day",
                            dataId: "avgDistance",
                            isLoading: false
                        }

                        vm.avgDuration = {
                            data:[],
                            options:{
                                elements:{
                                    point:{
                                        radius: 3
                                    },
                                    line:{
                                        tension: 0,
                                        fill: false,
                                        borderWidth: 4,
                                        borderColor: "#CE3655",
                                        borderJoinStyle: "round"
                                    }
                                },
                                responsive: true,
                                maintainAspectRatio: false,
                                scales:{
                                    xAxes:[
                                        {
                                            gridLines:{
                                                display: false
                                            }
                                        }
                                    ]
                                },
                                tooltips: {
                                    callbacks: {
                                        label: function(tooltipItem, chart) {
                                            return tooltipItem.yLabel + "min"
                                        }
                                    }
                                }
                            },
                            labels:[],
                            series:['Average ride duration'],
                            chart: null,
                            periodFilter: aMonthAgo,
                            endPeriodFilter: todayMidnight,
                            minImportantValue: 0,
                            maxImportantValue: 0,
                            resolution: "day",
                            dataId: "avgDuration",
                            isLoading: false
                        }

                        vm.freeAndPaidRides = {
                            data:[[],[]],
                            options:{
                                elements:{
                                    point:{
                                        radius: 3
                                    },
                                    line:{
                                        tension: 0,
                                        fill: false,
                                        borderWidth: 4,
                                        borderJoinStyle: "round"
                                    }
                                },
                                responsive: true,
                                maintainAspectRatio: false,
                                scales:{
                                    xAxes:[
                                        {
                                            gridLines:{
                                                display: false
                                            },
                                            stacked: false
                                        }
                                    ],
                                    yAxes: [
                                        {
                                            stacked: false
                                        }
                                    ]
                                }
                            },
                            labels:[],
                            colors:[
                                {
                                    backgroundColor: "#4173C4",
                                    borderColor: "#4173C4"
                                },
                                {
                                    backgroundColor: "#7C97C4",
                                    borderColor: "#7C97C4"
                                }
                            ],
                            series:['Free rides', 'Paid rides' ],
                            chart: null,
                            periodFilter: aMonthAgo,
                            endPeriodFilter: todayMidnight,
                            minImportantValue: 0,
                            maxImportantValue: 0,
                            resolution: "day",
                            dataId: "freeAndPaidRides",
                            isLoading: false
                        }

                        vm.billableMinutesAndRevenues = {
                            data:[[],[]],
                            options:{
                                elements:{
                                    point:{
                                        radius: 3
                                    },
                                    line:{
                                        tension: 0,
                                        fill: false,
                                        borderWidth: 4,
                                        borderJoinStyle: "round"
                                    }
                                },
                                responsive: true,
                                maintainAspectRatio: false,
                                scales:{
                                    xAxes:[
                                        {
                                            gridLines:{
                                                display: false
                                            }
                                        }
                                    ]
                                },
                                tooltips: {
                                    callbacks: {
                                        label: function(tooltipItem, chart) {
                                            if(tooltipItem.datasetIndex == 1){
                                                return chart.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel
                                            }
                                            return chart.datasets[tooltipItem.datasetIndex].label + ": " + vm.dataCurrency +" " + tooltipItem.yLabel
                                        }
                                    }
                                }
                            },
                            labels:[],
                            colors:[
                                {
                                    borderColor: "#CE3655"
                                },
                                {
                                    backgroundColor: "#7C97C4",
                                    borderColor: "#7C97C4"
                                }
                            ],
                            datasetsOverride:[
                                {
                                    type: 'line'
                                },
                                {
                                    type: 'bar',
                                    borderWidth: 1
                                }

                            ],
                            series:['Revenues', 'Billable minutes' ],
                            chart: null,
                            periodFilter: aMonthAgo,
                            endPeriodFilter: todayMidnight,
                            minImportantValue: 0,
                            maxImportantValue: 0,
                            resolution: "day",
                            dataId: "billableMinutesAndRevenues",
                            isLoading: false
                        }

                        vm.usersAnalyticsData = {
                            leads: 0,
                            missing_credit_card: 0,
                            registered_users: 0,
                            active_users: 0,
                            active_riders: 0,
                            payer_users: 0,
                            missing_documents: 0,
                            missing_personal_information: 0
                        }

                        vm.data = {
                            ridesPerScooter:{
                                values:[]//[value: number, date: Date]
                            },
                            fleetRides:{
                                values:[]
                            },
                            avgDistance:{
                                values:[]
                            },
                            avgDuration:{
                                values:[]
                            },
                            freeAndPaidRides:{
                                values:[[],[]]
                            },
                            billableMinutesAndRevenues:{
                                values:[[],[]]
                            }
                        }

                        refreshCharts();
                    }
                });
            }
    
            init();

            vm.toHireDefaultColor = ToHireDefaultColor

            vm.previusInfoWindow = null

            /*vm.mapData = {
                defaultCenter:{
                    lat : 0,
                    lng: 0
                },
                center: {
                    latitude : MapDefaults.center.latitude,
                    longitude: MapDefaults.center.longitude
                },
                zoom  : MapDefaults.zoom,
                options:{
                    mapTypeControl: false,
                    streetViewControl: false,
                    scrollwheel: false,
                    clickableIcons: false
                },
                stationMarkers: {},
                vehicleMarkers: {},
                events:{
                    tilesloaded: function (map) {

                        if(vm.mapInitialized){
                            return;
                        }
                        vm.mainMap = map;
                        vm.mapInitialized = true
                        if(!vm.heatmaps.start && !vm.heatmaps.end){
                            refreshHeatMaps()
                        }

                    },
                    click: function (map) {
                        if(vm.previusInfoWindow){
                            vm.previusInfoWindow.close()
                            vm.previusInfoWindow = null
                        }
                    }
                }
            }*/

            vm.refreshChart = refreshChart
            vm.refreshCharts = refreshCharts
            vm.getMaxDate = getMaxDate
            vm.setUpGraph = setUpGraph
            vm.setUpDoubleSerieChart = setUpDoubleSerieChart
            vm.exportChart = exportChart

            $scope.$on("chart-create",function(event, chart){
                for(var datasetIndex in chart.data.datasets){
                    if(chart.data.datasets.length == 1){
                        chart.data.datasets[datasetIndex].pointBorderColor = chart.options.elements.line.borderColor
                    }else{
                        chart.data.datasets[datasetIndex].pointBorderColor = chart.data.datasets[datasetIndex].borderColor
                    }
                    chart.data.datasets[datasetIndex].pointBackgroundColor = "#fff"
                }

                chart.update()
            })

            vm.heatmaps = {
                start: null,
                end: null
            }

            vm.onMapInit = function (map) {
                vm.mainMap = map
                refreshHeatMaps()
            }

            // generateMockData()

            function refreshCharts(){
                refreshChart(vm.avgRidesGraph)
                refreshChart(vm.fleetRides)
                refreshChart(vm.avgDistance)
                refreshChart(vm.avgDuration)
                refreshChart(vm.freeAndPaidRides)
                refreshChart(vm.billableMinutesAndRevenues)
                if(vm.mainMap){
                    refreshHeatMaps()
                }
                refreshUsersAnalytics()
            }

            function refreshChart(chart){
                //Get from server
                if(chart === undefined || chart === null) return;

                switch(chart.resolution){
                    case "day":
                        chart.periodFilter = aMonthAgo
                        break
                    case "hour":
                        chart.periodFilter = aDayAgo
                        break
                    case "month":
                        chart.periodFilter = aYearAgo
                        break
                }
                chart.isLoading = true
                switch(chart.dataId){
                    case 'ridesPerScooter':
                        RideAnalyticsAdapter.getAverageScooterRides(chart.resolution,function (response,error) {
                            handleNetworkData(response, error, chart)
                        })
                        break

                    case 'fleetRides':
                        RideAnalyticsAdapter.getTotalRides(chart.resolution, function(response, error){
                            handleNetworkData(response, error, chart)
                        })
                        break

                    case 'avgDistance':
                        RideAnalyticsAdapter.getAverageTotalRidesDistance(chart.resolution, function(response, error){
                            handleNetworkData(response, error, chart)
                        })
                        break

                    case 'avgDuration':
                        RideAnalyticsAdapter.getAverageTotalRidesTime(chart.resolution, function(response, error){
                            handleNetworkData(response, error, chart)
                        })
                        break

                    case 'freeAndPaidRides':
                        RideAnalyticsAdapter.getFreeRidesTime(chart.resolution, function(response, error){
                            if(!error){
                                RideAnalyticsAdapter.getPaidRidesTime(chart.resolution, function(secondResponse, secondError){
                                    handleDoubleNetworkData(response,secondResponse,secondError,chart)
                                })
                            }else{ chart.isLoading = false }
                        })
                        break

                    case 'billableMinutesAndRevenues':
                        BusinessAnalyticsAdapter.getTotalGeneratedRevenues(chart.resolution, function(response, error){
                            if(!error){
                                BusinessAnalyticsAdapter.getTotalBillableMinutes(chart.resolution, function(secondResponse, secondError){
                                    handleDoubleNetworkData(response,secondResponse,secondError,chart)
                                })
                            }else{ chart.isLoading = false }
                        })
                        break

                }

                //console.log("Refreshing charts with", chart.resolution, chart.periodFilter)
            }

            function handleNetworkData(response, error, chart){
                chart.isLoading = false
                vm.data[chart.dataId].values = []
                if(!error){
                    response.forEach(function (item) {
                        var tempObj = {
                            date: generateDateFrom(item.year,item.month,item.day,item.hour),
                            value: item.value
                        }
                        vm.data[chart.dataId].values.push(tempObj)
                    })

                    setUpGraph(chart)
                }
            }

            function handleDoubleNetworkData(firstResponse, secondResponse, error, doubleSeriesChart){
                vm.data[doubleSeriesChart.dataId].values = [[],[]]
                doubleSeriesChart.isLoading = false
                if(!error){

                    firstResponse.forEach(function (item) {
                        var tempObj = {
                            date: generateDateFrom(item.year,item.month,item.day,item.hour),
                            value: item.value
                        }
                        vm.data[doubleSeriesChart.dataId].values[0].push(tempObj)
                    })
                    secondResponse.forEach(function (item) {
                        var tempObj = {
                            date: generateDateFrom(item.year,item.month,item.day,item.hour),
                            value: item.value
                        }
                        vm.data[doubleSeriesChart.dataId].values[1].push(tempObj)
                    })

                    setUpDoubleSerieChart(doubleSeriesChart)
                }
            }

            function generateDateFrom(year, month, day, hour){
                var output = MiscUtility.createTzMoment(null, vm.selectedSiteId).toDate();
                output.setFullYear(year)
                if(month != undefined)
                    output.setMonth(month - 1)
                if(day != undefined)
                    output.setDate(day)
                if(hour != undefined)
                    output.setHours(hour)


                output.setMinutes(0,0)

                return output
            }

            function getMaxDate(chart){
                if(chart === undefined || chart === null) return;
                
                switch(chart.resolution){
                    case "day":
                        return aMonthAgo
                    case "hour":
                        return aDayAgo
                    case "month":
                        return aYearAgo
                }
            }

            function getValuesFrom(dataObject){
                if(!dataObject.periodFilter || !dataObject.resolution){ 
                    console.error("Resolution or period not set") 
                    return;
                }
                switch(dataObject.resolution){
                    case "day":
                        dataObject.endPeriodFilter = MiscUtility.createTzMoment(null, vm.selectedSiteId).add(1, 'months').startOf('day').toDate();
                        dataObject.periodFilter = MiscUtility.createTzMoment(dataObject.periodFilter, vm.selectedSiteId).startOf('day').toDate();
                        break
                    case "hour":
                        dataObject.endPeriodFilter = MiscUtility.createTzMoment(null, vm.selectedSiteId).add(1, 'days').startOf('day').toDate();
                        break
                    case "month":
                        dataObject.endPeriodFilter = MiscUtility.createTzMoment(null, vm.selectedSiteId).add(1, 'years').startOf('day').toDate();
                        dataObject.periodFilter = MiscUtility.createTzMoment(dataObject.periodFilter, vm.selectedSiteId).startOf('month').toDate();
                    break
                }
                //console.log("periodFilter",dataObject.periodFilter)
                var endIndex = vm.data[dataObject.dataId].values.length - 1
                var dataToSearch = vm.data[dataObject.dataId].values
                var outputArray = {values:[], labels: []}


                for(var i = endIndex; i>=0; i--){

                    if(dataToSearch[i].date.getTime() > dataObject.endPeriodFilter.getTime()){ continue }

                    if(dataToSearch[i].date.getTime() >= dataObject.periodFilter.getTime()){
                        outputArray.values.unshift(dataToSearch[i].value)

                        if(dataObject.resolution == "hour"){
                            outputArray.labels.unshift(MiscUtility.createTzMoment(dataToSearch[i].date, vm.selectedSiteId).format("HH:mm"))
                        }else{
                            if(dataObject.resolution == "month"){
                                outputArray.labels.unshift(MiscUtility.createTzMoment(dataToSearch[i].date, vm.selectedSiteId).format("MMM yyyy"))
                            }else{
                                outputArray.labels.unshift(MiscUtility.createTzMoment(dataToSearch[i].date, vm.selectedSiteId).format("dd MMM"))
                            }
                        }
                    }
                }

                /*for(var i = endIndex; dataToSearch[i].date.getTime() >= dataObject.periodFilter.getTime(); i--){

                    if(dataToSearch[i].date.getTime() > dataObject.endPeriodFilter.getTime()){ continue }
                    outputArray.values.unshift(dataToSearch[i].value)

                    if(dataObject.resolution == "hour"){
                        outputArray.labels.unshift(toDateFilter(dataToSearch[i].date, "HH:mm"))
                    }else{
                        if(dataObject.resolution == "month"){
                            outputArray.labels.unshift(toDateFilter(dataToSearch[i].date, "MMM yyyy"))
                        }else{
                            outputArray.labels.unshift(toDateFilter(dataToSearch[i].date, "dd MMM"))
                        }
                    }
                }*/
                return outputArray
            }

            function getValuesFromDoubleSeries(dataObject){
                if(!dataObject.periodFilter || !dataObject.resolution){ console.error("Resolution or period not set") }
                switch(dataObject.resolution){
                    case "day":
                        dataObject.endPeriodFilter = MiscUtility.createTzMoment(null, vm.selectedSiteId).add(1, 'months').startOf('day').toDate();
                        dataObject.periodFilter = MiscUtility.createTzMoment(dataObject.periodFilter, vm.selectedSiteId).startOf('day').toDate();
                        break
                    case "hour":
                        dataObject.endPeriodFilter = MiscUtility.createTzMoment(null, vm.selectedSiteId).add(1, 'days').startOf('day').toDate();
                        break
                    case "month":
                        dataObject.endPeriodFilter = MiscUtility.createTzMoment(null, vm.selectedSiteId).add(1, 'years').startOf('day').toDate();
                        dataObject.periodFilter = MiscUtility.createTzMoment(dataObject.periodFilter, vm.selectedSiteId).startOf('month').toDate();
                        break
                }
                //console.log("periodFilter",dataObject.periodFilter)
                var firstEndIndex = vm.data[dataObject.dataId].values[0].length - 1
                var firstDataToSearch = vm.data[dataObject.dataId].values[0]
                var secondIndex = vm.data[dataObject.dataId].values[1].length - 1
                var secondDataToSearch = vm.data[dataObject.dataId].values[1]

                var outputArray = {values:[[],[]], labels: [[],[]]}

                for(var i = firstEndIndex; i>=0; i--){

                    if(firstDataToSearch[i].date.getTime() > dataObject.endPeriodFilter.getTime() || secondDataToSearch[i].date.getTime() > dataObject.endPeriodFilter.getTime()){ continue }

                    if(firstDataToSearch[i].date.getTime() >= dataObject.periodFilter.getTime() && secondDataToSearch[i].date.getTime() >= dataObject.periodFilter.getTime()){
                        outputArray.values[0].unshift(firstDataToSearch[i].value)
                        outputArray.values[1].unshift(secondDataToSearch[i].value)

                        if(dataObject.resolution == "hour"){
                            outputArray.labels[0].unshift(MiscUtility.createTzMoment(firstDataToSearch[i].date, vm.selectedSiteId).format("HH:mm"))
                        }else{
                            if(dataObject.resolution == "month"){
                                outputArray.labels[0].unshift(MiscUtility.createTzMoment(firstDataToSearch[i].date, vm.selectedSiteId).format("MMM yyyy"))
                            }else{
                                outputArray.labels[0].unshift(MiscUtility.createTzMoment(firstDataToSearch[i].date, vm.selectedSiteId).format("dd MMM"))
                            }
                        }
                    }
                }

                return outputArray
            }

            function setUpGraph(chart){
                chart.data = []
                chart.labels = []
                var chartValuesObj = getValuesFrom(chart)
                chart.minImportantValue = Math.min.apply(null, chartValuesObj.values)
                chart.maxImportantValue = Math.max.apply(null, chartValuesObj.values)
                chart.data = chartValuesObj.values
                chart.labels = chartValuesObj.labels
            }

            function setUpDoubleSerieChart(chart){
                chart.data = [[],[]]
                chart.labels = [[],[]]
                var chartValuesObj = getValuesFromDoubleSeries(chart)
                chart.minImportantValue = Math.min.apply(null, chartValuesObj.values[0])
                chart.maxImportantValue = Math.max.apply(null, chartValuesObj.values[0])
                chart.data[0] = chartValuesObj.values[0]
                chart.data[1] = chartValuesObj.values[1]
                chart.labels = chartValuesObj.labels[0]
            }

            function refreshHeatMaps(){
                vm.heatmaps.start ? vm.heatmaps.start.setMap(null) : console.log("No heatmap")
                vm.heatmaps.end ? vm.heatmaps.end.setMap(null) : console.log("No heatmap")
                
                RideAnalyticsAdapter.getHeatmapStartingPoints(function(response, error){
                    if(!error){
                        var latlngArray = []
                        for(var index in response){
                            latlngArray.push(new google.maps.LatLng(response[index]))
                        }
                        var startHeatMap = new google.maps.visualization.HeatmapLayer({
                            data: latlngArray,
                            map: vm.mainMap
                        })
                        vm.heatmaps.start = startHeatMap

                        //vm.mainMap.setCenter(latlngArray[0])
                        //vm.mainMap.setZoom(9)
                        fitMapBounds(latlngArray)
                    }
                })

                RideAnalyticsAdapter.getHeatmapFinishPoints(function(response, error){
                    if(!error){
                        var latlngArray = []
                        for(var index in response){
                            latlngArray.push(new google.maps.LatLng(response[index]))
                        }
                        var endHeatMap = new google.maps.visualization.HeatmapLayer({
                            data: latlngArray,
                            map: vm.mainMap
                        })
                        vm.heatmaps.end = endHeatMap
                        var gradient = [
                            'rgba(0, 255, 255, 0)',
                            'rgba(0, 255, 255, 1)',
                            'rgba(0, 191, 255, 1)',
                            'rgba(0, 127, 255, 1)',
                            'rgba(0, 63, 255, 1)',
                            'rgba(0, 0, 255, 1)',
                            'rgba(0, 0, 223, 1)',
                            'rgba(0, 0, 191, 1)',
                            'rgba(0, 0, 159, 1)',
                            'rgba(0, 0, 127, 1)',
                            'rgba(63, 0, 91, 1)',
                            'rgba(127, 0, 63, 1)',
                            'rgba(191, 0, 31, 1)',
                            'rgba(255, 0, 0, 1)'
                        ]
                        vm.heatmaps.end.set('gradient', gradient)
                    }
                })
            }

            function fitMapBounds(points) {
                var bounds = new google.maps.LatLngBounds()

                points.forEach(function (point) {
                    if(point.lat()!=0 && point.lng()!=0){
                        bounds.extend(point)
                    }
                })
                vm.mainMap.fitBounds(bounds)
            }

            function refreshUsersAnalytics(){
                UserAnalyticsAdapter.getUsersAnalytics(function(response, error){
                    if(!error){
                        vm.usersAnalyticsData.leads = response.leads
                        vm.usersAnalyticsData.missing_credit_card = response.missing_credit_card
                        vm.usersAnalyticsData.registered_users = response.registered_users
                        vm.usersAnalyticsData.active_users = response.active_user ? response.active_user : 0
                        vm.usersAnalyticsData.active_riders = response.active_rider ? response.active_rider : 0
                        vm.usersAnalyticsData.payer_users = response.payer_users
                        vm.usersAnalyticsData.missing_documents = response.missing_documents
                        vm.usersAnalyticsData.missing_personal_information = response.missing_personal_information
                    }
                })
            }

            function exportChart(chart){
                var dataOutput = vm.data[chart.dataId]
                var outputArray = []
                var outputString = ""
                if(chart.series.length > 1){
                    for(var valueIndex in dataOutput.values[0]){
                        if(valueIndex == 0){
                            outputString = ";"
                            for(var serieIndex in chart.series){
                                outputString +=  chart.series[serieIndex]
                                if(serieIndex == chart.series.length -1){
                                    outputString += "\n"
                                }else{
                                    outputString += ";"
                                }
                            }
                            outputArray.push(outputString)
                        }
                        outputString = MiscUtility.createTzMoment(dataOutput.values[0][valueIndex].date, vm.selectedSiteId).format("dd/MM/yyyy HH:mm") + ";"
                        for(var serieIndex in dataOutput.values){
                            var serie = dataOutput.values[serieIndex]
                            var currentValue = serie[valueIndex]
                            outputString += currentValue.value
                            if(serieIndex != dataOutput.values.length -1){
                                outputString += ";"
                            }else{
                                outputString += "\n"
                            }
                        }
                        outputArray.push(outputString)
                    }

                }else{
                    outputString += ";" + chart.series[0] + "\n"
                    outputArray.push(outputString)
                    for(var valueIndex in dataOutput.values){
                        var valueObj = dataOutput.values[valueIndex]
                        outputString = MiscUtility.createTzMoment(valueObj.date, vm.selectedSiteId).format("dd/MM/yyyy HH:mm") + ";" + valueObj.value + "\n"
                        outputArray.push(outputString)
                    }
                }
                GenerateCSVService.generate(outputArray)

                /*var blob = new Blob(outputArray, {type: "text/csv"})
                var objUrl = window.URL.createObjectURL(blob)
                var fileName = prompt("Please enter a file name", "File name")
                if(!fileName){ return }
                fileName += ".csv"
                var downloadLink = document.createElement("a")
                downloadLink.download = fileName
                downloadLink.innerHTML = "Download File"
                downloadLink.href = objUrl
                downloadLink.onclick = destroyClickedElement
                downloadLink.style.display  = "none"
                document.body.appendChild(downloadLink)
                downloadLink.click()*/
            }

            function generateMockData(){
                generateRidesPerScooterData()
            }

            function generateRidesPerScooterData(){
                for(var i = 1; i <= 365; i++){
                    vm.data.ridesPerScooter.values.push({ value: Math.floor(Math.random() * 100), date: generateDateFrom(2016, i/30, i) } )
                }
            }
        }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope,$q,$state,$timeout,$mdSidenav,$translate,$mdToast,msNavigationService,LogInService,SitesService,GeofenceService,ServiceSettings,ServiceAdapter,DialogFactory,SweetAlert,ErrorUtility,ShowToast,LoginPage)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.selectedSite = ''
        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.selectSite = selectSite;
        vm.callEnableAllVehicles = callEnableAllVehicles
        vm.callDisableAllVehicles = callDisableAllVehicles
        vm.getSitesTrigger = getSitesTrigger

        //////////

        init()

        /**
         * Initialize
         */
        function init(){
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            
            SitesService.getSites(function (sites,error) {
                if(error){
                    console.log("ToolbarController: error get sites",error)
                } else {
                    vm.selectedSite = SitesService.getSiteName(SitesService.getSelectedSite())
                }
            })

        }
        
        function getSitesTrigger(mdMenu) {
            SitesService.getSites(function (sites,error){
                if(error){
                }else{
                    vm.sites = sites
                        
                    //prevent to show sites if admin is site restricted or sites are 1
                    if(mdMenu && sites && sites.length>1){
                        mdMenu.open()
                    }
                }
            })
        }
        
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId){
            $mdSidenav(sidenavId).toggle()
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status){
            vm.userStatus = status;
        }

        function selectSite(site){
            vm.selectedSite = site.name
            
            const isSiteRestricted = false
            
            SitesService.setSelectedSite(site,isSiteRestricted,function(){
                GeofenceService.refreshGeofencingAreas()
                ServiceSettings.updateServiceSettings()
                
                $rootScope.$broadcast('siteChanged', site)
            })
        }

        /**
         * Logout Function
         */
        function logout(){
            LogInService.logOut()
            $state.go(LoginPage)
        }

        function showConfirmAlertAndPerformAction(ev,type,action){
            DialogFactory.confirm(type.toUpperCase()+" ALL VEHICLES","Are you sure you want to "+type+" all vehicles for <span style='color:red'>all sites</span>?",ev, null, null, true)
            .then(
                function ok(){
                    DialogFactory.confirm(type.toUpperCase()+" ALL VEHICLES","This action will be applied to <span style='color:red'>ALL SITES</span>, do you want to proceed?",ev, null, null, true)
                    .then(
                        function ok(){
                            action();
                        }
                    )
                }
            )
        }

        function callEnableAllVehicles(ev){
            showConfirmAlertAndPerformAction(ev,"enable",function(){
                ServiceAdapter.enableAllVehicles(function(data,error){
                    if(!error){
                        SweetAlert.swal("ALL VEHICLES ENABLED","All vehicles were succesfully enabled!","success")
                        ShowToast.hideCurrent()
                    }
                    else{
                        ErrorUtility.showErrorMessage({title: type.toUpperCase()+" ALL VEHICLES",description:"An error occurred while enabling vehicles!"})
                    }
                })
            })
            
        }

        function callDisableAllVehicles(ev){
            showConfirmAlertAndPerformAction(ev,"disable",function(){
                ServiceAdapter.disableAllVehicles(function(data,error){
                    if(!error){
                        SweetAlert.swal("ALL VEHICLES DISABLED","All vehicles were succesfully disabled!","success")
                        ShowToast.showServiceDisabled()
                    }
                    else{
                        ErrorUtility.showErrorMessage({title: type.toUpperCase()+" ALL VEHICLES",description:"An error occurred while disabling vehicles!"})
                    }
                })
            })
        }

        /**
         * Change Language
         */
        function changeLanguage(lang){
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code)
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu(){
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active')
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded(){
            msNavigationService.toggleFolded()
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams)
                }
                else
                {
                    $state.go(item.state)
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi,ServiceSettings)
    {
        var vm = this;

        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope,$timeout)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = true;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        $timeout(function(){
            vm.folded = true;
        },3000)
    }

})();
(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular.module('fuse', [
        // Core
        'app.core',

        // Navigation
        'app.navigation',

        // Toolbar
        'app.toolbar',

        // Quick Panel
        'app.quick-panel',

        // Sample
        //app.sample',

        //dependency
        'ngAnimate',
        'oitozero.ngSweetAlert',
        'flow',
        'pdfjsViewer',
        'ngEmbed',
        'ngSanitize',
        // 'chart.js',

        // 3rd Party Dependencies
        'uiGmapgoogle-maps',

        //my dependency
        'app.pages_auth_login',
        'app.pages.invoice',
        'app.utility',
        'app.dashboard',
        // 'app.analytics',
        //'app.rent',
        'app.vehicle',
        'app.trip',
        // 'app.maintenance',
        //'app.catalog',
        //'app.history',
        'app.user',
        'app.settings',
        'app.notification-center',
        'app.invoice',
        'app.damage-report',
        'app.coupon-legacy',
        //'app.obd_data',
        'app.bonus',
        'app.coupon',
    ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock)

    /** @ngInject */
    function runBlock($rootScope,$timeout,$interval,$state,LocalStorageService,SessionStorageService,TokenData,ServiceTokenData,LogInUtility,LogInService,LoginPage,ErrorUtility,LoggingAdapter) {

        //Use browser time to get unix
        var todayDateEpochUnix = moment().valueOf()
        var token
        var serviceToken
        var expireDateEpochUnix

        function setAuthCookie(token){
            document.cookie = "token="+token+";domain=.2hire.io;path=/;secure;"
        }

        /**
         * Check if token is expired 
         */
        function checkTokenExpiration() {
            if(todayDateEpochUnix < expireDateEpochUnix){

                LogInUtility.setAuthorizationHeader(token)
                setAuthCookie(token)

            } else {
                console.log("token is EXPIRED,go to login page")
                throw 'tokenExpired'
            }
        }

        /**
         * Check if token is present 
         */
        function runTokenChecks() {
            //check local storage
            token = LocalStorageService.getItem(TokenData.TOKEN);
            expireDateEpochUnix = parseInt(LocalStorageService.getItem(TokenData.EXPIRE))
            
            //service token is stored in localStorage only,it must be always present
            serviceToken = LocalStorageService.getItem(ServiceTokenData.TOKEN)
            // console.log("token in local storage",token)
            
            //if present serviceToken must be set in all cases
            if(typeof serviceToken != "undefined" && serviceToken!=null){
                LogInUtility.setServiceTokenHeader(serviceToken)
            }

            if((typeof token != "undefined" && token!=null)
                && (typeof expireDateEpochUnix != "undefined" && expireDateEpochUnix!=null)){

                checkTokenExpiration()
            }
            else{
                //check session storage
                console.log("LocalStorage check fails,check sessionStorage");

                token = SessionStorageService.getItem(TokenData.TOKEN);
                expireDateEpochUnix = parseInt(SessionStorageService.getItem(TokenData.EXPIRE))
                // console.log("token in session storage",token)

                if((typeof token != "undefined" && token!=null)
                    && (typeof expireDateEpochUnix != "undefined" && expireDateEpochUnix!=null)){
                        
                        checkTokenExpiration()
                }
                else{

                    console.log("SessionStorage check fails");
                    console.log("token doesn't exists,go to login page")

                    throw 'noToken'

                }
            }
        }

        //set global page data refresh
        //disabled in favour of different behaviour
        // $interval(function () {
        //     console.log("emit refresh data")
        //     $rootScope.$broadcast('refreshData')
        // },5*60*1000)


        //global date format
        $rootScope.defaultDateFormat = "dd/MM/yyyy"
        const referrer = document.referrer

        var isUserLogged = false
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event,toState,toStateParams,fromState,fromStateParams){
            // console.warn("stateChangeStart",event,toState,toStateParams,fromState,fromStateParams)
            
            $rootScope.loadingProgress = true

            if(toState.name !== LoginPage){
                // var isUserLogged = LocalStorageService.getItem(MiscData.ISUSERLOGGED,"true")
                // console.log("stateChangeStart isUserLogged", isUserLogged)
                if(!isUserLogged){
                    
                    try{
                        runTokenChecks()
                        isUserLogged = true

                    }catch(error){
                        console.warn("error",error)
                        event.preventDefault()
                        switch(error){
                            case 'noToken':
                                $state.go(LoginPage)
                                LogInService.logOut()
                                break;
                            case 'tokenExpired':
                                $state.go(LoginPage)
                                LogInService.logOut()
                                break;
                        }
                    }
                }
            }

            if(isUserLogged){
                const prevPageUrl = fromState.url.replace(/\{|\}|int|\:/g,'').replace("^",'/')
                const nextPageUrl = toState.url.replace(/\{|\}|int|\:/g,'').replace("^",'/')
                var dataToSend = {
                    type:'dashboard:page',
                    message: "goes to " + nextPageUrl + " from " + prevPageUrl,
                    data:{
                        prevPageUrl: prevPageUrl,
                        nextPageUrl: nextPageUrl
                    }
                }
                if(prevPageUrl == "/"){
                    dataToSend.data.referrer = referrer
                }
                LoggingAdapter.logUserInteraction(dataToSend)
            }
        })

        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event,toState,toStateParams,fromState,fromStateParams){
            // console.log("stateChangeSuccess",event,toState,toStateParams,fromState,fromStateParams)

            $timeout(function (){
                $rootScope.loadingProgress = false
            })
        })

        // $rootScope.$on('$stateChangeCancel',function(ev,a,b,c,d){
        //     console.warn("stateChangeCancel",ev,a,b,c,d)
        //     // $state.go(LoginPage)
        // })

        var stateChangeErrorEvent = $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
            console.error("stateChangeError",event, toState, toParams, fromState, fromParams, error)
            if(error){
                if(error.type && error.type=='appInternalError'){
                    ErrorUtility.showErrorMessage({title:'App Internal Error',description:'There was an app internal error'})
                }
            }
            event.preventDefault()
            $state.go(LoginPage)
        })

        // Store state in the root scope for easy access
        $rootScope.state = $state

        // Cleanup
        $rootScope.$on('$destroy', function (){
            stateChangeStartEvent()
            stateChangeSuccessEvent()
            stateChangeErrorEvent()
        })

    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(false)
        //$locationProvider.hashPrefix('')
        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        var layout =  {
            main      : 'app/core/layouts/vertical-navigation.html',
            toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
            navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
        };

        // END - Layout Style Switcher

        //default route
        $urlRouterProvider
            .when('','/')
            .when('/','/dashboard')

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layout.main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layout.toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layout.navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                    // 'notification-center@app':{
                    //     templateUrl: 'app/main/notification-center/notificationCenter.html',
                    //     controller: 'NotificationCenterController as vm'
                    // }
                },
                resolve:{
                    AppRequirements: function ($q,$timeout,$interval,ServiceSettings,SitesService,UserAdapter,LocalStorageService,SessionStorageService,TokenData,ServiceTokenData,MiscData,LogInUtility,ServiceData) {
                        var deferred = $q.defer()
                        var sitesLoaded = false
                        var settingsLoaded = false
                        var promiseResolved = false
                        var serviceName = LocalStorageService.getItem(ServiceTokenData.COMPANY)
                        var userToken = LocalStorageService.getItem(TokenData.TOKEN) || SessionStorageService.getItem(TokenData.TOKEN)          
                        
                        if(typeof userToken === "undefined" || userToken === null){
                            $timeout(function(){
                                console.warn("AppRequirements: no userToken go to login")
                                deferred.reject({type:'appInternalError',description:'Root state evaluated but user is not logged in'})
                            })
                        }else{
                            
                            LogInUtility.doCompanyLogIn(serviceName, function(service,error){
                                if(error){
                                    deferred.reject({type:'appInternalError',description:'Company log in failed in the root state'})
                                }else{

                                    //TODO: now first init of ServiceData is here (same endpoint as LogInUtility.doCompanyLogIn) in the future maybe use ServiceData.refresh
                                    ServiceData.setServiceData(service)
                                    ServiceData.checkIfServiceIsEnabled()
                                    
                                    SitesService.refresh(function(sites,error){
                                        if(error){
                                            deferred.reject({type:'appInternalError',description:'Refresh sites failed in the root state'})
                                        }else{
                                            sitesLoaded = true
                                            if(settingsLoaded && !promiseResolved){
                                                deferred.resolve({})
                                                promiseResolved = true
                                            }
                                        }
                                    })

                                    ServiceSettings.updateServiceSettings(function(settings,error){
                                        if(error){
                                            deferred.reject({type:'appInternalError',description:'Refresh service settings failed in the root state'})
                                        }else{
                                            settingsLoaded = true
                                            if(sitesLoaded && !promiseResolved){
                                                deferred.resolve({})
                                                promiseResolved = true
                                            }
                                        }
                                    })
                                    
                                }
                            })

                            //set interval to check if service is enabled/disabled
                            $interval(function () {
                                ServiceData.refresh(function(service,error){
                                    if(error){
                                    }else{
                                        ServiceData.checkIfServiceIsEnabled()
                                    }
                                })
                            },5*60*1000)
                        }

                        return deferred.promise
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming,$scope,ServiceData)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        
        $scope.$on('$viewContentLoaded',function(event){
            setDashboardTitle(ServiceData.getServiceName())
        })  
        
        function setDashboardTitle(serviceName){
            serviceName = serviceName || "2hire" 
            const dashboardTitle = serviceName.charAt(0).toUpperCase() + serviceName.slice(1) + " Admin"
            
            angular.element("head")
                .find("#dashboard-title")
                .text(dashboardTitle)
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $httpProvider, uiGmapGoogleMapApiProvider)
    {
        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        $httpProvider.interceptors.push('MyHttpInterceptor');

        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyCQq1UkJVH76-tUgUtV8kV-lpmjWv4hbPY',
            libraries: 'weather,geometry,visualization,drawing'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
/**
 * Created by alex on 05/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.settings',
            [
                "app.settings.geofencing",
                "app.settings.damage",
                // "app.settings.fares",
                "app.settings.api-settings",
                "app.settings.permission",
                "app.settings.translations",
                "app.settings.device"
            ]
        )
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.settings',{
                abstract : true,
                url: "/settings"
            })

        // Navigation
        msNavigationServiceProvider.saveItem('settings', {
            title : 'Settings',
            icon  : 'icon-cog',
            weight: 50
        });

    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("settings")
        
        if(!active) {
            msNavigationService.deleteItem("settings")
        }
    }

})();

/**
 * Created by alex on 05/01/17.
 */
(function ()
{
    'use strict';

    angular
        .module('app.rent',
            [
                'app.rent.gantt-chart',
                'app.rent.manage'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.rent',{
                abstract : true,
                url: "/rent"
            })

        // Navigation
        msNavigationServiceProvider.saveItem('rent', {
            title : 'Rent',
            icon  : 'icon-calendar-text',
            weight: 5
        });

    }

})();
(function () {
    ('use strict');

    angular // this is for formatting
        .module('app.coupon', ['app.coupon.template'])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider.state('app.coupon', {
            abstract: true,
            url: '/coupon',
        });

        // Navigation
        // msNavigationServiceProvider.saveItem('coupon', {
        //     title: 'Coupon',
        //     icon: 'icon-star',
        //     weight: 50,
        // });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled('coupon');

        if (!active) {
            msNavigationService.deleteItem('coupon');
        }
    }
})();

/**
 * Created by alex on 01/02/17.
 */

(function ()
{
    'use strict';

    angular
        .module('app.catalog', [
            'app.catalog.category',
            'app.catalog.fare',
            'app.catalog.station',
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider) {

        $stateProvider
            .state('app.catalog',{
                abstract:true,
                url:"/catalog"
        })

        msNavigationServiceProvider.saveItem('catalog', {
            title: 'Catalog',
            icon : 'icon-store',
            weight: 6
        });



    }
})();

/**
 * Created by alex on 05/01/17.
 */
(function () {
    ("use strict");

    angular // this is for formatting
        .module("app.bonus", ["app.bonus.template", "app.bonus.shopItem"])
        .config(config)
        .run(run);
    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        $stateProvider.state("app.bonus", {
            abstract: true,
            url: "/bonus",
        });

        // Navigation
        msNavigationServiceProvider.saveItem("bonus", {
            title: "Bonus",
            icon: "icon-star",
            weight: 45,
        });
    }

    /** @ngInject */
    function run(AppConfigurations, msNavigationService) {
        const active = AppConfigurations.isPageEnabled("bonus");

        if (!active) {
            msNavigationService.deleteItem("bonus");
        }
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ui-view=\"navigation\">\n</md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/analytics/analytics-home.html","<div id=\"analytics-home\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\"></span></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.refreshCharts()\" class=\"md-fab md-icon-button\" \naria-label=\"Reload\" translate-attr-aria-label=\"DSHB.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip>\n<span translate=\"DSHB.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"bottom\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><div class=\"date-filter-box md-whiteframe-3dp\" \nng-show=\"vm.dateFilterActive\" layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"filter from\"><span class=\"label\">From:</span><md-datepicker ms-datepicker-fix \nng-model=\"vm.options.fromDate\" md-max-date=\"vm.options.toDate\" md-placeholder=\"Enter date\" \nng-change=\"vm.refreshWidgetsOnDateChange()\"></md-datepicker></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"filter to\"><span class=\"label\">To:</span><md-datepicker ms-datepicker-fix ng-model=\"vm.options.toDate\" \nmd-min-date=\"vm.options.fromDate\" md-max-date=\"vm.todayDate\" md-placeholder=\"Enter date\" \nng-change=\"vm.refreshWidgetsOnDateChange()\"></md-datepicker></div></div></div></div><div class=\"content\"><div \nclass=\"white-bg\" layout=\"column\" layout-align=\"center center\"><span class=\"p-16 md-display-1 font-weight-300\">\nRides Heatmap</span></div><div class=\"analyticsContainer\"><div class=\"heatMapContainer roundCorners md-whiteframe-4dp\">\n<two-hire-vehicle-map style=\"height: 400px\" on-map-init=\"vm.onMapInit\"></two-hire-vehicle-map></div></div><div \nclass=\"graphsContainer\"><div class=\"halfPageGraph roundCorners md-whiteframe-4dp\"><div class=\"graphContentContainer\">\n<div class=\"titleToolbarContainer\"><div class=\"titleContainer\"><div class=\"title\"><span>Average rides per scooter\n</span></div><div class=\"filtersContainer centersSingleElement\"><div class=\"flexContainer\"><md-button \nclass=\"button30pxHeight noPaddingButton marginButton4px button60pxWidth exportButton\" \nng-click=\"vm.exportChart(vm.avgRidesGraph)\" aria-label=\"download\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n</md-button><md-select class=\"resolutionSelect\" ng-model=\"vm.avgRidesGraph.resolution\" \nng-change=\"vm.refreshChart(vm.avgRidesGraph)\" aria-label=\"choose\"><md-option value=\"hour\">hour</md-option><md-option \nvalue=\"day\">day</md-option><md-option value=\"month\">month</md-option></md-select><md-datepicker class=\"dateFilter\" \nng-model=\"vm.avgRidesGraph.periodFilter\" md-max-date=\"vm.getMaxDate(vm.avgRidesGraph)\" md-open-on-focus \nng-change=\"vm.setUpGraph(vm.avgRidesGraph)\"></md-datepicker></div></div></div><div class=\"toolbarContainer\"><div \nclass=\"toolbarElement\"><div class=\"elementContent\"><div class=\"elementTitle\">Lowest number of rides</div><div \nclass=\"elementValue\">{{vm.avgRidesGraph.minImportantValue | number:2}}</div></div></div><div class=\"toolbarElement\">\n<div class=\"elementContent\"><div class=\"elementTitle\">Highest number of rides</div><div class=\"elementValue\">\n{{vm.avgRidesGraph.maxImportantValue| number:2}}</div></div></div></div></div><div class=\"graphContainer\"><div \nclass=\"graphLoadingOverlay\" ng-hide=\"!vm.avgRidesGraph.isLoading\"><span>Loading...</span></div><canvas id=\"line\" \nclass=\"chart chart-line\" chart-data=\"vm.avgRidesGraph.data\" chart-labels=\"vm.avgRidesGraph.labels\" \nchart-series=\"vm.avgRidesGraph.series\" chart-options=\"vm.avgRidesGraph.options\"></canvas></div></div></div><div \nclass=\"halfPageGraph roundCorners md-whiteframe-4dp\"><div class=\"graphContentContainer\"><div \nclass=\"titleToolbarContainer\"><div class=\"titleContainer\"><div class=\"title\"><span>Total fleet rides</span></div><div \nclass=\"filtersContainer centersSingleElement\"><div class=\"flexContainer\"><md-button \nclass=\"button30pxHeight noPaddingButton marginButton4px button60pxWidth exportButton\" \nng-click=\"vm.exportChart(vm.fleetRides)\" aria-label=\"download\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n</md-button><md-select class=\"resolutionSelect\" ng-model=\"vm.fleetRides.resolution\" \nng-change=\"vm.refreshChart(vm.fleetRides)\" aria-label=\"choose\"><md-option value=\"hour\">hour</md-option><md-option \nvalue=\"day\">day</md-option><md-option value=\"month\">month</md-option></md-select><md-datepicker class=\"dateFilter\" \nng-model=\"vm.fleetRides.periodFilter\" md-max-date=\"vm.getMaxDate(vm.fleetRides)\" md-open-on-focus \nng-change=\"vm.setUpGraph(vm.fleetRides)\"></md-datepicker></div></div></div><div class=\"toolbarContainer\"><div \nclass=\"toolbarElement\"><div class=\"elementContent\"><div class=\"elementTitle\">Lowest number of rides</div><div \nclass=\"elementValue\">{{vm.fleetRides.minImportantValue| number:2}}</div></div></div><div class=\"toolbarElement\"><div \nclass=\"elementContent\"><div class=\"elementTitle\">Highest number of rides</div><div class=\"elementValue\">\n{{vm.fleetRides.maxImportantValue| number:2}}</div></div></div></div></div><div class=\"graphContainer\"><div \nclass=\"graphLoadingOverlay\" ng-hide=\"!vm.fleetRides.isLoading\"><span>Loading...</span></div><canvas id=\"line1\" \nclass=\"chart chart-line\" chart-data=\"vm.fleetRides.data\" chart-labels=\"vm.fleetRides.labels\" \nchart-series=\"vm.fleetRides.series\" chart-options=\"vm.fleetRides.options\"></canvas></div></div></div></div><div \nclass=\"graphsContainer\"><div class=\"halfPageGraph roundCorners md-whiteframe-4dp\"><div class=\"graphContentContainer\">\n<div class=\"titleToolbarContainer\"><div class=\"titleContainer\"><div class=\"title\"><span>Average distance per ride\n</span></div><div class=\"filtersContainer centersSingleElement\"><div class=\"flexContainer\"><md-button \nclass=\"button30pxHeight noPaddingButton marginButton4px button60pxWidth exportButton\" \nng-click=\"vm.exportChart(vm.avgDistance)\" aria-label=\"download\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n</md-button><md-select class=\"resolutionSelect\" ng-model=\"vm.avgDistance.resolution\" \nng-change=\"vm.refreshChart(vm.avgDistance)\" aria-label=\"choose\"><md-option value=\"hour\">hour</md-option><md-option \nvalue=\"day\">day</md-option><md-option value=\"month\">month</md-option></md-select><md-datepicker class=\"dateFilter\" \nng-model=\"vm.avgDistance.periodFilter\" md-max-date=\"vm.getMaxDate(vm.avgDistance)\" md-open-on-focus \nng-change=\"vm.setUpGraph(vm.avgDistance)\"></md-datepicker></div></div></div><div class=\"toolbarContainer\"><div \nclass=\"toolbarElement\"><div class=\"elementContent\"><div class=\"elementTitle\">Shortest ride distance</div><div \nclass=\"elementValue\">{{vm.avgDistance.minImportantValue| number:0}}km</div></div></div><div class=\"toolbarElement\"><div\n class=\"elementContent\"><div class=\"elementTitle\">Longest ride distance</div><div class=\"elementValue\">\n{{vm.avgDistance.maxImportantValue| number:0}}km</div></div></div></div></div><div class=\"graphContainer\"><div \nclass=\"graphLoadingOverlay\" ng-hide=\"!vm.avgDistance.isLoading\"><span>Loading...</span></div><canvas id=\"line2\" \nclass=\"chart chart-line\" chart-data=\"vm.avgDistance.data\" chart-labels=\"vm.avgDistance.labels\" \nchart-series=\"vm.avgDistance.series\" chart-options=\"vm.avgDistance.options\"></canvas></div></div></div><div \nclass=\"halfPageGraph roundCorners md-whiteframe-4dp\"><div class=\"graphContentContainer\"><div \nclass=\"titleToolbarContainer\"><div class=\"titleContainer\"><div class=\"title\"><span>Average ride duration</span></div>\n<div class=\"filtersContainer centersSingleElement\"><div class=\"flexContainer\"><md-button \nclass=\"button30pxHeight noPaddingButton marginButton4px button60pxWidth exportButton\" \nng-click=\"vm.exportChart(vm.avgDuration)\" aria-label=\"download\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n</md-button><md-select class=\"resolutionSelect\" ng-model=\"vm.avgDuration.resolution\" \nng-change=\"vm.refreshChart(vm.avgDuration)\" aria-label=\"choose\"><md-option value=\"hour\">hour</md-option><md-option \nvalue=\"day\">day</md-option><md-option value=\"month\">month</md-option></md-select><md-datepicker class=\"dateFilter\" \nng-model=\"vm.avgDuration.periodFilter\" md-max-date=\"vm.getMaxDate(vm.avgDuration)\" md-open-on-focus \nng-change=\"vm.setUpGraph(vm.avgDuration)\"></md-datepicker></div></div></div><div class=\"toolbarContainer\"><div \nclass=\"toolbarElement\"><div class=\"elementContent\"><div class=\"elementTitle\">Shortest ride duration</div><div \nclass=\"elementValue\">{{vm.avgDuration.minImportantValue| number:0}}min</div></div></div><div class=\"toolbarElement\">\n<div class=\"elementContent\"><div class=\"elementTitle\">Longest ride duration</div><div class=\"elementValue\">\n{{vm.avgDuration.maxImportantValue| number:0}}min</div></div></div></div></div><div class=\"graphContainer\"><div \nclass=\"graphLoadingOverlay\" ng-hide=\"!vm.avgDuration.isLoading\"><span>Loading...</span></div><canvas id=\"line3\" \nclass=\"chart chart-line\" chart-data=\"vm.avgDuration.data\" chart-labels=\"vm.avgDuration.labels\" \nchart-series=\"vm.avgDuration.series\" chart-options=\"vm.avgDuration.options\"></canvas></div></div></div></div><div \nclass=\"graphsContainer\"><div class=\"halfPageGraph roundCorners md-whiteframe-4dp\"><div class=\"graphContentContainer\">\n<div class=\"titleToolbarContainer\"><div class=\"titleContainer\"><div class=\"title\"><span>Free and paid rides</span>\n</div><div class=\"filtersContainer centersSingleElement\"><div class=\"flexContainer\"><md-button \nclass=\"button30pxHeight noPaddingButton marginButton4px button60pxWidth exportButton\" \nng-click=\"vm.exportChart(vm.freeAndPaidRides)\" aria-label=\"download\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n</md-button><md-select class=\"resolutionSelect\" ng-model=\"vm.freeAndPaidRides.resolution\" \nng-change=\"vm.refreshChart(vm.freeAndPaidRides)\" aria-label=\"choose\"><md-option value=\"hour\">hour</md-option><md-option\n value=\"day\">day</md-option><md-option value=\"month\">month</md-option></md-select><md-datepicker class=\"dateFilter\" \nng-model=\"vm.freeAndPaidRides.periodFilter\" md-max-date=\"vm.getMaxDate(vm.freeAndPaidRides)\" md-open-on-focus \nng-change=\"vm.setUpDoubleSerieChart(vm.freeAndPaidRides)\"></md-datepicker></div></div></div><div \nclass=\"toolbarContainer\"><div class=\"toolbarElement\"><div class=\"elementContent\"><div class=\"elementTitle\">\nLowest free rides number</div><div class=\"elementValue\">{{vm.freeAndPaidRides.minImportantValue| number:2}}</div></div>\n</div><div class=\"toolbarElement\"><div class=\"elementContent\"><div class=\"elementTitle\">Highest free rides number</div>\n<div class=\"elementValue\">{{vm.freeAndPaidRides.maxImportantValue| number:2}}</div></div></div></div></div><div \nclass=\"graphContainer\"><div class=\"graphLoadingOverlay\" ng-hide=\"!vm.freeAndPaidRides.isLoading\"><span>Loading...\n</span></div><canvas id=\"line4\" class=\"chart chart-bar\" chart-data=\"vm.freeAndPaidRides.data\" \nchart-labels=\"vm.freeAndPaidRides.labels\" chart-series=\"vm.freeAndPaidRides.series\" \nchart-options=\"vm.freeAndPaidRides.options\" chart-colors=\"vm.freeAndPaidRides.colors\"></canvas></div></div></div><div \nclass=\"halfPageGraph roundCorners md-whiteframe-4dp\"><div class=\"graphContentContainer\"><div \nclass=\"titleToolbarContainer\"><div class=\"titleContainer\"><div class=\"title\"><span>Billable minutes and revenues</span>\n</div><div class=\"filtersContainer centersSingleElement\"><div class=\"flexContainer\"><md-button \nclass=\"button30pxHeight noPaddingButton marginButton4px button60pxWidth exportButton\" \nng-click=\"vm.exportChart(vm.billableMinutesAndRevenues)\" aria-label=\"download\"><md-icon md-font-icon=\"icon-download\">\n</md-icon></md-button><md-select class=\"resolutionSelect\" ng-model=\"vm.billableMinutesAndRevenues.resolution\" \nng-change=\"vm.refreshChart(vm.billableMinutesAndRevenues)\" aria-label=\"choose\"><md-option value=\"hour\">hour</md-option>\n<md-option value=\"day\">day</md-option><md-option value=\"month\">month</md-option></md-select><md-datepicker \nclass=\"dateFilter\" ng-model=\"vm.billableMinutesAndRevenues.periodFilter\" \nmd-max-date=\"vm.getMaxDate(vm.billableMinutesAndRevenues)\" md-open-on-focus \nng-change=\"vm.setUpDoubleSerieChart(vm.billableMinutesAndRevenues)\"></md-datepicker></div></div></div><div \nclass=\"toolbarContainer\"><div class=\"toolbarElement\"><div class=\"elementContent\"><div class=\"elementTitle\">\nLowest revenues</div><div class=\"elementValue\">\n{{ vm.dataCurrency}} {{vm.billableMinutesAndRevenues.minImportantValue| number:2}}</div></div></div><div \nclass=\"toolbarElement\"><div class=\"elementContent\"><div class=\"elementTitle\">Highest revenues</div><div \nclass=\"elementValue\">{{ vm.dataCurrency}} {{vm.billableMinutesAndRevenues.maxImportantValue| number:2}}</div></div>\n</div></div></div><div class=\"graphContainer\"><div class=\"graphLoadingOverlay\" \nng-hide=\"!vm.billableMinutesAndRevenues.isLoading\"><span>Loading...</span></div><canvas id=\"line5\" \nclass=\"chart chart-bar\" chart-data=\"vm.billableMinutesAndRevenues.data\" \nchart-labels=\"vm.billableMinutesAndRevenues.labels\" chart-series=\"vm.billableMinutesAndRevenues.series\" \nchart-options=\"vm.billableMinutesAndRevenues.options\" chart-colors=\"vm.billableMinutesAndRevenues.colors\" \nchart-dataset-override=\"vm.billableMinutesAndRevenues.datasetsOverride\"></canvas></div></div></div></div><div \nclass=\"white-bg\" layout=\"column\" layout-align=\"center center\"><span class=\"p-16 md-display-1 font-weight-300\">\nRegistration procedure</span></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-between center\"><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-text\" ng-style=\"{\'background-color\':vm.toHireDefaultColor.violet}\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Users</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" ng-click=\"flipWidget(); console.log(\'update data\')\">\n<div class=\"white-fg font-size-72 line-height-72\">{{vm.usersAnalyticsData.leads}}</div><div \nclass=\"h3 secondary-text font-weight-500\">New leads</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.fuchsia}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Users</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\" ng-click=\"flipWidget(); vm.updateVehicleInError()\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.usersAnalyticsData.missing_personal_information}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Missing personal info</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.pink}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Users</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\" ng-click=\"flipWidget()\"><div class=\"white-fg font-size-72 line-height-72\">\n{{vm.usersAnalyticsData.missing_credit_card}}</div><div class=\"h3 secondary-text font-weight-500\">\nMissing payment method</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-text\" ng-style=\"{\'background-color\':vm.toHireDefaultColor.criticalRed}\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Users</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" ng-click=\"flipWidget()\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.usersAnalyticsData.missing_documents}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Missing documents</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div class=\"white-bg\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"p-16 md-display-1 font-weight-300\">Registered users</span></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"space-between center\"><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.violet}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Users</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\" ng-click=\"flipWidget(); console.log(\'update data\')\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.usersAnalyticsData.registered_users}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Fully registered</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.fuchsia}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Users</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\" ng-click=\"flipWidget(); vm.updateVehicleInError()\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.usersAnalyticsData.active_users}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Active</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\">\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-text\" ng-style=\"{\'background-color\':vm.toHireDefaultColor.pink}\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Riders</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" ng-click=\"flipWidget()\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.usersAnalyticsData.active_riders}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Paying</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\">\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-text\" ng-style=\"{\'background-color\':vm.toHireDefaultColor.pink}\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Payers</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" ng-click=\"flipWidget()\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.usersAnalyticsData.payer_users}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Paying</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\">\n</div></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/coupon-legacy/coupons-list.html","<div id=\"couponsList\" class=\"page-layout simple inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"coupon-icon\" md-font-icon=\"icon-ticket\"></md-icon><span>Coupons legacy</span></div></div><div \nclass=\"buttonsContainerTopPage\"><md-button class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.addCouponAction()\" \naria-label=\"addCoupon\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div><div \nclass=\"container\"><generic-table headers=\"vm.tableFields\" data=\"vm.coupons\" search-filters=\"vm.searchFilters\" \nupdate-data=\"vm.getCoupons\" class=\"coupons-generic-table\" apply-filters-trigger=\"vm.applyFiltersTrigger\" \nenable-auto-refresh=\"true\" page-id=\"coupons-list\"></generic-table></div></div>");
$templateCache.put("app/main/damage-report/damage-report-list.html","<div id=\"damage-report-list\" class=\"page-layout simple inner-sidenav\" layout=\"row\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-alert-box\"></md-icon><span>Reports</span></div></div><div class=\"filtersWrapper\"></div></div></div>\n<generic-table headers=\"vm.tableFields\" data=\"vm.damagesReports\" search-filters=\"vm.searchFilters\" \nfilters=\"vm.filters\" update-data=\"vm.refreshDamagesReports\" apply-filters-trigger=\"vm.applyFiltersTrigger\" \nenable-auto-refresh=\"true\" page-id=\"damage-report-list\"></generic-table></div>");
$templateCache.put("app/main/dashboard/dashboard-home.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\"></span></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.refreshWidgets()\" class=\"md-fab md-icon-button\" \naria-label=\"Reload\" translate-attr-aria-label=\"DSHB.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip>\n<span translate=\"DSHB.RELOAD\">Reload</span></md-tooltip></md-button></div></div><div class=\"bottom\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><div class=\"date-filter-box md-whiteframe-3dp\" \nng-show=\"vm.dateFilterActive\" layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"filter from\"><span class=\"label\">From:</span><md-datepicker ms-datepicker-fix \nng-model=\"vm.options.fromDate\" md-max-date=\"vm.options.toDate\" md-placeholder=\"Enter date\" \nng-change=\"vm.refreshWidgetsOnDateChange()\"></md-datepicker></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"filter to\"><span class=\"label\">To:</span><md-datepicker ms-datepicker-fix ng-model=\"vm.options.toDate\" \nmd-min-date=\"vm.options.fromDate\" md-max-date=\"vm.todayDate\" md-placeholder=\"Enter date\" \nng-change=\"vm.refreshWidgetsOnDateChange()\"></md-datepicker></div></div></div></div><div class=\"content\"><div \nclass=\"white-bg\" layout=\"column\" layout-align=\"center center\"><span class=\"p-16 md-display-1 font-weight-300\" \ntranslate=\"DSHB.FLEET_STATUS\">Fleet Status</span></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-between center\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"33\"><ms-widget-front class=\"white-text\" ng-style=\"{\'background-color\':vm.toHireDefaultColor.blue}\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \ntranslate=\"DSHB.VEHICLES\">Vehicles</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget(); vm.updateActiveScooters()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\" ng-click=\"flipWidget(); vm.updateActiveScooters()\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.activeScooters.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\" translate=\"DSHB.ACTIVE\">Active</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><span translate=\"DSHB.ACTIVE_BACK_DESCRIPTION\" class=\"backWidgetTitle\">\nVehicles currently active</span><div class=\"backWidgetList\"><div class=\"backWidgetRow noBatteryAlert\" \nng-if=\"vm.vehicles.active.data.length == 0\">\n{{vm.vehicles.active.isLoading? \'Loading\' : vm.vehicles.active.encounteredError? \'Error\' : \'No vehicle\'}}</div><div \nclass=\"backWidgetRow\" ng-repeat=\"vehicle in vm.vehicles.active.data\"><div class=\"title\">{{vehicle.license_plate}}</div>\n<md-button class=\"action\" ng-click=\"vm.goToDetails(vehicle)\">Go to details</md-button></div></div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front \nclass=\"white-text\" ng-style=\"{\'background-color\':vm.toHireDefaultColor.azure}\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.VEHICLES\">Vehicles</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget(); vm.updateInactiveScooters()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" \nng-click=\"flipWidget(); vm.updateInactiveScooters()\"><div class=\"white-fg font-size-72 line-height-72\">\n{{vm.inactiveScooters.value}}</div><div class=\"h3 secondary-text font-weight-500\" translate=\"DSHB.INACTIVE\">Inactive\n</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><span \ntranslate=\"DSHB.INACTIVE_BACK_DESCRIPTION\" class=\"backWidgetTitle\">Vehicles currently inactive</span><div \nclass=\"backWidgetList\"><div class=\"backWidgetRow noBatteryAlert\" ng-if=\"vm.vehicles.inactive.data.length == 0\">\n{{vm.vehicles.inactive.isLoading? \'Loading\' : vm.vehicles.inactive.encounteredError? \'Error\' : \'No vehicle\'}}</div><div\n class=\"backWidgetRow\" ng-repeat=\"vehicle in vm.vehicles.inactive.data\"><div class=\"title\">{{vehicle.license_plate}}\n</div><md-button class=\"action\" ng-click=\"vm.goToDetails(vehicle)\">Go to details</md-button></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"33\">\n<ms-widget-front class=\"white-text\" ng-style=\"{\'background-color\':vm.toHireDefaultColor.lobster}\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \ntranslate=\"DSHB.VEHICLES\">Vehicles</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.goToVehiclesWithExternalStatus(vm.vehicleExternalStatus.MAINTENANCE)\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"white-fg font-size-72 line-height-72\">\n{{vm.maintenanceScooters.value}}</div><div class=\"h3 secondary-text font-weight-500\" translate=\"DSHB.MAINTENANCE\">\nMaintenance</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget>\n</div><div class=\"white-bg\" layout=\"column\" layout-align=\"center center\"><span \nclass=\"p-16 md-display-1 font-weight-300\">Vehicles Status</span></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap layout-align=\"space-between center\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.blue}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Vehicles</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToVehiclesWithExternalStatus(vm.vehicleExternalStatus.TRIP)\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"white-fg font-size-72 line-height-72\">{{vm.tripScooters.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\" translate=\"DSHB.TRIP\">Trip</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.azure}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Vehicles</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"\" aria-label=\"Flip widget\">Details</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"white-fg font-size-72 line-height-72\">{{vm.parkedScooters.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Parked Inside Area</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.violet}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Vehicles</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToVehiclesWithExternalStatus(vm.vehicleExternalStatus.OUTSIDE_OPERATING_AREA)\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"white-fg font-size-72 line-height-72\">\n{{vm.outsideOperatingAreaScooters.value}}</div><div class=\"h3 secondary-text font-weight-500\">Parked Outside Area</div>\n</div><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.pink}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Vehicles</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToVehiclesWithExternalStatus(vm.vehicleExternalStatus.LOW_BATTERY)\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"white-fg font-size-72 line-height-72\">{{vm.lowBatteryScooters.value}}</div>\n<div class=\"h3 secondary-text font-weight-500\" translate=\"DSHB.LOW_BATTERY\">Low Battery</div></div><div class=\"p-16\" \nlayout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.criticalRed}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Vehicles</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToVehiclesWithExternalStatus(vm.vehicleExternalStatus.CONNECTION_ISSUE)\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"white-fg font-size-72 line-height-72\">{{vm.connectionIssueScooters.value}}\n</div><div class=\"h3 secondary-text font-weight-500\" translate=\"DSHB.CONNECTION_ISSUE\">Connection Issue</div></div><div\n class=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.criticalRed}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Vehicles</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToVehiclesWithExternalStatus(vm.vehicleExternalStatus.ACTION_NEEDED)\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"white-fg font-size-72 line-height-72\">{{vm.actionNeededScooters.value}}</div>\n<div class=\"h3 secondary-text font-weight-500\" translate=\"DSHB.ACTION_NEEDED\">Action Needed</div></div><div \nclass=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.criticalRed}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Vehicles</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.goToVehiclesWithStatus(vm.vehicleStatus.UNAVAILABLE)\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"white-fg font-size-72 line-height-72\">\n{{vm.unavailableScooters.value}}</div><div class=\"h3 secondary-text font-weight-500\">Unavailable</div></div><div \nclass=\"p-16\" layout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div class=\"white-bg\" \nlayout=\"column\" layout-align=\"center center\"><span class=\"p-16 md-display-1 font-weight-300\" \ntranslate=\"DSHB.TRIPS_STATUS\">Trips Status</span></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-between center\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"33\"><ms-widget-front class=\"white-text\" ng-style=\"{\'background-color\':vm.toHireDefaultColor.blue}\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.TRIPS\">\nTrips</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToTripsList(vm.vehicleTripStatus.BOOKED)\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.bookedTrips.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\" translate=\"DSHB.BOOKED\">Booked</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.azure}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.TRIPS\">Trips</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToTripsList(vm.vehicleTripStatus.PRE_RIDING)\" aria-label=\"Flip widget\">Details</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"white-fg font-size-72 line-height-72\">{{vm.preRidingTrips.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Pre riding</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.violet}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.TRIPS\">Trips</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToTripsList(vm.vehicleTripStatus.RIDING)\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.ridingTrips.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\" translate=\"DSHB.RIDING\">Riding</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.lobster}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.TRIPS\">Trips</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToTripsList(vm.vehicleTripStatus.PAUSED)\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.pausedTrips.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\" translate=\"DSHB.PAUSED\">Paused</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.blue}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.TRIPS\">Trips</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToTripsList(vm.vehicleTripStatus.FINISHED)\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"white-fg font-size-72 line-height-72\">{{vm.finishedTrips.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\" translate=\"DSHB.FINISHED\">Finished</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div><div class=\"white-bg\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"p-16 md-display-1 font-weight-300\" translate=\"DSHB.USERS_STATUS\">Users Status\n</span></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"space-between center\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front \nclass=\"white-text\" ng-style=\"{\'background-color\':vm.toHireDefaultColor.blue}\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.USERS\">Users</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToUsersList(vm.userStatus.ACTIVATED_USER)\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" \nng-click=\"\'flipWidget(); vm.updateVerificationPendingUsers()\'\"><div class=\"white-fg font-size-72 line-height-72\">\n{{vm.activatedUsers.value}}</div><div class=\"h3 secondary-text font-weight-500\">Activated</div></div><div class=\"p-16\" \nlayout=\"row\" layout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.azure}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.USERS\">Users</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToUsersList(vm.userStatus.INCOMPLETE_SIGN_UP)\" aria-label=\"Flip widget\">Details</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" \nng-click=\"\'flipWidget(); vm.updateIncompleteSignUpUsers()\'\"><div class=\"white-fg font-size-72 line-height-72\">\n{{vm.incompleteSignUpUsers.value}}</div><div class=\"h3 secondary-text font-weight-500\" \ntranslate=\"DSHB.INCOMPLETE_SIGN_UP\">Incomplete Sign Up</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.lobster}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.USERS\">Users</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToUsersList(vm.userStatus.FULLY_REGISTERED)\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" \nng-click=\"\'flipWidget(); vm.updateFullyRegisteredUsers()\'\"><div class=\"white-fg font-size-72 line-height-72\">\n{{vm.fullyRegisteredUsers.value}}</div><div class=\"h3 secondary-text font-weight-500\" \ntranslate=\"DSHB.FULLY_REGISTERED\">Fully Registered</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.criticalRed}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.USERS\">Users</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToUsersList(vm.userStatus.BLOCKED_USER)\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" ng-click=\"\'\'\">\n<div class=\"white-fg font-size-72 line-height-72\">{{vm.blockedUsers.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Blocked</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-text\" \nng-style=\"{\'background-color\':vm.toHireDefaultColor.criticalRed}\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"DSHB.USERS\">Users</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.goToUsersList({value:\'failed\',name:\'Failed\'})\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" ng-click=\"\'\'\">\n<div class=\"white-fg font-size-72 line-height-72\">{{vm.paymentFailedUsers.value}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Payment Failed</div></div><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"></div></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/data/obd-data.html","<div id=\"obdData-list\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span>OBD Data</span></div><div class=\"order-count secondary-text\"><span>Total data:</span> <span>{{vm.obdData.length}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"obdData-list-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><tbody></tbody></table></div></div>\n</div></div>");
$templateCache.put("app/main/invoices/invoice-list.html","<div id=\"invoices\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-receipt\" class=\"s24\"></md-icon></span><span class=\"logo-text\">Tickets\n</span></div></div><div class=\"column buttonsContainerTopPage\"><md-button class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.addAInvoice($event)\" aria-label=\"add tickets\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button ng-if=\"vm.enableBulkCharge\" class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.addBulkCharges($event)\" \naria-label=\"add bulk charges\"><md-icon md-font-icon=\"icon-credit-card\"></md-icon></md-button></div></div></div>\n<generic-table headers=\"vm.tableFields\" data=\"vm.invoices\" search-filters=\"vm.searchFilters\" filters=\"vm.filters\" \nupdate-data=\"vm.refreshInvoices\" apply-filters-trigger=\"vm.applyFiltersTrigger\" enable-auto-refresh=\"true\" \npage-id=\"invoice-list\"></generic-table></div>");
$templateCache.put("app/main/maintenance/maintenance-list.html","<div id=\"maintenance-list\" class=\"page-layout simple inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span>Maintenance\n</span></div><div class=\"order-count secondary-text\"><span>Maintenance records:</span> <span>{{vm.records.length}}\n</span></div></div><div class=\"filtersContainerTopPage\" hide-xs hide-sm><div class=\"vehicleFilter\"><div \nclass=\"filterToggles\"><md-datepicker md-placeholder=\"Start date\" ng-model=\"vm.dateFilters.start\" \nmd-max-date=\"vm.todayDate\"></md-datepicker></div></div><div class=\"vehicleFilter\"><div class=\"filterToggles\">\n<md-datepicker md-placeholder=\"End date\" ng-model=\"vm.dateFilters.end\" md-max-date=\"vm.todayDate\"></md-datepicker>\n</div></div><div class=\"vehicleFilter\"><div class=\"filterToggles\"><md-select multiple=\"true\" \nplaceholder=\"Maintenance status\" ng-model=\"vm.filters.maintenanceState.selected\"><md-option ng-value=\"option\" \nng-repeat=\"option in vm.filters.maintenanceState.values\">{{vm.filters.maintenanceState.descriptions[$index]}}\n</md-option></md-select></div></div><div class=\"vehicleFilter\"><div class=\"filterToggles\"><md-select multiple=\"true\" \nplaceholder=\"Maintenance category\" ng-model=\"vm.filters.maintenanceCategory.selected\"><md-option ng-value=\"option\" \nng-repeat=\"option in vm.filters.maintenanceCategory.values\">{{vm.filters.maintenanceCategory.descriptions[$index]}}\n</md-option></md-select></div></div><div class=\"vehicleFilter\"><div class=\"filterToggles\"><md-select multiple=\"true\" \nplaceholder=\"Maintenance type\" ng-model=\"vm.filters.maintenanceType.selected\"><md-option ng-value=\"option\" \nng-repeat=\"option in vm.filters.maintenanceType.values\">{{vm.filters.maintenanceType.descriptions[$index]}}</md-option>\n</md-select></div></div><md-button class=\"md-raised resetFiltersButton filtersButtons\" ng-click=\"vm.resetFilters()\">\nReset</md-button><md-button class=\"md-raised applyFiltersButton filtersButtons\" ng-click=\"vm.applyFiltersTrigger()\">\nApply</md-button></div><div><md-button class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.openRecordAddDialog($event)\" aria-label=\"add vehicle\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip><span>Add Record</span></md-tooltip></md-button></div></div></div><generic-table headers=\"vm.tableFields\" \ndata=\"vm.records\" search-filters=\"vm.searchFilters\" filters=\"vm.filters\" update-data=\"vm.updateList\" \napply-filters-trigger=\"vm.applyFiltersTrigger\" page-id=\"maintenance-list\"></generic-table></div>");
$templateCache.put("app/main/notification-center/notificationCenter.html","<div id=\"notificationCenterContainer\"><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'notification-center\')\" aria-label=\"toggleSidenav\" aria-label=\"Toggle quick panel\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-bell-outline\" \nclass=\"icon notificationIcon\"><div class=\"notificationCounter\" ng-hide=\"vm.notificationCount == 0\"><span>\n{{vm.notificationCount}}</span></div></md-icon></md-button><md-sidenav id=\"notification-center\" \nmd-component-id=\"notification-center\" class=\"md-sidenav-right md-whiteframe-4dp\"><div \nclass=\"notificationCenterContent\"><div class=\"title\"><md-button class=\"closeButton md-icon-button\" \nng-click=\"vm.toggleSidenav(\'notification-center\')\" aria-label=\"closeNotificationCenter\"><md-icon \nclass=\"icon-close centersSingleElement\"></md-icon></md-button><md-button class=\"openFilterButton md-icon-button\" \nng-click=\"vm.filersCollapsed = !vm.filersCollapsed\" aria-label=\"openFilters\"><md-icon \nclass=\"icon-filter-variant centersSingleElement\"></md-icon></md-button><div class=\"textTitle\">Notifications</div></div>\n<div class=\"topicSubscriptionPanel\" ng-class=\"{collapsed: vm.filersCollapsed}\"><md-switch \nng-repeat=\"topicSubscription in vm.topicsSubscription\" ng-model=\"topicSubscription.subscribed\" \nng-click=\"vm.toggleTopicSubscription(topicSubscription.topic)\">{{topicSubscription.topicName}}</md-switch></div><div \nclass=\"listsContainer\"><div class=\"listContainer\" \nng-class=\"vm.notifications.geofencing.length == 0? \'collapsed\' : vm.notifications.geofencing.length < 2? \'medium\' : \'\' \">\n<div class=\"listContent\"><div class=\"priority high\">Geofencing</div><div class=\"notificationList\"><div \nclass=\"notification\" ng-repeat=\"notification in vm.notifications.geofencing\"><div class=\"descriptionContainer\"><p>\n{{notification.description}}</p></div><div class=\"actionContainer\"><md-button class=\"goToSectionAction md-raised high\" \naria-label=\"goToSectionActionGeofencing\">Go</md-button></div></div></div></div></div><div class=\"listContainer\" \nng-class=\"vm.notifications.notification.length == 0? \'collapsed\' : vm.notifications.notification.length < 2? \'medium\' : \'\' \">\n<div class=\"listContent\"><div class=\"priority medium\">Notification</div><div class=\"notificationList\"><div \nclass=\"notification\" ng-repeat=\"notification in vm.notifications.notification\"><div class=\"descriptionContainer\"><p>\n{{notification.description}}</p></div><div class=\"actionContainer\"><md-button \nclass=\"goToSectionAction md-raised medium\" aria-label=\"goToSectionActionNotification\">Go</md-button></div></div></div>\n</div></div><div class=\"listContainer\" \nng-class=\"vm.notifications.vehicle.length == 0? \'collapsed\' : vm.notifications.vehicle.length < 2? \'medium\' : \'\' \"><div\n class=\"listContent\"><div class=\"priority low\">Vehicle</div><div class=\"notificationList\"><div class=\"notification\" \nng-repeat=\"vehicle in vm.notifications.vehicle\"><div class=\"descriptionContainer\"><p>{{vehicle.license_plate}}</p><p>\n{{vehicle.brand}}</p><p>{{vehicle.latitude}}/{{vehicle.longitude}}</p></div><div class=\"actionContainer\"><md-button \nclass=\"goToSectionAction md-raised low\" aria-label=\"goToSectionActionVehicle\">Go</md-button></div></div></div></div>\n</div></div></div></md-sidenav></div>");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/trip/trip-list-map.html","<div id=\"trip-list-map\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><span>Trips</span></div><div class=\"secondary-text\"><span>Displayed:</span> \n<span>{{vm.tripsViewed}}</span></div><div class=\"secondary-text\" style=\"margin-top:0px\"><span>Total:</span> <span>\n{{vm.allTripsLength}}</span></div></div><div><md-button class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.refreshTrips()\" aria-label=\"refresh\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip><span>\nReload</span></md-tooltip></md-button><md-button class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.goToListView()\">\n<md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon><md-tooltip><span>Go to list view</span></md-tooltip>\n</md-button></div></div></div><div class=\"tripListMapContainer\"><div \nclass=\"listContainer md-whiteframe-4dp roundCorners\"><div class=\"sortOptionsContainer\"><div class=\"sortOptionsTitle\">\nSort by:</div><div class=\"sortOptionsSelectorsContainer\"><md-select ng-model=\"vm.selectedOrderBy.orderBy\" \nclass=\"sortOptionsSelector\" aria-label=\"selectOrderBy\"><md-option ng-value=\"null\" ng-click=\"vm.callApplyOrderBy(null)\">\n</md-option><md-option ng-value=\"option.orderBy\" ng-repeat=\"option in vm.orderByPossibilities\" \nng-click=\"vm.callApplyOrderBy(option.orderBy)\">{{option.name}}</md-option></md-select><md-select \nng-model=\"vm.selectedOrderBy.ascOrder\" class=\"sortOptionsSelector\" aria-label=\"selectOrderByAscOrder\"><md-option \nng-value=\"true\" ng-click=\"vm.callApplyOrderBy(vm.selectedOrderBy.orderBy)\">Ascended</md-option><md-option \nng-value=\"false\" ng-click=\"vm.callApplyOrderBy(vm.selectedOrderBy.orderBy)\">Descended</md-option></md-select></div>\n</div><div class=\"filterOptionsContainer\"><div class=\"filterOptionsTitle\">Filter by:</div><filter-row \nsearch-filters=\"vm.searchFilters\" update-data=\"vm.callGetTrips\" call-update-data-on-init=\"true\" \napply-filters-trigger=\"vm.applyFilterRowTrigger\" reset-static-filters-trigger=\"vm.resetStaticFilters\" \nclass=\"search-input-wrapper\"></filter-row></div><div class=\"tripsList\"><div class=\"tripCell\" \nng-repeat=\"trip in vm.trips | orderBy:vm.selectedSort.property:vm.selectedSort.reversed\" \nng-click=\"vm.showTripOnMap(trip)\" ng-class=\"trip.isFocused? \'selectedCell\' : \'\' \"><div class=\"cellTitle\"><span><b>Trip\n</b> {{trip.id}}</span><md-button class=\"md-icon-button detailsButton\" \nng-click=\"vm.goToTripDetails(vm.focusedTripData.trip)\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\n</md-button></div><div class=\"cellContent\"><div class=\"imageContainer\"><img src=\"assets/icons/icon-route.svg\"></div>\n<div class=\"infoContainer\"><div class=\"infoLabel\">Ref.Code: <a class=\"userLink\" \nui-sref=\"app.vehicle.details({vehicleId: trip.Vehicle.id})\">{{trip.Vehicle.reference_code}}</a></div><div \nclass=\"infoLabel\">Plate: {{trip.Vehicle.license_plate}}</div><div class=\"infoLabel\">\nDevice: {{trip.Vehicle.deviceTypeHuman}}</div><div class=\"infoLabel\" ng-show=\"trip.User\">User: <a class=\"userLink\" \nui-sref=\"app.user.details({userId: trip.User.id})\">{{trip.User.fullName}}</a></div><div class=\"infoLabel\">\nStart: {{trip.start | toDate: \'dateTime\':trip.SiteId}}</div><div class=\"infoLabel\">\n{{trip.FinishPosition ? (trip.duration +\' min, \'+trip.totalKm +\' km\') : \'Not finished\'}}</div><div class=\"infoLabel\">\nPrice: {{ trip.FinishPosition ? vm.getCurrencyValue(trip.Booking.price, trip.SiteId) : \'N/A\' }}</div></div></div></div>\n</div><div class=\"vehicleListFooter\"><div class=\"vehicleListPaginationContainer\"><md-button class=\"md-icon-button\" \nng-click=\"vm.goToTablePage(\'prev\')\" ng-disabled=\"vm.currentTablePageIndex===1\" aria-label=\"goToTablePage\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"vehicleListPaginationInfo\"><label>Page:</label>\n<md-input-container class=\"vehicleListPaginationInput\"><input ng-model=\"vm.currentTablePageIndex\" \nng-change=\"vm.goToTablePage()\" ng-model-options=\"{debounce: 1500}\" type=\"number\" min=\"1\" \naria-label=\"goToPageWithIndex\"></md-input-container></div><md-button class=\"md-icon-button\" \nng-click=\"vm.goToTablePage(\'next\')\" aria-label=\"goToTablePage\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div></div></div><div class=\"mapContainer roundCorners md-whiteframe-4dp\"><div \nclass=\"floatingButtonsContainer\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"detailsButtonContainer md-whiteframe-4dp roundCorners\"><md-button class=\"md-icon-button detailsButton\" \nng-click=\"vm.goToTripDetails(vm.focusedTripData.trip)\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\n</md-button></div><div class=\"detailsButtonContainer md-whiteframe-4dp roundCorners\" style=\"margin-left:8px\"><md-button\n class=\"md-icon-button detailsButton\" ng-click=\"vm.showTripOnMap(vm.focusedTripData.trip)\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon></md-button></div><div \nclass=\"switchPolylineContainer md-whiteframe-4dp roundCorners\" ng-show=\"vm.savedTripPaths.matched.length>0\"><div \nlayout=\"row\" layout-align=\"space-around center\"><span style=\"margin: 8px\">Original</span><md-switch \nng-click=\"vm.toggleOriginalOrMatchedTripPath()\" ng-model=\"vm.isMatchedTripShown\" \naria-label=\"toggleOriginalOrMatchedTripPath\"></md-switch><span style=\"margin: 4px\">Matched</span></div></div></div>\n<two-hire-vehicle-map class=\"roundCorners\" on-map-init=\"vm.onMapInit\" \nshown-geofence-vehicle-types=\"vm.shownGeofenceVehicleTypes\"></two-hire-vehicle-map></div></div></div></div>");
$templateCache.put("app/main/user/user-list.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\" flex-xs=\"25\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"CONTACTS.CONTACTS\">Users</span></div></div><div class=\"buttonsContainerTopPage\"><md-button \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.openContactDialog($event)\" aria-label=\"register an admin\"><md-icon\n md-font-icon=\"icon-account-plus\"></md-icon><md-tooltip>Register an admin</md-tooltip></md-button></div></div></div>\n<generic-table headers=\"vm.tableFields\" data=\"vm.contacts\" search-filters=\"vm.searchFilters\" filters=\"vm.filters\" \nupdate-data=\"vm.refreshUsers\" apply-filters-trigger=\"vm.applyFiltersTrigger\" enable-auto-refresh=\"true\" \npage-id=\"user-list\"></generic-table></div>");
$templateCache.put("app/main/vehicle/vehicle-list.html","<div id=\"vehicle-list\" class=\"page-layout simple inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\" flex-xs=\"25\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-car\"></md-icon><span translate=\"VEHICLES.VEHICLES\">Vehicles</span></div></div><filter-row \nfilters=\"vm.filters\" search-filters=\"vm.searchFilters\" hide-search-filters=\"true\" \nupdate-data=\"vm.callApplyFiltersTrigger\" apply-filters-trigger=\"vm.applyFilterRowTrigger\" \nclass=\"filtersContainerTopPage\"></filter-row><div class=\"buttonsContainerTopPage\"><md-button \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.openVehicleAddDialog($event)\" aria-label=\"add vehicle\" translate \ntranslate-attr-aria-label=\"VEHICLES.ADD_VEHICLE\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-if=\"vm.isBulkActionsEnabled\" class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.openVehiclesBulkUpdateDialog($event)\" aria-label=\"vehiclesBulkUpdate\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></div></div></div><generic-table headers=\"vm.tableFields\" data=\"vm.vehicles\" \nsearch-filters=\"vm.searchFilters\" filters=\"vm.filters\" update-data=\"vm.refreshVehicles\" \non-row-click=\"vm.focusOnVehicle\" apply-filters-trigger=\"vm.applyFiltersTrigger\" enable-auto-refresh=\"true\" \npage-id=\"vehicle-list\"></generic-table><div class=\"vehiclesMapPadding\"><div flex \nclass=\"card white-bg md-whiteframe-4dp vehiclesMapContainer roundCorners\"><two-hire-vehicle-map vehicles=\"vm.vehicles\" \non-refresh=\"vm.onVehiclesRefresh\" focus-on-vehicle=\"vm.focusOnVehicle\"></two-hire-vehicle-map></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/bonus/shopItem/shopItem-list.html","<div id=\"shop-item-list\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\" flex-xs=\"25\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-icon\"><md-icon md-font-icon=\"icon-store\" class=\"s24\"></md-icon></span><span class=\"logo-text\">Store\n</span></div></div><div class=\"buttonsContainerTopPage\"><md-button ng-if=\"vm.isAddItemEnabled\" \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.openAddShopItemDialog($event)\" aria-label=\"\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip>Add Item</md-tooltip></md-button></div></div></div><generic-table \nheaders=\"vm.tableFields\" data=\"vm.shopItems\" search-filters=\"vm.searchFilters\" filters=\"vm.filters\" \nupdate-data=\"vm.refreshShopItems\" apply-filters-trigger=\"vm.applyFiltersTrigger\" enable-auto-refresh=\"true\">\n</generic-table></div>");
$templateCache.put("app/main/bonus/template/template-list.html","<div id=\"bonus-template-list\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\" flex-xs=\"25\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-icon\"><md-icon md-font-icon=\"icon-receipt\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\nTemplates</span></div></div><div class=\"buttonsContainerTopPage\"><md-button ng-if=\"vm.isAddTemplateEnabled\" \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.openAddTemplateDialog($event)\" aria-label=\"\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip>Add Template</md-tooltip></md-button></div></div></div><generic-table \nheaders=\"vm.tableFields\" data=\"vm.templates\" search-filters=\"vm.searchFilters\" filters=\"vm.filters\" \nupdate-data=\"vm.refreshTemplates\" apply-filters-trigger=\"vm.applyFiltersTrigger\" enable-auto-refresh=\"true\">\n</generic-table></div>");
$templateCache.put("app/main/catalog/category/category-list.html","<div id=\"category-list\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-car\"></md-icon><span>Categories</span></div><div class=\"order-count secondary-text\"><span>\nTotal categories:</span> <span>{{vm.categories.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex hide show-gt-xs><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"category-list-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><md-button class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.openCategoryDialog($event)\" aria-label=\"add category\" translate \ntranslate-attr-aria-label=\"CATEGORY.ADD_CATEGORY\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Km</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Edit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"category in vm.categories track by $index \"><td>{{category.name}}</td><td>{{category.description}}</td>\n<td>{{category.km}} km</td><td>{{category.type}}</td><td style=\"text-align: center\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openCategoryDialog($event,category)\"><md-icon \nmd-font-icon=\"icon-pencil\" aria-hidden=\"true\" class=\"s16\" aria-label=\"Modify category\"></md-icon></md-button></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalog/fare/fare-list.html","<div id=\"fare-list\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-timetable\"></md-icon><span>Fares</span></div><div class=\"order-count secondary-text\"><span>\nTotal fares:</span> <span>{{vm.fares.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex hide show-gt-xs><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"fare-list-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><md-button class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.openFareDialog($event)\" aria-label=\"add category\" translate \ntranslate-attr-aria-label=\"CATEGORY.ADD_CATEGORY\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">End Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Edit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"fare in vm.fares track by $index \"><td data-order=\"fare.start\">{{fare.start | toDate}}</td><td \ndata-order=\"fare.end\">{{fare.end | toDate}}</td><td>{{fare.name}}</td><td>\n{{ vm.getCurrencyValue(fare.price, fare.SiteId) }}</td><td style=\"text-align: center\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openFareDialog($event,fare)\"><md-icon md-font-icon=\"icon-pencil\" \naria-hidden=\"true\" class=\"s16\" aria-label=\"Modify fare\"></md-icon></md-button></td></tr></tbody></table></div></div>\n</div></div>");
$templateCache.put("app/main/catalog/station/station-list.html","<div id=\"station-list\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-store\"></md-icon><span>Stations</span></div><div class=\"order-count secondary-text\"><span>\nTotal stations:</span> <span>{{vm.stations.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex hide show-gt-xs><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"station-list-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><md-button class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.openStationDialog($event)\" aria-label=\"add category\" translate \ntranslate-attr-aria-label=\"CATEGORY.ADD_CATEGORY\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Edit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"station in vm.stations track by $index \"><td>{{station.name}}</td><td>{{station.address}}</td><td \nstyle=\"text-align: center\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.openStationDialog($event,station)\"><md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\" class=\"s16\" \naria-label=\"Modify station\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/coupon/template/template-list.html","<div id=\"coupon-template-list\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\" flex-xs=\"25\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-icon\"><md-icon md-font-icon=\"icon-content-duplicate\" class=\"s24\"></md-icon></span><span \nclass=\"logo-text\">Campaigns</span></div></div><div class=\"buttonsContainerTopPage\"><md-button \nng-if=\"vm.isAddTemplateEnabled\" class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.openAddTemplateDialog($event)\" \naria-label=\"\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip>Add Campaign</md-tooltip></md-button></div></div>\n</div><generic-table headers=\"vm.tableFields\" data=\"vm.templates\" search-filters=\"vm.searchFilters\" \nfilters=\"vm.filters\" update-data=\"vm.refreshTemplates\" apply-filters-trigger=\"vm.applyFiltersTrigger\" \nenable-auto-refresh=\"true\"></generic-table></div>");
$templateCache.put("app/main/coupon-legacy/details/coupon-details.html","<div class=\"couponsPageContainer roundCornersSmaller\" layout=\"column\"><div class=\"titleDescriptionContainer\"><div \nlayout=\"column\" layout-align=\"center\" class=\"titleInputs\"><div class=\"couponTitle\" ng-hide=\"vm.coupon.isBeingModified\">\n{{vm.coupon.name}}</div><div class=\"couponDescription\" ng-hide=\"vm.coupon.isBeingModified\">Code: {{vm.coupon.code}}\n</div><input class=\"couponTitle onlyBottomBorderInput onColor\" placeholder=\"Name\" ng-model=\"vm.coupon.name\" \nng-hide=\"!vm.coupon.isBeingModified\"> <input class=\"couponDescription onlyBottomBorderInput onColor\" \nplaceholder=\"CODE\" ng-model=\"vm.coupon.code\" ng-hide=\"!vm.coupon.isBeingModified\"></div><div layout=\"column\"><md-button\n class=\"editButton md-icon-button\" ng-click=\"vm.modifyCouponAction()\" aria-label=\"modifyCoupon\"><md-icon \nclass=\"centersSingleElement\" ng-class=\"vm.coupon.isBeingModified? \'icon-check\' : \'icon-pencil\' \"></md-icon></md-button>\n<md-button class=\"closeButton md-icon-button\" ng-click=\"vm.deleteCouponAction()\" aria-label=\"deleteCoupon\"><md-icon \nclass=\"centersSingleElement\" ng-class=\"vm.coupon.isBeingModified? \'icon-close\' : \'icon-delete\' \"></md-icon></md-button>\n</div></div><div class=\"couponContent md-whiteframe-4dp roundCornersSmaller\" layout=\"row\" layout-align=\"start\"><div \nclass=\"priceContainer\"><div layout=\"row\" layout-align=\"start start\" layout-wrap><div layout=\"column\" flex-xs=\"100\" \nflex-sm=\"50\" flex-gt-sm=\"20\" layout-align=\"start stretch\" ng-hide=\"vm.coupon.isBeingModified\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"couponValueTitle\">From:</div><div class=\"couponValueSingle\">\n{{vm.coupon.start | toDate:\'\':vm.coupon.SiteId}}</div></div></div><div layout=\"column\" flex-xs=\"100\" flex-sm=\"40\" \nflex-gt-sm=\"30\" layout-align=\"start stretch\" ng-hide=\"!vm.coupon.isBeingModified\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"couponValueTitle\">From:</div><md-datepicker class=\"datepicker\" \nng-model=\"vm.coupon.startDate\" md-min-date=\"vm.todayDate\" md-max-date=\"vm.fromMaxDate\" ng-change=\"vm.updateMaxDates()\" \nplaceholder=\"Date\" md-open-on-focus></md-datepicker></div></div><div layout=\"column\" flex-xs=\"100\" flex-sm=\"50\" \nflex-gt-sm=\"30\" layout-align=\"start stretch\" ng-hide=\"vm.coupon.isBeingModified\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"couponValueTitle\">To:</div><div class=\"couponValueDouble\">\n{{vm.coupon.unlimited_finish? \'No limit\' : (vm.coupon.finish | toDate:\'\':vm.coupon.SiteId)}}</div><md-checkbox \nclass=\"myCheckbox couponValueDouble right mediumWidth\" ng-model=\"vm.coupon.unlimited_finish\" ng-disabled=\"true\">\nNo limit</md-checkbox></div></div><div layout=\"column\" flex-xs=\"100\" flex-sm=\"60\" flex-gt-sm=\"40\" \nlayout-align=\"start stretch\" ng-hide=\"!vm.coupon.isBeingModified\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"couponValueTitle\">To:</div><md-datepicker ng-show=\"!vm.coupon.unlimited_finish\" class=\"datepicker\" \nng-model=\"vm.coupon.finishDate\" md-min-date=\"vm.toMinDate\" ng-change=\"vm.updateMaxDates()\" placeholder=\"Date\" \nmd-open-on-focus ng-disabled=\"vm.coupon.unlimited_finish\"></md-datepicker><md-checkbox \nclass=\"myCheckbox couponValueDouble right mediumWidth\" ng-model=\"vm.coupon.unlimited_finish\">No limit</md-checkbox>\n</div></div><div layout=\"column\" flex-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"30\" layout-align=\"start stretch\" \nng-hide=\"vm.coupon.isBeingModified\"><div layout=\"row\" layout-align=\"start center\"><div class=\"couponValueTitle\">\nMax users:</div><div class=\"couponValueDouble\">{{vm.coupon.unlimited_join ? \'No limit\' : vm.coupon.join_count}}</div>\n<md-checkbox class=\"myCheckbox couponValueDouble right mediumWidth\" ng-model=\"vm.coupon.unlimited_join\" \nng-disabled=\"true\">No limit</md-checkbox></div></div><div layout=\"column\" flex-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"30\" \nlayout-align=\"start stretch\" ng-hide=\"!vm.coupon.isBeingModified\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"couponValueTitle\">Max users:</div><input type=\"number\" \nclass=\"myInput couponValueDouble onlyBottomBorderInput valueInput\" ng-model=\"vm.coupon.join_count\" min=\"0\" \nng-disabled=\"vm.coupon.unlimited_join\" placeholder=\"User limit\"><md-checkbox \nclass=\"myCheckbox couponValueDouble right mediumWidth\" ng-model=\"vm.coupon.unlimited_join\">No limit</md-checkbox></div>\n</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div layout=\"column\" flex-xs=\"100\" flex-sm=\"50\" \nflex-gt-sm=\"25\" layout-align=\"start stretch\" ng-hide=\"vm.coupon.isBeingModified\"><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"couponValueTitle\">Value:</div>\n<div class=\"couponValueDouble\">{{ vm.generateCouponValue(vm.coupon) | toCurrency: vm.DefaultSite.id}}</div></div></div>\n</div><div layout=\"column\" flex-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"25\" layout-align=\"start stretch\" \nng-hide=\"vm.coupon.isBeingModified\"><div layout=\"row\" layout-align=\"start center\"><div class=\"couponValueTitle\" \nng-show=\"vm.coupon.type == vm.couponTypes.REFERRAL.value\">Cashback:</div><div class=\"couponValueDouble\" \nng-show=\"vm.coupon.type == vm.couponTypes.REFERRAL.value\">{{vm.coupon.cashback | toCurrency: vm.DefaultSite.id}}</div>\n</div></div><div layout=\"column\" flex-xs=\"100\" flex-sm=\"40\" flex-gt-sm=\"30\" layout-align=\"start stretch\" \nng-hide=\"!vm.coupon.isBeingModified\"><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"couponValueTitle\">Value:</div><input type=\"number\" \nclass=\"myInput couponValueDouble onlyBottomBorderInput valueInput\" ng-model=\"vm.coupon.creditValue\" min=\"0\" \nstep=\"0.01\" placeholder=\"Coupon value\"></div><div class=\"couponValueDouble\">{{vm.getCouponDescription(vm.coupon)}}\n</div></div></div><div layout=\"column\" flex-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"20\" layout-align=\"start stretch\" \nng-hide=\"!vm.coupon.isBeingModified\"><div layout=\"row\" layout-align=\"start center\"><div class=\"couponValueTitle\" \nng-show=\"vm.coupon.type == vm.couponTypes.REFERRAL.value\">Cashback:</div><input type=\"number\" \nclass=\"myInput onlyBottomBorderInput valueInput\" ng-show=\"vm.coupon.type == vm.couponTypes.REFERRAL.value\" \nng-model=\"vm.coupon.cashback\" min=\"0\" step=\"0.01\"></div></div></div><div layout=\"row\" flex-xs=\"100\" flex-sm=\"100\" \nflex-gt-sm=\"100\" layout-align=\"start center\" ng-hide=\"vm.coupon.isBeingModified\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"couponValueTitle\">Created:</div><div class=\"couponValueSingle\">\n{{ vm.coupon.created_at | toDate:\'dateTime\':vm.coupon.SiteId}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin-left: 32px\"><div class=\"couponValueTitle\">Modified:</div><div \nclass=\"couponValueSingle\">{{ vm.coupon.updated_at | toDate:\'dateTime\':vm.coupon.SiteId}}</div></div></div><div \nlayout=\"row spaced\" layout-align=\"space-between center\"><div class=\"redeemedCounter\" \nng-click=\"vm.getCouponUsers(coupon)\">{{vm.redeemed ? vm.redeemed.length : \'...\'}}</div><md-button \nclass=\"setReferralButton\" ng-if=\"vm.coupon.type == vm.couponTypes.REFERRAL.value\" ng-disabled=\"vm.coupon.isReferral\" \nng-class=\"vm.coupon.isReferral? \'activated\': \'\' \" ng-click=\"vm.setAsReferral(coupon)\" aria-label=\"setAsReferralCoupon\">\n{{vm.coupon.isReferral? \'Referral coupon\' : \'Set as referral\'}}</md-button></div></div><div class=\"redeemWrapper\" \nlayout=\"row\" layout-align=\"center\"><paginated-table headers=\"vm.redeemedHeaders\" data=\"vm.redeemed\" \nupdate-data=\"vm.updateRedeemed\" apply-update-data=\"vm.applyUpdateTableData\" page-limit=\"25\" class=\"couponTable\">\n</paginated-table></div></div></div>");
$templateCache.put("app/main/coupon-legacy/dialogs/coupon-add-dialog.html","<md-dialog id=\"coupon-add-dialog\" aria-label=\"Add New Vehicle\"><form name=\"addCouponForm\" class=\"\"><div class=\"list\">\n<div class=\"element\"><div class=\"titleDescriptionContainer\"><input required \nclass=\"elementTitle onlyBottomBorderInput onColor\" placeholder=\"Name\" ng-model=\"vm.newCoupon.name\"> <input required \nclass=\"elementDescription onlyBottomBorderInput onColor\" placeholder=\"CODE\" ng-model=\"vm.newCoupon.code\"><md-button \nclass=\"editButton md-icon-button\" ng-click=\"vm.addCoupon()\" aria-label=\"add coupon\"><md-icon \nclass=\"centersSingleElement icon-check\"></md-icon></md-button><md-button class=\"closeButton md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon class=\"centersSingleElement icon-close\"></md-icon>\n</md-button></div><div class=\"priceContainer\"><div class=\"elementRow itemsCenter\"><div class=\"elementValueTitle\">From:\n</div><md-datepicker required class=\"datepicker\" ng-model=\"vm.newCoupon.start\" md-min-date=\"vm.todayDate\" \nmd-max-date=\"vm.newCoupon.finish\" placeholder=\"Date\" md-open-on-focus></md-datepicker></div><div \nclass=\"elementRow itemsCenter\"><div class=\"elementValueTitle\">To:</div><md-datepicker class=\"datepicker\" \nng-model=\"vm.newCoupon.finish\" md-min-date=\"vm.newCoupon.start\" placeholder=\"Date\" md-open-on-focus \nng-disabled=\"vm.newCoupon.unlimited_finish\"></md-datepicker><md-checkbox required \nclass=\"myCheckbox elementValueDouble right mediumWidth\" ng-model=\"vm.newCoupon.unlimited_finish\">No limit</md-checkbox>\n</div><div class=\"elementRow itemsCenter\"><div class=\"elementValueTitle\">Max users:</div><input required type=\"number\" \nclass=\"myInput elementValueDouble onlyBottomBorderInput\" ng-model=\"vm.newCoupon.join_count\" min=\"0\" \nng-disabled=\"vm.newCoupon.unlimited_join\"><md-checkbox class=\"myCheckbox elementValueDouble right mediumWidth\" \nng-model=\"vm.newCoupon.unlimited_join\">No limit</md-checkbox></div><div layout=\"row\" \nlayout-align=\"space-between cente\"><div class=\"elementRow itemsCenter\" flex=\"60\"><div class=\"elementValueTitle\">Value:\n</div><input required type=\"number\" class=\"myInput elementValueDouble onlyBottomBorderInput\" \nng-model=\"vm.newCoupon.value\" min=\"0\" step=\"0.01\"><md-select class=\"elementSelect\" ng-model=\"vm.newCoupon.type\" \nclass=\"elementValueDouble\" aria-label=\"couponType\" placeholder=\"Type\"><md-option ng-value=\"couponType.value\" \nng-repeat=\"couponType in vm.couponTypes\">{{couponType.name}}</md-option></md-select></div><div \nclass=\"elementRow itemsCenter\" flex=\"35\"><div class=\"elementValueTitle\" \nng-show=\"vm.newCoupon.type == vm.couponTypes.REFERRAL.value\">Cashback:</div><input type=\"number\" \nclass=\"myInput elementValueDouble onlyBottomBorderInput\" ng-show=\"vm.newCoupon.type == vm.couponTypes.REFERRAL.value\" \nng-model=\"vm.newCoupon.cashback\" min=\"0\" step=\"0.01\"></div></div></div></div></div></form></md-dialog>");
$templateCache.put("app/main/damage-report/dialogs/damage-report-details-dialog.html","<md-dialog class=\"damage-report-details-dialog\" aria-label=\"Add New Vehicle\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">\nDamage report {{vm.currentDamageReport.created_at | toDate:\"dateTime\":vm.currentDamageReport.vehicle.SiteId}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex><div \nclass=\"damage-report-info md-whiteframe-4dp roundCorners\"><div class=\"tileTitle fixed\">\nDamage report {{vm.currentDamageReport.id}}</div><div class=\"tileInfo text-descr\">\n{{vm.currentDamageReport.description}}</div><div class=\"tileInfo\"><span>Other: </span>\n{{vm.currentDamageReport.other_damage_human}}</div><div class=\"tileInfo\"><span>Damaged parts: </span></div><div \nclass=\"partsContainer\"><div class=\"partElement centersSingleElement\" ng-repeat=\"part in vm.currentDamageReport.parts\">\n<md-checkbox class=\"partCheckbox\" ng-checked=\"\'true\'\" aria-label=\"partChecked\">{{part.description}}</md-checkbox></div>\n</div><div class=\"tileInfo\"><span>User Email: </span><a class=\"userLink\" \nng-href=\"mailto:{{vm.currentDamageReport.user.email}} \">{{vm.currentDamageReport.user.email}}</a></div><div flex \nclass=\"damage-report-image-container\"><img class=\"damage-image\" ng-if=\"vm.selectedDamageReportImage.location!=\'\'\" \nng-src=\"{{vm.selectedDamageReportImage.location}}\"><div ng-if=\"vm.selectedDamageReportImage.location==\'\'\" \nclass=\"no-damage-image\"><div>No image available!</div></div><div class=\"dotContainer\"><div class=\"dot\" \nng-class=\"vm.selectedDamageReportImage.number == $index ? \'dotSelected\':\'\' \" \nng-repeat=\"img in vm.currentDamageReport.media\" ng-click=\"vm.selectDamageReportImage($index)\"></div></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/invoices/details/invoice-details.html","<div id=\"invoice-details\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-fab md-icon-button\" ng-click=\"vm.goToInvoicesPage()\" \naria-label=\"Go Back\" translate-attr-aria-label=\"INVOICE.GO_BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n<md-tooltip><span translate=\"INVOICE.GO_BACK\">Go Back</span></md-tooltip></md-button><div layout=\"row\"><md-button \nclass=\"md-fab md-icon-button\" ng-click=\"vm.refreshVehicle()\" aria-label=\"Reload\" \ntranslate-attr-aria-label=\"INVOICE.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"INVOICE.RELOAD\">Reload</span></md-tooltip></md-button><md-button class=\"md-fab md-icon-button\" \nng-click=\"vm.callDeleteVehicleConfirmDialog()\" aria-label=\"Delete\" translate-attr-aria-label=\"INVOICE.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"INVOICE.DELETE\">Delete</span></md-tooltip>\n</md-button></div></div></div><div class=\"content\"><div flex layout=\"row\" class=\"row-container\"><div flex layout=\"row\">\n<div flex class=\"vehicle-details-widget white-bg md-whiteframe-4dp\" layout=\"column\"><div class=\"h3\" layout=\"row\" \nlayout-align=\"space-between center\"><p>\n{{vm.invoice.code}} | {{vm.invoice.created | toDate:\"dateTime\":vm.invoice.SiteId}}</p><md-button \nclass=\"md-icon-button\" ng-click=\"vm.focusOnImagesTab()\" aria-label=\"Edit\" translate-attr-aria-label=\"INVOICE.EDIT\">\n<md-tooltip><span translate=\"INVOICE.EDIT\">Edit</span></md-tooltip></md-button></div><md-divider></md-divider><div \nflex class=\"vehicle-details-widget-item centerImage\" layout=\"row\"><md-icon class=\"account-icon\" \nmd-font-icon=\"{{vm.invoice.type == vm.invoiceType.TICKET.value ? \'icon-receipt\' : \'icon-document\'}}\"></md-icon></div>\n</div><div flex class=\"vehicle-details-widget white-bg md-whiteframe-4dp\" layout=\"column\" style=\"margin-left:12px\"><div\n class=\"h3\"><p>User info</p></div><md-divider></md-divider><div flex class=\"vehicle-details-widget-item\" \nlayout=\"column\" layout-align=\"center center\"><md-icon class=\"account-icon\" md-font-icon=\"icon-account\"></md-icon><div \nlayout=\"row\" layout-align=\"center center\"><p style=\"margin: 0\">{{vm.invoice.User.fullName}}</p><md-icon \nng-click=\"vm.goToUserDetailsPage(vm.invoice.User)\" md-font-icon=\"icon-open-in-new\" style=\"margin:4px\"></md-icon></div>\n</div></div></div><div flex class=\"vehicle-details-widget white-bg md-whiteframe-4dp\" layout=\"column\" \nstyle=\"margin-left:12px\"><div class=\"h3\" layout=\"row\" layout-align=\"space-between center\"><p>Ticket Overview</p><div \nlayout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.disableEditInvoiceDetails ? vm.enableEditInvoiceTypeChange() : vm.disableEditInvoiceTypeChange()\" \naria-label=\"Edit\" translate-attr-aria-label=\"INVOICE.EDIT\" ng-disabled=\"!vm.isBeforeTicketInvoice\"><md-icon \nmd-font-icon=\"{{vm.disableEditInvoiceDetails ? \'icon-pencil\' : \'icon-close\'}}\"></md-icon><md-tooltip><span \ntranslate=\"{{vm.disableEditInvoiceDetails ? \'INVOICE.EDIT\' : \'INVOICE.CANCEL\'}}\">Edit</span></md-tooltip></md-button>\n</div></div><md-divider></md-divider><div flex class=\"vehicle-overview-container\" layout=\"row\"><div flex \nclass=\"vehicle-details-widget-item\" layout=\"column\" layout-align=\"center center\"><p class=\"main-label\" \nng-style=\"{color:vm.toHireDefaultColor.blue}\">{{ vm.getCurrencyValue(vm.totalPrice, vm.invoice.SiteId) }}</p><p>Price\n</p></div><div flex class=\"vehicle-details-widget-item border-left\" layout=\"column\"><div flex class=\"pl-8\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"vehicle-list-item\" layout=\"row\" layout-align=\"center center\">\n<md-icon class=\"icon-small\" md-font-icon=\"icon-calendar-clock\" ng-style=\"{color:vm.toHireDefaultColor.blue}\"></md-icon>\n<div layout=\"column\"><p>Creation Date:</p><p>{{vm.invoice.created | toDate:\"dateTime\":vm.invoice.SiteId}}</p></div>\n</div><div class=\"vehicle-list-item\" layout=\"row\" layout-align=\"center center\"><md-icon class=\"icon-small\" \nmd-font-icon=\"icon-document\" ng-style=\"{color:vm.toHireDefaultColor.blue}\"></md-icon><div layout=\"column\"><p>Status:\n</p><p>{{vm.getInvoiceStatusDescription(vm.invoice)}}</p></div></div><div class=\"vehicle-list-item\" layout=\"row\" \nlayout-align=\"center center\"><md-icon class=\"icon-small\" md-font-icon=\"icon-document\" \nng-style=\"{color:vm.toHireDefaultColor.blue}\"></md-icon><div layout=\"column\"><p>Type:</p><md-select \nng-model=\"vm.invoice.type\" style=\"margin:0px\" aria-label=\"invoiceType\" ng-disabled=\"vm.disableEditInvoiceDetails\">\n<md-option ng-value=\"option.value\" ng-repeat=\"option in vm.invoiceType\">{{option.name}}</md-option></md-select></div>\n</div><div class=\"vehicle-list-item\" layout=\"row\" layout-align=\"center center\"><md-icon class=\"icon-small\" \nmd-font-icon=\"icon-document\" ng-style=\"{color:vm.toHireDefaultColor.blue}\"></md-icon><div layout=\"column\"><p>\nShow document</p><p class=\"vehicleLink\" ng-click=\"vm.openDocument()\">Link</p></div></div></div></div></div></div></div>\n<div layout=\"row\" class=\"row-container\" style=\"height: 340px\" ng-if=\"vm.invoice.type == vm.invoiceType.INVOICE.value\">\n<div flex class=\"vehicle-details-widget white-bg md-whiteframe-4dp\" layout=\"column\" style=\"height: 100%\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"space-between center\"><p>Ticket Contact Details</p><div layout=\"row\"><md-select \nng-model=\"vm.invoice.additional_data.user_type\" style=\"margin: 0px\" ng-disabled=\"!vm.isBeforeTicketInvoice\" \naria-label=\"invoiceUserType\"><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.invoiceUserType\">\n{{option.name}}</md-option></md-select><md-button class=\"md-raised\" ng-show=\"vm.isBeforeTicketInvoice\" \nng-click=\"vm.upgradeToInvoice()\" style=\"margin-left: 12px\">Generate Ticket</md-button></div></div><md-divider>\n</md-divider><div flex class=\"vehicle-details-widget-item\" layout=\"column\"><div flex layout=\"column\" \nng-if=\"vm.invoice.additional_data.user_type==vm.invoiceUserType.PRIVATE_USER.value\"><div \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\" layout-align=\"space-between\"><div flex><label>Name:</label>\n<p>{{vm.invoice.User.name}}</p></div><div flex><label>Surname:</label><p>{{vm.invoice.User.surname}}</p></div><div \nflex><label>Email:</label><p>{{vm.invoice.User.email}}</p></div><div flex><label>Phone:</label><p>\n{{vm.invoice.User.phone}}</p></div></div><div class=\"vehicle-list-item border-bottom p-16\" layout=\"row\" \nlayout-align=\"space-between\"><div flex><label>Adress:</label><p>{{vm.invoice.User.residence}}</p></div><div flex>\n<label>Cap:</label><p>{{vm.invoice.User.cap}}</p></div><div flex><label>City:</label><p>\n{{vm.invoice.User.residence_city}}</p></div><div flex><label>Country:</label><p>{{vm.invoice.User.residence_country}}\n</p></div></div></div><div flex layout=\"column\" \nng-if=\"vm.invoice.additional_data.user_type==vm.invoiceUserType.COMPANY.value\"><form name=\"invoiceDataForm\"><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container><label>Company Name</label><input \nng-model=\"vm.invoice.additional_data.business_name\" ng-disabled=\"!vm.isBeforeTicketInvoice\"></md-input-container>\n<md-input-container><label>Company Address</label><input ng-model=\"vm.invoice.additional_data.business_address\" \nng-disabled=\"!vm.isBeforeTicketInvoice\"></md-input-container><md-input-container><label>Company City</label><input \nng-model=\"vm.invoice.additional_data.business_city\" ng-disabled=\"!vm.isBeforeTicketInvoice\"></md-input-container>\n<md-input-container><label>Company State</label><input ng-model=\"vm.invoice.additional_data.business_state\" \nng-disabled=\"!vm.isBeforeTicketInvoice\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container style=\"margin-top:0px\"><label>Company Country</label><input \nng-model=\"vm.invoice.additional_data.business_country\" ng-disabled=\"!vm.isBeforeTicketInvoice\"></md-input-container>\n<md-input-container style=\"margin-top:0px\"><label>Company phone</label><input \nng-model=\"vm.invoice.additional_data.telephone\" ng-disabled=\"!vm.isBeforeTicketInvoice\"></md-input-container>\n<md-input-container style=\"margin-top:0px\"><label>Company email</label><input \nng-model=\"vm.invoice.additional_data.business_email\" ng-disabled=\"!vm.isBeforeTicketInvoice\"></md-input-container>\n<md-input-container style=\"margin-top:0px\"><label>Company VAT</label><input ng-model=\"vm.invoice.additional_data.vat\" \nng-disabled=\"!vm.isBeforeTicketInvoice\"></md-input-container></div></form></div></div></div></div><div flex \nlayout=\"row\" class=\"row-container\" style=\"height: 500px\"><div flex \nclass=\"vehicle-details-widget white-bg md-whiteframe-4dp\" layout=\"column\" style=\"height: 100%\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"space-between center\"><p>Ticket Details</p><div layout=\"row\"></div></div><md-divider>\n</md-divider><div flex class=\"vehicle-details-widget-item\" layout=\"column\"><div \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Code:</label><p>{{vm.invoice.code}}</p></div><div \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Creation Date:</label><p>\n{{vm.invoice.created | toDate:\"dateTime\":vm.invoice.SiteId}}</p></div><div \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Total minutes:</label><p>{{vm.totalMinutes}}</p></div>\n<div class=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Fare price:</label><p>No fare</p></div><div \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Fare vat:</label><p>22%</p></div><div \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Free minutes:</label><p>No minutes</p></div><div \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Prepaid minutes:</label><p>No minutes</p></div><div \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Coupon:</label><p>No coupon</p></div><div \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Total price:</label><p>\n{{ vm.getCurrencyValue(vm.totalPrice, vm.invoice.SiteId) }}</p></div></div></div><div flex \nclass=\"vehicle-details-widget white-bg md-whiteframe-4dp\" layout=\"column\" style=\"margin-left:12px; height: 100%\"><div \nclass=\"h3\" layout=\"row\" layout-align=\"space-between center\"><p>Ticket Trips</p></div><md-divider></md-divider><div \nflex class=\"vehicle-details-widget-item\" layout=\"column\"><div style=\"margin-top:8px;text-align:center\" \nng-if=\"vm.invoice.Booking.length == 0\">No trip found</div><div ng-if=\"vm.invoice.Booking.length>0\"><div \nclass=\"vehicle-list-item trip-list-item border-bottom\" ng-repeat=\"booking in vm.invoice.Booking\"><div class=\"mt-5\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><label>Trip ID:</label><p>{{booking.Trip.id}}</p>\n</div><div layout=\"row\" ng-click=\"vm.goToVehicleDetailsPage(booking.Trip.Vehicle)\"><label>Vehicle code:</label><p \nclass=\"vehicleLink\">{{booking.Trip.Vehicle.reference_code}}</p></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"vehicle-list-item-icon-medium\" md-svg-icon=\"assets/icons/icon-route.svg\">\n</md-icon><div flex layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"35\" layout=\"row\">\n<label label>From:</label><p>\n{{booking.Trip.StartPosition ? vm.getVehicleShortAddress(booking.Trip.StartPosition) : \"No start position\"}}</p></div>\n<div flex=\"35\" layout=\"row\"><label>Start:</label><p>{{booking.Trip.start |toDate:\"dateTime\":booking.SiteId}}</p></div>\n<div flex=\"30\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"vehicle-list-item-icon-small\" \nmd-svg-icon=\"assets/icons/icon-clock.svg\"></md-icon><label>Duration:</label><p flex>\n{{booking.Trip.duration | number: 0}}min</p></div></div><div layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"35\" layout=\"row\"><label>To:</label><p>\n{{booking.Trip.FinishPosition ? vm.getVehicleShortAddress(booking.Trip.FinishPosition):\"No end position\"}}</p></div>\n<div flex=\"35\" layout=\"row\"><label>End:</label><p>{{booking.Trip.end |toDate:\"dateTime\":booking.SiteId}}</p></div><div \nflex=\"30\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"vehicle-list-item-icon-small\" \nmd-svg-icon=\"assets/icons/icon-dollar.svg\"></md-icon><div flex layout=\"row\"><label>Cost:</label><p>{{booking.price}}\n</p></div></div></div></div><md-icon ng-click=\"vm.goToTripDetailsPage(booking.Trip)\" md-font-icon=\"icon-open-in-new\" \nstyle=\"margin:4px\"></md-icon></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/invoices/dialogs/invoice-manage-dialog.html","<md-dialog class=\"invoice-manage-dialog\" aria-label=\"rectify ticket\"><form name=\"manageInvoiceForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{ dialogType==dialogTypes.add ? \'Add a ticket\': \'Rectify this ticket\'}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content flex layout=\"column\"><p class=\"title-details full\">Select a user:</p>\n<two-hire-autocomplete options=\"searchOptions\" set-result=\"setUser\"></two-hire-autocomplete><div layout=\"column\" \nng-if=\"dialogType==dialogTypes.edit\"><p class=\"title-details\">Ticket info:</p><div class=\"invoice-info-item\" \nlayout=\"row\" layout-align=\"start center\"><label>Code:</label><p>{{invoice.code}}</p></div><div \nclass=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>User:</label><p>{{invoice.User.fullName}}</p>\n</div><div class=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Creation Date:</label><p>\n{{invoice.created | toDate:\"dateTime\":invoice.SiteId}}</p></div><div class=\"invoice-info-item\" layout=\"row\" \nlayout-align=\"start center\"><label>Description:</label><p>{{invoice.description}}</p></div><div \nclass=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Total:</label><p>\n{{ getCurrencyValue(invoice.totalPrice, invoice.SiteId) }}</p></div></div><div layout=\"column\"><p \nclass=\"title-details full\">New info:</p><md-input-container class=\"md-block md-icon-float price-input\"><label>\nPrice (+/-)</label><input ng-model=\"newInvoice.price\" ng-model-options=\"{debounce:1000}\" \nng-change=\"updateTotalPrice()\" type=\"number\" ng-required=\"true\"></md-input-container><md-input-container flex \nclass=\"md-block md-icon-float\"><label>Description</label><textarea ng-model=\"newInvoice.description\" \nmd-maxlenght=\"400\" ng-required=\"true\"></textarea></md-input-container></div><div class=\"invoice-info-item\" \nlayout=\"row\" layout-align=\"start center\"><label>New Total:</label><p>\n{{ getCurrencyValue(newInvoice.newTotal, invoice.SiteId) }}</p></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><two-hire-loading-button \nng-if=\"dialogType==dialogTypes.edit\" type=\"submit\" label=\"\'Rectify\'\" my-on-click=\"callRectifyInvoice()\">\n</two-hire-loading-button><two-hire-loading-button ng-if=\"dialogType==dialogTypes.add\" type=\"submit\" label=\"\'Add\'\" \nmy-on-click=\"callAddInvoice()\"></two-hire-loading-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/maintenance/details/maintenance-details.html","<div id=\"maintenance-details\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-fab md-icon-button\" ng-click=\"vm.goBack()\" \naria-label=\"Go Back\" translate-attr-aria-label=\"VEHICLE.GO_BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n<md-tooltip><span translate=\"VEHICLE.GO_BACK\">Go Back</span></md-tooltip></md-button><div layout=\"row\"><md-button \nclass=\"md-fab md-icon-button\" ng-click=\"vm.refreshRecord()\" aria-label=\"Reload\" \ntranslate-attr-aria-label=\"VEHICLE.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"VEHICLE.RELOAD\">Reload</span></md-tooltip></md-button></div></div></div><div class=\"content\"><div flex \nlayout=\"row\" class=\"row-container\"><div flex layout=\"row\"><div flex \nclass=\"vehicle-details-widget white-bg md-whiteframe-4dp\" layout=\"column\"><div class=\"h3\" layout=\"row\" \nlayout-align=\"space-between center\"><p>{{vm.record.Vehicle.reference_code}} | {{vm.record.Vehicle.id}}</p></div>\n<md-divider></md-divider><div flex class=\"vehicle-details-widget-item\" layout=\"row\"><img \nng-src=\"{{vm.record.Vehicle.Image[0].location}}\" style=\"object-fit:contain\"></div></div></div><div flex \nclass=\"vehicle-details-widget white-bg md-whiteframe-4dp\" layout=\"column\" style=\"margin-left:12px\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"space-between center\"><p>Vehicle Overview</p><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-show=\"!vm.disableEditMaintenanceDetails\" ng-click=\"vm.updateRecord()\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip><span>Confirm</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" \nng-click=\"vm.disableEditMaintenanceDetails ? vm.enableMaintenanceDetailsChange() : vm.disableMaintenanceDetailsChange()\" \naria-label=\"Edit\"><md-icon md-font-icon=\"{{vm.disableEditMaintenanceDetails ? \'icon-pencil\' : \'icon-close\'}}\">\n</md-icon><md-tooltip><span>{{vm.disableEditMaintenanceDetails ? \'Edit\' : \'Cancel\'}}</span></md-tooltip></md-button>\n</div></div><md-divider></md-divider><div flex class=\"vehicle-overview-container\" layout=\"row\"><div flex \nclass=\"vehicle-details-widget-item columnDirection\" layout=\"column\" layout-align=\"center center\"><p class=\"main-label\" \nng-style=\"{color:vm.toHireDefaultColor.blue}\">{{vm.record.Vehicle.total_percentage}}%</p><p>Battery Level</p></div><div\n flex class=\"vehicle-details-widget-item border-left\" layout=\"column\" style=\"padding-top: 0px\"><div flex \nlayout=\"column\" layout-align=\"center start\"><div class=\"vehicle-list-item\" layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"vehicle-list-item-icon-medium\" md-svg-icon=\"assets/icons/icon-license-plate.svg\"></md-icon><div \nlayout=\"column\"><p>License Plate:</p><p>{{vm.record.Vehicle.license_plate}}</p></div></div><div \nclass=\"vehicle-list-item\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-icon=\"assets/icons/icon-location-pointer.svg\"></md-icon><div layout=\"column\"><p>Position:</p><p>\n{{vm.record.Vehicle.address}}</p></div></div><div class=\"vehicle-list-item\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-svg-icon=\"assets/icons/icon-scooter-front.svg\"></md-icon><div layout=\"column\"><p>Maintenance category:</p>\n<md-select ng-model=\"vm.record.category\" ng-disabled=\"vm.disableEditMaintenanceDetails\" style=\"margin: 0px\"><md-option \nng-value=\"category.value\" ng-repeat=\"category in vm.maintenanceCategories\">{{category.name}}</md-option></md-select>\n</div></div><div class=\"vehicle-list-item\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-icon=\"assets/icons/icon-scooter-front.svg\"></md-icon><div layout=\"column\"><p>Maintenance ype:</p><md-select \nng-model=\"vm.record.type\" ng-disabled=\"vm.disableEditMaintenanceDetails\" style=\"margin: 0px;width: 125.64px\"><md-option\n ng-repeat=\"type in vm.maintenanceType\" ng-value=\"type.value\">{{type.name}}</md-option></md-select></div></div><div \nclass=\"vehicle-list-item\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-icon=\"assets/icons/icon-scooter-front.svg\"></md-icon><div flex layout=\"column\"><p>Description</p><textarea \nng-class=\"{\'border-bottom\': !vm.disableEditMaintenanceDetails}\" type=\"text\" ng-model=\"vm.record.description\" rows=\"3\" \nng-disabled=\"vm.disableEditMaintenanceDetails\" style=\"resize: none\"></textarea></div></div></div></div></div></div>\n</div><div flex layout=\"column\" class=\"row-container\"><div flex \nclass=\"vehicle-details-widget manage-maintenance-widget white-bg md-whiteframe-4dp\" layout=\"column\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"space-between center\"><p>Manage maintenance</p></div><md-divider></md-divider><div \nclass=\"vehicle-details-widget-item\"><div class=\"statusBallContainer\"><div class=\"maintenanceStatusBall\" \nng-class=\"vm.record.status >= vm.maintenanceStatus.OPEN.value ? \'enabled\' : \'disabled\'\">\n{{vm.maintenanceStatus.OPEN.name}}</div><div class=\"maintenanceStatusBall\" \nng-class=\"vm.record.status >= vm.maintenanceStatus.WORKING.value ? \'enabled\' : \'disabled\'\">\n{{vm.maintenanceStatus.WORKING.name}}</div><div class=\"maintenanceStatusBall enabled blockStatus\" \nng-hide=\"vm.record.status != vm.maintenanceStatus.BLOCKED.value\">{{vm.maintenanceStatus.BLOCKED.name}}</div><div \nclass=\"maintenanceStatusBall\" \nng-class=\"vm.record.status == vm.maintenanceStatus.FINISHED.value ? \'enabled\' : \'disabled\'\">\n{{vm.maintenanceStatus.FINISHED.name}}</div></div></div><div class=\"buttonBar\" \nng-hide=\"vm.record.status == vm.maintenanceStatus.FINISHED.value\"><md-button class=\"md-raised buttonAdvance\" \nng-hide=\"vm.record.status == vm.maintenanceStatus.BLOCKED.value\" \nng-click=\"vm.record.status == vm.maintenanceStatus.WORKING.value ? vm.closeMaintenance() : vm.advanceStatus()\">\n{{vm.record.status == vm.maintenanceStatus.WORKING.value ? \'Report as finished\' : \'Advance status\'}}</md-button>\n<md-button class=\"md-raised buttonBack\" \nng-hide=\"vm.record.status == vm.maintenanceStatus.OPEN.value || vm.record.status == vm.maintenanceStatus.BLOCKED.value\" \nng-click=\"vm.goBackAStatus()\">Go back</md-button><md-button class=\"md-raised buttonBlock\" \nng-click=\"vm.record.status == vm.maintenanceStatus.BLOCKED.value ? vm.unblockMaintenance() : vm.blockMaintenance()\">\n{{vm.record.status == vm.maintenanceStatus.BLOCKED.value ? \'Unblock maintenance\' : \'Block maintenance\'}}</md-button>\n</div></div></div><div class=\"commentsContainer md-whiteframe-4dp roundCorners\"><div \nclass=\"commentsContainerTitle centersSingleElement\">Comments</div><div class=\"commentsList\"><div class=\"commentRow\" \nng-repeat=\"comment in vm.comments\" ng-class=\"comment.UserId == vm.userId? \'rightComment\':\'leftComment\'\"><div \nclass=\"commentContent\">{{comment.description}}</div></div><div class=\"commentListFooter\"></div></div><div \nclass=\"barContainer\"><div class=\"newCommentBar\"><input class=\"invisibleInput\" \nplaceholder=\"{{vm.record.status == vm.maintenanceStatus.FINISHED.value ? \'You cannot add a comment to a closed record\' : \'Insert new comment\'}}\" \nng-model=\"vm.newComment.description\" ng-keyup=\"vm.checkForEnterAndSendComment($event)\" \nng-disabled=\"vm.record.status == vm.maintenanceStatus.FINISHED.value\"><md-button \nclass=\"md-icon-button sendCommentButton\" ng-click=\"vm.addComment()\" \nng-disabled=\"vm.record.status == vm.maintenanceStatus.FINISHED.value\"><md-icon class=\"icon-arrow-up sendIcon\">\n</md-icon></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/maintenance/dialogs/maintenance-add-record-dialog.html","<md-dialog class=\"maintenance-add-record-dialog\" aria-label=\"Add New Maintenance Record\"><form \nname=\"addMaintenanceRecordForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAdd Maintenance Record</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"VEHICLE.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><md-content flex><md-autocomplete required md-no-cache=\"false\" \nmd-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.reference_code\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-min-length=\"0\" \nplaceholder=\"Select vehicle (ref. code or license plate)\"><md-item-template><span md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">Ref. Code: {{item.reference_code}} , License Plate: {{item.license_plate}}</span>\n</md-item-template><md-not-found>No vehicle matching \"{{vm.searchText}}\" was found.</md-not-found></md-autocomplete>\n<div class=\"inputsContainer\" layout-align=\"space-between center\" style=\"padding-top: 16px\"><md-input-container \nflex=\"30\"><label>Category</label><md-select ng-model=\"vm.dataToSend.category\" style=\"margin-top: 0px\"><md-option \nng-value=\"category.value\" ng-repeat=\"category in vm.maintenanceCategories\">{{category.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"30\"><label>Type</label><md-select ng-model=\"vm.dataToSend.type\" \nstyle=\"margin-top: 0px\"><md-option ng-value=\"type.value\" ng-repeat=\"type in vm.maintenanceType\">{{type.name}}\n</md-option></md-select></md-input-container><md-input-container flex=\"30\" style=\"margin-bottom: 0px\"><label>\nEta (number of days)</label><input name=\"eta\" ng-model=\"vm.dataToSend.eta\" type=\"number\" min=\"0\" required><div \nng-messages=\"addMaintenanceRecordForm.eta.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \nclass=\"my-message\">You must supply a eta</div><div ng-message=\"min\" class=\"my-message\">Min 0 day/s</div></div>\n</md-input-container></div><div class=\"inputsContainer\"><md-input-container flex=\"100\"><label>Description</label>\n<textarea ng-model=\"vm.dataToSend.description\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus required>\n                    </md-input-container>\n                </div>\n\n            </md-content>\n\n\n\n        \n</md-dialog-content>\n        \n\n        \n        <md-dialog-actions layout=\"row\" layout-align=\"end center\">\n\n            <md-button type=\"submit\" ng-click=\"vm.callAddRecord()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"addMaintenanceRecordForm.$invalid || addMaintenanceRecordForm.$pristine\" aria-label=\"Add\" \ntranslate=\"VEHICLE.ADD\" translate-attr-aria-label=\"VEHICLE.ADD\">\n                ADD\n            </md-button>\n        \n</md-dialog-actions>\n        \n\n    </form>\n\n</md-dialog>");
$templateCache.put("app/main/rent/gantt-chart/gantt-chart.html","<div id=\"gantt-chart\" class=\"page-layout carded fullwidth\" \nng-class=\"{\'date-filter-active\':vm.dateFilterActive, \'search-active\': vm.searchActive}\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-text\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text\" translate=\"GANTT.GANTT_CHART\">Current rents</span></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchActive = !vm.searchActive\" \naria-label=\"Search\" translate translate-attr-aria-label=\"GANTT.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-tooltip><span translate=\"GANTT.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.dateFilterActive = !vm.dateFilterActive\" aria-label=\"Filter Date\" translate \ntranslate-attr-aria-label=\"GANTT.FILTER_DATE\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip><span \ntranslate=\"GANTT.FILTER_DATE\">Filter Date</span></md-tooltip></md-button><md-button ng-click=\"vm.reload()\" \nclass=\"md-icon-button\" aria-label=\"Reload\" translate translate-attr-aria-label=\"GANTT.RELOAD\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"GANTT.RELOAD\">RELOAD</span></md-tooltip></md-button>\n</div></div><div class=\"bottom\" layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><div \nclass=\"search-boxes\" flex ng-show=\"vm.searchActive\" layout=\"column\" layout-gt-xs=\"row\"><div \nclass=\"search md-whiteframe-3dp mr-8\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchRowKeyword\" \nng-change=\"vm.search(\'rows\', vm.searchRowKeyword)\" type=\"text\" placeholder=\"Search in rows\" translate \ntranslate-attr-placeholder=\"GANTT.SEARCH_IN_ROWS\"></div><div class=\"search md-whiteframe-3dp\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchTaskKeyword\" ng-change=\"vm.search(\'tasks\', vm.searchTaskKeyword)\" type=\"text\" \nplaceholder=\"Search in tasks\" translate translate-attr-placeholder=\"GANTT.SEARCH_IN_TASKS\"></div></div><div \nclass=\"date-filter-box md-whiteframe-3dp\" ng-show=\"vm.dateFilterActive\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"center center\"><div layout=\"row\" layout-align=\"center center\" class=\"filter from\"><span \nclass=\"label\">From:</span><md-datepicker ms-datepicker-fix ng-model=\"vm.options.fromDate\" \nng-change=\"vm.checkDate(\'from\')\" md-current-view=\"year\" md-placeholder=\"Enter date\"></md-datepicker></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"filter to\"><span class=\"label\">To:</span><md-datepicker \nms-datepicker-fix ng-model=\"vm.options.toDate\" ng-change=\"vm.checkDate(\'to\')\" md-current-view=\"year\" \nmd-placeholder=\"Enter date\"></md-datepicker></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div\n class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"vm.addDialog($event)\" class=\"md-icon-button add-row-button\" aria-label=\"Add\" translate \ntranslate-attr-aria-label=\"GANTT.ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"zoom\" layout=\"row\" layout-align=\"end center\"><span class=\"label\">Zoom:</span>\n<div class=\"input-wrapper\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \naria-label=\"minus\" ng-click=\"vm.options.zoom  = vm.options.zoom - 0.1\"><md-icon md-font-icon=\"icon-minus\"></md-icon>\n</md-button><input type=\"number\" ng-model=\"vm.options.zoom\" step=\"0.1\" min=\"0.1\" max=\"5\"><md-button \nclass=\"md-icon-button\" aria-label=\"plus\" ng-click=\"vm.options.zoom =vm.options.zoom + 0.1\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><md-select class=\"simplified select-scale\" \nng-model=\"vm.options.scale\" placeholder=\"Scale\"><md-option value=\"hour\" translate=\"GANTT.HOUR\">hour</md-option>\n<md-option value=\"3 hours\" translate=\"GANTT.3_HOURS\">3 hours</md-option><md-option value=\"day\" translate=\"GANTT.DAY\">\nday</md-option><md-option value=\"week\" translate=\"GANTT.WEEK\">week</md-option><md-option value=\"2 weeks\" \ntranslate=\"GANTT.2_WEEKS\">2 weeks</md-option><md-option value=\"month\" translate=\"GANTT.MONTH\">month</md-option>\n<md-option value=\"quarter\" translate=\"GANTT.QUARTER\">quarter</md-option><md-option value=\"6 months\" \ntranslate=\"GANTT.6_MONTHS\">6 months</md-option><md-option value=\"year\" translate=\"GANTT.YEAR\">year</md-option>\n</md-select><div class=\"divider-vertical\"></div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon \nmd-font-icon=\"icon-sort\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(undefined)\" translate=\"GANTT.DISABLED\" \ntranslate-attr-aria-label=\"GANTT.DISABLED\">disabled</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(\'from\')\" translate=\"GANTT.FROM\" translate-attr-aria-label=\"GANTT.FROM\">\nfrom</md-button></md-menu-item><md-menu-item><md-button aria-label=\"disabled\" ng-click=\"vm.setSortMode(\'to\')\" \ntranslate=\"GANTT.TO\" translate-attr-aria-label=\"GANTT.TO\">to</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(\'model.name\')\" translate=\"GANTT.NAME\" \ntranslate-attr-aria-label=\"GANTT.NAME\">name</md-button></md-menu-item></md-menu-content></md-menu></div></div>\n<md-content id=\"chart-container\" class=\"content\" flex layout=\"column\"><div flex layout-fill id=\"gantt\" gantt \ndata=\"vm.data\" timespans=\"vm.timespans\" show-side=\"vm.options.labelsEnabled\" daily=\"vm.options.daily\" \nfilter-task=\"{\'name\': vm.options.filterTask}\" filter-row=\"{\'name\': vm.options.filterRow}\" \nsort-mode=\"vm.options.sortMode\" view-scale=\"vm.options.scale\" \ncolumn-width=\"vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)\" \nauto-expand=\"vm.options.autoExpand\" task-out-of-range=\"vm.options.taskOutOfRange\" from-date=\"vm.options.fromDate\" \nto-date=\"vm.options.toDate\" allow-side-resizing=\"vm.options.allowSideResizing\" \ntask-content=\"vm.options.taskContentEnabled ? vm.options.taskContent : undefined\" \nrow-content=\"vm.options.rowContentEnabled ? vm.options.rowContent : undefined\" current-date=\"vm.options.currentDate\" \ncurrent-date-value=\"vm.options.currentDateValue\" \nheaders=\"vm.options.width && vm.options.shortHeaders || vm.options.longHeaders\" max-height=\"vm.options.maxHeight\" \ntime-frames=\"vm.options.timeFrames\" date-frames=\"vm.options.dateFrames\" \ntime-frames-non-working-mode=\"vm.options.timeFramesNonWorkingMode\" time-frames-magnet=\"vm.options.timeFramesMagnet\" \napi=\"vm.options.api\" column-magnet=\"vm.options.columnMagnet\"><gantt-tree \nenabled=\"vm.options.sideMode === \'Tree\' || vm.options.sideMode === \'TreeTable\'\" \nheader-content=\"vm.options.treeHeaderContent\" keep-ancestor-on-filter-row=\"true\"></gantt-tree><gantt-table \nenabled=\"vm.options.sideMode === \'Table\' || vm.options.sideMode === \'TreeTable\'\" \ncolumns=\"vm.options.sideMode === \'TreeTable\' ? vm.options.treeTableColumns : vm.options.columns\" \nheaders=\"vm.options.columnsHeaders\" classes=\"vm.options.columnsClasses\" formatters=\"vm.options.columnsFormatters\" \ncontents=\"vm.options.columnsContents\" header-contents=\"vm.options.columnsHeaderContents\"></gantt-table><gantt-groups \nenabled=\"vm.options.groupDisplayMode === \'group\' || vm.options.groupDisplayMode === \'overview\' || vm.options.groupDisplayMode === \'promote\'\" \ndisplay=\"vm.options.groupDisplayMode\"></gantt-groups><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress>\n<gantt-sortable></gantt-sortable><gantt-movable enabled=\"false\" allow-moving=\"false\" allow-resizing=\"false\" \nallow-row-switching=\"false\"></gantt-movable><gantt-draw-task enabled=\"vm.options.canDraw\" move-threshold=\"2\" \ntask-factory=\"vm.options.drawTaskFactory\"></gantt-draw-task><gantt-resize-sensor></gantt-resize-sensor>\n<gantt-dependencies></gantt-dependencies></div></md-content></div></div></div>");
$templateCache.put("app/main/rent/manage/reservation-manager.html","<div id=\"e-commerce-orders\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span translate=\"MG.ONGOING_RESERVATIONS\">Ongoing Reservations</span></div><div class=\"order-count secondary-text\">\n<span translate=\"MG.TOTAL_RESERVATIONS\">Total reservations:</span> <span>{{vm.aliveReservations.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex hide show-gt-xs><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"EC.SEARCH\" flex></div>\n<md-button class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.refreshAliveReservations()\" aria-label=\"refresh\">\n<md-icon md-font-icon=\"icon-reload\"></md-icon></md-button></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Pick Up</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Return</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Pick Up Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Return Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"aliveReservation in vm.aliveReservations track by $index \"><td>{{aliveReservation.id}}</td><td>\n{{aliveReservation.User.name}} {{aliveReservation.User.surname}}</td><td>{{aliveReservation.CategoryRent.name}}</td>\n<td>{{aliveReservation.CategoryRent.type}}</td><td>{{aliveReservation.status}}</td><td>{{aliveReservation.PickUp.name}}\n</td><td>{{aliveReservation.Return.name}}</td><td>\n{{aliveReservation.start | toDate:\"dateTime\":aliveReservation.SiteId}}</td><td>\n{{aliveReservation.end | toDate:\"dateTime\":aliveReservation.SiteId}}</td><td><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.openAssignVehicleDialog(aliveReservation,$event)\" aria-label=\"aliveReservation details\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>Manage</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteAliveReservation(aliveReservation,$index)\" aria-label=\"aliveReservation delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></td>\n</tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/settings/apisettings/apiSettings.html","<div id=\"api-settings\"><two-hire-service-settings site-name=\"\'Default\'\" \nservice-settings=\"vm.currentServiceSettings.base\" show-app-translations=\"true\" \non-update-service-settings=\"vm.callUpdateBaseServiceSettings()\"></two-hire-service-settings><div \nng-repeat=\"site in vm.sites | filter: vm.filterSelectedSite\"><two-hire-service-settings site-name=\"site.name\" \nsite-id=\"site.id\" service-settings=\"vm.currentServiceSettings.specific[site.id]\" permit-delete=\"true\" \non-update-service-settings=\"vm.callUpdateSpecificServiceSettings(site.id)\"></two-hire-service-settings></div></div>");
$templateCache.put("app/main/settings/damages/damagesList.html","<div id=\"damagesList\"><div class=\"title\"><span>Damages</span><div class=\"buttonContainer\"><md-button \nid=\"newDamageButton\" class=\"md-icon-button md-fab newDamageButton\" ng-click=\"vm.addDamageButtonAction($event)\" \nstyle=\"background-color: #4173C4\" aria-label=\"addDamage\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button class=\"md-icon-button md-fab\" ng-click=\"vm.exportListAsCSV()\" aria-label=\"exportCsv\" \nstyle=\"background-color: #4173C4\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span>Export As CSV\n</span></md-tooltip></md-button></div></div><div class=\"container\"><div class=\"list\"><div \nclass=\"element roundCorners md-whiteframe-4dp\" ng-hide=\"!vm.isAddingDamage\"><div class=\"titleDescriptionContainer\">\n<input class=\"elementTitle onlyBottomBorderInput\" placeholder=\"Title\" ng-model=\"vm.newDamage.name\"> <input \nclass=\"elementDescription onlyBottomBorderInput\" placeholder=\"Description\" ng-model=\"vm.newDamage.description\">\n<md-button class=\"closeButton md-icon-button\" ng-click=\"vm.addDamage()\" aria-label=\"addDamage\"><md-icon \nclass=\"icon-check centersSingleElement\"></md-icon></md-button></div><input \nclass=\"priceContainer centersSingleElement onlyBottomBorderInput\" placeholder=\"Price\" ng-model=\"vm.newDamage.price\">\n</div><div class=\"element roundCorners md-whiteframe-4dp\" ng-repeat=\"damage in vm.damages\"><div \nclass=\"titleDescriptionContainer\"><div class=\"elementTitle\" ng-hide=\"damage.isBeingModified\">{{damage.name}}</div>\n<input class=\"elementTitle onlyBottomBorderInput\" placeholder=\"Title\" ng-model=\"damage.name\" \nng-hide=\"!damage.isBeingModified\"><div class=\"elementDescription\" ng-hide=\"damage.isBeingModified\"><p>\n{{damage.description}}</p></div><input class=\"elementDescription onlyBottomBorderInput\" placeholder=\"Description\" \nng-model=\"damage.description\" ng-hide=\"!damage.isBeingModified\"><md-button class=\"editButton md-icon-button\" \nng-click=\"vm.modifyButtonAction(damage)\" aria-label=\"modifyDamage\"><md-icon class=\"centersSingleElement\" \nng-class=\"damage.isBeingModified? \'icon-check\' : \'icon-pencil\' \"></md-icon></md-button><md-button \nclass=\"closeButton md-icon-button\" ng-click=\"vm.deleteButtonAction(damage,$event)\" aria-label=\"deleteDamage\"><md-icon \nclass=\"centersSingleElement\" ng-class=\"damage.isBeingModified? \'icon-close\' : \'icon-delete\' \"></md-icon></md-button>\n</div><div class=\"priceContainer centersSingleElement\" ng-hide=\"damage.isBeingModified\"><span>\n{{ vm.getCurrencyValue(damage.price, damage.SiteId) }}</span></div><input \nclass=\"priceContainer centersSingleElement onlyBottomBorderInput\" placeholder=\"Price\" ng-model=\"damage.price\" \nng-hide=\"!damage.isBeingModified\"></div></div></div></div>");
$templateCache.put("app/main/settings/devices/devices-list.html","<div id=\"devices-list\"><div class=\"title\"><span>Devices</span><div class=\"buttonContainer\"><md-button \nid=\"newCouponButton\" class=\"md-icon-button md-fab newDamageButton md-whiteframe-2dp\" \nng-click=\"vm.addCouponAction($event)\" aria-label=\"addCoupon\" style=\"background-color: #4173C4\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><generic-table headers=\"vm.tableFields\" data=\"vm.devices\" \nsearch-filters=\"vm.searchFilters\" filters=\"vm.filters\" update-data=\"vm.refreshDevices\" \napply-filters-trigger=\"vm.applyFiltersTrigger\" enable-auto-refresh=\"true\" page-id=\"devices-list\"></generic-table></div>");
$templateCache.put("app/main/settings/fares/fares-list.html","<div id=\"faresList\"><div class=\"title\"><span>Fares</span><div class=\"buttonContainer\"><md-button id=\"newFareButton\" \nclass=\"md-icon-button md-fab newDamageButton md-whiteframe-2dp\" ng-click=\"vm.addFareButtonAction($event)\" \nstyle=\"background-color: #4173C4\" aria-label=\"addFareButtonAction\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button><md-button class=\"md-icon-button md-fab\" ng-click=\"vm.exportListAsCSV()\" style=\"background-color: #4173C4\">\n<md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span>Export As CSV</span></md-tooltip></md-button></div>\n</div><div class=\"container\"><div class=\"list\"><div class=\"element roundCorners md-whiteframe-4dp\" \nng-hide=\"!vm.isAddingFare\"><div class=\"titleDescriptionContainer\"><input class=\"elementTitle onlyBottomBorderInput\" \nplaceholder=\"Name\" ng-model=\"vm.newFare.name\"><div class=\"datePickersContainer\"><span class=\"datePickerTitle\">Start:\n</span><md-datepicker md-open-on-focus class=\"singleDatePicker\" ng-model=\"vm.newFare.start\" md-current-view=\"year\">\n</md-datepicker><span class=\"datePickerTitle\">End:</span><md-datepicker md-open-on-focus class=\"doubleDatePicker\" \nng-model=\"vm.newFare.end\" md-current-view=\"year\" ng-disabled=\"vm.newFare.unlimited\"></md-datepicker><md-checkbox \nclass=\"doubleDatePicker\" ng-model=\"vm.newFare.unlimited\">Unlimited</md-checkbox></div><md-button \nclass=\"closeButton md-icon-button\" ng-click=\"vm.addFare()\" aria-label=\"addFare\"><md-icon \nclass=\"icon-check centersSingleElement\"></md-icon></md-button></div><div \nclass=\"multiplePriceContainer editPricesContainer\"><div class=\"priceContainer centersSingleElement\"><div \nclass=\"priceTitle\">Running:</div><input class=\"onlyBottomBorderInput priceInput\" placeholder=\"Price\" \nng-model=\"vm.newFare.prices[0].price\" type=\"number\" min=\"0\"> <input class=\"valueInput\" placeholder=\"Value\" \nng-model=\"vm.newFare.prices[0].value\" ng-if=\"vm.newFare.prices[0].type == vm.fareType.KM.value\" type=\"number\" min=\"0\">\n<md-select class=\"onlyBottomBorderInput typeSelect\" placeholder=\"Type\" ng-model=\"vm.newFare.prices[0].type\"><md-option \nvalue=\"{{fare.value}}\" ng-repeat=\"fare in vm.fareType\">{{fare.name}}</md-option></md-select></div><div \nclass=\"priceContainer centersSingleElement\"><div class=\"priceTitle\">Parked:</div><input \nclass=\"onlyBottomBorderInput priceInput\" placeholder=\"Price\" ng-model=\"vm.newFare.prices[1].price\" type=\"number\" \nmin=\"0\"> <input class=\"valueInput\" placeholder=\"Value\" ng-model=\"vm.newFare.value\" \nng-if=\"vm.newFare.prices[1].type == vm.fareType.KM.value\" type=\"number\" min=\"0\"><md-select \nclass=\"onlyBottomBorderInput typeSelect\" placeholder=\"Type\" ng-model=\"vm.newFare.prices[1].type\"><md-option \nvalue=\"{{fare.value}}\" ng-repeat=\"fare in vm.fareType\">{{fare.name}}</md-option></md-select></div></div><input \nclass=\"onlyBottomBorderInput vatInput typeSelect\" placeholder=\"Vat\" ng-model=\"vm.newFare.vat\" type=\"number\" min=\"0\">\n</div><div class=\"element roundCorners md-whiteframe-4dp\" ng-repeat=\"fare in vm.fares\"><div \nclass=\"titleDescriptionContainer\"><div class=\"elementTitle\" ng-hide=\"fare.isBeingModified\">{{fare.name}}</div><input \nclass=\"elementTitle onlyBottomBorderInput\" placeholder=\"Name\" ng-model=\"fare.name\" ng-hide=\"!fare.isBeingModified\"><div\n class=\"datePickersContainer\" ng-hide=\"fare.isBeingModified\"><span class=\"datePickerTitle\">Start:</span><div \nclass=\"singleDatePicker dateValue\">{{fare.start | toDate}}</div><span class=\"datePickerTitle\">End:</span><div \nclass=\"doubleDatePicker dateValue\">{{fare.end | toDate}}</div><md-checkbox class=\"doubleDatePicker\" \nng-model=\"fare.unlimited\" ng-disabled=\"true\">Unlimited</md-checkbox></div><div class=\"datePickersContainer\" \nng-hide=\"!fare.isBeingModified\"><span class=\"datePickerTitle\">Start:</span><md-datepicker md-open-on-focus \nclass=\"singleDatePicker\" ng-model=\"fare.startDate\" ms-datepicker-fix md-current-view=\"year\"></md-datepicker><span \nclass=\"datePickerTitle\">End:</span><md-datepicker md-open-on-focus class=\"doubleDatePicker\" ng-model=\"fare.endDate\" \nng-disabled=\"fare.unlimited\" ms-datepicker-fix md-current-view=\"year\"></md-datepicker><md-checkbox \nclass=\"doubleDatePicker\" ng-model=\"fare.unlimited\">Unlimited</md-checkbox></div><md-button \nclass=\"editButton md-icon-button\" ng-click=\"vm.modifyButtonAction(fare)\" aria-label=\"modifyButtonAction\"><md-icon \nclass=\"centersSingleElement\" ng-class=\"fare.isBeingModified? \'icon-check\' : \'icon-pencil\' \"></md-icon></md-button>\n<md-button class=\"closeButton md-icon-button\" ng-click=\"vm.deleteButtonAction(fare,ev)\" \naria-label=\"deleteButtonAction\"><md-icon class=\"centersSingleElement\" \nng-class=\"fare.isBeingModified? \'icon-close\' : \'icon-delete\' \"></md-icon></md-button></div><div \nclass=\"multiplePriceContainer\"><div class=\"priceContainer centersSingleElement\"><div class=\"priceTitle\">Running:</div>\n<div class=\"onlyBottomBorderInput priceInput\" ng-hide=\"fare.isBeingModified\">\n{{ vm.getCurrencyValue(fare.prices[0].price, fare.SiteId ) }}</div><div class=\"onlyBottomBorderInput typeSelect\" \nng-hide=\"fare.isBeingModified\">/{{vm.getFareTypeDescription(fare.prices[0])}}</div><input \nclass=\"onlyBottomBorderInput priceInput\" placeholder=\"Price\" ng-model=\"fare.prices[0].price\" \nng-hide=\"!fare.isBeingModified\" min=\"0\"><md-select class=\"onlyBottomBorderInput typeSelect\" placeholder=\"Type\" \nng-model=\"fare.prices[0].type\" ng-hide=\"!fare.isBeingModified\"><md-option value=\"{{fare.value}}\" \nng-repeat=\"fare in vm.fareType\">{{fare.name}}</md-option></md-select></div><div \nclass=\"priceContainer centersSingleElement\"><div class=\"priceTitle\">Parked:</div><div \nclass=\"onlyBottomBorderInput priceInput\" ng-hide=\"fare.isBeingModified\">\n{{ vm.getCurrencyValue(fare.prices[1].price, fare.SiteId ) }}</div><div class=\"onlyBottomBorderInput typeSelect\" \nng-hide=\"fare.isBeingModified\">/{{vm.getFareTypeDescription(fare.prices[1])}}</div><input \nclass=\"onlyBottomBorderInput priceInput\" placeholder=\"Price\" ng-model=\"fare.prices[1].price\" \nng-hide=\"!fare.isBeingModified\" min=\"0\"><md-select class=\"onlyBottomBorderInput typeSelect\" placeholder=\"Type\" \nng-model=\"fare.prices[1].type\" ng-hide=\"!fare.isBeingModified\"><md-option value=\"{{fare.value}}\" \nng-repeat=\"fare in vm.fareType\">{{fare.name}}</md-option></md-select></div></div><div \nclass=\"onlyBottomBorderInput vatInput typeSelect\" ng-hide=\"fare.isBeingModified\">Vat: {{fare.vat}}%</div><input \nclass=\"onlyBottomBorderInput vatInput\" placeholder=\"Vat\" ng-model=\"fare.vat\" ng-hide=\"!fare.isBeingModified\" \ntype=\"number\" min=\"0\"><div class=\"footerContainer\"><p class=\"bottomGeofenceIndicator\" ng-click=\"vm.goToGeofence()\">\n{{fare.GeoFencing.length == 0? \'add to geofence\' : \'view geofence\'}}</p><md-button class=\"setFareAsDefaultButton\" \nng-class=\"{\'activated\':fare.defaultService}\" ng-click=\"vm.setFareAsDefault(fare)\">\n{{fare.defaultService ? \'Default Fare\' : \'Set as default\'}}</md-button></div></div></div></div></div>");
$templateCache.put("app/main/settings/geofencing/geofencing-manager.html","<div id=\"geofencing-manager\"><div class=\"container\"><div class=\"mapTitleContainer md-whiteframe-4dp\"><div \nclass=\"containerTitle\"><span>{{vm.title}}</span><div class=\"backButtonContainer centersSingleElement\"><md-button \nclass=\"md-icon-button backButton md-whiteframe-2dp\" ng-hide=\"!vm.isAreaDetail\" ng-click=\"vm.goBackButtonAction()\" \naria-label=\"goBackButtonAction\"><md-icon class=\"icon-arrow-left centersSingleElement\"></md-icon></md-button></div>\n</div><div class=\"mapContainer\"><md-button id=\"addAreaButton\" \nclass=\"md-icon-button addGeofenceButton md-whiteframe-1dp\" ng-click=\"vm.addGeofencingAreaButtonAction($event)\" \nng-hide=\"vm.isEditing || vm.isAreaDetail\" aria-label=\"addAreaButtonAction\"><md-icon class=\"icon-plus\"></md-icon>\n</md-button><md-button class=\"md-icon-button undoButton md-whiteframe-1dp\" ng-click=\"vm.undoPolygon($event)\" \nng-hide=\"!vm.isDrawingArea || vm.polygons.length == 0 || (vm.polygonHistory.length == 0 && vm.isEditing)\" \naria-label=\"undoPolygon\"><md-icon class=\"icon-undo-variant\"></md-icon></md-button><div \nclass=\"drawingToolsContainer md-whiteframe-1dp roundCorners\" ng-hide=\"!vm.isDrawingArea\"><div \nclass=\"containerTitle smallTitle\">Drawing tools</div><div class=\"toolsContainer\"><md-button \nclass=\"md-icon-button tool\" ng-click=\"vm.handDrawingToolClicked()\" aria-label=\"handDrawingToolClickedButton\"><md-icon \nmd-svg-src=\"/assets/icons/hold.svg\"></md-icon></md-button><md-button class=\"md-icon-button tool\" \nng-click=\"vm.polygonDrawingToolClicked()\" ng-class=\"vm.drawingTools.polygon? \'active\': \'\'\" \naria-label=\"polygonDrawingToolClickedButton\"><md-icon md-svg-src=\"/assets/icons/POLIGON.svg\"></md-icon></md-button>\n<md-button class=\"md-icon-button tool\" ng-click=\"vm.polygonMinusDrawingToolClicked()\" \nng-class=\"vm.drawingTools.polygonMinus? \'active\': \'\'\" aria-label=\"polygonMinusDrawingToolClickedButton\"><md-icon \nmd-svg-src=\"/assets/icons/POLIGON-.svg\"></md-icon></md-button></div></div><two-hire-vehicle-map flex \non-map-init=\"vm.onMapInit\" hide-geofence=\"true\" map-provider=\"vm.MapProvider.GOOGLE_MAPS\"></two-hire-vehicle-map></div>\n</div><div class=\"areaListContainer md-whiteframe-4dp roundCorners\" \nng-hide=\"!vm.isDrawingArea || vm.isAreaDetail || !vm.newArea.id\"><div class=\"containerTitle mediumTitle\">\nNew geofencing area</div><div class=\"areaList\"><div class=\"areaRow\"><div class=\"areaCell areaCellId\"><div \nclass=\"areaCellElement areaCellTitle\">ID</div><div class=\"areaCellElement\">{{vm.newArea.id}}</div></div><div \nclass=\"areaCell areaCelWithInput\"><div class=\"areaCellElement areaCellTitle\">Name</div><div class=\"areaCellElement\">\n<md-input-container md-no-float><input ng-model=\"vm.newArea.name\" type=\"text\" aria-label=\"areaName\">\n</md-input-container></div></div><div class=\"areaCell areaCelWithInput\"><div class=\"areaCellElement areaCellTitle\">Site\n</div><div class=\"areaCellElement\">{{ vm.getSiteName(vm.selectedSiteId) }}</div></div><div \nclass=\"areaCell areaCelWithInput\"><div class=\"areaCellElement areaCellTitle\">Type</div><div class=\"areaCellElement\">\n<md-input-container md-no-float><md-select ng-model=\"vm.newArea.vehicleType\" aria-label=\"vehicleType\"><md-option \nng-value=\"null\">Default</md-option><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.vehicleType\">\n{{option.name}}</md-option></md-select></md-input-container></div></div><div class=\"areaCell areaCellDate\"><div \nclass=\"areaCellElement areaCellTitle\">Registration date</div><div class=\"areaCellElement\">\n{{ vm.toDateFilter(vm.newArea.registrationDate, \'dateTime\',vm.selectedSiteId) }}</div></div><div class=\"areaCell\"><div \nclass=\"areaCellElement areaCellTitle\">Latest review</div><div class=\"areaCellElement\">\n{{ vm.toDateFilter(vm.newArea.latestReview, \'dateTime\',vm.selectedSiteId) }}</div></div><div class=\"areaCell\"><div \nclass=\"areaCellElement areaCellTitle\">Area</div><div class=\"areaCellElement\">{{vm.newArea.area | number: 2}}km<sup>2\n</sup></div></div><div class=\"areaCell areaCellButton\"><md-button class=\"areaButton saveButton\" \nng-click=\"vm.addGeofencingArea()\" aria-label=\"addGeofencingAreaButton\">Save</md-button></div></div></div></div><div \nclass=\"areaListContainer md-whiteframe-4dp roundCorners\" \nng-hide=\"(vm.isDrawingArea && !vm.isEditing) || !vm.currentArea.id\"><div class=\"containerTitle mediumTitle\"><span>\nCurrent geofencing areas</span><div class=\"editDeleteButtonsContainer\"><div \nclass=\"buttonContainer edit centersSingleElement\" ng-hide=\"!vm.isAreaDetail\"><md-button \nclass=\"editButton md-icon-button\" ng-click=\"vm.editAreaButtonAction()\" aria-label=\"editButtonAction\"><md-icon \nclass=\"centersSingleElement\" ng-class=\"vm.isEditing? \'icon-check\' : \'icon-pencil\' \"></md-icon></md-button></div><div \nclass=\"buttonContainer centersSingleElement\" ng-hide=\"!vm.isAreaDetail\"><md-button \nclass=\"editButton closeButton md-icon-button\" ng-click=\"vm.closeAreaButtonAction()\" aria-label=\"closeButtonAction\">\n<md-icon class=\"centersSingleElement\" ng-class=\"vm.isEditing? \'icon-close\' : \'icon-delete\'\"></md-icon></md-button>\n</div></div></div><div class=\"areaList\"><div class=\"areaRow\"><div class=\"areaCell areaCellId\"><div \nclass=\"areaCellElement areaCellTitle\">ID</div><div class=\"areaCellElement\">{{vm.currentArea.id}}</div></div><div \nclass=\"areaCell\" ng-class=\"{\'areaCelWithInput\':vm.isEditing}\"><div class=\"areaCellElement areaCellTitle\">Name</div><div\n class=\"areaCellElement\" ng-if=\"!vm.isEditing\">{{vm.currentArea.name}}</div><div class=\"areaCellElement\" \nng-if=\"vm.isEditing\"><md-input-container md-no-float><input ng-model=\"vm.currentArea.name\" type=\"text\" \naria-label=\"areaName\"></md-input-container></div></div><div class=\"areaCell areaCelWithInput\"><div \nclass=\"areaCellElement areaCellTitle\">Site</div><div class=\"areaCellElement\">\n{{ vm.getSiteName(vm.currentArea.SiteId) }}</div></div><div class=\"areaCell\" \nng-class=\"{\'areaCelWithInput\':vm.isEditing}\"><div class=\"areaCellElement areaCellTitle\">Type</div><div \nclass=\"areaCellElement\" ng-if=\"!vm.isEditing\">{{vm.currentArea.vehicleType ? vm.currentArea.vehicleType : \'Default\'}}\n</div><div class=\"areaCellElement\" ng-if=\"vm.isEditing\"><md-input-container md-no-float><md-select \nng-model=\"vm.currentArea.vehicleType\" aria-label=\"vehicleType\"><md-option ng-value=\"null\">Default</md-option><md-option\n ng-value=\"option.value\" ng-repeat=\"option in vm.vehicleType\">{{option.name}}</md-option></md-select>\n</md-input-container></div></div><div class=\"areaCell areaCellDate\"><div class=\"areaCellElement areaCellTitle\">\nRegistration date</div><div class=\"areaCellElement\">\n{{ vm.toDateFilter(vm.currentArea.created_at, \'dateTime\', vm.currentArea.SiteId) }}</div></div><div class=\"areaCell\">\n<div class=\"areaCellElement areaCellTitle\">Latest review</div><div class=\"areaCellElement\">\n{{ vm.toDateFilter(vm.currentArea.updated_at, \'dateTime\', vm.currentArea.SiteId) }}</div></div><div \nclass=\"areaCell areaCellStatus\"><div class=\"areaCellElement areaCellTitle\">Status</div><div class=\"areaCellElement\">\n{{vm.currentArea.active? \'Active\' : \'Inactive\'}}</div></div><div class=\"areaCell areaCellButton\"><md-button \nclass=\"areaButton\" ng-click=\"vm.areaButtonAction()\" aria-label=\"activateButtonAction\">\n{{vm.isAreaDetail? vm.currentArea.active? \'Deactivate\' : \'Activate\' : \'View\'}}</md-button></div></div></div></div><div \nclass=\"areaListContainer md-whiteframe-4dp roundCorners\" \nng-hide=\"vm.isAreaDetail ||(vm.isDrawingArea && !vm.isEditing) || !vm.currentActiveAreas.length>0\"><div \nclass=\"containerTitle mediumTitle\"><span>Current geofencing active areas</span></div><div class=\"areaList\"><div \nclass=\"areaRow\" ng-repeat=\"area in vm.currentActiveAreas\"><div class=\"areaCell areaCellId\"><div \nclass=\"areaCellElement areaCellTitle\">ID</div><div class=\"areaCellElement\">{{area.id}}</div></div><div \nclass=\"areaCell\"><div class=\"areaCellElement areaCellTitle\">Name</div><div class=\"areaCellElement\">{{area.name}}</div>\n</div><div class=\"areaCell\"><div class=\"areaCellElement areaCellTitle\">Site</div><div class=\"areaCellElement\">\n{{ vm.getSiteName(area.SiteId) }}</div></div><div class=\"areaCell\"><div class=\"areaCellElement areaCellTitle\">Type\n</div><div class=\"areaCellElement\">{{area.vehicleType ? area.vehicleType : \'Default\'}}</div></div><div \nclass=\"areaCell\"><div class=\"areaCellElement areaCellTitle\">Registration date</div><div class=\"areaCellElement\">\n{{ vm.toDateFilter(area.created_at, \'dateTime\', area.SiteId) }}</div></div><div class=\"areaCell\"><div \nclass=\"areaCellElement areaCellTitle\">Latest review</div><div class=\"areaCellElement\">\n{{ vm.toDateFilter(area.updated_at, \'dateTime\', area.SiteId) }}</div></div><div class=\"areaCell areaCellStatus\"><div \nclass=\"areaCellElement areaCellTitle\">Status</div><div class=\"areaCellElement\">{{area.active? \'Active\' : \'Inactive\'}}\n</div></div><div class=\"areaCell areaCellButton\"><md-button class=\"areaButton\" ng-click=\"vm.areaButtonAction(area)\" \naria-label=\"activateButtonAction\" style=\"width:10%;margin:0\">View</md-button></div></div></div></div><div \nclass=\"areaListContainer md-whiteframe-4dp roundCorners\" ng-hide=\"vm.isDrawingArea || vm.isAreaDetail\"><div \nclass=\"containerTitle mediumTitle\">Saved geofencing areas</div><div class=\"areaList\"><div class=\"areaRow\" \nng-repeat=\"area in vm.areas\"><div class=\"areaCell areaCellId\"><div class=\"areaCellElement areaCellTitle\">ID</div><div \nclass=\"areaCellElement\">{{area.id}}</div></div><div class=\"areaCell\"><div class=\"areaCellElement areaCellTitle\">Name\n</div><div class=\"areaCellElement\">{{area.name}}</div></div><div class=\"areaCell\"><div \nclass=\"areaCellElement areaCellTitle\">Site</div><div class=\"areaCellElement\">{{ vm.getSiteName(area.SiteId) }}</div>\n</div><div class=\"areaCell\"><div class=\"areaCellElement areaCellTitle\">Type</div><div class=\"areaCellElement\">\n{{area.vehicleType ? area.vehicleType : \'Default\'}}</div></div><div class=\"areaCell\"><div \nclass=\"areaCellElement areaCellTitle\">Registration date</div><div class=\"areaCellElement\">\n{{ vm.toDateFilter(area.created_at, \'dateTime\', area.SiteId) }}</div></div><div class=\"areaCell\"><div \nclass=\"areaCellElement areaCellTitle\">Latest review</div><div class=\"areaCellElement\">\n{{ vm.toDateFilter(area.updated_at, \'dateTime\', area.SiteId) }}</div></div><div class=\"areaCell areaCellStatus\"><div \nclass=\"areaCellElement areaCellTitle\">Status</div><div class=\"areaCellElement\">{{area.active? \'Active\' : \'Inactive\'}}\n</div></div><div class=\"areaCell areaCellButton\"><md-button class=\"areaButton\" ng-click=\"vm.areaButtonAction(area)\" \naria-label=\"viewGeofenceButton\">View</md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/settings/permissions/permissions.html","<div id=\"permissions\"><div class=\"title\"><span>Permissions</span><div class=\"buttonContainer centersSingleElement\">\n<md-button id=\"newRoleButton\" class=\"md-icon-button newDamageButton md-whiteframe-2dp\" \nng-click=\"vm.addRoleButtonAction($event)\" aria-label=\"addRoleButtonAction\"><md-icon \nclass=\"icon-plus centersSingleElement\"></md-icon><md-tooltip>Add role</md-tooltip></md-button></div></div><div \nclass=\"paddingContainer\"><div class=\"containerCard roundCorners md-whiteframe-4dp\"><div class=\"fixedTableHeader\"><div \nclass=\"spacerForName\"></div><div class=\"permissionCell centersSingleElement\" ng-hide=\"!vm.isAddingRole\"><input \nclass=\"transparentInput\" ng-model=\"vm.roles[0].name\"><md-button class=\"closeButton md-icon-button\" \nng-click=\"vm.addRole()\" aria-label=\"addRoleButtonAction\"><md-icon class=\"icon-check centersSingleElement\"></md-icon>\n</md-button></div><div class=\"permissionCell centersSingleElement\" \nng-repeat=\"role in vm.roles | filter: vm.getNonHiddenElements\"><a class=\"roleLink\" \nui-sref=\"app.settings.permission.role-details({id: role.id})\" ng-hide=\"role.isBeingModified\">{{role.name}}<md-tooltip>\nGo to Role Details Page</md-tooltip></a><input ng-hide=\"!role.isBeingModified\" class=\"transparentInput\" \nng-model=\"role.name\"><md-button class=\"editButton md-icon-button\" ng-click=\"vm.modifyButtonAction(role)\" \naria-label=\"modifyButtonAction\"><md-icon class=\"centersSingleElement\" \nng-class=\"role.isBeingModified? \'icon-check\' : \'icon-pencil\' \"></md-icon></md-button><md-button \nclass=\"closeButton md-icon-button\" ng-click=\"vm.deleteButtonAction(role,ev)\" aria-label=\"deleteButtonAction\" \nng-hide=\"role.name === \'Super Admin\' && !role.isBeingModified\"><md-icon class=\"centersSingleElement\" \nng-class=\"role.isBeingModified? \'icon-close\' : \'icon-delete\' \"></md-icon></md-button></div></div><div \nclass=\"permissionsList\"><div class=\"permissionsRow\" ng-repeat=\"permissionsGroup in vm.permissionsGroups\"><details \nstyle=\"width: 100%\"><summary style=\"display:flex!important\"><div class=\"permissionsRow\"><div class=\"spacerForName\">\n{{permissionsGroup.name}}</div><div class=\"permissionCell permissionsRecap centersSingleElement\" \nng-repeat=\"role in vm.roles\"><div \nng-class=\"{\'roleHasPermission\': permissionsGroup[role.id].allGranted,\'roleHasNotPermission\': permissionsGroup[role.id].noneGranted}\">\n{{permissionsGroup[role.id].allGranted ? \'All granted\' : (permissionsGroup[role.id].noneGranted ? \'None granted\' : \'(\'+permissionsGroup[role.id].nOfGranted +\'/\'+ permissionsGroup[role.id].nOfPermissions+\') granted\')}}\n</div></div></div></summary><div class=\"permissionsRow\" ng-repeat=\"permissionObj in permissionsGroup.permissions\"><div \nclass=\"spacerForName\">{{permissionObj.description}}</div><div class=\"permissionCell centersSingleElement\" \nng-repeat=\"role in vm.roles\"><md-switch ng-model=\"role[permissionObj.permission]\" \nng-click=\"vm.permissionButtonAction(role, permissionObj.permission,permissionsGroup)\" \naria-label=\"enableDisablePermission\"></md-switch></div></div></details></div></div></div></div></div>");
$templateCache.put("app/main/settings/translations/translations.html","<div id=\"translations\"><div class=\"mainTitlePaddingLevel roundCorners md-whiteframe-4dp\"><div class=\"mainTitle\">\nMobile App Translations</div><div class=\"mainContentLevel\"><div class=\"mainTitle sectionTitle\">Add a translation</div>\n<div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">Site:</div>\n<md-select class=\"inputField md-no-underline\" ng-model=\"vm.newTranslation.siteId\" aria-label=\"site\" \nng-disabled=\"!vm.isDefaultSiteSelected\"><md-option ng-value=\"site.id\" ng-repeat=\"site in vm.sites\">{{site.name}}\n</md-option></md-select></div><div class=\"contentRow\"><div class=\"fieldTitle\">Language:</div><md-select \nclass=\"inputField md-no-underline\" ng-model=\"vm.newTranslation.lang\" aria-label=\"language\"><md-option \nng-value=\"option.value\" ng-repeat=\"option in vm.availableLanguages\">{{option.name}}</md-option></md-select></div><div \nclass=\"contentRow\"><div class=\"fieldTitle\">Key:</div><input class=\"inputField\" type=\"text\" \nng-model=\"vm.newTranslation.key\" style=\"text-transform:uppercase\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Value:</div><input class=\"inputField\" type=\"text\" ng-model=\"vm.newTranslation.value\"></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent roundedButton\" md-no-ink \nng-click=\"vm.addATranslation()\" aria-label=\"addTranslation\">Save</md-button></div></div></div><div \nclass=\"mainTitle sectionTitle\" layout=\"row\" layout-align=\"space-between center\" style=\"margin-top:0px\"><div>\nEdit a translation</div><div layout=\"row\"><md-button class=\"md-fab md-button-icon\" ng-show=\"vm.isEditing\" \nng-click=\"vm.callModifyTranslations()\" aria-label=\"applyChanges\"><md-icon md-font-icon=\"icon-check\"></md-icon>\n</md-button><md-button class=\"md-fab md-button-icon\" ng-click=\"vm.toggleEditing(translation)\" \naria-label=\"toggleEditing\"><md-icon md-font-icon=\"{{!vm.isEditing ? \'icon-pencil\' : \'icon-close\'}}\"></md-icon>\n</md-button></div></div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Site:</div><md-select class=\"inputField md-no-underline\" ng-model=\"vm.filter.siteId\" \naria-label=\"site\" ng-disabled=\"!vm.isDefaultSiteSelected\"><md-option ng-value=\"site.id\" ng-repeat=\"site in vm.sites\">\n{{site.name}}</md-option></md-select></div><div class=\"contentRow\"><div class=\"fieldTitle\">Language:</div><md-select \nclass=\"inputField md-no-underline\" ng-model=\"vm.filter.lang\" aria-label=\"language\"><md-option ng-value=\"\'all\'\" \nng-click=\"vm.languageFilter()\">All</md-option><md-option ng-value=\"langObj.value\" \nng-repeat=\"langObj in vm.availableLanguages\" ng-click=\"vm.languageFilter(langObj.value)\">{{langObj.name}}</md-option>\n</md-select></div><div class=\"contentRow\"><div class=\"fieldTitle\">Search:</div><input class=\"inputField\" type=\"text\" \nng-model=\"vm.filter.query\" ng-model-options=\"{ debounce: 700 }\"></div></div></div><div><div \nng-show=\"vm.isAFilterSelected && vm.filter.siteId == vm.DefaultSite.id\"><div class=\"mainTitle sectionTitle\"><b>Default\n</b> Translations</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div \nng-repeat=\"(languageKey,translations) in vm.translations.base\" ng-hide=\"vm.availableLanguages[languageKey].isHidden\">\n<div class=\"mainTitle sectionTitle\">\n{{vm.availableLanguages[languageKey].name}} ({{(translations | filter: vm.searchFilter).length}})</div><div \nclass=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\" \nng-repeat=\"translation in translations | filter: vm.searchFilter\"><div ng-show=\"!vm.isEditing\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"fieldTitle\">{{translation.key}}</div><div class=\"inputField\" \nstyle=\"padding-top: 5px\">{{translation.value}}</div></div><div ng-show=\"vm.isEditing\" layout=\"row\" \nlayout-align=\"center center\" flex><input class=\"fieldTitle borderBottom\" type=\"text\" ng-model=\"translation.key\" \nstyle=\"text-transform:uppercase\"> <input class=\"inputField\" type=\"text\" ng-model=\"translation.value\"></div></div></div>\n</div></div></div></div></div><div ng-repeat=\"site in vm.sites | filter:{id:\'!\'+vm.DefaultSite.id}\" \nng-show=\"vm.isAFilterSelected && (vm.filter.siteId == vm.DefaultSite.id || vm.filter.siteId == site.id)\"><div \nclass=\"mainTitle sectionTitle\"><b>{{vm.getSiteName(site.id)}}</b> Translations</div><div class=\"subSectionLevel\"><div \nclass=\"contentContainer\"><div ng-repeat=\"(languageKey,translations) in vm.translations.specific[site.id]\" \nng-hide=\"vm.availableLanguages[languageKey].isHidden\"><div class=\"mainTitle sectionTitle\">\n{{vm.availableLanguages[languageKey].name}} ({{(translations | filter: vm.searchFilter).length}})</div><div \nclass=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\" \nng-repeat=\"translation in translations | filter: vm.searchFilter\"><div ng-show=\"!vm.isEditing\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"fieldTitle\">{{translation.key}}</div><div class=\"inputField\" \nstyle=\"padding-top: 5px\">{{translation.value}}</div></div><div ng-show=\"vm.isEditing\" layout=\"row\" \nlayout-align=\"center center\" flex><input class=\"fieldTitle borderBottom\" type=\"text\" ng-model=\"translation.key\" \nstyle=\"text-transform:uppercase\"> <input class=\"inputField\" type=\"text\" ng-model=\"translation.value\"></div></div></div>\n</div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/trip/details/trip-details.html","<div id=\"trip-details\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-fab md-icon-button\" ng-click=\"vm.goToTrips()\" \naria-label=\"Go Back\" translate-attr-aria-label=\"VEHICLE.GO_BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n<md-tooltip><span translate=\"VEHICLE.GO_BACK\">Go Back</span></md-tooltip></md-button><div layout=\"row\"><md-button \nclass=\"md-fab md-icon-button\" ng-click=\"vm.refreshTrip()\" aria-label=\"Reload\" \ntranslate-attr-aria-label=\"VEHICLE.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"VEHICLE.RELOAD\">Reload</span></md-tooltip></md-button></div></div></div><div class=\"content\"><div flex \nclass=\"row-container\" layout=\"column\" layout-gt-sm=\"row\"><div flex layout=\"column\" layout-gt-xs=\"row\"><div flex \nclass=\"trip-details-widget widget-small md-whiteframe-4dp roundCornersSmaller\" layout=\"column\"><div class=\"h3\"><p>\nUsed By</p></div><md-divider></md-divider><div flex class=\"trip-details-widget-item\" layout=\"column\" \nlayout-align=\"center center\"><md-icon class=\"account-icon\" md-font-icon=\"icon-account\"></md-icon><div layout=\"row\" \nlayout-align=\"center center\"><p><span>User:</span> <a class=\"userLink\" \nui-sref=\"app.user.details({userId: vm.trip.User.id})\">{{vm.trip.User.fullName}}</a></p></div></div></div><div flex \nclass=\"trip-details-widget widget-small md-whiteframe-4dp roundCornersSmaller\" layout=\"column\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"space-between center\"><p><a class=\"userLink\" \nui-sref=\"app.vehicle.details({vehicleId: vm.trip.Vehicle.id})\">{{vm.trip.Vehicle.reference_code}}</a>\n | {{vm.trip.Vehicle.id}} | {{vm.trip.Vehicle.license_plate}} | {{vm.trip.Vehicle.deviceTypeHuman}}</p></div>\n<md-divider></md-divider><div flex class=\"trip-details-widget-item\" layout=\"row\" layout-align=\"center center\"><img \nng-src=\"{{vm.trip.Vehicle.Image[0].location}}\" style=\"object-fit:contain\"></div></div></div><div flex><div flex \nclass=\"trip-details-widget widget-small md-whiteframe-4dp roundCornersSmaller\" layout=\"column\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"space-between center\"><p>Trip Overview</p><p ng-if=\"vm.showTripImage\">End Trip Images\n<md-icon style=\"margin: 0px 4px\" md-font-icon=\"icon-open-in-new\" ng-click=\"vm.showTripEndImagesDialog($event)\">\n</md-icon></p></div><md-divider></md-divider><div flex class=\"trip-overview-container\" layout=\"column\" \nlayout-gt-xs=\"row\"><div flex-gt-xs=\"60\" class=\"trip-details-widget-item\" layout=\"column\" layout-align=\"start center\">\n<div class=\"trip-overview-info\"><div class=\"trip-overview-info-title\">Start Info:</div><md-divider></md-divider><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" flex layout-align=\"center start\"><div \nlayout=\"row\"><md-icon md-font-icon=\"icon-calendar-clock\" style=\"margin-right: 4px\"></md-icon><p>\n{{vm.trip.start | toDate:\'dateTime\':vm.trip.SiteId}}</p></div></div><div layout=\"column\" flex=\"30\" flex-gt-sm=\"25\" \nlayout-align=\"center center\"><div layout=\"row\"><md-icon md-font-icon=\"icon-road\"></md-icon><p>\n{{vm.trip.StartPosition.km}} Km</p></div></div><div layout=\"column\" flex=\"30\" flex-gt-sm=\"25\" \nlayout-align=\"center center\"><div layout=\"row\"><md-icon md-font-icon=\"icon-gas-station\"></md-icon><p>\n{{vm.trip.StartPosition.total_percentage | number:0}} %</p></div></div></div></div><div class=\"trip-overview-info\" \nng-repeat=\"vehicleParked in vm.parkedStatuses\"><div class=\"trip-overview-info-title\">Parked Info:</div><md-divider>\n</md-divider><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" flex \nlayout-align=\"center start\"><div layout=\"row\"><md-icon md-font-icon=\"icon-calendar-clock\" style=\"margin-right: 4px\">\n</md-icon><p>{{vehicleParked.updated_at |toDate:\"dateTime\":vm.trip.SiteId}}</p></div></div><div layout=\"column\" \nflex=\"30\" flex-gt-sm=\"25\" layout-align=\"center center\"><div layout=\"row\"><md-icon md-font-icon=\"icon-road\"></md-icon>\n<p>{{vehicleParked.km}} Km</p></div></div><div layout=\"column\" flex=\"30\" flex-gt-sm=\"25\" layout-align=\"center center\">\n<div layout=\"row\"><md-icon md-font-icon=\"icon-gas-station\"></md-icon><p>{{vehicleParked.total_percentage | number:0}} %\n</p></div></div></div></div><div class=\"trip-overview-info\" ng-show=\"vm.trip.FinishPosition\"><div \nclass=\"trip-overview-info-title\">End Info:</div><md-divider></md-divider><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex layout-align=\"center start\"><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-calendar-clock\" style=\"margin-right: 4px\"></md-icon><p>\n{{vm.trip.end|toDate:\"dateTime\":vm.trip.SiteId}}</p></div></div><div layout=\"column\" flex=\"30\" flex-gt-sm=\"25\" \nlayout-align=\"center center\" layout-align=\"center center\"><div layout=\"row\"><md-icon md-font-icon=\"icon-road\">\n</md-icon><p>{{vm.trip.FinishPosition.km}} Km</p></div></div><div layout=\"column\" flex=\"30\" flex-gt-sm=\"25\" \nlayout-align=\"center center\" layout-align=\"center center\"><div layout=\"row\"><md-icon md-font-icon=\"icon-gas-station\">\n</md-icon><p>{{vm.trip.FinishPosition.total_percentage | number:0}} %</p></div></div></div></div></div><div flex-gt-xs \nclass=\"trip-details-widget-item border-left\" layout=\"column\" layout-align=\"center center\"><p class=\"main-label\" \nng-style=\"{color:vm.toHireDefaultColor.blue}\">{{ vm.getCurrencyValue(vm.trip.Booking.price, vm.trip.SiteId) }}</p><div \nclass=\"detailedPriceContainer\"><div class=\"detailedPriceRow plusPrice\"><div>Running:</div><div class=\"right\">\n{{vm.getCurrencyValue(vm.trip.Booking.detailedPrice.running, vm.trip.SiteId)}}</div></div><div \nclass=\"detailedPriceRow plusPrice\"><div>Parked:</div><div class=\"right\">\n{{vm.getCurrencyValue(vm.trip.Booking.detailedPrice.parked, vm.trip.SiteId)}}</div></div><div \nclass=\"detailedPriceRow minusPrice\"><div>Free:</div><div class=\"right\">\n{{vm.getCurrencyValue(vm.trip.Booking.detailedPrice.free, vm.trip.SiteId)}}</div></div><div \nclass=\"detailedPriceRow minusPrice\"><div>Prepaid:</div><div class=\"right\">\n{{vm.getCurrencyValue(vm.trip.Booking.detailedPrice.prepaid, vm.trip.SiteId)}}</div></div><div \nclass=\"detailedPriceRow additionalPrice\"><div>Outside geofence:</div><div class=\"right\">\n{{vm.getCurrencyValue(vm.trip.Booking.detailedPrice.outOfGeoFence, vm.trip.SiteId)}}</div></div><div \nclass=\"detailedPriceRow additionalPrice\"><div>VAT:</div><div class=\"right\">\n{{vm.getCurrencyValue(vm.trip.Booking.detailedPrice.vat, vm.trip.SiteId)}}</div></div></div></div></div></div></div>\n</div><div class=\"row-container\" layout=\"column\" layout-gt-xs=\"row\"><div flex \nclass=\"trip-details-widget md-whiteframe-4dp roundCornersSmaller\" layout=\"column\"><div class=\"h3\"><p>Trip Details</p>\n</div><md-divider></md-divider><div flex class=\"trip-details-widget-item\" layout=\"column\" style=\"overflow-y: scroll\">\n<div class=\"trip-list-item border-bottom p-16\"><label>ID:</label><p>{{vm.trip.id}}</p></div><div \nclass=\"trip-list-item border-bottom p-16\"><label>Trip status:</label><p>{{vm.getTripStatusDescription(vm.trip)}}</p>\n</div><div class=\"trip-list-item border-bottom p-16\"><label>Start Lat/Long:</label><p>\n{{vm.trip.StartPosition.latitude}} / {{vm.trip.StartPosition.longitude}}</p></div><div \nclass=\"trip-list-item border-bottom p-16\"><label>End Lat/Long:</label><p>\n{{vm.trip.FinishPosition.latitude}} / {{vm.trip.FinishPosition.longitude}}</p></div><div \nclass=\"trip-list-item border-bottom p-16\"><label>Start Position:</label><p>\n{{vm.trip.StartPosition.address || \'No address found\'}}</p></div><div class=\"trip-list-item border-bottom p-16\"><label>\nEnd Position:</label><p>{{vm.trip.FinishPosition.address}}</p></div><div class=\"trip-list-item border-bottom p-16\">\n<label>Distance Covered:</label><p>{{vm.trip.totalKm}} Km</p></div><div class=\"trip-list-item border-bottom p-16\">\n<label>Duration:</label><p>{{vm.trip.FinishPosition ? vm.trip.duration + \' min\' : \'Not Finished\'}}</p></div></div>\n</div><div flex class=\"trip-details-widget md-whiteframe-4dp roundCornersSmaller\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\"><p>Map Overview</p></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-show=\"vm.savedTripPaths.matched.length>0\"><span style=\"margin: 8px\">Original\n</span><md-switch ng-click=\"vm.toggleOriginalOrMatchedTripPath()\" ng-model=\"vm.isMatchedTripShown\" \naria-label=\"ToggleOriginalOrMatchedTrip\"></md-switch><span style=\"margin: 4px\">Matched</span></div></div><md-divider>\n</md-divider><div flex class=\"trip-details-widget-item\" layout=\"column\"><two-hire-vehicle-map \nclass=\"trip-details-widget-item-map\" style=\"height:100%\" on-map-init=\"vm.onMapInit\" \nshown-geofence-vehicle-types=\"[vm.trip.Vehicle.type]\" on-refresh=\"vm.onRefreshMap\"></two-hire-vehicle-map></div></div>\n</div><div class=\"row-container\" layout=\"column\"><div \nclass=\"trip-details-widget trip-logs-widget md-whiteframe-4dp roundCornersSmaller\" layout=\"column\"><div class=\"h3\" \nlayout=\"row\" layout-align=\"space-between center\"><p>Trip Logs</p></div><md-divider></md-divider><paginated-table \nheaders=\"vm.tripLogsTableFields\" data=\"vm.tripLogs\" update-data=\"vm.getTripLogs\" \napply-update-data=\"vm.applyUpdateData\" call-update-data-on-init=\"false\" class=\"tripLogsTable\"></paginated-table></div>\n</div></div></div></div>");
$templateCache.put("app/main/trip/tripList/trip-list-view.html","<div id=\"trip-list-view\" class=\"page-layout simple inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\" flex-xs=\"25\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-map-marker-multiple\"></md-icon><span>Trips</span></div></div><div \nclass=\"buttonsContainerTopPage\"><md-button class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.goToTripsListMapView()\"><md-icon md-font-icon=\"icon-google-maps\"></md-icon><md-tooltip><span>\nGo to map view</span></md-tooltip></md-button></div></div></div><generic-table headers=\"vm.tableFields\" \ndata=\"vm.trips\" search-filters=\"vm.searchFilters\" filters=\"vm.filters\" update-data=\"vm.refreshTrips\" \napply-filters-trigger=\"vm.applyFiltersTrigger\" enable-auto-refresh=\"true\" page-id=\"trip-list\"></generic-table></div>");
$templateCache.put("app/main/user/details/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed hideable\" \nng-class=\"{resizeForFullScreen: (vm.referredUsersListFullScreen || vm.couponsHistoryListFullScreen || vm.userRelatedDataFullScreen)}\">\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-fab md-icon-button\" ng-click=\"vm.goToUserList()\" \naria-label=\"Go Back\" translate-attr-aria-label=\"VEHICLE.GO_BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n<md-tooltip><span translate=\"VEHICLE.GO_BACK\">Go Back</span></md-tooltip></md-button><div layout=\"row\"><md-button \nclass=\"md-fab md-icon-button\" ng-if=\"vm.enableDeleteUser\" ng-click=\"vm.callDeleteUserConfirmDialog($event)\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Delete</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-icon-button\" ng-if=\"vm.enableDeactivateUser\" \nng-click=\"vm.callDeactivateUserConfirmDialog($event)\" aria-label=\"Deactivate\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span>Deactivate</span></md-tooltip></md-button><md-button class=\"md-fab md-icon-button\" \nng-click=\"vm.refresh()\" aria-label=\"Reload\" translate-attr-aria-label=\"VEHICLE.RELOAD\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon></md-button></div></div></div><div class=\"content\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"rowContainer\"><div class=\"leftContainer\" flex-gt-sm=\"20\" flex><div \nclass=\"userTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{isHidden: (vm.referredUsersListFullScreen || vm.couponsHistoryListFullScreen)}\"><div \nclass=\"tileTitle fixed centersSingleElement\">{{vm.user.fullName}}</div><div class=\"tileContent\"><div \nclass=\"uploadButtonContainer\"><label for=\"selfie_image_upload\">Upload</label><input type=\"file\" \nid=\"selfie_image_upload\" name=\"selfie_image_upload\" accept=\".jpg, .jpeg, .png\"></div><md-icon \nng-if=\"!vm.user.Avatar[0]\" class=\"icon-account userIcon centersSingleElement\"></md-icon><img ng-if=\"vm.user.Avatar[0]\" \nclass=\"userImage\" ng-src=\"{{vm.user.Avatar[0].location}}\" ng-click=\"vm.showBiggerImage(vm.user.Avatar[0].location)\">\n</div></div><div class=\"statisticsTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{isHidden: (vm.referredUsersListFullScreen || vm.couponsHistoryListFullScreen)}\"><div \nclass=\"tileTitle fixed centersSingleElement\">Statistics</div><div class=\"tileContent\"><div \nclass=\"statisticRow centersSingleElement border-bottom\"><div><span>Customer ID: </span><span class=\"title\">\n{{vm.user.id}}</span></div></div><div class=\"statisticRow centersSingleElement border-bottom\"><div><span>Total trips: \n</span><span class=\"title\">{{vm.totalTrips}}</span></div></div><div \nclass=\"statisticRow centersSingleElement border-bottom\"><div><span>Canceled trips: </span><span class=\"title\">\n{{vm.canceledTrips}}</span></div></div><div class=\"statisticRow centersSingleElement border-bottom\"><div><span>\nPaused trips: </span><span class=\"title\">{{vm.pausedTrips}}</span></div></div><div \nclass=\"statisticRow centersSingleElement border-bottom\"><div><span>Canceled bookings: </span><span class=\"title\">\n{{vm.canceledBookings}}</span></div></div><div class=\"statisticRow centersSingleElement border-bottom\"><div><span>\nExpired bookings: </span><span class=\"title\">{{vm.expiredBookings}}</span></div></div><div \nclass=\"statisticRow centersSingleElement border-bottom\"><div><span>Total spent: </span><span class=\"title\">\n{{vm.isDefaultSiteSelected ? \'N/A\' :vm.getCurrencyValue(vm.totalSpent, vm.selectedSiteId)}}</span><span \nclass=\"tooltipBtn\"><md-tooltip>\n{{vm.isDefaultSiteSelected ? \'Information Not Available when viewing All Sites\' : \'Only the latest \' + vm.displayedTransactions + \' transactions are considered, click \\\'Show more\\\' then \\\'Load more\\\'\'}}\n</md-tooltip><md-icon md-font-icon=\"icon-alert-circle\" class=\"mh-5\"></md-icon></span></div></div><div \nclass=\"statisticRow centersSingleElement border-bottom\"><div><span>Total unpaid: </span><span class=\"title\">\n{{vm.isDefaultSiteSelected ? \'N/A\' :vm.getCurrencyValue(vm.totalUnpaid, vm.selectedSiteId)}}</span><span \nclass=\"tooltipBtn\"><md-tooltip>\n{{vm.isDefaultSiteSelected ? \'Information Not Available when viewing All Sites\' : \'Only the latest \' + vm.displayedTransactions + \' transactions are considered, click \\\'Show more\\\' then \\\'Load more\\\'\'}}\n</md-tooltip><md-icon md-font-icon=\"icon-alert-circle\" class=\"mh-5\"></md-icon></span></div></div><div \nclass=\"statisticRow centersSingleElement border-bottom\"><div><span>Total refunded: </span><span class=\"title\">\n{{vm.isDefaultSiteSelected ? \'N/A\' :vm.getCurrencyValue(vm.totalRefunded, vm.selectedSiteId)}}</span><span \nclass=\"tooltipBtn\"><md-tooltip>\n{{vm.isDefaultSiteSelected ? \'Information Not Available when viewing All Sites\' : \'Only the latest \' + vm.displayedTransactions + \' transactions are considered, click \\\'Show more\\\' then \\\'Load more\\\'\'}}\n</md-tooltip><md-icon md-font-icon=\"icon-alert-circle\" class=\"mh-5\"></md-icon></span></div></div><div \nclass=\"statisticRow statisticRowWithButton border-bottom\"><div class=\"centersSingleElement\"><div><span>Free credit:\n</span><span class=\"title\">{{vm.getUserFreeCredit(vm.user) | toCurrency: vm.user.SiteId}}</span></div></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.showChangeUserFreeMinutesDialog($event)\" ng-if=\"vm.enableChangeFreeMillis\"><md-icon\n class=\"mh-5\" md-font-icon=\"icon-pencil\"><md-tooltip>Edit user free credit</md-tooltip></md-icon></md-button></div><div\n class=\"statisticRow centersSingleElement border-bottom\"><div><span>Prepaid minutes: </span><span class=\"title\">\n{{vm.user.prepaidMinutes |number:0}}</span></div></div><div class=\"statisticRow centersSingleElement border-bottom\">\n<div><span>Referred users : </span><span class=\"title\">{{vm.referredUsers.length}}</span></div></div></div></div><div \nclass=\"resetUserPasswordTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{isHidden: (vm.referredUsersListFullScreen || vm.couponsHistoryListFullScreen)}\"><div \nclass=\"tileTitle fixed centersSingleElement\">Reset password</div><div class=\"tileContent\"><md-button \nclass=\"resetButton md-raised\" ng-click=\"vm.openResetUserPasswordConfirmDialog()\">Reset Password</md-button></div></div>\n<div class=\"blockUserTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{isHidden: (vm.referredUsersListFullScreen || vm.couponsHistoryListFullScreen)}\"><div \nclass=\"tileTitle fixed centersSingleElement\">Block user</div><div class=\"tileContent\"><textarea \nclass=\"descriptionArea\" placeholder=\"Reason and (DD/MM/YYYY)\" ng-disabled=\"vm.user.block\" \nng-model=\"vm.user.block_reason\"></textarea><md-button class=\"blockButton md-raised\" ng-click=\"vm.blockUnblockAction()\" \nng-class=\"vm.user.block? \'activated\' : \'\' \">{{vm.user.block? \'Unblock user\' : \'Block user\'}}</md-button></div></div>\n</div><div class=\"rightContainer\" flex-gt-sm=\"80\" flex><div class=\"topContainer hideable\" layout=\"column\" \nlayout-gt-sm=\"row\" ng-class=\"{streched: vm.userDetailsFullScreen}\"><div \nclass=\"personalInfoTile md-whiteframe-4dp roundCornersSmaller hideable\" flex \nng-class=\"{streched: vm.userDetailsFullScreen, isHidden: (vm.userRelatedDataFullScreen || vm.couponsHistoryListFullScreen || vm.referredUsersListFullScreen)}\">\n<div class=\"tileTitleContainer\"><div class=\"tileTitle fixed centersSingleElement\">Personal info</div><div layout=\"row\">\n<md-button class=\"md-icon-button\" ng-show=\"!vm.disableEditUserDetails\" ng-click=\"vm.callUpdateUser()\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-check\"><md-tooltip><span>Confirm</span></md-tooltip></md-icon>\n</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.disableEditUserDetails ? vm.enableUserDetailsChange() : vm.disableUserDetailsChange()\" aria-label=\"Edit\">\n<md-icon md-font-icon=\"{{vm.disableEditUserDetails ? \'icon-pencil\' : \'icon-close\'}}\"><md-tooltip><span>\n{{vm.disableEditUserDetails ? \'Edit\' : \'Cancel\'}}</span></md-tooltip></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.exporPersonalInfoAsCSV()\"><md-icon md-font-icon=\"icon-download\"><md-tooltip><span>\nExport As CSV</span></md-tooltip></md-icon></md-button></div></div><div class=\"personalInfoContent\" layout=\"column\" \nlayout-gt-sm=\"row\"><div class=\"infoCell\"><div class=\"infoRow\"><div class=\"title centersSingleElement\">Custumer ID:\n</div><div class=\"info centersSingleElement disabledColor\">{{vm.user.id}}</div></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">Registration date:</div><div class=\"info centersSingleElement disabledColor\">\n{{vm.user.registrationDate}}</div></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">First name:</div>\n<input class=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" \nng-model=\"vm.user.name\" type=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">Sex:</div><div class=\"info centersSingleElement\"><md-select class=\"selectionInfo\" \nng-model=\"vm.user.sex\" ng-disabled=\"vm.disableEditUserDetails\" aria-label=\"userSex\"><md-option ng-value=\"type.value\" \nng-repeat=\"type in vm.userSexType\">{{type.name}}</md-option></md-select></div></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">Blocked:</div><div class=\"info centersSingleElement disabledColor\">\n{{vm.user.block? \'Yes\' : \'No\'}}</div></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">Country:</div>\n<input class=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" \nng-model=\"vm.user.residence_country\" type=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\">\n<div class=\"title centersSingleElement\">City:</div><input class=\"info centersSingleElement\" \nng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.residence_city\" type=\"text\" \nng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">Zip code:\n</div><input class=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" \nng-model=\"vm.user.cap\" type=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">Birth Country:</div><input class=\"info centersSingleElement\" \nng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.birth_country\" type=\"text\" \nng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\" ng-hide=\"vm.disableEditUserDetails\"><div \nclass=\"title centersSingleElement\">Birth State:</div><input class=\"info centersSingleElement\" \nng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.birth_state\" type=\"text\" \nng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">ID release:\n</div><md-datepicker class=\"info dateInfo\" ng-model=\"vm.user.identity_release\" md-max-date=\"vm.todayDate\" \nmd-current-view=\"year\" ng-disabled=\"vm.disableEditUserDetails\"></md-datepicker></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">ID expiration:</div><md-datepicker class=\"info dateInfo\" \nng-model=\"vm.user.identity_expiration\" md-min-date=\"vm.todayDate\" md-current-view=\"year\" \nng-disabled=\"vm.disableEditUserDetails\"></md-datepicker></div><div ng-hide=\"vm.disableEditUserDetails\"><div \nclass=\"infoRow\"><div class=\"title centersSingleElement\">ID Type:</div><div class=\"info centersSingleElement\"><md-select\n class=\"selectionInfo\" ng-model=\"vm.user.identity_type\" ng-disabled=\"vm.disableEditUserDetails\" \naria-label=\"userIdentityType\"><md-option ng-value=\"type.value\" ng-repeat=\"type in vm.documentTypes\">{{type.name}}\n</md-option></md-select></div></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">ID # :</div><input \nclass=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" \nng-model=\"vm.user.identity_id\" type=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">ID issue state:</div><input class=\"info centersSingleElement\" \nng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.identity_issue_state\" type=\"text\" \nng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">\nID issue city:</div><input class=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" \nng-model=\"vm.user.identity_issue_city\" type=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\">\n<div class=\"title centersSingleElement\">Cf:</div><input class=\"info centersSingleElement cfInfo\" \nng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.cf\" type=\"text\" \nng-disabled=\"vm.disableEditUserDetails\"></div></div></div><div class=\"infoCell\"><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">Status:</div><div class=\"info centersSingleElement disabledColor\">\n{{vm.user.statusHuman}}</div></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">Email:</div><input \nclass=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.email\" \ntype=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">\nLast name:</div><input class=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" \nng-model=\"vm.user.surname\" type=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">Client type:</div><div class=\"info centersSingleElement disabledColor\">\n{{vm.user.clientTypeHuman}}</div></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">Block reason:</div>\n<div class=\"info centersSingleElement disabledColor\">{{vm.user.block_reason ? vm.user.block_reason : \'Not blocked\'}}\n</div></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">State:</div><input \nclass=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" \nng-model=\"vm.user.residence_state\" type=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">Address:</div><input class=\"info centersSingleElement\" \nng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.residence\" type=\"text\" \nng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">Phone:</div>\n<input class=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.tel\" \ntype=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">\nBirth date:</div><md-datepicker class=\"info dateInfo\" ng-model=\"vm.user.birth\" md-max-date=\"vm.todayDate\" \nmd-current-view=\"year\" ng-disabled=\"vm.disableEditUserDetails\"></md-datepicker></div><div class=\"infoRow\" \nng-hide=\"vm.disableEditUserDetails\"><div class=\"title centersSingleElement\">Birth City:</div><input \nclass=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.birth_city\" \ntype=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">\nDL release:</div><md-datepicker class=\"info dateInfo\" ng-model=\"vm.user.license_release\" md-max-date=\"vm.todayDate\" \nmd-current-view=\"year\" ng-disabled=\"vm.disableEditUserDetails\"></md-datepicker></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">DL expiration:</div><md-datepicker class=\"info dateInfo\" \nng-model=\"vm.user.license_expiration\" md-min-date=\"vm.todayDate\" md-current-view=\"year\" \nng-disabled=\"vm.disableEditUserDetails\"></md-datepicker></div><div ng-hide=\"vm.disableEditUserDetails\"><div \nclass=\"infoRow\"><div class=\"title centersSingleElement\">DL ID:</div><input class=\"info centersSingleElement\" \nng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.license_id\" type=\"text\" \nng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">\nDL issue country:</div><input class=\"info centersSingleElement\" ng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" \nng-model=\"vm.user.license_country\" type=\"text\" ng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div \nclass=\"title centersSingleElement\">DL issue city:</div><input class=\"info centersSingleElement\" \nng-class=\"{\'modifyInput\': !vm.disableEditUserDetails}\" ng-model=\"vm.user.license_place\" type=\"text\" \nng-disabled=\"vm.disableEditUserDetails\"></div><div class=\"infoRow\"><div class=\"title centersSingleElement\">DL status:\n</div><div class=\"info centersSingleElement\">{{vm.user.licenseStatusHuman}}</div></div></div></div></div></div><div \nclass=\"documentSliderContainer md-whiteframe-4dp roundCornersSmaller hideable\" flex \nng-class=\"{streched: vm.userDetailsFullScreen, isHidden: (vm.userRelatedDataFullScreen || vm.couponsHistoryListFullScreen || vm.referredUsersListFullScreen)}\">\n<md-radio-group class=\"documentSliderSelector\" ng-model=\"vm.documentSlider.index\"><md-radio-button \nng-value=\"vm.documentSliderPage.LICENSE\" class=\"md-primary\">License</md-radio-button><md-radio-button \nng-value=\"vm.documentSliderPage.ID\" class=\"md-primary\">Document</md-radio-button></md-radio-group><div \nclass=\"documentSlider\"><div class=\"driverLicenseTile\" \nng-show=\"vm.documentSlider.index == vm.documentSliderPage.LICENSE\"><div class=\"invertedTileTitle centersSingleElement\">\nDriving license: {{vm.user.license_id}} | Expiration: {{vm.user.license_expiration | toDate:\'\':vm.user.SiteId}}</div>\n<div class=\"tileContent driverLicenseContent\"><div class=\"sliderContainer\"><div class=\"uploadButtonContainer\"><label \nfor=\"dl_image_upload\">Upload</label><input type=\"file\" id=\"dl_image_upload\" name=\"dl_image_upload\" \naccept=\".jpg, .jpeg, .png\"></div><div class=\"driverLicenseOvelay centersSingleElement\" \nng-hide=\"vm.documentSlider.license.images.length > 0\">No license uploaded</div><img class=\"licenseImage\" \nng-src=\"{{vm.documentSlider.license.selectedImage.location}}\" \nng-click=\"vm.showBiggerImage(vm.documentSlider.license.selectedImage.location)\"><div class=\"dotContainer\"><div \nclass=\"dot\" ng-class=\"vm.documentSlider.license.selectedImageIndex == 0? \'dotSelected\':\'\' \" \nng-click=\"vm.selectImage(0)\"></div><div class=\"dot\" \nng-class=\"vm.documentSlider.license.selectedImageIndex == 1? \'dotSelected\':\'\' \" ng-click=\"vm.selectImage(1)\"></div>\n</div></div><div class=\"actionsBar\"><md-button class=\"action actionButtonReject\" \nng-disabled=\"vm.user.validLicensePlate == vm.userLicenseStatus.REJECTED.value || vm.user.validLicensePlate == vm.userLicenseStatus.NOT_VALID.value\" \nng-click=\"vm.revokeRejectButtonAction()\">\n{{vm.user.validLicensePlate == vm.userLicenseStatus.VALID.value ? \'Revoke\' : vm.user.validLicensePlate == vm.userLicenseStatus.REJECTED.value ? \'Rejected\' : vm.user.validLicensePlate == vm.userLicenseStatus.NOT_VALID.value ? \'Revoked\' : vm.user.validLicensePlate == vm.userLicenseStatus.WAITING_FOR_APPROVAL.value ? \'Reject\':\'\'}}\n</md-button><md-checkbox class=\"action actionCheckbox\" ng-model=\"vm.user.accessForCar\">Car</md-checkbox><md-checkbox \nclass=\"action actionCheckbox\" ng-model=\"vm.user.accessForScooter\">Scooter</md-checkbox><md-button \nclass=\"action actionButtonAccept\" \nng-class=\"vm.user.validLicensePlate == vm.userLicenseStatus.VALID.value ? \'accepted\' : \'\' \" \nng-disabled=\"vm.user.validLicensePlate == vm.userLicenseStatus.VALID.value\" ng-click=\"vm.acceptLicense()\">\n{{vm.user.validLicensePlate == vm.userLicenseStatus.VALID.value ? \'Accepted\' : \'Accept\'}}</md-button></div></div></div>\n<div class=\"IDTile\" ng-show=\"vm.documentSlider.index ==  vm.documentSliderPage.ID\"><div \nclass=\"invertedTileTitle centersSingleElement\">\nID: {{vm.user.identity_id}} | Type: {{vm.getDocumentTypeDescription()}} | Expiration: {{vm.user.identity_expiration | toDate:\'\':vm.user.SiteId}}\n</div><div class=\"tileContent driverLicenseContent\"><div class=\"sliderContainer\"><div class=\"uploadButtonContainer\">\n<label for=\"id_image_upload\">Upload</label><input type=\"file\" id=\"id_image_upload\" name=\"id_image_upload\" \naccept=\".jpg, .jpeg, .png\"></div><div class=\"driverLicenseOvelay centersSingleElement\" \nng-hide=\"vm.documentSlider.document.images.length > 0\">No document uploaded</div><img class=\"licenseImage\" \nng-src=\"{{vm.documentSlider.document.selectedImage.location}}\" \nng-click=\"vm.showBiggerImage(vm.documentSlider.document.selectedImage.location)\"><div class=\"dotContainer\"><div \nclass=\"dot\" ng-class=\"vm.documentSlider.document.selectedImageIndex == 0? \'dotSelected\':\'\' \" \nng-click=\"vm.selectImage(0)\"></div><div class=\"dot\" \nng-class=\"vm.documentSlider.document.selectedImageIndex == 1? \'dotSelected\':\'\' \" ng-click=\"vm.selectImage(1)\"></div>\n</div></div><div class=\"actionsBar\"><md-button class=\"action actionButtonReject\" \nng-disabled=\"vm.user.validDocument == vm.userDocumentStatus.REJECTED.value || vm.user.validDocument == vm.userDocumentStatus.NOT_VALID.value\" \nng-click=\"vm.revokeRejectButtonAction()\">\n{{vm.user.validDocument == vm.userDocumentStatus.VALID.value ? \'Revoke\' : vm.user.validDocument == vm.userDocumentStatus.REJECTED.value ? \'Rejected\' : vm.user.validDocument == vm.userDocumentStatus.NOT_VALID.value ? \'Revoked\' : vm.user.validDocument == vm.userDocumentStatus.WAITING_FOR_APPROVAL.value ? \'Reject\':\'\'}}\n</md-button><md-button class=\"action actionButtonAccept\" \nng-class=\"vm.user.validDocument == vm.userDocumentStatus.VALID.value ? \'accepted\' : \'\' \" \nng-disabled=\"vm.user.validDocument == vm.userLicenseStatus.VALID.value\" ng-click=\"vm.acceptID()\">\n{{vm.user.validDocument == vm.userDocumentStatus.VALID.value ? \'Accepted\' : \'Accept\'}}</md-button></div></div></div>\n</div></div></div><div class=\"bottomContainer hideable\" layout=\"column\" layout-gt-sm=\"row\" \nng-class=\"{streched: vm.userRelatedDataFullScreen}\"><div \nclass=\"threeInARowTile md-whiteframe-4dp roundCornersSmaller hideable\" flex \nng-class=\"{streched: vm.userRelatedDataFullScreen, isHidden: (vm.userDetailsFullScreen || vm.referredUsersListFullScreen || vm.couponsHistoryListFullScreen)}\">\n<div class=\"tileTitleContainer\"><div class=\"tileTitle centersSingleElement\"><div>Trips</div><div class=\"subtitle\">\n{{ vm.userRelatedDataFullScreen ? \'Displayed: \' + vm.userTrips.length + \'/\' + vm.totalTrips : \'Total: \' + vm.totalTrips }}\n</div></div><md-button class=\"md-icon-button\" ng-click=\"vm.exportUserTripsAsCSV()\"><md-icon \nmd-font-icon=\"icon-download\"><md-tooltip><span>Export As CSV</span></md-tooltip></md-icon></md-button></div><div \nclass=\"tileContent threeInARowContent disableScroll\" ng-show=\"vm.userTrips.length == 0\"><div \nstyle=\"margin-top:8px;text-align:center\">No trip found</div></div><div \nclass=\"tileContent threeInARowContent disableScroll\" ng-if=\"vm.userTrips.length > 0\"><div \nclass=\"vehicle-list-item trip-list-item border-bottom\" layout=\"column\" \nng-repeat=\"trip in vm.userTrips track by trip.id\"><div class=\"vehicle-list-item-title\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><label>Trip ID:</label><a \nclass=\"userLink\" ui-sref=\"app.trip.details({tripId: trip.id})\">{{trip.id}}</a></div><div layout=\"row\" flex=\"50\" \nlayout-align=\"end center\"><label>Vehicle:</label><a class=\"userLink text-ellipsis\" \nui-sref=\"app.vehicle.details({vehicleId: trip.Vehicle.id})\">{{trip.Vehicle.reference_code}}</a></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div flex=\"15\" layout=\"row\" layout-align=\"center center\" hide-xs hide-sm>\n<md-icon class=\"vehicle-list-item-icon-small\" md-svg-icon=\"assets/icons/icon-route.svg\"></md-icon></div><div flex=\"20\" \nlayout=\"row\" layout-align=\"center center\" hide-gt-sm><md-icon class=\"vehicle-list-item-icon-medium\" \nmd-svg-icon=\"assets/icons/icon-route.svg\"></md-icon></div><div flex layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"60\" layout=\"column\" class=\"fill-width-md\"><label>Start:</label><p>\n{{trip.start |toDate:\"dateTime\":trip.SiteId}}</p></div><div flex=\"30\" flex-sm=\"20\" layout=\"column\"><label>Duration:\n</label><p flex>{{trip.FinishPosition ? trip.duration +\' min\' : \'Not finished\'}}</p></div></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"60\" layout=\"column\" class=\"fill-width-md\"><label>End:</label><p>\n{{trip.end |toDate:\"dateTime\":trip.SiteId}}</p></div><div flex=\"30\" flex-sm=\"20\" layout=\"column\"><label>Cost:</label>\n<p>{{trip.FinishPosition ? vm.getCurrencyValue(trip.Booking.price, trip.SiteId) : \'N/A\'}}</p></div></div></div></div>\n</div><div class=\"vehicle-list-item trip-list-item border-bottom\" ng-show=\"vm.userRelatedDataFullScreen\" layout=\"row\" \nlayout-align=\"space-around center\"><md-button class=\"md-raised\" ng-click=\"vm.gotoTripsPage()\">View More</md-button>\n</div></div><div class=\"showMoreButtonContainer\" layout=\"row\" layout-align=\"space-around center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.toggleUserRelatedDataFullScreen()\">\n{{vm.userRelatedDataFullScreen ? \'Show less\' : \'Show more\' }}</md-button></div></div><div \nclass=\"threeInARowTile md-whiteframe-4dp roundCornersSmaller hideable\" flex \nng-class=\"{streched: vm.userRelatedDataFullScreen , isHidden: (vm.userDetailsFullScreen || vm.referredUsersListFullScreen || vm.couponsHistoryListFullScreen)}\">\n<div class=\"tileTitleContainer\"><div class=\"tileTitle centersSingleElement\"><div>Transactions</div><div \nclass=\"subtitle\">\n{{ vm.userRelatedDataFullScreen ? \'Displayed: \' + vm.displayedTransactions + \'/\' + vm.totalTransactions : \'Total: \' + vm.totalTransactions }}\n</div></div><md-button class=\"md-icon-button\" ng-click=\"vm.exportUserTransactionsAsCSV()\"><md-icon \nmd-font-icon=\"icon-download\"><md-tooltip>Export As CSV</md-tooltip></md-icon></md-button></div><div \nclass=\"tileContent threeInARowContent disableScroll\"><div style=\"margin-top:8px;text-align:center\" \nng-if=\"vm.transactions.length == 0\">No transaction found</div><div class=\"transactionRow border-bottom\" \nng-repeat=\"transaction in vm.transactions track by transaction.id\"><div class=\"iconContainer centersSingleElement\">\n<md-icon class=\"vehicle-list-item-icon-small\" md-svg-icon=\"assets/icons/icon-dollar.svg\"></md-icon></div><div \nclass=\"infoContainer centersSingleElement\"><div><span class=\"title\">Id: </span><span>{{transaction.id}}</span></div>\n<div><span class=\"title\">Code: </span><span>{{transaction.code}}</span></div><div><span class=\"title\">Cost: </span>\n<span>{{vm.getCurrencyValue(transaction.price, vm.getTransactionSiteId(transaction))}}</span></div><div \nng-show=\"transaction.data.failure_message\"><span class=\"title\">Error: </span><span>{{transaction.data.failure_message}}\n</span></div><div><span class=\"title\">Descr: </span><span>{{vm.getTransactionDescription(transaction)}}</span></div>\n<div><span class=\"title\">Created: </span><span>\n{{transaction.created_at | toDate:\"dateTime\": vm.getTransactionSiteId(transaction)}}</span></div><div><span \nclass=\"title\">Updated: </span><span>\n{{transaction.updated_at | toDate:\"dateTime\": vm.getTransactionSiteId(transaction)}}</span></div></div><div \nclass=\"transactionStatusIconsContainer\"><div flex class=\"statusIconContainer centersSingleElement\"><md-icon \nclass=\"statusIcon\" ng-class=\"vm.checkTransactionStatusAndGetIcon(transaction)\"><md-tooltip>\n{{vm.getTransactionStatusDescription(transaction)}}</md-tooltip></md-icon></div><div flex layout=\"row\" \nng-show=\"vm.isTransactionRetryable(transaction)\"><div class=\"statusIconContainer centersSingleElement\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.blockAutomaticTransactionRetry(transaction)\" ng-disabled=\"vm.isButtonDisabled\">\n<md-icon md-font-icon=\"icon-repeat-off\"><md-tooltip>Block Automatic Retry</md-tooltip></md-icon></md-button></div><div \nclass=\"statusIconContainer centersSingleElement\"><md-button class=\"md-icon-button\" \nng-click=\"vm.retryTransaction(transaction)\" ng-disabled=\"vm.isButtonDisabled\"><md-icon md-font-icon=\"icon-repeat\">\n<md-tooltip>Retry</md-tooltip></md-icon></md-button></div></div></div></div><div \nclass=\"vehicle-list-item trip-list-item border-bottom\" ng-if=\"vm.transactions.length > 0\" \nng-show=\"vm.userRelatedDataFullScreen\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-raised\" \nng-click=\"vm.getNextTransactionsPage()\">Load More</md-button></div></div><div class=\"showMoreButtonContainer\" \nlayout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-raised\" \nng-click=\"vm.toggleUserRelatedDataFullScreen()\">{{vm.userRelatedDataFullScreen ? \'Show less\' : \'Show more\' }}\n</md-button></div></div><div class=\"threeInARowDoubleTile hideable\" flex \nng-class=\"{streched: vm.userRelatedDataFullScreen , isHidden: (vm.referredUsersListFullScreen || vm.userDetailsFullScreen || vm.couponsHistoryListFullScreen)}\">\n<div class=\"threeInARowTile paymentMethodTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{streched: (vm.userRelatedDataFullScreen)}\"><div class=\"tileTitleContainer\"><div \nclass=\"tileTitle centersSingleElement\"><div>Payment Methods</div><div class=\"subtitle\">\nReference: {{vm.user.paymentRef}}</div></div></div><div class=\"tileContent threeInARowContent\"><div \nstyle=\"margin-top:8px;text-align:center\" ng-if=\"vm.payments.length == 0\">No payment methods found</div><div \nclass=\"paymentMethodRow border-bottom\" \nng-repeat=\"paymentMethod in vm.payments |filter: {pan: \'!Cash\'} track by paymentMethod.id\"><div \nclass=\"iconContainer centersSingleElement\"><md-icon md-font-icon=\"icon-credit-card\"></md-icon></div><div \nclass=\"infoContainer centersSingleElement\"><div><span class=\"title\">Brand: </span><span>{{paymentMethod.brand}}</span>\n</div><div><span class=\"title\">Pan: </span><span>{{paymentMethod.pan}}</span></div><div><span class=\"title\">\nExpiration: </span><span>{{paymentMethod.exp_month}}/{{paymentMethod.exp_year}}</span></div></div><div \nclass=\"iconContainer centersSingleElement\"><md-icon md-font-icon=\"icon-delete\" style=\"font-size:20px\" \nng-click=\"vm.callDeletePayment(paymentMethod,$index)\"><md-tooltip>Delete</md-tooltip></md-icon></div></div></div><div \nclass=\"tileFooter\"><div>Last payment status: {{vm.user.paymentStatusHuman}}</div><md-button \nclass=\"smallFloatingButton\" ng-click=\"vm.showMakeManualPaymentDialog($event)\">Charge</md-button></div></div><div \nclass=\"threeInARowTile invoicesShortTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{streched: (vm.userRelatedDataFullScreen)}\"><div class=\"tileTitleContainer\"><div \nclass=\"tileTitle centersSingleElement\"><div>Tickets</div><div class=\"subtitle\" ng-show=\"vm.userRelatedDataFullScreen\">\n{{ vm.userRelatedDataFullScreen ? \'Displayed: \' + vm.invoices.length + \'/\' + vm.totalInvoices : \'Total: \' + vm.totalInvoices }}\n</div></div><md-button class=\"md-icon-button\" ng-click=\"vm.exportUserInvoicesAsCSV()\"><md-icon \nmd-font-icon=\"icon-download\"><md-tooltip><span>Export As CSV</span></md-tooltip></md-icon></md-button></div><div \nclass=\"tileContent threeInARowContent\"><div class=\"invoicesRow invoicesRecapRow border-bottom\" \nng-show=\"!vm.userRelatedDataFullScreen\"><div class=\"iconContainer centersSingleElement\"><md-icon \nclass=\"vehicle-list-item-icon-small\" md-font-icon=\"icon-clipboard-text\"></md-icon></div><div \nclass=\"infoContainer centersSingleElement\">Total tickets: {{vm.totalInvoices}}</div></div><div \nclass=\"tileContent threeInARowContent\" ng-show=\"vm.invoices.length>0 && vm.userRelatedDataFullScreen\"><div \nclass=\"invoicesRow border-bottom\" ng-repeat=\"invoice in vm.invoices track by invoice.id\"><div \nclass=\"iconContainer centersSingleElement\"><md-icon class=\"vehicle-list-item-icon-small\" \nmd-font-icon=\"icon-clipboard-text\"></md-icon></div><div class=\"infoContainer centersSingleElement\"><div><span \nclass=\"title\">Code: </span><span class=\"userLink\" ng-click=\"vm.openPdf(invoice)\">{{invoice.code}}</span></div><div>\n<span class=\"title\">Creation date: </span><span>{{invoice.created | toDate:\"dateTime\":invoice.SiteId}}</span></div>\n<div><span class=\"title\">Type: </span><span>{{vm.getInvoiceTypeDescription(invoice)}}</span></div><div><span \nclass=\"title\">Status: </span><span>{{vm.getInvoiceStatusDescription(invoice)}}</span></div><div><span class=\"title\">\nPrice: </span><span>{{vm.getCurrencyValue(invoice.totalPrice, invoice.SiteId)}}</span></div><div><span class=\"title\">\nPayment: </span><span>{{invoice.paymentStatusHuman}}</span></div></div></div><div \nclass=\"vehicle-list-item trip-list-item border-bottom\" ng-show=\"vm.userRelatedDataFullScreen\" layout=\"row\" \nlayout-align=\"space-around center\"><md-button class=\"md-raised\" ng-click=\"vm.goToInvoicesPage()\">View More</md-button>\n</div></div></div><div class=\"showMoreButtonContainer\" layout=\"row\" layout-align=\"space-around center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.toggleUserRelatedDataFullScreen()\">\n{{vm.userRelatedDataFullScreen ? \'Show less\' : \'Show more\' }}</md-button></div></div></div></div></div></div><div \nclass=\"referredUsersTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{streched: vm.referredUsersListFullScreen, isHidden: (vm.couponsHistoryListFullScreen || vm.userRelatedDataFullScreen)}\" \nng-show=\"vm.referredUsers.length>0\"><div class=\"tileTitle\"><div>Referred Users</div><div class=\"subtitle\">\nTotal: {{vm.referredUsersTotal}}</div></div><generic-table headers=\"vm.referredUsersTableFields\" \ndata=\"vm.referredUsers\" update-data=\"vm.getReferredUser\" class=\"referredUsersTable\" page-limit=\"5\" \ndownload-data=\"false\" show-last-update=\"false\"></generic-table></div><div \nclass=\"couponsHistoryTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{streched: vm.couponsLegacyHistoryListFullScreen, isHidden: (vm.referredUsersListFullScreen || vm.userRelatedDataFullScreen)}\" \nng-show=\"vm.couponsLegacyHistory.length>0\"><div class=\"tileTitle\"><div>Coupons Legacy History</div><div \nclass=\"subtitle\">Total: {{vm.couponLegacyHistoryTotal}}</div></div><generic-table \nheaders=\"vm.couponsLegacyHistoryTableFields\" data=\"vm.couponsLegacyHistory\" update-data=\"vm.getCouponsLegacyHistory\" \npage-limit=\"5\" download-data=\"false\" show-last-update=\"false\" class=\"couponsHistoryTable\"></generic-table></div><div \nclass=\"couponsHistoryTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{streched: vm.couponsHistoryListFullScreen, isHidden: (vm.referredUsersListFullScreen || vm.userRelatedDataFullScreen)}\" \nng-show=\"vm.couponsHistory.length>-1\"><div class=\"tileTitle\"><div>Coupons History</div><div class=\"subtitle\">\nTotal: {{vm.couponHistoryTotal}}</div></div><generic-table headers=\"vm.couponsHistoryTableFields\" \ndata=\"vm.couponsHistory\" update-data=\"vm.getCouponsHistory\" page-limit=\"5\" download-data=\"false\" \nshow-last-update=\"false\" class=\"couponsHistoryTable\"></generic-table></div><div \nclass=\"couponsHistoryTile md-whiteframe-4dp roundCornersSmaller hideable\" \nng-class=\"{isHidden: (vm.referredUsersListFullScreen || vm.userRelatedDataFullScreen)}\" \nng-show=\"vm.shopOrders.length>0\"><div class=\"tileTitle\"><div>Store orders</div><div class=\"subtitle\">\nTotal: {{vm.shopOrdersTotal}}</div></div><generic-table headers=\"vm.shopOrdersTableFields\" data=\"vm.shopOrders\" \nupdate-data=\"vm.getShopOrders\" page-limit=\"5\" download-data=\"false\" show-last-update=\"false\" \nclass=\"couponsHistoryTable\"></generic-table></div><div class=\"pageBottomContainer hideable\" \nng-class=\"{isHidden: ( vm.referredUsersListFullScreen || vm.couponsHistoryListFullScreen || vm.userDetailsFullScreen || vm.userRelatedDataFullScreen)}\">\n<div class=\"rolesTile md-whiteframe-4dp roundCornersSmaller\"><div class=\"tileTitle pillContainerTitle\"><div>\n{{vm.isManagingUserSites ? \'Manage Sites\' : \'Activated Sites\'}}</div><md-icon \nng-show=\"vm.user.role === \'user\' && vm.enableManageUserSites\" ng-click=\"vm.toggleManageUserSites()\" \nmd-font-icon=\"{{vm.isManagingUserSites ? \'icon-close\' : \'icon-pencil\'}}\"></md-icon></div><div \nclass=\"rolesTileContentContainer\"><div class=\"roleElement centersSingleElement\" \nng-class=\"(vm.isUserActiveInSite(site)? \'activated\' : \'\')\" \nng-repeat=\"site in vm.shownSites | filter:{\'id\':\'!-1\'} track by site.id \"><md-checkbox class=\"roleCheckbox\" \nng-checked=\"vm.isUserActiveInSite(site)\" ng-click=\"vm.handleUserSiteManaging(site)\" \nng-disabled=\"!vm.isManagingUserSites\">{{site.name}}</md-checkbox></div></div></div><div \nclass=\"rolesTile md-whiteframe-4dp roundCornersSmaller\"><div class=\"tileTitle pillContainerTitle\"><div>\n{{vm.isManagingRoles ? \'Manage Roles\' : \'Roles\'}}</div><md-icon ng-show=\"vm.user.role === \'admin\'\" \nng-click=\"vm.toggleManageRoles()\" md-font-icon=\"{{vm.isManagingRoles ? \'icon-close\' : \'icon-pencil\'}}\"></md-icon></div>\n<div class=\"rolesTileContentContainer\"><div class=\"roleElement centersSingleElement\" \nng-repeat=\"role in vm.shownRoles track by role.id\" ng-class=\"(vm.checkUserForRole(role, $index))? \'activated\' : \'\' \">\n<md-checkbox class=\"roleCheckbox\" ng-checked=\"vm.checkUserForRole(role)\" ng-click=\"vm.addRemoveRole(role)\" \nng-disabled=\"!vm.isManagingRoles\">{{role.name}}</md-checkbox></div></div></div></div></div><div \nclass=\"biggerImageBackDrop\" ng-show=\"vm.isShowingTheBiggerPicture\" ng-click=\"vm.dismissBiggerImage()\"><div \nclass=\"biggerImageContainer\"><img ng-src=\"{{vm.biggerImage}}\"></div></div></div>");
$templateCache.put("app/main/user/dialogs/user-add-dialog.html","<md-dialog class=\"user-add-dialog\" aria-label=\"Create user\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Register an Admin</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><img ng-src=\"assets/images/avatars/profile.jpg\" \nclass=\"md-avatar avatar contact-avatar huge\" alt=\"{{vm.user.name}}\"></div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" \nlayout-align=\"center center\"></div></div></md-toolbar><md-dialog-content><md-tabs md-dynamic-height><md-tab>\n<md-tab-label><span>Details</span></md-tab-label><md-tab-body><md-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label>Name</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"vm.user.name\" type=\"text\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>\nLast name</label><md-icon md-font-icon=\"icon-account\"></md-icon><input ng-model=\"vm.user.surname\" type=\"text\">\n</md-input-container><md-input-container class=\"md-block\" style=\"height: 58px\"><label>Restriction Site</label><md-icon \nmd-font-icon=\"icon-city\"></md-icon><md-select ng-model=\"vm.user.SiteId\" ng-disabled=\"vm.disableSiteChange\"><md-option \nng-repeat=\"site in vm.sites\" ng-value=\"site.id\">{{site.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>Email</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon>\n<input ng-model=\"vm.user.email\" type=\"email\" required></md-input-container></md-content></md-tab-body></md-tab>\n</md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\">\n</div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"vm.user\" \nng-click=\"vm.callAddUser()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add\">Add</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/user/dialogs/user-change-free-minutes-dialog.html","<md-dialog class=\"user-change-free-minutes-dialog\" aria-label=\"manage device\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">User {{vm.user.id}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \nng-disabled=\"vm.isLoading\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content flex><md-content flex layout=\"column\"><p class=\"title-details\">User info:</p><div \nclass=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Id:</label><p>{{vm.user.id}}</p></div><div \nclass=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Full name:</label><p>{{vm.user.fullName}}</p>\n</div><div class=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Email:</label><p>{{vm.user.email}}\n</p></div><div class=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Phone:</label><p>\n{{vm.user.tel}}</p></div><div class=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>\nCurrent free credit:</label><p>{{vm.getUserFreeCredit(vm.user)}}</p></div><div layout=\"column\"><p \nclass=\"title-details\">Change free credit:</p><div class=\"changeMinutesRow\"><div class=\"inputMinutes\" flex>\n<md-input-container><label>Amount</label><input type=\"number\" ng-model=\"vm.creditToChangeDisplayed\" \nng-model-options=\"{\'debounce\': 500}\" ng-change=\"vm.calculateUserFreeCredit()\"></md-input-container></div><div \nclass=\"invoice-info-item\" flex><div layout=\"row\" layout-align=\"start center\"><label>New free credit:</label><p>\n{{vm.parseFreeCredit(vm.newUserFreeCredit)}}</p></div></div></div></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-around center\"><md-button class=\"send-button md-accent md-raised\" \nng-click=\"vm.callChangeUserFreeCredit()\" ng-disabled=\"vm.isLoading\" aria-label=\"change\">Change</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/vehicle/details/embed-template.html","<div ng-init=\"neImageLong=false\" ng-class=\"{false:\'ne-image\', true:\'ne-image ne-image-long\'}[neImageLong]\" \nng-if=\"image.url\"><div class=\"ne-image-wrapper\"><img ng-src=\"{{image.url}}\" ng-click=\"neImageLong=!neImageLong\" alt=\"\">\n</div></div><div class=\"ne-pdf\" ng-if=\"pdf.url\"><div class=\"ne-pdf-preview\" ng-hide=\"neShowPdf\"><div \nclass=\"ne-pdf-icon\" layout=\"column\" layout-align=\"center center\" style=\"height: 200px!important\"><md-icon \nclass=\"pdf-image\" md-font-icon=\"icon-file-pdf\"></md-icon></div><div class=\"ne-pdf-detail\" layout=\"column\" \nlayout-align=\"space-between end\"><div class=\"ne-pdf-title\"><div></div></div><div class=\"ne-pdf-view\"><button><i \nclass=\"fa fa-download\"></i> <a ng-href=\"{{pdf.url}}\" target=\"_blank\">Download</a></button> <button \nng-click=\"neShowPdf=!neShowPdf\"><i class=\"fa fa-eye\"></i> View PDF</button></div></div></div><div \nclass=\"ne-pdf-viewer\" ng-if=\"neShowPdf\" ng-show=\"neShowPdf\"><iframe ng-src=\"{{pdf.url}}\" frameborder=\"0\"></iframe>\n</div></div>");
$templateCache.put("app/main/vehicle/details/vehicle-details.html","<div id=\"vehicle-details\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-fab md-icon-button\" ng-click=\"vm.goToVehicles()\" \naria-label=\"Go Back\" translate-attr-aria-label=\"VEHICLE.GO_BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n<md-tooltip><span translate=\"VEHICLE.GO_BACK\">Go Back</span></md-tooltip></md-button><div layout=\"row\"><md-button \nclass=\"md-fab md-icon-button\" ng-click=\"vm.refreshVehicle()\" aria-label=\"Reload\" \ntranslate-attr-aria-label=\"VEHICLE.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"VEHICLE.RELOAD\">Reload</span></md-tooltip></md-button><md-button class=\"md-fab md-icon-button\" \nng-click=\"vm.callDeleteVehicleConfirmDialog()\" aria-label=\"Delete\" translate-attr-aria-label=\"VEHICLE.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"VEHICLE.DELETE\">Delete</span></md-tooltip>\n</md-button></div></div></div><div class=\"content\" style=\"padding: 16px\"><div flex layout=\"column\" \nclass=\"row-container\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between center\"><div flex layout=\"column\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div flex \nclass=\"vehicle-details-widget white-bg md-whiteframe-4dp roundCornersSmaller\" layout=\"column\"><div \nclass=\"h3 vehicle-details-widget-title-container\"><p>\n{{vm.vehicle.reference_code}} | {{vm.vehicle.id}} | {{vm.vehicle.deviceTypeHuman}} |<md-icon \nclass=\"vehicle-online-icon\" ng-class=\"vm.vehicle.online? \'icon-check-circle\' : \'icon-close-circle-outline\' \"></md-icon>\n</p><md-button class=\"md-icon-button\" ng-click=\"vm.focusOnImagesTab()\" aria-label=\"Edit\" \ntranslate-attr-aria-label=\"VEHICLE.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span \ntranslate=\"VEHICLE.EDIT\">Edit</span></md-tooltip></md-button></div><md-divider></md-divider><div flex \nclass=\"vehicle-details-widget-item centerImage\" layout=\"row\"><img ng-src=\"{{vm.vehicle.images[0].location}}\" \nstyle=\"object-fit:contain\"></div></div><div flex \nclass=\"vehicle-details-widget white-bg md-whiteframe-4dp roundCornersSmaller\" layout=\"column\"><div class=\"h3\"><p>\n{{vm.checkBookingStatusAndGetDescription(vm.vehicle)}}</p></div><md-divider></md-divider><div flex \nclass=\"vehicle-details-widget-item\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"account-icon\" \nmd-font-icon=\"{{vm.vehicle.bookings[0] ? \'icon-account\' : \'icon-close\'}}\"></md-icon><p><span>User: </span><a \nclass=\"userLink text-ellipsis\" ui-sref=\"app.user.details({userId: vm.vehicle.bookings[0].user.id})\">\n{{vm.hasVehicleACurrentBooking(vm.vehicle) ? vm.vehicle.currentUser : vm.vehicle.lastUser}}</a></p></div></div></div>\n<div flex><div flex class=\"vehicle-details-widget white-bg md-whiteframe-4dp roundCornersSmaller\" layout=\"column\"><div \nclass=\"h3\"><p>Vehicle Overview</p></div><md-divider></md-divider><div flex class=\"vehicle-overview-container\" \nlayout=\"row\"><div flex class=\"vehicle-details-widget-item overview-battery-top-container\" layout=\"column\" \nlayout-align=\"space-between center\"><div flex layout=\"column\" layout-align=\"center center\"><p class=\"main-label\" \nng-style=\"{color:vm.toHireDefaultColor.blue}\">\n{{vm.vehicle.extraInfo.noBatteryData === true ? \'N/A\' : (vm.vehicle.total_percentage + \' %\')}}</p></div><div \nclass=\"vehicle-details-widget-item-footer\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"voltageContainer\" \nng-if=\"vm.vehicle.deviceType === vm.deviceType.PERSONAL.value || vm.vehicle.extraInfo.noBatteryData === true\"><div>\n<span class=\"batteryVoltage\">{{vm.vehicleBattery.value}} {{vm.vehicleBattery.unit}}</span><md-tooltip>\n{{vm.vehicleBattery.description}}</md-tooltip></div></div><div class=\"battery-info-container\"><div \nng-if=\"vm.vehicle.fuels.length >= 1\" class=\"battery-info\"><md-icon style=\"color:#284678\" \nmd-font-icon=\"{{vm.getVehicleBatteryPercentageIcon(vm.vehicle.fuels[0].percentage)}}\"></md-icon><md-tooltip>\n{{vm.vehicle.type == vm.vehicleTypes.CAR.value ? \'Fuel\' : \'Battery\'}} 1</md-tooltip><span>\n{{vm.vehicle.fuels[0] && (vm.vehicle.fuels[0].percentage | toNumber: 2)}} %</span></div><div \nng-if=\"vm.vehicle.fuels.length >= 2\" class=\"battery-info\"><md-icon style=\"color:#284678\" \nmd-font-icon=\"{{vm.getVehicleBatteryPercentageIcon(vm.vehicle.fuels[1].percentage)}}\"></md-icon><md-tooltip>\n{{vm.vehicle.type == vm.vehicleTypes.CAR.value ? \'Fuel\' : \'Battery\'}} 2</md-tooltip><span>\n{{vm.vehicle.fuels[1] && (vm.vehicle.fuels[1].percentage | toNumber: 2)}} %</span></div><div \nng-if=\"vm.vehicle.autonomy_meters\" class=\"battery-info\"><md-icon style=\"color:#284678\" \nmd-svg-icon=\"assets/icons/road-with-broken-line.svg\"></md-icon><md-tooltip>Autonomy</md-tooltip><span>\n{{vm.vehicle.autonomy_meters/1000 | toNumber: 1}} km</span></div></div></div></div><div flex \nclass=\"vehicle-details-widget-item border-left\" layout=\"column\"><div class=\"vehicle-info-list-item\" layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"vehicle-list-item-icon-medium\" \nmd-svg-icon=\"assets/icons/icon-license-plate.svg\"></md-icon><div layout=\"column\"><p>License Plate:</p><p>\n{{vm.vehicle.license_plate}}</p></div></div><div class=\"vehicle-info-list-item\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-svg-icon=\"assets/icons/icon-location-pointer.svg\"></md-icon><div \nlayout=\"column\"><p>Position:</p><p class=\"text-ellipsis\">{{vm.vehicle.address}}</p></div></div><div \nclass=\"vehicle-info-list-item\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-icon=\"{{vm.getVehicleIcon(vm.vehicle)}}\"></md-icon><div layout=\"column\"><p>Status:</p><p>{{vm.vehicle.status}}\n</p></div></div></div></div></div></div></div><div flex layout=\"column\" class=\"row-container\" layout-gt-xs=\"row\" \nlayout-gt-xs-align=\"space-between center\"><div flex \nclass=\"vehicle-details-widget vehicle-details-widget-list white-bg md-whiteframe-4dp roundCornersSmaller\" \nlayout=\"column\"><div class=\"h3 vehicle-details-widget-title-container\"><p>Vehicle Details</p><div layout=\"row\">\n<md-button class=\"md-icon-button\" ng-show=\"!vm.disableEditVehicleDetails\" ng-click=\"vm.callUpdateVehicle()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"VEHICLE.CONFIRM\"><md-icon md-font-icon=\"icon-check\"></md-icon>\n<md-tooltip><span translate=\"VEHICLE.CONFIRM\">Confirm</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.disableEditVehicleDetails ? vm.enableVehicleDetailsChange() : vm.disableVehicleDetailsChange()\" \naria-label=\"Edit\" translate-attr-aria-label=\"VEHICLE.EDIT\"><md-icon \nmd-font-icon=\"{{vm.disableEditVehicleDetails ? \'icon-pencil\' : \'icon-close\'}}\"></md-icon><md-tooltip><span \ntranslate=\"{{vm.disableEditVehicleDetails ? \'VEHICLE.EDIT\' : \'VEHICLE.CANCEL\'}}\">Edit</span></md-tooltip></md-button>\n<md-button class=\"md-icon-button export-csv-button\" ng-click=\"vm.exportVehicleDetailsAsCSV()\" \naria-label=\"Export as CSV\" translate-attr-aria-label=\"VEHICLE.EXPORT_AS_CSV\"><md-icon md-font-icon=\"icon-download\">\n</md-icon><md-tooltip><span translate=\"VEHICLE.EXPORT_AS_CSV\">Export As CSV</span></md-tooltip></md-button></div></div>\n<md-divider></md-divider><div flex class=\"vehicle-details-widget-item\" layout=\"column\" style=\"overflow-y: scroll\"><div \nflex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" layout=\"row\" layout-align=\"start center\" \nstyle=\"height: 58px\"><label>Group tag:</label><md-select ng-model=\"vm.vehicle.movoGroupTag\" style=\"margin: 0px\" \nng-disabled=\"vm.disableEditVehicleDetails\" aria-label=\"choose descriptor\"><md-option \nng-repeat=\"tagObj in vm.vehicleServiceGroupTags\" ng-selected=\"vm.vehicle.movoGroupTag == tagObj.value|| $index==0\" \nng-value=\"tagObj.value\">{{tagObj.name}}</md-option></md-select></div><div flex=\"noshrink\" \nng-show=\"vm.vehicle.status == vm.vehicleStatus.UNAVAILABLE.value\" class=\"vehicle-list-item border-bottom p-16\" \nlayout=\"row\" layout-align=\"start center\" style=\"height: 58px\"><label>Unavailable descriptor</label><md-select \nng-model=\"vm.vehicle.movoUnavailableDescriptor\" style=\"margin: 0px\" ng-disabled=\"vm.disableEditVehicleDetails\" \naria-label=\"choose descriptor\"><md-option ng-repeat=\"descriptor in vm.movoUnavailableDescriptors\" \nng-value=\"descriptor.value\">{{descriptor.name}}</md-option></md-select></div><div flex=\"noshrink\" \nng-show=\"vm.vehicle.hidden_at != null\" class=\"vehicle-list-item border-bottom p-16\" layout=\"row\" \nlayout-align=\"start center\"><label>Hidden on:</label><p>\n{{vm.vehicle.hidden_at | toDate: \"dateTime\": vm.vehicle.SiteId}}</p></div><div flex=\"noshrink\" \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Ref. Code:</label><input \nng-class=\"{\'border-bottom\': !vm.disableEditVehicleDetails}\" ng-model=\"vm.vehicle.reference_code\" type=\"text\" \nng-disabled=\"vm.disableEditVehicleDetails\"></div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" \nlayout=\"row\"><label>Vehicle ID:</label><p>{{vm.vehicle.id}}</p></div><div flex=\"noshrink\" \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\" layout-align=\"start center\" \nng-class=\"{\'vehicle-list-item-editable\': !vm.disableEditVehicleDetails}\"><label>License Plate:</label><input \nng-class=\"{\'border-bottom\': !vm.disableEditVehicleDetails}\" ng-model=\"vm.vehicle.license_plate\" type=\"text\" \nng-disabled=\"vm.disableEditVehicleDetails\"></div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" \nlayout=\"row\" layout-align=\"start center\" ng-class=\"{\'vehicle-list-item-editable\': !vm.disableEditVehicleDetails}\">\n<label>Total km:</label><input ng-class=\"{\'border-bottom\': !vm.disableEditVehicleDetails}\" ng-model=\"vm.vehicle.km\" \ntype=\"text\" ng-disabled=\"vm.disableEditVehicleDetails\"></div><div flex=\"noshrink\" \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\"><label>Connectivity Provider:</label><p>\n{{vm.vehicle.deviceTypeHuman}}</p></div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" layout=\"row\" \nlayout-align=\"start center\"><label>Device:</label><p \nng-show=\"vm.vehicle.core_board == null && vm.vehicle.deviceType == vm.deviceType.PERSONAL.value\">No device associated\n</p><p ng-show=\"vm.vehicle.core_board != null && vm.vehicle.deviceType == vm.deviceType.PERSONAL.value\">ID: <a \nclass=\"userLink\" ng-click=\"vm.goToDevicesList(vm.vehicle.core_board)\">{{vm.vehicle.core_board.id}}</a>\n, Name: {{vm.vehicle.core_board.code}}</p><p ng-show=\"vm.vehicle.deviceType != vm.deviceType.PERSONAL.value\">\nID: {{vm.vehicle.deviceId}}</p></div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" layout=\"row\" \nlayout-align=\"start center\"><label>Last GPS Update:</label><p>\n{{vm.vehicle.fixtaken | toDate:\"dateTime\":vm.vehicle.SiteId}}</p></div><div flex=\"noshrink\" \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\" layout-align=\"start center\"><label>Street:</label><p>\n{{vm.vehicle.address}}</p></div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" layout=\"row\" \nlayout-align=\"start center\"><label>Last Moved:</label><p>\n{{vm.vehicle.bookings[0] ? (vm.vehicle.bookings[0].updated_at | toDate:\"dateTime\":vm.vehicle.SiteId) : \"Never moved\"}}\n</p></div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" layout=\"row\" layout-align=\"start center\">\n<label>{{vm.checkBookingStatusAndGetDescription(vm.vehicle)}}</label><p>\n{{vm.hasVehicleACurrentBooking(vm.vehicle) ? vm.vehicle.currentUser : vm.vehicle.lastUser}}</p></div><div \nflex=\"noshrink\" class=\"vehicle-list-item border-bottom\" layout=\"row\" layout-align=\"start center\" \nstyle=\"padding:6px 16px\"><label>Registration Date:</label><md-datepicker ng-model=\"vm.vehicle.registration_date\" \nms-datepicker-fix md-open-on-focus md-max-date=\"vm.todayDate\" ng-disabled=\"vm.disableEditVehicleDetails\">\n</md-datepicker></div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" layout=\"row\" \nlayout-align=\"start center\"><label>Creation Date:</label><p>\n{{vm.vehicle.bookings[0] ? (vm.vehicle.bookings[0].created_at | toDate:\"dateTime\":vm.vehicle.SiteId) : \"Not Present\"}}\n</p></div><div ng-show=\"vm.isServiceMultisite\" flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" \nlayout=\"row\" layout-align=\"start center\" style=\"height: 58px\"><label>City</label><md-select \nng-model=\"vm.vehicle.SiteId\" style=\"margin: 0px\" ng-disabled=\"vm.disableEditVehicleDetails\" aria-label=\"choose site\">\n<md-option ng-repeat=\"site in vm.sites | filter:{id:\'!-1\'}\" ng-value=\"site.id\">{{site.name}}</md-option></md-select>\n</div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" layout=\"row\" layout-align=\"start center\" \nng-class=\"{\'vehicle-list-item-editable\': !vm.disableEditVehicleDetails}\"><label>Brand:</label><input \nng-class=\"{\'border-bottom\': !vm.disableEditVehicleDetails}\" ng-model=\"vm.vehicle.brand\" type=\"text\" \nng-disabled=\"vm.disableEditVehicleDetails\"></div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" \nlayout=\"row\" layout-align=\"start center\" ng-class=\"{\'vehicle-list-item-editable\': !vm.disableEditVehicleDetails}\">\n<label>Model Name:</label><input ng-class=\"{\'border-bottom\': !vm.disableEditVehicleDetails}\" \nng-model=\"vm.vehicle.model_name\" type=\"text\" ng-disabled=\"vm.disableEditVehicleDetails\"></div><div flex=\"noshrink\" \nclass=\"vehicle-list-item border-bottom p-16\" layout=\"row\" layout-align=\"start center\" \nng-class=\"{\'vehicle-list-item-editable\': !vm.disableEditVehicleDetails}\"><label>Version:</label><input \nng-class=\"{\'border-bottom\': !vm.disableEditVehicleDetails}\" ng-model=\"vm.vehicle.version\" type=\"text\" \nng-disabled=\"vm.disableEditVehicleDetails\"></div><div flex=\"noshrink\" class=\"vehicle-list-item border-bottom p-16\" \nlayout=\"row\" layout-align=\"start center\"><label>Status:</label><p>{{vm.vehicle.status}}</p></div></div></div><div flex \nclass=\"vehicle-details-widget vehicle-details-widget-list white-bg md-whiteframe-4dp roundCornersSmaller\" \nlayout=\"column\"><div class=\"h3 vehicle-details-widget-title-container\"><div class=\"vehicle-details-widget-title\"><p>\nVehicle Trips</p><p class=\"subtitle\">Total: {{ vm.totalVehicleTrips }}</p></div><md-button \nclass=\"md-icon-button export-csv-button\" ng-click=\"vm.exportTripsListAsCSV()\" aria-label=\"Export as CSV\" \ntranslate-attr-aria-label=\"VEHICLE.EXPORT_AS_CSV\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span \ntranslate=\"VEHICLE.EXPORT_AS_CSV\">Export As CSV</span></md-tooltip></md-button></div><md-divider></md-divider><div \nflex class=\"vehicle-details-widget-item trip-list-widget\" layout=\"column\"><div \nstyle=\"margin-top:8px;text-align:center\" ng-show=\"vm.vehicle.trips.length == 0\">No trips found</div><div \nclass=\"trip-list-wrapper\" flex ng-if=\"vm.vehicle.trips.length>0\" layout=\"column\"><div \nclass=\"vehicle-list-item trip-list-item border-bottom\" ng-repeat=\"trip in vm.vehicle.trips\" layout=\"column\"><div \nclass=\"vehicle-list-item-title\"><div layout=\"row\" flex=\"45\" flex-gt-sm=\"35\"><label>Trip ID:</label><a class=\"userLink\" \nui-sref=\"app.trip.details({tripId:trip.id})\">{{trip.id}}</a></div><div layout=\"row\" flex=\"45\" flex-gt-sm=\"35\" \nlayout-align=\"end center\"><label>User:</label><a class=\"userLink text-ellipsis\" \nui-sref=\"app.user.details({userId:trip.User.id})\">{{trip.User.fullName}}</a></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"20\" flex-gt-sm=\"15\" layout=\"column\" layout-align=\"center center\"><md-icon \nmd-svg-icon=\"assets/icons/icon-route.svg\"></md-icon></div><div flex layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between start\"><div flex=\"30\" layout=\"column\" hide-xs hide-sm><label>From:</label><p \nclass=\"text-ellipsis\">{{vm.getVehicleShortAddress(trip.StartPosition)}}</p></div><div flex=\"55\" flex-gt-sm=\"45\" \nlayout=\"column\" layout-align=\"start start\"><label>Start:</label><p>{{trip.start |toDate:\"dateTime\":trip.SiteId}}</p>\n</div><div flex=\"30\" flex-gt-sm=\"20\" layout=\"column\" layout-align=\"start start\"><label>Duration:</label><p flex>\n{{trip.FinishPosition ? trip.duration + \" min\" : \"Not Finished\"}}</p></div></div><div layout=\"row\" \nlayout-align=\"space-between start\"><div flex=\"30\" layout=\"column\" hide-xs hide-sm><label>To:</label><p \nclass=\"text-ellipsis\">{{vm.getVehicleShortAddress(trip.FinishPosition)}}</p></div><div flex=\"55\" flex-gt-sm=\"45\" \nlayout=\"column\" layout-align=\"start start\"><label>End:</label><p>{{trip.end |toDate:\"dateTime\":trip.SiteId}}</p></div>\n<div flex=\"30\" flex-gt-sm=\"20\" layout=\"column\" layout-align=\"start start\"><label>Cost:</label><p>\n{{trip.FinishPosition ? vm.getCurrencySymbol(trip.Booking.price, trip.SiteId) : \'N/A\'}}</p></div></div></div></div>\n</div></div><div ng-if=\"vm.vehicle.trips.length>0\" layout=\"row\" layout-align=\"space-around center\"><md-button \nclass=\"md-raised view-more-button\" ng-click=\"vm.goToTripsWithFilter()\" style=\"width: 100%\" aria-label=\"view more\">\nView more</md-button></div></div></div></div><md-tabs id=\"vehicle-details-tabs\" md-selected=\"vm.selectedTab\" \nmd-dynamic-height><md-tab md-on-select=\"vm.onTabSelect(0)\"><md-tab-label><span translate=\"VEHICLE.VEHICLE_POSITION\">\nVehicle Position</span></md-tab-label><md-tab-body><div flex layout=\"column\"><two-hire-vehicle-map \nvehicles=\"vm.vehicles\" on-refresh=\"vm.onVehiclesRefresh\" shown-geofence-vehicle-types=\"vm.geofenceVehicleTypes\" \nstyle=\"height:400px\"></two-hire-vehicle-map></div></md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabSelect(1)\">\n<md-tab-label><span translate=\"VEHICLE.VEHICLE_MANAGE\">Vehicle Manage</span></md-tab-label><md-tab-body><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-around start\"><div flex-gt-xs=\"50\" layout=\"column\" \nng-if=\"vm.vehicle.type == vm.vehicleTypes.CAR.value && vm.serviceName !== \'e-gap\'\"><two-hire-loading-button \nclass=\"action-button\" label=\"\'Start Car\'\" my-on-click=\"vm.startCarCommand()\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" label=\"\'Stop Car\'\" my-on-click=\"vm.stopCarCommand()\">\n</two-hire-loading-button><md-button class=\"md-raised action-button\" \nng-click=\"vm.showAdditionalButtons = !vm.showAdditionalButtons\" aria-label=\"show more\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\"></md-icon><md-tooltip><span>Show additional buttons</span></md-tooltip></md-button>\n</div><div flex-gt-xs=\"50\" layout=\"column\" \nng-if=\"vm.vehicle.type == vm.vehicleTypes.CAR.value && vm.serviceName == \'e-gap\'\"><two-hire-loading-button \nclass=\"action-button\" label=\"\'Unlock\'\" my-on-click=\"vm.unlockCommand()\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" label=\"\'ExtractData\'\" ng-show=\"vm.vehicle.core_board\" \nmy-on-click=\"vm.extractData(vm.vehicle.core_board.id)\"></two-hire-loading-button><two-hire-loading-button \nng-repeat=\"additionalAction in vm.vehicleAdditionalActions\" class=\"action-button\" \nlabel=\"additionalAction.completeName\" \nmy-on-click=\"vm.executeVehicleAdditionalAction(additionalAction.name,additionalAction.action)\">\n</two-hire-loading-button><two-hire-loading-button class=\"action-button\" label=\"\'Lock\'\" my-on-click=\"vm.lockCommand()\">\n</two-hire-loading-button></div><div flex layout=\"column\" class=\"button-container-right\" \nng-if=\"vm.vehicle.type == vm.vehicleTypes.CAR.value && vm.showAdditionalButtons\"><p \nclass=\"md-title text-center button-container-right-text\" ng-click=\"vm.triggerEasterEgg()\">Additional buttons</p><div \nlayout=\"column\" ng-show=\"vm.showEasterEgg\"><two-hire-loading-button class=\"action-button\" label=\"\'Start Trip\'\" \nmy-on-click=\"vm.startTrip()\"></two-hire-loading-button><two-hire-loading-button class=\"action-button\" \nlabel=\"\'Stop Trip\'\" my-on-click=\"vm.stopTrip()\"></two-hire-loading-button></div><two-hire-loading-button \nclass=\"action-button\" label=\"\'Leave\'\" my-on-click=\"vm.leaveCommand()\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" ng-show=\"vm.vehicle.status == vm.vehicleStatus.FREE.value\" \nlabel=\"\'Make unavailable\'\" my-on-click=\"vm.toggleVehicleAvailability($event)\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" ng-show=\"vm.vehicle.status == vm.vehicleStatus.UNAVAILABLE.value\" \nlabel=\"\'Make available\'\" my-on-click=\"vm.toggleVehicleAvailability($event)\"></two-hire-loading-button>\n<two-hire-loading-button ng-repeat=\"additionalAction in vm.vehicleAdditionalActions\" class=\"action-button\" \nlabel=\"additionalAction.completeName\" \nmy-on-click=\"vm.executeVehicleAdditionalAction(additionalAction.name,additionalAction.action)\">\n</two-hire-loading-button></div><div flex-gt-xs=\"50\" layout=\"column\" \nng-if=\"vm.vehicle.type == vm.vehicleTypes.SCOOTER.value\"><two-hire-loading-button class=\"action-button\" \nlabel=\"\'Start Scooter\'\" my-on-click=\"vm.startScooterCommand()\"></two-hire-loading-button><two-hire-loading-button \nclass=\"action-button\" label=\"\'Stop Scooter\'\" my-on-click=\"vm.stopScooterCommand()\"></two-hire-loading-button><md-button\n class=\"md-raised action-button\" ng-click=\"vm.showAdditionalButtons = !vm.showAdditionalButtons\" \naria-label=\"show more\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon><md-tooltip><span>Show additional buttons\n</span></md-tooltip></md-button></div><div flex layout=\"column\" class=\"button-container-right\" \nng-if=\"vm.vehicle.type == vm.vehicleTypes.SCOOTER.value && vm.showAdditionalButtons\"><p \nclass=\"md-title text-center button-container-right-text\" ng-click=\"vm.triggerEasterEgg()\">Additional buttons</p><div \nlayout=\"column\" ng-show=\"vm.showEasterEgg\"><two-hire-loading-button class=\"action-button\" label=\"\'Start Trip\'\" \nmy-on-click=\"vm.startTrip()\"></two-hire-loading-button><two-hire-loading-button class=\"action-button\" \nlabel=\"\'Stop Trip\'\" my-on-click=\"vm.stopTrip()\"></two-hire-loading-button></div><two-hire-loading-button \nclass=\"action-button\" label=\"\'ON Engine\'\" my-on-click=\"vm.onCommand()\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" label=\"\'OFF Engine\'\" my-on-click=\"vm.offCommand()\">\n</two-hire-loading-button><two-hire-loading-button class=\"action-button\" label=\"\'Locate\'\" \nmy-on-click=\"vm.locateScooterCommand()\"></two-hire-loading-button><two-hire-loading-button class=\"action-button\" \nng-if=\"vm.vehicle.deviceType == vm.deviceType.NIU.value\" label=\"\'Open Saddle\'\" my-on-click=\"vm.openSaddleCommand()\">\n</two-hire-loading-button><two-hire-loading-button class=\"action-button\" label=\"\'Open Trunk\'\" \nmy-on-click=\"vm.openTrunkCommand()\"></two-hire-loading-button><two-hire-loading-button class=\"action-button\" \nlabel=\"\'Close Trunk\'\" my-on-click=\"vm.closeTrunkCommand()\"></two-hire-loading-button><two-hire-loading-button \nclass=\"action-button\" label=\"\'Leave\'\" my-on-click=\"vm.leaveCommand()\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" ng-show=\"vm.vehicle.status == vm.vehicleStatus.FREE.value\" \nlabel=\"\'Make unavailable\'\" my-on-click=\"vm.toggleVehicleAvailability($event)\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" ng-show=\"vm.vehicle.status == vm.vehicleStatus.UNAVAILABLE.value\" \nlabel=\"\'Make available\'\" my-on-click=\"vm.toggleVehicleAvailability($event)\"></two-hire-loading-button>\n<two-hire-loading-button ng-repeat=\"additionalAction in vm.vehicleAdditionalActions\" class=\"action-button\" \nlabel=\"additionalAction.completeName\" \nmy-on-click=\"vm.executeVehicleAdditionalAction(additionalAction.name,additionalAction.action)\">\n</two-hire-loading-button></div><div flex-gt-xs=\"50\" layout=\"column\" \nng-if=\"vm.vehicle.type == vm.vehicleTypes.KICK_SCOOTER.value\"><two-hire-loading-button class=\"action-button\" \nlabel=\"\'Start Kick\'\" my-on-click=\"vm.startKickCommand()\"></two-hire-loading-button><two-hire-loading-button \nclass=\"action-button\" label=\"\'Stop Kick\'\" my-on-click=\"vm.stopKickCommand()\"></two-hire-loading-button><md-button \nclass=\"md-raised action-button\" ng-click=\"vm.showAdditionalButtons = !vm.showAdditionalButtons\" aria-label=\"show more\">\n<md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon><md-tooltip><span>Show additional buttons</span></md-tooltip>\n</md-button></div><div flex layout=\"column\" class=\"button-container-right\" \nng-if=\"vm.vehicle.type == vm.vehicleTypes.KICK_SCOOTER.value && vm.showAdditionalButtons\"><p \nclass=\"md-title text-center button-container-right-text\">Additional buttons</p><two-hire-loading-button \nclass=\"action-button\" label=\"\'ON Engine\'\" my-on-click=\"vm.onKickCommand()\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" label=\"\'OFF Engine\'\" my-on-click=\"vm.offKickCommand()\">\n</two-hire-loading-button><two-hire-loading-button class=\"action-button\" label=\"\'Leave\'\" \nmy-on-click=\"vm.leaveCommand()\"></two-hire-loading-button><two-hire-loading-button class=\"action-button\" \nlabel=\"\'Locate\'\" my-on-click=\"vm.locateKickCommand()\"></two-hire-loading-button><two-hire-loading-button \nclass=\"action-button\" label=\"\'Unlock Battery Compartment\'\" my-on-click=\"vm.unlockKickBatteryCompartmentCommand()\">\n</two-hire-loading-button><two-hire-loading-button class=\"action-button\" label=\"\'Unlock Cable Lock\'\" \nmy-on-click=\"vm.unlockKickCableLockCommand()\"></two-hire-loading-button><two-hire-loading-button class=\"action-button\" \nng-show=\"vm.vehicle.deviceType == vm.deviceType.SEGWAY.value\" label=\"\'Enable Alarm\'\" \nmy-on-click=\"vm.enableAlarmSegwayKickCommand()\"></two-hire-loading-button><two-hire-loading-button \nclass=\"action-button\" ng-show=\"vm.vehicle.deviceType == vm.deviceType.SEGWAY.value\" label=\"\'Disable Alarm\'\" \nmy-on-click=\"vm.disableAlarmSegwayKickCommand()\"></two-hire-loading-button><two-hire-loading-button \nclass=\"action-button\" ng-show=\"vm.vehicle.status == vm.vehicleStatus.FREE.value\" label=\"\'Make unavailable\'\" \nmy-on-click=\"vm.toggleVehicleAvailability($event)\"></two-hire-loading-button><two-hire-loading-button \nclass=\"action-button\" ng-show=\"vm.vehicle.status == vm.vehicleStatus.UNAVAILABLE.value\" label=\"\'Make available\'\" \nmy-on-click=\"vm.toggleVehicleAvailability($event)\"></two-hire-loading-button></div><div flex-gt-xs=\"50\" \nlayout=\"column\" ng-if=\"vm.vehicle.type == vm.vehicleTypes.BIKE.value\"><two-hire-loading-button class=\"action-button\" \nlabel=\"\'Start Bike\'\" my-on-click=\"vm.startBikeCommand()\"></two-hire-loading-button><two-hire-loading-button \nclass=\"action-button\" label=\"\'Stop Bike\'\" my-on-click=\"vm.stopBikeCommand()\"></two-hire-loading-button><md-button \nclass=\"md-raised action-button\" ng-click=\"vm.showAdditionalButtons = !vm.showAdditionalButtons\" aria-label=\"show more\">\n<md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon><md-tooltip><span>Show additional buttons</span></md-tooltip>\n</md-button></div><div flex layout=\"column\" class=\"button-container-right\" \nng-if=\"vm.vehicle.type == vm.vehicleTypes.BIKE.value && vm.showAdditionalButtons\"><p \nclass=\"md-title text-center button-container-right-text\" ng-click=\"vm.triggerEasterEgg()\">Additional buttons</p><div \nlayout=\"column\" ng-show=\"vm.showEasterEgg\"><two-hire-loading-button class=\"action-button\" label=\"\'Start Trip\'\" \nmy-on-click=\"vm.startTrip()\"></two-hire-loading-button><two-hire-loading-button class=\"action-button\" \nlabel=\"\'Stop Trip\'\" my-on-click=\"vm.stopTrip()\"></two-hire-loading-button></div><two-hire-loading-button \nclass=\"action-button\" label=\"\'Unlock Bike\'\" my-on-click=\"vm.unlockCommand()\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" label=\"\'Lock Bike\'\" my-on-click=\"vm.lockCommand()\">\n</two-hire-loading-button><two-hire-loading-button class=\"action-button\" label=\"\'Enable Bike Lock\'\" \nmy-on-click=\"vm.enableBikeLock()\"></two-hire-loading-button><two-hire-loading-button class=\"action-button\" \nlabel=\"\'Leave Bike\'\" my-on-click=\"vm.leaveCommand()\"></two-hire-loading-button><two-hire-loading-button \nclass=\"action-button\" label=\"\'Locate\'\" my-on-click=\"vm.locateBikeCommand()\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" ng-show=\"vm.vehicle.status == vm.vehicleStatus.FREE.value\" \nlabel=\"\'Make unavailable\'\" my-on-click=\"vm.toggleVehicleAvailability($event)\"></two-hire-loading-button>\n<two-hire-loading-button class=\"action-button\" ng-show=\"vm.vehicle.status == vm.vehicleStatus.UNAVAILABLE.value\" \nlabel=\"\'Make available\'\" my-on-click=\"vm.toggleVehicleAvailability($event)\"></two-hire-loading-button>\n<two-hire-loading-button ng-repeat=\"additionalAction in vm.vehicleAdditionalActions\" class=\"action-button\" \nlabel=\"additionalAction.completeName\" \nmy-on-click=\"vm.executeVehicleAdditionalAction(additionalAction.name,additionalAction.action)\">\n</two-hire-loading-button></div></div></md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabSelect(2)\"><md-tab-label>\n<span translate=\"VEHICLE.VEHICLE_DOCUMENTS\">Vehicle Documents</span></md-tab-label><md-tab-body><div \nclass=\"md-padding\" flow-init=\"vm.ngFlowDocumentFileOptions\" flow-name=\"vm.ngFlowDocumentFile.flow\" \nflow-files-added=\"vm.documentFilesAdded($files)\" flow-files-submitted=\"vm.documentFilesSubmitted()\" \nflow-file-success=\"vm.documentFileSuccess($file,$message)\" flow-file-error=\"vm.documentFileError($file,$message)\" \nflow-complete=\"vm.documentFileUploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping = true\" \nflow-drag-leave=\"vm.dropping = false\" ng-class=\"{\'dropping\': vm.dropping}\"><div class=\"drop-text\" layout=\"row\" \nlayout-align=\"center center\"><span translate=\"VEHICLE.DRAG_TO_UPLOAD\">Drag to upload</span></div><div layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" flow-btn flow-drop translate=\"VEHICLE.SELECT\" \naria-label=\"select document\">Select</md-button><span class=\"secondary-text mt-8\">\nYou can also drop documents here to upload. PDF, PNG, JPG - Max. 20MB</span></div><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" style=\"width: 80%\" \nng-repeat=\"flowFile in vm.ngFlowDocumentFile.flow.files\"><img ng-show=\"flowFile.file.type!=\'application/pdf\'\" \nclass=\"current-vehicle-image\" flow-img=\"flowFile\"><md-icon ng-show=\"flowFile.file.type==\'application/pdf\'\" \nclass=\"current-pdf-image\" md-font-icon=\"icon-file-pdf\"></md-icon><md-input-container class=\"md-block\" \nstyle=\"height: 58px;width: 100%\"><label translate=\"VEHICLE.DOCUMENT_TYPE\">Document Type</label><md-icon \nmd-font-icon=\"icon-doc\"></md-icon><md-select ng-model=\"flowFile.vehicleDocumentType\" required><md-option \nng-repeat=\"documentType in vm.vehicleDocumentTypes\" ng-value=\"documentType.value\">{{documentType.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" style=\"width: 100%\"><label \ntranslate=\"VEHICLE.DOCUMENT_DESCRIPTION\">Document Description</label><md-icon md-font-icon=\"icon-doc\"></md-icon><input \nng-model=\"flowFile.vehicleDocumentDescription\" type=\"text\" required></md-input-container></div><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.showProgress\" style=\"width:100%\"><md-progress-linear class=\"mt-16 md-accent\" \nmd-mode=\"determinate\" value=\"{{vm.ngFlowDocumentFile.flow.progress() * 100}}\"></md-progress-linear><span \nclass=\"secondary-text mt-8 mb-16\">{{vm.uploadStatus}}</span></div><div layout=\"row\" layout-align=\"center center\" \nng-show=\"vm.ngFlowDocumentFile.flow.files[0]\"><md-button class=\"md-raised md-accent\" translate=\"VEHICLE.UPLOAD\" \nng-click=\"vm.uploadDocumentFiles()\" aria-label=\"upload\">Upload</md-button></div></div></div><div layout=\"column\"><div \nflex layout-align=\"space-between start\" ng-repeat=\"document in vm.vehicle.documents\"><div flex \nclass=\"md-whiteframe-4dp roundCornersSmaller p-16\" layout=\"row\" style=\"margin-bottom: 6px\"><div flex layout=\"column\">\n<div layout=\"row\"><md-input-container class=\"md-block\" style=\"width: 100%\"><label>Name</label><input \nng-model=\"document.name\" ng-disabled=\"true\" style=\"color:rgba(0, 0, 0, 0.87)\"></md-input-container><md-input-container \nclass=\"md-block\" style=\"height: 58px;width: 100%\"><label translate=\"VEHICLE.DOCUMENT_TYPE\">Document Type</label>\n<md-select ng-model=\"document.type\"><md-option ng-repeat=\"documentType in vm.vehicleDocumentTypes\" \nng-value=\"documentType.value\">{{documentType.name}}</md-option></md-select></md-input-container></div>\n<md-input-container class=\"md-block\" style=\"width: 100%\"><label translate=\"VEHICLE.DOCUMENT_DESCRIPTION\">\nDocument Description</label><input ng-model=\"document.description\" type=\"text\"></md-input-container></div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"vm.selectVehicleDocument($mdOpenMenu,document)\" style=\"margin: 0px\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.openDocument(document)\" aria-label=\"open\">Open</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.modifyVehicleDocument(document)\" aria-label=\"SAVE\" \ntranslate=\"VEHICLE.SAVE_CHANGES\">Save Changes</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.callDeleteVehicleDocumentDialog(document,$index,$event)\" aria-label=\"delete\" translate=\"VEHICLE.DELETE\">\nDelete</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></md-tab-body></md-tab><md-tab \nmd-on-select=\"vm.onTabSelect(3)\"><md-tab-label><span translate=\"VEHICLE.VEHICLE_IMAGES\">Vehicle Images</span>\n</md-tab-label><md-tab-body><div class=\"md-padding\" flow-init=\"vm.ngFlowImageFileOptions\" \nflow-name=\"vm.ngFlowImageFile.flow\" flow-files-added=\"vm.imageFilesAdded($files)\" \nflow-files-submitted=\"vm.imageFilesSubmitted()\" flow-file-success=\"vm.imageFileSuccess($file,$message)\" \nflow-file-error=\"vm.imageFileError($file,$message)\" flow-complete=\"vm.imageFileUploadComplete()\" flow-drop \nflow-drag-enter=\"vm.dropping = true\" flow-drag-leave=\"vm.dropping = false\" ng-class=\"{\'dropping\': vm.dropping}\"><div \nclass=\"drop-text\" layout=\"row\" layout-align=\"center center\"><span translate=\"VEHICLE.DRAG_TO_UPLOAD\">Drag to upload\n</span></div><div layout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" flow-btn \nflow-drop translate=\"{{vm.vehicle.images.length>0 ? \'VEHICLE.CHANGE\' : \'VEHICLE.UPLOAD\'}}\" aria-label=\"upload image\">\n</md-button><span class=\"secondary-text mt-8\">You can also drop images here to upload. Only PNG, JPG - Max. 20MB</span>\n</div><div layout=\"column\" layout-align=\"center center\"><md-progress-linear class=\"mt-64 md-accent\" \nng-show=\"vm.ngFlowImageFile.flow.files[0]\" md-mode=\"determinate\" value=\"{{vm.ngFlowImageFile.flow.progress() * 100}}\">\n</md-progress-linear><span class=\"secondary-text mt-8\" ng-show=\"vm.ngFlowImageFile.flow.files[0]\">{{vm.uploadStatus}}\n</span> <img class=\"current-vehicle-image\" flow-img=\"flowFile\" ng-repeat=\"flowFile in vm.ngFlowImageFile.flow.files\">\n</div></div><div layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"space-between start\" \nng-repeat=\"image in vm.vehicle.images\"><img class=\"vehicle-image\" ng-src=\"{{image.location}}\"><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.deleteVehicleImage(image.id,$index)\" \naria-label=\"delete\" translate=\"VEHICLE.DELETE\">Delete</md-button></md-menu-item></md-menu-content></md-menu></div>\n</div></md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabSelect(4)\"><md-tab-label><span>Vehicle Status Log</span>\n</md-tab-label><md-tab-body><div layout=\"column\"><div class=\"vehiclesStatusLogsTableContainer\"><div \nclass=\"vehicleStatusLogsFilterContainer\"><div layout=\"row\"><md-input-container flex style=\"margin:0px\" layout=\"row\" \nlayout-align=\"start center\"><label style=\"left: 52px\">Start Date</label><md-datepicker ng-model=\"vm.logFilter.start\" \nmd-max-date=\"vm.todayDate\"></md-datepicker></md-input-container><md-input-container flex style=\"margin:0px\" \nlayout=\"row\" layout-align=\"start center\"><label style=\"left: 52px\">End Date</label><md-datepicker \nng-model=\"vm.logFilter.end\" md-min-date=\"vm.logFilter.start\" md-max-date=\"vm.todayDate\"></md-datepicker>\n</md-input-container><md-button class=\"md-fab md-accent md-icon-button\" ng-click=\"vm.applyUpdateDataTable()\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon></md-button></div></div><paginated-table headers=\"vm.vehicleStatusTableFields\" \ndata=\"vm.vehicleStatusLogs\" update-data=\"vm.getTimeRangeVehicleStatusLogs\" apply-update-data=\"vm.applyUpdateDataTable\" \nhide-update-data=\"true\" call-update-data-on-init=\"false\" class=\"vehicleStatusLogTable\"></paginated-table></div></div>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabSelect(5)\"><md-tab-label><span>Vehicle Damages\' Reports</span>\n</md-tab-label><md-tab-body><div layout=\"column\" style=\"height: 500px\"><div class=\"damage-report-tab-container\" \nng-if=\"vm.vehicleDamagesReports.length==0\"><div style=\"text-align: center;font-size: 14px\">\nNo damages\' reports for this vehicle</div></div><paginated-table headers=\"vm.vehicleDamageReportsFields\" \ndata=\"vm.vehicleDamagesReports\" update-data=\"vm.updateTableDamagesData\" apply-update-data=\"vm.applyUpdateData\" \ncall-update-data-on-init=\"false\" class=\"vehicleDamagesReportsTable\" ng-hide=\"vm.vehicleDamagesReports.length==0\">\n</paginated-table></div></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/vehicle/dialogs/vehicle-add-dialog.html","<md-dialog class=\"vehicle-add-dialog\" aria-label=\"Add New Vehicle\"><form name=\"addVehicleForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"VEHICLE.ADD_VEHICLE\">Add Vehicle</span>\n<md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"VEHICLE.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content flex layout=\"column\" ng-hide=\"isBulkActive\"><div \nclass=\"uploadButtonContainer\"><label for=\"id_vehicles_csv\">Upload CSV</label><input type=\"file\" id=\"id_vehicles_csv\" \nname=\"id_vehicles_csv\" accept=\".csv, .txt\"></div><div class=\"inputSeparator\" layout=\"row\" layout-align=\"center center\">\n<div class=\"textOnInputSeparator\">Or</div></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><p flex \nstyle=\"margin:0px\">{{!isBulkInsertion ? \'Choose how many vehicles you want to add\' : \'Remains\'}}</p><span flex=\"5\" \nhide-xs hide-sm></span><md-input-container flex class=\"md-block md-icon-float flex-gt-sm-30\" style=\"margin:0px\"><label>\nNumber</label><input ng-model=\"nOfInsertions\" type=\"number\"></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-input-container class=\"md-block flex-gt-sm-20\" style=\"height: 58px\"><label \ntranslate=\"VEHICLE.TYPE\">Type</label><md-select ng-model=\"vehicle.type\" required><md-option \nng-repeat=\"vehicleType in vehicleTypes\" ng-value=\"vehicleType.value\">{{vehicleType.name}}</md-option></md-select>\n</md-input-container><span flex=\"5\" hide-xs hide-sm></span><md-input-container flex \nclass=\"md-block md-icon-float flex-gt-sm-30\"><label translate=\"VEHICLE.REF_CODE\">Ref. Code</label><input \nng-model=\"vehicle.reference_code\" type=\"text\" ng-required=\"true\"></md-input-container><span flex=\"5\" hide-xs hide-sm>\n</span><md-input-container flex class=\"md-block md-icon-float\"><label translate=\"VEHICLE.LICENSE_PLATE\">License plate\n</label><input ng-model=\"vehicle.license_plate\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container class=\"md-block flex-gt-sm-20\"><label \ntranslate=\"VEHICLE.BRAND\">Brand</label><input ng-model=\"vehicle.brand\" type=\"text\" ng-pattern=\"/^[(a-z|A-Z)]*$/\" \nrequired></md-input-container><span flex=\"5\" hide-xs hide-sm></span><md-input-container class=\"md-block\" flex><label \ntranslate=\"VEHICLE.MODEL\">Model</label><input ng-model=\"vehicle.model_name\" type=\"text\" required></md-input-container>\n<span flex=\"5\" hide-xs hide-sm></span><md-input-container class=\"md-block\" flex><label translate=\"VEHICLE.VERSION\">\nVersion</label><input ng-model=\"vehicle.version\" type=\"text\" required></md-input-container><span flex=\"5\" hide-xs \nhide-sm></span><md-input-container class=\"md-block flex-gt-sm-30\"><label translate=\"VEHICLE.CYLINDER_CAPACITY\">\nCylinder Capacity</label><input ng-model=\"vehicle.cylinder_capacity\" type=\"text\" ng-pattern=\"/^[0-9]*$/\" required>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container \nclass=\"md-block flex-gt-sm-20\" style=\"height: 58px\"><label>Device Provider</label><md-select \nng-model=\"vehicle.deviceType\" required><md-option ng-repeat=\"type in deviceType\" ng-value=\"type.value\">{{type.name}}\n</md-option></md-select></md-input-container><span flex=\"5\" hide-xs hide-sm></span><md-input-container \nclass=\"flex-gt-sm-20\" ng-if=\"!vehicle.deviceType == deviceType.PERSONAL.value\"><label>Device ID</label><input \nng-model=\"vehicle.deviceId\" type=\"text\" required></md-input-container><span flex=\"5\" \nng-if=\"!vehicle.deviceType == deviceType.PERSONAL.value\" hide-xs hide-sm></span><md-input-container \nclass=\"flex-gt-sm-20\"><label translate=\"VEHICLE.BATTERY_CODE\">Battery Code</label><input \nng-model=\"vehicle.battery.code\" type=\"text\" required></md-input-container><span flex=\"5\" hide-xs hide-sm></span>\n<md-input-container class=\"flex-gt-sm-20\"><label translate=\"VEHICLE.BATTERY_TOTAL_AMPERE\">Battery Total Ampere</label>\n<input ng-model=\"vehicle.battery.ah_tot\" type=\"text\" ng-pattern=\"/^[0-9]*$/\" required></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-datepicker md-placeholder=\"Registration Date\" ms-datepicker-fix \nng-model=\"vehicle.registration_date\" md-open-on-focus md-max-date=\"todayDate\" required></md-datepicker><span hide-xs \nhide-sm style=\"min-width: 11%\"></span><md-input-container flex><label translate=\"VEHICLE.CURRENT_KM\">Current KM</label>\n<input ng-model=\"vehicle.km\" type=\"text\" ng-pattern=\"/^[0-9]*$/\"></md-input-container><span flex=\"5\" hide-xs hide-sm>\n</span><md-input-container flex class=\"md-block flex-gt-sm-20\" style=\"height: 58px\" ng-show=\"isServiceMultisite\"><label\n translate=\"VEHICLE.CITY\">CITY</label><md-select ng-model=\"vehicle.SiteId\" required><md-option \nng-repeat=\"site in sites | filter:{id:\'!-1\'}\" ng-value=\"site.id\">{{site.name}}</md-option></md-select>\n</md-input-container></div></md-content><md-content flex layout=\"column\" ng-show=\"isBulkActive\"><div layout=\"row\" \nng-show=\"totalUploadedFileRows !== null\">\nTotal uploaded vehicles: {{ totalUploadedFileRows }} / {{ fileLines.length - (headingRowExists ? 1 : 0) }}</div><div \nlayout=\"row\" class=\"bulkProgressbarContainer\"><md-progress-linear class=\"bulkProgressbar\" md-mode=\"determinate\" \nng-value=\"loadingProgress\"></md-progress-linear></div><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\">Total file lines: {{ fileLines.length }}</div><div layout=\"column\"><md-checkbox \nng-model=\"headingRowExists\" ng-change=\"updateBulkKeysTable()\" aria-label=\"contains header?\">\nThe file contains a heading row</md-checkbox></div></div><div layout=\"column\"><div layout=\"row\" \nclass=\"optionsSelectWrapper\"><md-select id=\"bulk-{{$index}}\" class=\"optionsSelect\" \nng-repeat=\"(index,items) in bulkUploadKeys\" selected=\"{{ bulkUploadKeys[$index] }}\" ng-model=\"selectedKey[$index]\" \naria-label=\"choose\"><md-option ng-repeat=\"(inx,item) in bulkUploadKeys\" value=\"{{ item.key }}\" \nng-selected=\"index === item.index\" ng-click=\"updateBulkKeys(index, inx)\">{{ item.name }}</md-option></md-select></div>\n</div><div layout=\"row\"><generic-table headers=\"bulkUploadKeys\" data=\"bulkKeysTable\" class=\"updateVehicleBulkTable\" \ndownload-data=\"false\" show-last-update=\"false\"></generic-table></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"callAddVehicle()\" \nclass=\"send-button md-accent md-raised\" ng-hide=\"isBulkActive\" \nng-disabled=\"addVehicleForm.$invalid || addVehicleForm.$pristine\" aria-label=\"Add\" translate=\"VEHICLE.ADD\" \ntranslate-attr-aria-label=\"VEHICLE.ADD\">ADD</md-button><md-button type=\"button\" ng-click=\"callAddVehicle()\" \nclass=\"send-button md-accent md-raised\" ng-show=\"isBulkActive\" ng-disabled=\"!isBulkActive\" aria-label=\"Add\" \ntranslate=\"VEHICLE.ADD\" translate-attr-aria-label=\"VEHICLE.ADD\">ADD</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/vehicle/dialogs/vehicle-bulk-update-dialog.html","<md-dialog class=\"vehicle-bulk-update-dialog\" aria-label=\"Vehicles update\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Vehicles bulk update</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-content flex layout=\"column\"><div layout=\"column\" ng-show=\"showUploadVehicles\"><form \nname=\"vehicleBulkUpdateForm\"><md-input-container class=\"md-block selectorContainer\"><label>Select vehicle field</label>\n<md-select name=\"vehicleFieldFilter\" ng-model=\"selectedVehicleFieldFilter\" ng-change=\"onSetVehicleFieldFilter()\" \nrequired aria-label=\"selectVehicleFieldFilter\"><md-option ng-repeat=\"fieldFilter in availableVehicleFieldFilters\" \nng-value=\"fieldFilter\">{{fieldFilter.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vehicleBulkUpdateForm.vehicleFieldFilter.$error\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></form><div class=\"uploadButtonContainer marginTop\"><label for=\"id_update_vehicles_csv\">Upload CSV\n</label><input type=\"file\" id=\"id_update_vehicles_csv\" name=\"id_update_vehicles_csv\" accept=\".csv, .txt\" \nng-disabled=\"disableUploadVehicles\"></div><div class=\"inputSeparator marginTop\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"textOnInputSeparator\">Or</div></div><md-input-container \nclass=\"md-block marginTop\"><label>Fields list (separated by \',\')</label><input ng-model=\"vehiclesListString\" \nng-model-options=\"{\'debounce\':1500}\" ng-change=\"onVehiclesListStringChange()\" ng-disabled=\"disableUploadVehicles\">\n</md-input-container></div><div ng-show=\"selectedAction !== null\" style=\"margin-bottom: 8px\"><md-button \nclass=\"md-fab md-accent md-icon-button goBackButton\" ng-click=\"goBackToAvailableActions()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"totalVehiclesCountContainer\" layout=\"row\" \nlayout-align=\"start center\"><div><span class=\"totalVehiclesCount\">Total vehicles found:</span> <span \nng-show=\"!isDownloadingData\">{{vehicles.length}}</span></div><div layout=\"row\" ng-show=\"selectedAction == null\">\n<md-progress-circular class=\"md-accent\" ng-show=\"isDownloadingData\" md-mode=\"indeterminate\" md-diameter=\"24\">\n</md-progress-circular><md-icon ng-show=\"!isDownloadingData\" class=\"iconCount\" \nmd-font-icon=\"{{ downloadSuccess ? \'icon-check-circle\' : \'icon-close-circle-outline\'}}\"><md-tooltip>\nNot found: {{vehiclesNotFound}}</md-tooltip></md-icon></div></div><div layout=\"column\" ng-show=\"showAvailableActions\">\n<p class=\"title-details\" style=\"margin-bottom: 12px\">Available Actions:</p><md-radio-group class=\"md-primary\" \nng-model=\"selectedAction\"><md-radio-button ng-repeat=\"action in availableActions\" ng-value=\"action.value\" \nng-click=\"selectAction(action.value)\">{{action.name}}</md-radio-button></md-radio-group></div><div \nng-show=\"selectedAction !== null\" class=\"mt-10\" layout=\"column\"><md-progress-linear class=\"uploadProgressBar\" \nmd-mode=\"determinate\" ng-value=\"loadingProgress\"></md-progress-linear><div ng-show=\"errorsOccurred\" class=\"mt-10\" \nlayout=\"column\"><div layout=\"row\"><span class=\"errorVehiclesCount\">Total Vehicles with error:</span>\n {{vehiclesWithError.length}}</div><div layout=\"row\"><input flex type=\"text\" ng-model=\"vehiclesWithErrorListString\" \ndisabled=\"disabled\"></div></div><div><update-segway-settings ng-show=\"selectedAction == 0\" \non-update-click=\"executeActionOnVehicles(updateSegwayVehicle)\"></update-segway-settings><execute-vehicle-commands \nng-show=\"selectedAction == 1\" on-update-click=\"executeActionOnVehicles(executeCommandsOnVehicles)\">\n</execute-vehicle-commands></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/vehicle/dialogs/vehicle-test-action-dialog.html","<md-dialog class=\"vehicle-test-action-dialog\" aria-label=\"Vehicle test action\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Test this vehicle</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-content flex layout=\"column\"><p>{{step}}/{{commands.length}}</p><md-progress-linear \nmd-mode=\"determinate\" value=\"{{progressValue}}\"></md-progress-linear><p ng-show=\"isTesting\">Testing...</p></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"isTesting\"></md-progress-circular><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"my-success-icon\" ng-if=\"isTestPassed\"></md-icon><div flex layout=\"row\" \nng-if=\"isTestNotPassed\"><md-icon md-font-icon=\"icon-alert\" class=\"my-alert-icon\"></md-icon><p>{{errorLabel}}</p></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/vehicle/dialogs/vehicle-toot-gif-dialog.html","<md-dialog class=\"vehicle-toot-gif-dialog\" aria-label=\"Vehicle toot gif\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Noooooooot Noooooooot!!!</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-content flex layout=\"column\"><div \nstyle=\"width:100%;height:0;padding-bottom:76%;position:relative\"><img src=\"assets/images/noot.gif\" width=\"100%\" \nheight=\"100%\" style=\"position:absolute\" frameborder=\"0\" class=\"giphy-embed\" allowfullscreen></div></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/vehicle/maps/maps.html","<div id=\"maps\" class=\"page-layout simple inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"column\"><div flex \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-map-marker\"></md-icon><span>\nVehicles\' Map</span></div></div></div></div><div class=\"content\"><div class=\"card white-bg md-whiteframe-4dp\"><div \nclass=\"mapPageInfo\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\" layout-align-xs=\"center center\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"mapPageCount\"><md-tooltip>\nDisplayed {{vm.vehiclesViewed}} out of {{ vm.allVehiclesLength | number}}</md-tooltip><md-icon \nmd-font-icon=\"icon-pound\"></md-icon><span hide-xs>\n{{vm.vehiclesViewed !== \'...\' ? vm.vehiclesViewed + \' / \' : \'\'}}{{vm.allVehiclesLength}}</span></div></div><div \nlayout=\"column\" class=\"filtersContainerTopPageContainer\" flex=\"60\"><div class=\"filtersContainerTopPageWrapper\">\n<filter-row filters=\"vm.filters\" search-filters=\"vm.searchFilters\" update-data=\"vm.refreshVehicleMarkers\" \ncall-update-data-on-init=\"true\" apply-filters-trigger=\"vm.applyFiltersTrigger\" hide-static-filters=\"true\" \nallow-multi-filter=\"true\" class=\"filtersContainerTopPage\"></filter-row></div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\"><div class=\"mapPageRefreshIcon\"><md-icon ng-hide=\"vm.isDownloadingData\" \nmd-font-icon=\"icon-refresh\" aria-label=\"refresh\" ng-click=\"vm.refreshMap()\"></md-icon><md-progress-circular \nng-show=\"vm.isDownloadingData\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"30\" aria-label=\"loading\">\n</md-progress-circular><md-tooltip><span>{{ !vm.isDownloadingData ? \'Refresh\' : \'Loading\' }}</span></md-tooltip></div>\n</div></div><div class=\"mapContainer\"><two-hire-vehicle-map vehicles=\"vm.vehicles\" on-refresh=\"vm.onVehiclesRefresh\">\n</two-hire-vehicle-map></div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img \nsrc=\"assets/images/logos/2hire_monogram_white.svg\"> </span><span class=\"logo-text\">2hire Admin</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar>\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon class=\"icon status s16\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \naria-label=\"icon\"></md-icon></div><span class=\"username\" hide show-gt-sm>Admin</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div><md-menu md-offset=\"0 58\" \nmd-position-mode=\"target-right target\"><md-button md-no-ink class=\"language-button siteButton\" \nng-click=\"vm.getSitesTrigger($mdMenu)\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"iso\">{{vm.selectedSite}}</span></div></md-button><md-menu-content width=\"3\" \nid=\"language-menu-content\"><md-menu-item ng-repeat=\"site in vm.sites | filter: \'!\'+vm.selectedSite\"><md-button \nmd-no-ink ng-click=\"vm.selectSite(site)\" aria-label=\"site\"><span layout=\"row\" layout-align=\"start center\"><img \nclass=\"flag\"> <span>{{site.name}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"toolbar-separator\"></div><md-menu md-offset=\"0 12\" md-position-mode=\"left bottom\"><md-button \nclass=\"md-icon-button language-button\" ng-click=\"$mdMenu.open()\" aria-label=\"settings\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.callEnableAllVehicles($event)\"><md-button \nclass=\"toolbarEnableButton\" aria-label=\"callEnableAllVehicles\"><md-icon class=\"toolbarEnableButtonIcon greenBtn\" \nmd-font-icon=\"icon-check\"></md-icon><span layout=\"row\" layout-align=\"start center\"><span>Enable all vehicles</span>\n</span></md-button></div></md-menu-item><md-menu-item><div layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.callDisableAllVehicles($event)\"><md-button class=\"toolbarEnableButton\" \naria-label=\"callDisableAllVehicles\"><md-icon class=\"toolbarEnableButtonIcon redBtn\" md-font-icon=\"icon-block-helper\">\n</md-icon><span layout=\"row\" layout-align=\"start center\"><span>Disable all vehicles</span></span></md-button></div>\n</md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/bonus/shopItem/dialogs/shop-item-add-dialog.html","<md-dialog class=\"shop-item-add-dialog\" aria-label=\"Add New template\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Add Shop Item</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-content flex class=\"md-padding\" layout=\"column\"><form name=\"addShopItemForm\" \nclass=\"md-inline-form\" novalidate><div class=\"uploadButtonContainer\"><md-button \nclass=\"redirect-button md-accent md-raised\" ng-click=\"vm.goToTemplatesPage()\" aria-label=\"Create template link\">\nCreate Template</md-button></div><div class=\"inputSeparator\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"textOnInputSeparator\">Or</div></div><div><p class=\"title-details\">Select a template:</p><two-hire-autocomplete \noptions=\"vm.searchOptions\" set-result=\"vm.setTemplate\" selected-item=\"vm.template\"></two-hire-autocomplete></div><p \nclass=\"title-details\">Item info:</p><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container \nclass=\"md-block flex-gt-sm-20\" style=\"height: 58px\"><label>Site</label><md-select ng-model=\"vm.shopItem.SiteId\" \nng-disabled=\"vm.preventSiteChange\" required><md-option ng-repeat=\"site in vm.sites | filter: {id:\'!-1\'}\" \nng-value=\"site.id\">{{site.name}}</md-option></md-select></md-input-container><span flex=\"5\" hide-xs hide-sm></span>\n<md-input-container class=\"md-block flex-gt-sm-20\" flex><label>Price</label><input ng-model=\"vm.shopItem.price\" \ntype=\"number\" min=\"0\" required></md-input-container><span flex hide-xs hide-sm></span><md-input-container \nclass=\"flex-gt-sm-20\" flex><md-checkbox class=\"checkboxInput\" ng-model=\"vm.shopItem.userVisible\">Set on sale\n</md-checkbox></md-input-container></div><div layout=\"row\"><md-button type=\"submit\" ng-click=\"vm.callAddShopItem()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"addShopItemForm.$invalid || addShopItemForm.$pristine\" \naria-label=\"Add Shop Item\">ADD</md-button></div></form></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/bonus/template/dialogs/bonus-template-add-dialog.html","<md-dialog class=\"bonus-template-add-dialog\" aria-label=\"Add New template\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Add Template</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-content flex class=\"md-padding\" layout=\"column\"><form name=\"addVehicleForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container \nclass=\"md-block flex-gt-sm-20\" style=\"height: 58px\"><label>Type</label><md-select ng-model=\"vm.template.type\" required>\n<md-option ng-repeat=\"type in vm.bonusTemplateType\" ng-value=\"type.value\">{{type.name}}</md-option></md-select>\n</md-input-container><span flex=\"5\" hide-xs hide-sm></span><md-input-container flex \nclass=\"md-block md-icon-float flex\"><label>Description</label><input ng-model=\"vm.template.description\" type=\"text\" \nng-required=\"true\"></md-input-container></div><h1 class=\"md-title\">Validity Time constraint</h1><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-input-container class=\"md-block flex-gt-sm-20\" style=\"height: 58px\"><label>\nStart Date</label><md-select ng-model=\"vm.template.constraints.validityTime[0].type\" required><md-option \nng-repeat=\"type in vm.validityTimeType\" ng-value=\"type.value\">{{type.name}}</md-option></md-select>\n</md-input-container><span \nng-show=\"vm.template.constraints.validityTime[0].type !== vm.validityTimeType.UNBOUNDED.value\" flex=\"5\" hide-xs \nhide-sm></span><md-datepicker \nng-if=\"vm.template.constraints.validityTime[0].type === vm.validityTimeType.TIMESTAMP.value\" \nmd-placeholder=\"Select Date\" ms-datepicker-fix ng-model=\"vm.template.constraints.validityTime[0].date\" \nmd-open-on-focus md-min-date=\"vm.todayDate\" required></md-datepicker><md-input-container \nng-if=\"vm.template.constraints.validityTime[0].type === vm.validityTimeType.DURATION_FROM_ACQUISITION.value\" \nclass=\"flex-gt-sm-30\"><label>Duration (minutes)</label><input \nng-model=\"vm.template.constraints.validityTime[0].duration\" type=\"number\" min=\"0\" required></md-input-container><span \nflex=\"5\" hide-xs hide-sm></span><md-input-container class=\"md-block flex-gt-sm-20\" style=\"height: 58px\"><label>End Date\n</label><md-select ng-model=\"vm.template.constraints.validityTime[1].type\" required><md-option \nng-repeat=\"type in vm.validityTimeType\" ng-value=\"type.value\">{{type.name}}</md-option></md-select>\n</md-input-container><span flex=\"5\" hide-xs hide-sm></span><md-datepicker \nng-if=\"vm.template.constraints.validityTime[1].type === vm.validityTimeType.TIMESTAMP.value\" \nmd-placeholder=\"Select Date\" ms-datepicker-fix ng-model=\"vm.template.constraints.validityTime[1].date\" \nmd-open-on-focus \nmd-min-date=\"(vm.template.constraints.validityTime[1] && vm.template.constraints.validityTime[1].date || vm.todayDate)\" \nrequired></md-datepicker><md-input-container \nng-if=\"vm.template.constraints.validityTime[1].type === vm.validityTimeType.DURATION_FROM_ACQUISITION.value\" \nclass=\"flex-gt-sm-30\"><label>Duration (minutes)</label><input \nng-model=\"vm.template.constraints.validityTime[1].duration\" type=\"number\" min=\"0\" required></md-input-container></div>\n<div ng-show=\"vm.template.type === vm.bonusTemplateType.CREDIT.value\"><h1 class=\"md-title\">Usage limits</h1><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container class=\"md-block flex-gt-sm-20\"><label>Max trips\n</label><input ng-model=\"vm.template.limits.forValidity.count\" type=\"number\" min=\"0\"></md-input-container><span \nflex=\"5\" hide-xs hide-sm></span><md-input-container class=\"md-block flex-gt-sm-20\" flex><label>Max price</label><input \nng-model=\"vm.template.limits.forValidity.price\" type=\"number\" min=\"0\"></md-input-container></div></div><h1 \nclass=\"md-title\">Per Trip limits</h1><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container \nclass=\"md-block flex-gt-sm-20\"><label>Max price</label><input ng-model=\"vm.template.limits.perBooking.price\" \ntype=\"number\" min=\"0\"></md-input-container></div><div ng-show=\"vm.template.type === vm.bonusTemplateType.PASS.value\">\n<h1 class=\"md-title\">Per Time Window limits</h1><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\">\n<md-input-container class=\"md-block flex-gt-sm-30\"><label>Duration (minutes)</label><input \nng-model=\"vm.template.limits.perTimeWindow.window.duration\" type=\"number\" min=\"0\"></md-input-container><span flex=\"5\" \nhide-xs hide-sm></span><md-input-container class=\"md-block flex-gt-sm-20\"><label>Max trips</label><input \nng-model=\"vm.template.limits.perTimeWindow.limits.count\" type=\"number\" min=\"0\"></md-input-container><span flex=\"5\" \nhide-xs hide-sm></span><md-input-container class=\"md-block flex-gt-sm-20\"><label>Max price</label><input \nng-model=\"vm.template.limits.perTimeWindow.limits.price\" type=\"number\" min=\"0\"></md-input-container></div></div><h1 \nclass=\"md-title\">Validity Sites constraint</h1><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\">\n<md-input-container class=\"md-block flex-gt-sm-20\" style=\"height: 58px\"><label>Site ownership</label><md-select \nng-model=\"vm.template.SiteId\" ng-disabled=\"vm.preventSiteChange\" required><md-option \nng-repeat=\"site in vm.sites track by site.id\" ng-value=\"site.id\">{{site.name}}</md-option></md-select>\n</md-input-container><span flex=\"5\" hide-xs hide-sm></span><md-input-container flex class=\"md-block flex-gt-sm-20\" \nstyle=\"height: 58px\"><label>Validity Sites</label><md-select ng-model=\"vm.template.constraints.siteIds\" \nmultiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input id=\"template-constraint-site-search\" \nclass=\"demo-header-searchbox md-text\" ng-model=\"vm.searchSiteText\" type=\"search\" placeholder=\"Site filter\" \naria-label=\"Site filter\"></md-select-header><md-optgroup label=\"Site filter\"><md-option ng-value=\"site.id\" \nng-click=\"vm.onSiteChange(site)\" ng-repeat=\"site in vm.sites | filter: vm.searchSiteText track by site.id\">\n{{site.name}}</md-option></md-optgroup></md-select></md-input-container></div><div><md-checkbox \nng-show=\"!vm.showCreateCouponTemplate\" class=\"\" ng-model=\"vm.createShopItemSelected\">\nI\'d like to create a Shop Item after the Template creation</md-checkbox><md-checkbox \nng-show=\"vm.showCreateCouponTemplate\" class=\"\" ng-model=\"vm.createCouponTemplateSelected\">\nI\'d like to create a Campaign after the Template creation</md-checkbox></div><div layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"vm.callAddTemplate()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"addVehicleForm.$invalid || addVehicleForm.$pristine\" aria-label=\"Add template\">ADD</md-button></div>\n</form></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/catalog/category/dialogs/category-dialog.html","<md-dialog class=\"category-dialog\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \nng-if=\"vm.dialogType === \'add\'\" translate=\"CATEGORY.ADD_CATEGORY\">Add Category</span> <span class=\"title\" \nng-if=\"vm.dialogType === \'edit\'\" translate=\"CATEGORY.EDIT_CATEGORY\">Edit Category</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CATEGORY.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><form name=\"categoryForm\" class=\"md-inline-form\" novalidate>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"CATEGORY.NAME\">Name</label><input \nng-model=\"vm.category.name\" type=\"text\" ng-required=\"true\" md-autofocus></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CATEGORY.DESCRIPTION\">Description</label><input \nng-model=\"vm.category.description\" type=\"text\" ng-required=\"true\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CATEGORY.TOTAL_KM\">Total Km</label><input ng-model=\"vm.category.km\" \ntype=\"text\" ng-pattern=\"/^[0-9]*$/\" ng-required=\"true\"></md-input-container><md-input-container class=\"md-block\"><label\n translate=\"CATEGORY.TYPE\">Type</label><md-select ng-model=\"vm.category.type\"><md-option \nng-repeat=\"categoryType in vm.categoryTypes\" ng-value=\"categoryType.value\">{{categoryType.name}}</md-option>\n</md-select></md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-if=\"vm.dialogType === \'edit\'\" ng-click=\"vm.deleteCategoryConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CATEGORY.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CATEGORY.DELETE\">DELETE</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"vm.dialogType === \'edit\'\" class=\"send-button md-accent md-raised\" \nng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" aria-label=\"SAVE\" translate=\"CATEGORY.SAVE\" \ntranslate-attr-aria-label=\"CATEGORY.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.dialogType === \'add\'\" \nng-click=\"vm.addCategory()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" aria-label=\"Add Task\" translate=\"CATEGORY.ADD\" \ntranslate-attr-aria-label=\"CATEGORY.ADD\">ADD CONTACT</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/catalog/fare/dialogs/fare-dialog.html","<md-dialog class=\"fare-dialog\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \nng-if=\"vm.dialogType === \'add\'\" translate=\"FARE.ADD_FARE\">Add Fare</span> <span class=\"title\" \nng-if=\"vm.dialogType === \'edit\'\" translate=\"FARE.EDIT_FARE\">Edit Fare</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"FARE.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form name=\"fareForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"\"><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"FARE.NAME\">Name</label><md-icon md-font-icon=\"icon-timetable\"></md-icon><input ng-model=\"vm.fare.name\" \ntype=\"text\" ng-required=\"true\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"FARE.START\" \nstyle=\"bottom: 65px;left: 37px\">Start Date</label><md-datepicker class=\"birthday-input\" ms-datepicker-fix \nng-model=\"vm.fare.start\" md-current-view=\"year\" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"FARE.END\" style=\"bottom: 65px;left: 37px\">End Date</label>\n<md-datepicker class=\"birthday-input\" ms-datepicker-fix ng-model=\"vm.fare.end\" md-current-view=\"year\" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container class=\"md-block\" style=\"height: 58px\" \nng-show=\"vm.dialogType==\'add\'\"><label translate=\"FARE.CATEGORIES\">Categories</label><md-icon \nmd-font-icon=\"icon-timetable\"></md-icon><md-select ng-model=\"vm.fare.categories\" multiple=\"multiple\" \nng-change=\"vm.print(vm.fare.categories)\"><md-option ng-repeat=\"category in vm.allCategories\" \nng-value=\"{id:category.id,name:category.name,type:category.type,dailyFare:{numberOfDays:1,days:[{}]}}\">\n{{category.name}} , {{category.type}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nstyle=\"height: 58px\" ng-show=\"vm.dialogType==\'add\'\"><label translate=\"FARE.FARE_TYPES\">Fare Types</label><md-icon \nmd-font-icon=\"icon-timetable\"></md-icon><md-select ng-model=\"vm.fare.fareTypes\" multiple=\"multiple\" \nng-change=\"vm.print(vm.fare.fareTypes)\" required><md-option ng-repeat=\"fareType in vm.fareTypes\" \nng-value=\"{name:fareType.name,value:fareType.value}\">{{fareType.name}}</md-option></md-select></md-input-container><div\n ng-repeat=\"(selectedCategoryIndex,selectedCategory) in vm.fare.categories\" ng-show=\"vm.fare.fareTypes\"><p \nclass=\"md-title\">Category {{selectedCategory.name}} {{selectedCategory.type}}</p><div \nng-repeat=\"(fareTypeIndex,fareType) in vm.fare.fareTypes\"><p>{{fareType.name}} Fare</p><md-input-container \nclass=\"md-icon-float md-block\" ng-show=\"fareType.value == vm.fareTypes.DAILY.value\"><label \ntranslate=\"FARE.NUMBER_OF_DAYS\">Number of Days</label><input \nng-model=\"vm.fare.categories[selectedCategoryIndex].dailyFare.numberOfDays\" \nng-change=\"vm.changeRange(vm.fare.categories[selectedCategoryIndex].dailyFare.numberOfDays,\n                                                              vm.fare.categories[selectedCategoryIndex].dailyFare.days)\" \nng-model-options=\"{ debounce: 500 }\" type=\"text\" ng-pattern=\"/^[1-9][0-9]*$/\"></md-input-container><div \nng-repeat=\"(dayIndex,day) in vm.fare.categories[selectedCategoryIndex].dailyFare.days track by $index\" \nng-show=\"fareType.value == vm.fareTypes.DAILY.value\"><p>Day {{dayIndex + 1}}</p><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"FARE.PRICE\">Price</label><input \nng-model=\"vm.fare.categories[selectedCategoryIndex].dailyFare.days[dayIndex].price\" type=\"text\" \nng-pattern=\"/^[0-9]*$/\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"FARE.EXTRA_DAY\">Extra Day</label><input \nng-model=\"vm.fare.categories[selectedCategoryIndex].dailyFare.days[dayIndex].extraDayPrice\" type=\"text\" \nng-pattern=\"/^[0-9]*$/\"></md-input-container></div><div ng-show=\"fareType.value == vm.fareTypes.HOURLY.value\">\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"FARE.HOURS\">Hours</label><input \nng-model=\"vm.fare.categories[selectedCategoryIndex].hourlyFare.hours\" type=\"text\" ng-pattern=\"/^[0-9]*$/\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"FARE.PRICE\">Price</label>\n<input ng-model=\"vm.fare.categories[selectedCategoryIndex].hourlyFare.price\" type=\"text\" ng-pattern=\"/^[0-9]*$/\">\n</md-input-container></div></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-if=\"vm.dialogType === \'edit\'\" ng-click=\"vm.deleteFareConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"FARE.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"FARE.DELETE\">DELETE</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"vm.dialogType === \'edit\'\" ng-click=\"vm.updateFare()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"fareForm.$invalid || fareForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"FARE.SAVE\" translate-attr-aria-label=\"FARE.SAVE\">SAVE</md-button><md-button type=\"submit\" \nng-if=\"vm.dialogType === \'add\'\" ng-click=\"vm.addFare()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"fareForm.$invalid || fareForm.$pristine\" aria-label=\"Add Task\" translate=\"FARE.ADD\" \ntranslate-attr-aria-label=\"FARE.ADD\">ADD FARE</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/catalog/station/dialogs/station-dialog.html","<md-dialog class=\"station-dialog\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \nng-if=\"vm.dialogType === \'add\'\" translate=\"STATION.ADD_STATION\">Add Station</span> <span class=\"title\" \nng-if=\"vm.dialogType === \'edit\'\" translate=\"STATION.EDIT_STATION\">Edit Station</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"STATION.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nname=\"stationForm\" class=\"md-inline-form\" novalidate ng-submit=\"\"><md-input-container class=\"md-icon-float md-block\">\n<label translate=\"STATION.NAME\">Name</label><input ng-model=\"vm.station.name\" type=\"text\" ng-required=\"true\" \nmd-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"STATION.ADDRESS\">Address</label><input ng-model=\"vm.station.address\" type=\"text\" ng-required=\"true\">\n</md-input-container></form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\"><md-button class=\"md-icon-button\" ng-if=\"vm.dialogType === \'edit\'\" \nng-click=\"vm.deleteStationConfirm($event)\" aria-label=\"Delete\" translate translate-attr-aria-label=\"STATION.DELETE\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"STATION.DELETE\">DELETE</span></md-tooltip>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"vm.dialogType === \'edit\'\" ng-click=\"vm.updateStation()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"stationForm.$invalid || stationForm.$pristine\" aria-label=\"SAVE\" translate=\"STATION.SAVE\" \ntranslate-attr-aria-label=\"STATION.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.dialogType === \'add\'\" \nng-click=\"vm.addStation()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"stationForm.$invalid || stationForm.$pristine\" aria-label=\"Add Task\" translate=\"STATION.ADD\" \ntranslate-attr-aria-label=\"STATION.ADD\">ADD STATION</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/coupon/template/details/template-detail.html","<div id=\"coupon-template-detail\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-fab md-icon-button\" ng-click=\"vm.goToCouponTemplatesPage()\" aria-label=\"Go Back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip><span>Go Back</span></md-tooltip></md-button><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\"></span></div></div><div \nclass=\"buttonsContainerTopPage\"><md-button ng-if=\"vm.isAddCodeEnabled\" class=\"md-fab md-accent md-icon-button\" \nng-click=\"vm.openAddTemplateDialog($event, vm.template)\" aria-label=\"\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip>Add Redeem Code</md-tooltip></md-button></div></div></div><div layout=\"row\" flex=\"noshrink\" \nstyle=\"margin:0px 8px\"><div flex class=\"vehicle-details-widget white-bg md-whiteframe-4dp roundCornersSmaller\" \nlayout=\"column\"><div class=\"h3\"><p>Campaign <b>{{vm.template.name}}</b></p></div><md-divider></md-divider><div flex \nclass=\"vehicle-overview-container\" layout=\"row\"><div flex \nclass=\"vehicle-details-widget-item overview-battery-top-container\" layout=\"column\" layout-align=\"space-between center\">\n<div flex layout=\"column\" layout-align=\"center center\"><p class=\"main-label\" \nng-style=\"{color:vm.toHireDefaultColor.blue}\">{{vm.getBonusValue(vm.template).value}}</p><span>\nTemplate ID: {{vm.template.BonusTemplateId}}</span></div><div class=\"vehicle-details-widget-item-footer\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div><span class=\"batteryVoltage\">\n{{vm.getBonusValue(vm.template).description}}</span></div></div></div></div><div flex \nclass=\"vehicle-details-widget-item border-left\" layout=\"column\"><div class=\"vehicle-info-list-item\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><div layout=\"column\"><b>From Date:\n</b><p>{{vm.getFromDate(vm.template)}}</p></div></div><div class=\"vehicle-info-list-item\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><div layout=\"column\"><b>To Date:</b>\n<p>{{vm.getToDate(vm.template)}}</p></div></div><div class=\"vehicle-info-list-item\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-box\"></md-icon><div layout=\"column\"><b>Constraints:</b>\n<p>{{vm.getConstraintDescription(vm.template)}}</p></div></div></div></div></div><div \nclass=\"card-container md-whiteframe-4dp roundCornersSmaller\"><div class=\"card-with-value\"><span class=\"value\">\n{{(vm.exhaustedCoupons !== null ? (vm.exhaustedCoupons + \"/\" + vm.coupons.length) : \'...\')}}</span><div \nclass=\"card-subtitle\">Exhausted coupons</div></div></div></div><generic-table headers=\"vm.tableFields\" \ndata=\"vm.coupons\" search-filters=\"vm.searchFilters\" filters=\"vm.filters\" update-data=\"vm.refreshCoupons\" \napply-filters-trigger=\"vm.applyFiltersTrigger\"></generic-table></div>");
$templateCache.put("app/main/coupon/template/dialogs/coupon-template-add-dialog.html","<md-dialog class=\"coupon-template-add-dialog\" aria-label=\"Add New template\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Add Campaign</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-content flex class=\"md-padding\" layout=\"column\"><form name=\"addCouponTemplateForm\" \nclass=\"md-inline-form\" novalidate><div class=\"uploadButtonContainer\"><md-button \nclass=\"redirect-button md-accent md-raised\" ng-click=\"vm.goToBonusTemplatesPage()\" aria-label=\"Create template link\">\nCreate Bonus Template</md-button></div><div class=\"inputSeparator\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"textOnInputSeparator\">Or</div></div><div><p class=\"title-details\">Select Bonus Template:</p>\n<two-hire-autocomplete options=\"vm.searchOptions\" set-result=\"vm.setBonusTemplate\" selected-item=\"vm.bonusTemplate\">\n</two-hire-autocomplete></div><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex \nclass=\"md-block md-icon-float flex\"><label>Name</label><input ng-model=\"vm.template.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div><h1 class=\"md-title\">Usage limits</h1><div layout=\"row\" \nlayout-xs=\"column\" layout-sm=\"column\"><md-input-container class=\"md-block flex-gt-sm-25\"><label>Per code redeem/s\n</label><input ng-model=\"vm.template.constraints.useLimit\" type=\"number\" min=\"1\" \nng-required=\"!vm.template.noRedeemLimit\" ng-disabled=\"vm.template.noRedeemLimit\"></md-input-container><span flex=\"5\" \nhide-xs hide-sm></span><md-input-container class=\"flex-gt-sm-25\" flex><md-checkbox class=\"checkboxInput\" \nng-model=\"vm.template.noRedeemLimit\" ng-required=\"!vm.template.constraints.useLimit\">No Redeem limit</md-checkbox>\n</md-input-container><md-input-container class=\"flex-gt-sm-25\" flex><md-checkbox class=\"checkboxInput\" \nng-model=\"vm.template.onlyNewUser\">Only new users</md-checkbox></md-input-container><md-input-container \nclass=\"flex-gt-sm-25\" flex ng-if=\"vm.showPurchase\"><md-checkbox class=\"checkboxInput\" ng-model=\"vm.template.purchased\">\nValid as payment</md-checkbox></md-input-container></div></div><h1 class=\"md-title\">Validity Time constraint</h1><div \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container class=\"md-block flex-gt-sm-20\" \nstyle=\"height: 58px\"><label>Start Date</label><md-select ng-model=\"vm.template.constraints.validityTime[0].type\" \nrequired><md-option ng-repeat=\"type in vm.validityTimeType\" ng-value=\"type.value\">{{type.name}}</md-option></md-select>\n</md-input-container><span \nng-show=\"vm.template.constraints.validityTime[0].type !== vm.validityTimeType.UNBOUNDED.value\" flex=\"5\" hide-xs \nhide-sm></span><md-datepicker \nng-if=\"vm.template.constraints.validityTime[0].type === vm.validityTimeType.TIMESTAMP.value\" \nmd-placeholder=\"Select Date\" ms-datepicker-fix ng-model=\"vm.template.constraints.validityTime[0].date\" \nmd-open-on-focus md-min-date=\"vm.todayDate\" required></md-datepicker><span flex=\"5\" hide-xs hide-sm></span>\n<md-input-container class=\"md-block flex-gt-sm-20\" style=\"height: 58px\"><label>End Date</label><md-select \nng-model=\"vm.template.constraints.validityTime[1].type\" required><md-option ng-repeat=\"type in vm.validityTimeType\" \nng-value=\"type.value\">{{type.name}}</md-option></md-select></md-input-container><span flex=\"5\" hide-xs hide-sm></span>\n<md-datepicker ng-if=\"vm.template.constraints.validityTime[1].type === vm.validityTimeType.TIMESTAMP.value\" \nmd-placeholder=\"Select Date\" ms-datepicker-fix ng-model=\"vm.template.constraints.validityTime[1].date\" \nmd-open-on-focus \nmd-min-date=\"(vm.template.constraints.validityTime[1] && vm.template.constraints.validityTime[1].date || vm.todayDate)\" \nrequired></md-datepicker></div><h1 class=\"md-title\">Validity Sites constraint</h1><div layout=\"row\" layout-xs=\"column\" \nlayout-sm=\"column\"><md-input-container class=\"md-block flex-gt-sm-20\" style=\"height: 58px\"><label>Site ownership\n</label><md-select ng-model=\"vm.template.SiteId\" ng-disabled=\"vm.preventSiteChange\" required><md-option \nng-repeat=\"site in vm.sites track by site.id\" ng-value=\"site.id\">{{site.name}}</md-option></md-select>\n</md-input-container><span flex=\"5\" hide-xs hide-sm></span><md-input-container flex class=\"md-block flex-gt-sm-20\" \nstyle=\"height: 58px\"><label>Validity Sites</label><md-select ng-model=\"vm.template.constraints.siteIds\" \nmultiple=\"multiple\"><md-select-header class=\"demo-select-header\"><input id=\"template-constraint-site-search\" \nclass=\"demo-header-searchbox md-text\" ng-model=\"vm.searchSiteText\" type=\"search\" placeholder=\"Site filter\" \naria-label=\"Site filter\"></md-select-header><md-optgroup label=\"Site filter\"><md-option ng-value=\"site.id\" \nng-click=\"vm.onSiteChange(site)\" ng-repeat=\"site in vm.sites | filter: vm.searchSiteText track by site.id\">\n{{site.name}}</md-option></md-optgroup></md-select></md-input-container></div><div><md-checkbox class=\"\" \nng-model=\"vm.createCouponSelected\">I\'d like to create a Coupon after the Campaign creation</md-checkbox></div><div \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"vm.callAddTemplate()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"addCouponTemplateForm.$invalid || addCouponTemplateForm.$pristine\" aria-label=\"Add Coupon Template\">ADD\n</md-button></div></form></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/history/views/reservations/rentBooking.html","<div id=\"e-commerce-orders\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span ng-if=\"vm.viewType == vm.viewTypes.RESERVATION\" translate=\"EC.RESERVATIONS\">Reservations</span> <span \nng-if=\"vm.viewType == vm.viewTypes.RENTALAGREEMENT\" translate=\"EC.RENTALAGREEMENTS\">Rental agreements</span></div><div \nclass=\"order-count secondary-text\"><span ng-if=\"vm.viewType == vm.viewTypes.RESERVATION\" \ntranslate=\"EC.TOTAL_RESERVATIONS\">Total reservations:</span> <span ng-if=\"vm.viewType == vm.viewTypes.RENTALAGREEMENT\" \ntranslate=\"EC.TOTAL_RENTALAGREEMENTS\">Total agreements:</span> <span>{{vm.rentBookings.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"EC.SEARCH\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vehicle</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pick Up</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Return</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.viewType == vm.viewTypes.RENTALAGREEMENT\"><div class=\"table-header\"><span \nclass=\"column-title\">Deposit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"rentBooking in vm.rentBookings track by $index \"><td>{{rentBooking.id}}</td><td>\n{{rentBooking.User.name}} {{rentBooking.User.surname}}</td><td>{{rentBooking.CategoryRent.name}}</td><td>\n{{rentBooking.Vehicle.license_plate || \"Not assigned\"}}</td><td>{{rentBooking.status}}</td><td>\n{{rentBooking.PickUp.name}}</td><td>{{rentBooking.Return.name}}</td><td>\n{{ vm.getCurrencyValue(rentBooking.price, rentBooking.SiteId) }}</td><td \nng-if=\"vm.viewType == vm.viewTypes.RENTALAGREEMENT\">{{ vm.getCurrencyValue(rentBooking.deposit, rentBooking.SiteId) }}\n</td><td>{{rentBooking.start | toDate}} - {{ rentBooking.end | toDate}}</td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/invoices/dialogs/bulk-charges/bulk-charges-dialog.html","<md-dialog class=\"bulk-charge-manage-dialog\" aria-label=\"rectify ticket\"><form name=\"manageInvoiceForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAdd a charge</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content flex layout=\"column\" \nng-hide=\"isBulkActive\"><div class=\"uploadButtonContainer\"><label for=\"id_charges_csv\">Upload CSV</label><input \ntype=\"file\" id=\"id_charges_csv\" name=\"id_charges_csv\" accept=\".csv, .txt\"></div><div class=\"inputSeparator\" \nlayout=\"row\" layout-align=\"center center\"><div class=\"textOnInputSeparator\">Or</div></div><md-content flex \nlayout=\"column\"><pf class=\"title-details full\">Select a user:<p></p><two-hire-autocomplete options=\"searchOptions\" \nset-result=\"setUser\"></two-hire-autocomplete><p class=\"title-details full\">Billing Site:</p><md-input-container \nclass=\"md-block md-icon-float\" style=\"height: 58px\"><label>Site</label><md-select ng-model=\"newCharge.siteId\" \nng-disabled=\"!selectedUser\" ng-model-options=\"{\'debounce\': 1000}\" ng-change=\"vm.getCurrencySymbolBySite()\" required>\n<md-option ng-repeat=\"siteInfo in selectedUser.UserSites\" ng-value=\"siteInfo.SiteId\">\n{{vm.getSiteName(siteInfo.SiteId)}}</md-option></md-select></md-input-container><div layout=\"column\"><p \nclass=\"title-details full\">Charge:</p><div layout=\"row\"><md-input-container \nclass=\"md-block md-icon-float double-input\"><label>Amount</label><input ng-model=\"newCharge.amountOfMoney\" \ntype=\"number\" min=\"0\" ng-required=\"true\"></md-input-container><md-input-container \nclass=\"md-block md-icon-float double-input\" style=\"margin-left: 12px\"><label>Currency</label><input \nng-model=\"vm.currency\" type=\"string\" disabled=\"disabled\"></md-input-container></div><md-input-container flex \nclass=\"md-block md-icon-float\"><label>Description</label><textarea ng-model=\"newCharge.description\" md-maxlenght=\"400\">\n</textarea></md-input-container></div></pf></md-content></md-content><md-content flex layout=\"column\" \nng-show=\"isBulkActive\"><div layout=\"row\" ng-show=\"totalUploadedFileRows !== null\">\nCharges evaluated: {{ totalUploadedFileRows }} / {{ fileLines.length - (headingRowExists ? 1 : 0) }}</div><div \nlayout=\"row\" class=\"bulkProgressbarContainer\"><md-progress-linear class=\"bulkProgressbar\" md-mode=\"determinate\" \nng-value=\"loadingProgress\"></md-progress-linear></div><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" ng-class=\"{bulkErrorMessage: isBulkUploadError}\">\n{{ isBulkUploadError ? (\"Error encountered on charge n°: \" + totalUploadedFileRows) : (\"Total file lines: \" + fileLines.length) }}\n</div><div layout=\"column\"><md-checkbox ng-model=\"headingRowExists\" ng-change=\"updateBulkKeysTable()\" \naria-label=\"contains header?\">The file contains a heading row</md-checkbox></div></div><div layout=\"column\"><div \nlayout=\"row\" class=\"optionsSelectWrapper\"><md-select id=\"bulk-{{$index}}\" class=\"optionsSelect\" \nng-repeat=\"(index,items) in bulkUploadKeys\" selected=\"{{ bulkUploadKeys[$index] }}\" ng-model=\"selectedKey[$index]\" \naria-label=\"choose\"><md-option ng-repeat=\"(inx,item) in bulkUploadKeys\" value=\"{{ item.key }}\" \nng-selected=\"index === item.index\" ng-click=\"updateBulkKeys(index, inx)\">{{ item.name }}</md-option></md-select></div>\n</div><div layout=\"row\"><generic-table headers=\"bulkUploadKeys\" data=\"bulkKeysTable\" class=\"addChargesBulkTable\" \ndownload-data=\"false\" show-last-update=\"false\"></generic-table></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><two-hire-loading-button ng-hide=\"isBulkActive\" \ntype=\"submit\" label=\"\'Add\'\" my-on-click=\"callAddCharge()\"></two-hire-loading-button><md-button type=\"button\" \nng-click=\"callAddCharge()\" class=\"send-button md-accent md-raised\" ng-show=\"isBulkActive\" \nng-disabled=\"!isBulkActive||isBulkUploadError\" aria-label=\"Add\" translate=\"VEHICLE.ADD\" \ntranslate-attr-aria-label=\"VEHICLE.ADD\">ADD</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><md-tabs md-dynamic-height \nmd-selected=\"vm.selectedTab\" ng-show=\"!vm.showResetPasswordTab\"><md-tab md-on-select=\"vm.onTabSelect(0)\"><md-tab-label>\n<span translate=\"LOGIN.FIRST_PAGE.COMPANY\">COMPANY</span></md-tab-label><md-tab-body><md-content><div class=\"logo\"><img\n src=\"assets/images/logos/2hire_monogram.svg\"></div><div class=\"title\" translate=\"LOGIN.FIRST_PAGE.TITLE\">\nEnter your Company Name</div><div class=\"subhead\" translate=\"LOGIN.FIRST_PAGE.SUBTITLE\">Only for the first time</div>\n<form name=\"companyForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" \nname=\"company_name\" ng-model=\"vm.companyData.name\" placeholder=\"Company Name\" translate \ntranslate-attr-placeholder=\"LOGIN.FIRST_PAGE.COMPANY_NAME\" required><div ng-messages=\"companyForm.company_name.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.FIRST_PAGE.ERRORS.COMPANY_REQUIRED\">\nCompany name field is required</span></div></div></md-input-container><two-hire-loading-button class=\"submit-button\" \nlabel=\"\'SUBMIT\'\" my-on-click=\"vm.callCompanyLogin($event)\" type=\"submit\" \ndisabled=\"companyForm.$invalid || companyForm.$pristine\"></form></md-content></md-tab-body></md-tab><md-tab \nmd-on-select=\"vm.onTabSelect(1)\" ng-disabled=\"!vm.canLogin\"><md-tab-label><span translate=\"LOGIN.SECOND_PAGE.LOGIN\">\nLogin</span></md-tab-label><md-tab-body><md-content><div class=\"logo\"><img \nsrc=\"assets/images/logos/2hire_monogram.svg\"></div><div class=\"title\" translate=\"LOGIN.SECOND_PAGE.TITLE\">\nLog in to your account</div><form name=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \ntype=\"text\" name=\"email\" ng-model=\"vm.loginData.username\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN.SECOND_PAGE.EMAIL\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.SECOND_PAGE.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.SECOND_PAGE.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.loginData.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.SECOND_PAGE.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.SECOND_PAGE.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float \nng-if=\"vm.isOtpVisible\"><span translate=\"LOGIN.SECOND_PAGE.OTP_INTRO\">\nAn OTP code has been sent to your email. Check it and insert it here. </span><input type=\"text\" name=\"otpCode\" \nng-model=\"vm.loginData.otpCode\" placeholder=\"Code\" translate translate-attr-placeholder=\"LOGIN.SECOND_PAGE.OTP\" \nrequired><div ng-messages=\"loginForm.otpCode.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.SECOND_PAGE.ERRORS.OTP_REQUIRED\">OTP Code field is required</span></div></div></md-input-container>\n<div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"vm.rememberMe\" aria-label=\"Remember Me\"><span translate=\"LOGIN.SECOND_PAGE.REMEMBER_ME\">\nRemember Me</span></md-checkbox></div><two-hire-loading-button class=\"submit-button\" label=\"\'LOGIN\'\" \nmy-on-click=\"vm.callLogin($event)\" type=\"submit\" disabled=\"loginForm.$invalid || loginForm.$pristine\"></form>\n</md-content></md-tab-body></md-tab></md-tabs><md-tabs md-dynamic-height ng-show=\"vm.showResetPasswordTab\"><md-tab>\n<md-tab-label><span translate=\"LOGIN.RESET_PASSWORD.TAB_TITLE\">Reset Password</span></md-tab-label><md-tab-body>\n<md-content><div class=\"logo\"><img src=\"assets/images/logos/2hire_monogram.svg\"></div><div class=\"title\" \ntranslate=\"LOGIN.RESET_PASSWORD.TITLE\">Set a New Password</div><form name=\"resetPasswordForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"newPassword\" \nng-model=\"vm.loginData.newPassword\" \nng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^a-zA-Z\\d])[A-Za-z\\d\\W\\S]{10,256}$/\" placeholder=\"New Password\" \ntranslate translate-attr-placeholder=\"LOGIN.RESET_PASSWORD.NEW_PASSWORD\" required><div \nng-messages=\"resetPasswordForm.newPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.RESET_PASSWORD.ERRORS.NEW_PASSWORD_REQUIRED\">New password field is required</span></div><div \nng-message=\"pattern\"><span translate=\"LOGIN.RESET_PASSWORD.ERRORS.NEW_PASSWORD_INVALID\">\nPassword must be 10-256 characters long and include an uppercase letter, a lowercase letter, a digit, and a special character.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"confirmNewPassword\" ng-model=\"vm.loginData.confirmNewPassword\" placeholder=\"Confirm New Password\" translate \ntranslate-attr-placeholder=\"LOGIN.RESET_PASSWORD.CONFIRM_NEW_PASSWORD\" required><div \nng-messages=\"resetPasswordForm.confirmNewPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.RESET_PASSWORD.ERRORS.CONFIRM_PASSWORD_REQUIRED\">Confirm new password field is required</span></div>\n<div ng-message=\"match\"><span translate=\"LOGIN.RESET_PASSWORD.ERRORS.PASSWORDS_MUST_MATCH\">Passwords must match</span>\n</div></div></md-input-container><two-hire-loading-button class=\"submit-button\" label=\"\'RESET PASSWORD\'\" \nmy-on-click=\"vm.callLogin($event)\" type=\"submit\" \ndisabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine || vm.loginData.newPassword !== vm.loginData.confirmNewPassword\">\n</form></md-content></md-tab-body></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/rent/manage/dialogs/assign-vehicle-dialog.html","<md-dialog class=\"assign-vehicle-dialog\" aria-label=\"Add Dialog\"><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Assign Vehicle</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll layout=\"column\" class=\"p-16\"><div class=\"pt-16 pr-16 pl-16\"><p class=\"md-title\">Reservation info:</p><p \nclass=\"h4\">Category: {{vm.aliveReservation.CategoryRent.name}}</p><p class=\"h4\">\nCategory type: {{vm.aliveReservation.CategoryRent.type}}</p></div><p class=\"p-16 md-title\" \nng-show=\"vm.noAvailableVehicles\">No available vehicles !</p><md-list ng-hide=\"vm.noAvailableVehicles\"><md-list-item>\n<md-icon md-svg-icon=\"\"></md-icon><p class=\"text-left font-weight-500\">License Plate</p><p \nclass=\"text-right font-weight-500\">Category</p><p class=\"text-center font-weight-500\">Category Type</p></md-list-item>\n<md-list-item \nng-repeat=\"availableVehicle in vm.availableVehicles |filter:{$:vm.aliveReservation.CategoryRent.type} track by $index\">\n<md-icon ng-if=\"vm.vehicleTypes.CAR.value == availableVehicle.type\" md-svg-icon=\"assets/icons/icon-car.svg\"></md-icon>\n<md-icon ng-if=\"vm.vehicleTypes.SCOOTER.value == availableVehicle.type\" md-svg-icon=\"assets/icons/icon-scooter.svg\">\n</md-icon><md-icon ng-if=\"vm.vehicleTypes.BIKE.value == availableVehicle.type\" \nmd-svg-icon=\"assets/icons/icon-bicycle.svg\"></md-icon><p class=\"text-left\">{{availableVehicle.license_plate}}</p><p \nclass=\"text-right\">{{availableVehicle.CategoryRent.name}}</p><p class=\"text-center\">\n{{availableVehicle.CategoryRent.type}}</p><md-radio-group><md-radio-button class=\"md-primary\" \nng-click=\"vm.assignVehicle(availableVehicle)\" aria-label=\"select\"></md-radio-button></md-radio-group></md-list-item>\n</md-list></md-dialog-content></md-dialog>");
$templateCache.put("app/main/settings/devices/dialogs/device-manage-dialog.html","<md-dialog class=\"device-manage-dialog\" aria-label=\"manage device\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{\'Manage this device\'}}</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" ng-disabled=\"isLoading\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><md-content flex layout=\"column\"><p class=\"title-details\">Device info:</p><div \nclass=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Id:</label><p>{{device.id}}</p></div><div \nclass=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Name:</label><p>{{device.name}}</p></div><div\n class=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Online:</label><md-icon \nng-class=\"device.online? \'icon-check-circle\' : \'icon-close-circle-outline\' \"></md-icon></div><div \nclass=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\" ng-show=\"device.vehicle\"><label>Vehicle Ref.Code:\n</label><p>{{device.vehicle.reference_code}}</p></div><div class=\"invoice-info-item\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"device.vehicle\"><label>Vehicle plate:</label><p>{{device.vehicle.license_plate }}\n</p></div><p class=\"title-details\">Select new vehicle:</p><two-hire-autocomplete options=\"searchOptions\" \nset-result=\"setVehicle\"></two-hire-autocomplete></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-around center\"><md-button ng-click=\"callDetachVehicle()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"isLoading || device.status!=deviceStatus.ATTACHED.value\" aria-label=\"detach\">Detach</md-button><md-button \nng-show=\"device.status == deviceStatus.ATTACHED.value\" ng-click=\"callUnlinkVehicle()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"isLoading\" aria-label=\"unlink\">Unlink</md-button><md-button \nng-show=\"device.status == deviceStatus.DETACHED.value\" ng-click=\"callAttachVehicle()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"isLoading\" aria-label=\"attach\">Attach</md-button><md-button \nng-show=\"device.status == deviceStatus.ATTACHED.value\" ng-click=\"callChangeVehicle()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"isLoading\" aria-label=\"swap\">Change</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/permissions/role/role-details.html","<div id=\"role-details\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"start start\" flex-xs=\"25\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\nAdmins with role <b>{{vm.role.name}}</b></span></div></div><div class=\"buttonsContainerTopPage\"></div></div></div>\n<generic-table headers=\"vm.tableFields\" data=\"vm.admins\" search-filters=\"vm.searchFilters\" filters=\"vm.filters\" \nupdate-data=\"vm.refresh\" apply-filters-trigger=\"vm.applyFiltersTrigger\" enable-auto-refresh=\"true\"></generic-table>\n</div>");
$templateCache.put("app/main/trip/details/dialogs/trip-end-image-dialog.html","<md-dialog class=\"trip-end-image-dialog\" aria-label=\"Add New Vehicle\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">End Trip Images</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content flex><div class=\"card-container md-whiteframe-4dp roundCorners\"><div class=\"tileTitle fixed\">\nTrip {{vm.trip.id}} | Vehicle {{vm.trip.Vehicle.reference_code || \"\"}}</div><div class=\"tileInfo\"><span>\nImage taken at: {{vm.selectedImage.takenAt | toDate:\"dateTime\":vm.trip.SiteId}} </span></div><div flex \nclass=\"image-container\"><img class=\"image\" ng-if=\"vm.selectedImage.location!=\'\'\" \nng-src=\"{{vm.selectedImage.location}}\"><div ng-if=\"vm.selectedImage.location==\'\'\" class=\"no-image\"><div>\nNo image available!</div></div><div class=\"dotContainer\"><div class=\"dot\" \nng-class=\"vm.selectedImage.number == $index ? \'dotSelected\':\'\' \" ng-repeat=\"img in vm.images\" \nng-click=\"vm.selectImage($index)\"></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/user/dialogs/payment/make-manual-payment-dialog.html","<md-dialog id=\"manual-payment-dialog\" class=\"manual-payment-dialog\" aria-label=\"make manual payment\"><form \nname=\"makePaymentForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nMake manual payment</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content flex \nlayout=\"column\"><p class=\"title-details full\">Select a user:</p><two-hire-autocomplete options=\"vm.searchOptions\" \nset-result=\"vm.setUser\" selected-item=\"vm.selectedUser\" disabled=\"vm.selectUserDisabled\"></two-hire-autocomplete><div \nlayout=\"column\"><p class=\"title-details full\">Payment method:</p><div class=\"invoice-info-item\" layout=\"row\" \nlayout-align=\"start center\"><label>Brand:</label><p>{{vm.paymentMethod.brand}}</p></div><div class=\"invoice-info-item\" \nlayout=\"row\" layout-align=\"start center\"><label>Pan:</label><p>{{vm.paymentMethod.pan}}</p></div><div \nclass=\"invoice-info-item\" layout=\"row\" layout-align=\"start center\"><label>Expire:</label><p>\n{{vm.paymentMethod.exp_month}} / {{vm.paymentMethod.exp_year}}</p></div></div><p class=\"title-details full\">\nBilling Site:</p><md-input-container class=\"md-block md-icon-float\" style=\"height: 58px\"><label>Site</label><md-select \nng-model=\"vm.amountOfMoney.siteId\" ng-model-options=\"{\'debounce\': 1000}\" ng-change=\"vm.getCurrencySymbolBySite()\" \nrequired><md-option ng-repeat=\"siteInfo in vm.userSites\" ng-value=\"siteInfo.SiteId\">{{vm.getSiteName(siteInfo.SiteId)}}\n</md-option></md-select></md-input-container><div layout=\"column\"><p class=\"title-details full\">Charge:</p><div \nlayout=\"row\"><md-input-container class=\"md-block md-icon-float double-input\"><label>Amount</label><input \nng-model=\"vm.amountOfMoney.amount\" type=\"number\" min=\"0\" ng-required=\"true\"></md-input-container><md-input-container \nclass=\"md-block md-icon-float double-input\" style=\"margin-left: 12px\"><label>Currency</label><input \nng-model=\"vm.currency\" type=\"string\" disabled=\"disabled\"></md-input-container></div><md-input-container flex \nclass=\"md-block md-icon-float\"><label>Description</label><textarea ng-model=\"vm.amountOfMoney.description\" \nmd-maxlenght=\"400\"></textarea></md-input-container></div></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><two-hire-loading-button type=\"submit\" label=\"\'Submit\'\" \nmy-on-click=\"vm.callChargeUserPayment()\"></two-hire-loading-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/utility/directives/buttons/two-hire-loading-button.html","<div id=\"twoHireLoadingButton\" class=\"vehicle-action-container\"><md-button \nclass=\"md-raised md-accent vehicle-action-button\" ng-class=\"{\'userDisabled\': vm.disabled}\" type=\"vm.type\" \nng-click=\"vm.myOnClickHandler()\" ng-disabled=\"vm.actionIsLoading || vm.disabled\" aria-label=\"vm.ariaLabel\">{{vm.label}}\n</md-button><md-progress-circular ng-show=\"vm.actionIsLoading\" class=\"md-accent vehicle-action-icon-top-left\" \nmd-diameter=\"20\"></md-progress-circular><md-icon ng-show=\"vm.actionIsLoaded && vm.actionSuccess\" \nclass=\"vehicle-action-icon-top-left vehicle-action-icon\" md-font-icon=\"icon-check\"></md-icon><md-icon \nng-show=\"vm.actionIsLoaded && !vm.actionSuccess\" class=\"vehicle-action-icon-top-left vehicle-action-icon\" \nmd-font-icon=\"icon-close\"></md-icon></div>");
$templateCache.put("app/main/utility/directives/filter-row/filter-row.html","<div class=\"filterRowContainer\"><div class=\"filters\" ng-repeat=\"filter in vm.filters\" ng-hide=\"vm.hideStaticFilters\">\n<div class=\"filterToggles\" ng-if=\"filter.options.multiple\"><md-select class=\"itemFilter\" ng-model=\"filter.selected\" \nng-change=\"vm.callApplyFilters()\" placeholder=\"{{filter.name}}\" multiple=\"multiple\" aria-label=\"selectStaticFilter\">\n<md-option ng-value=\"option.value\" ng-repeat=\"option in filter.values\" aria-label=\"{{option.description}}\">\n{{option.description}}</md-option></md-select></div><div class=\"filterToggles\" ng-if=\"!filter.options.multiple\">\n<md-select ng-if=\"filter.valueType!==\'date\'\" class=\"itemFilter\" ng-model=\"filter.selected\" \nng-change=\"vm.callApplyFilters()\" placeholder=\"{{filter.name}}\" aria-label=\"selectStaticFilter\"><md-option \nng-click=\"filter.selected=null\"></md-option><md-option ng-value=\"option.value\" ng-repeat=\"option in filter.values\" \naria-label=\"{{option.description}}\">{{option.description}}</md-option></md-select><md-datepicker \nng-if=\"filter.valueType==\'date\'\" md-placeholder=\"{{filter.name}}\" ng-model=\"filter.selected\" \nng-model-options=\"{debounce:500}\" ng-change=\"vm.applyFiltersTrigger()\" md-min-date=\"\" md-max-date=\"vm.todayDate\" \naria-label=\"dateFilter\"></md-datepicker></div></div><div class=\"filters\" \nng-repeat=\"(index,filterSet) in vm.searchFiltersArray track by (index + \'-\' + $index)\" \nng-hide=\"vm.hideSearchFilters || !vm.searchFilters\"><div class=\"filterToggles\" \nng-class=\"{\'searchFiltersMultiple\': vm.selectedSearchFilter[index] ,\'searchFiltersSingle\': vm.selectedSearchFilter[index]===undefined || vm.selectedSearchFilter[index]===null}\" \nlayout=\"row\"><md-select ng-init=\"undefined\" class=\"{{ \'itemFilter \' + vm.selectedSearchFilter[index].valueType }}\" \nng-class=\"{disabledStyle: vm.selectedSearchFilter[index] === undefined }\" ng-model=\"vm.selectedSearchFilter[index]\" \nlayout=\"column\" layout-align=\"start center\" aria-label=\"selectSearchFilter\"><md-option ng-value=\"undefined\" \nng-click=\"vm.selectedSearchFilter[index]=undefined;vm.removeSearchFilter(index)\" class=\"filterTogglesDefaultOption\">\n{{ vm.placeholder || \'Filter\' }}</md-option><md-option ng-value=\"filter\" \nng-click=\"vm.resetSearchFilters(index, filterKey)\" ng-repeat=\"(filterKey,filter) in filterSet\">{{filter.name}}\n</md-option></md-select><div ng-show=\"vm.selectedSearchFilter[index]\" \nng-switch=\"vm.selectedSearchFilter[index].valueType\" layout=\"column\" layout-align=\"start center\"><div \nng-switch-when=\"dateRange\" layout=\"row\" class=\"dateRangeWrapper\"><md-datepicker \nng-model=\"vm.selectedSearchFilter[index].selected[0]\" ng-change=\"vm.callDatedApplyFilters(index)\" md-min-date=\"\" \nmd-max-date=\"\" aria-label=\"dateFilter\" md-placeholder=\"Start date\"></md-datepicker><md-datepicker \nng-model=\"vm.selectedSearchFilter[index].selected[1]\" ng-change=\"vm.callDatedApplyFilters(index)\" md-min-date=\"\" \nmd-max-date=\"\" aria-label=\"dateFilter\" md-placeholder=\"End date\"></md-datepicker></div><md-input-container \nng-switch-when=\"date\" class=\"dateWrapper\"><md-datepicker ng-model=\"vm.selectedSearchFilter[index].selected\" \nng-change=\"vm.callApplyFilters()\" md-min-date=\"\" md-max-date=\"vm.todayDate\" aria-label=\"dateFilter\"></md-datepicker>\n</md-input-container><md-input-container class=\"itemFilterInput\" ng-switch-when=\"boolean\"><md-checkbox \nclass=\"itemFilterInputCheckbox\" ng-model=\"vm.selectedSearchFilter[index].selected\" ng-change=\"vm.callApplyFilters()\" \naria-label=\"onlineStatus\"></md-checkbox></md-input-container><md-input-container class=\"itemFilterInput\" \nng-switch-when=\"multiselect\"><md-select class=\"itemFilter\" ng-model=\"vm.selectedSearchFilter[index].selected\" \nng-change=\"vm.callApplyFilters()\" placeholder=\"{{vm.selectedSearchFilter[index].description}}\" multiple=\"multiple\" \naria-label=\"selectStaticFilter\"><md-option ng-value=\"option.value\" \nng-repeat=\"option in vm.selectedSearchFilter[index].values\" aria-label=\"{{option.description}}\" class=\"option-tooltip\">\n{{ option.description }}<div ng-if=\"option.hasOwnProperty(\'tooltip\')\" class=\"filter-tooltip\">{{ option.tooltip }}</div>\n</md-option></md-select></md-input-container><md-input-container class=\"itemFilterInput\" ng-switch-when=\"dropdown\">\n<md-select class=\"itemFilter\" ng-model=\"vm.selectedSearchFilter[index].selected\" ng-change=\"vm.callApplyFilters()\" \nplaceholder=\"{{vm.selectedSearchFilter[index].description}}\" aria-label=\"selectStaticFilter\"><md-option \nng-value=\"option.value\" ng-repeat=\"option in vm.selectedSearchFilter[index].values\" \naria-label=\"{{option.description}}\">{{ option.description }}</md-option></md-select></md-input-container><div \nlayout=\"row\" ng-switch-when=\"multiinput\"><md-input-container class=\"itemFilterInput\"><input \nclass=\"borderedColor defaultFilterInput\" ng-model=\"vm.selectedSearchFilter[index].selected[0]\" \nng-change=\"vm.callApplyFilters()\" aria-label=\"input\"></md-input-container><md-input-container class=\"itemFilterInput\">\n<input class=\"borderedColor defaultFilterInput\" ng-model=\"vm.selectedSearchFilter[index].selected[1]\" \nng-change=\"vm.callApplyFilters()\" aria-label=\"input\"></md-input-container></div><md-input-container \nclass=\"itemFilterInput\" ng-switch-default><input class=\"borderedColor defaultFilterInput\" \nng-model=\"vm.selectedSearchFilter[index].selected\" ng-change=\"vm.callApplyFilters()\" \ntype=\"{{vm.selectedSearchFilter[index].valueType}}\" aria-label=\"input\"></md-input-container></div></div></div>\n<md-button ng-show=\"vm.selectedSearchFilter[0] && vm.allowMultiFilter\" \nclass=\"filterAddBtn md-fab md-accent md-icon-button\" aria-label=\"add filter\" ng-click=\"vm.addSearchFilter()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/utility/directives/generic-table/generic-table.html","<div class=\"genericTableContentContainer {{vm.cssClass}}\"><div \nclass=\"genericTableContainer md-whiteframe-4dp roundCorners\"><div class=\"genericTableHeader\" \nng-show=\"vm.updateData && (vm.filters || vm.searchFilters)\"><div class=\"lastUpdate\" \nng-show=\"vm.showLastUpdate && vm.lastUpdateText\"><div class=\"lastUpdateInfo\"><md-tooltip>\nDisplayed {{vm.totalDisplayed}} out of {{ vm.totalAvailable | number}}</md-tooltip><md-icon class=\"lastUpdateInfoIcon\" \nmd-font-icon=\"icon-pound\"></md-icon><span hide-xs>\n{{vm.totalDisplayed !== \'...\' ? vm.totalDisplayed + \' / \' : \'\'}}{{vm.totalAvailable | number}}</span></div></div><div \nclass=\"containerTitle\"><div ng-show=\"vm.searchFilters\" class=\"filterRowWrapper\" layout=\"row\" \nlayout-align=\"start center\"><filter-row filters=\"vm.filters\" search-filters=\"vm.searchFilters\" \nhide-static-filters=\"true\" update-data=\"vm.updateFiltersData\" call-update-data-on-init=\"true\" \nallow-multi-filter=\"true\" apply-filters-trigger=\"vm.applyInnerFiltersTrigger\" class=\"search-input-wrapper\" \npage-id=\"vm.pageId\"></filter-row></div></div><div class=\"genericTableHeaderButtonsContainer\"><div \nclass=\"containerRefreshButton\"><md-icon ng-show=\"!vm.isDownloadingData && vm.updateData\" md-font-icon=\"icon-refresh\" \nng-click=\"vm.applyInnerFiltersTrigger()\" aria-label=\"refresh\"></md-icon><md-progress-circular \nng-show=\"vm.isDownloadingData && vm.updateData\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"30\" \naria-label=\"loading\"></md-progress-circular><md-tooltip>{{ !vm.isDownloadingData ? \'Refresh\' : \'Loading\' }}\n</md-tooltip></div><div class=\"containerDownloadButton\" ng-show=\"vm.downloadData\" \nng-click=\"vm.exportListAsCSVPromptDialog($event)\"><md-icon md-font-icon=\"icon-download\" aria-label=\"csvDownload\">\n<md-tooltip><span>Export As CSV</span></md-tooltip></md-icon></div></div></div><div \nclass=\"genericTableMainContentContainer\"><div class=\"genericTableRow genericTableRowHeader\"><div \nclass=\"genericTableRowCell\" ng-repeat=\"field in vm.headers\" \nng-show=\"field.hasOwnProperty(\'hide\') ? !field.hide : true\" ng-click=\"vm.callApplyOrderBy(field.orderBy)\" \nng-class=\"field.class\">\n{{field.name}}{{field.orderBy ? (field.orderBy == vm.selectedOrderBy.orderBy) ? vm.selectedOrderBy.ascOrder ? \'&#x25B2;\' : \'&#x25BC;\' : \'\' : \'\'}}\n</div></div><div class=\"genericTable\"><div class=\"genericTableRow\" ng-repeat=\"data in vm.data\" \nng-click=\"vm.onRowClick(data)\" ng-style=\"{cursor: (vm.onRowClick) ? \'pointer\' : \'default\'}\"><div \nclass=\"{{ \'genericTableRowCell \' + field.class }}\" ng-show=\"field.hasOwnProperty(\'hide\') ? !field.hide : true\" \nng-repeat=\"field in vm.headers\"><div ng-show=\"!field.hasOwnProperty(\'type\')\" \nclass=\"{{ \'\' + field.key + \' \' + (field.ellipsis ? \'ellipsis\' : \'\') }}\">{{data[field.key]}}</div><div \nng-show=\"field.hasOwnProperty(\'type\')\" ng-switch=\"field.type\" \nclass=\"{{ \'\' + field.key + \' \' + (field.ellipsis ? \'ellipsis\' : \'\') }}\"><span ng-switch-when=\"icon-link\" \nclass=\"{{field.key}}\"><md-button class=\"md-icon-button centersSingleElement\" \nui-sref=\"{{ vm.getLink(field.icon, data) }}\" ng-click=\"$event.stopPropagation()\" aria-label=\"details\"><md-icon \nmd-font-icon=\"{{ field.icon.icon }}\" aria-label=\"icon\"></md-icon></md-button></span><md-icon \nng-switch-when=\"icon-boolean\" class=\"centersSingleElement {{ field.key }}\" \nng-class=\"(field.icon.render !== undefined ? field.icon.render(\'\', data) : data[field.icon.key]) ? field.icon.true : field.icon.false\" \naria-label=\"icon\"></md-icon><span ng-switch-when=\"render\" class=\"{{field.key}}\" style=\"width:100%\" \nng-bind-html=\"field.render((data.hasOwnProperty(field.key) ? data[field.key] : \'undefined\'), data)\"></span> <span \nng-switch-when=\"link\" class=\"{{field.key}}\"><a ng-class=\"field.link.class ? field.link.class(data) : \'\' \" \nui-sref=\"{{ vm.getLink(field.link, data) }}\" ng-bind-html=\"field.render(data[field.key], data)\"></a></span> <span \nng-switch-when=\"icon-click\" class=\"{{field.key}}\"><md-button class=\"md-icon-button\" \nng-click=\"field.icon.click(data, $event)\" aria-label=\"{{ field.icon.aria || \'action link\' }}\">\n{{ field.render && field.render(\'\', data) }}<md-icon ng-show=\"!field.hasOwnProperty(\'render\')\" \nmd-font-icon=\"{{field.icon.class }}\"></md-icon></md-button></span><span ng-switch-when=\"email\" class=\"{{field.key}}\"><a\n class=\"userLink\" ng-href=\"mailto:{{field.render(data[field.key], data)}} \" \nng-bind-html=\"field.render(data[field.key], data)\"></a></span> <span ng-switch-when=\"button\" class=\"{{field.key}}\">\n<md-button class=\"{{ field.button.class }}\" ng-click=\"field.button.click(data, $event)\" \nng-bind-html=\"field.render(\'\', data)\" aria-label=\"{{ field.button.class  || \'action button\'}}\"></md-button></span><span\n ng-switch-when=\"tooltip\" class=\"{{field.key}}\" style=\"width:100%\" \nng-bind-html=\"field.render((data.hasOwnProperty(field.key) ? data[field.key] : \'undefined\'), data)\"><md-tooltip \nmd-direction=\"right\" \nng-bind-html=\"field.tooltip((data.hasOwnProperty(field.key) ? data[field.key] : \'undefined\'), data)\"></md-tooltip>\n</span></div></div></div></div></div><div class=\"genericTableFooter\" ng-show=\"vm.updateData\"><div \nclass=\"genericTablePaginationContainer\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\" \nlayout-align-xs=\"center center\"><div layout=\"row\"><div class=\"lastUpdateInfo\"><md-tooltip md-direction=\"top\">\nLast updated {{vm.lastUpdateText }}</md-tooltip><md-icon class=\"lastUpdateInfoIcon\" md-font-icon=\"icon-clock\">\n</md-icon><span hide-xs>{{ vm.lastUpdateText }}</span></div></div></div><div layout=\"column\" flex=\"60\"><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"vm.goToTablePage(\'prev\')\" \nng-disabled=\"vm.currentTablePageIndex===1\" aria-label=\"goToTablePage\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div class=\"genericTablePaginationInfo\"><label>Page:</label><md-input-container \nclass=\"genericTablePaginationInput\"><input class=\"paginationInput\" ng-model=\"vm.currentTablePageIndex\" \nng-change=\"vm.goToTablePage()\" ng-model-options=\"{debounce: 1500}\" type=\"number\" min=\"1\" max=\"{{vm.totalTablePages}}\" \naria-label=\"goToTablePageWithIndex\"></md-input-container><span class=\"paginationInputSeparator\">\n{{ vm.totalTablePages ? \'/ \' : \'...\' }}</span> <span class=\"paginationInputTotalPages\">{{ vm.totalTablePages }}</span>\n</div><md-button ng-disabled=\"vm.currentTablePageIndex>=vm.totalTablePages\" class=\"md-icon-button\" \nng-click=\"vm.goToTablePage(\'next\')\" aria-label=\"goToTablePage\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div></div><div layout=\"column\" flex=\"20\"></div></div></div></div></div>");
$templateCache.put("app/main/utility/directives/paginated-table/paginated-table.html","<div class=\"paginatedTableContentContainer {{vm.cssClass}}\"><div \nclass=\"paginatedTableContainer md-whiteframe-4dp roundCorners\"><div class=\"paginatedTableTopBar\" \nng-show=\"vm.updateData\"><div class=\"lastUpdate\"><div class=\"lastUpdateInfo\"><strong>Last update: </strong>\n{{ vm.lastUpdateText }}</div></div><div class=\"paginatedTableHeaderButtonsContainer\"><div \nclass=\"containerRefreshButton\" ng-hide=\"vm.hideUpdateData\"><md-icon ng-show=\"!vm.isDownloadingData && vm.updateData\" \nmd-font-icon=\"icon-refresh\" ng-click=\"vm.callUpdateData()\" aria-label=\"refresh\"></md-icon><md-progress-circular \nng-show=\"vm.isDownloadingData && vm.updateData\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"30\" \naria-label=\"loading\"></md-progress-circular><md-tooltip>{{ !vm.isDownloadingData ? \'Refresh\' : \'Loading\' }}\n</md-tooltip></div><div class=\"containerDownloadButton\" ng-click=\"vm.exportListAsCSV()\"><md-icon \nmd-font-icon=\"icon-download\" aria-label=\"csvDownload\"><md-tooltip><span>Export As CSV</span></md-tooltip></md-icon>\n</div></div></div><div class=\"paginatedTableMainContentContainer\"><div \nclass=\"paginatedTableRow paginatedTableRowHeader\"><div class=\"paginatedTableRowCell\" ng-repeat=\"field in vm.headers\" \nng-show=\"field.hasOwnProperty(\'hide\') ? !field.hide : true\" ng-click=\"vm.callApplyOrderBy(field.orderBy)\" \nng-class=\"field.class\">\n{{field.name}}{{field.orderBy ? (field.orderBy == vm.selectedOrderBy.orderBy) ? vm.selectedOrderBy.ascOrder ? \'&#x25B2;\' : \'&#x25BC;\' : \'\' : \'\'}}\n</div></div><div class=\"paginatedTable\"><div class=\"defaultText\" ng-hide=\"vm.currentData.length > 0\"><div \nng-show=\"!vm.isDownloadingData && vm.updateData\">\n{{ vm.dataHasLoaded && vm.currentData.length === 0 ? \'No Data Available\' : \'No data loaded\' }}</div></div><div \nclass=\"paginatedTableRow\" ng-repeat=\"data in vm.currentData\" ng-click=\"vm.onRowClick(data)\" \nng-style=\"{cursor: (vm.onRowClick) ? \'pointer\' : \'default\'}\"><div class=\"{{ \'paginatedTableRowCell \' + field.class }}\" \nng-show=\"field.hasOwnProperty(\'hide\') ? !field.hide : true\" ng-repeat=\"field in vm.headers\"><div \nng-show=\"!field.hasOwnProperty(\'type\')\" class=\"{{ \'\' + field.key + \' \' + (field.ellipsis ? \'ellipsis\' : \'\') }}\">\n{{data[field.key]}}</div><div ng-show=\"field.hasOwnProperty(\'type\')\" ng-switch=\"field.type\" \nclass=\"{{ \'\' + field.key + \' \' + (field.ellipsis ? \'ellipsis\' : \'\') }}\"><span ng-switch-when=\"icon-link\" \nclass=\"{{field.key}}\"><md-button class=\"md-icon-button centersSingleElement\" \nui-sref=\"{{ vm.getLink(field.icon, data) }}\" ng-click=\"$event.stopPropagation()\" aria-label=\"details\"><md-icon \nmd-font-icon=\"{{ field.icon.icon }}\" aria-label=\"icon\"></md-icon></md-button></span><md-icon \nng-switch-when=\"icon-boolean\" class=\"centersSingleElement {{ field.key }}\" \nng-class=\"data[field.icon.key] ? field.icon.true : field.icon.false\" aria-label=\"icon\"></md-icon><span \nng-switch-when=\"render\" class=\"{{field.key}}\" \nng-bind-html=\"field.render((data.hasOwnProperty(field.key) ? data[field.key] : \'undefined\'), data)\"></span> <span \nng-switch-when=\"link\" class=\"{{field.key}}\"><a ng-class=\"field.link.class ? field.link.class(data) : \'\' \" \nui-sref=\"{{ vm.getLink(field.link, data) }}\" ng-bind-html=\"field.render(data[field.key], data)\"></a></span> <span \nng-switch-when=\"icon-click\" class=\"{{field.key}}\"><md-button class=\"md-icon-button\" \nng-click=\"field.icon.click(data, $event)\" aria-label=\"{{ field.icon.aria || \'action link\' }}\">\n{{ field.render && field.render(\'\', data) }}<md-icon ng-show=\"!field.hasOwnProperty(\'render\')\" \nmd-font-icon=\"{{field.icon.class }}\"></md-icon></md-button></span><span ng-switch-when=\"email\" class=\"{{field.key}}\"><a\n class=\"userLink\" ng-href=\"mailto:{{field.render(data[field.key], data)}} \" \nng-bind-html=\"field.render(data[field.key], data)\"></a></span> <span ng-switch-when=\"button\" class=\"{{field.key}}\">\n<md-button class=\"{{ field.button.class }}\" ng-click=\"field.button.click(data, $event)\" \nng-bind-html=\"field.render(\'\', data)\" aria-label=\"{{ field.button.class  || \'action button\'}}\"></md-button></span>\n</div></div></div></div></div><div class=\"paginatedTableFooter\" ng-show=\"vm.dataHasLoaded\"><div \nclass=\"paginatedTablePaginationContainer\"><md-button class=\"md-icon-button\" ng-click=\"vm.goToTablePage(\'prev\')\" \nng-disabled=\"vm.currentTablePageIndex===1\" aria-label=\"goToTablePage\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div class=\"paginatedTablePaginationInfo\"><label>Page:</label><md-input-container \nclass=\"paginatedTablePaginationInput\"><input ng-model=\"vm.currentTablePageIndex\" ng-change=\"vm.goToTablePage()\" \ntype=\"number\" min=\"1\" max=\"{{vm.max}}\" aria-label=\"goToTablePageWithIndex\"></md-input-container><div>{{\" / \"+vm.max}}\n</div></div><md-button class=\"md-icon-button\" ng-click=\"vm.goToTablePage(\'next\')\" aria-label=\"goToTablePage\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/utility/directives/settings/two-hire-service-settings.html","<div id=\"twoHireServiceSettings\"><div class=\"mainTitlePaddingLevel roundCorners md-whiteframe-4dp\"><div \nclass=\"mainTitle\"><b class=\"mr-8\">{{vm.siteName}}</b>Service Settings</div><div class=\"mainContentLevel\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"mainTitle sectionTitle\">Global message</div><div \nng-show=\"!vm.isEditingServiceGlobalMessage\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleServiceGlobalMessageEditing()\" aria-label=\"modify\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.callDeleteServiceGlobalMessage()\" aria-label=\"delete\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div ng-if=\"vm.isEditingServiceGlobalMessage\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.callModifyServiceGlobalMessage()\" aria-label=\"toggleEditing\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleServiceGlobalMessageEditing()\" aria-label=\"toggleEditing\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\">\n<div class=\"fieldTitle\">Message</div><input class=\"inputField\" ng-model=\"vm.serviceGlobalMessage.message\" type=\"text\">\n</div></div></div><div class=\"mainTitle sectionTitle\">Mobile Apps version</div><div class=\"subSectionLevel\"><div \nclass=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">Minimum iOS version:</div><input \nclass=\"inputField\" ng-model=\"vm.serviceSettings.app.oldest.version.ios\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Minimum Android version:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.app.oldest.version.android\"></div></div></div><div class=\"mainTitle sectionTitle\">Service\n</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">\nLocale format:</div><div><input class=\"inputField inputFieldSmall\" \nng-class=\"{\'inputField-invalid\': vm.localeFieldInvalid}\" name=\"locale-format\" \nng-blur=\"vm.validateLocaleFormat($event)\" ng-model=\"vm.serviceSettings.service.locale.rfc5646LanguageCode\" \npattern=\"[a-z]{2}-[A-Z]{2}\" maxlength=\"5\"><div class=\"inputField-message\" ng-show=\"vm.localeFieldInvalid\">\nPlease use valid rfc 5646 format!</div></div></div><div class=\"contentRow\"><div class=\"fieldTitle\">Enabled 2FA</div>\n<md-checkbox class=\"checkboxInputField\" ng-model=\"vm.serviceSettings.service[\'2fa\'].enabled.value\" \naria-label=\"enableService2fa\"></md-checkbox></div></div></div><div class=\"mainTitle sectionTitle\">Vehicle settings\n</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">\nEnabled vehicle types</div><div class=\"twoInARowInputFields\"><div class=\"twoInARowInputFieldsElem\" \nng-repeat=\"multiVehicleType in vm.vehicleType\"><div class=\"fieldTitle\">{{multiVehicleType.name}}</div><md-checkbox \nclass=\"checkboxInputField\" ng-model=\"vm.serviceSettings.service.vehicle.enabled[multiVehicleType.value]\" \nng-change=\"vm.handleVehicleTypeEnableChange(multiVehicleType.value,$index)\" aria-label=\"enableVehicleType\">\n</md-checkbox></div></div></div><div class=\"contentRow\"><div class=\"fieldTitle\">Minimum fuel in percentage</div><div \nclass=\"twoInARowInputFields\"><div class=\"twoInARowInputFieldsElem\" \nng-repeat=\"multiVehicleType in vm.enabledVehicleTypes\"><div class=\"fieldTitle\">{{multiVehicleType.name}}</div><input \nclass=\"inputField numberInputField\" ng-model=\"vm.serviceSettings.service.vehicle.lowBattery[multiVehicleType.value]\" \ntype=\"number\" min=\"0\"></div></div></div><div class=\"contentRow\"><div class=\"fieldTitle\">Min autonomy in meters</div>\n<div class=\"twoInARowInputFields\"><div class=\"twoInARowInputFieldsElem\" \nng-repeat=\"multiVehicleType in vm.enabledVehicleTypes\"><div class=\"fieldTitle\">{{multiVehicleType.name}}</div><input \nclass=\"inputField numberInputField\" \nng-model=\"vm.serviceSettings.service.vehicle.lowAutonomyMeters[multiVehicleType.value]\" type=\"number\" min=\"0\"></div>\n</div></div></div></div><div class=\"mainTitle sectionTitle\">Availability hours</div><div class=\"subSectionLevel\"><div \nng-repeat=\"multiVehicleType in vm.enabledVehicleTypes\"><div class=\"mainTitle subSectionTitle\">{{multiVehicleType.name}}\n</div><div class=\"contentContainer\" \nng-repeat=\"schedules in vm.serviceSettings.service.availability[multiVehicleType.value].frames\"><div \nclass=\"mainTitle subSectionTitle\">Schedule {{$index+1}}<md-button class=\"md-icon-button\" \nng-click=\"vm.removeAvailabilityHour($index, multiVehicleType.value)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div><div class=\"contentRow\"><div class=\"fieldTitle\">Start time:</div><div class=\"twoInARowInputFields\">\n<div class=\"fieldTitle\">(HH 24h)</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.service.availability[multiVehicleType.value].frames[$index].start.hour\" type=\"number\" \nmin=\"$index\"><div class=\"fieldTitle\">(mm)</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.service.availability[multiVehicleType.value].frames[$index].start.minute\" type=\"number\" \nmin=\"0\"></div></div><div class=\"contentRow\"><div class=\"fieldTitle\">End time :</div><div class=\"twoInARowInputFields\">\n<div class=\"fieldTitle\">(HH 24h)</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.service.availability[multiVehicleType.value].frames[$index].end.hour\" type=\"number\" \nmin=\"0\"><div class=\"fieldTitle\">(mm)</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.service.availability[multiVehicleType.value].frames[$index].end.minute\" type=\"number\" \nmin=\"0\"></div></div></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-fab md-accent md-icon-button addThresholdButton\" ng-click=\"vm.addAvailabilityHour(multiVehicleType.value)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div><div class=\"mainTitle sectionTitle\">\nSignup settings</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Accept user documents by default:</div><md-checkbox class=\"checkboxInputField\" \nng-model=\"vm.serviceSettings.service.trustDocuments.value\" aria-label=\"acceptUserDocuments\"></md-checkbox></div><div \nclass=\"contentRow\"><div class=\"fieldTitle\">Free credit:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.formSpecific.freeCredit\" type=\"number\" min=\"0\"><md-button ng-if=\"vm.permitDelete\" \nclass=\"md-icon\" style=\"height:30px;min-height:30px;margin-top:0px\" \nng-click=\"vm.callDeleteServicePropertyConfirmDialog(vm.serviceSettings,[\'login\'],$event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"mainTitle sectionTitle\">Coupon settings\n</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">\nMax. number of users that a user can refer:</div><div class=\"inputFieldCoupon\"><input \nclass=\"inputField inputFieldSmall\" ng-model=\"vm.serviceSettings.coupon.maxCashbacks\" number-converter type=\"number\" \nmin=\"0\"><div class=\"inputField-message inputFieldCoupon-message\" \nng-if=\"vm.serviceSettings.coupon.maxCashbacks === \'0\'\">No Limits</div></div></div></div></div><div \nclass=\"mainTitle sectionTitle\">Booking settings</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div \nclass=\"contentRow\"><div class=\"fieldTitle\">Use bonuses\' value to preauthorize a trip</div><md-checkbox \nclass=\"checkboxInputField\" ng-model=\"vm.serviceSettings.booking.preauthorize.with.bonus.value\" \naria-label=\"preauthorizeInput\"></md-checkbox></div></div><div ng-repeat=\"multiVehicleType in vm.enabledVehicleTypes\">\n<div class=\"mainTitle subSectionTitle\">{{multiVehicleType.name}}<md-button ng-if=\"vm.permitDelete\" class=\"md-icon\" \nng-click=\"vm.callDeleteServicePropertyConfirmDialog(vm.serviceSettings,[\'booking.multi_vehicle.setupTime.\'+multiVehicleType.value,\'booking.multi_vehicle.bookingTime.\'+multiVehicleType.value],$event)\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"contentContainer\"><div class=\"contentRow\">\n<div class=\"fieldTitle\">Setup time (seconds):</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.booking.multi_vehicle.setupTime[multiVehicleType.value]\" type=\"number\" min=\"0\"></div><div \nclass=\"contentRow\"><div class=\"fieldTitle\">Booking time (seconds):</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.booking.multi_vehicle.bookingTime[multiVehicleType.value]\" type=\"number\" min=\"0\"></div>\n<div class=\"contentRow\"><div class=\"fieldTitle\">Start with QRCode</div><md-checkbox class=\"checkboxInputField\" \nng-model=\"vm.serviceSettings.booking.qrcode.auto_start[multiVehicleType.value]\" aria-label=\"qrcodeAutoStart\">\n</md-checkbox></div><div class=\"contentRow\"><div class=\"fieldTitle\">Close booking if stop fails</div><md-checkbox \nclass=\"checkboxInputField\" \nng-model=\"vm.serviceSettings.booking.multi_vehicle.closeBookingIfStopFails[multiVehicleType.value]\" \naria-label=\"closeBookingIfStopFails\"></md-checkbox></div></div></div></div><div class=\"mainTitle sectionTitle\">Pricing\n</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">VAT:\n</div><input class=\"inputField\" ng-model=\"vm.serviceSettings.movo.pricing.vat.value\" type=\"number\" min=\"0\"></div></div>\n<div class=\"mainTitle subSectionTitle\">Minimum charge<md-button ng-if=\"vm.permitDelete\" class=\"md-icon\" \nng-click=\"vm.callDeleteServicePropertyConfirmDialog(vm.serviceSettings,[\'movo.pricing.minimum_charge\'],$event)\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"contentContainer\"><div class=\"contentRow\">\n<div class=\"fieldTitle\">Value:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.movo.pricing.minimum_charge.value\" type=\"number\" min=\"0\"></div></div><div \nng-repeat=\"multiVehicleType in vm.enabledVehicleTypes\"><div class=\"mainTitle subSectionTitle\">{{multiVehicleType.name}}\n<md-button ng-if=\"vm.permitDelete\" class=\"md-icon\" \nng-click=\"vm.callDeleteServicePropertyConfirmDialog(vm.serviceSettings,[\'movo.pricing.multi_vehicle.time_thresholds.\'+multiVehicleType.value, \'movo.pricing.multi_vehicle.type.\'+multiVehicleType.value],$event)\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"subSectionLevel\"><div \nclass=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">Preauthorization amount:</div><input \nclass=\"inputField\" ng-model=\"vm.serviceSettings.booking.multi_vehicle.preauthorizeAmount[multiVehicleType.value]\" \ntype=\"number\" min=\"0\"></div></div></div><div class=\"subSectionLevel\"><div \nng-repeat=\"threshold in vm.serviceSettings.movo.pricing.multi_vehicle.time_thresholds[multiVehicleType.value].thresholds\">\n<div class=\"contentContainer\"><div class=\"mainTitle subSectionTitle\">Threeshold {{$index+1}}<md-button \nclass=\"md-icon-button\" ng-click=\"vm.removePricingThreeshold($index,multiVehicleType.value)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"contentRow\"><div class=\"fieldTitle\">Seconds:</div>\n<input class=\"inputField\" ng-model=\"threshold.ms\" type=\"number\" min=\"0\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Price:</div><input class=\"inputField\" ng-model=\"threshold.price\" type=\"number\" min=\"0\"></div></div>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-fab md-accent md-icon-button addThresholdButton\" ng-click=\"vm.addPricingThreeshold(multiVehicleType.value)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div></div><div class=\"mainTitle sectionTitle\">\nPayment settings</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Default Gateway:</div><md-select class=\"selectField md-no-underline\" \nng-model=\"vm.serviceSettings.payment.default.gateway\" aria-label=\"selectPaymentGateway\"><md-option value=\"adyen\">Adyen\n</md-option><md-option value=\"stripe\">Stripe</md-option><md-option value=\"stripe-sca\">Stripe SCA</md-option>\n</md-select></div><div \nng-if=\"vm.serviceSettings.payment.default.gateway === \'stripe\' || vm.serviceSettings.payment.default.gateway === \'stripe-sca\'\">\n<div class=\"contentRow\"><div class=\"fieldTitle\">Stripe API Token:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.stripe.token\"></div><div class=\"contentRow\"><div class=\"fieldTitle\">\nStripe Webhooks Secret:</div><input class=\"inputField\" ng-model=\"vm.serviceSettings.payment.stripe.secret\"></div><div \nclass=\"contentRow\"><div class=\"fieldTitle\">Stripe Webhooks Endpoint:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.stripe.endpoint\"></div></div><div \nng-if=\"vm.serviceSettings.payment.default.gateway === \'adyen\'\"><div class=\"contentRow\"><div class=\"fieldTitle\">\nAuthentication username:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.adyen.service.httpAuth.username\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Authentication password:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.adyen.service.httpAuth.password\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Merchant account:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.adyen.service.merchantAccount\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Checkout API url:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.adyen.service.apiUrls.checkout\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Checkout API key:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.adyen.service.checkoutApiKey\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Payment API url:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.adyen.service.apiUrls.payment\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Recurring API url:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.adyen.service.apiUrls.recurring\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Webhook password:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.payment.webhook.password\"></div></div></div></div><div class=\"mainTitle sectionTitle\">\nFirebase settings</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Firebase Token:</div><input class=\"inputField\" ng-model=\"vm.serviceSettings.firebase.auth\"></div>\n</div></div><div class=\"mainTitle sectionTitle\">Geofencing settings</div><div class=\"subSectionLevel\"><div \nng-repeat=\"multiVehicleType in vm.enabledVehicleTypes\"><div class=\"mainTitle subSectionTitle\">{{multiVehicleType.name}}\n<md-button ng-if=\"vm.permitDelete\" class=\"md-icon\" \nng-click=\"vm.callDeleteServicePropertyConfirmDialog(vm.serviceSettings,[\'geofencing.sharing.multi_vehicle.rate.\'+multiVehicleType.value],$event)\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"contentContainer\"><div class=\"contentRow\">\n<div class=\"fieldTitle\">Allow stop out of geofence</div><md-checkbox class=\"checkboxInputField\" \nng-model=\"vm.serviceSettings.booking.multi_vehicle.allowStopOutOfGeoFence[multiVehicleType.value]\" \naria-label=\"allowStopOutOfGeoFence\"></md-checkbox></div><div class=\"contentRow\"><div class=\"fieldTitle\">\nOutside area fare price:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.geofencing.sharing.multi_vehicle.rate[multiVehicleType.value].price\" type=\"number\" \nmin=\"0\"></div><div class=\"contentRow\" \nng-if=\"vm.serviceSettings.geofencing.sharing.multi_vehicle.rate[multiVehicleType.value].type == vm.outsideAreafareType.MINUTES.value\">\n<div class=\"fieldTitle\">Outside area fare value:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.geofencing.sharing.multi_vehicle.rate[multiVehicleType.value].value\" min=\"1\"></div></div>\n</div></div><div class=\"mainTitle sectionTitle\">Mail settings</div><div class=\"subSectionLevel\"><div \nclass=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">Sender name:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.mail.from.name\"></div><div class=\"contentRow\"><div class=\"fieldTitle\">Sender address:\n</div><input class=\"inputField\" ng-model=\"vm.serviceSettings.mail.from.address\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Sendgrid token:</div><input class=\"inputField\" ng-model=\"vm.serviceSettings.mail.token\"></div><div \nclass=\"contentRow\"><div class=\"fieldTitle\">Signup template url:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.mail.signup\"></div><div class=\"contentRow\"><div class=\"fieldTitle\">\nAll documents confirmed template url:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.mail.confermation_user\"></div><div class=\"contentRow\"><div class=\"fieldTitle\">\nRejected ID template url:</div><input class=\"inputField\" ng-model=\"vm.serviceSettings.mail.document_error_user\"></div>\n<div class=\"contentRow\"><div class=\"fieldTitle\">Rejected driving license template url:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.mail.driving_license_error_user\"></div><div class=\"contentRow\"><div class=\"fieldTitle\">\nTrip recap template url:</div><input class=\"inputField\" ng-model=\"vm.serviceSettings.mail.payment_succes\"></div></div>\n</div><div class=\"mainTitle sectionTitle\">Ticket settings</div><div class=\"subSectionLevel\"><div \nclass=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">Default type:</div><md-select \nclass=\"selectField md-no-underline\" ng-model=\"vm.serviceSettings.invoice.sharing.default.type\" \naria-label=\"invoiceSharingDefaultType\"><md-option ng-value=\"option.value\" ng-repeat=\"option in vm.invoiceType\">\n{{option.name}}</md-option></md-select></div><div class=\"contentRow\"><div class=\"fieldTitle\">Template Ticket:</div><div\n class=\"uploadButtonContainer\"><label for=\"{{\'template_invoice_hbs_\' + vm.siteName}}\">Upload HBS file</label><span>\n(will upload immediately)</span> <input type=\"file\" id=\"{{\'template_invoice_hbs_\' + vm.siteName}}\" \nname=\"{{\'template_invoice_hbs_\' + vm.siteName}}\" accept=\".hbs\" \nng-upload-change=\"vm.handleFileUpload($event, vm.siteId)\"></div></div></div></div><div class=\"mainTitle sectionTitle\">\nTOS</div><div class=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">\nTOS URL</div><input class=\"inputField\" ng-model=\"vm.serviceSettings.service.tos.link\"></div></div></div><div \nng-if=\"vm.showAppTranslations\"><div class=\"mainTitle sectionTitle\">Mobile App Translations</div><div \nclass=\"subSectionLevel\"><div class=\"contentContainer\"><div class=\"contentRow\"><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Inspect:</div><div><md-button class=\"md-raised md-accent roundedButton\" md-no-ink \nng-click=\"vm.goToTranslationsPage()\">View</md-button></div></div></div></div></div></div><div \nclass=\"mainTitle sectionTitle\">IOT settings</div><div class=\"subSectionLevel\"><div class=\"mainTitle subSectionTitle\">\nNIU</div><div class=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">NIU App ID:</div><input \nclass=\"inputField\" ng-model=\"vm.serviceSettings.vehicle.adapter.niu.appId\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">NIU App Secret:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.vehicle.adapter.niu.appSecret\"></div></div><div class=\"mainTitle subSectionTitle\">Segway\n</div><div class=\"contentContainer\"><div class=\"contentRow\"><div class=\"fieldTitle\">Segway base url:</div><input \nclass=\"inputField\" ng-model=\"vm.serviceSettings.vehicle.adapter.segway.baseUrl\"></div><div class=\"contentRow\"><div \nclass=\"fieldTitle\">Segway Client ID:</div><input class=\"inputField\" \nng-model=\"vm.serviceSettings.vehicle.adapter.segway.clientId\"></div><div class=\"contentRow\"><div class=\"fieldTitle\">\nSegway Client Secret:</div><input class=\"inputField\" ng-model=\"vm.serviceSettings.vehicle.adapter.segway.clientSecret\">\n</div></div></div><div class=\"buttonFooter\"><md-button class=\"md-raised md-accent roundedButton\" md-no-ink \nng-click=\"vm.onUpdateServiceSettings()\">Update settings</md-button></div></div></div></div>");
$templateCache.put("app/main/utility/directives/tile-with-footer-color/tile-with-footer-color.html","<div id=\"twoHireTileWithFooterColor\" class=\"tileContainer\"><div class=\"tileToolbar\"><md-menu md-offset=\"-225 48\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><p \nstyle=\"font-weight:600\">Details</p></md-menu-item><md-menu-item><p style=\"width:250px\">{{description}}</p>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"tileContent\"><div class=\"tileTitle\" \nng-style=\"{\'color\': color}\">{{title}}</div><div class=\"tileValue\">{{value}}</div></div><div class=\"tileFooter\" \nng-style=\"{\'background-color\': color}\"></div></div>");
$templateCache.put("app/main/utility/directives/two-hire-autocomplete/two-hire-autocomplete.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" flex=\"30\"><md-select placeholder=\"Filter\" \nng-model=\"vm.selectedSearchFilter\" aria-label=\"search filters\" ng-disabled=\"vm.disabled\"><md-option \nng-selected=\"count===0\" ng-value=\"filter\" ng-click=\"vm.setOptionFilter(filter)\" \nng-repeat=\"(count,filter) in vm.options\">{{filter.name}}</md-option></md-select></div><div layout=\"column\" flex=\"70\">\n<md-autocomplete ng-disabled=\"vm.disabled\" md-no-cache=\"\'true\'\" md-search-text=\"vm.searchText\" \nmd-selected-item=\"vm.selectedItem\" md-selected-item-change=\"vm.updateSelectedItem(item)\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"vm.getItemText(item)\" md-min-length=\"1\" md-delay=\"800\" \nplaceholder=\"{{ \'Search by \' + vm.selectedSearchFilter.name }}\" class=\"twoHireAutocomplete\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{ vm.getItemText(item) }}</span></md-item-template>\n<md-not-found>No items matching \"{{vm.searchText}}\" found</md-not-found></md-autocomplete></div></div>");
$templateCache.put("app/main/utility/directives/vehicle/execute-vehicle-commands.html","<div class=\"executeVehicleCommandsContainer\"><p class=\"title-details\">Execute these commands:</p><div layout=\"column\">\n<p class=\"title-details-inner\">Select vehicle type</p><md-select placeholder=\"Vehicle type\" ng-model=\"vm.vehicleType\" \naria-label=\"selectVehicleType\"><md-option ng-repeat=\"vehicleType in vm.vehicleTypes\" ng-value=\"vehicleType.value\" \nng-click=\"vm.initVehicleCommands(vehicleType.value)\">{{vehicleType.name}}</md-option></md-select></div><div \nlayout=\"column\"><p class=\"title-details-inner\">Select the commands</p><div layout=\"column\" \nng-repeat=\"command in vm.commands track by $index\"><div flex layout=\"row\" layout-align=\"space-between center\">\n<md-select flex placeholder=\"Command\" ng-model=\"vm.commands[$index]\" aria-label=\"selectCommand\"><md-option \nng-repeat=\"availableCommand in vm.availableCommands\" ng-value=\"availableCommand\">{{availableCommand.name}}</md-option>\n</md-select><div layout=\"row\"><md-button ng-show=\"$index>0\" class=\"md-fab md-accent md-icon-button smallFabButton\" \nng-click=\"vm.removeACommand($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button><md-button \nclass=\"md-fab md-accent md-icon-button smallFabButton\" ng-click=\"vm.addACommand($index)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div></div><md-button class=\"md-raised\" \nng-click=\"vm.onUpdateClick({executeCommandsOnVehicles: vm.executeCommandsOnVehicles})\">Execute commands</md-button>\n</div>");
$templateCache.put("app/main/utility/directives/vehicle/two-hire-vehicle-map.html","<div id=\"twoHireVehicleMap\"><div class=\"map-buttons-container\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-fab md-raised md-secondary\" ng-show=\"vm.lastClickedVehicleWatcher.watcher.path.getPath().length>0\" \naria-label=\"center\" \nng-click=\"vm.panTo(vm.lastClickedVehicleWatcher.watcher.path.getPath().getAt(vm.lastClickedVehicleWatcher.watcher.path.getPath().getLength()-1))\">\n<md-icon md-font-icon=\"icon-image-filter-center-focus\"></md-icon></md-button><md-button \nclass=\"md-fab md-raised md-secondary\" ng-show=\"vm.lastClickedVehicleWatcher.watcher.path.getPath().length>0\" \naria-label=\"stop\" ng-click=\"vm.stopVehiclesWatchers()\">Stop</md-button></div><ui-gmap-google-map \nng-if=\"vm.mapProvider === vm.MapProvider.GOOGLE_MAPS\" center=\"vm.mapData.center\" zoom=\"vm.mapData.zoom\" \nevents=\"vm.mapData.events\" options=\"vm.mapData.options\"></ui-gmap-google-map><div \nng-show=\"vm.mapProvider === vm.MapProvider.MAPBOX\" id=\"mapboxMap\"></div></div>");
$templateCache.put("app/main/utility/directives/vehicle/update-segway-settings.html","<div class=\"updateSegwaySettingsContainer\"><p class=\"title-details\">Update Segways settings:</p><div layout=\"column\"><p\n class=\"title-details-inner\">Base settings</p><md-checkbox ng-model=\"vm.settings.buttonSwitchSpeedMode\">\nEnable switch speed mode button</md-checkbox></div><div layout=\"column\"><p class=\"title-details-inner\">\nSpeed limit settings</p><div layout=\"row\" layout-align=\"space-between center\"><md-input-container><label>\nLow speed limit</label><input ng-model=\"vm.settings.lowSpeedLimit\" type=\"number\" min=\"6\" max=\"25\"></md-input-container>\n<md-input-container><label>Medium speed limit</label><input ng-model=\"vm.settings.mediumSpeedLimit\" type=\"number\" \nmin=\"6\" max=\"25\"></md-input-container><md-input-container><label>High speed limit</label><input \nng-model=\"vm.settings.highSpeedLimit\" type=\"number\" min=\"6\" max=\"25\"></md-input-container></div></div><md-button \nclass=\"md-raised\" ng-click=\"vm.onUpdateClick({updateSegwayVehicle: vm.updateSegwaySetting})\">Update settings\n</md-button></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/coupon/template/details/dialogs/coupon-bonus-add-dialog.html","<md-dialog class=\"coupon-bonus-add-dialog\" aria-label=\"Add New template\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Add Redeem Code</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-content flex class=\"md-padding\" layout=\"column\"><form name=\"addCouponForm\" \nclass=\"md-inline-form\" novalidate><div><p class=\"title-details\">Select Campaign:</p><two-hire-autocomplete \noptions=\"vm.searchOptions\" set-result=\"vm.setTemplate\" selected-item=\"vm.couponTemplate\"></two-hire-autocomplete></div>\n<div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\"><md-input-container flex class=\"md-block md-icon-float flex\">\n<label>Code</label><input ng-model=\"vm.coupon.code\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"vm.callAddCoupon()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"addCouponForm.$invalid || addCouponForm.$pristine\" aria-label=\"Add Coupon\">ADD</md-button></div></form>\n</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/invoice/views/compact/compact.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div \nlayout=\"row\" layout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">TICKET</span> <span class=\"number\">\n{{vm.invoice.number}}</span></div><div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"INVOICE.DUE_DATE\">DUE DATE</span> <span class=\"date\">{{vm.invoice.dueDate}}</span></div><div class=\"info\">\n<div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div>\n<div ng-if=\"vm.invoice.client.email\" class=\"email\">{{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\">{{vm.invoice.client.website}}</div></div></div><div \nclass=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.from.title}}</div>\n<div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" \nclass=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table class=\"simple invoice-table\">\n<thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">\n{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">\n{{service.total | currency}}</td></tr><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td \nclass=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" \ntranslate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/invoice/views/rentalAgreement/rentalAgreement.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><md-button \nclass=\"md-fab md-accent md-icon-button\" ng-click=\"vm.printRentalAgreement()\" aria-label=\"print\" translate \ntranslate-attr-aria-label=\"\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button><div id=\"invoice-container\" \nclass=\"invoice-container\"><style>\n.reservationLetterHeader {\n                height: 100px;\n                width: 100%;\n                display: flex;\n                margin-bottom: 8px;\n            }\n\n            .reservationLetterFirstSection {\n                width: 100%;\n                height: 90px;\n                display: flex;\n                padding: 4px;\n                overflow: hidden !important;\n                margin-bottom: 4px;\n            }\n\n            .reservationLetterSecondSection {\n                width: 100%;\n                height: auto;\n                display: flex;\n                padding: 4px;\n            }\n\n            .reservationLetterThirdSection {\n                width: 100%;\n                height: auto;\n                display: flex;\n                padding: 4px;\n            }\n\n            .reservationLetterImageContainer {\n                min-height: 100px;\n                max-height: 100px;\n                width: 300px;\n                object-fit: contain;\n            }\n\n            .reservationLetterCompanyInfo {\n                min-height: 100px;\n                max-height: 100px;\n                width: 300px;\n                margin-left: auto;\n                font-size: 10px;\n            }\n\n            .reservationLetterCompanyInfo p {\n                text-align: center;\n            }\n\n            .reservationLetterCompanyInfo p:first-child {\n                margin-top: 8px !important;\n            }\n\n            .reservationLetterCreditCardContainer {\n                height: 100%;\n                width: 45%;\n                border-left-color: #C7C7CD;\n                border-bottom-color: #C7C7CD;\n                border-width: 0px;\n                border-left-width: 4px;\n                border-bottom-width: 4px;\n                border-style: solid;\n            }\n\n            .reservationLetterCreditCardContainer p {\n                margin-left: 8px;\n                margin-top: 8px;\n            }\n\n            .reservationLetterCreditCardContainer p:first-child {\n                font-size: 10px;\n                margin-top: 0px;\n            }\n\n            .reservationLetterCreditCardContainer p:not(:first-child) {\n                font-size: 8px;\n            }\n\n            .numberExpirationContainer {\n                display: flex;\n            }\n\n            .numberExpirationContainer p:first-child {\n                margin-right: 4px;\n                margin-top: 8px;\n                font-size: 8px;\n            }\n\n            .numberExpirationContainer p:not(:first-child) {\n                margin-right: 4px;\n                margin-top: 8px;\n                font-size: 8px;\n            }\n\n            .reservationLetterNumberContainer {\n                height: 100%;\n                width: 45%;\n                margin-left: 10%;\n                border-left-color: #C7C7CD;\n                border-width: 0px;\n                border-left-width: 4px;\n                border-style: solid;\n                padding-left: 4px;\n                padding-right: 4px;\n            }\n\n            .reservationLetterNumberContainer p {\n                font-size: 10px;\n                margin-top: 8px;\n                font-weight: bold;\n            }\n\n            .reservationLetterNumberContainer p:first-child {\n                margin-top: 0px;\n            }\n\n            #reservationLetterNR {\n                border-bottom-color: #C7C7CD;\n                border-width: 0px;\n                border-bottom-width: 1px;\n                border-style: solid;\n                padding-bottom: 4px;\n            }\n\n            .reservationLetterSecondSectionColumn {\n                width: 24%;\n                height: auto;\n                border-left-color: #C7C7CD;\n                border-width: 0px;\n                border-left-width: 1px;\n                border-style: solid;\n                padding-left: 4px;\n                padding-right: 4px;\n                border-bottom-color: #C7C7CD;\n                border-bottom-width: 2px;\n            }\n\n            .reservationLetterSecondSectionColumn:first-child {\n                width: 43%\n            }\n\n            .reservationLetterSecondSectionColumn:last-child {\n                width: 29%;\n            }\n\n            .reservationLetterSecondSectionColumnCell {\n                width: 100%;\n                min-height: 34px;\n                margin-bottom: 4px;\n                border-bottom-color: #C7C7CD;\n                border-width: 0px;\n                border-bottom-width: 2px;\n                border-style: solid;\n                padding-bottom: 4px;\n            }\n\n            .reservationLetterSecondSectionColumnCell p:first-child {\n                font-size: 10px;\n                font-weight: bold;\n            }\n\n            .reservationLetterSecondSectionColumnCell p:not(:first-child) {\n                font-size: 9px;\n            }\n\n            .reservationLetterSecondSectionColumnCell:last-child {\n                border-bottom: 0px;\n            }\n\n            .sameLineParagraphsContainerInCell {\n                display: flex;\n            }\n\n            .sameLineParagraphsContainerInCell p:first-child {\n                font-size: 8px;\n                font-weight: normal;\n                margin-right: 12px\n            }\n\n            .sameLineParagraphsContainerInCell p:not(:first-child) {\n                font-size: 8px;\n                font-weight: normal;\n                margin-right: 12px\n            }\n\n            #responsable p {\n                font-size: 8px;\n            }\n\n            .reservationLetterThirdSectionColumn {\n                width: 80%;\n                height: auto;\n                border-right-color: #C7C7CD;\n                border-width: 0px;\n                border-right-width: 1px;\n                border-style: solid;\n                padding-left: 4px;\n                padding-right: 4px;\n                text-align: center;\n                padding-top: 0px;\n            }\n\n            .legalizedText {\n                font-size: 2px;\n                margin-top: 4px;\n            }\n\n            .signature {\n                margin-top: 4px;\n                font-weight: bold;\n                text-align: left;\n                margin-bottom: 4px;\n            }\n\n            .reservationLetterThirdSectionColumn:last-child{\n                width: 20%;\n            }\n\n            .reservationLetterThirdSectionColumn .reservationLetterSecondSectionColumnCell{\n                min-height: 28px;\n            }\n\n            .reservationLetterThirdSectionColumn .reservationLetterSecondSectionColumnCell p{\n                font-size: 8px;\n            }\n\n            /* PRINT STYLES */\n            @media print {\n\n                html,body{\n                    margin: 0;\n                }\n            }\n</style><div class=\"reservationLetterHeader\"><img class=\"reservationLetterImageContainer\" \nsrc=\"http://www.myvespaworld.com/img/cms/MYVESPA.png\"><div class=\"reservationLetterCompanyInfo\"><p><b>Two S.r.l</b></p>\n<p>Via Cavour 80, 00184 (RM), Roma</p><p>Tel. 06 4815669 Fax 064881329</p><p>P.IVA 13638211006</p></div></div><div \nclass=\"reservationLetterFirstSection\"><div class=\"reservationLetterCreditCardContainer\"><p><b>Carta di Credito</b></p>\n<p>Tipo {{vm.rentalAgreement.Payment.brand}}</p><p>\nIntestata {{vm.rentalAgreement.User.name}} {{vm.rentalAgreement.User.surname}}</p><div \nclass=\"numberExpirationContainer\"><p>Numero: {{vm.rentalAgreement.Payment.pan}}</p><p>\nScadenza: {{vm.rentalAgreement.Payment.exp_month}} / {{vm.rentalAgreement.Payment.exp_year}}</p></div></div><div \nclass=\"reservationLetterNumberContainer\"><p><b>LETTERA DI NOLEGGIO</b></p><p id=\"reservationLetterNR\">\nNR. {{vm.rentalAgreement.id}}</p><p>NR.RA</p></div></div><div class=\"reservationLetterSecondSection\"><div \nclass=\"reservationLetterSecondSectionColumn\"><div class=\"reservationLetterSecondSectionColumnCell\"><p>Fatturare a</p>\n</div><div class=\"reservationLetterSecondSectionColumnCell\"><p>Guidatore</p><p>\n{{vm.rentalAgreement.Drivers[0].name}} {{vm.rentalAgreement.Drivers[0].surname}}</p><p>\n{{vm.rentalAgreement.Drivers[0].residence}}</p><p>{{vm.rentalAgreement.Drivers[0].birth | toDate}}</p><p>\nDocumento: {{vm.getDocumentType(vm.rentalAgreement.Drivers[0].identity_type)}} Nr: {{vm.rentalAgreement.Drivers[0].identity_id}}\n</p></div><div class=\"reservationLetterSecondSectionColumnCell\"><p>Altro guidatore</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>Prenotazione</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>Supplementi</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>Annotazioni</p></div></div><div \nclass=\"reservationLetterSecondSectionColumn\"><div class=\"reservationLetterSecondSectionColumnCell\"><p>Veicolo</p><p>\n{{vm.rentalAgreement.Vehicle.license_plate}}</p><p>{{vm.rentalAgreement.Vehicle.brand}}</p><p>\n{{vm.rentalAgreement.Vehicle.model_name}}</p><p>\nOut KM: 1100 Gas: {{vm.rentalAgreement.Vehicle.Fuel[0].percentage |number:2}}%</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>Tariffa/Gruppo</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>Assicurazioni</p><p>CDW: INCLUSA</p><p>TP: NON INCLUSA</p><p>\nPAI: NON INCLUSA</p></div><div class=\"reservationLetterSecondSectionColumnCell\"><p>Super Insurance</p><p>\nS.PAI: NON INCLUSA</p></div><div class=\"reservationLetterSecondSectionColumnCell\"><p>Super Plus Insurance</p><p>\nS.PLUS: NON INCLUSA</p></div><div class=\"reservationLetterSecondSectionColumnCell\"><p>Franchigie</p><p>\nFranchigia furto:</p><p>Franchigia danni:</p></div><div class=\"reservationLetterSecondSectionColumnCell\"><p>Pagamento\n</p></div><div class=\"reservationLetterSecondSectionColumnCell\"><p>Cauzione</p></div></div><div \nclass=\"reservationLetterSecondSectionColumn\"><div class=\"reservationLetterSecondSectionColumnCell\"><p>Consegna</p><p>\n</p></div><div class=\"reservationLetterSecondSectionColumnCell\"><p>Rientrata data e ora</p><p>\n{{vm.rentalAgreement.start | toDate:\"dateTime\":vm.rentalAgreement.SiteId}}</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>Uscita data e ora</p><p>\n{{vm.rentalAgreement.end | toDate:\"dateTime\":vm.rentalAgreement.SiteId}}</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>Tariffe</p><p>Giorni/Tariffa:</p><p>Imponibile:</p><p>Aliq. IVA:\n</p><p>Imposta:</p><p><b>Totale Noleggio:</b></p></div><div class=\"reservationLetterSecondSectionColumnCell\" \nid=\"responsable\"><p>QUALE RESPONSABILE SOLIDALE DEL GUIDATORE</p></div></div></div><div \nclass=\"reservationLetterThirdSection\"><div class=\"reservationLetterThirdSectionColumn\"><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>Uscita data e ora</p><p class=\"legalizedText\">\nRiconosco ed accetto fin d’ora tutte le spese (carburante, franchigie assicurative, multe o danni) rilevate o riscontrate dopo la riconsegna della vettura e autorizzo l’auto-moto noleggio ad addebitare sulla mia carta di credito. Accetto che il costo per la gestione della pratica di ogni singolo verbale è di € 30+IVA\n</p><p class=\"legalizedText\">\nI acknowledge and accebt beforehand all the expenses (fuel, insurance deductibles, fines, tolls and damages) registered or made known after the vehicle’s redelivery and authorize the rental company to charge my credit card for them. Furthermore, I accept beforehand the payment and charge of €30+VAT as reimbursement for the management of every specific fine or toll.\n</p><p class=\"signature\">Signature</p><p class=\"legalizedText\">\nAcconsento al trattamento dei dati personali così come prescritti nella “Legge sulla privacy” del 31 dicembre 1996, n675 e dichiaro di aver letto e di accettare integralmente il contratto di noleggio come riportato nella sezione “Termini contratto” del sito www.onroad.it, ed in particolare di approvare specificatamente, ai sensi dell’Art. 1341 c.c le clausole di cui ai punti 3, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15, e 16.\n</p><p class=\"signature\">Signature</p></div></div><div class=\"reservationLetterThirdSectionColumn\"><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>RIMBORSATO</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>RIMBORSATO R.TO</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>OUT BY</p></div><div \nclass=\"reservationLetterSecondSectionColumnCell\"><p>IN BY</p></div></div></div></div></div>");
$templateCache.put("app/main/pages/invoice/views/rentalAgreement/rentalAgreement.old.html","<div class=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"column\"><div layout=\"row\"><span flex=\"60\"></span><table\n class=\"summary\"><tr class=\"code\"><td class=\"label\" translate=\"INVOICE.INVOICE\">TICKET</td><td class=\"value\"></td></tr>\n<tr><td class=\"label\" translate=\"INVOICE.INVOICE_DATE\">TICKET DATE</td><td class=\"value\">{{vm.todayDate | toDate}}</td>\n</tr></table></div><div class=\"ids\" layout=\"row\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"center center\"><img src=\"assets/images/invoce/MyVespa-LOGO.png\"></div><div \nclass=\"divider\"></div><div class=\"detail\"><div class=\"title\">Ges.mo S.r.l</div><div class=\"phone\"><span \ntranslate=\"INVOICE.VAT\">VAT</span>: 13638461007</div><div class=\"address\">Via Cavour 80, 00184 (RM) ROMA</div><div \nclass=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>: 064815669</div></div></div><div layout=\"row\" \nclass=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div \ntranslate=\"INVOICE.CLIENT\">CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{vm.rentalAgreement.User.surname}} {{vm.rentalAgreement.User.name}}</div><div class=\"title\">\n{{vm.rentalAgreement.User.cf}}</div><div ng-if=\"vm.rentalAgreement.User.residence\" class=\"address\">\n{{vm.rentalAgreement.User.residence}}</div><div class=\"title\">\n{{vm.rentalAgreement.User.cap}} {{vm.rentalAgreement.User.residence_city}} {{vm.rentalAgreement.User.residence_state}} {{vm.rentalAgreement.User.residence_country}}\n</div><div ng-if=\"vm.rentalAgreement.User.tel\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>\n: {{vm.rentalAgreement.User.tel}}</div><div ng-if=\"vm.rentalAgreement.User.email\" class=\"email\"><span \ntranslate=\"INVOICE.EMAIL\">Email</span>: {{vm.rentalAgreement.User.email}}</div></div></div></div></div><div \nclass=\"content\"><p class=\"table-title\">Rental info</p><table class=\"simple invoice-table invoice-table-container\">\n<thead><th>Start</th><th>Pickup place</th><th>End</th><th>Return Place</th></thead><tbody><td>\n{{vm.rentalAgreement.start |toDate:\'dateTime\':vm.rentalAgreement.SiteId}}</td><td>{{vm.rentalAgreement.PickUp.address}}\n</td><td>{{vm.rentalAgreement.end | toDate:\'dateTime\':vm.rentalAgreement.SiteId}}</td><td>\n{{vm.rentalAgreement.Return.address}}</td></tbody></table><p class=\"table-title\">Driver info</p><table \nclass=\"simple invoice-table invoice-table-container\"><thead><tr><th>Name</th><th>Surname</th><th>License ID</th><th>\nLicense Release</th><th>License Issue City</th><th>License Expiration</th></tr></thead><tbody><tr \nng-repeat=\"driver in vm.rentalAgreement.Drivers\"><td>{{driver.name}}</td><td>{{driver.surname}}</td><td>\n{{driver.license_id}}</td><td>{{driver.license_release | toDate}}</td><td>{{driver.license_place}}</td><td>\n{{driver.license_expiration | toDate}}</td></tr></tbody></table><p class=\"table-title\">Vehicle info</p><table \nclass=\"simple invoice-table invoice-table-container\"><thead><th>License plate</th><th class=\"text-right\">Category</th>\n<th class=\"text-right\">Brand</th><th class=\"text-right\">Model Name</th><th class=\"text-right\">Km Out</th><th \nclass=\"text-right\">Gas</th></thead><tbody><td>{{vm.rentalAgreement.Vehicle.license_plate}}</td><td class=\"text-right\">\n{{vm.rentalAgreement.CategoryRent.name}}</td><td class=\"text-right\">{{vm.rentalAgreement.Vehicle.brand}}</td><td \nclass=\"text-right\">{{vm.rentalAgreement.Vehicle.model_name}}</td><td class=\"text-right\">\n{{vm.rentalAgreement.Vehicle.km}} km</td><td class=\"text-right\">Full</td></tbody></table><p class=\"table-title\">\nRate info</p><table class=\"simple invoice-table invoice-table-container\"><thead><th>Type</th><th class=\"text-right\">\nDaily Price</th><th class=\"text-right\">Total</th></thead><tbody><tr ng-repeat=\"rate in vm.rentalAgreement.Rates\"><td>\n<div class=\"title\">{{rate.name}}</div></td><td class=\"text-right\">{{rate.day}}/gg</td><td class=\"text-right\">\n{{rate.price}} €</td></tr></tbody></table><p class=\"table-title\">Credit Card info</p><table \nclass=\"simple invoice-table invoice-table-container\"><thead><th>Card number</th><th class=\"text-right\">Card Type</th>\n<th class=\"text-right\">Card Expiration Date</th></thead><tbody><td>{{vm.rentalAgreement.Payment.pan}}</td><td \nclass=\"text-right\">{{vm.rentalAgreement.Payment.brand}}</td><td class=\"text-right\">\n{{vm.rentalAgreement.Payment.exp_month}} / {{vm.rentalAgreement.Payment.exp_year}}</td></tbody></table><table \nclass=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">SUBTOTAL</td><td>\n{{vm.rentalAgreement.price}} €</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>0 €</td></tr><tr \nclass=\"tax\"><td translate=\"INVOICE.SECURITY_DEPOSIT\">SECURITY DEPOSIT</td><td>-{{vm.rentalAgreement.deposit}} €</td>\n</tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>-{{vm.rentalAgreement.discount}} €</td>\n</tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>{{vm.rentalAgreement.price}} €</td></tr></tbody>\n</table></div><div class=\"footer\"><div layout=\"row\" layout-align=\"start start\"><div class=\"small-note\" \ntranslate=\"INVOICE.SMALL_NOTE1\">\nI acknowledge an accept beforehand all expenses (fuel, insurance deductibles, fines, tolls and damages) registered or made known after the vehicle’s redelivery and authorize the rental company to charge my credit card for them. Furthermore, I accept beforehand the payment and charge of € 30 + VAT as reimbursement for the management of every specific fine or toll.\n</div><div class=\"divider\"></div><div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE2\">\nAcconsento al trattamento dei dati personali cosí come prescritti nella “Legge sulla privacy” del 31 dicembre 1996, n 675 e dichiaro di aver letto e di accettare integralmente il contratto di noleggio così come riportato nella sezione “ Termini Contratto” del sito www.onroad.it, ed in particolare di approvare specificatamente ai sensi dell’ Art. 1341 c.c le clausole di cui ai punti 3, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15, e 16.\n</div></div></div></div><div class=\"page-break\"></div>");
$templateCache.put("app/main/rent/gantt-chart/dialogs/add-edit/add-dialog.html","<md-dialog class=\"gantt-chart-add-edit-dialog\" aria-label=\"Add Dialog\"><md-toolbar class=\"md-accent\" \nstyle=\"background-color: #f9b54c\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Add</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs \nmd-dynamic-height><form id=\"reservationForm\" name=\"reservationForm\" ng-submit=\"vm.callAddReservationAddDialog()\">\n<md-tab md-on-select=\"vm.onTabSelect(0)\"><md-tab-label><span translate=\"GANTT.ADD_RESERVATION\">Reservation</span>\n</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/rent/gantt-chart/dialogs/add-edit/views/reservation-form-view.html\'\"></div></md-tab-body>\n</md-tab></form><form id=\"rentalAgreementForm\" name=\"rentalAgreementForm\" \nng-submit=\"vm.callAddRentalAgreementAddDialog()\"><md-tab md-on-select=\"vm.onTabSelect(1)\"><md-tab-label><span \ntranslate=\"GANTT.ADD_RENTAL_AGREEMENT\">Rental Agreement</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/rent/gantt-chart/dialogs/add-edit/views/rental-agreement-form-view.html\'\"></div></md-tab-body>\n</md-tab></form></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div \nng-show=\"vm.selectedTab==0\"><md-button ng-if=\"vm.dialogType === \'edit\'\" class=\"md-icon-button\" \nng-click=\"vm.removeTask()\" aria-label=\"Remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>Delete Locally\n</md-tooltip></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" form=\"reservationForm\" \nng-disabled=\"!vm.validateReservationFields()\" aria-label=\"Add\"><span>Add</span></md-button></div><div \nng-show=\"vm.selectedTab==1\"><md-button class=\"md-accent md-raised\" type=\"submit\" form=\"rentalAgreementForm\" \nng-disabled=\"!vm.validateRentalAgreementFields()\" aria-label=\"Add\"><span>Add</span></md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/rent/gantt-chart/dialogs/add-edit/edit-dialog.html","<md-dialog class=\"gantt-chart-add-edit-dialog\" aria-label=\"Edit Dialog\"><md-toolbar class=\"md-accent\" \nng-class=\"vm.task.classes[0]\" ng-style=\"(!vm.task.classes[0]) ? {\'background-color\': \'#f9b54c\'} :{}\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"title\">Edit</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height><form \nid=\"reservationForm\" name=\"reservationForm\" \nng-submit=\"(vm.dialogType === \'edit\' && vm.task.stubReservation ? vm.callAddReservationEditDialog() : vm.callUpdateReservation())\">\n<md-tab ng-if=\"vm.task.type==vm.reservationTypes.RESERVATION\" md-on-select=\"vm.onTabSelect(0)\"><md-tab-label><span \ntranslate=\"GANTT.ADD_RESERVATION\">Reservation</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/rent/gantt-chart/dialogs/add-edit/views/reservation-form-view.html\'\"></div></md-tab-body>\n</md-tab></form><form id=\"rentalAgreementForm\" name=\"rentalAgreementForm\" \nng-submit=\"(vm.dialogType === \'edit\' && vm.task.stubReservation ? vm.callAddRentalAgreementEditDialog():\n                    (vm.dialogType === \'edit\' && vm.canUpgradeReservation ? vm.callUpgradeReservation() : vm.callUpgradeRentalAgreement()))\">\n<md-tab md-on-select=\"vm.onTabSelect(1)\"><md-tab-label><span translate=\"GANTT.ADD_RENTAL_AGREEMENT\">Rental Agreement\n</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/rent/gantt-chart/dialogs/add-edit/views/rental-agreement-form-view.html\'\"></div></md-tab-body>\n</md-tab></form><md-tab ng-if=\"vm.task.type==vm.reservationTypes.RENTAL_AGREEMENT\" md-on-select=\"vm.onTabSelect(2)\">\n<md-tab-label><span>Damages</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/main/rent/gantt-chart/dialogs/add-edit/views/rental-agreement-damage-view.html\'\"></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions ng-if=\"vm.selectedTab==0\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.task.stubReservation ? vm.removeTask() : vm.callDeleteReservation()\" aria-label=\"Remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip ng-if=\"vm.task.stubReservation\">Delete Locally</md-tooltip><md-tooltip\n ng-if=\"(!vm.task.stubReservation)\">Delete from Server</md-tooltip></md-button><md-button class=\"md-accent md-raised\" \ntype=\"submit\" form=\"reservationForm\" ng-disabled=\"!vm.validateReservationFields()\" aria-label=\"Save\"><span \nng-if=\"vm.dialogType === \'edit\' && vm.task.stubReservation\">Add</span> <span \nng-if=\"vm.dialogType === \'edit\' && !(vm.task.stubReservation)\">Save</span></md-button></md-dialog-actions>\n<md-dialog-actions ng-if=\"vm.selectedTab==1\"><div ng-show=\"vm.task.type == vm.reservationTypes.RESERVATION\" flex \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" type=\"submit\" form=\"rentalAgreementForm\" \nng-disabled=\"!vm.validateRentalAgreementFields()\" aria-label=\"Add\"><span \nng-if=\"vm.dialogType === \'edit\' && vm.task.stubReservation\">Add</span> <span \nng-if=\"vm.dialogType === \'edit\' && vm.canUpgradeReservation \">Upgrade</span></md-button></div><div \nng-show=\"vm.task.type == vm.reservationTypes.RENTAL_AGREEMENT\" layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.generateRentalAgreementInvoice()\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon><md-tooltip>Generate ticket</md-tooltip></md-button><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.callDeleteRentalAgreement()\" aria-label=\"Remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip>Delete from Server</md-tooltip></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nform=\"rentalAgreementForm\" ng-disabled=\"!vm.validateRentalAgreementFields()\" aria-label=\"Save\"><span \nng-if=\"vm.dialogType === \'edit\' && !(vm.task.stubReservation)\">Save</span></md-button></div></div></md-dialog-actions>\n<md-dialog-actions ng-if=\"vm.selectedTab==2\"><md-button class=\"md-accent md-raised\" aria-label=\"Add\" \nng-show=\"rentalAgreementRelatedDamages.status == vm.damageStatus.NOT_CREATED\" \nng-click=\"vm.callAddRentalAgreementRelatedDamage()\"><span>Add</span></md-button><div layout=\"row\" \nng-if=\"rentalAgreementRelatedDamages.status != vm.damageStatus.NOT_CREATED\"><md-button class=\"md-accent md-raised\" \naria-label=\"Update Status\" ng-click=\"vm.callUpdateRentalAgreementRelatedDamageStatus()\"><span>Update Status</span>\n</md-button><md-button class=\"md-accent md-raised\" aria-label=\"Save\" \nng-click=\"vm.callUpdateRentalAgreementRelatedDamage()\"><span>Save</span></md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/rent/gantt-chart/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><h2><span>Settings</span></h2></div>\n</md-toolbar><md-content class=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"GANTT.EDIT\">Edit</span></md-subheader><md-list-item><md-icon md-font-icon=\"icon-pencil\"></md-icon><p \ntranslate=\"GANTT.DRAW\">Draw</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.draw\"></md-checkbox>\n</md-list-item><md-list-item><md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.READ_ONLY\">Read only</p>\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.options.readOnly\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SNAP\">Snap</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-magnet\"></md-icon><p translate=\"GANTT.SNAP_AREA\">Snap area</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.columnMagnet\" placeholder=\"Snap area\"><md-option value=\"column\" \ntranslate=\"GANTT.COLUMN\">Column</md-option><md-option value=\"1 second\" translate=\"GANTT.1_SECOND\">1 second</md-option>\n<md-option value=\"1 minute\" translate=\"GANTT.1_MINUTE\">1 minute</md-option><md-option value=\"5 minutes\" \ntranslate=\"GANTT.5_MINUTES\">5 minutes</md-option><md-option value=\"15 minutes\" translate=\"GANTT.15_MINUTES\">15 minutes\n</md-option><md-option value=\"1 hour\" translate=\"GANTT.1_HOUR\">1 hour</md-option><md-option value=\"1 day\" \ntranslate=\"GANTT.1_DAY\">1 day</md-option><md-option value=\"5 days\" translate=\"GANTT.5_DAYS\">5 days</md-option>\n</md-select></md-list-item><md-list-item><md-icon md-font-icon=\"icon-view-day\"></md-icon><p translate=\"GANTT.DAILY\">\nDaily</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.daily\"></md-checkbox></md-list-item><md-list-item>\n<md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.TIME_FRAMES\">Time frames</p><md-checkbox \nclass=\"md-secondary\" ng-model=\"vm.options.timeFramesMagnet\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SIDEBAR\">Sidebar</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><p translate=\"GANTT.SHOW_SIDEBAR\">Show Sidebar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.labelsEnabled\"></md-checkbox></md-list-item><md-list-item><md-icon md-font-icon=\"icon-code-tags\">\n</md-icon><p translate=\"GANTT.RESIZABLE\">Resizable</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.allowSideResizing\"></md-checkbox></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.LIST_MODE\">List Mode</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.sideMode\" placeholder=\"List\"><md-option value=\"Tree\" \ntranslate=\"GANTT.TREE\">Tree</md-option><md-option value=\"Table\" translate=\"GANTT.TABLE\">Table</md-option><md-option \nvalue=\"TreeTable\" translate=\"GANTT.TREE_TABLE\">TreeTable</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"GANTT.TIMELINE\">Timeline</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.GROUPS\">Groups</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.groupDisplayMode\" placeholder=\"Groups\"><md-option value=\"group\" \ntranslate=\"GANTT.GROUP\">Group</md-option><md-option value=\"overview\" translate=\"GANTT.OVERVIEW\">Overview</md-option>\n<md-option value=\"promote\" translate=\"GANTT.PROMOTE\">Promote</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-list-item>\n<md-icon md-font-icon=\"icon-calendar-today\"></md-icon><p translate=\"GANTT.TODAY\">Today</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.currentDate\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"line\" translate=\"GANTT.LINE\">Line</md-option><md-option \nvalue=\"column\" translate=\"GANTT.COLUMN\">Column</md-option></md-select></md-list-item><md-divider></md-divider>\n<md-list-item><md-icon md-font-icon=\"icon-arrow-expand\"></md-icon><p translate=\"GANTT.EXPAND\">Expand</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.autoExpand\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"both\" translate=\"GANTT.BOTH\">Both</md-option><md-option \nvalue=\"left\" translate=\"GANTT.LEFT\">Left</md-option><md-option value=\"right\" translate=\"GANTT.RIGHT\">Right</md-option>\n</md-select></md-list-item><md-divider></md-divider><md-list-item><md-icon md-font-icon=\"icon-content-cut\"></md-icon><p\n translate=\"GANTT.OUT_OF_RANGE\">Out of range</p><md-select class=\"simplified md-secondary\" \nng-model=\"vm.options.taskOutOfRange\" placeholder=\"Out of range\"><md-option value=\"expand\" translate=\"GANTT.EXPAND\">\nEXPAND</md-option><md-option value=\"truncate\" translate=\"GANTT.TRUNCATE\">Truncate</md-option></md-select>\n</md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/main/user/details/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/user/details/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">\n{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline\n</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> \n<span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span \nng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div \nclass=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div\n class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\">\n<img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>\n({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>\n({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">\n{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" \nlayout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply\n</a><md-icon flex md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" \nlayout=\"row\" layout-fill><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex><textarea \nplaceholder=\"Add a comment...\" translate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button \nng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" \nclass=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">\n{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">\n{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/user/details/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div class=\"info-line\">\n<div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\">{{vm.about.general.gender}}</div></div><div\n class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\">\n{{vm.about.general.birthday}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LOCATIONS\">\nLocations</div><div class=\"info location\" ng-repeat=\"location in vm.about.general.locations\"><span>{{location}}</span>\n<md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.ABOUT_ME\">About Me</div><div class=\"info\">{{vm.about.general.about}}</div></div></div></div><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.WORK\">Work</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.OCCUPATION\">Occupation</div><div class=\"info\">{{vm.about.work.occupation}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKILLS\">Skills</div><div class=\"info\">{{vm.about.work.skills}}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOBS\">Jobs</div><table class=\"info jobs\"><tr \nclass=\"job\" ng-repeat=\"job in vm.about.work.jobs\"><td class=\"company\">{{job.company}}</td><td class=\"date\">{{job.date}}\n</td></tr></table></div></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header\n class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">\n{{vm.about.contact.address}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div>\n<div class=\"info\" ng-repeat=\"tel in vm.about.contact.tel\"><span>{{tel}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.WEBSITE\">Website</div><div class=\"info\" \nng-repeat=\"website in vm.about.contact.websites\"><span>{{website}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\" ng-repeat=\"email in vm.about.contact.emails\">\n<span>{{email}}</span></div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">\nFriends</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>454</span> <span \ntranslate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"friend\" \nflex=\"20\" ng-repeat=\"friend in vm.about.friends\"><img ng-src=\"{{friend.avatar}}\"></div></div></div><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div><div \nclass=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>6</span> <span translate=\"PROFILE.MORE\">More\n</span></div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"group in vm.about.groups\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{group.logo}}\" \nclass=\"logo\" alt=\"{{group.name}}\"><div><div class=\"name\">{{group.name}}</div><div class=\"category\">{{group.category}}\n</div><div class=\"members\">{{group.members}} people</div></div></div><md-button class=\"md-icon-button\" \naria-label=\"more\" translate translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/rent/gantt-chart/dialogs/add-edit/views/rental-agreement-damage-view.html","<div class=\"form-content\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\"><div flex \nclass=\"input-block\"><md-input-container><label>Status</label><md-select name=\"status\" \nng-model=\"rentalAgreementRelatedDamages.status\"><md-option ng-repeat=\"damageStatus in vm.damageStatusViewer\" \nng-value=\"damageStatus.value\">{{damageStatus.name}}</md-option></md-select></md-input-container></div><div flex \nclass=\"input-block\"><md-input-container><label>Instant Spotted</label><md-select name=\"instantSpotted\" \nng-model=\"rentalAgreementRelatedDamages.instantSpotted\"><md-option \nng-repeat=\"damageInstantSpotted in vm.damageInstantSpottedViewer\" ng-value=\"damageInstantSpotted.value\">\n{{damageInstantSpotted.name}}</md-option></md-select></md-input-container></div></div><div style=\"position: relative\">\n<div id=\"vespaSideSVG\" ng-include=\"\'assets/icons/scooter-side.svg\'\" \nstyle=\"position: absolute;left:-8px;height: 450px;width: 450px\"></div><div id=\"vespaFrontSVG\" \nng-include=\"\'assets/icons/scooter-front.svg\'\" \nstyle=\"position: absolute;left:-8px;height: 450px;width: 450px;transform:translateX(-450px)\"></div><div layout=\"row\" \nflex><div layout=\"column\"><div style=\"height: 450px;width: 450px\"></div><md-radio-group \nng-init=\"vm.selectedVehicleSvg=0\" ng-model=\"vm.selectedVehicleSvg\" layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-top: 12px\"><md-radio-button ng-click=\"vm.selectVehicleSideSvg()\" value=\"0\" aria-label=\"first page\">\n</md-radio-button><md-radio-button ng-click=\"vm.selectVehicleFrontSvg()\" value=\"1\" aria-label=\"second page\">\n</md-radio-button></md-radio-group></div><div layout=\"column\" flex style=\"margin-left:12px;margin-top: 24px\"><div \nng-repeat=\"damagedPart in rentalAgreementRelatedDamages.Part\"><div ng-show=\"damagedPart.value\" layout=\"column\">\n<md-input-container flex class=\"my-disable\" layout=\"row\" layout-align=\"space-between center\"><label>Name</label><input \ntype=\"text\" ng-model=\"damagedPart.name\" disabled=\"disabled\"></md-input-container><md-input-container flex \nstyle=\"margin:12px 0px 0px 0px\"><label>Description</label><textarea flex ng-model=\"damagedPart.description\" \nmd-maxlength=\"150\" rows=\"1\" md-select-on-focus></textarea></md-input-container></div></div></div></div></div></div>");
$templateCache.put("app/main/rent/gantt-chart/dialogs/add-edit/views/rental-agreement-form-view.html","<div class=\"form-content\" layout=\"column\"><div \nng-include=\"\'app/main/rent/gantt-chart/dialogs/add-edit/views/reservation-form-part.html\'\"></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nng-class=\"\'md-input-has-value\'\" flex layout=\"row\" layout-align=\"space-between center\"><label>Security deposit</label>€\n<input type=\"number\" min=\"0\" ng-model=\"vm.task.deposit\" required></md-input-container></div><div class=\"input-block\" \nflex><md-input-container ng-class=\"\'md-input-has-value\'\" flex layout=\"row\" layout-align=\"space-between center\"><label>\nPrice</label>€<input type=\"text\" ng-model=\"vm.task.price\" disabled=\"disabled\"></md-input-container></div></div></div>");
$templateCache.put("app/main/rent/gantt-chart/dialogs/add-edit/views/reservation-form-part.html","<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between center\"><div flex class=\"input-block\">\n<md-input-container flex=\"10\"><label>N°</label><input name=\"number\" ng-model=\"vm.task.id\" md-autofocus \nng-disabled=\"true\"></md-input-container></div><div flex class=\"input-block\" layout=\"row\" \nlayout-align=\"space-between center\"><label>Date</label><md-datepicker name=\"todayDate\" ms-datepicker-fix \nng-model=\"vm.creationDate\" ng-disabled=\"true\"></md-datepicker></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><div flex class=\"input-block\"><md-input-container><label>Customer</label><md-select\n name=\"client\" ng-model=\"vm.task.client\" md-on-close=\"vm.searchTextClient=\'\'\" required><md-select-header><input \nclass=\"md-text\" ng-model=\"vm.searchTextClient\" type=\"search\" placeholder=\"Insert Name\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option ng-click=\"vm.goToUsersView()\" ng-value=\"null\">\nAdd new Customer</md-option><md-option ng-repeat=\"client in vm.clients | filter:vm.searchTextClient\" \nng-value=\"client.id\" ng-click=\"vm.setClientAsFirstDriverAndRefreshPayments(client.id)\">\n{{client.surname}} {{client.name}}</md-option></md-select></md-input-container></div><div flex class=\"input-block\">\n<md-input-container><label>Vehicle class</label><md-select name=\"category\" ng-model=\"vm.task.category\" \nmd-on-close=\"vm.searchTextVehicleClass=\'\'\" required><md-select-header><input class=\"md-text\" \nng-model=\"vm.searchTextVehicleClass\" type=\"search\" placeholder=\"Insert class name\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"category in vm.categories |filter:vm.searchTextVehicleClass\" ng-value=\"category.id\">{{category.name}}\n</md-option></md-select></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><div flex class=\"input-block\"><md-input-container><label>Driver 1</label><md-select\n name=\"driver1\" ng-model=\"vm.task.drivers[0]\" md-on-close=\"vm.searchTextFirstDriver=\'\'\" required><md-select-header>\n<input class=\"md-text\" ng-model=\"vm.searchTextFirstDriver\" type=\"search\" placeholder=\"Insert Name\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"client in vm.clients |filter:vm.searchTextFirstDriver\" ng-value=\"client.id\">\n{{client.surname}} {{client.name}}</md-option></md-select></md-input-container></div><div flex class=\"input-block\">\n<md-input-container><label>Driver 2</label><md-select name=\"driver2\" ng-model=\"vm.task.drivers[1]\" \nmd-on-close=\"vm.searchTextSecondDriver=\'\'\"><md-select-header><input class=\"md-text\" \nng-model=\"vm.searchTextSecondDriver\" type=\"search\" placeholder=\"Insert Name\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"client in vm.clients | filter:vm.searchTextSecondDriver\" ng-value=\"client.id\">\n{{client.surname}} {{client.name}}</md-option></md-select></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div flex class=\"input-block\"><md-input-container><label>Pick up place\n</label><md-select name=\"pickUpPlace\" ng-model=\"vm.task.pickup\" required><md-option \nng-repeat=\"station in vm.rentStations\" ng-value=\"station.id\">{{station.name}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>From:\n</label><md-datepicker name=\"fromDate\" ms-datepicker-fix ng-model=\"vm.task.from\" md-placeholder=\"Select Date\" \nmd-min-date=\"vm.creationDate\" md-open-on-focus required></md-datepicker></div><div class=\"input-block\" flex>\n<md-input-container flex layout=\"row\" layout-align=\"space-between center\"><label>Pick up time</label><input \ntype=\"time\" ng-model=\"vm.task.pickUpTime\" required></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div flex class=\"input-block\"><md-input-container><label>Return place\n</label><md-select name=\"returnPlace\" ng-model=\"vm.task.return\" required><md-option \nng-repeat=\"station in vm.rentStations\" ng-value=\"station.id\">{{station.name}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>To:\n</label><md-datepicker name=\"toDate\" ms-datepicker-fix ng-model=\"vm.task.to\" md-placeholder=\"Select Date\" \nmd-min-date=\"vm.task.from\" md-open-on-focus required></md-datepicker></div><div class=\"input-block\" flex>\n<md-input-container flex layout=\"row\" layout-align=\"space-between center\"><label>Return time</label><input type=\"time\" \nng-model=\"vm.task.returnTime\" required></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><div flex class=\"input-block\"><md-input-container><label>Payment method</label>\n<md-select name=\"paymentMethod\" ng-model=\"vm.task.payment\" required><md-option \nng-repeat=\"paymentMethod in vm.clientPaymentMethods\" ng-value=\"paymentMethod.id\">\n{{paymentMethod.pan}} {{paymentMethod.brand}}</md-option><md-option ng-click=\"vm.goToUserProfileView()\">\nAdd new credit card</md-option></md-select></md-input-container></div><div flex class=\"input-block\">\n<md-input-container><label>Rate</label><md-select name=\"rowId\" ng-model=\"vm.task.rate\"><md-option ng-value=\"\'default\'\">\nDefault today rate</md-option><md-option ng-repeat=\"rate in vm.rates\" ng-value=\"rate.id\">\n{{rate.price | number:2}} €, From: {{rate.start | date: defaultDateFormat}} To: {{rate.end | date: defaultDateFormat}}\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"start start\"><div flex \nclass=\"input-block\"><md-input-container ng-class=\"{\'md-input-invalid\':vm.showVehicleFieldError}\"><label>Vehicle</label>\n<md-select name=\"vehicleId\" ng-model=\"vm.task.vehicle\" ng-disabled=\"vm.dialogType === \'edit\'\" required><md-option \nng-repeat=\"row in vm.chartData\" ng-value=\"row.id\" ng-click=\"vm.toggleShowVehicleFieldError()\">{{row.name}}</md-option>\n</md-select><div ng-messages=\"reservationForm.vehicleId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nVehicle field is required</span></div></div></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex layout=\"row\" \nlayout-align=\"space-between center\"><label>Prepaid days</label><input type=\"number\" min=\"0\" \nng-model=\"vm.task.prepaid_day\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex \nlayout=\"row\" layout-align=\"space-between center\"><label>Discount</label><input type=\"number\" min=\"0\" \nng-model=\"vm.task.discount\"></md-input-container></div></div>");
$templateCache.put("app/main/rent/gantt-chart/dialogs/add-edit/views/reservation-form-view.html","<div class=\"form-content\" layout=\"column\"><div \nng-include=\"\'app/main/rent/gantt-chart/dialogs/add-edit/views/reservation-form-part.html\'\"></div></div>");}]);